webpackJsonp([0],[
/* 0 */
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// this module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate
    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(8);

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
                                           navigator.product === 'NativeScript' ||
                                           navigator.product === 'NS')) {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Function equal to merge with the difference being that no reference
 * to original objects is kept.
 *
 * @see merge
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function deepMerge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = deepMerge(result[key], val);
    } else if (typeof val === 'object') {
      result[key] = deepMerge({}, val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  deepMerge: deepMerge,
  extend: extend,
  trim: trim
};


/***/ }),
/* 2 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, setImmediate) {/*!
 * Vue.js v2.6.12
 * (c) 2014-2020 Evan You
 * Released under the MIT License.
 */
/*  */

var emptyObject = Object.freeze({});

// These helpers produce better VM code in JS engines due to their
// explicitness and function inlining.
function isUndef (v) {
  return v === undefined || v === null
}

function isDef (v) {
  return v !== undefined && v !== null
}

function isTrue (v) {
  return v === true
}

function isFalse (v) {
  return v === false
}

/**
 * Check if value is primitive.
 */
function isPrimitive (value) {
  return (
    typeof value === 'string' ||
    typeof value === 'number' ||
    // $flow-disable-line
    typeof value === 'symbol' ||
    typeof value === 'boolean'
  )
}

/**
 * Quick object check - this is primarily used to tell
 * Objects from primitive values when we know the value
 * is a JSON-compliant type.
 */
function isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

/**
 * Get the raw type string of a value, e.g., [object Object].
 */
var _toString = Object.prototype.toString;

function toRawType (value) {
  return _toString.call(value).slice(8, -1)
}

/**
 * Strict object type check. Only returns true
 * for plain JavaScript objects.
 */
function isPlainObject (obj) {
  return _toString.call(obj) === '[object Object]'
}

function isRegExp (v) {
  return _toString.call(v) === '[object RegExp]'
}

/**
 * Check if val is a valid array index.
 */
function isValidArrayIndex (val) {
  var n = parseFloat(String(val));
  return n >= 0 && Math.floor(n) === n && isFinite(val)
}

function isPromise (val) {
  return (
    isDef(val) &&
    typeof val.then === 'function' &&
    typeof val.catch === 'function'
  )
}

/**
 * Convert a value to a string that is actually rendered.
 */
function toString (val) {
  return val == null
    ? ''
    : Array.isArray(val) || (isPlainObject(val) && val.toString === _toString)
      ? JSON.stringify(val, null, 2)
      : String(val)
}

/**
 * Convert an input value to a number for persistence.
 * If the conversion fails, return original string.
 */
function toNumber (val) {
  var n = parseFloat(val);
  return isNaN(n) ? val : n
}

/**
 * Make a map and return a function for checking if a key
 * is in that map.
 */
function makeMap (
  str,
  expectsLowerCase
) {
  var map = Object.create(null);
  var list = str.split(',');
  for (var i = 0; i < list.length; i++) {
    map[list[i]] = true;
  }
  return expectsLowerCase
    ? function (val) { return map[val.toLowerCase()]; }
    : function (val) { return map[val]; }
}

/**
 * Check if a tag is a built-in tag.
 */
var isBuiltInTag = makeMap('slot,component', true);

/**
 * Check if an attribute is a reserved attribute.
 */
var isReservedAttribute = makeMap('key,ref,slot,slot-scope,is');

/**
 * Remove an item from an array.
 */
function remove (arr, item) {
  if (arr.length) {
    var index = arr.indexOf(item);
    if (index > -1) {
      return arr.splice(index, 1)
    }
  }
}

/**
 * Check whether an object has the property.
 */
var hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn (obj, key) {
  return hasOwnProperty.call(obj, key)
}

/**
 * Create a cached version of a pure function.
 */
function cached (fn) {
  var cache = Object.create(null);
  return (function cachedFn (str) {
    var hit = cache[str];
    return hit || (cache[str] = fn(str))
  })
}

/**
 * Camelize a hyphen-delimited string.
 */
var camelizeRE = /-(\w)/g;
var camelize = cached(function (str) {
  return str.replace(camelizeRE, function (_, c) { return c ? c.toUpperCase() : ''; })
});

/**
 * Capitalize a string.
 */
var capitalize = cached(function (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
});

/**
 * Hyphenate a camelCase string.
 */
var hyphenateRE = /\B([A-Z])/g;
var hyphenate = cached(function (str) {
  return str.replace(hyphenateRE, '-$1').toLowerCase()
});

/**
 * Simple bind polyfill for environments that do not support it,
 * e.g., PhantomJS 1.x. Technically, we don't need this anymore
 * since native bind is now performant enough in most browsers.
 * But removing it would mean breaking code that was able to run in
 * PhantomJS 1.x, so this must be kept for backward compatibility.
 */

/* istanbul ignore next */
function polyfillBind (fn, ctx) {
  function boundFn (a) {
    var l = arguments.length;
    return l
      ? l > 1
        ? fn.apply(ctx, arguments)
        : fn.call(ctx, a)
      : fn.call(ctx)
  }

  boundFn._length = fn.length;
  return boundFn
}

function nativeBind (fn, ctx) {
  return fn.bind(ctx)
}

var bind = Function.prototype.bind
  ? nativeBind
  : polyfillBind;

/**
 * Convert an Array-like object to a real Array.
 */
function toArray (list, start) {
  start = start || 0;
  var i = list.length - start;
  var ret = new Array(i);
  while (i--) {
    ret[i] = list[i + start];
  }
  return ret
}

/**
 * Mix properties into target object.
 */
function extend (to, _from) {
  for (var key in _from) {
    to[key] = _from[key];
  }
  return to
}

/**
 * Merge an Array of Objects into a single Object.
 */
function toObject (arr) {
  var res = {};
  for (var i = 0; i < arr.length; i++) {
    if (arr[i]) {
      extend(res, arr[i]);
    }
  }
  return res
}

/* eslint-disable no-unused-vars */

/**
 * Perform no operation.
 * Stubbing args to make Flow happy without leaving useless transpiled code
 * with ...rest (https://flow.org/blog/2017/05/07/Strict-Function-Call-Arity/).
 */
function noop (a, b, c) {}

/**
 * Always return false.
 */
var no = function (a, b, c) { return false; };

/* eslint-enable no-unused-vars */

/**
 * Return the same value.
 */
var identity = function (_) { return _; };

/**
 * Generate a string containing static keys from compiler modules.
 */
function genStaticKeys (modules) {
  return modules.reduce(function (keys, m) {
    return keys.concat(m.staticKeys || [])
  }, []).join(',')
}

/**
 * Check if two values are loosely equal - that is,
 * if they are plain objects, do they have the same shape?
 */
function looseEqual (a, b) {
  if (a === b) { return true }
  var isObjectA = isObject(a);
  var isObjectB = isObject(b);
  if (isObjectA && isObjectB) {
    try {
      var isArrayA = Array.isArray(a);
      var isArrayB = Array.isArray(b);
      if (isArrayA && isArrayB) {
        return a.length === b.length && a.every(function (e, i) {
          return looseEqual(e, b[i])
        })
      } else if (a instanceof Date && b instanceof Date) {
        return a.getTime() === b.getTime()
      } else if (!isArrayA && !isArrayB) {
        var keysA = Object.keys(a);
        var keysB = Object.keys(b);
        return keysA.length === keysB.length && keysA.every(function (key) {
          return looseEqual(a[key], b[key])
        })
      } else {
        /* istanbul ignore next */
        return false
      }
    } catch (e) {
      /* istanbul ignore next */
      return false
    }
  } else if (!isObjectA && !isObjectB) {
    return String(a) === String(b)
  } else {
    return false
  }
}

/**
 * Return the first index at which a loosely equal value can be
 * found in the array (if value is a plain object, the array must
 * contain an object of the same shape), or -1 if it is not present.
 */
function looseIndexOf (arr, val) {
  for (var i = 0; i < arr.length; i++) {
    if (looseEqual(arr[i], val)) { return i }
  }
  return -1
}

/**
 * Ensure a function is called only once.
 */
function once (fn) {
  var called = false;
  return function () {
    if (!called) {
      called = true;
      fn.apply(this, arguments);
    }
  }
}

var SSR_ATTR = 'data-server-rendered';

var ASSET_TYPES = [
  'component',
  'directive',
  'filter'
];

var LIFECYCLE_HOOKS = [
  'beforeCreate',
  'created',
  'beforeMount',
  'mounted',
  'beforeUpdate',
  'updated',
  'beforeDestroy',
  'destroyed',
  'activated',
  'deactivated',
  'errorCaptured',
  'serverPrefetch'
];

/*  */



var config = ({
  /**
   * Option merge strategies (used in core/util/options)
   */
  // $flow-disable-line
  optionMergeStrategies: Object.create(null),

  /**
   * Whether to suppress warnings.
   */
  silent: false,

  /**
   * Show production mode tip message on boot?
   */
  productionTip: "production" !== 'production',

  /**
   * Whether to enable devtools
   */
  devtools: "production" !== 'production',

  /**
   * Whether to record perf
   */
  performance: false,

  /**
   * Error handler for watcher errors
   */
  errorHandler: null,

  /**
   * Warn handler for watcher warns
   */
  warnHandler: null,

  /**
   * Ignore certain custom elements
   */
  ignoredElements: [],

  /**
   * Custom user key aliases for v-on
   */
  // $flow-disable-line
  keyCodes: Object.create(null),

  /**
   * Check if a tag is reserved so that it cannot be registered as a
   * component. This is platform-dependent and may be overwritten.
   */
  isReservedTag: no,

  /**
   * Check if an attribute is reserved so that it cannot be used as a component
   * prop. This is platform-dependent and may be overwritten.
   */
  isReservedAttr: no,

  /**
   * Check if a tag is an unknown element.
   * Platform-dependent.
   */
  isUnknownElement: no,

  /**
   * Get the namespace of an element
   */
  getTagNamespace: noop,

  /**
   * Parse the real tag name for the specific platform.
   */
  parsePlatformTagName: identity,

  /**
   * Check if an attribute must be bound using property, e.g. value
   * Platform-dependent.
   */
  mustUseProp: no,

  /**
   * Perform updates asynchronously. Intended to be used by Vue Test Utils
   * This will significantly reduce performance if set to false.
   */
  async: true,

  /**
   * Exposed for legacy reasons
   */
  _lifecycleHooks: LIFECYCLE_HOOKS
});

/*  */

/**
 * unicode letters used for parsing html tags, component names and property paths.
 * using https://www.w3.org/TR/html53/semantics-scripting.html#potentialcustomelementname
 * skipping \u10000-\uEFFFF due to it freezing up PhantomJS
 */
var unicodeRegExp = /a-zA-Z\u00B7\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u037D\u037F-\u1FFF\u200C-\u200D\u203F-\u2040\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD/;

/**
 * Check if a string starts with $ or _
 */
function isReserved (str) {
  var c = (str + '').charCodeAt(0);
  return c === 0x24 || c === 0x5F
}

/**
 * Define a property.
 */
function def (obj, key, val, enumerable) {
  Object.defineProperty(obj, key, {
    value: val,
    enumerable: !!enumerable,
    writable: true,
    configurable: true
  });
}

/**
 * Parse simple path.
 */
var bailRE = new RegExp(("[^" + (unicodeRegExp.source) + ".$_\\d]"));
function parsePath (path) {
  if (bailRE.test(path)) {
    return
  }
  var segments = path.split('.');
  return function (obj) {
    for (var i = 0; i < segments.length; i++) {
      if (!obj) { return }
      obj = obj[segments[i]];
    }
    return obj
  }
}

/*  */

// can we use __proto__?
var hasProto = '__proto__' in {};

// Browser environment sniffing
var inBrowser = typeof window !== 'undefined';
var inWeex = typeof WXEnvironment !== 'undefined' && !!WXEnvironment.platform;
var weexPlatform = inWeex && WXEnvironment.platform.toLowerCase();
var UA = inBrowser && window.navigator.userAgent.toLowerCase();
var isIE = UA && /msie|trident/.test(UA);
var isIE9 = UA && UA.indexOf('msie 9.0') > 0;
var isEdge = UA && UA.indexOf('edge/') > 0;
var isAndroid = (UA && UA.indexOf('android') > 0) || (weexPlatform === 'android');
var isIOS = (UA && /iphone|ipad|ipod|ios/.test(UA)) || (weexPlatform === 'ios');
var isChrome = UA && /chrome\/\d+/.test(UA) && !isEdge;
var isPhantomJS = UA && /phantomjs/.test(UA);
var isFF = UA && UA.match(/firefox\/(\d+)/);

// Firefox has a "watch" function on Object.prototype...
var nativeWatch = ({}).watch;

var supportsPassive = false;
if (inBrowser) {
  try {
    var opts = {};
    Object.defineProperty(opts, 'passive', ({
      get: function get () {
        /* istanbul ignore next */
        supportsPassive = true;
      }
    })); // https://github.com/facebook/flow/issues/285
    window.addEventListener('test-passive', null, opts);
  } catch (e) {}
}

// this needs to be lazy-evaled because vue may be required before
// vue-server-renderer can set VUE_ENV
var _isServer;
var isServerRendering = function () {
  if (_isServer === undefined) {
    /* istanbul ignore if */
    if (!inBrowser && !inWeex && typeof global !== 'undefined') {
      // detect presence of vue-server-renderer and avoid
      // Webpack shimming the process
      _isServer = global['process'] && global['process'].env.VUE_ENV === 'server';
    } else {
      _isServer = false;
    }
  }
  return _isServer
};

// detect devtools
var devtools = inBrowser && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;

/* istanbul ignore next */
function isNative (Ctor) {
  return typeof Ctor === 'function' && /native code/.test(Ctor.toString())
}

var hasSymbol =
  typeof Symbol !== 'undefined' && isNative(Symbol) &&
  typeof Reflect !== 'undefined' && isNative(Reflect.ownKeys);

var _Set;
/* istanbul ignore if */ // $flow-disable-line
if (typeof Set !== 'undefined' && isNative(Set)) {
  // use native Set when available.
  _Set = Set;
} else {
  // a non-standard Set polyfill that only works with primitive keys.
  _Set = /*@__PURE__*/(function () {
    function Set () {
      this.set = Object.create(null);
    }
    Set.prototype.has = function has (key) {
      return this.set[key] === true
    };
    Set.prototype.add = function add (key) {
      this.set[key] = true;
    };
    Set.prototype.clear = function clear () {
      this.set = Object.create(null);
    };

    return Set;
  }());
}

/*  */

var warn = noop;
var tip = noop;
var generateComponentTrace = (noop); // work around flow check
var formatComponentName = (noop);

if (false) {
  var hasConsole = typeof console !== 'undefined';
  var classifyRE = /(?:^|[-_])(\w)/g;
  var classify = function (str) { return str
    .replace(classifyRE, function (c) { return c.toUpperCase(); })
    .replace(/[-_]/g, ''); };

  warn = function (msg, vm) {
    var trace = vm ? generateComponentTrace(vm) : '';

    if (config.warnHandler) {
      config.warnHandler.call(null, msg, vm, trace);
    } else if (hasConsole && (!config.silent)) {
      console.error(("[Vue warn]: " + msg + trace));
    }
  };

  tip = function (msg, vm) {
    if (hasConsole && (!config.silent)) {
      console.warn("[Vue tip]: " + msg + (
        vm ? generateComponentTrace(vm) : ''
      ));
    }
  };

  formatComponentName = function (vm, includeFile) {
    if (vm.$root === vm) {
      return '<Root>'
    }
    var options = typeof vm === 'function' && vm.cid != null
      ? vm.options
      : vm._isVue
        ? vm.$options || vm.constructor.options
        : vm;
    var name = options.name || options._componentTag;
    var file = options.__file;
    if (!name && file) {
      var match = file.match(/([^/\\]+)\.vue$/);
      name = match && match[1];
    }

    return (
      (name ? ("<" + (classify(name)) + ">") : "<Anonymous>") +
      (file && includeFile !== false ? (" at " + file) : '')
    )
  };

  var repeat = function (str, n) {
    var res = '';
    while (n) {
      if (n % 2 === 1) { res += str; }
      if (n > 1) { str += str; }
      n >>= 1;
    }
    return res
  };

  generateComponentTrace = function (vm) {
    if (vm._isVue && vm.$parent) {
      var tree = [];
      var currentRecursiveSequence = 0;
      while (vm) {
        if (tree.length > 0) {
          var last = tree[tree.length - 1];
          if (last.constructor === vm.constructor) {
            currentRecursiveSequence++;
            vm = vm.$parent;
            continue
          } else if (currentRecursiveSequence > 0) {
            tree[tree.length - 1] = [last, currentRecursiveSequence];
            currentRecursiveSequence = 0;
          }
        }
        tree.push(vm);
        vm = vm.$parent;
      }
      return '\n\nfound in\n\n' + tree
        .map(function (vm, i) { return ("" + (i === 0 ? '---> ' : repeat(' ', 5 + i * 2)) + (Array.isArray(vm)
            ? ((formatComponentName(vm[0])) + "... (" + (vm[1]) + " recursive calls)")
            : formatComponentName(vm))); })
        .join('\n')
    } else {
      return ("\n\n(found in " + (formatComponentName(vm)) + ")")
    }
  };
}

/*  */

var uid = 0;

/**
 * A dep is an observable that can have multiple
 * directives subscribing to it.
 */
var Dep = function Dep () {
  this.id = uid++;
  this.subs = [];
};

Dep.prototype.addSub = function addSub (sub) {
  this.subs.push(sub);
};

Dep.prototype.removeSub = function removeSub (sub) {
  remove(this.subs, sub);
};

Dep.prototype.depend = function depend () {
  if (Dep.target) {
    Dep.target.addDep(this);
  }
};

Dep.prototype.notify = function notify () {
  // stabilize the subscriber list first
  var subs = this.subs.slice();
  if (false) {
    // subs aren't sorted in scheduler if not running async
    // we need to sort them now to make sure they fire in correct
    // order
    subs.sort(function (a, b) { return a.id - b.id; });
  }
  for (var i = 0, l = subs.length; i < l; i++) {
    subs[i].update();
  }
};

// The current target watcher being evaluated.
// This is globally unique because only one watcher
// can be evaluated at a time.
Dep.target = null;
var targetStack = [];

function pushTarget (target) {
  targetStack.push(target);
  Dep.target = target;
}

function popTarget () {
  targetStack.pop();
  Dep.target = targetStack[targetStack.length - 1];
}

/*  */

var VNode = function VNode (
  tag,
  data,
  children,
  text,
  elm,
  context,
  componentOptions,
  asyncFactory
) {
  this.tag = tag;
  this.data = data;
  this.children = children;
  this.text = text;
  this.elm = elm;
  this.ns = undefined;
  this.context = context;
  this.fnContext = undefined;
  this.fnOptions = undefined;
  this.fnScopeId = undefined;
  this.key = data && data.key;
  this.componentOptions = componentOptions;
  this.componentInstance = undefined;
  this.parent = undefined;
  this.raw = false;
  this.isStatic = false;
  this.isRootInsert = true;
  this.isComment = false;
  this.isCloned = false;
  this.isOnce = false;
  this.asyncFactory = asyncFactory;
  this.asyncMeta = undefined;
  this.isAsyncPlaceholder = false;
};

var prototypeAccessors = { child: { configurable: true } };

// DEPRECATED: alias for componentInstance for backwards compat.
/* istanbul ignore next */
prototypeAccessors.child.get = function () {
  return this.componentInstance
};

Object.defineProperties( VNode.prototype, prototypeAccessors );

var createEmptyVNode = function (text) {
  if ( text === void 0 ) text = '';

  var node = new VNode();
  node.text = text;
  node.isComment = true;
  return node
};

function createTextVNode (val) {
  return new VNode(undefined, undefined, undefined, String(val))
}

// optimized shallow clone
// used for static nodes and slot nodes because they may be reused across
// multiple renders, cloning them avoids errors when DOM manipulations rely
// on their elm reference.
function cloneVNode (vnode) {
  var cloned = new VNode(
    vnode.tag,
    vnode.data,
    // #7975
    // clone children array to avoid mutating original in case of cloning
    // a child.
    vnode.children && vnode.children.slice(),
    vnode.text,
    vnode.elm,
    vnode.context,
    vnode.componentOptions,
    vnode.asyncFactory
  );
  cloned.ns = vnode.ns;
  cloned.isStatic = vnode.isStatic;
  cloned.key = vnode.key;
  cloned.isComment = vnode.isComment;
  cloned.fnContext = vnode.fnContext;
  cloned.fnOptions = vnode.fnOptions;
  cloned.fnScopeId = vnode.fnScopeId;
  cloned.asyncMeta = vnode.asyncMeta;
  cloned.isCloned = true;
  return cloned
}

/*
 * not type checking this file because flow doesn't play well with
 * dynamically accessing methods on Array prototype
 */

var arrayProto = Array.prototype;
var arrayMethods = Object.create(arrayProto);

var methodsToPatch = [
  'push',
  'pop',
  'shift',
  'unshift',
  'splice',
  'sort',
  'reverse'
];

/**
 * Intercept mutating methods and emit events
 */
methodsToPatch.forEach(function (method) {
  // cache original method
  var original = arrayProto[method];
  def(arrayMethods, method, function mutator () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    var result = original.apply(this, args);
    var ob = this.__ob__;
    var inserted;
    switch (method) {
      case 'push':
      case 'unshift':
        inserted = args;
        break
      case 'splice':
        inserted = args.slice(2);
        break
    }
    if (inserted) { ob.observeArray(inserted); }
    // notify change
    ob.dep.notify();
    return result
  });
});

/*  */

var arrayKeys = Object.getOwnPropertyNames(arrayMethods);

/**
 * In some cases we may want to disable observation inside a component's
 * update computation.
 */
var shouldObserve = true;

function toggleObserving (value) {
  shouldObserve = value;
}

/**
 * Observer class that is attached to each observed
 * object. Once attached, the observer converts the target
 * object's property keys into getter/setters that
 * collect dependencies and dispatch updates.
 */
var Observer = function Observer (value) {
  this.value = value;
  this.dep = new Dep();
  this.vmCount = 0;
  def(value, '__ob__', this);
  if (Array.isArray(value)) {
    if (hasProto) {
      protoAugment(value, arrayMethods);
    } else {
      copyAugment(value, arrayMethods, arrayKeys);
    }
    this.observeArray(value);
  } else {
    this.walk(value);
  }
};

/**
 * Walk through all properties and convert them into
 * getter/setters. This method should only be called when
 * value type is Object.
 */
Observer.prototype.walk = function walk (obj) {
  var keys = Object.keys(obj);
  for (var i = 0; i < keys.length; i++) {
    defineReactive$$1(obj, keys[i]);
  }
};

/**
 * Observe a list of Array items.
 */
Observer.prototype.observeArray = function observeArray (items) {
  for (var i = 0, l = items.length; i < l; i++) {
    observe(items[i]);
  }
};

// helpers

/**
 * Augment a target Object or Array by intercepting
 * the prototype chain using __proto__
 */
function protoAugment (target, src) {
  /* eslint-disable no-proto */
  target.__proto__ = src;
  /* eslint-enable no-proto */
}

/**
 * Augment a target Object or Array by defining
 * hidden properties.
 */
/* istanbul ignore next */
function copyAugment (target, src, keys) {
  for (var i = 0, l = keys.length; i < l; i++) {
    var key = keys[i];
    def(target, key, src[key]);
  }
}

/**
 * Attempt to create an observer instance for a value,
 * returns the new observer if successfully observed,
 * or the existing observer if the value already has one.
 */
function observe (value, asRootData) {
  if (!isObject(value) || value instanceof VNode) {
    return
  }
  var ob;
  if (hasOwn(value, '__ob__') && value.__ob__ instanceof Observer) {
    ob = value.__ob__;
  } else if (
    shouldObserve &&
    !isServerRendering() &&
    (Array.isArray(value) || isPlainObject(value)) &&
    Object.isExtensible(value) &&
    !value._isVue
  ) {
    ob = new Observer(value);
  }
  if (asRootData && ob) {
    ob.vmCount++;
  }
  return ob
}

/**
 * Define a reactive property on an Object.
 */
function defineReactive$$1 (
  obj,
  key,
  val,
  customSetter,
  shallow
) {
  var dep = new Dep();

  var property = Object.getOwnPropertyDescriptor(obj, key);
  if (property && property.configurable === false) {
    return
  }

  // cater for pre-defined getter/setters
  var getter = property && property.get;
  var setter = property && property.set;
  if ((!getter || setter) && arguments.length === 2) {
    val = obj[key];
  }

  var childOb = !shallow && observe(val);
  Object.defineProperty(obj, key, {
    enumerable: true,
    configurable: true,
    get: function reactiveGetter () {
      var value = getter ? getter.call(obj) : val;
      if (Dep.target) {
        dep.depend();
        if (childOb) {
          childOb.dep.depend();
          if (Array.isArray(value)) {
            dependArray(value);
          }
        }
      }
      return value
    },
    set: function reactiveSetter (newVal) {
      var value = getter ? getter.call(obj) : val;
      /* eslint-disable no-self-compare */
      if (newVal === value || (newVal !== newVal && value !== value)) {
        return
      }
      /* eslint-enable no-self-compare */
      if (false) {
        customSetter();
      }
      // #7981: for accessor properties without setter
      if (getter && !setter) { return }
      if (setter) {
        setter.call(obj, newVal);
      } else {
        val = newVal;
      }
      childOb = !shallow && observe(newVal);
      dep.notify();
    }
  });
}

/**
 * Set a property on an object. Adds the new property and
 * triggers change notification if the property doesn't
 * already exist.
 */
function set (target, key, val) {
  if (false
  ) {
    warn(("Cannot set reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.length = Math.max(target.length, key);
    target.splice(key, 1, val);
    return val
  }
  if (key in target && !(key in Object.prototype)) {
    target[key] = val;
    return val
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid adding reactive properties to a Vue instance or its root $data ' +
      'at runtime - declare it upfront in the data option.'
    );
    return val
  }
  if (!ob) {
    target[key] = val;
    return val
  }
  defineReactive$$1(ob.value, key, val);
  ob.dep.notify();
  return val
}

/**
 * Delete a property and trigger change if necessary.
 */
function del (target, key) {
  if (false
  ) {
    warn(("Cannot delete reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.splice(key, 1);
    return
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid deleting properties on a Vue instance or its root $data ' +
      '- just set it to null.'
    );
    return
  }
  if (!hasOwn(target, key)) {
    return
  }
  delete target[key];
  if (!ob) {
    return
  }
  ob.dep.notify();
}

/**
 * Collect dependencies on array elements when the array is touched, since
 * we cannot intercept array element access like property getters.
 */
function dependArray (value) {
  for (var e = (void 0), i = 0, l = value.length; i < l; i++) {
    e = value[i];
    e && e.__ob__ && e.__ob__.dep.depend();
    if (Array.isArray(e)) {
      dependArray(e);
    }
  }
}

/*  */

/**
 * Option overwriting strategies are functions that handle
 * how to merge a parent option value and a child option
 * value into the final value.
 */
var strats = config.optionMergeStrategies;

/**
 * Options with restrictions
 */
if (false) {
  strats.el = strats.propsData = function (parent, child, vm, key) {
    if (!vm) {
      warn(
        "option \"" + key + "\" can only be used during instance " +
        'creation with the `new` keyword.'
      );
    }
    return defaultStrat(parent, child)
  };
}

/**
 * Helper that recursively merges two data objects together.
 */
function mergeData (to, from) {
  if (!from) { return to }
  var key, toVal, fromVal;

  var keys = hasSymbol
    ? Reflect.ownKeys(from)
    : Object.keys(from);

  for (var i = 0; i < keys.length; i++) {
    key = keys[i];
    // in case the object is already observed...
    if (key === '__ob__') { continue }
    toVal = to[key];
    fromVal = from[key];
    if (!hasOwn(to, key)) {
      set(to, key, fromVal);
    } else if (
      toVal !== fromVal &&
      isPlainObject(toVal) &&
      isPlainObject(fromVal)
    ) {
      mergeData(toVal, fromVal);
    }
  }
  return to
}

/**
 * Data
 */
function mergeDataOrFn (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    // in a Vue.extend merge, both should be functions
    if (!childVal) {
      return parentVal
    }
    if (!parentVal) {
      return childVal
    }
    // when parentVal & childVal are both present,
    // we need to return a function that returns the
    // merged result of both functions... no need to
    // check if parentVal is a function here because
    // it has to be a function to pass previous merges.
    return function mergedDataFn () {
      return mergeData(
        typeof childVal === 'function' ? childVal.call(this, this) : childVal,
        typeof parentVal === 'function' ? parentVal.call(this, this) : parentVal
      )
    }
  } else {
    return function mergedInstanceDataFn () {
      // instance merge
      var instanceData = typeof childVal === 'function'
        ? childVal.call(vm, vm)
        : childVal;
      var defaultData = typeof parentVal === 'function'
        ? parentVal.call(vm, vm)
        : parentVal;
      if (instanceData) {
        return mergeData(instanceData, defaultData)
      } else {
        return defaultData
      }
    }
  }
}

strats.data = function (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    if (childVal && typeof childVal !== 'function') {
      "production" !== 'production' && warn(
        'The "data" option should be a function ' +
        'that returns a per-instance value in component ' +
        'definitions.',
        vm
      );

      return parentVal
    }
    return mergeDataOrFn(parentVal, childVal)
  }

  return mergeDataOrFn(parentVal, childVal, vm)
};

/**
 * Hooks and props are merged as arrays.
 */
function mergeHook (
  parentVal,
  childVal
) {
  var res = childVal
    ? parentVal
      ? parentVal.concat(childVal)
      : Array.isArray(childVal)
        ? childVal
        : [childVal]
    : parentVal;
  return res
    ? dedupeHooks(res)
    : res
}

function dedupeHooks (hooks) {
  var res = [];
  for (var i = 0; i < hooks.length; i++) {
    if (res.indexOf(hooks[i]) === -1) {
      res.push(hooks[i]);
    }
  }
  return res
}

LIFECYCLE_HOOKS.forEach(function (hook) {
  strats[hook] = mergeHook;
});

/**
 * Assets
 *
 * When a vm is present (instance creation), we need to do
 * a three-way merge between constructor options, instance
 * options and parent options.
 */
function mergeAssets (
  parentVal,
  childVal,
  vm,
  key
) {
  var res = Object.create(parentVal || null);
  if (childVal) {
    "production" !== 'production' && assertObjectType(key, childVal, vm);
    return extend(res, childVal)
  } else {
    return res
  }
}

ASSET_TYPES.forEach(function (type) {
  strats[type + 's'] = mergeAssets;
});

/**
 * Watchers.
 *
 * Watchers hashes should not overwrite one
 * another, so we merge them as arrays.
 */
strats.watch = function (
  parentVal,
  childVal,
  vm,
  key
) {
  // work around Firefox's Object.prototype.watch...
  if (parentVal === nativeWatch) { parentVal = undefined; }
  if (childVal === nativeWatch) { childVal = undefined; }
  /* istanbul ignore if */
  if (!childVal) { return Object.create(parentVal || null) }
  if (false) {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = {};
  extend(ret, parentVal);
  for (var key$1 in childVal) {
    var parent = ret[key$1];
    var child = childVal[key$1];
    if (parent && !Array.isArray(parent)) {
      parent = [parent];
    }
    ret[key$1] = parent
      ? parent.concat(child)
      : Array.isArray(child) ? child : [child];
  }
  return ret
};

/**
 * Other object hashes.
 */
strats.props =
strats.methods =
strats.inject =
strats.computed = function (
  parentVal,
  childVal,
  vm,
  key
) {
  if (childVal && "production" !== 'production') {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = Object.create(null);
  extend(ret, parentVal);
  if (childVal) { extend(ret, childVal); }
  return ret
};
strats.provide = mergeDataOrFn;

/**
 * Default strategy.
 */
var defaultStrat = function (parentVal, childVal) {
  return childVal === undefined
    ? parentVal
    : childVal
};

/**
 * Validate component names
 */
function checkComponents (options) {
  for (var key in options.components) {
    validateComponentName(key);
  }
}

function validateComponentName (name) {
  if (!new RegExp(("^[a-zA-Z][\\-\\.0-9_" + (unicodeRegExp.source) + "]*$")).test(name)) {
    warn(
      'Invalid component name: "' + name + '". Component names ' +
      'should conform to valid custom element name in html5 specification.'
    );
  }
  if (isBuiltInTag(name) || config.isReservedTag(name)) {
    warn(
      'Do not use built-in or reserved HTML elements as component ' +
      'id: ' + name
    );
  }
}

/**
 * Ensure all props option syntax are normalized into the
 * Object-based format.
 */
function normalizeProps (options, vm) {
  var props = options.props;
  if (!props) { return }
  var res = {};
  var i, val, name;
  if (Array.isArray(props)) {
    i = props.length;
    while (i--) {
      val = props[i];
      if (typeof val === 'string') {
        name = camelize(val);
        res[name] = { type: null };
      } else if (false) {
        warn('props must be strings when using array syntax.');
      }
    }
  } else if (isPlainObject(props)) {
    for (var key in props) {
      val = props[key];
      name = camelize(key);
      res[name] = isPlainObject(val)
        ? val
        : { type: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"props\": expected an Array or an Object, " +
      "but got " + (toRawType(props)) + ".",
      vm
    );
  }
  options.props = res;
}

/**
 * Normalize all injections into Object-based format
 */
function normalizeInject (options, vm) {
  var inject = options.inject;
  if (!inject) { return }
  var normalized = options.inject = {};
  if (Array.isArray(inject)) {
    for (var i = 0; i < inject.length; i++) {
      normalized[inject[i]] = { from: inject[i] };
    }
  } else if (isPlainObject(inject)) {
    for (var key in inject) {
      var val = inject[key];
      normalized[key] = isPlainObject(val)
        ? extend({ from: key }, val)
        : { from: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"inject\": expected an Array or an Object, " +
      "but got " + (toRawType(inject)) + ".",
      vm
    );
  }
}

/**
 * Normalize raw function directives into object format.
 */
function normalizeDirectives (options) {
  var dirs = options.directives;
  if (dirs) {
    for (var key in dirs) {
      var def$$1 = dirs[key];
      if (typeof def$$1 === 'function') {
        dirs[key] = { bind: def$$1, update: def$$1 };
      }
    }
  }
}

function assertObjectType (name, value, vm) {
  if (!isPlainObject(value)) {
    warn(
      "Invalid value for option \"" + name + "\": expected an Object, " +
      "but got " + (toRawType(value)) + ".",
      vm
    );
  }
}

/**
 * Merge two option objects into a new one.
 * Core utility used in both instantiation and inheritance.
 */
function mergeOptions (
  parent,
  child,
  vm
) {
  if (false) {
    checkComponents(child);
  }

  if (typeof child === 'function') {
    child = child.options;
  }

  normalizeProps(child, vm);
  normalizeInject(child, vm);
  normalizeDirectives(child);

  // Apply extends and mixins on the child options,
  // but only if it is a raw options object that isn't
  // the result of another mergeOptions call.
  // Only merged options has the _base property.
  if (!child._base) {
    if (child.extends) {
      parent = mergeOptions(parent, child.extends, vm);
    }
    if (child.mixins) {
      for (var i = 0, l = child.mixins.length; i < l; i++) {
        parent = mergeOptions(parent, child.mixins[i], vm);
      }
    }
  }

  var options = {};
  var key;
  for (key in parent) {
    mergeField(key);
  }
  for (key in child) {
    if (!hasOwn(parent, key)) {
      mergeField(key);
    }
  }
  function mergeField (key) {
    var strat = strats[key] || defaultStrat;
    options[key] = strat(parent[key], child[key], vm, key);
  }
  return options
}

/**
 * Resolve an asset.
 * This function is used because child instances need access
 * to assets defined in its ancestor chain.
 */
function resolveAsset (
  options,
  type,
  id,
  warnMissing
) {
  /* istanbul ignore if */
  if (typeof id !== 'string') {
    return
  }
  var assets = options[type];
  // check local registration variations first
  if (hasOwn(assets, id)) { return assets[id] }
  var camelizedId = camelize(id);
  if (hasOwn(assets, camelizedId)) { return assets[camelizedId] }
  var PascalCaseId = capitalize(camelizedId);
  if (hasOwn(assets, PascalCaseId)) { return assets[PascalCaseId] }
  // fallback to prototype chain
  var res = assets[id] || assets[camelizedId] || assets[PascalCaseId];
  if (false) {
    warn(
      'Failed to resolve ' + type.slice(0, -1) + ': ' + id,
      options
    );
  }
  return res
}

/*  */



function validateProp (
  key,
  propOptions,
  propsData,
  vm
) {
  var prop = propOptions[key];
  var absent = !hasOwn(propsData, key);
  var value = propsData[key];
  // boolean casting
  var booleanIndex = getTypeIndex(Boolean, prop.type);
  if (booleanIndex > -1) {
    if (absent && !hasOwn(prop, 'default')) {
      value = false;
    } else if (value === '' || value === hyphenate(key)) {
      // only cast empty string / same name to boolean if
      // boolean has higher priority
      var stringIndex = getTypeIndex(String, prop.type);
      if (stringIndex < 0 || booleanIndex < stringIndex) {
        value = true;
      }
    }
  }
  // check default value
  if (value === undefined) {
    value = getPropDefaultValue(vm, prop, key);
    // since the default value is a fresh copy,
    // make sure to observe it.
    var prevShouldObserve = shouldObserve;
    toggleObserving(true);
    observe(value);
    toggleObserving(prevShouldObserve);
  }
  if (
    false
  ) {
    assertProp(prop, key, value, vm, absent);
  }
  return value
}

/**
 * Get the default value of a prop.
 */
function getPropDefaultValue (vm, prop, key) {
  // no default, return undefined
  if (!hasOwn(prop, 'default')) {
    return undefined
  }
  var def = prop.default;
  // warn against non-factory defaults for Object & Array
  if (false) {
    warn(
      'Invalid default value for prop "' + key + '": ' +
      'Props with type Object/Array must use a factory function ' +
      'to return the default value.',
      vm
    );
  }
  // the raw prop value was also undefined from previous render,
  // return previous default value to avoid unnecessary watcher trigger
  if (vm && vm.$options.propsData &&
    vm.$options.propsData[key] === undefined &&
    vm._props[key] !== undefined
  ) {
    return vm._props[key]
  }
  // call factory function for non-Function types
  // a value is Function if its prototype is function even across different execution context
  return typeof def === 'function' && getType(prop.type) !== 'Function'
    ? def.call(vm)
    : def
}

/**
 * Assert whether a prop is valid.
 */
function assertProp (
  prop,
  name,
  value,
  vm,
  absent
) {
  if (prop.required && absent) {
    warn(
      'Missing required prop: "' + name + '"',
      vm
    );
    return
  }
  if (value == null && !prop.required) {
    return
  }
  var type = prop.type;
  var valid = !type || type === true;
  var expectedTypes = [];
  if (type) {
    if (!Array.isArray(type)) {
      type = [type];
    }
    for (var i = 0; i < type.length && !valid; i++) {
      var assertedType = assertType(value, type[i]);
      expectedTypes.push(assertedType.expectedType || '');
      valid = assertedType.valid;
    }
  }

  if (!valid) {
    warn(
      getInvalidTypeMessage(name, value, expectedTypes),
      vm
    );
    return
  }
  var validator = prop.validator;
  if (validator) {
    if (!validator(value)) {
      warn(
        'Invalid prop: custom validator check failed for prop "' + name + '".',
        vm
      );
    }
  }
}

var simpleCheckRE = /^(String|Number|Boolean|Function|Symbol)$/;

function assertType (value, type) {
  var valid;
  var expectedType = getType(type);
  if (simpleCheckRE.test(expectedType)) {
    var t = typeof value;
    valid = t === expectedType.toLowerCase();
    // for primitive wrapper objects
    if (!valid && t === 'object') {
      valid = value instanceof type;
    }
  } else if (expectedType === 'Object') {
    valid = isPlainObject(value);
  } else if (expectedType === 'Array') {
    valid = Array.isArray(value);
  } else {
    valid = value instanceof type;
  }
  return {
    valid: valid,
    expectedType: expectedType
  }
}

/**
 * Use function string name to check built-in types,
 * because a simple equality check will fail when running
 * across different vms / iframes.
 */
function getType (fn) {
  var match = fn && fn.toString().match(/^\s*function (\w+)/);
  return match ? match[1] : ''
}

function isSameType (a, b) {
  return getType(a) === getType(b)
}

function getTypeIndex (type, expectedTypes) {
  if (!Array.isArray(expectedTypes)) {
    return isSameType(expectedTypes, type) ? 0 : -1
  }
  for (var i = 0, len = expectedTypes.length; i < len; i++) {
    if (isSameType(expectedTypes[i], type)) {
      return i
    }
  }
  return -1
}

function getInvalidTypeMessage (name, value, expectedTypes) {
  var message = "Invalid prop: type check failed for prop \"" + name + "\"." +
    " Expected " + (expectedTypes.map(capitalize).join(', '));
  var expectedType = expectedTypes[0];
  var receivedType = toRawType(value);
  var expectedValue = styleValue(value, expectedType);
  var receivedValue = styleValue(value, receivedType);
  // check if we need to specify expected value
  if (expectedTypes.length === 1 &&
      isExplicable(expectedType) &&
      !isBoolean(expectedType, receivedType)) {
    message += " with value " + expectedValue;
  }
  message += ", got " + receivedType + " ";
  // check if we need to specify received value
  if (isExplicable(receivedType)) {
    message += "with value " + receivedValue + ".";
  }
  return message
}

function styleValue (value, type) {
  if (type === 'String') {
    return ("\"" + value + "\"")
  } else if (type === 'Number') {
    return ("" + (Number(value)))
  } else {
    return ("" + value)
  }
}

function isExplicable (value) {
  var explicitTypes = ['string', 'number', 'boolean'];
  return explicitTypes.some(function (elem) { return value.toLowerCase() === elem; })
}

function isBoolean () {
  var args = [], len = arguments.length;
  while ( len-- ) args[ len ] = arguments[ len ];

  return args.some(function (elem) { return elem.toLowerCase() === 'boolean'; })
}

/*  */

function handleError (err, vm, info) {
  // Deactivate deps tracking while processing error handler to avoid possible infinite rendering.
  // See: https://github.com/vuejs/vuex/issues/1505
  pushTarget();
  try {
    if (vm) {
      var cur = vm;
      while ((cur = cur.$parent)) {
        var hooks = cur.$options.errorCaptured;
        if (hooks) {
          for (var i = 0; i < hooks.length; i++) {
            try {
              var capture = hooks[i].call(cur, err, vm, info) === false;
              if (capture) { return }
            } catch (e) {
              globalHandleError(e, cur, 'errorCaptured hook');
            }
          }
        }
      }
    }
    globalHandleError(err, vm, info);
  } finally {
    popTarget();
  }
}

function invokeWithErrorHandling (
  handler,
  context,
  args,
  vm,
  info
) {
  var res;
  try {
    res = args ? handler.apply(context, args) : handler.call(context);
    if (res && !res._isVue && isPromise(res) && !res._handled) {
      res.catch(function (e) { return handleError(e, vm, info + " (Promise/async)"); });
      // issue #9511
      // avoid catch triggering multiple times when nested calls
      res._handled = true;
    }
  } catch (e) {
    handleError(e, vm, info);
  }
  return res
}

function globalHandleError (err, vm, info) {
  if (config.errorHandler) {
    try {
      return config.errorHandler.call(null, err, vm, info)
    } catch (e) {
      // if the user intentionally throws the original error in the handler,
      // do not log it twice
      if (e !== err) {
        logError(e, null, 'config.errorHandler');
      }
    }
  }
  logError(err, vm, info);
}

function logError (err, vm, info) {
  if (false) {
    warn(("Error in " + info + ": \"" + (err.toString()) + "\""), vm);
  }
  /* istanbul ignore else */
  if ((inBrowser || inWeex) && typeof console !== 'undefined') {
    console.error(err);
  } else {
    throw err
  }
}

/*  */

var isUsingMicroTask = false;

var callbacks = [];
var pending = false;

function flushCallbacks () {
  pending = false;
  var copies = callbacks.slice(0);
  callbacks.length = 0;
  for (var i = 0; i < copies.length; i++) {
    copies[i]();
  }
}

// Here we have async deferring wrappers using microtasks.
// In 2.5 we used (macro) tasks (in combination with microtasks).
// However, it has subtle problems when state is changed right before repaint
// (e.g. #6813, out-in transitions).
// Also, using (macro) tasks in event handler would cause some weird behaviors
// that cannot be circumvented (e.g. #7109, #7153, #7546, #7834, #8109).
// So we now use microtasks everywhere, again.
// A major drawback of this tradeoff is that there are some scenarios
// where microtasks have too high a priority and fire in between supposedly
// sequential events (e.g. #4521, #6690, which have workarounds)
// or even between bubbling of the same event (#6566).
var timerFunc;

// The nextTick behavior leverages the microtask queue, which can be accessed
// via either native Promise.then or MutationObserver.
// MutationObserver has wider support, however it is seriously bugged in
// UIWebView in iOS >= 9.3.3 when triggered in touch event handlers. It
// completely stops working after triggering a few times... so, if native
// Promise is available, we will use it:
/* istanbul ignore next, $flow-disable-line */
if (typeof Promise !== 'undefined' && isNative(Promise)) {
  var p = Promise.resolve();
  timerFunc = function () {
    p.then(flushCallbacks);
    // In problematic UIWebViews, Promise.then doesn't completely break, but
    // it can get stuck in a weird state where callbacks are pushed into the
    // microtask queue but the queue isn't being flushed, until the browser
    // needs to do some other work, e.g. handle a timer. Therefore we can
    // "force" the microtask queue to be flushed by adding an empty timer.
    if (isIOS) { setTimeout(noop); }
  };
  isUsingMicroTask = true;
} else if (!isIE && typeof MutationObserver !== 'undefined' && (
  isNative(MutationObserver) ||
  // PhantomJS and iOS 7.x
  MutationObserver.toString() === '[object MutationObserverConstructor]'
)) {
  // Use MutationObserver where native Promise is not available,
  // e.g. PhantomJS, iOS7, Android 4.4
  // (#6466 MutationObserver is unreliable in IE11)
  var counter = 1;
  var observer = new MutationObserver(flushCallbacks);
  var textNode = document.createTextNode(String(counter));
  observer.observe(textNode, {
    characterData: true
  });
  timerFunc = function () {
    counter = (counter + 1) % 2;
    textNode.data = String(counter);
  };
  isUsingMicroTask = true;
} else if (typeof setImmediate !== 'undefined' && isNative(setImmediate)) {
  // Fallback to setImmediate.
  // Technically it leverages the (macro) task queue,
  // but it is still a better choice than setTimeout.
  timerFunc = function () {
    setImmediate(flushCallbacks);
  };
} else {
  // Fallback to setTimeout.
  timerFunc = function () {
    setTimeout(flushCallbacks, 0);
  };
}

function nextTick (cb, ctx) {
  var _resolve;
  callbacks.push(function () {
    if (cb) {
      try {
        cb.call(ctx);
      } catch (e) {
        handleError(e, ctx, 'nextTick');
      }
    } else if (_resolve) {
      _resolve(ctx);
    }
  });
  if (!pending) {
    pending = true;
    timerFunc();
  }
  // $flow-disable-line
  if (!cb && typeof Promise !== 'undefined') {
    return new Promise(function (resolve) {
      _resolve = resolve;
    })
  }
}

/*  */

var mark;
var measure;

if (false) {
  var perf = inBrowser && window.performance;
  /* istanbul ignore if */
  if (
    perf &&
    perf.mark &&
    perf.measure &&
    perf.clearMarks &&
    perf.clearMeasures
  ) {
    mark = function (tag) { return perf.mark(tag); };
    measure = function (name, startTag, endTag) {
      perf.measure(name, startTag, endTag);
      perf.clearMarks(startTag);
      perf.clearMarks(endTag);
      // perf.clearMeasures(name)
    };
  }
}

/* not type checking this file because flow doesn't play well with Proxy */

var initProxy;

if (false) {
  var allowedGlobals = makeMap(
    'Infinity,undefined,NaN,isFinite,isNaN,' +
    'parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,' +
    'Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,' +
    'require' // for Webpack/Browserify
  );

  var warnNonPresent = function (target, key) {
    warn(
      "Property or method \"" + key + "\" is not defined on the instance but " +
      'referenced during render. Make sure that this property is reactive, ' +
      'either in the data option, or for class-based components, by ' +
      'initializing the property. ' +
      'See: https://vuejs.org/v2/guide/reactivity.html#Declaring-Reactive-Properties.',
      target
    );
  };

  var warnReservedPrefix = function (target, key) {
    warn(
      "Property \"" + key + "\" must be accessed with \"$data." + key + "\" because " +
      'properties starting with "$" or "_" are not proxied in the Vue instance to ' +
      'prevent conflicts with Vue internals. ' +
      'See: https://vuejs.org/v2/api/#data',
      target
    );
  };

  var hasProxy =
    typeof Proxy !== 'undefined' && isNative(Proxy);

  if (hasProxy) {
    var isBuiltInModifier = makeMap('stop,prevent,self,ctrl,shift,alt,meta,exact');
    config.keyCodes = new Proxy(config.keyCodes, {
      set: function set (target, key, value) {
        if (isBuiltInModifier(key)) {
          warn(("Avoid overwriting built-in modifier in config.keyCodes: ." + key));
          return false
        } else {
          target[key] = value;
          return true
        }
      }
    });
  }

  var hasHandler = {
    has: function has (target, key) {
      var has = key in target;
      var isAllowed = allowedGlobals(key) ||
        (typeof key === 'string' && key.charAt(0) === '_' && !(key in target.$data));
      if (!has && !isAllowed) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return has || !isAllowed
    }
  };

  var getHandler = {
    get: function get (target, key) {
      if (typeof key === 'string' && !(key in target)) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return target[key]
    }
  };

  initProxy = function initProxy (vm) {
    if (hasProxy) {
      // determine which proxy handler to use
      var options = vm.$options;
      var handlers = options.render && options.render._withStripped
        ? getHandler
        : hasHandler;
      vm._renderProxy = new Proxy(vm, handlers);
    } else {
      vm._renderProxy = vm;
    }
  };
}

/*  */

var seenObjects = new _Set();

/**
 * Recursively traverse an object to evoke all converted
 * getters, so that every nested property inside the object
 * is collected as a "deep" dependency.
 */
function traverse (val) {
  _traverse(val, seenObjects);
  seenObjects.clear();
}

function _traverse (val, seen) {
  var i, keys;
  var isA = Array.isArray(val);
  if ((!isA && !isObject(val)) || Object.isFrozen(val) || val instanceof VNode) {
    return
  }
  if (val.__ob__) {
    var depId = val.__ob__.dep.id;
    if (seen.has(depId)) {
      return
    }
    seen.add(depId);
  }
  if (isA) {
    i = val.length;
    while (i--) { _traverse(val[i], seen); }
  } else {
    keys = Object.keys(val);
    i = keys.length;
    while (i--) { _traverse(val[keys[i]], seen); }
  }
}

/*  */

var normalizeEvent = cached(function (name) {
  var passive = name.charAt(0) === '&';
  name = passive ? name.slice(1) : name;
  var once$$1 = name.charAt(0) === '~'; // Prefixed last, checked first
  name = once$$1 ? name.slice(1) : name;
  var capture = name.charAt(0) === '!';
  name = capture ? name.slice(1) : name;
  return {
    name: name,
    once: once$$1,
    capture: capture,
    passive: passive
  }
});

function createFnInvoker (fns, vm) {
  function invoker () {
    var arguments$1 = arguments;

    var fns = invoker.fns;
    if (Array.isArray(fns)) {
      var cloned = fns.slice();
      for (var i = 0; i < cloned.length; i++) {
        invokeWithErrorHandling(cloned[i], null, arguments$1, vm, "v-on handler");
      }
    } else {
      // return handler return value for single handlers
      return invokeWithErrorHandling(fns, null, arguments, vm, "v-on handler")
    }
  }
  invoker.fns = fns;
  return invoker
}

function updateListeners (
  on,
  oldOn,
  add,
  remove$$1,
  createOnceHandler,
  vm
) {
  var name, def$$1, cur, old, event;
  for (name in on) {
    def$$1 = cur = on[name];
    old = oldOn[name];
    event = normalizeEvent(name);
    if (isUndef(cur)) {
      "production" !== 'production' && warn(
        "Invalid handler for event \"" + (event.name) + "\": got " + String(cur),
        vm
      );
    } else if (isUndef(old)) {
      if (isUndef(cur.fns)) {
        cur = on[name] = createFnInvoker(cur, vm);
      }
      if (isTrue(event.once)) {
        cur = on[name] = createOnceHandler(event.name, cur, event.capture);
      }
      add(event.name, cur, event.capture, event.passive, event.params);
    } else if (cur !== old) {
      old.fns = cur;
      on[name] = old;
    }
  }
  for (name in oldOn) {
    if (isUndef(on[name])) {
      event = normalizeEvent(name);
      remove$$1(event.name, oldOn[name], event.capture);
    }
  }
}

/*  */

function mergeVNodeHook (def, hookKey, hook) {
  if (def instanceof VNode) {
    def = def.data.hook || (def.data.hook = {});
  }
  var invoker;
  var oldHook = def[hookKey];

  function wrappedHook () {
    hook.apply(this, arguments);
    // important: remove merged hook to ensure it's called only once
    // and prevent memory leak
    remove(invoker.fns, wrappedHook);
  }

  if (isUndef(oldHook)) {
    // no existing hook
    invoker = createFnInvoker([wrappedHook]);
  } else {
    /* istanbul ignore if */
    if (isDef(oldHook.fns) && isTrue(oldHook.merged)) {
      // already a merged invoker
      invoker = oldHook;
      invoker.fns.push(wrappedHook);
    } else {
      // existing plain hook
      invoker = createFnInvoker([oldHook, wrappedHook]);
    }
  }

  invoker.merged = true;
  def[hookKey] = invoker;
}

/*  */

function extractPropsFromVNodeData (
  data,
  Ctor,
  tag
) {
  // we are only extracting raw values here.
  // validation and default values are handled in the child
  // component itself.
  var propOptions = Ctor.options.props;
  if (isUndef(propOptions)) {
    return
  }
  var res = {};
  var attrs = data.attrs;
  var props = data.props;
  if (isDef(attrs) || isDef(props)) {
    for (var key in propOptions) {
      var altKey = hyphenate(key);
      if (false) {
        var keyInLowerCase = key.toLowerCase();
        if (
          key !== keyInLowerCase &&
          attrs && hasOwn(attrs, keyInLowerCase)
        ) {
          tip(
            "Prop \"" + keyInLowerCase + "\" is passed to component " +
            (formatComponentName(tag || Ctor)) + ", but the declared prop name is" +
            " \"" + key + "\". " +
            "Note that HTML attributes are case-insensitive and camelCased " +
            "props need to use their kebab-case equivalents when using in-DOM " +
            "templates. You should probably use \"" + altKey + "\" instead of \"" + key + "\"."
          );
        }
      }
      checkProp(res, props, key, altKey, true) ||
      checkProp(res, attrs, key, altKey, false);
    }
  }
  return res
}

function checkProp (
  res,
  hash,
  key,
  altKey,
  preserve
) {
  if (isDef(hash)) {
    if (hasOwn(hash, key)) {
      res[key] = hash[key];
      if (!preserve) {
        delete hash[key];
      }
      return true
    } else if (hasOwn(hash, altKey)) {
      res[key] = hash[altKey];
      if (!preserve) {
        delete hash[altKey];
      }
      return true
    }
  }
  return false
}

/*  */

// The template compiler attempts to minimize the need for normalization by
// statically analyzing the template at compile time.
//
// For plain HTML markup, normalization can be completely skipped because the
// generated render function is guaranteed to return Array<VNode>. There are
// two cases where extra normalization is needed:

// 1. When the children contains components - because a functional component
// may return an Array instead of a single root. In this case, just a simple
// normalization is needed - if any child is an Array, we flatten the whole
// thing with Array.prototype.concat. It is guaranteed to be only 1-level deep
// because functional components already normalize their own children.
function simpleNormalizeChildren (children) {
  for (var i = 0; i < children.length; i++) {
    if (Array.isArray(children[i])) {
      return Array.prototype.concat.apply([], children)
    }
  }
  return children
}

// 2. When the children contains constructs that always generated nested Arrays,
// e.g. <template>, <slot>, v-for, or when the children is provided by user
// with hand-written render functions / JSX. In such cases a full normalization
// is needed to cater to all possible types of children values.
function normalizeChildren (children) {
  return isPrimitive(children)
    ? [createTextVNode(children)]
    : Array.isArray(children)
      ? normalizeArrayChildren(children)
      : undefined
}

function isTextNode (node) {
  return isDef(node) && isDef(node.text) && isFalse(node.isComment)
}

function normalizeArrayChildren (children, nestedIndex) {
  var res = [];
  var i, c, lastIndex, last;
  for (i = 0; i < children.length; i++) {
    c = children[i];
    if (isUndef(c) || typeof c === 'boolean') { continue }
    lastIndex = res.length - 1;
    last = res[lastIndex];
    //  nested
    if (Array.isArray(c)) {
      if (c.length > 0) {
        c = normalizeArrayChildren(c, ((nestedIndex || '') + "_" + i));
        // merge adjacent text nodes
        if (isTextNode(c[0]) && isTextNode(last)) {
          res[lastIndex] = createTextVNode(last.text + (c[0]).text);
          c.shift();
        }
        res.push.apply(res, c);
      }
    } else if (isPrimitive(c)) {
      if (isTextNode(last)) {
        // merge adjacent text nodes
        // this is necessary for SSR hydration because text nodes are
        // essentially merged when rendered to HTML strings
        res[lastIndex] = createTextVNode(last.text + c);
      } else if (c !== '') {
        // convert primitive to vnode
        res.push(createTextVNode(c));
      }
    } else {
      if (isTextNode(c) && isTextNode(last)) {
        // merge adjacent text nodes
        res[lastIndex] = createTextVNode(last.text + c.text);
      } else {
        // default key for nested array children (likely generated by v-for)
        if (isTrue(children._isVList) &&
          isDef(c.tag) &&
          isUndef(c.key) &&
          isDef(nestedIndex)) {
          c.key = "__vlist" + nestedIndex + "_" + i + "__";
        }
        res.push(c);
      }
    }
  }
  return res
}

/*  */

function initProvide (vm) {
  var provide = vm.$options.provide;
  if (provide) {
    vm._provided = typeof provide === 'function'
      ? provide.call(vm)
      : provide;
  }
}

function initInjections (vm) {
  var result = resolveInject(vm.$options.inject, vm);
  if (result) {
    toggleObserving(false);
    Object.keys(result).forEach(function (key) {
      /* istanbul ignore else */
      if (false) {
        defineReactive$$1(vm, key, result[key], function () {
          warn(
            "Avoid mutating an injected value directly since the changes will be " +
            "overwritten whenever the provided component re-renders. " +
            "injection being mutated: \"" + key + "\"",
            vm
          );
        });
      } else {
        defineReactive$$1(vm, key, result[key]);
      }
    });
    toggleObserving(true);
  }
}

function resolveInject (inject, vm) {
  if (inject) {
    // inject is :any because flow is not smart enough to figure out cached
    var result = Object.create(null);
    var keys = hasSymbol
      ? Reflect.ownKeys(inject)
      : Object.keys(inject);

    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      // #6574 in case the inject object is observed...
      if (key === '__ob__') { continue }
      var provideKey = inject[key].from;
      var source = vm;
      while (source) {
        if (source._provided && hasOwn(source._provided, provideKey)) {
          result[key] = source._provided[provideKey];
          break
        }
        source = source.$parent;
      }
      if (!source) {
        if ('default' in inject[key]) {
          var provideDefault = inject[key].default;
          result[key] = typeof provideDefault === 'function'
            ? provideDefault.call(vm)
            : provideDefault;
        } else if (false) {
          warn(("Injection \"" + key + "\" not found"), vm);
        }
      }
    }
    return result
  }
}

/*  */



/**
 * Runtime helper for resolving raw children VNodes into a slot object.
 */
function resolveSlots (
  children,
  context
) {
  if (!children || !children.length) {
    return {}
  }
  var slots = {};
  for (var i = 0, l = children.length; i < l; i++) {
    var child = children[i];
    var data = child.data;
    // remove slot attribute if the node is resolved as a Vue slot node
    if (data && data.attrs && data.attrs.slot) {
      delete data.attrs.slot;
    }
    // named slots should only be respected if the vnode was rendered in the
    // same context.
    if ((child.context === context || child.fnContext === context) &&
      data && data.slot != null
    ) {
      var name = data.slot;
      var slot = (slots[name] || (slots[name] = []));
      if (child.tag === 'template') {
        slot.push.apply(slot, child.children || []);
      } else {
        slot.push(child);
      }
    } else {
      (slots.default || (slots.default = [])).push(child);
    }
  }
  // ignore slots that contains only whitespace
  for (var name$1 in slots) {
    if (slots[name$1].every(isWhitespace)) {
      delete slots[name$1];
    }
  }
  return slots
}

function isWhitespace (node) {
  return (node.isComment && !node.asyncFactory) || node.text === ' '
}

/*  */

function normalizeScopedSlots (
  slots,
  normalSlots,
  prevSlots
) {
  var res;
  var hasNormalSlots = Object.keys(normalSlots).length > 0;
  var isStable = slots ? !!slots.$stable : !hasNormalSlots;
  var key = slots && slots.$key;
  if (!slots) {
    res = {};
  } else if (slots._normalized) {
    // fast path 1: child component re-render only, parent did not change
    return slots._normalized
  } else if (
    isStable &&
    prevSlots &&
    prevSlots !== emptyObject &&
    key === prevSlots.$key &&
    !hasNormalSlots &&
    !prevSlots.$hasNormal
  ) {
    // fast path 2: stable scoped slots w/ no normal slots to proxy,
    // only need to normalize once
    return prevSlots
  } else {
    res = {};
    for (var key$1 in slots) {
      if (slots[key$1] && key$1[0] !== '$') {
        res[key$1] = normalizeScopedSlot(normalSlots, key$1, slots[key$1]);
      }
    }
  }
  // expose normal slots on scopedSlots
  for (var key$2 in normalSlots) {
    if (!(key$2 in res)) {
      res[key$2] = proxyNormalSlot(normalSlots, key$2);
    }
  }
  // avoriaz seems to mock a non-extensible $scopedSlots object
  // and when that is passed down this would cause an error
  if (slots && Object.isExtensible(slots)) {
    (slots)._normalized = res;
  }
  def(res, '$stable', isStable);
  def(res, '$key', key);
  def(res, '$hasNormal', hasNormalSlots);
  return res
}

function normalizeScopedSlot(normalSlots, key, fn) {
  var normalized = function () {
    var res = arguments.length ? fn.apply(null, arguments) : fn({});
    res = res && typeof res === 'object' && !Array.isArray(res)
      ? [res] // single vnode
      : normalizeChildren(res);
    return res && (
      res.length === 0 ||
      (res.length === 1 && res[0].isComment) // #9658
    ) ? undefined
      : res
  };
  // this is a slot using the new v-slot syntax without scope. although it is
  // compiled as a scoped slot, render fn users would expect it to be present
  // on this.$slots because the usage is semantically a normal slot.
  if (fn.proxy) {
    Object.defineProperty(normalSlots, key, {
      get: normalized,
      enumerable: true,
      configurable: true
    });
  }
  return normalized
}

function proxyNormalSlot(slots, key) {
  return function () { return slots[key]; }
}

/*  */

/**
 * Runtime helper for rendering v-for lists.
 */
function renderList (
  val,
  render
) {
  var ret, i, l, keys, key;
  if (Array.isArray(val) || typeof val === 'string') {
    ret = new Array(val.length);
    for (i = 0, l = val.length; i < l; i++) {
      ret[i] = render(val[i], i);
    }
  } else if (typeof val === 'number') {
    ret = new Array(val);
    for (i = 0; i < val; i++) {
      ret[i] = render(i + 1, i);
    }
  } else if (isObject(val)) {
    if (hasSymbol && val[Symbol.iterator]) {
      ret = [];
      var iterator = val[Symbol.iterator]();
      var result = iterator.next();
      while (!result.done) {
        ret.push(render(result.value, ret.length));
        result = iterator.next();
      }
    } else {
      keys = Object.keys(val);
      ret = new Array(keys.length);
      for (i = 0, l = keys.length; i < l; i++) {
        key = keys[i];
        ret[i] = render(val[key], key, i);
      }
    }
  }
  if (!isDef(ret)) {
    ret = [];
  }
  (ret)._isVList = true;
  return ret
}

/*  */

/**
 * Runtime helper for rendering <slot>
 */
function renderSlot (
  name,
  fallback,
  props,
  bindObject
) {
  var scopedSlotFn = this.$scopedSlots[name];
  var nodes;
  if (scopedSlotFn) { // scoped slot
    props = props || {};
    if (bindObject) {
      if (false) {
        warn(
          'slot v-bind without argument expects an Object',
          this
        );
      }
      props = extend(extend({}, bindObject), props);
    }
    nodes = scopedSlotFn(props) || fallback;
  } else {
    nodes = this.$slots[name] || fallback;
  }

  var target = props && props.slot;
  if (target) {
    return this.$createElement('template', { slot: target }, nodes)
  } else {
    return nodes
  }
}

/*  */

/**
 * Runtime helper for resolving filters
 */
function resolveFilter (id) {
  return resolveAsset(this.$options, 'filters', id, true) || identity
}

/*  */

function isKeyNotMatch (expect, actual) {
  if (Array.isArray(expect)) {
    return expect.indexOf(actual) === -1
  } else {
    return expect !== actual
  }
}

/**
 * Runtime helper for checking keyCodes from config.
 * exposed as Vue.prototype._k
 * passing in eventKeyName as last argument separately for backwards compat
 */
function checkKeyCodes (
  eventKeyCode,
  key,
  builtInKeyCode,
  eventKeyName,
  builtInKeyName
) {
  var mappedKeyCode = config.keyCodes[key] || builtInKeyCode;
  if (builtInKeyName && eventKeyName && !config.keyCodes[key]) {
    return isKeyNotMatch(builtInKeyName, eventKeyName)
  } else if (mappedKeyCode) {
    return isKeyNotMatch(mappedKeyCode, eventKeyCode)
  } else if (eventKeyName) {
    return hyphenate(eventKeyName) !== key
  }
}

/*  */

/**
 * Runtime helper for merging v-bind="object" into a VNode's data.
 */
function bindObjectProps (
  data,
  tag,
  value,
  asProp,
  isSync
) {
  if (value) {
    if (!isObject(value)) {
      "production" !== 'production' && warn(
        'v-bind without argument expects an Object or Array value',
        this
      );
    } else {
      if (Array.isArray(value)) {
        value = toObject(value);
      }
      var hash;
      var loop = function ( key ) {
        if (
          key === 'class' ||
          key === 'style' ||
          isReservedAttribute(key)
        ) {
          hash = data;
        } else {
          var type = data.attrs && data.attrs.type;
          hash = asProp || config.mustUseProp(tag, type, key)
            ? data.domProps || (data.domProps = {})
            : data.attrs || (data.attrs = {});
        }
        var camelizedKey = camelize(key);
        var hyphenatedKey = hyphenate(key);
        if (!(camelizedKey in hash) && !(hyphenatedKey in hash)) {
          hash[key] = value[key];

          if (isSync) {
            var on = data.on || (data.on = {});
            on[("update:" + key)] = function ($event) {
              value[key] = $event;
            };
          }
        }
      };

      for (var key in value) loop( key );
    }
  }
  return data
}

/*  */

/**
 * Runtime helper for rendering static trees.
 */
function renderStatic (
  index,
  isInFor
) {
  var cached = this._staticTrees || (this._staticTrees = []);
  var tree = cached[index];
  // if has already-rendered static tree and not inside v-for,
  // we can reuse the same tree.
  if (tree && !isInFor) {
    return tree
  }
  // otherwise, render a fresh tree.
  tree = cached[index] = this.$options.staticRenderFns[index].call(
    this._renderProxy,
    null,
    this // for render fns generated for functional component templates
  );
  markStatic(tree, ("__static__" + index), false);
  return tree
}

/**
 * Runtime helper for v-once.
 * Effectively it means marking the node as static with a unique key.
 */
function markOnce (
  tree,
  index,
  key
) {
  markStatic(tree, ("__once__" + index + (key ? ("_" + key) : "")), true);
  return tree
}

function markStatic (
  tree,
  key,
  isOnce
) {
  if (Array.isArray(tree)) {
    for (var i = 0; i < tree.length; i++) {
      if (tree[i] && typeof tree[i] !== 'string') {
        markStaticNode(tree[i], (key + "_" + i), isOnce);
      }
    }
  } else {
    markStaticNode(tree, key, isOnce);
  }
}

function markStaticNode (node, key, isOnce) {
  node.isStatic = true;
  node.key = key;
  node.isOnce = isOnce;
}

/*  */

function bindObjectListeners (data, value) {
  if (value) {
    if (!isPlainObject(value)) {
      "production" !== 'production' && warn(
        'v-on without argument expects an Object value',
        this
      );
    } else {
      var on = data.on = data.on ? extend({}, data.on) : {};
      for (var key in value) {
        var existing = on[key];
        var ours = value[key];
        on[key] = existing ? [].concat(existing, ours) : ours;
      }
    }
  }
  return data
}

/*  */

function resolveScopedSlots (
  fns, // see flow/vnode
  res,
  // the following are added in 2.6
  hasDynamicKeys,
  contentHashKey
) {
  res = res || { $stable: !hasDynamicKeys };
  for (var i = 0; i < fns.length; i++) {
    var slot = fns[i];
    if (Array.isArray(slot)) {
      resolveScopedSlots(slot, res, hasDynamicKeys);
    } else if (slot) {
      // marker for reverse proxying v-slot without scope on this.$slots
      if (slot.proxy) {
        slot.fn.proxy = true;
      }
      res[slot.key] = slot.fn;
    }
  }
  if (contentHashKey) {
    (res).$key = contentHashKey;
  }
  return res
}

/*  */

function bindDynamicKeys (baseObj, values) {
  for (var i = 0; i < values.length; i += 2) {
    var key = values[i];
    if (typeof key === 'string' && key) {
      baseObj[values[i]] = values[i + 1];
    } else if (false) {
      // null is a special value for explicitly removing a binding
      warn(
        ("Invalid value for dynamic directive argument (expected string or null): " + key),
        this
      );
    }
  }
  return baseObj
}

// helper to dynamically append modifier runtime markers to event names.
// ensure only append when value is already string, otherwise it will be cast
// to string and cause the type check to miss.
function prependModifier (value, symbol) {
  return typeof value === 'string' ? symbol + value : value
}

/*  */

function installRenderHelpers (target) {
  target._o = markOnce;
  target._n = toNumber;
  target._s = toString;
  target._l = renderList;
  target._t = renderSlot;
  target._q = looseEqual;
  target._i = looseIndexOf;
  target._m = renderStatic;
  target._f = resolveFilter;
  target._k = checkKeyCodes;
  target._b = bindObjectProps;
  target._v = createTextVNode;
  target._e = createEmptyVNode;
  target._u = resolveScopedSlots;
  target._g = bindObjectListeners;
  target._d = bindDynamicKeys;
  target._p = prependModifier;
}

/*  */

function FunctionalRenderContext (
  data,
  props,
  children,
  parent,
  Ctor
) {
  var this$1 = this;

  var options = Ctor.options;
  // ensure the createElement function in functional components
  // gets a unique context - this is necessary for correct named slot check
  var contextVm;
  if (hasOwn(parent, '_uid')) {
    contextVm = Object.create(parent);
    // $flow-disable-line
    contextVm._original = parent;
  } else {
    // the context vm passed in is a functional context as well.
    // in this case we want to make sure we are able to get a hold to the
    // real context instance.
    contextVm = parent;
    // $flow-disable-line
    parent = parent._original;
  }
  var isCompiled = isTrue(options._compiled);
  var needNormalization = !isCompiled;

  this.data = data;
  this.props = props;
  this.children = children;
  this.parent = parent;
  this.listeners = data.on || emptyObject;
  this.injections = resolveInject(options.inject, parent);
  this.slots = function () {
    if (!this$1.$slots) {
      normalizeScopedSlots(
        data.scopedSlots,
        this$1.$slots = resolveSlots(children, parent)
      );
    }
    return this$1.$slots
  };

  Object.defineProperty(this, 'scopedSlots', ({
    enumerable: true,
    get: function get () {
      return normalizeScopedSlots(data.scopedSlots, this.slots())
    }
  }));

  // support for compiled functional template
  if (isCompiled) {
    // exposing $options for renderStatic()
    this.$options = options;
    // pre-resolve slots for renderSlot()
    this.$slots = this.slots();
    this.$scopedSlots = normalizeScopedSlots(data.scopedSlots, this.$slots);
  }

  if (options._scopeId) {
    this._c = function (a, b, c, d) {
      var vnode = createElement(contextVm, a, b, c, d, needNormalization);
      if (vnode && !Array.isArray(vnode)) {
        vnode.fnScopeId = options._scopeId;
        vnode.fnContext = parent;
      }
      return vnode
    };
  } else {
    this._c = function (a, b, c, d) { return createElement(contextVm, a, b, c, d, needNormalization); };
  }
}

installRenderHelpers(FunctionalRenderContext.prototype);

function createFunctionalComponent (
  Ctor,
  propsData,
  data,
  contextVm,
  children
) {
  var options = Ctor.options;
  var props = {};
  var propOptions = options.props;
  if (isDef(propOptions)) {
    for (var key in propOptions) {
      props[key] = validateProp(key, propOptions, propsData || emptyObject);
    }
  } else {
    if (isDef(data.attrs)) { mergeProps(props, data.attrs); }
    if (isDef(data.props)) { mergeProps(props, data.props); }
  }

  var renderContext = new FunctionalRenderContext(
    data,
    props,
    children,
    contextVm,
    Ctor
  );

  var vnode = options.render.call(null, renderContext._c, renderContext);

  if (vnode instanceof VNode) {
    return cloneAndMarkFunctionalResult(vnode, data, renderContext.parent, options, renderContext)
  } else if (Array.isArray(vnode)) {
    var vnodes = normalizeChildren(vnode) || [];
    var res = new Array(vnodes.length);
    for (var i = 0; i < vnodes.length; i++) {
      res[i] = cloneAndMarkFunctionalResult(vnodes[i], data, renderContext.parent, options, renderContext);
    }
    return res
  }
}

function cloneAndMarkFunctionalResult (vnode, data, contextVm, options, renderContext) {
  // #7817 clone node before setting fnContext, otherwise if the node is reused
  // (e.g. it was from a cached normal slot) the fnContext causes named slots
  // that should not be matched to match.
  var clone = cloneVNode(vnode);
  clone.fnContext = contextVm;
  clone.fnOptions = options;
  if (false) {
    (clone.devtoolsMeta = clone.devtoolsMeta || {}).renderContext = renderContext;
  }
  if (data.slot) {
    (clone.data || (clone.data = {})).slot = data.slot;
  }
  return clone
}

function mergeProps (to, from) {
  for (var key in from) {
    to[camelize(key)] = from[key];
  }
}

/*  */

/*  */

/*  */

/*  */

// inline hooks to be invoked on component VNodes during patch
var componentVNodeHooks = {
  init: function init (vnode, hydrating) {
    if (
      vnode.componentInstance &&
      !vnode.componentInstance._isDestroyed &&
      vnode.data.keepAlive
    ) {
      // kept-alive components, treat as a patch
      var mountedNode = vnode; // work around flow
      componentVNodeHooks.prepatch(mountedNode, mountedNode);
    } else {
      var child = vnode.componentInstance = createComponentInstanceForVnode(
        vnode,
        activeInstance
      );
      child.$mount(hydrating ? vnode.elm : undefined, hydrating);
    }
  },

  prepatch: function prepatch (oldVnode, vnode) {
    var options = vnode.componentOptions;
    var child = vnode.componentInstance = oldVnode.componentInstance;
    updateChildComponent(
      child,
      options.propsData, // updated props
      options.listeners, // updated listeners
      vnode, // new parent vnode
      options.children // new children
    );
  },

  insert: function insert (vnode) {
    var context = vnode.context;
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isMounted) {
      componentInstance._isMounted = true;
      callHook(componentInstance, 'mounted');
    }
    if (vnode.data.keepAlive) {
      if (context._isMounted) {
        // vue-router#1212
        // During updates, a kept-alive component's child components may
        // change, so directly walking the tree here may call activated hooks
        // on incorrect children. Instead we push them into a queue which will
        // be processed after the whole patch process ended.
        queueActivatedComponent(componentInstance);
      } else {
        activateChildComponent(componentInstance, true /* direct */);
      }
    }
  },

  destroy: function destroy (vnode) {
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isDestroyed) {
      if (!vnode.data.keepAlive) {
        componentInstance.$destroy();
      } else {
        deactivateChildComponent(componentInstance, true /* direct */);
      }
    }
  }
};

var hooksToMerge = Object.keys(componentVNodeHooks);

function createComponent (
  Ctor,
  data,
  context,
  children,
  tag
) {
  if (isUndef(Ctor)) {
    return
  }

  var baseCtor = context.$options._base;

  // plain options object: turn it into a constructor
  if (isObject(Ctor)) {
    Ctor = baseCtor.extend(Ctor);
  }

  // if at this stage it's not a constructor or an async component factory,
  // reject.
  if (typeof Ctor !== 'function') {
    if (false) {
      warn(("Invalid Component definition: " + (String(Ctor))), context);
    }
    return
  }

  // async component
  var asyncFactory;
  if (isUndef(Ctor.cid)) {
    asyncFactory = Ctor;
    Ctor = resolveAsyncComponent(asyncFactory, baseCtor);
    if (Ctor === undefined) {
      // return a placeholder node for async component, which is rendered
      // as a comment node but preserves all the raw information for the node.
      // the information will be used for async server-rendering and hydration.
      return createAsyncPlaceholder(
        asyncFactory,
        data,
        context,
        children,
        tag
      )
    }
  }

  data = data || {};

  // resolve constructor options in case global mixins are applied after
  // component constructor creation
  resolveConstructorOptions(Ctor);

  // transform component v-model data into props & events
  if (isDef(data.model)) {
    transformModel(Ctor.options, data);
  }

  // extract props
  var propsData = extractPropsFromVNodeData(data, Ctor, tag);

  // functional component
  if (isTrue(Ctor.options.functional)) {
    return createFunctionalComponent(Ctor, propsData, data, context, children)
  }

  // extract listeners, since these needs to be treated as
  // child component listeners instead of DOM listeners
  var listeners = data.on;
  // replace with listeners with .native modifier
  // so it gets processed during parent component patch.
  data.on = data.nativeOn;

  if (isTrue(Ctor.options.abstract)) {
    // abstract components do not keep anything
    // other than props & listeners & slot

    // work around flow
    var slot = data.slot;
    data = {};
    if (slot) {
      data.slot = slot;
    }
  }

  // install component management hooks onto the placeholder node
  installComponentHooks(data);

  // return a placeholder vnode
  var name = Ctor.options.name || tag;
  var vnode = new VNode(
    ("vue-component-" + (Ctor.cid) + (name ? ("-" + name) : '')),
    data, undefined, undefined, undefined, context,
    { Ctor: Ctor, propsData: propsData, listeners: listeners, tag: tag, children: children },
    asyncFactory
  );

  return vnode
}

function createComponentInstanceForVnode (
  vnode, // we know it's MountedComponentVNode but flow doesn't
  parent // activeInstance in lifecycle state
) {
  var options = {
    _isComponent: true,
    _parentVnode: vnode,
    parent: parent
  };
  // check inline-template render functions
  var inlineTemplate = vnode.data.inlineTemplate;
  if (isDef(inlineTemplate)) {
    options.render = inlineTemplate.render;
    options.staticRenderFns = inlineTemplate.staticRenderFns;
  }
  return new vnode.componentOptions.Ctor(options)
}

function installComponentHooks (data) {
  var hooks = data.hook || (data.hook = {});
  for (var i = 0; i < hooksToMerge.length; i++) {
    var key = hooksToMerge[i];
    var existing = hooks[key];
    var toMerge = componentVNodeHooks[key];
    if (existing !== toMerge && !(existing && existing._merged)) {
      hooks[key] = existing ? mergeHook$1(toMerge, existing) : toMerge;
    }
  }
}

function mergeHook$1 (f1, f2) {
  var merged = function (a, b) {
    // flow complains about extra args which is why we use any
    f1(a, b);
    f2(a, b);
  };
  merged._merged = true;
  return merged
}

// transform component v-model info (value and callback) into
// prop and event handler respectively.
function transformModel (options, data) {
  var prop = (options.model && options.model.prop) || 'value';
  var event = (options.model && options.model.event) || 'input'
  ;(data.attrs || (data.attrs = {}))[prop] = data.model.value;
  var on = data.on || (data.on = {});
  var existing = on[event];
  var callback = data.model.callback;
  if (isDef(existing)) {
    if (
      Array.isArray(existing)
        ? existing.indexOf(callback) === -1
        : existing !== callback
    ) {
      on[event] = [callback].concat(existing);
    }
  } else {
    on[event] = callback;
  }
}

/*  */

var SIMPLE_NORMALIZE = 1;
var ALWAYS_NORMALIZE = 2;

// wrapper function for providing a more flexible interface
// without getting yelled at by flow
function createElement (
  context,
  tag,
  data,
  children,
  normalizationType,
  alwaysNormalize
) {
  if (Array.isArray(data) || isPrimitive(data)) {
    normalizationType = children;
    children = data;
    data = undefined;
  }
  if (isTrue(alwaysNormalize)) {
    normalizationType = ALWAYS_NORMALIZE;
  }
  return _createElement(context, tag, data, children, normalizationType)
}

function _createElement (
  context,
  tag,
  data,
  children,
  normalizationType
) {
  if (isDef(data) && isDef((data).__ob__)) {
    "production" !== 'production' && warn(
      "Avoid using observed data object as vnode data: " + (JSON.stringify(data)) + "\n" +
      'Always create fresh vnode data objects in each render!',
      context
    );
    return createEmptyVNode()
  }
  // object syntax in v-bind
  if (isDef(data) && isDef(data.is)) {
    tag = data.is;
  }
  if (!tag) {
    // in case of component :is set to falsy value
    return createEmptyVNode()
  }
  // warn against non-primitive key
  if (false
  ) {
    {
      warn(
        'Avoid using non-primitive value as key, ' +
        'use string/number value instead.',
        context
      );
    }
  }
  // support single function children as default scoped slot
  if (Array.isArray(children) &&
    typeof children[0] === 'function'
  ) {
    data = data || {};
    data.scopedSlots = { default: children[0] };
    children.length = 0;
  }
  if (normalizationType === ALWAYS_NORMALIZE) {
    children = normalizeChildren(children);
  } else if (normalizationType === SIMPLE_NORMALIZE) {
    children = simpleNormalizeChildren(children);
  }
  var vnode, ns;
  if (typeof tag === 'string') {
    var Ctor;
    ns = (context.$vnode && context.$vnode.ns) || config.getTagNamespace(tag);
    if (config.isReservedTag(tag)) {
      // platform built-in elements
      if (false) {
        warn(
          ("The .native modifier for v-on is only valid on components but it was used on <" + tag + ">."),
          context
        );
      }
      vnode = new VNode(
        config.parsePlatformTagName(tag), data, children,
        undefined, undefined, context
      );
    } else if ((!data || !data.pre) && isDef(Ctor = resolveAsset(context.$options, 'components', tag))) {
      // component
      vnode = createComponent(Ctor, data, context, children, tag);
    } else {
      // unknown or unlisted namespaced elements
      // check at runtime because it may get assigned a namespace when its
      // parent normalizes children
      vnode = new VNode(
        tag, data, children,
        undefined, undefined, context
      );
    }
  } else {
    // direct component options / constructor
    vnode = createComponent(tag, data, context, children);
  }
  if (Array.isArray(vnode)) {
    return vnode
  } else if (isDef(vnode)) {
    if (isDef(ns)) { applyNS(vnode, ns); }
    if (isDef(data)) { registerDeepBindings(data); }
    return vnode
  } else {
    return createEmptyVNode()
  }
}

function applyNS (vnode, ns, force) {
  vnode.ns = ns;
  if (vnode.tag === 'foreignObject') {
    // use default namespace inside foreignObject
    ns = undefined;
    force = true;
  }
  if (isDef(vnode.children)) {
    for (var i = 0, l = vnode.children.length; i < l; i++) {
      var child = vnode.children[i];
      if (isDef(child.tag) && (
        isUndef(child.ns) || (isTrue(force) && child.tag !== 'svg'))) {
        applyNS(child, ns, force);
      }
    }
  }
}

// ref #5318
// necessary to ensure parent re-render when deep bindings like :style and
// :class are used on slot nodes
function registerDeepBindings (data) {
  if (isObject(data.style)) {
    traverse(data.style);
  }
  if (isObject(data.class)) {
    traverse(data.class);
  }
}

/*  */

function initRender (vm) {
  vm._vnode = null; // the root of the child tree
  vm._staticTrees = null; // v-once cached trees
  var options = vm.$options;
  var parentVnode = vm.$vnode = options._parentVnode; // the placeholder node in parent tree
  var renderContext = parentVnode && parentVnode.context;
  vm.$slots = resolveSlots(options._renderChildren, renderContext);
  vm.$scopedSlots = emptyObject;
  // bind the createElement fn to this instance
  // so that we get proper render context inside it.
  // args order: tag, data, children, normalizationType, alwaysNormalize
  // internal version is used by render functions compiled from templates
  vm._c = function (a, b, c, d) { return createElement(vm, a, b, c, d, false); };
  // normalization is always applied for the public version, used in
  // user-written render functions.
  vm.$createElement = function (a, b, c, d) { return createElement(vm, a, b, c, d, true); };

  // $attrs & $listeners are exposed for easier HOC creation.
  // they need to be reactive so that HOCs using them are always updated
  var parentData = parentVnode && parentVnode.data;

  /* istanbul ignore else */
  if (false) {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, function () {
      !isUpdatingChildComponent && warn("$attrs is readonly.", vm);
    }, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, function () {
      !isUpdatingChildComponent && warn("$listeners is readonly.", vm);
    }, true);
  } else {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, null, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, null, true);
  }
}

var currentRenderingInstance = null;

function renderMixin (Vue) {
  // install runtime convenience helpers
  installRenderHelpers(Vue.prototype);

  Vue.prototype.$nextTick = function (fn) {
    return nextTick(fn, this)
  };

  Vue.prototype._render = function () {
    var vm = this;
    var ref = vm.$options;
    var render = ref.render;
    var _parentVnode = ref._parentVnode;

    if (_parentVnode) {
      vm.$scopedSlots = normalizeScopedSlots(
        _parentVnode.data.scopedSlots,
        vm.$slots,
        vm.$scopedSlots
      );
    }

    // set parent vnode. this allows render functions to have access
    // to the data on the placeholder node.
    vm.$vnode = _parentVnode;
    // render self
    var vnode;
    try {
      // There's no need to maintain a stack because all render fns are called
      // separately from one another. Nested component's render fns are called
      // when parent component is patched.
      currentRenderingInstance = vm;
      vnode = render.call(vm._renderProxy, vm.$createElement);
    } catch (e) {
      handleError(e, vm, "render");
      // return error render result,
      // or previous vnode to prevent render error causing blank component
      /* istanbul ignore else */
      if (false) {
        try {
          vnode = vm.$options.renderError.call(vm._renderProxy, vm.$createElement, e);
        } catch (e) {
          handleError(e, vm, "renderError");
          vnode = vm._vnode;
        }
      } else {
        vnode = vm._vnode;
      }
    } finally {
      currentRenderingInstance = null;
    }
    // if the returned array contains only a single node, allow it
    if (Array.isArray(vnode) && vnode.length === 1) {
      vnode = vnode[0];
    }
    // return empty vnode in case the render function errored out
    if (!(vnode instanceof VNode)) {
      if (false) {
        warn(
          'Multiple root nodes returned from render function. Render function ' +
          'should return a single root node.',
          vm
        );
      }
      vnode = createEmptyVNode();
    }
    // set parent
    vnode.parent = _parentVnode;
    return vnode
  };
}

/*  */

function ensureCtor (comp, base) {
  if (
    comp.__esModule ||
    (hasSymbol && comp[Symbol.toStringTag] === 'Module')
  ) {
    comp = comp.default;
  }
  return isObject(comp)
    ? base.extend(comp)
    : comp
}

function createAsyncPlaceholder (
  factory,
  data,
  context,
  children,
  tag
) {
  var node = createEmptyVNode();
  node.asyncFactory = factory;
  node.asyncMeta = { data: data, context: context, children: children, tag: tag };
  return node
}

function resolveAsyncComponent (
  factory,
  baseCtor
) {
  if (isTrue(factory.error) && isDef(factory.errorComp)) {
    return factory.errorComp
  }

  if (isDef(factory.resolved)) {
    return factory.resolved
  }

  var owner = currentRenderingInstance;
  if (owner && isDef(factory.owners) && factory.owners.indexOf(owner) === -1) {
    // already pending
    factory.owners.push(owner);
  }

  if (isTrue(factory.loading) && isDef(factory.loadingComp)) {
    return factory.loadingComp
  }

  if (owner && !isDef(factory.owners)) {
    var owners = factory.owners = [owner];
    var sync = true;
    var timerLoading = null;
    var timerTimeout = null

    ;(owner).$on('hook:destroyed', function () { return remove(owners, owner); });

    var forceRender = function (renderCompleted) {
      for (var i = 0, l = owners.length; i < l; i++) {
        (owners[i]).$forceUpdate();
      }

      if (renderCompleted) {
        owners.length = 0;
        if (timerLoading !== null) {
          clearTimeout(timerLoading);
          timerLoading = null;
        }
        if (timerTimeout !== null) {
          clearTimeout(timerTimeout);
          timerTimeout = null;
        }
      }
    };

    var resolve = once(function (res) {
      // cache resolved
      factory.resolved = ensureCtor(res, baseCtor);
      // invoke callbacks only if this is not a synchronous resolve
      // (async resolves are shimmed as synchronous during SSR)
      if (!sync) {
        forceRender(true);
      } else {
        owners.length = 0;
      }
    });

    var reject = once(function (reason) {
      "production" !== 'production' && warn(
        "Failed to resolve async component: " + (String(factory)) +
        (reason ? ("\nReason: " + reason) : '')
      );
      if (isDef(factory.errorComp)) {
        factory.error = true;
        forceRender(true);
      }
    });

    var res = factory(resolve, reject);

    if (isObject(res)) {
      if (isPromise(res)) {
        // () => Promise
        if (isUndef(factory.resolved)) {
          res.then(resolve, reject);
        }
      } else if (isPromise(res.component)) {
        res.component.then(resolve, reject);

        if (isDef(res.error)) {
          factory.errorComp = ensureCtor(res.error, baseCtor);
        }

        if (isDef(res.loading)) {
          factory.loadingComp = ensureCtor(res.loading, baseCtor);
          if (res.delay === 0) {
            factory.loading = true;
          } else {
            timerLoading = setTimeout(function () {
              timerLoading = null;
              if (isUndef(factory.resolved) && isUndef(factory.error)) {
                factory.loading = true;
                forceRender(false);
              }
            }, res.delay || 200);
          }
        }

        if (isDef(res.timeout)) {
          timerTimeout = setTimeout(function () {
            timerTimeout = null;
            if (isUndef(factory.resolved)) {
              reject(
                 false
                  ? ("timeout (" + (res.timeout) + "ms)")
                  : null
              );
            }
          }, res.timeout);
        }
      }
    }

    sync = false;
    // return in case resolved synchronously
    return factory.loading
      ? factory.loadingComp
      : factory.resolved
  }
}

/*  */

function isAsyncPlaceholder (node) {
  return node.isComment && node.asyncFactory
}

/*  */

function getFirstComponentChild (children) {
  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      var c = children[i];
      if (isDef(c) && (isDef(c.componentOptions) || isAsyncPlaceholder(c))) {
        return c
      }
    }
  }
}

/*  */

/*  */

function initEvents (vm) {
  vm._events = Object.create(null);
  vm._hasHookEvent = false;
  // init parent attached events
  var listeners = vm.$options._parentListeners;
  if (listeners) {
    updateComponentListeners(vm, listeners);
  }
}

var target;

function add (event, fn) {
  target.$on(event, fn);
}

function remove$1 (event, fn) {
  target.$off(event, fn);
}

function createOnceHandler (event, fn) {
  var _target = target;
  return function onceHandler () {
    var res = fn.apply(null, arguments);
    if (res !== null) {
      _target.$off(event, onceHandler);
    }
  }
}

function updateComponentListeners (
  vm,
  listeners,
  oldListeners
) {
  target = vm;
  updateListeners(listeners, oldListeners || {}, add, remove$1, createOnceHandler, vm);
  target = undefined;
}

function eventsMixin (Vue) {
  var hookRE = /^hook:/;
  Vue.prototype.$on = function (event, fn) {
    var vm = this;
    if (Array.isArray(event)) {
      for (var i = 0, l = event.length; i < l; i++) {
        vm.$on(event[i], fn);
      }
    } else {
      (vm._events[event] || (vm._events[event] = [])).push(fn);
      // optimize hook:event cost by using a boolean flag marked at registration
      // instead of a hash lookup
      if (hookRE.test(event)) {
        vm._hasHookEvent = true;
      }
    }
    return vm
  };

  Vue.prototype.$once = function (event, fn) {
    var vm = this;
    function on () {
      vm.$off(event, on);
      fn.apply(vm, arguments);
    }
    on.fn = fn;
    vm.$on(event, on);
    return vm
  };

  Vue.prototype.$off = function (event, fn) {
    var vm = this;
    // all
    if (!arguments.length) {
      vm._events = Object.create(null);
      return vm
    }
    // array of events
    if (Array.isArray(event)) {
      for (var i$1 = 0, l = event.length; i$1 < l; i$1++) {
        vm.$off(event[i$1], fn);
      }
      return vm
    }
    // specific event
    var cbs = vm._events[event];
    if (!cbs) {
      return vm
    }
    if (!fn) {
      vm._events[event] = null;
      return vm
    }
    // specific handler
    var cb;
    var i = cbs.length;
    while (i--) {
      cb = cbs[i];
      if (cb === fn || cb.fn === fn) {
        cbs.splice(i, 1);
        break
      }
    }
    return vm
  };

  Vue.prototype.$emit = function (event) {
    var vm = this;
    if (false) {
      var lowerCaseEvent = event.toLowerCase();
      if (lowerCaseEvent !== event && vm._events[lowerCaseEvent]) {
        tip(
          "Event \"" + lowerCaseEvent + "\" is emitted in component " +
          (formatComponentName(vm)) + " but the handler is registered for \"" + event + "\". " +
          "Note that HTML attributes are case-insensitive and you cannot use " +
          "v-on to listen to camelCase events when using in-DOM templates. " +
          "You should probably use \"" + (hyphenate(event)) + "\" instead of \"" + event + "\"."
        );
      }
    }
    var cbs = vm._events[event];
    if (cbs) {
      cbs = cbs.length > 1 ? toArray(cbs) : cbs;
      var args = toArray(arguments, 1);
      var info = "event handler for \"" + event + "\"";
      for (var i = 0, l = cbs.length; i < l; i++) {
        invokeWithErrorHandling(cbs[i], vm, args, vm, info);
      }
    }
    return vm
  };
}

/*  */

var activeInstance = null;
var isUpdatingChildComponent = false;

function setActiveInstance(vm) {
  var prevActiveInstance = activeInstance;
  activeInstance = vm;
  return function () {
    activeInstance = prevActiveInstance;
  }
}

function initLifecycle (vm) {
  var options = vm.$options;

  // locate first non-abstract parent
  var parent = options.parent;
  if (parent && !options.abstract) {
    while (parent.$options.abstract && parent.$parent) {
      parent = parent.$parent;
    }
    parent.$children.push(vm);
  }

  vm.$parent = parent;
  vm.$root = parent ? parent.$root : vm;

  vm.$children = [];
  vm.$refs = {};

  vm._watcher = null;
  vm._inactive = null;
  vm._directInactive = false;
  vm._isMounted = false;
  vm._isDestroyed = false;
  vm._isBeingDestroyed = false;
}

function lifecycleMixin (Vue) {
  Vue.prototype._update = function (vnode, hydrating) {
    var vm = this;
    var prevEl = vm.$el;
    var prevVnode = vm._vnode;
    var restoreActiveInstance = setActiveInstance(vm);
    vm._vnode = vnode;
    // Vue.prototype.__patch__ is injected in entry points
    // based on the rendering backend used.
    if (!prevVnode) {
      // initial render
      vm.$el = vm.__patch__(vm.$el, vnode, hydrating, false /* removeOnly */);
    } else {
      // updates
      vm.$el = vm.__patch__(prevVnode, vnode);
    }
    restoreActiveInstance();
    // update __vue__ reference
    if (prevEl) {
      prevEl.__vue__ = null;
    }
    if (vm.$el) {
      vm.$el.__vue__ = vm;
    }
    // if parent is an HOC, update its $el as well
    if (vm.$vnode && vm.$parent && vm.$vnode === vm.$parent._vnode) {
      vm.$parent.$el = vm.$el;
    }
    // updated hook is called by the scheduler to ensure that children are
    // updated in a parent's updated hook.
  };

  Vue.prototype.$forceUpdate = function () {
    var vm = this;
    if (vm._watcher) {
      vm._watcher.update();
    }
  };

  Vue.prototype.$destroy = function () {
    var vm = this;
    if (vm._isBeingDestroyed) {
      return
    }
    callHook(vm, 'beforeDestroy');
    vm._isBeingDestroyed = true;
    // remove self from parent
    var parent = vm.$parent;
    if (parent && !parent._isBeingDestroyed && !vm.$options.abstract) {
      remove(parent.$children, vm);
    }
    // teardown watchers
    if (vm._watcher) {
      vm._watcher.teardown();
    }
    var i = vm._watchers.length;
    while (i--) {
      vm._watchers[i].teardown();
    }
    // remove reference from data ob
    // frozen object may not have observer.
    if (vm._data.__ob__) {
      vm._data.__ob__.vmCount--;
    }
    // call the last hook...
    vm._isDestroyed = true;
    // invoke destroy hooks on current rendered tree
    vm.__patch__(vm._vnode, null);
    // fire destroyed hook
    callHook(vm, 'destroyed');
    // turn off all instance listeners.
    vm.$off();
    // remove __vue__ reference
    if (vm.$el) {
      vm.$el.__vue__ = null;
    }
    // release circular reference (#6759)
    if (vm.$vnode) {
      vm.$vnode.parent = null;
    }
  };
}

function mountComponent (
  vm,
  el,
  hydrating
) {
  vm.$el = el;
  if (!vm.$options.render) {
    vm.$options.render = createEmptyVNode;
    if (false) {
      /* istanbul ignore if */
      if ((vm.$options.template && vm.$options.template.charAt(0) !== '#') ||
        vm.$options.el || el) {
        warn(
          'You are using the runtime-only build of Vue where the template ' +
          'compiler is not available. Either pre-compile the templates into ' +
          'render functions, or use the compiler-included build.',
          vm
        );
      } else {
        warn(
          'Failed to mount component: template or render function not defined.',
          vm
        );
      }
    }
  }
  callHook(vm, 'beforeMount');

  var updateComponent;
  /* istanbul ignore if */
  if (false) {
    updateComponent = function () {
      var name = vm._name;
      var id = vm._uid;
      var startTag = "vue-perf-start:" + id;
      var endTag = "vue-perf-end:" + id;

      mark(startTag);
      var vnode = vm._render();
      mark(endTag);
      measure(("vue " + name + " render"), startTag, endTag);

      mark(startTag);
      vm._update(vnode, hydrating);
      mark(endTag);
      measure(("vue " + name + " patch"), startTag, endTag);
    };
  } else {
    updateComponent = function () {
      vm._update(vm._render(), hydrating);
    };
  }

  // we set this to vm._watcher inside the watcher's constructor
  // since the watcher's initial patch may call $forceUpdate (e.g. inside child
  // component's mounted hook), which relies on vm._watcher being already defined
  new Watcher(vm, updateComponent, noop, {
    before: function before () {
      if (vm._isMounted && !vm._isDestroyed) {
        callHook(vm, 'beforeUpdate');
      }
    }
  }, true /* isRenderWatcher */);
  hydrating = false;

  // manually mounted instance, call mounted on self
  // mounted is called for render-created child components in its inserted hook
  if (vm.$vnode == null) {
    vm._isMounted = true;
    callHook(vm, 'mounted');
  }
  return vm
}

function updateChildComponent (
  vm,
  propsData,
  listeners,
  parentVnode,
  renderChildren
) {
  if (false) {
    isUpdatingChildComponent = true;
  }

  // determine whether component has slot children
  // we need to do this before overwriting $options._renderChildren.

  // check if there are dynamic scopedSlots (hand-written or compiled but with
  // dynamic slot names). Static scoped slots compiled from template has the
  // "$stable" marker.
  var newScopedSlots = parentVnode.data.scopedSlots;
  var oldScopedSlots = vm.$scopedSlots;
  var hasDynamicScopedSlot = !!(
    (newScopedSlots && !newScopedSlots.$stable) ||
    (oldScopedSlots !== emptyObject && !oldScopedSlots.$stable) ||
    (newScopedSlots && vm.$scopedSlots.$key !== newScopedSlots.$key)
  );

  // Any static slot children from the parent may have changed during parent's
  // update. Dynamic scoped slots may also have changed. In such cases, a forced
  // update is necessary to ensure correctness.
  var needsForceUpdate = !!(
    renderChildren ||               // has new static slots
    vm.$options._renderChildren ||  // has old static slots
    hasDynamicScopedSlot
  );

  vm.$options._parentVnode = parentVnode;
  vm.$vnode = parentVnode; // update vm's placeholder node without re-render

  if (vm._vnode) { // update child tree's parent
    vm._vnode.parent = parentVnode;
  }
  vm.$options._renderChildren = renderChildren;

  // update $attrs and $listeners hash
  // these are also reactive so they may trigger child update if the child
  // used them during render
  vm.$attrs = parentVnode.data.attrs || emptyObject;
  vm.$listeners = listeners || emptyObject;

  // update props
  if (propsData && vm.$options.props) {
    toggleObserving(false);
    var props = vm._props;
    var propKeys = vm.$options._propKeys || [];
    for (var i = 0; i < propKeys.length; i++) {
      var key = propKeys[i];
      var propOptions = vm.$options.props; // wtf flow?
      props[key] = validateProp(key, propOptions, propsData, vm);
    }
    toggleObserving(true);
    // keep a copy of raw propsData
    vm.$options.propsData = propsData;
  }

  // update listeners
  listeners = listeners || emptyObject;
  var oldListeners = vm.$options._parentListeners;
  vm.$options._parentListeners = listeners;
  updateComponentListeners(vm, listeners, oldListeners);

  // resolve slots + force update if has children
  if (needsForceUpdate) {
    vm.$slots = resolveSlots(renderChildren, parentVnode.context);
    vm.$forceUpdate();
  }

  if (false) {
    isUpdatingChildComponent = false;
  }
}

function isInInactiveTree (vm) {
  while (vm && (vm = vm.$parent)) {
    if (vm._inactive) { return true }
  }
  return false
}

function activateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = false;
    if (isInInactiveTree(vm)) {
      return
    }
  } else if (vm._directInactive) {
    return
  }
  if (vm._inactive || vm._inactive === null) {
    vm._inactive = false;
    for (var i = 0; i < vm.$children.length; i++) {
      activateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'activated');
  }
}

function deactivateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = true;
    if (isInInactiveTree(vm)) {
      return
    }
  }
  if (!vm._inactive) {
    vm._inactive = true;
    for (var i = 0; i < vm.$children.length; i++) {
      deactivateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'deactivated');
  }
}

function callHook (vm, hook) {
  // #7573 disable dep collection when invoking lifecycle hooks
  pushTarget();
  var handlers = vm.$options[hook];
  var info = hook + " hook";
  if (handlers) {
    for (var i = 0, j = handlers.length; i < j; i++) {
      invokeWithErrorHandling(handlers[i], vm, null, vm, info);
    }
  }
  if (vm._hasHookEvent) {
    vm.$emit('hook:' + hook);
  }
  popTarget();
}

/*  */

var MAX_UPDATE_COUNT = 100;

var queue = [];
var activatedChildren = [];
var has = {};
var circular = {};
var waiting = false;
var flushing = false;
var index = 0;

/**
 * Reset the scheduler's state.
 */
function resetSchedulerState () {
  index = queue.length = activatedChildren.length = 0;
  has = {};
  if (false) {
    circular = {};
  }
  waiting = flushing = false;
}

// Async edge case #6566 requires saving the timestamp when event listeners are
// attached. However, calling performance.now() has a perf overhead especially
// if the page has thousands of event listeners. Instead, we take a timestamp
// every time the scheduler flushes and use that for all event listeners
// attached during that flush.
var currentFlushTimestamp = 0;

// Async edge case fix requires storing an event listener's attach timestamp.
var getNow = Date.now;

// Determine what event timestamp the browser is using. Annoyingly, the
// timestamp can either be hi-res (relative to page load) or low-res
// (relative to UNIX epoch), so in order to compare time we have to use the
// same timestamp type when saving the flush timestamp.
// All IE versions use low-res event timestamps, and have problematic clock
// implementations (#9632)
if (inBrowser && !isIE) {
  var performance = window.performance;
  if (
    performance &&
    typeof performance.now === 'function' &&
    getNow() > document.createEvent('Event').timeStamp
  ) {
    // if the event timestamp, although evaluated AFTER the Date.now(), is
    // smaller than it, it means the event is using a hi-res timestamp,
    // and we need to use the hi-res version for event listener timestamps as
    // well.
    getNow = function () { return performance.now(); };
  }
}

/**
 * Flush both queues and run the watchers.
 */
function flushSchedulerQueue () {
  currentFlushTimestamp = getNow();
  flushing = true;
  var watcher, id;

  // Sort queue before flush.
  // This ensures that:
  // 1. Components are updated from parent to child. (because parent is always
  //    created before the child)
  // 2. A component's user watchers are run before its render watcher (because
  //    user watchers are created before the render watcher)
  // 3. If a component is destroyed during a parent component's watcher run,
  //    its watchers can be skipped.
  queue.sort(function (a, b) { return a.id - b.id; });

  // do not cache length because more watchers might be pushed
  // as we run existing watchers
  for (index = 0; index < queue.length; index++) {
    watcher = queue[index];
    if (watcher.before) {
      watcher.before();
    }
    id = watcher.id;
    has[id] = null;
    watcher.run();
    // in dev build, check and stop circular updates.
    if (false) {
      circular[id] = (circular[id] || 0) + 1;
      if (circular[id] > MAX_UPDATE_COUNT) {
        warn(
          'You may have an infinite update loop ' + (
            watcher.user
              ? ("in watcher with expression \"" + (watcher.expression) + "\"")
              : "in a component render function."
          ),
          watcher.vm
        );
        break
      }
    }
  }

  // keep copies of post queues before resetting state
  var activatedQueue = activatedChildren.slice();
  var updatedQueue = queue.slice();

  resetSchedulerState();

  // call component updated and activated hooks
  callActivatedHooks(activatedQueue);
  callUpdatedHooks(updatedQueue);

  // devtool hook
  /* istanbul ignore if */
  if (devtools && config.devtools) {
    devtools.emit('flush');
  }
}

function callUpdatedHooks (queue) {
  var i = queue.length;
  while (i--) {
    var watcher = queue[i];
    var vm = watcher.vm;
    if (vm._watcher === watcher && vm._isMounted && !vm._isDestroyed) {
      callHook(vm, 'updated');
    }
  }
}

/**
 * Queue a kept-alive component that was activated during patch.
 * The queue will be processed after the entire tree has been patched.
 */
function queueActivatedComponent (vm) {
  // setting _inactive to false here so that a render function can
  // rely on checking whether it's in an inactive tree (e.g. router-view)
  vm._inactive = false;
  activatedChildren.push(vm);
}

function callActivatedHooks (queue) {
  for (var i = 0; i < queue.length; i++) {
    queue[i]._inactive = true;
    activateChildComponent(queue[i], true /* true */);
  }
}

/**
 * Push a watcher into the watcher queue.
 * Jobs with duplicate IDs will be skipped unless it's
 * pushed when the queue is being flushed.
 */
function queueWatcher (watcher) {
  var id = watcher.id;
  if (has[id] == null) {
    has[id] = true;
    if (!flushing) {
      queue.push(watcher);
    } else {
      // if already flushing, splice the watcher based on its id
      // if already past its id, it will be run next immediately.
      var i = queue.length - 1;
      while (i > index && queue[i].id > watcher.id) {
        i--;
      }
      queue.splice(i + 1, 0, watcher);
    }
    // queue the flush
    if (!waiting) {
      waiting = true;

      if (false) {
        flushSchedulerQueue();
        return
      }
      nextTick(flushSchedulerQueue);
    }
  }
}

/*  */



var uid$2 = 0;

/**
 * A watcher parses an expression, collects dependencies,
 * and fires callback when the expression value changes.
 * This is used for both the $watch() api and directives.
 */
var Watcher = function Watcher (
  vm,
  expOrFn,
  cb,
  options,
  isRenderWatcher
) {
  this.vm = vm;
  if (isRenderWatcher) {
    vm._watcher = this;
  }
  vm._watchers.push(this);
  // options
  if (options) {
    this.deep = !!options.deep;
    this.user = !!options.user;
    this.lazy = !!options.lazy;
    this.sync = !!options.sync;
    this.before = options.before;
  } else {
    this.deep = this.user = this.lazy = this.sync = false;
  }
  this.cb = cb;
  this.id = ++uid$2; // uid for batching
  this.active = true;
  this.dirty = this.lazy; // for lazy watchers
  this.deps = [];
  this.newDeps = [];
  this.depIds = new _Set();
  this.newDepIds = new _Set();
  this.expression =  false
    ? expOrFn.toString()
    : '';
  // parse expression for getter
  if (typeof expOrFn === 'function') {
    this.getter = expOrFn;
  } else {
    this.getter = parsePath(expOrFn);
    if (!this.getter) {
      this.getter = noop;
      "production" !== 'production' && warn(
        "Failed watching path: \"" + expOrFn + "\" " +
        'Watcher only accepts simple dot-delimited paths. ' +
        'For full control, use a function instead.',
        vm
      );
    }
  }
  this.value = this.lazy
    ? undefined
    : this.get();
};

/**
 * Evaluate the getter, and re-collect dependencies.
 */
Watcher.prototype.get = function get () {
  pushTarget(this);
  var value;
  var vm = this.vm;
  try {
    value = this.getter.call(vm, vm);
  } catch (e) {
    if (this.user) {
      handleError(e, vm, ("getter for watcher \"" + (this.expression) + "\""));
    } else {
      throw e
    }
  } finally {
    // "touch" every property so they are all tracked as
    // dependencies for deep watching
    if (this.deep) {
      traverse(value);
    }
    popTarget();
    this.cleanupDeps();
  }
  return value
};

/**
 * Add a dependency to this directive.
 */
Watcher.prototype.addDep = function addDep (dep) {
  var id = dep.id;
  if (!this.newDepIds.has(id)) {
    this.newDepIds.add(id);
    this.newDeps.push(dep);
    if (!this.depIds.has(id)) {
      dep.addSub(this);
    }
  }
};

/**
 * Clean up for dependency collection.
 */
Watcher.prototype.cleanupDeps = function cleanupDeps () {
  var i = this.deps.length;
  while (i--) {
    var dep = this.deps[i];
    if (!this.newDepIds.has(dep.id)) {
      dep.removeSub(this);
    }
  }
  var tmp = this.depIds;
  this.depIds = this.newDepIds;
  this.newDepIds = tmp;
  this.newDepIds.clear();
  tmp = this.deps;
  this.deps = this.newDeps;
  this.newDeps = tmp;
  this.newDeps.length = 0;
};

/**
 * Subscriber interface.
 * Will be called when a dependency changes.
 */
Watcher.prototype.update = function update () {
  /* istanbul ignore else */
  if (this.lazy) {
    this.dirty = true;
  } else if (this.sync) {
    this.run();
  } else {
    queueWatcher(this);
  }
};

/**
 * Scheduler job interface.
 * Will be called by the scheduler.
 */
Watcher.prototype.run = function run () {
  if (this.active) {
    var value = this.get();
    if (
      value !== this.value ||
      // Deep watchers and watchers on Object/Arrays should fire even
      // when the value is the same, because the value may
      // have mutated.
      isObject(value) ||
      this.deep
    ) {
      // set new value
      var oldValue = this.value;
      this.value = value;
      if (this.user) {
        try {
          this.cb.call(this.vm, value, oldValue);
        } catch (e) {
          handleError(e, this.vm, ("callback for watcher \"" + (this.expression) + "\""));
        }
      } else {
        this.cb.call(this.vm, value, oldValue);
      }
    }
  }
};

/**
 * Evaluate the value of the watcher.
 * This only gets called for lazy watchers.
 */
Watcher.prototype.evaluate = function evaluate () {
  this.value = this.get();
  this.dirty = false;
};

/**
 * Depend on all deps collected by this watcher.
 */
Watcher.prototype.depend = function depend () {
  var i = this.deps.length;
  while (i--) {
    this.deps[i].depend();
  }
};

/**
 * Remove self from all dependencies' subscriber list.
 */
Watcher.prototype.teardown = function teardown () {
  if (this.active) {
    // remove self from vm's watcher list
    // this is a somewhat expensive operation so we skip it
    // if the vm is being destroyed.
    if (!this.vm._isBeingDestroyed) {
      remove(this.vm._watchers, this);
    }
    var i = this.deps.length;
    while (i--) {
      this.deps[i].removeSub(this);
    }
    this.active = false;
  }
};

/*  */

var sharedPropertyDefinition = {
  enumerable: true,
  configurable: true,
  get: noop,
  set: noop
};

function proxy (target, sourceKey, key) {
  sharedPropertyDefinition.get = function proxyGetter () {
    return this[sourceKey][key]
  };
  sharedPropertyDefinition.set = function proxySetter (val) {
    this[sourceKey][key] = val;
  };
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function initState (vm) {
  vm._watchers = [];
  var opts = vm.$options;
  if (opts.props) { initProps(vm, opts.props); }
  if (opts.methods) { initMethods(vm, opts.methods); }
  if (opts.data) {
    initData(vm);
  } else {
    observe(vm._data = {}, true /* asRootData */);
  }
  if (opts.computed) { initComputed(vm, opts.computed); }
  if (opts.watch && opts.watch !== nativeWatch) {
    initWatch(vm, opts.watch);
  }
}

function initProps (vm, propsOptions) {
  var propsData = vm.$options.propsData || {};
  var props = vm._props = {};
  // cache prop keys so that future props updates can iterate using Array
  // instead of dynamic object key enumeration.
  var keys = vm.$options._propKeys = [];
  var isRoot = !vm.$parent;
  // root instance props should be converted
  if (!isRoot) {
    toggleObserving(false);
  }
  var loop = function ( key ) {
    keys.push(key);
    var value = validateProp(key, propsOptions, propsData, vm);
    /* istanbul ignore else */
    if (false) {
      var hyphenatedKey = hyphenate(key);
      if (isReservedAttribute(hyphenatedKey) ||
          config.isReservedAttr(hyphenatedKey)) {
        warn(
          ("\"" + hyphenatedKey + "\" is a reserved attribute and cannot be used as component prop."),
          vm
        );
      }
      defineReactive$$1(props, key, value, function () {
        if (!isRoot && !isUpdatingChildComponent) {
          warn(
            "Avoid mutating a prop directly since the value will be " +
            "overwritten whenever the parent component re-renders. " +
            "Instead, use a data or computed property based on the prop's " +
            "value. Prop being mutated: \"" + key + "\"",
            vm
          );
        }
      });
    } else {
      defineReactive$$1(props, key, value);
    }
    // static props are already proxied on the component's prototype
    // during Vue.extend(). We only need to proxy props defined at
    // instantiation here.
    if (!(key in vm)) {
      proxy(vm, "_props", key);
    }
  };

  for (var key in propsOptions) loop( key );
  toggleObserving(true);
}

function initData (vm) {
  var data = vm.$options.data;
  data = vm._data = typeof data === 'function'
    ? getData(data, vm)
    : data || {};
  if (!isPlainObject(data)) {
    data = {};
    "production" !== 'production' && warn(
      'data functions should return an object:\n' +
      'https://vuejs.org/v2/guide/components.html#data-Must-Be-a-Function',
      vm
    );
  }
  // proxy data on instance
  var keys = Object.keys(data);
  var props = vm.$options.props;
  var methods = vm.$options.methods;
  var i = keys.length;
  while (i--) {
    var key = keys[i];
    if (false) {
      if (methods && hasOwn(methods, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a data property."),
          vm
        );
      }
    }
    if (props && hasOwn(props, key)) {
      "production" !== 'production' && warn(
        "The data property \"" + key + "\" is already declared as a prop. " +
        "Use prop default value instead.",
        vm
      );
    } else if (!isReserved(key)) {
      proxy(vm, "_data", key);
    }
  }
  // observe data
  observe(data, true /* asRootData */);
}

function getData (data, vm) {
  // #7573 disable dep collection when invoking data getters
  pushTarget();
  try {
    return data.call(vm, vm)
  } catch (e) {
    handleError(e, vm, "data()");
    return {}
  } finally {
    popTarget();
  }
}

var computedWatcherOptions = { lazy: true };

function initComputed (vm, computed) {
  // $flow-disable-line
  var watchers = vm._computedWatchers = Object.create(null);
  // computed properties are just getters during SSR
  var isSSR = isServerRendering();

  for (var key in computed) {
    var userDef = computed[key];
    var getter = typeof userDef === 'function' ? userDef : userDef.get;
    if (false) {
      warn(
        ("Getter is missing for computed property \"" + key + "\"."),
        vm
      );
    }

    if (!isSSR) {
      // create internal watcher for the computed property.
      watchers[key] = new Watcher(
        vm,
        getter || noop,
        noop,
        computedWatcherOptions
      );
    }

    // component-defined computed properties are already defined on the
    // component prototype. We only need to define computed properties defined
    // at instantiation here.
    if (!(key in vm)) {
      defineComputed(vm, key, userDef);
    } else if (false) {
      if (key in vm.$data) {
        warn(("The computed property \"" + key + "\" is already defined in data."), vm);
      } else if (vm.$options.props && key in vm.$options.props) {
        warn(("The computed property \"" + key + "\" is already defined as a prop."), vm);
      }
    }
  }
}

function defineComputed (
  target,
  key,
  userDef
) {
  var shouldCache = !isServerRendering();
  if (typeof userDef === 'function') {
    sharedPropertyDefinition.get = shouldCache
      ? createComputedGetter(key)
      : createGetterInvoker(userDef);
    sharedPropertyDefinition.set = noop;
  } else {
    sharedPropertyDefinition.get = userDef.get
      ? shouldCache && userDef.cache !== false
        ? createComputedGetter(key)
        : createGetterInvoker(userDef.get)
      : noop;
    sharedPropertyDefinition.set = userDef.set || noop;
  }
  if (false) {
    sharedPropertyDefinition.set = function () {
      warn(
        ("Computed property \"" + key + "\" was assigned to but it has no setter."),
        this
      );
    };
  }
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function createComputedGetter (key) {
  return function computedGetter () {
    var watcher = this._computedWatchers && this._computedWatchers[key];
    if (watcher) {
      if (watcher.dirty) {
        watcher.evaluate();
      }
      if (Dep.target) {
        watcher.depend();
      }
      return watcher.value
    }
  }
}

function createGetterInvoker(fn) {
  return function computedGetter () {
    return fn.call(this, this)
  }
}

function initMethods (vm, methods) {
  var props = vm.$options.props;
  for (var key in methods) {
    if (false) {
      if (typeof methods[key] !== 'function') {
        warn(
          "Method \"" + key + "\" has type \"" + (typeof methods[key]) + "\" in the component definition. " +
          "Did you reference the function correctly?",
          vm
        );
      }
      if (props && hasOwn(props, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a prop."),
          vm
        );
      }
      if ((key in vm) && isReserved(key)) {
        warn(
          "Method \"" + key + "\" conflicts with an existing Vue instance method. " +
          "Avoid defining component methods that start with _ or $."
        );
      }
    }
    vm[key] = typeof methods[key] !== 'function' ? noop : bind(methods[key], vm);
  }
}

function initWatch (vm, watch) {
  for (var key in watch) {
    var handler = watch[key];
    if (Array.isArray(handler)) {
      for (var i = 0; i < handler.length; i++) {
        createWatcher(vm, key, handler[i]);
      }
    } else {
      createWatcher(vm, key, handler);
    }
  }
}

function createWatcher (
  vm,
  expOrFn,
  handler,
  options
) {
  if (isPlainObject(handler)) {
    options = handler;
    handler = handler.handler;
  }
  if (typeof handler === 'string') {
    handler = vm[handler];
  }
  return vm.$watch(expOrFn, handler, options)
}

function stateMixin (Vue) {
  // flow somehow has problems with directly declared definition object
  // when using Object.defineProperty, so we have to procedurally build up
  // the object here.
  var dataDef = {};
  dataDef.get = function () { return this._data };
  var propsDef = {};
  propsDef.get = function () { return this._props };
  if (false) {
    dataDef.set = function () {
      warn(
        'Avoid replacing instance root $data. ' +
        'Use nested data properties instead.',
        this
      );
    };
    propsDef.set = function () {
      warn("$props is readonly.", this);
    };
  }
  Object.defineProperty(Vue.prototype, '$data', dataDef);
  Object.defineProperty(Vue.prototype, '$props', propsDef);

  Vue.prototype.$set = set;
  Vue.prototype.$delete = del;

  Vue.prototype.$watch = function (
    expOrFn,
    cb,
    options
  ) {
    var vm = this;
    if (isPlainObject(cb)) {
      return createWatcher(vm, expOrFn, cb, options)
    }
    options = options || {};
    options.user = true;
    var watcher = new Watcher(vm, expOrFn, cb, options);
    if (options.immediate) {
      try {
        cb.call(vm, watcher.value);
      } catch (error) {
        handleError(error, vm, ("callback for immediate watcher \"" + (watcher.expression) + "\""));
      }
    }
    return function unwatchFn () {
      watcher.teardown();
    }
  };
}

/*  */

var uid$3 = 0;

function initMixin (Vue) {
  Vue.prototype._init = function (options) {
    var vm = this;
    // a uid
    vm._uid = uid$3++;

    var startTag, endTag;
    /* istanbul ignore if */
    if (false) {
      startTag = "vue-perf-start:" + (vm._uid);
      endTag = "vue-perf-end:" + (vm._uid);
      mark(startTag);
    }

    // a flag to avoid this being observed
    vm._isVue = true;
    // merge options
    if (options && options._isComponent) {
      // optimize internal component instantiation
      // since dynamic options merging is pretty slow, and none of the
      // internal component options needs special treatment.
      initInternalComponent(vm, options);
    } else {
      vm.$options = mergeOptions(
        resolveConstructorOptions(vm.constructor),
        options || {},
        vm
      );
    }
    /* istanbul ignore else */
    if (false) {
      initProxy(vm);
    } else {
      vm._renderProxy = vm;
    }
    // expose real self
    vm._self = vm;
    initLifecycle(vm);
    initEvents(vm);
    initRender(vm);
    callHook(vm, 'beforeCreate');
    initInjections(vm); // resolve injections before data/props
    initState(vm);
    initProvide(vm); // resolve provide after data/props
    callHook(vm, 'created');

    /* istanbul ignore if */
    if (false) {
      vm._name = formatComponentName(vm, false);
      mark(endTag);
      measure(("vue " + (vm._name) + " init"), startTag, endTag);
    }

    if (vm.$options.el) {
      vm.$mount(vm.$options.el);
    }
  };
}

function initInternalComponent (vm, options) {
  var opts = vm.$options = Object.create(vm.constructor.options);
  // doing this because it's faster than dynamic enumeration.
  var parentVnode = options._parentVnode;
  opts.parent = options.parent;
  opts._parentVnode = parentVnode;

  var vnodeComponentOptions = parentVnode.componentOptions;
  opts.propsData = vnodeComponentOptions.propsData;
  opts._parentListeners = vnodeComponentOptions.listeners;
  opts._renderChildren = vnodeComponentOptions.children;
  opts._componentTag = vnodeComponentOptions.tag;

  if (options.render) {
    opts.render = options.render;
    opts.staticRenderFns = options.staticRenderFns;
  }
}

function resolveConstructorOptions (Ctor) {
  var options = Ctor.options;
  if (Ctor.super) {
    var superOptions = resolveConstructorOptions(Ctor.super);
    var cachedSuperOptions = Ctor.superOptions;
    if (superOptions !== cachedSuperOptions) {
      // super option changed,
      // need to resolve new options.
      Ctor.superOptions = superOptions;
      // check if there are any late-modified/attached options (#4976)
      var modifiedOptions = resolveModifiedOptions(Ctor);
      // update base extend options
      if (modifiedOptions) {
        extend(Ctor.extendOptions, modifiedOptions);
      }
      options = Ctor.options = mergeOptions(superOptions, Ctor.extendOptions);
      if (options.name) {
        options.components[options.name] = Ctor;
      }
    }
  }
  return options
}

function resolveModifiedOptions (Ctor) {
  var modified;
  var latest = Ctor.options;
  var sealed = Ctor.sealedOptions;
  for (var key in latest) {
    if (latest[key] !== sealed[key]) {
      if (!modified) { modified = {}; }
      modified[key] = latest[key];
    }
  }
  return modified
}

function Vue (options) {
  if (false
  ) {
    warn('Vue is a constructor and should be called with the `new` keyword');
  }
  this._init(options);
}

initMixin(Vue);
stateMixin(Vue);
eventsMixin(Vue);
lifecycleMixin(Vue);
renderMixin(Vue);

/*  */

function initUse (Vue) {
  Vue.use = function (plugin) {
    var installedPlugins = (this._installedPlugins || (this._installedPlugins = []));
    if (installedPlugins.indexOf(plugin) > -1) {
      return this
    }

    // additional parameters
    var args = toArray(arguments, 1);
    args.unshift(this);
    if (typeof plugin.install === 'function') {
      plugin.install.apply(plugin, args);
    } else if (typeof plugin === 'function') {
      plugin.apply(null, args);
    }
    installedPlugins.push(plugin);
    return this
  };
}

/*  */

function initMixin$1 (Vue) {
  Vue.mixin = function (mixin) {
    this.options = mergeOptions(this.options, mixin);
    return this
  };
}

/*  */

function initExtend (Vue) {
  /**
   * Each instance constructor, including Vue, has a unique
   * cid. This enables us to create wrapped "child
   * constructors" for prototypal inheritance and cache them.
   */
  Vue.cid = 0;
  var cid = 1;

  /**
   * Class inheritance
   */
  Vue.extend = function (extendOptions) {
    extendOptions = extendOptions || {};
    var Super = this;
    var SuperId = Super.cid;
    var cachedCtors = extendOptions._Ctor || (extendOptions._Ctor = {});
    if (cachedCtors[SuperId]) {
      return cachedCtors[SuperId]
    }

    var name = extendOptions.name || Super.options.name;
    if (false) {
      validateComponentName(name);
    }

    var Sub = function VueComponent (options) {
      this._init(options);
    };
    Sub.prototype = Object.create(Super.prototype);
    Sub.prototype.constructor = Sub;
    Sub.cid = cid++;
    Sub.options = mergeOptions(
      Super.options,
      extendOptions
    );
    Sub['super'] = Super;

    // For props and computed properties, we define the proxy getters on
    // the Vue instances at extension time, on the extended prototype. This
    // avoids Object.defineProperty calls for each instance created.
    if (Sub.options.props) {
      initProps$1(Sub);
    }
    if (Sub.options.computed) {
      initComputed$1(Sub);
    }

    // allow further extension/mixin/plugin usage
    Sub.extend = Super.extend;
    Sub.mixin = Super.mixin;
    Sub.use = Super.use;

    // create asset registers, so extended classes
    // can have their private assets too.
    ASSET_TYPES.forEach(function (type) {
      Sub[type] = Super[type];
    });
    // enable recursive self-lookup
    if (name) {
      Sub.options.components[name] = Sub;
    }

    // keep a reference to the super options at extension time.
    // later at instantiation we can check if Super's options have
    // been updated.
    Sub.superOptions = Super.options;
    Sub.extendOptions = extendOptions;
    Sub.sealedOptions = extend({}, Sub.options);

    // cache constructor
    cachedCtors[SuperId] = Sub;
    return Sub
  };
}

function initProps$1 (Comp) {
  var props = Comp.options.props;
  for (var key in props) {
    proxy(Comp.prototype, "_props", key);
  }
}

function initComputed$1 (Comp) {
  var computed = Comp.options.computed;
  for (var key in computed) {
    defineComputed(Comp.prototype, key, computed[key]);
  }
}

/*  */

function initAssetRegisters (Vue) {
  /**
   * Create asset registration methods.
   */
  ASSET_TYPES.forEach(function (type) {
    Vue[type] = function (
      id,
      definition
    ) {
      if (!definition) {
        return this.options[type + 's'][id]
      } else {
        /* istanbul ignore if */
        if (false) {
          validateComponentName(id);
        }
        if (type === 'component' && isPlainObject(definition)) {
          definition.name = definition.name || id;
          definition = this.options._base.extend(definition);
        }
        if (type === 'directive' && typeof definition === 'function') {
          definition = { bind: definition, update: definition };
        }
        this.options[type + 's'][id] = definition;
        return definition
      }
    };
  });
}

/*  */



function getComponentName (opts) {
  return opts && (opts.Ctor.options.name || opts.tag)
}

function matches (pattern, name) {
  if (Array.isArray(pattern)) {
    return pattern.indexOf(name) > -1
  } else if (typeof pattern === 'string') {
    return pattern.split(',').indexOf(name) > -1
  } else if (isRegExp(pattern)) {
    return pattern.test(name)
  }
  /* istanbul ignore next */
  return false
}

function pruneCache (keepAliveInstance, filter) {
  var cache = keepAliveInstance.cache;
  var keys = keepAliveInstance.keys;
  var _vnode = keepAliveInstance._vnode;
  for (var key in cache) {
    var cachedNode = cache[key];
    if (cachedNode) {
      var name = getComponentName(cachedNode.componentOptions);
      if (name && !filter(name)) {
        pruneCacheEntry(cache, key, keys, _vnode);
      }
    }
  }
}

function pruneCacheEntry (
  cache,
  key,
  keys,
  current
) {
  var cached$$1 = cache[key];
  if (cached$$1 && (!current || cached$$1.tag !== current.tag)) {
    cached$$1.componentInstance.$destroy();
  }
  cache[key] = null;
  remove(keys, key);
}

var patternTypes = [String, RegExp, Array];

var KeepAlive = {
  name: 'keep-alive',
  abstract: true,

  props: {
    include: patternTypes,
    exclude: patternTypes,
    max: [String, Number]
  },

  created: function created () {
    this.cache = Object.create(null);
    this.keys = [];
  },

  destroyed: function destroyed () {
    for (var key in this.cache) {
      pruneCacheEntry(this.cache, key, this.keys);
    }
  },

  mounted: function mounted () {
    var this$1 = this;

    this.$watch('include', function (val) {
      pruneCache(this$1, function (name) { return matches(val, name); });
    });
    this.$watch('exclude', function (val) {
      pruneCache(this$1, function (name) { return !matches(val, name); });
    });
  },

  render: function render () {
    var slot = this.$slots.default;
    var vnode = getFirstComponentChild(slot);
    var componentOptions = vnode && vnode.componentOptions;
    if (componentOptions) {
      // check pattern
      var name = getComponentName(componentOptions);
      var ref = this;
      var include = ref.include;
      var exclude = ref.exclude;
      if (
        // not included
        (include && (!name || !matches(include, name))) ||
        // excluded
        (exclude && name && matches(exclude, name))
      ) {
        return vnode
      }

      var ref$1 = this;
      var cache = ref$1.cache;
      var keys = ref$1.keys;
      var key = vnode.key == null
        // same constructor may get registered as different local components
        // so cid alone is not enough (#3269)
        ? componentOptions.Ctor.cid + (componentOptions.tag ? ("::" + (componentOptions.tag)) : '')
        : vnode.key;
      if (cache[key]) {
        vnode.componentInstance = cache[key].componentInstance;
        // make current key freshest
        remove(keys, key);
        keys.push(key);
      } else {
        cache[key] = vnode;
        keys.push(key);
        // prune oldest entry
        if (this.max && keys.length > parseInt(this.max)) {
          pruneCacheEntry(cache, keys[0], keys, this._vnode);
        }
      }

      vnode.data.keepAlive = true;
    }
    return vnode || (slot && slot[0])
  }
};

var builtInComponents = {
  KeepAlive: KeepAlive
};

/*  */

function initGlobalAPI (Vue) {
  // config
  var configDef = {};
  configDef.get = function () { return config; };
  if (false) {
    configDef.set = function () {
      warn(
        'Do not replace the Vue.config object, set individual fields instead.'
      );
    };
  }
  Object.defineProperty(Vue, 'config', configDef);

  // exposed util methods.
  // NOTE: these are not considered part of the public API - avoid relying on
  // them unless you are aware of the risk.
  Vue.util = {
    warn: warn,
    extend: extend,
    mergeOptions: mergeOptions,
    defineReactive: defineReactive$$1
  };

  Vue.set = set;
  Vue.delete = del;
  Vue.nextTick = nextTick;

  // 2.6 explicit observable API
  Vue.observable = function (obj) {
    observe(obj);
    return obj
  };

  Vue.options = Object.create(null);
  ASSET_TYPES.forEach(function (type) {
    Vue.options[type + 's'] = Object.create(null);
  });

  // this is used to identify the "base" constructor to extend all plain-object
  // components with in Weex's multi-instance scenarios.
  Vue.options._base = Vue;

  extend(Vue.options.components, builtInComponents);

  initUse(Vue);
  initMixin$1(Vue);
  initExtend(Vue);
  initAssetRegisters(Vue);
}

initGlobalAPI(Vue);

Object.defineProperty(Vue.prototype, '$isServer', {
  get: isServerRendering
});

Object.defineProperty(Vue.prototype, '$ssrContext', {
  get: function get () {
    /* istanbul ignore next */
    return this.$vnode && this.$vnode.ssrContext
  }
});

// expose FunctionalRenderContext for ssr runtime helper installation
Object.defineProperty(Vue, 'FunctionalRenderContext', {
  value: FunctionalRenderContext
});

Vue.version = '2.6.12';

/*  */

// these are reserved for web because they are directly compiled away
// during template compilation
var isReservedAttr = makeMap('style,class');

// attributes that should be using props for binding
var acceptValue = makeMap('input,textarea,option,select,progress');
var mustUseProp = function (tag, type, attr) {
  return (
    (attr === 'value' && acceptValue(tag)) && type !== 'button' ||
    (attr === 'selected' && tag === 'option') ||
    (attr === 'checked' && tag === 'input') ||
    (attr === 'muted' && tag === 'video')
  )
};

var isEnumeratedAttr = makeMap('contenteditable,draggable,spellcheck');

var isValidContentEditableValue = makeMap('events,caret,typing,plaintext-only');

var convertEnumeratedValue = function (key, value) {
  return isFalsyAttrValue(value) || value === 'false'
    ? 'false'
    // allow arbitrary string value for contenteditable
    : key === 'contenteditable' && isValidContentEditableValue(value)
      ? value
      : 'true'
};

var isBooleanAttr = makeMap(
  'allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,' +
  'default,defaultchecked,defaultmuted,defaultselected,defer,disabled,' +
  'enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,' +
  'muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,' +
  'required,reversed,scoped,seamless,selected,sortable,translate,' +
  'truespeed,typemustmatch,visible'
);

var xlinkNS = 'http://www.w3.org/1999/xlink';

var isXlink = function (name) {
  return name.charAt(5) === ':' && name.slice(0, 5) === 'xlink'
};

var getXlinkProp = function (name) {
  return isXlink(name) ? name.slice(6, name.length) : ''
};

var isFalsyAttrValue = function (val) {
  return val == null || val === false
};

/*  */

function genClassForVnode (vnode) {
  var data = vnode.data;
  var parentNode = vnode;
  var childNode = vnode;
  while (isDef(childNode.componentInstance)) {
    childNode = childNode.componentInstance._vnode;
    if (childNode && childNode.data) {
      data = mergeClassData(childNode.data, data);
    }
  }
  while (isDef(parentNode = parentNode.parent)) {
    if (parentNode && parentNode.data) {
      data = mergeClassData(data, parentNode.data);
    }
  }
  return renderClass(data.staticClass, data.class)
}

function mergeClassData (child, parent) {
  return {
    staticClass: concat(child.staticClass, parent.staticClass),
    class: isDef(child.class)
      ? [child.class, parent.class]
      : parent.class
  }
}

function renderClass (
  staticClass,
  dynamicClass
) {
  if (isDef(staticClass) || isDef(dynamicClass)) {
    return concat(staticClass, stringifyClass(dynamicClass))
  }
  /* istanbul ignore next */
  return ''
}

function concat (a, b) {
  return a ? b ? (a + ' ' + b) : a : (b || '')
}

function stringifyClass (value) {
  if (Array.isArray(value)) {
    return stringifyArray(value)
  }
  if (isObject(value)) {
    return stringifyObject(value)
  }
  if (typeof value === 'string') {
    return value
  }
  /* istanbul ignore next */
  return ''
}

function stringifyArray (value) {
  var res = '';
  var stringified;
  for (var i = 0, l = value.length; i < l; i++) {
    if (isDef(stringified = stringifyClass(value[i])) && stringified !== '') {
      if (res) { res += ' '; }
      res += stringified;
    }
  }
  return res
}

function stringifyObject (value) {
  var res = '';
  for (var key in value) {
    if (value[key]) {
      if (res) { res += ' '; }
      res += key;
    }
  }
  return res
}

/*  */

var namespaceMap = {
  svg: 'http://www.w3.org/2000/svg',
  math: 'http://www.w3.org/1998/Math/MathML'
};

var isHTMLTag = makeMap(
  'html,body,base,head,link,meta,style,title,' +
  'address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,' +
  'div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,' +
  'a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,' +
  's,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,' +
  'embed,object,param,source,canvas,script,noscript,del,ins,' +
  'caption,col,colgroup,table,thead,tbody,td,th,tr,' +
  'button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,' +
  'output,progress,select,textarea,' +
  'details,dialog,menu,menuitem,summary,' +
  'content,element,shadow,template,blockquote,iframe,tfoot'
);

// this map is intentionally selective, only covering SVG elements that may
// contain child elements.
var isSVG = makeMap(
  'svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,' +
  'foreignObject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,' +
  'polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view',
  true
);

var isPreTag = function (tag) { return tag === 'pre'; };

var isReservedTag = function (tag) {
  return isHTMLTag(tag) || isSVG(tag)
};

function getTagNamespace (tag) {
  if (isSVG(tag)) {
    return 'svg'
  }
  // basic support for MathML
  // note it doesn't support other MathML elements being component roots
  if (tag === 'math') {
    return 'math'
  }
}

var unknownElementCache = Object.create(null);
function isUnknownElement (tag) {
  /* istanbul ignore if */
  if (!inBrowser) {
    return true
  }
  if (isReservedTag(tag)) {
    return false
  }
  tag = tag.toLowerCase();
  /* istanbul ignore if */
  if (unknownElementCache[tag] != null) {
    return unknownElementCache[tag]
  }
  var el = document.createElement(tag);
  if (tag.indexOf('-') > -1) {
    // http://stackoverflow.com/a/28210364/1070244
    return (unknownElementCache[tag] = (
      el.constructor === window.HTMLUnknownElement ||
      el.constructor === window.HTMLElement
    ))
  } else {
    return (unknownElementCache[tag] = /HTMLUnknownElement/.test(el.toString()))
  }
}

var isTextInputType = makeMap('text,number,password,search,email,tel,url');

/*  */

/**
 * Query an element selector if it's not an element already.
 */
function query (el) {
  if (typeof el === 'string') {
    var selected = document.querySelector(el);
    if (!selected) {
      "production" !== 'production' && warn(
        'Cannot find element: ' + el
      );
      return document.createElement('div')
    }
    return selected
  } else {
    return el
  }
}

/*  */

function createElement$1 (tagName, vnode) {
  var elm = document.createElement(tagName);
  if (tagName !== 'select') {
    return elm
  }
  // false or null will remove the attribute but undefined will not
  if (vnode.data && vnode.data.attrs && vnode.data.attrs.multiple !== undefined) {
    elm.setAttribute('multiple', 'multiple');
  }
  return elm
}

function createElementNS (namespace, tagName) {
  return document.createElementNS(namespaceMap[namespace], tagName)
}

function createTextNode (text) {
  return document.createTextNode(text)
}

function createComment (text) {
  return document.createComment(text)
}

function insertBefore (parentNode, newNode, referenceNode) {
  parentNode.insertBefore(newNode, referenceNode);
}

function removeChild (node, child) {
  node.removeChild(child);
}

function appendChild (node, child) {
  node.appendChild(child);
}

function parentNode (node) {
  return node.parentNode
}

function nextSibling (node) {
  return node.nextSibling
}

function tagName (node) {
  return node.tagName
}

function setTextContent (node, text) {
  node.textContent = text;
}

function setStyleScope (node, scopeId) {
  node.setAttribute(scopeId, '');
}

var nodeOps = /*#__PURE__*/Object.freeze({
  createElement: createElement$1,
  createElementNS: createElementNS,
  createTextNode: createTextNode,
  createComment: createComment,
  insertBefore: insertBefore,
  removeChild: removeChild,
  appendChild: appendChild,
  parentNode: parentNode,
  nextSibling: nextSibling,
  tagName: tagName,
  setTextContent: setTextContent,
  setStyleScope: setStyleScope
});

/*  */

var ref = {
  create: function create (_, vnode) {
    registerRef(vnode);
  },
  update: function update (oldVnode, vnode) {
    if (oldVnode.data.ref !== vnode.data.ref) {
      registerRef(oldVnode, true);
      registerRef(vnode);
    }
  },
  destroy: function destroy (vnode) {
    registerRef(vnode, true);
  }
};

function registerRef (vnode, isRemoval) {
  var key = vnode.data.ref;
  if (!isDef(key)) { return }

  var vm = vnode.context;
  var ref = vnode.componentInstance || vnode.elm;
  var refs = vm.$refs;
  if (isRemoval) {
    if (Array.isArray(refs[key])) {
      remove(refs[key], ref);
    } else if (refs[key] === ref) {
      refs[key] = undefined;
    }
  } else {
    if (vnode.data.refInFor) {
      if (!Array.isArray(refs[key])) {
        refs[key] = [ref];
      } else if (refs[key].indexOf(ref) < 0) {
        // $flow-disable-line
        refs[key].push(ref);
      }
    } else {
      refs[key] = ref;
    }
  }
}

/**
 * Virtual DOM patching algorithm based on Snabbdom by
 * Simon Friis Vindum (@paldepind)
 * Licensed under the MIT License
 * https://github.com/paldepind/snabbdom/blob/master/LICENSE
 *
 * modified by Evan You (@yyx990803)
 *
 * Not type-checking this because this file is perf-critical and the cost
 * of making flow understand it is not worth it.
 */

var emptyNode = new VNode('', {}, []);

var hooks = ['create', 'activate', 'update', 'remove', 'destroy'];

function sameVnode (a, b) {
  return (
    a.key === b.key && (
      (
        a.tag === b.tag &&
        a.isComment === b.isComment &&
        isDef(a.data) === isDef(b.data) &&
        sameInputType(a, b)
      ) || (
        isTrue(a.isAsyncPlaceholder) &&
        a.asyncFactory === b.asyncFactory &&
        isUndef(b.asyncFactory.error)
      )
    )
  )
}

function sameInputType (a, b) {
  if (a.tag !== 'input') { return true }
  var i;
  var typeA = isDef(i = a.data) && isDef(i = i.attrs) && i.type;
  var typeB = isDef(i = b.data) && isDef(i = i.attrs) && i.type;
  return typeA === typeB || isTextInputType(typeA) && isTextInputType(typeB)
}

function createKeyToOldIdx (children, beginIdx, endIdx) {
  var i, key;
  var map = {};
  for (i = beginIdx; i <= endIdx; ++i) {
    key = children[i].key;
    if (isDef(key)) { map[key] = i; }
  }
  return map
}

function createPatchFunction (backend) {
  var i, j;
  var cbs = {};

  var modules = backend.modules;
  var nodeOps = backend.nodeOps;

  for (i = 0; i < hooks.length; ++i) {
    cbs[hooks[i]] = [];
    for (j = 0; j < modules.length; ++j) {
      if (isDef(modules[j][hooks[i]])) {
        cbs[hooks[i]].push(modules[j][hooks[i]]);
      }
    }
  }

  function emptyNodeAt (elm) {
    return new VNode(nodeOps.tagName(elm).toLowerCase(), {}, [], undefined, elm)
  }

  function createRmCb (childElm, listeners) {
    function remove$$1 () {
      if (--remove$$1.listeners === 0) {
        removeNode(childElm);
      }
    }
    remove$$1.listeners = listeners;
    return remove$$1
  }

  function removeNode (el) {
    var parent = nodeOps.parentNode(el);
    // element may have already been removed due to v-html / v-text
    if (isDef(parent)) {
      nodeOps.removeChild(parent, el);
    }
  }

  function isUnknownElement$$1 (vnode, inVPre) {
    return (
      !inVPre &&
      !vnode.ns &&
      !(
        config.ignoredElements.length &&
        config.ignoredElements.some(function (ignore) {
          return isRegExp(ignore)
            ? ignore.test(vnode.tag)
            : ignore === vnode.tag
        })
      ) &&
      config.isUnknownElement(vnode.tag)
    )
  }

  var creatingElmInVPre = 0;

  function createElm (
    vnode,
    insertedVnodeQueue,
    parentElm,
    refElm,
    nested,
    ownerArray,
    index
  ) {
    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // This vnode was used in a previous render!
      // now it's used as a new node, overwriting its elm would cause
      // potential patch errors down the road when it's used as an insertion
      // reference node. Instead, we clone the node on-demand before creating
      // associated DOM element for it.
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    vnode.isRootInsert = !nested; // for transition enter check
    if (createComponent(vnode, insertedVnodeQueue, parentElm, refElm)) {
      return
    }

    var data = vnode.data;
    var children = vnode.children;
    var tag = vnode.tag;
    if (isDef(tag)) {
      if (false) {
        if (data && data.pre) {
          creatingElmInVPre++;
        }
        if (isUnknownElement$$1(vnode, creatingElmInVPre)) {
          warn(
            'Unknown custom element: <' + tag + '> - did you ' +
            'register the component correctly? For recursive components, ' +
            'make sure to provide the "name" option.',
            vnode.context
          );
        }
      }

      vnode.elm = vnode.ns
        ? nodeOps.createElementNS(vnode.ns, tag)
        : nodeOps.createElement(tag, vnode);
      setScope(vnode);

      /* istanbul ignore if */
      {
        createChildren(vnode, children, insertedVnodeQueue);
        if (isDef(data)) {
          invokeCreateHooks(vnode, insertedVnodeQueue);
        }
        insert(parentElm, vnode.elm, refElm);
      }

      if (false) {
        creatingElmInVPre--;
      }
    } else if (isTrue(vnode.isComment)) {
      vnode.elm = nodeOps.createComment(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    } else {
      vnode.elm = nodeOps.createTextNode(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    }
  }

  function createComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i = vnode.data;
    if (isDef(i)) {
      var isReactivated = isDef(vnode.componentInstance) && i.keepAlive;
      if (isDef(i = i.hook) && isDef(i = i.init)) {
        i(vnode, false /* hydrating */);
      }
      // after calling the init hook, if the vnode is a child component
      // it should've created a child instance and mounted it. the child
      // component also has set the placeholder vnode's elm.
      // in that case we can just return the element and be done.
      if (isDef(vnode.componentInstance)) {
        initComponent(vnode, insertedVnodeQueue);
        insert(parentElm, vnode.elm, refElm);
        if (isTrue(isReactivated)) {
          reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm);
        }
        return true
      }
    }
  }

  function initComponent (vnode, insertedVnodeQueue) {
    if (isDef(vnode.data.pendingInsert)) {
      insertedVnodeQueue.push.apply(insertedVnodeQueue, vnode.data.pendingInsert);
      vnode.data.pendingInsert = null;
    }
    vnode.elm = vnode.componentInstance.$el;
    if (isPatchable(vnode)) {
      invokeCreateHooks(vnode, insertedVnodeQueue);
      setScope(vnode);
    } else {
      // empty component root.
      // skip all element-related modules except for ref (#3455)
      registerRef(vnode);
      // make sure to invoke the insert hook
      insertedVnodeQueue.push(vnode);
    }
  }

  function reactivateComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i;
    // hack for #4339: a reactivated component with inner transition
    // does not trigger because the inner node's created hooks are not called
    // again. It's not ideal to involve module-specific logic in here but
    // there doesn't seem to be a better way to do it.
    var innerNode = vnode;
    while (innerNode.componentInstance) {
      innerNode = innerNode.componentInstance._vnode;
      if (isDef(i = innerNode.data) && isDef(i = i.transition)) {
        for (i = 0; i < cbs.activate.length; ++i) {
          cbs.activate[i](emptyNode, innerNode);
        }
        insertedVnodeQueue.push(innerNode);
        break
      }
    }
    // unlike a newly created component,
    // a reactivated keep-alive component doesn't insert itself
    insert(parentElm, vnode.elm, refElm);
  }

  function insert (parent, elm, ref$$1) {
    if (isDef(parent)) {
      if (isDef(ref$$1)) {
        if (nodeOps.parentNode(ref$$1) === parent) {
          nodeOps.insertBefore(parent, elm, ref$$1);
        }
      } else {
        nodeOps.appendChild(parent, elm);
      }
    }
  }

  function createChildren (vnode, children, insertedVnodeQueue) {
    if (Array.isArray(children)) {
      if (false) {
        checkDuplicateKeys(children);
      }
      for (var i = 0; i < children.length; ++i) {
        createElm(children[i], insertedVnodeQueue, vnode.elm, null, true, children, i);
      }
    } else if (isPrimitive(vnode.text)) {
      nodeOps.appendChild(vnode.elm, nodeOps.createTextNode(String(vnode.text)));
    }
  }

  function isPatchable (vnode) {
    while (vnode.componentInstance) {
      vnode = vnode.componentInstance._vnode;
    }
    return isDef(vnode.tag)
  }

  function invokeCreateHooks (vnode, insertedVnodeQueue) {
    for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
      cbs.create[i$1](emptyNode, vnode);
    }
    i = vnode.data.hook; // Reuse variable
    if (isDef(i)) {
      if (isDef(i.create)) { i.create(emptyNode, vnode); }
      if (isDef(i.insert)) { insertedVnodeQueue.push(vnode); }
    }
  }

  // set scope id attribute for scoped CSS.
  // this is implemented as a special case to avoid the overhead
  // of going through the normal attribute patching process.
  function setScope (vnode) {
    var i;
    if (isDef(i = vnode.fnScopeId)) {
      nodeOps.setStyleScope(vnode.elm, i);
    } else {
      var ancestor = vnode;
      while (ancestor) {
        if (isDef(i = ancestor.context) && isDef(i = i.$options._scopeId)) {
          nodeOps.setStyleScope(vnode.elm, i);
        }
        ancestor = ancestor.parent;
      }
    }
    // for slot content they should also get the scopeId from the host instance.
    if (isDef(i = activeInstance) &&
      i !== vnode.context &&
      i !== vnode.fnContext &&
      isDef(i = i.$options._scopeId)
    ) {
      nodeOps.setStyleScope(vnode.elm, i);
    }
  }

  function addVnodes (parentElm, refElm, vnodes, startIdx, endIdx, insertedVnodeQueue) {
    for (; startIdx <= endIdx; ++startIdx) {
      createElm(vnodes[startIdx], insertedVnodeQueue, parentElm, refElm, false, vnodes, startIdx);
    }
  }

  function invokeDestroyHook (vnode) {
    var i, j;
    var data = vnode.data;
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.destroy)) { i(vnode); }
      for (i = 0; i < cbs.destroy.length; ++i) { cbs.destroy[i](vnode); }
    }
    if (isDef(i = vnode.children)) {
      for (j = 0; j < vnode.children.length; ++j) {
        invokeDestroyHook(vnode.children[j]);
      }
    }
  }

  function removeVnodes (vnodes, startIdx, endIdx) {
    for (; startIdx <= endIdx; ++startIdx) {
      var ch = vnodes[startIdx];
      if (isDef(ch)) {
        if (isDef(ch.tag)) {
          removeAndInvokeRemoveHook(ch);
          invokeDestroyHook(ch);
        } else { // Text node
          removeNode(ch.elm);
        }
      }
    }
  }

  function removeAndInvokeRemoveHook (vnode, rm) {
    if (isDef(rm) || isDef(vnode.data)) {
      var i;
      var listeners = cbs.remove.length + 1;
      if (isDef(rm)) {
        // we have a recursively passed down rm callback
        // increase the listeners count
        rm.listeners += listeners;
      } else {
        // directly removing
        rm = createRmCb(vnode.elm, listeners);
      }
      // recursively invoke hooks on child component root node
      if (isDef(i = vnode.componentInstance) && isDef(i = i._vnode) && isDef(i.data)) {
        removeAndInvokeRemoveHook(i, rm);
      }
      for (i = 0; i < cbs.remove.length; ++i) {
        cbs.remove[i](vnode, rm);
      }
      if (isDef(i = vnode.data.hook) && isDef(i = i.remove)) {
        i(vnode, rm);
      } else {
        rm();
      }
    } else {
      removeNode(vnode.elm);
    }
  }

  function updateChildren (parentElm, oldCh, newCh, insertedVnodeQueue, removeOnly) {
    var oldStartIdx = 0;
    var newStartIdx = 0;
    var oldEndIdx = oldCh.length - 1;
    var oldStartVnode = oldCh[0];
    var oldEndVnode = oldCh[oldEndIdx];
    var newEndIdx = newCh.length - 1;
    var newStartVnode = newCh[0];
    var newEndVnode = newCh[newEndIdx];
    var oldKeyToIdx, idxInOld, vnodeToMove, refElm;

    // removeOnly is a special flag used only by <transition-group>
    // to ensure removed elements stay in correct relative positions
    // during leaving transitions
    var canMove = !removeOnly;

    if (false) {
      checkDuplicateKeys(newCh);
    }

    while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
      if (isUndef(oldStartVnode)) {
        oldStartVnode = oldCh[++oldStartIdx]; // Vnode has been moved left
      } else if (isUndef(oldEndVnode)) {
        oldEndVnode = oldCh[--oldEndIdx];
      } else if (sameVnode(oldStartVnode, newStartVnode)) {
        patchVnode(oldStartVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        oldStartVnode = oldCh[++oldStartIdx];
        newStartVnode = newCh[++newStartIdx];
      } else if (sameVnode(oldEndVnode, newEndVnode)) {
        patchVnode(oldEndVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        oldEndVnode = oldCh[--oldEndIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldStartVnode, newEndVnode)) { // Vnode moved right
        patchVnode(oldStartVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        canMove && nodeOps.insertBefore(parentElm, oldStartVnode.elm, nodeOps.nextSibling(oldEndVnode.elm));
        oldStartVnode = oldCh[++oldStartIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldEndVnode, newStartVnode)) { // Vnode moved left
        patchVnode(oldEndVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        canMove && nodeOps.insertBefore(parentElm, oldEndVnode.elm, oldStartVnode.elm);
        oldEndVnode = oldCh[--oldEndIdx];
        newStartVnode = newCh[++newStartIdx];
      } else {
        if (isUndef(oldKeyToIdx)) { oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx); }
        idxInOld = isDef(newStartVnode.key)
          ? oldKeyToIdx[newStartVnode.key]
          : findIdxInOld(newStartVnode, oldCh, oldStartIdx, oldEndIdx);
        if (isUndef(idxInOld)) { // New element
          createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
        } else {
          vnodeToMove = oldCh[idxInOld];
          if (sameVnode(vnodeToMove, newStartVnode)) {
            patchVnode(vnodeToMove, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
            oldCh[idxInOld] = undefined;
            canMove && nodeOps.insertBefore(parentElm, vnodeToMove.elm, oldStartVnode.elm);
          } else {
            // same key but different element. treat as new element
            createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
          }
        }
        newStartVnode = newCh[++newStartIdx];
      }
    }
    if (oldStartIdx > oldEndIdx) {
      refElm = isUndef(newCh[newEndIdx + 1]) ? null : newCh[newEndIdx + 1].elm;
      addVnodes(parentElm, refElm, newCh, newStartIdx, newEndIdx, insertedVnodeQueue);
    } else if (newStartIdx > newEndIdx) {
      removeVnodes(oldCh, oldStartIdx, oldEndIdx);
    }
  }

  function checkDuplicateKeys (children) {
    var seenKeys = {};
    for (var i = 0; i < children.length; i++) {
      var vnode = children[i];
      var key = vnode.key;
      if (isDef(key)) {
        if (seenKeys[key]) {
          warn(
            ("Duplicate keys detected: '" + key + "'. This may cause an update error."),
            vnode.context
          );
        } else {
          seenKeys[key] = true;
        }
      }
    }
  }

  function findIdxInOld (node, oldCh, start, end) {
    for (var i = start; i < end; i++) {
      var c = oldCh[i];
      if (isDef(c) && sameVnode(node, c)) { return i }
    }
  }

  function patchVnode (
    oldVnode,
    vnode,
    insertedVnodeQueue,
    ownerArray,
    index,
    removeOnly
  ) {
    if (oldVnode === vnode) {
      return
    }

    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // clone reused vnode
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    var elm = vnode.elm = oldVnode.elm;

    if (isTrue(oldVnode.isAsyncPlaceholder)) {
      if (isDef(vnode.asyncFactory.resolved)) {
        hydrate(oldVnode.elm, vnode, insertedVnodeQueue);
      } else {
        vnode.isAsyncPlaceholder = true;
      }
      return
    }

    // reuse element for static trees.
    // note we only do this if the vnode is cloned -
    // if the new node is not cloned it means the render functions have been
    // reset by the hot-reload-api and we need to do a proper re-render.
    if (isTrue(vnode.isStatic) &&
      isTrue(oldVnode.isStatic) &&
      vnode.key === oldVnode.key &&
      (isTrue(vnode.isCloned) || isTrue(vnode.isOnce))
    ) {
      vnode.componentInstance = oldVnode.componentInstance;
      return
    }

    var i;
    var data = vnode.data;
    if (isDef(data) && isDef(i = data.hook) && isDef(i = i.prepatch)) {
      i(oldVnode, vnode);
    }

    var oldCh = oldVnode.children;
    var ch = vnode.children;
    if (isDef(data) && isPatchable(vnode)) {
      for (i = 0; i < cbs.update.length; ++i) { cbs.update[i](oldVnode, vnode); }
      if (isDef(i = data.hook) && isDef(i = i.update)) { i(oldVnode, vnode); }
    }
    if (isUndef(vnode.text)) {
      if (isDef(oldCh) && isDef(ch)) {
        if (oldCh !== ch) { updateChildren(elm, oldCh, ch, insertedVnodeQueue, removeOnly); }
      } else if (isDef(ch)) {
        if (false) {
          checkDuplicateKeys(ch);
        }
        if (isDef(oldVnode.text)) { nodeOps.setTextContent(elm, ''); }
        addVnodes(elm, null, ch, 0, ch.length - 1, insertedVnodeQueue);
      } else if (isDef(oldCh)) {
        removeVnodes(oldCh, 0, oldCh.length - 1);
      } else if (isDef(oldVnode.text)) {
        nodeOps.setTextContent(elm, '');
      }
    } else if (oldVnode.text !== vnode.text) {
      nodeOps.setTextContent(elm, vnode.text);
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.postpatch)) { i(oldVnode, vnode); }
    }
  }

  function invokeInsertHook (vnode, queue, initial) {
    // delay insert hooks for component root nodes, invoke them after the
    // element is really inserted
    if (isTrue(initial) && isDef(vnode.parent)) {
      vnode.parent.data.pendingInsert = queue;
    } else {
      for (var i = 0; i < queue.length; ++i) {
        queue[i].data.hook.insert(queue[i]);
      }
    }
  }

  var hydrationBailed = false;
  // list of modules that can skip create hook during hydration because they
  // are already rendered on the client or has no need for initialization
  // Note: style is excluded because it relies on initial clone for future
  // deep updates (#7063).
  var isRenderedModule = makeMap('attrs,class,staticClass,staticStyle,key');

  // Note: this is a browser-only function so we can assume elms are DOM nodes.
  function hydrate (elm, vnode, insertedVnodeQueue, inVPre) {
    var i;
    var tag = vnode.tag;
    var data = vnode.data;
    var children = vnode.children;
    inVPre = inVPre || (data && data.pre);
    vnode.elm = elm;

    if (isTrue(vnode.isComment) && isDef(vnode.asyncFactory)) {
      vnode.isAsyncPlaceholder = true;
      return true
    }
    // assert node match
    if (false) {
      if (!assertNodeMatch(elm, vnode, inVPre)) {
        return false
      }
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.init)) { i(vnode, true /* hydrating */); }
      if (isDef(i = vnode.componentInstance)) {
        // child component. it should have hydrated its own tree.
        initComponent(vnode, insertedVnodeQueue);
        return true
      }
    }
    if (isDef(tag)) {
      if (isDef(children)) {
        // empty element, allow client to pick up and populate children
        if (!elm.hasChildNodes()) {
          createChildren(vnode, children, insertedVnodeQueue);
        } else {
          // v-html and domProps: innerHTML
          if (isDef(i = data) && isDef(i = i.domProps) && isDef(i = i.innerHTML)) {
            if (i !== elm.innerHTML) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('server innerHTML: ', i);
                console.warn('client innerHTML: ', elm.innerHTML);
              }
              return false
            }
          } else {
            // iterate and compare children lists
            var childrenMatch = true;
            var childNode = elm.firstChild;
            for (var i$1 = 0; i$1 < children.length; i$1++) {
              if (!childNode || !hydrate(childNode, children[i$1], insertedVnodeQueue, inVPre)) {
                childrenMatch = false;
                break
              }
              childNode = childNode.nextSibling;
            }
            // if childNode is not null, it means the actual childNodes list is
            // longer than the virtual children list.
            if (!childrenMatch || childNode) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('Mismatching childNodes vs. VNodes: ', elm.childNodes, children);
              }
              return false
            }
          }
        }
      }
      if (isDef(data)) {
        var fullInvoke = false;
        for (var key in data) {
          if (!isRenderedModule(key)) {
            fullInvoke = true;
            invokeCreateHooks(vnode, insertedVnodeQueue);
            break
          }
        }
        if (!fullInvoke && data['class']) {
          // ensure collecting deps for deep class bindings for future updates
          traverse(data['class']);
        }
      }
    } else if (elm.data !== vnode.text) {
      elm.data = vnode.text;
    }
    return true
  }

  function assertNodeMatch (node, vnode, inVPre) {
    if (isDef(vnode.tag)) {
      return vnode.tag.indexOf('vue-component') === 0 || (
        !isUnknownElement$$1(vnode, inVPre) &&
        vnode.tag.toLowerCase() === (node.tagName && node.tagName.toLowerCase())
      )
    } else {
      return node.nodeType === (vnode.isComment ? 8 : 3)
    }
  }

  return function patch (oldVnode, vnode, hydrating, removeOnly) {
    if (isUndef(vnode)) {
      if (isDef(oldVnode)) { invokeDestroyHook(oldVnode); }
      return
    }

    var isInitialPatch = false;
    var insertedVnodeQueue = [];

    if (isUndef(oldVnode)) {
      // empty mount (likely as component), create new root element
      isInitialPatch = true;
      createElm(vnode, insertedVnodeQueue);
    } else {
      var isRealElement = isDef(oldVnode.nodeType);
      if (!isRealElement && sameVnode(oldVnode, vnode)) {
        // patch existing root node
        patchVnode(oldVnode, vnode, insertedVnodeQueue, null, null, removeOnly);
      } else {
        if (isRealElement) {
          // mounting to a real element
          // check if this is server-rendered content and if we can perform
          // a successful hydration.
          if (oldVnode.nodeType === 1 && oldVnode.hasAttribute(SSR_ATTR)) {
            oldVnode.removeAttribute(SSR_ATTR);
            hydrating = true;
          }
          if (isTrue(hydrating)) {
            if (hydrate(oldVnode, vnode, insertedVnodeQueue)) {
              invokeInsertHook(vnode, insertedVnodeQueue, true);
              return oldVnode
            } else if (false) {
              warn(
                'The client-side rendered virtual DOM tree is not matching ' +
                'server-rendered content. This is likely caused by incorrect ' +
                'HTML markup, for example nesting block-level elements inside ' +
                '<p>, or missing <tbody>. Bailing hydration and performing ' +
                'full client-side render.'
              );
            }
          }
          // either not server-rendered, or hydration failed.
          // create an empty node and replace it
          oldVnode = emptyNodeAt(oldVnode);
        }

        // replacing existing element
        var oldElm = oldVnode.elm;
        var parentElm = nodeOps.parentNode(oldElm);

        // create new node
        createElm(
          vnode,
          insertedVnodeQueue,
          // extremely rare edge case: do not insert if old element is in a
          // leaving transition. Only happens when combining transition +
          // keep-alive + HOCs. (#4590)
          oldElm._leaveCb ? null : parentElm,
          nodeOps.nextSibling(oldElm)
        );

        // update parent placeholder node element, recursively
        if (isDef(vnode.parent)) {
          var ancestor = vnode.parent;
          var patchable = isPatchable(vnode);
          while (ancestor) {
            for (var i = 0; i < cbs.destroy.length; ++i) {
              cbs.destroy[i](ancestor);
            }
            ancestor.elm = vnode.elm;
            if (patchable) {
              for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
                cbs.create[i$1](emptyNode, ancestor);
              }
              // #6513
              // invoke insert hooks that may have been merged by create hooks.
              // e.g. for directives that uses the "inserted" hook.
              var insert = ancestor.data.hook.insert;
              if (insert.merged) {
                // start at index 1 to avoid re-invoking component mounted hook
                for (var i$2 = 1; i$2 < insert.fns.length; i$2++) {
                  insert.fns[i$2]();
                }
              }
            } else {
              registerRef(ancestor);
            }
            ancestor = ancestor.parent;
          }
        }

        // destroy old node
        if (isDef(parentElm)) {
          removeVnodes([oldVnode], 0, 0);
        } else if (isDef(oldVnode.tag)) {
          invokeDestroyHook(oldVnode);
        }
      }
    }

    invokeInsertHook(vnode, insertedVnodeQueue, isInitialPatch);
    return vnode.elm
  }
}

/*  */

var directives = {
  create: updateDirectives,
  update: updateDirectives,
  destroy: function unbindDirectives (vnode) {
    updateDirectives(vnode, emptyNode);
  }
};

function updateDirectives (oldVnode, vnode) {
  if (oldVnode.data.directives || vnode.data.directives) {
    _update(oldVnode, vnode);
  }
}

function _update (oldVnode, vnode) {
  var isCreate = oldVnode === emptyNode;
  var isDestroy = vnode === emptyNode;
  var oldDirs = normalizeDirectives$1(oldVnode.data.directives, oldVnode.context);
  var newDirs = normalizeDirectives$1(vnode.data.directives, vnode.context);

  var dirsWithInsert = [];
  var dirsWithPostpatch = [];

  var key, oldDir, dir;
  for (key in newDirs) {
    oldDir = oldDirs[key];
    dir = newDirs[key];
    if (!oldDir) {
      // new directive, bind
      callHook$1(dir, 'bind', vnode, oldVnode);
      if (dir.def && dir.def.inserted) {
        dirsWithInsert.push(dir);
      }
    } else {
      // existing directive, update
      dir.oldValue = oldDir.value;
      dir.oldArg = oldDir.arg;
      callHook$1(dir, 'update', vnode, oldVnode);
      if (dir.def && dir.def.componentUpdated) {
        dirsWithPostpatch.push(dir);
      }
    }
  }

  if (dirsWithInsert.length) {
    var callInsert = function () {
      for (var i = 0; i < dirsWithInsert.length; i++) {
        callHook$1(dirsWithInsert[i], 'inserted', vnode, oldVnode);
      }
    };
    if (isCreate) {
      mergeVNodeHook(vnode, 'insert', callInsert);
    } else {
      callInsert();
    }
  }

  if (dirsWithPostpatch.length) {
    mergeVNodeHook(vnode, 'postpatch', function () {
      for (var i = 0; i < dirsWithPostpatch.length; i++) {
        callHook$1(dirsWithPostpatch[i], 'componentUpdated', vnode, oldVnode);
      }
    });
  }

  if (!isCreate) {
    for (key in oldDirs) {
      if (!newDirs[key]) {
        // no longer present, unbind
        callHook$1(oldDirs[key], 'unbind', oldVnode, oldVnode, isDestroy);
      }
    }
  }
}

var emptyModifiers = Object.create(null);

function normalizeDirectives$1 (
  dirs,
  vm
) {
  var res = Object.create(null);
  if (!dirs) {
    // $flow-disable-line
    return res
  }
  var i, dir;
  for (i = 0; i < dirs.length; i++) {
    dir = dirs[i];
    if (!dir.modifiers) {
      // $flow-disable-line
      dir.modifiers = emptyModifiers;
    }
    res[getRawDirName(dir)] = dir;
    dir.def = resolveAsset(vm.$options, 'directives', dir.name, true);
  }
  // $flow-disable-line
  return res
}

function getRawDirName (dir) {
  return dir.rawName || ((dir.name) + "." + (Object.keys(dir.modifiers || {}).join('.')))
}

function callHook$1 (dir, hook, vnode, oldVnode, isDestroy) {
  var fn = dir.def && dir.def[hook];
  if (fn) {
    try {
      fn(vnode.elm, dir, vnode, oldVnode, isDestroy);
    } catch (e) {
      handleError(e, vnode.context, ("directive " + (dir.name) + " " + hook + " hook"));
    }
  }
}

var baseModules = [
  ref,
  directives
];

/*  */

function updateAttrs (oldVnode, vnode) {
  var opts = vnode.componentOptions;
  if (isDef(opts) && opts.Ctor.options.inheritAttrs === false) {
    return
  }
  if (isUndef(oldVnode.data.attrs) && isUndef(vnode.data.attrs)) {
    return
  }
  var key, cur, old;
  var elm = vnode.elm;
  var oldAttrs = oldVnode.data.attrs || {};
  var attrs = vnode.data.attrs || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(attrs.__ob__)) {
    attrs = vnode.data.attrs = extend({}, attrs);
  }

  for (key in attrs) {
    cur = attrs[key];
    old = oldAttrs[key];
    if (old !== cur) {
      setAttr(elm, key, cur);
    }
  }
  // #4391: in IE9, setting type can reset value for input[type=radio]
  // #6666: IE/Edge forces progress value down to 1 before setting a max
  /* istanbul ignore if */
  if ((isIE || isEdge) && attrs.value !== oldAttrs.value) {
    setAttr(elm, 'value', attrs.value);
  }
  for (key in oldAttrs) {
    if (isUndef(attrs[key])) {
      if (isXlink(key)) {
        elm.removeAttributeNS(xlinkNS, getXlinkProp(key));
      } else if (!isEnumeratedAttr(key)) {
        elm.removeAttribute(key);
      }
    }
  }
}

function setAttr (el, key, value) {
  if (el.tagName.indexOf('-') > -1) {
    baseSetAttr(el, key, value);
  } else if (isBooleanAttr(key)) {
    // set attribute for blank value
    // e.g. <option disabled>Select one</option>
    if (isFalsyAttrValue(value)) {
      el.removeAttribute(key);
    } else {
      // technically allowfullscreen is a boolean attribute for <iframe>,
      // but Flash expects a value of "true" when used on <embed> tag
      value = key === 'allowfullscreen' && el.tagName === 'EMBED'
        ? 'true'
        : key;
      el.setAttribute(key, value);
    }
  } else if (isEnumeratedAttr(key)) {
    el.setAttribute(key, convertEnumeratedValue(key, value));
  } else if (isXlink(key)) {
    if (isFalsyAttrValue(value)) {
      el.removeAttributeNS(xlinkNS, getXlinkProp(key));
    } else {
      el.setAttributeNS(xlinkNS, key, value);
    }
  } else {
    baseSetAttr(el, key, value);
  }
}

function baseSetAttr (el, key, value) {
  if (isFalsyAttrValue(value)) {
    el.removeAttribute(key);
  } else {
    // #7138: IE10 & 11 fires input event when setting placeholder on
    // <textarea>... block the first input event and remove the blocker
    // immediately.
    /* istanbul ignore if */
    if (
      isIE && !isIE9 &&
      el.tagName === 'TEXTAREA' &&
      key === 'placeholder' && value !== '' && !el.__ieph
    ) {
      var blocker = function (e) {
        e.stopImmediatePropagation();
        el.removeEventListener('input', blocker);
      };
      el.addEventListener('input', blocker);
      // $flow-disable-line
      el.__ieph = true; /* IE placeholder patched */
    }
    el.setAttribute(key, value);
  }
}

var attrs = {
  create: updateAttrs,
  update: updateAttrs
};

/*  */

function updateClass (oldVnode, vnode) {
  var el = vnode.elm;
  var data = vnode.data;
  var oldData = oldVnode.data;
  if (
    isUndef(data.staticClass) &&
    isUndef(data.class) && (
      isUndef(oldData) || (
        isUndef(oldData.staticClass) &&
        isUndef(oldData.class)
      )
    )
  ) {
    return
  }

  var cls = genClassForVnode(vnode);

  // handle transition classes
  var transitionClass = el._transitionClasses;
  if (isDef(transitionClass)) {
    cls = concat(cls, stringifyClass(transitionClass));
  }

  // set the class
  if (cls !== el._prevClass) {
    el.setAttribute('class', cls);
    el._prevClass = cls;
  }
}

var klass = {
  create: updateClass,
  update: updateClass
};

/*  */

var validDivisionCharRE = /[\w).+\-_$\]]/;

function parseFilters (exp) {
  var inSingle = false;
  var inDouble = false;
  var inTemplateString = false;
  var inRegex = false;
  var curly = 0;
  var square = 0;
  var paren = 0;
  var lastFilterIndex = 0;
  var c, prev, i, expression, filters;

  for (i = 0; i < exp.length; i++) {
    prev = c;
    c = exp.charCodeAt(i);
    if (inSingle) {
      if (c === 0x27 && prev !== 0x5C) { inSingle = false; }
    } else if (inDouble) {
      if (c === 0x22 && prev !== 0x5C) { inDouble = false; }
    } else if (inTemplateString) {
      if (c === 0x60 && prev !== 0x5C) { inTemplateString = false; }
    } else if (inRegex) {
      if (c === 0x2f && prev !== 0x5C) { inRegex = false; }
    } else if (
      c === 0x7C && // pipe
      exp.charCodeAt(i + 1) !== 0x7C &&
      exp.charCodeAt(i - 1) !== 0x7C &&
      !curly && !square && !paren
    ) {
      if (expression === undefined) {
        // first filter, end of expression
        lastFilterIndex = i + 1;
        expression = exp.slice(0, i).trim();
      } else {
        pushFilter();
      }
    } else {
      switch (c) {
        case 0x22: inDouble = true; break         // "
        case 0x27: inSingle = true; break         // '
        case 0x60: inTemplateString = true; break // `
        case 0x28: paren++; break                 // (
        case 0x29: paren--; break                 // )
        case 0x5B: square++; break                // [
        case 0x5D: square--; break                // ]
        case 0x7B: curly++; break                 // {
        case 0x7D: curly--; break                 // }
      }
      if (c === 0x2f) { // /
        var j = i - 1;
        var p = (void 0);
        // find first non-whitespace prev char
        for (; j >= 0; j--) {
          p = exp.charAt(j);
          if (p !== ' ') { break }
        }
        if (!p || !validDivisionCharRE.test(p)) {
          inRegex = true;
        }
      }
    }
  }

  if (expression === undefined) {
    expression = exp.slice(0, i).trim();
  } else if (lastFilterIndex !== 0) {
    pushFilter();
  }

  function pushFilter () {
    (filters || (filters = [])).push(exp.slice(lastFilterIndex, i).trim());
    lastFilterIndex = i + 1;
  }

  if (filters) {
    for (i = 0; i < filters.length; i++) {
      expression = wrapFilter(expression, filters[i]);
    }
  }

  return expression
}

function wrapFilter (exp, filter) {
  var i = filter.indexOf('(');
  if (i < 0) {
    // _f: resolveFilter
    return ("_f(\"" + filter + "\")(" + exp + ")")
  } else {
    var name = filter.slice(0, i);
    var args = filter.slice(i + 1);
    return ("_f(\"" + name + "\")(" + exp + (args !== ')' ? ',' + args : args))
  }
}

/*  */



/* eslint-disable no-unused-vars */
function baseWarn (msg, range) {
  console.error(("[Vue compiler]: " + msg));
}
/* eslint-enable no-unused-vars */

function pluckModuleFunction (
  modules,
  key
) {
  return modules
    ? modules.map(function (m) { return m[key]; }).filter(function (_) { return _; })
    : []
}

function addProp (el, name, value, range, dynamic) {
  (el.props || (el.props = [])).push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

function addAttr (el, name, value, range, dynamic) {
  var attrs = dynamic
    ? (el.dynamicAttrs || (el.dynamicAttrs = []))
    : (el.attrs || (el.attrs = []));
  attrs.push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

// add a raw attr (use this in preTransforms)
function addRawAttr (el, name, value, range) {
  el.attrsMap[name] = value;
  el.attrsList.push(rangeSetItem({ name: name, value: value }, range));
}

function addDirective (
  el,
  name,
  rawName,
  value,
  arg,
  isDynamicArg,
  modifiers,
  range
) {
  (el.directives || (el.directives = [])).push(rangeSetItem({
    name: name,
    rawName: rawName,
    value: value,
    arg: arg,
    isDynamicArg: isDynamicArg,
    modifiers: modifiers
  }, range));
  el.plain = false;
}

function prependModifierMarker (symbol, name, dynamic) {
  return dynamic
    ? ("_p(" + name + ",\"" + symbol + "\")")
    : symbol + name // mark the event as captured
}

function addHandler (
  el,
  name,
  value,
  modifiers,
  important,
  warn,
  range,
  dynamic
) {
  modifiers = modifiers || emptyObject;
  // warn prevent and passive modifier
  /* istanbul ignore if */
  if (
    false
  ) {
    warn(
      'passive and prevent can\'t be used together. ' +
      'Passive handler can\'t prevent default event.',
      range
    );
  }

  // normalize click.right and click.middle since they don't actually fire
  // this is technically browser-specific, but at least for now browsers are
  // the only target envs that have right/middle clicks.
  if (modifiers.right) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'contextmenu':(" + name + ")";
    } else if (name === 'click') {
      name = 'contextmenu';
      delete modifiers.right;
    }
  } else if (modifiers.middle) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'mouseup':(" + name + ")";
    } else if (name === 'click') {
      name = 'mouseup';
    }
  }

  // check capture modifier
  if (modifiers.capture) {
    delete modifiers.capture;
    name = prependModifierMarker('!', name, dynamic);
  }
  if (modifiers.once) {
    delete modifiers.once;
    name = prependModifierMarker('~', name, dynamic);
  }
  /* istanbul ignore if */
  if (modifiers.passive) {
    delete modifiers.passive;
    name = prependModifierMarker('&', name, dynamic);
  }

  var events;
  if (modifiers.native) {
    delete modifiers.native;
    events = el.nativeEvents || (el.nativeEvents = {});
  } else {
    events = el.events || (el.events = {});
  }

  var newHandler = rangeSetItem({ value: value.trim(), dynamic: dynamic }, range);
  if (modifiers !== emptyObject) {
    newHandler.modifiers = modifiers;
  }

  var handlers = events[name];
  /* istanbul ignore if */
  if (Array.isArray(handlers)) {
    important ? handlers.unshift(newHandler) : handlers.push(newHandler);
  } else if (handlers) {
    events[name] = important ? [newHandler, handlers] : [handlers, newHandler];
  } else {
    events[name] = newHandler;
  }

  el.plain = false;
}

function getRawBindingAttr (
  el,
  name
) {
  return el.rawAttrsMap[':' + name] ||
    el.rawAttrsMap['v-bind:' + name] ||
    el.rawAttrsMap[name]
}

function getBindingAttr (
  el,
  name,
  getStatic
) {
  var dynamicValue =
    getAndRemoveAttr(el, ':' + name) ||
    getAndRemoveAttr(el, 'v-bind:' + name);
  if (dynamicValue != null) {
    return parseFilters(dynamicValue)
  } else if (getStatic !== false) {
    var staticValue = getAndRemoveAttr(el, name);
    if (staticValue != null) {
      return JSON.stringify(staticValue)
    }
  }
}

// note: this only removes the attr from the Array (attrsList) so that it
// doesn't get processed by processAttrs.
// By default it does NOT remove it from the map (attrsMap) because the map is
// needed during codegen.
function getAndRemoveAttr (
  el,
  name,
  removeFromMap
) {
  var val;
  if ((val = el.attrsMap[name]) != null) {
    var list = el.attrsList;
    for (var i = 0, l = list.length; i < l; i++) {
      if (list[i].name === name) {
        list.splice(i, 1);
        break
      }
    }
  }
  if (removeFromMap) {
    delete el.attrsMap[name];
  }
  return val
}

function getAndRemoveAttrByRegex (
  el,
  name
) {
  var list = el.attrsList;
  for (var i = 0, l = list.length; i < l; i++) {
    var attr = list[i];
    if (name.test(attr.name)) {
      list.splice(i, 1);
      return attr
    }
  }
}

function rangeSetItem (
  item,
  range
) {
  if (range) {
    if (range.start != null) {
      item.start = range.start;
    }
    if (range.end != null) {
      item.end = range.end;
    }
  }
  return item
}

/*  */

/**
 * Cross-platform code generation for component v-model
 */
function genComponentModel (
  el,
  value,
  modifiers
) {
  var ref = modifiers || {};
  var number = ref.number;
  var trim = ref.trim;

  var baseValueExpression = '$$v';
  var valueExpression = baseValueExpression;
  if (trim) {
    valueExpression =
      "(typeof " + baseValueExpression + " === 'string'" +
      "? " + baseValueExpression + ".trim()" +
      ": " + baseValueExpression + ")";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }
  var assignment = genAssignmentCode(value, valueExpression);

  el.model = {
    value: ("(" + value + ")"),
    expression: JSON.stringify(value),
    callback: ("function (" + baseValueExpression + ") {" + assignment + "}")
  };
}

/**
 * Cross-platform codegen helper for generating v-model value assignment code.
 */
function genAssignmentCode (
  value,
  assignment
) {
  var res = parseModel(value);
  if (res.key === null) {
    return (value + "=" + assignment)
  } else {
    return ("$set(" + (res.exp) + ", " + (res.key) + ", " + assignment + ")")
  }
}

/**
 * Parse a v-model expression into a base path and a final key segment.
 * Handles both dot-path and possible square brackets.
 *
 * Possible cases:
 *
 * - test
 * - test[key]
 * - test[test1[key]]
 * - test["a"][key]
 * - xxx.test[a[a].test1[key]]
 * - test.xxx.a["asa"][test1[key]]
 *
 */

var len, str, chr, index$1, expressionPos, expressionEndPos;



function parseModel (val) {
  // Fix https://github.com/vuejs/vue/pull/7730
  // allow v-model="obj.val " (trailing whitespace)
  val = val.trim();
  len = val.length;

  if (val.indexOf('[') < 0 || val.lastIndexOf(']') < len - 1) {
    index$1 = val.lastIndexOf('.');
    if (index$1 > -1) {
      return {
        exp: val.slice(0, index$1),
        key: '"' + val.slice(index$1 + 1) + '"'
      }
    } else {
      return {
        exp: val,
        key: null
      }
    }
  }

  str = val;
  index$1 = expressionPos = expressionEndPos = 0;

  while (!eof()) {
    chr = next();
    /* istanbul ignore if */
    if (isStringStart(chr)) {
      parseString(chr);
    } else if (chr === 0x5B) {
      parseBracket(chr);
    }
  }

  return {
    exp: val.slice(0, expressionPos),
    key: val.slice(expressionPos + 1, expressionEndPos)
  }
}

function next () {
  return str.charCodeAt(++index$1)
}

function eof () {
  return index$1 >= len
}

function isStringStart (chr) {
  return chr === 0x22 || chr === 0x27
}

function parseBracket (chr) {
  var inBracket = 1;
  expressionPos = index$1;
  while (!eof()) {
    chr = next();
    if (isStringStart(chr)) {
      parseString(chr);
      continue
    }
    if (chr === 0x5B) { inBracket++; }
    if (chr === 0x5D) { inBracket--; }
    if (inBracket === 0) {
      expressionEndPos = index$1;
      break
    }
  }
}

function parseString (chr) {
  var stringQuote = chr;
  while (!eof()) {
    chr = next();
    if (chr === stringQuote) {
      break
    }
  }
}

/*  */

var warn$1;

// in some cases, the event used has to be determined at runtime
// so we used some reserved tokens during compile.
var RANGE_TOKEN = '__r';
var CHECKBOX_RADIO_TOKEN = '__c';

function model (
  el,
  dir,
  _warn
) {
  warn$1 = _warn;
  var value = dir.value;
  var modifiers = dir.modifiers;
  var tag = el.tag;
  var type = el.attrsMap.type;

  if (false) {
    // inputs with type="file" are read only and setting the input's
    // value will throw an error.
    if (tag === 'input' && type === 'file') {
      warn$1(
        "<" + (el.tag) + " v-model=\"" + value + "\" type=\"file\">:\n" +
        "File inputs are read only. Use a v-on:change listener instead.",
        el.rawAttrsMap['v-model']
      );
    }
  }

  if (el.component) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (tag === 'select') {
    genSelect(el, value, modifiers);
  } else if (tag === 'input' && type === 'checkbox') {
    genCheckboxModel(el, value, modifiers);
  } else if (tag === 'input' && type === 'radio') {
    genRadioModel(el, value, modifiers);
  } else if (tag === 'input' || tag === 'textarea') {
    genDefaultModel(el, value, modifiers);
  } else if (!config.isReservedTag(tag)) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (false) {
    warn$1(
      "<" + (el.tag) + " v-model=\"" + value + "\">: " +
      "v-model is not supported on this element type. " +
      'If you are working with contenteditable, it\'s recommended to ' +
      'wrap a library dedicated for that purpose inside a custom component.',
      el.rawAttrsMap['v-model']
    );
  }

  // ensure runtime directive metadata
  return true
}

function genCheckboxModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  var trueValueBinding = getBindingAttr(el, 'true-value') || 'true';
  var falseValueBinding = getBindingAttr(el, 'false-value') || 'false';
  addProp(el, 'checked',
    "Array.isArray(" + value + ")" +
    "?_i(" + value + "," + valueBinding + ")>-1" + (
      trueValueBinding === 'true'
        ? (":(" + value + ")")
        : (":_q(" + value + "," + trueValueBinding + ")")
    )
  );
  addHandler(el, 'change',
    "var $$a=" + value + "," +
        '$$el=$event.target,' +
        "$$c=$$el.checked?(" + trueValueBinding + "):(" + falseValueBinding + ");" +
    'if(Array.isArray($$a)){' +
      "var $$v=" + (number ? '_n(' + valueBinding + ')' : valueBinding) + "," +
          '$$i=_i($$a,$$v);' +
      "if($$el.checked){$$i<0&&(" + (genAssignmentCode(value, '$$a.concat([$$v])')) + ")}" +
      "else{$$i>-1&&(" + (genAssignmentCode(value, '$$a.slice(0,$$i).concat($$a.slice($$i+1))')) + ")}" +
    "}else{" + (genAssignmentCode(value, '$$c')) + "}",
    null, true
  );
}

function genRadioModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  valueBinding = number ? ("_n(" + valueBinding + ")") : valueBinding;
  addProp(el, 'checked', ("_q(" + value + "," + valueBinding + ")"));
  addHandler(el, 'change', genAssignmentCode(value, valueBinding), null, true);
}

function genSelect (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var selectedVal = "Array.prototype.filter" +
    ".call($event.target.options,function(o){return o.selected})" +
    ".map(function(o){var val = \"_value\" in o ? o._value : o.value;" +
    "return " + (number ? '_n(val)' : 'val') + "})";

  var assignment = '$event.target.multiple ? $$selectedVal : $$selectedVal[0]';
  var code = "var $$selectedVal = " + selectedVal + ";";
  code = code + " " + (genAssignmentCode(value, assignment));
  addHandler(el, 'change', code, null, true);
}

function genDefaultModel (
  el,
  value,
  modifiers
) {
  var type = el.attrsMap.type;

  // warn if v-bind:value conflicts with v-model
  // except for inputs with v-bind:type
  if (false) {
    var value$1 = el.attrsMap['v-bind:value'] || el.attrsMap[':value'];
    var typeBinding = el.attrsMap['v-bind:type'] || el.attrsMap[':type'];
    if (value$1 && !typeBinding) {
      var binding = el.attrsMap['v-bind:value'] ? 'v-bind:value' : ':value';
      warn$1(
        binding + "=\"" + value$1 + "\" conflicts with v-model on the same element " +
        'because the latter already expands to a value binding internally',
        el.rawAttrsMap[binding]
      );
    }
  }

  var ref = modifiers || {};
  var lazy = ref.lazy;
  var number = ref.number;
  var trim = ref.trim;
  var needCompositionGuard = !lazy && type !== 'range';
  var event = lazy
    ? 'change'
    : type === 'range'
      ? RANGE_TOKEN
      : 'input';

  var valueExpression = '$event.target.value';
  if (trim) {
    valueExpression = "$event.target.value.trim()";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }

  var code = genAssignmentCode(value, valueExpression);
  if (needCompositionGuard) {
    code = "if($event.target.composing)return;" + code;
  }

  addProp(el, 'value', ("(" + value + ")"));
  addHandler(el, event, code, null, true);
  if (trim || number) {
    addHandler(el, 'blur', '$forceUpdate()');
  }
}

/*  */

// normalize v-model event tokens that can only be determined at runtime.
// it's important to place the event as the first in the array because
// the whole point is ensuring the v-model callback gets called before
// user-attached handlers.
function normalizeEvents (on) {
  /* istanbul ignore if */
  if (isDef(on[RANGE_TOKEN])) {
    // IE input[type=range] only supports `change` event
    var event = isIE ? 'change' : 'input';
    on[event] = [].concat(on[RANGE_TOKEN], on[event] || []);
    delete on[RANGE_TOKEN];
  }
  // This was originally intended to fix #4521 but no longer necessary
  // after 2.5. Keeping it for backwards compat with generated code from < 2.4
  /* istanbul ignore if */
  if (isDef(on[CHECKBOX_RADIO_TOKEN])) {
    on.change = [].concat(on[CHECKBOX_RADIO_TOKEN], on.change || []);
    delete on[CHECKBOX_RADIO_TOKEN];
  }
}

var target$1;

function createOnceHandler$1 (event, handler, capture) {
  var _target = target$1; // save current target element in closure
  return function onceHandler () {
    var res = handler.apply(null, arguments);
    if (res !== null) {
      remove$2(event, onceHandler, capture, _target);
    }
  }
}

// #9446: Firefox <= 53 (in particular, ESR 52) has incorrect Event.timeStamp
// implementation and does not fire microtasks in between event propagation, so
// safe to exclude.
var useMicrotaskFix = isUsingMicroTask && !(isFF && Number(isFF[1]) <= 53);

function add$1 (
  name,
  handler,
  capture,
  passive
) {
  // async edge case #6566: inner click event triggers patch, event handler
  // attached to outer element during patch, and triggered again. This
  // happens because browsers fire microtask ticks between event propagation.
  // the solution is simple: we save the timestamp when a handler is attached,
  // and the handler would only fire if the event passed to it was fired
  // AFTER it was attached.
  if (useMicrotaskFix) {
    var attachedTimestamp = currentFlushTimestamp;
    var original = handler;
    handler = original._wrapper = function (e) {
      if (
        // no bubbling, should always fire.
        // this is just a safety net in case event.timeStamp is unreliable in
        // certain weird environments...
        e.target === e.currentTarget ||
        // event is fired after handler attachment
        e.timeStamp >= attachedTimestamp ||
        // bail for environments that have buggy event.timeStamp implementations
        // #9462 iOS 9 bug: event.timeStamp is 0 after history.pushState
        // #9681 QtWebEngine event.timeStamp is negative value
        e.timeStamp <= 0 ||
        // #9448 bail if event is fired in another document in a multi-page
        // electron/nw.js app, since event.timeStamp will be using a different
        // starting reference
        e.target.ownerDocument !== document
      ) {
        return original.apply(this, arguments)
      }
    };
  }
  target$1.addEventListener(
    name,
    handler,
    supportsPassive
      ? { capture: capture, passive: passive }
      : capture
  );
}

function remove$2 (
  name,
  handler,
  capture,
  _target
) {
  (_target || target$1).removeEventListener(
    name,
    handler._wrapper || handler,
    capture
  );
}

function updateDOMListeners (oldVnode, vnode) {
  if (isUndef(oldVnode.data.on) && isUndef(vnode.data.on)) {
    return
  }
  var on = vnode.data.on || {};
  var oldOn = oldVnode.data.on || {};
  target$1 = vnode.elm;
  normalizeEvents(on);
  updateListeners(on, oldOn, add$1, remove$2, createOnceHandler$1, vnode.context);
  target$1 = undefined;
}

var events = {
  create: updateDOMListeners,
  update: updateDOMListeners
};

/*  */

var svgContainer;

function updateDOMProps (oldVnode, vnode) {
  if (isUndef(oldVnode.data.domProps) && isUndef(vnode.data.domProps)) {
    return
  }
  var key, cur;
  var elm = vnode.elm;
  var oldProps = oldVnode.data.domProps || {};
  var props = vnode.data.domProps || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(props.__ob__)) {
    props = vnode.data.domProps = extend({}, props);
  }

  for (key in oldProps) {
    if (!(key in props)) {
      elm[key] = '';
    }
  }

  for (key in props) {
    cur = props[key];
    // ignore children if the node has textContent or innerHTML,
    // as these will throw away existing DOM nodes and cause removal errors
    // on subsequent patches (#3360)
    if (key === 'textContent' || key === 'innerHTML') {
      if (vnode.children) { vnode.children.length = 0; }
      if (cur === oldProps[key]) { continue }
      // #6601 work around Chrome version <= 55 bug where single textNode
      // replaced by innerHTML/textContent retains its parentNode property
      if (elm.childNodes.length === 1) {
        elm.removeChild(elm.childNodes[0]);
      }
    }

    if (key === 'value' && elm.tagName !== 'PROGRESS') {
      // store value as _value as well since
      // non-string values will be stringified
      elm._value = cur;
      // avoid resetting cursor position when value is the same
      var strCur = isUndef(cur) ? '' : String(cur);
      if (shouldUpdateValue(elm, strCur)) {
        elm.value = strCur;
      }
    } else if (key === 'innerHTML' && isSVG(elm.tagName) && isUndef(elm.innerHTML)) {
      // IE doesn't support innerHTML for SVG elements
      svgContainer = svgContainer || document.createElement('div');
      svgContainer.innerHTML = "<svg>" + cur + "</svg>";
      var svg = svgContainer.firstChild;
      while (elm.firstChild) {
        elm.removeChild(elm.firstChild);
      }
      while (svg.firstChild) {
        elm.appendChild(svg.firstChild);
      }
    } else if (
      // skip the update if old and new VDOM state is the same.
      // `value` is handled separately because the DOM value may be temporarily
      // out of sync with VDOM state due to focus, composition and modifiers.
      // This  #4521 by skipping the unnecessary `checked` update.
      cur !== oldProps[key]
    ) {
      // some property updates can throw
      // e.g. `value` on <progress> w/ non-finite value
      try {
        elm[key] = cur;
      } catch (e) {}
    }
  }
}

// check platforms/web/util/attrs.js acceptValue


function shouldUpdateValue (elm, checkVal) {
  return (!elm.composing && (
    elm.tagName === 'OPTION' ||
    isNotInFocusAndDirty(elm, checkVal) ||
    isDirtyWithModifiers(elm, checkVal)
  ))
}

function isNotInFocusAndDirty (elm, checkVal) {
  // return true when textbox (.number and .trim) loses focus and its value is
  // not equal to the updated value
  var notInFocus = true;
  // #6157
  // work around IE bug when accessing document.activeElement in an iframe
  try { notInFocus = document.activeElement !== elm; } catch (e) {}
  return notInFocus && elm.value !== checkVal
}

function isDirtyWithModifiers (elm, newVal) {
  var value = elm.value;
  var modifiers = elm._vModifiers; // injected by v-model runtime
  if (isDef(modifiers)) {
    if (modifiers.number) {
      return toNumber(value) !== toNumber(newVal)
    }
    if (modifiers.trim) {
      return value.trim() !== newVal.trim()
    }
  }
  return value !== newVal
}

var domProps = {
  create: updateDOMProps,
  update: updateDOMProps
};

/*  */

var parseStyleText = cached(function (cssText) {
  var res = {};
  var listDelimiter = /;(?![^(]*\))/g;
  var propertyDelimiter = /:(.+)/;
  cssText.split(listDelimiter).forEach(function (item) {
    if (item) {
      var tmp = item.split(propertyDelimiter);
      tmp.length > 1 && (res[tmp[0].trim()] = tmp[1].trim());
    }
  });
  return res
});

// merge static and dynamic style data on the same vnode
function normalizeStyleData (data) {
  var style = normalizeStyleBinding(data.style);
  // static style is pre-processed into an object during compilation
  // and is always a fresh object, so it's safe to merge into it
  return data.staticStyle
    ? extend(data.staticStyle, style)
    : style
}

// normalize possible array / string values into Object
function normalizeStyleBinding (bindingStyle) {
  if (Array.isArray(bindingStyle)) {
    return toObject(bindingStyle)
  }
  if (typeof bindingStyle === 'string') {
    return parseStyleText(bindingStyle)
  }
  return bindingStyle
}

/**
 * parent component style should be after child's
 * so that parent component's style could override it
 */
function getStyle (vnode, checkChild) {
  var res = {};
  var styleData;

  if (checkChild) {
    var childNode = vnode;
    while (childNode.componentInstance) {
      childNode = childNode.componentInstance._vnode;
      if (
        childNode && childNode.data &&
        (styleData = normalizeStyleData(childNode.data))
      ) {
        extend(res, styleData);
      }
    }
  }

  if ((styleData = normalizeStyleData(vnode.data))) {
    extend(res, styleData);
  }

  var parentNode = vnode;
  while ((parentNode = parentNode.parent)) {
    if (parentNode.data && (styleData = normalizeStyleData(parentNode.data))) {
      extend(res, styleData);
    }
  }
  return res
}

/*  */

var cssVarRE = /^--/;
var importantRE = /\s*!important$/;
var setProp = function (el, name, val) {
  /* istanbul ignore if */
  if (cssVarRE.test(name)) {
    el.style.setProperty(name, val);
  } else if (importantRE.test(val)) {
    el.style.setProperty(hyphenate(name), val.replace(importantRE, ''), 'important');
  } else {
    var normalizedName = normalize(name);
    if (Array.isArray(val)) {
      // Support values array created by autoprefixer, e.g.
      // {display: ["-webkit-box", "-ms-flexbox", "flex"]}
      // Set them one by one, and the browser will only set those it can recognize
      for (var i = 0, len = val.length; i < len; i++) {
        el.style[normalizedName] = val[i];
      }
    } else {
      el.style[normalizedName] = val;
    }
  }
};

var vendorNames = ['Webkit', 'Moz', 'ms'];

var emptyStyle;
var normalize = cached(function (prop) {
  emptyStyle = emptyStyle || document.createElement('div').style;
  prop = camelize(prop);
  if (prop !== 'filter' && (prop in emptyStyle)) {
    return prop
  }
  var capName = prop.charAt(0).toUpperCase() + prop.slice(1);
  for (var i = 0; i < vendorNames.length; i++) {
    var name = vendorNames[i] + capName;
    if (name in emptyStyle) {
      return name
    }
  }
});

function updateStyle (oldVnode, vnode) {
  var data = vnode.data;
  var oldData = oldVnode.data;

  if (isUndef(data.staticStyle) && isUndef(data.style) &&
    isUndef(oldData.staticStyle) && isUndef(oldData.style)
  ) {
    return
  }

  var cur, name;
  var el = vnode.elm;
  var oldStaticStyle = oldData.staticStyle;
  var oldStyleBinding = oldData.normalizedStyle || oldData.style || {};

  // if static style exists, stylebinding already merged into it when doing normalizeStyleData
  var oldStyle = oldStaticStyle || oldStyleBinding;

  var style = normalizeStyleBinding(vnode.data.style) || {};

  // store normalized style under a different key for next diff
  // make sure to clone it if it's reactive, since the user likely wants
  // to mutate it.
  vnode.data.normalizedStyle = isDef(style.__ob__)
    ? extend({}, style)
    : style;

  var newStyle = getStyle(vnode, true);

  for (name in oldStyle) {
    if (isUndef(newStyle[name])) {
      setProp(el, name, '');
    }
  }
  for (name in newStyle) {
    cur = newStyle[name];
    if (cur !== oldStyle[name]) {
      // ie9 setting to null has no effect, must use empty string
      setProp(el, name, cur == null ? '' : cur);
    }
  }
}

var style = {
  create: updateStyle,
  update: updateStyle
};

/*  */

var whitespaceRE = /\s+/;

/**
 * Add class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function addClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.add(c); });
    } else {
      el.classList.add(cls);
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    if (cur.indexOf(' ' + cls + ' ') < 0) {
      el.setAttribute('class', (cur + cls).trim());
    }
  }
}

/**
 * Remove class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function removeClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.remove(c); });
    } else {
      el.classList.remove(cls);
    }
    if (!el.classList.length) {
      el.removeAttribute('class');
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    var tar = ' ' + cls + ' ';
    while (cur.indexOf(tar) >= 0) {
      cur = cur.replace(tar, ' ');
    }
    cur = cur.trim();
    if (cur) {
      el.setAttribute('class', cur);
    } else {
      el.removeAttribute('class');
    }
  }
}

/*  */

function resolveTransition (def$$1) {
  if (!def$$1) {
    return
  }
  /* istanbul ignore else */
  if (typeof def$$1 === 'object') {
    var res = {};
    if (def$$1.css !== false) {
      extend(res, autoCssTransition(def$$1.name || 'v'));
    }
    extend(res, def$$1);
    return res
  } else if (typeof def$$1 === 'string') {
    return autoCssTransition(def$$1)
  }
}

var autoCssTransition = cached(function (name) {
  return {
    enterClass: (name + "-enter"),
    enterToClass: (name + "-enter-to"),
    enterActiveClass: (name + "-enter-active"),
    leaveClass: (name + "-leave"),
    leaveToClass: (name + "-leave-to"),
    leaveActiveClass: (name + "-leave-active")
  }
});

var hasTransition = inBrowser && !isIE9;
var TRANSITION = 'transition';
var ANIMATION = 'animation';

// Transition property/event sniffing
var transitionProp = 'transition';
var transitionEndEvent = 'transitionend';
var animationProp = 'animation';
var animationEndEvent = 'animationend';
if (hasTransition) {
  /* istanbul ignore if */
  if (window.ontransitionend === undefined &&
    window.onwebkittransitionend !== undefined
  ) {
    transitionProp = 'WebkitTransition';
    transitionEndEvent = 'webkitTransitionEnd';
  }
  if (window.onanimationend === undefined &&
    window.onwebkitanimationend !== undefined
  ) {
    animationProp = 'WebkitAnimation';
    animationEndEvent = 'webkitAnimationEnd';
  }
}

// binding to window is necessary to make hot reload work in IE in strict mode
var raf = inBrowser
  ? window.requestAnimationFrame
    ? window.requestAnimationFrame.bind(window)
    : setTimeout
  : /* istanbul ignore next */ function (fn) { return fn(); };

function nextFrame (fn) {
  raf(function () {
    raf(fn);
  });
}

function addTransitionClass (el, cls) {
  var transitionClasses = el._transitionClasses || (el._transitionClasses = []);
  if (transitionClasses.indexOf(cls) < 0) {
    transitionClasses.push(cls);
    addClass(el, cls);
  }
}

function removeTransitionClass (el, cls) {
  if (el._transitionClasses) {
    remove(el._transitionClasses, cls);
  }
  removeClass(el, cls);
}

function whenTransitionEnds (
  el,
  expectedType,
  cb
) {
  var ref = getTransitionInfo(el, expectedType);
  var type = ref.type;
  var timeout = ref.timeout;
  var propCount = ref.propCount;
  if (!type) { return cb() }
  var event = type === TRANSITION ? transitionEndEvent : animationEndEvent;
  var ended = 0;
  var end = function () {
    el.removeEventListener(event, onEnd);
    cb();
  };
  var onEnd = function (e) {
    if (e.target === el) {
      if (++ended >= propCount) {
        end();
      }
    }
  };
  setTimeout(function () {
    if (ended < propCount) {
      end();
    }
  }, timeout + 1);
  el.addEventListener(event, onEnd);
}

var transformRE = /\b(transform|all)(,|$)/;

function getTransitionInfo (el, expectedType) {
  var styles = window.getComputedStyle(el);
  // JSDOM may return undefined for transition properties
  var transitionDelays = (styles[transitionProp + 'Delay'] || '').split(', ');
  var transitionDurations = (styles[transitionProp + 'Duration'] || '').split(', ');
  var transitionTimeout = getTimeout(transitionDelays, transitionDurations);
  var animationDelays = (styles[animationProp + 'Delay'] || '').split(', ');
  var animationDurations = (styles[animationProp + 'Duration'] || '').split(', ');
  var animationTimeout = getTimeout(animationDelays, animationDurations);

  var type;
  var timeout = 0;
  var propCount = 0;
  /* istanbul ignore if */
  if (expectedType === TRANSITION) {
    if (transitionTimeout > 0) {
      type = TRANSITION;
      timeout = transitionTimeout;
      propCount = transitionDurations.length;
    }
  } else if (expectedType === ANIMATION) {
    if (animationTimeout > 0) {
      type = ANIMATION;
      timeout = animationTimeout;
      propCount = animationDurations.length;
    }
  } else {
    timeout = Math.max(transitionTimeout, animationTimeout);
    type = timeout > 0
      ? transitionTimeout > animationTimeout
        ? TRANSITION
        : ANIMATION
      : null;
    propCount = type
      ? type === TRANSITION
        ? transitionDurations.length
        : animationDurations.length
      : 0;
  }
  var hasTransform =
    type === TRANSITION &&
    transformRE.test(styles[transitionProp + 'Property']);
  return {
    type: type,
    timeout: timeout,
    propCount: propCount,
    hasTransform: hasTransform
  }
}

function getTimeout (delays, durations) {
  /* istanbul ignore next */
  while (delays.length < durations.length) {
    delays = delays.concat(delays);
  }

  return Math.max.apply(null, durations.map(function (d, i) {
    return toMs(d) + toMs(delays[i])
  }))
}

// Old versions of Chromium (below 61.0.3163.100) formats floating pointer numbers
// in a locale-dependent way, using a comma instead of a dot.
// If comma is not replaced with a dot, the input will be rounded down (i.e. acting
// as a floor function) causing unexpected behaviors
function toMs (s) {
  return Number(s.slice(0, -1).replace(',', '.')) * 1000
}

/*  */

function enter (vnode, toggleDisplay) {
  var el = vnode.elm;

  // call leave callback now
  if (isDef(el._leaveCb)) {
    el._leaveCb.cancelled = true;
    el._leaveCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data)) {
    return
  }

  /* istanbul ignore if */
  if (isDef(el._enterCb) || el.nodeType !== 1) {
    return
  }

  var css = data.css;
  var type = data.type;
  var enterClass = data.enterClass;
  var enterToClass = data.enterToClass;
  var enterActiveClass = data.enterActiveClass;
  var appearClass = data.appearClass;
  var appearToClass = data.appearToClass;
  var appearActiveClass = data.appearActiveClass;
  var beforeEnter = data.beforeEnter;
  var enter = data.enter;
  var afterEnter = data.afterEnter;
  var enterCancelled = data.enterCancelled;
  var beforeAppear = data.beforeAppear;
  var appear = data.appear;
  var afterAppear = data.afterAppear;
  var appearCancelled = data.appearCancelled;
  var duration = data.duration;

  // activeInstance will always be the <transition> component managing this
  // transition. One edge case to check is when the <transition> is placed
  // as the root node of a child component. In that case we need to check
  // <transition>'s parent for appear check.
  var context = activeInstance;
  var transitionNode = activeInstance.$vnode;
  while (transitionNode && transitionNode.parent) {
    context = transitionNode.context;
    transitionNode = transitionNode.parent;
  }

  var isAppear = !context._isMounted || !vnode.isRootInsert;

  if (isAppear && !appear && appear !== '') {
    return
  }

  var startClass = isAppear && appearClass
    ? appearClass
    : enterClass;
  var activeClass = isAppear && appearActiveClass
    ? appearActiveClass
    : enterActiveClass;
  var toClass = isAppear && appearToClass
    ? appearToClass
    : enterToClass;

  var beforeEnterHook = isAppear
    ? (beforeAppear || beforeEnter)
    : beforeEnter;
  var enterHook = isAppear
    ? (typeof appear === 'function' ? appear : enter)
    : enter;
  var afterEnterHook = isAppear
    ? (afterAppear || afterEnter)
    : afterEnter;
  var enterCancelledHook = isAppear
    ? (appearCancelled || enterCancelled)
    : enterCancelled;

  var explicitEnterDuration = toNumber(
    isObject(duration)
      ? duration.enter
      : duration
  );

  if (false) {
    checkDuration(explicitEnterDuration, 'enter', vnode);
  }

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(enterHook);

  var cb = el._enterCb = once(function () {
    if (expectsCSS) {
      removeTransitionClass(el, toClass);
      removeTransitionClass(el, activeClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, startClass);
      }
      enterCancelledHook && enterCancelledHook(el);
    } else {
      afterEnterHook && afterEnterHook(el);
    }
    el._enterCb = null;
  });

  if (!vnode.data.show) {
    // remove pending leave element on enter by injecting an insert hook
    mergeVNodeHook(vnode, 'insert', function () {
      var parent = el.parentNode;
      var pendingNode = parent && parent._pending && parent._pending[vnode.key];
      if (pendingNode &&
        pendingNode.tag === vnode.tag &&
        pendingNode.elm._leaveCb
      ) {
        pendingNode.elm._leaveCb();
      }
      enterHook && enterHook(el, cb);
    });
  }

  // start enter transition
  beforeEnterHook && beforeEnterHook(el);
  if (expectsCSS) {
    addTransitionClass(el, startClass);
    addTransitionClass(el, activeClass);
    nextFrame(function () {
      removeTransitionClass(el, startClass);
      if (!cb.cancelled) {
        addTransitionClass(el, toClass);
        if (!userWantsControl) {
          if (isValidDuration(explicitEnterDuration)) {
            setTimeout(cb, explicitEnterDuration);
          } else {
            whenTransitionEnds(el, type, cb);
          }
        }
      }
    });
  }

  if (vnode.data.show) {
    toggleDisplay && toggleDisplay();
    enterHook && enterHook(el, cb);
  }

  if (!expectsCSS && !userWantsControl) {
    cb();
  }
}

function leave (vnode, rm) {
  var el = vnode.elm;

  // call enter callback now
  if (isDef(el._enterCb)) {
    el._enterCb.cancelled = true;
    el._enterCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data) || el.nodeType !== 1) {
    return rm()
  }

  /* istanbul ignore if */
  if (isDef(el._leaveCb)) {
    return
  }

  var css = data.css;
  var type = data.type;
  var leaveClass = data.leaveClass;
  var leaveToClass = data.leaveToClass;
  var leaveActiveClass = data.leaveActiveClass;
  var beforeLeave = data.beforeLeave;
  var leave = data.leave;
  var afterLeave = data.afterLeave;
  var leaveCancelled = data.leaveCancelled;
  var delayLeave = data.delayLeave;
  var duration = data.duration;

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(leave);

  var explicitLeaveDuration = toNumber(
    isObject(duration)
      ? duration.leave
      : duration
  );

  if (false) {
    checkDuration(explicitLeaveDuration, 'leave', vnode);
  }

  var cb = el._leaveCb = once(function () {
    if (el.parentNode && el.parentNode._pending) {
      el.parentNode._pending[vnode.key] = null;
    }
    if (expectsCSS) {
      removeTransitionClass(el, leaveToClass);
      removeTransitionClass(el, leaveActiveClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, leaveClass);
      }
      leaveCancelled && leaveCancelled(el);
    } else {
      rm();
      afterLeave && afterLeave(el);
    }
    el._leaveCb = null;
  });

  if (delayLeave) {
    delayLeave(performLeave);
  } else {
    performLeave();
  }

  function performLeave () {
    // the delayed leave may have already been cancelled
    if (cb.cancelled) {
      return
    }
    // record leaving element
    if (!vnode.data.show && el.parentNode) {
      (el.parentNode._pending || (el.parentNode._pending = {}))[(vnode.key)] = vnode;
    }
    beforeLeave && beforeLeave(el);
    if (expectsCSS) {
      addTransitionClass(el, leaveClass);
      addTransitionClass(el, leaveActiveClass);
      nextFrame(function () {
        removeTransitionClass(el, leaveClass);
        if (!cb.cancelled) {
          addTransitionClass(el, leaveToClass);
          if (!userWantsControl) {
            if (isValidDuration(explicitLeaveDuration)) {
              setTimeout(cb, explicitLeaveDuration);
            } else {
              whenTransitionEnds(el, type, cb);
            }
          }
        }
      });
    }
    leave && leave(el, cb);
    if (!expectsCSS && !userWantsControl) {
      cb();
    }
  }
}

// only used in dev mode
function checkDuration (val, name, vnode) {
  if (typeof val !== 'number') {
    warn(
      "<transition> explicit " + name + " duration is not a valid number - " +
      "got " + (JSON.stringify(val)) + ".",
      vnode.context
    );
  } else if (isNaN(val)) {
    warn(
      "<transition> explicit " + name + " duration is NaN - " +
      'the duration expression might be incorrect.',
      vnode.context
    );
  }
}

function isValidDuration (val) {
  return typeof val === 'number' && !isNaN(val)
}

/**
 * Normalize a transition hook's argument length. The hook may be:
 * - a merged hook (invoker) with the original in .fns
 * - a wrapped component method (check ._length)
 * - a plain function (.length)
 */
function getHookArgumentsLength (fn) {
  if (isUndef(fn)) {
    return false
  }
  var invokerFns = fn.fns;
  if (isDef(invokerFns)) {
    // invoker
    return getHookArgumentsLength(
      Array.isArray(invokerFns)
        ? invokerFns[0]
        : invokerFns
    )
  } else {
    return (fn._length || fn.length) > 1
  }
}

function _enter (_, vnode) {
  if (vnode.data.show !== true) {
    enter(vnode);
  }
}

var transition = inBrowser ? {
  create: _enter,
  activate: _enter,
  remove: function remove$$1 (vnode, rm) {
    /* istanbul ignore else */
    if (vnode.data.show !== true) {
      leave(vnode, rm);
    } else {
      rm();
    }
  }
} : {};

var platformModules = [
  attrs,
  klass,
  events,
  domProps,
  style,
  transition
];

/*  */

// the directive module should be applied last, after all
// built-in modules have been applied.
var modules = platformModules.concat(baseModules);

var patch = createPatchFunction({ nodeOps: nodeOps, modules: modules });

/**
 * Not type checking this file because flow doesn't like attaching
 * properties to Elements.
 */

/* istanbul ignore if */
if (isIE9) {
  // http://www.matts411.com/post/internet-explorer-9-oninput/
  document.addEventListener('selectionchange', function () {
    var el = document.activeElement;
    if (el && el.vmodel) {
      trigger(el, 'input');
    }
  });
}

var directive = {
  inserted: function inserted (el, binding, vnode, oldVnode) {
    if (vnode.tag === 'select') {
      // #6903
      if (oldVnode.elm && !oldVnode.elm._vOptions) {
        mergeVNodeHook(vnode, 'postpatch', function () {
          directive.componentUpdated(el, binding, vnode);
        });
      } else {
        setSelected(el, binding, vnode.context);
      }
      el._vOptions = [].map.call(el.options, getValue);
    } else if (vnode.tag === 'textarea' || isTextInputType(el.type)) {
      el._vModifiers = binding.modifiers;
      if (!binding.modifiers.lazy) {
        el.addEventListener('compositionstart', onCompositionStart);
        el.addEventListener('compositionend', onCompositionEnd);
        // Safari < 10.2 & UIWebView doesn't fire compositionend when
        // switching focus before confirming composition choice
        // this also fixes the issue where some browsers e.g. iOS Chrome
        // fires "change" instead of "input" on autocomplete.
        el.addEventListener('change', onCompositionEnd);
        /* istanbul ignore if */
        if (isIE9) {
          el.vmodel = true;
        }
      }
    }
  },

  componentUpdated: function componentUpdated (el, binding, vnode) {
    if (vnode.tag === 'select') {
      setSelected(el, binding, vnode.context);
      // in case the options rendered by v-for have changed,
      // it's possible that the value is out-of-sync with the rendered options.
      // detect such cases and filter out values that no longer has a matching
      // option in the DOM.
      var prevOptions = el._vOptions;
      var curOptions = el._vOptions = [].map.call(el.options, getValue);
      if (curOptions.some(function (o, i) { return !looseEqual(o, prevOptions[i]); })) {
        // trigger change event if
        // no matching option found for at least one value
        var needReset = el.multiple
          ? binding.value.some(function (v) { return hasNoMatchingOption(v, curOptions); })
          : binding.value !== binding.oldValue && hasNoMatchingOption(binding.value, curOptions);
        if (needReset) {
          trigger(el, 'change');
        }
      }
    }
  }
};

function setSelected (el, binding, vm) {
  actuallySetSelected(el, binding, vm);
  /* istanbul ignore if */
  if (isIE || isEdge) {
    setTimeout(function () {
      actuallySetSelected(el, binding, vm);
    }, 0);
  }
}

function actuallySetSelected (el, binding, vm) {
  var value = binding.value;
  var isMultiple = el.multiple;
  if (isMultiple && !Array.isArray(value)) {
    "production" !== 'production' && warn(
      "<select multiple v-model=\"" + (binding.expression) + "\"> " +
      "expects an Array value for its binding, but got " + (Object.prototype.toString.call(value).slice(8, -1)),
      vm
    );
    return
  }
  var selected, option;
  for (var i = 0, l = el.options.length; i < l; i++) {
    option = el.options[i];
    if (isMultiple) {
      selected = looseIndexOf(value, getValue(option)) > -1;
      if (option.selected !== selected) {
        option.selected = selected;
      }
    } else {
      if (looseEqual(getValue(option), value)) {
        if (el.selectedIndex !== i) {
          el.selectedIndex = i;
        }
        return
      }
    }
  }
  if (!isMultiple) {
    el.selectedIndex = -1;
  }
}

function hasNoMatchingOption (value, options) {
  return options.every(function (o) { return !looseEqual(o, value); })
}

function getValue (option) {
  return '_value' in option
    ? option._value
    : option.value
}

function onCompositionStart (e) {
  e.target.composing = true;
}

function onCompositionEnd (e) {
  // prevent triggering an input event for no reason
  if (!e.target.composing) { return }
  e.target.composing = false;
  trigger(e.target, 'input');
}

function trigger (el, type) {
  var e = document.createEvent('HTMLEvents');
  e.initEvent(type, true, true);
  el.dispatchEvent(e);
}

/*  */

// recursively search for possible transition defined inside the component root
function locateNode (vnode) {
  return vnode.componentInstance && (!vnode.data || !vnode.data.transition)
    ? locateNode(vnode.componentInstance._vnode)
    : vnode
}

var show = {
  bind: function bind (el, ref, vnode) {
    var value = ref.value;

    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    var originalDisplay = el.__vOriginalDisplay =
      el.style.display === 'none' ? '' : el.style.display;
    if (value && transition$$1) {
      vnode.data.show = true;
      enter(vnode, function () {
        el.style.display = originalDisplay;
      });
    } else {
      el.style.display = value ? originalDisplay : 'none';
    }
  },

  update: function update (el, ref, vnode) {
    var value = ref.value;
    var oldValue = ref.oldValue;

    /* istanbul ignore if */
    if (!value === !oldValue) { return }
    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    if (transition$$1) {
      vnode.data.show = true;
      if (value) {
        enter(vnode, function () {
          el.style.display = el.__vOriginalDisplay;
        });
      } else {
        leave(vnode, function () {
          el.style.display = 'none';
        });
      }
    } else {
      el.style.display = value ? el.__vOriginalDisplay : 'none';
    }
  },

  unbind: function unbind (
    el,
    binding,
    vnode,
    oldVnode,
    isDestroy
  ) {
    if (!isDestroy) {
      el.style.display = el.__vOriginalDisplay;
    }
  }
};

var platformDirectives = {
  model: directive,
  show: show
};

/*  */

var transitionProps = {
  name: String,
  appear: Boolean,
  css: Boolean,
  mode: String,
  type: String,
  enterClass: String,
  leaveClass: String,
  enterToClass: String,
  leaveToClass: String,
  enterActiveClass: String,
  leaveActiveClass: String,
  appearClass: String,
  appearActiveClass: String,
  appearToClass: String,
  duration: [Number, String, Object]
};

// in case the child is also an abstract component, e.g. <keep-alive>
// we want to recursively retrieve the real component to be rendered
function getRealChild (vnode) {
  var compOptions = vnode && vnode.componentOptions;
  if (compOptions && compOptions.Ctor.options.abstract) {
    return getRealChild(getFirstComponentChild(compOptions.children))
  } else {
    return vnode
  }
}

function extractTransitionData (comp) {
  var data = {};
  var options = comp.$options;
  // props
  for (var key in options.propsData) {
    data[key] = comp[key];
  }
  // events.
  // extract listeners and pass them directly to the transition methods
  var listeners = options._parentListeners;
  for (var key$1 in listeners) {
    data[camelize(key$1)] = listeners[key$1];
  }
  return data
}

function placeholder (h, rawChild) {
  if (/\d-keep-alive$/.test(rawChild.tag)) {
    return h('keep-alive', {
      props: rawChild.componentOptions.propsData
    })
  }
}

function hasParentTransition (vnode) {
  while ((vnode = vnode.parent)) {
    if (vnode.data.transition) {
      return true
    }
  }
}

function isSameChild (child, oldChild) {
  return oldChild.key === child.key && oldChild.tag === child.tag
}

var isNotTextNode = function (c) { return c.tag || isAsyncPlaceholder(c); };

var isVShowDirective = function (d) { return d.name === 'show'; };

var Transition = {
  name: 'transition',
  props: transitionProps,
  abstract: true,

  render: function render (h) {
    var this$1 = this;

    var children = this.$slots.default;
    if (!children) {
      return
    }

    // filter out text nodes (possible whitespaces)
    children = children.filter(isNotTextNode);
    /* istanbul ignore if */
    if (!children.length) {
      return
    }

    // warn multiple elements
    if (false) {
      warn(
        '<transition> can only be used on a single element. Use ' +
        '<transition-group> for lists.',
        this.$parent
      );
    }

    var mode = this.mode;

    // warn invalid mode
    if (false
    ) {
      warn(
        'invalid <transition> mode: ' + mode,
        this.$parent
      );
    }

    var rawChild = children[0];

    // if this is a component root node and the component's
    // parent container node also has transition, skip.
    if (hasParentTransition(this.$vnode)) {
      return rawChild
    }

    // apply transition data to child
    // use getRealChild() to ignore abstract components e.g. keep-alive
    var child = getRealChild(rawChild);
    /* istanbul ignore if */
    if (!child) {
      return rawChild
    }

    if (this._leaving) {
      return placeholder(h, rawChild)
    }

    // ensure a key that is unique to the vnode type and to this transition
    // component instance. This key will be used to remove pending leaving nodes
    // during entering.
    var id = "__transition-" + (this._uid) + "-";
    child.key = child.key == null
      ? child.isComment
        ? id + 'comment'
        : id + child.tag
      : isPrimitive(child.key)
        ? (String(child.key).indexOf(id) === 0 ? child.key : id + child.key)
        : child.key;

    var data = (child.data || (child.data = {})).transition = extractTransitionData(this);
    var oldRawChild = this._vnode;
    var oldChild = getRealChild(oldRawChild);

    // mark v-show
    // so that the transition module can hand over the control to the directive
    if (child.data.directives && child.data.directives.some(isVShowDirective)) {
      child.data.show = true;
    }

    if (
      oldChild &&
      oldChild.data &&
      !isSameChild(child, oldChild) &&
      !isAsyncPlaceholder(oldChild) &&
      // #6687 component root is a comment node
      !(oldChild.componentInstance && oldChild.componentInstance._vnode.isComment)
    ) {
      // replace old child transition data with fresh one
      // important for dynamic transitions!
      var oldData = oldChild.data.transition = extend({}, data);
      // handle transition mode
      if (mode === 'out-in') {
        // return placeholder node and queue update when leave finishes
        this._leaving = true;
        mergeVNodeHook(oldData, 'afterLeave', function () {
          this$1._leaving = false;
          this$1.$forceUpdate();
        });
        return placeholder(h, rawChild)
      } else if (mode === 'in-out') {
        if (isAsyncPlaceholder(child)) {
          return oldRawChild
        }
        var delayedLeave;
        var performLeave = function () { delayedLeave(); };
        mergeVNodeHook(data, 'afterEnter', performLeave);
        mergeVNodeHook(data, 'enterCancelled', performLeave);
        mergeVNodeHook(oldData, 'delayLeave', function (leave) { delayedLeave = leave; });
      }
    }

    return rawChild
  }
};

/*  */

var props = extend({
  tag: String,
  moveClass: String
}, transitionProps);

delete props.mode;

var TransitionGroup = {
  props: props,

  beforeMount: function beforeMount () {
    var this$1 = this;

    var update = this._update;
    this._update = function (vnode, hydrating) {
      var restoreActiveInstance = setActiveInstance(this$1);
      // force removing pass
      this$1.__patch__(
        this$1._vnode,
        this$1.kept,
        false, // hydrating
        true // removeOnly (!important, avoids unnecessary moves)
      );
      this$1._vnode = this$1.kept;
      restoreActiveInstance();
      update.call(this$1, vnode, hydrating);
    };
  },

  render: function render (h) {
    var tag = this.tag || this.$vnode.data.tag || 'span';
    var map = Object.create(null);
    var prevChildren = this.prevChildren = this.children;
    var rawChildren = this.$slots.default || [];
    var children = this.children = [];
    var transitionData = extractTransitionData(this);

    for (var i = 0; i < rawChildren.length; i++) {
      var c = rawChildren[i];
      if (c.tag) {
        if (c.key != null && String(c.key).indexOf('__vlist') !== 0) {
          children.push(c);
          map[c.key] = c
          ;(c.data || (c.data = {})).transition = transitionData;
        } else if (false) {
          var opts = c.componentOptions;
          var name = opts ? (opts.Ctor.options.name || opts.tag || '') : c.tag;
          warn(("<transition-group> children must be keyed: <" + name + ">"));
        }
      }
    }

    if (prevChildren) {
      var kept = [];
      var removed = [];
      for (var i$1 = 0; i$1 < prevChildren.length; i$1++) {
        var c$1 = prevChildren[i$1];
        c$1.data.transition = transitionData;
        c$1.data.pos = c$1.elm.getBoundingClientRect();
        if (map[c$1.key]) {
          kept.push(c$1);
        } else {
          removed.push(c$1);
        }
      }
      this.kept = h(tag, null, kept);
      this.removed = removed;
    }

    return h(tag, null, children)
  },

  updated: function updated () {
    var children = this.prevChildren;
    var moveClass = this.moveClass || ((this.name || 'v') + '-move');
    if (!children.length || !this.hasMove(children[0].elm, moveClass)) {
      return
    }

    // we divide the work into three loops to avoid mixing DOM reads and writes
    // in each iteration - which helps prevent layout thrashing.
    children.forEach(callPendingCbs);
    children.forEach(recordPosition);
    children.forEach(applyTranslation);

    // force reflow to put everything in position
    // assign to this to avoid being removed in tree-shaking
    // $flow-disable-line
    this._reflow = document.body.offsetHeight;

    children.forEach(function (c) {
      if (c.data.moved) {
        var el = c.elm;
        var s = el.style;
        addTransitionClass(el, moveClass);
        s.transform = s.WebkitTransform = s.transitionDuration = '';
        el.addEventListener(transitionEndEvent, el._moveCb = function cb (e) {
          if (e && e.target !== el) {
            return
          }
          if (!e || /transform$/.test(e.propertyName)) {
            el.removeEventListener(transitionEndEvent, cb);
            el._moveCb = null;
            removeTransitionClass(el, moveClass);
          }
        });
      }
    });
  },

  methods: {
    hasMove: function hasMove (el, moveClass) {
      /* istanbul ignore if */
      if (!hasTransition) {
        return false
      }
      /* istanbul ignore if */
      if (this._hasMove) {
        return this._hasMove
      }
      // Detect whether an element with the move class applied has
      // CSS transitions. Since the element may be inside an entering
      // transition at this very moment, we make a clone of it and remove
      // all other transition classes applied to ensure only the move class
      // is applied.
      var clone = el.cloneNode();
      if (el._transitionClasses) {
        el._transitionClasses.forEach(function (cls) { removeClass(clone, cls); });
      }
      addClass(clone, moveClass);
      clone.style.display = 'none';
      this.$el.appendChild(clone);
      var info = getTransitionInfo(clone);
      this.$el.removeChild(clone);
      return (this._hasMove = info.hasTransform)
    }
  }
};

function callPendingCbs (c) {
  /* istanbul ignore if */
  if (c.elm._moveCb) {
    c.elm._moveCb();
  }
  /* istanbul ignore if */
  if (c.elm._enterCb) {
    c.elm._enterCb();
  }
}

function recordPosition (c) {
  c.data.newPos = c.elm.getBoundingClientRect();
}

function applyTranslation (c) {
  var oldPos = c.data.pos;
  var newPos = c.data.newPos;
  var dx = oldPos.left - newPos.left;
  var dy = oldPos.top - newPos.top;
  if (dx || dy) {
    c.data.moved = true;
    var s = c.elm.style;
    s.transform = s.WebkitTransform = "translate(" + dx + "px," + dy + "px)";
    s.transitionDuration = '0s';
  }
}

var platformComponents = {
  Transition: Transition,
  TransitionGroup: TransitionGroup
};

/*  */

// install platform specific utils
Vue.config.mustUseProp = mustUseProp;
Vue.config.isReservedTag = isReservedTag;
Vue.config.isReservedAttr = isReservedAttr;
Vue.config.getTagNamespace = getTagNamespace;
Vue.config.isUnknownElement = isUnknownElement;

// install platform runtime directives & components
extend(Vue.options.directives, platformDirectives);
extend(Vue.options.components, platformComponents);

// install platform patch function
Vue.prototype.__patch__ = inBrowser ? patch : noop;

// public mount method
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && inBrowser ? query(el) : undefined;
  return mountComponent(this, el, hydrating)
};

// devtools global hook
/* istanbul ignore next */
if (inBrowser) {
  setTimeout(function () {
    if (config.devtools) {
      if (devtools) {
        devtools.emit('init', Vue);
      } else if (
        false
      ) {
        console[console.info ? 'info' : 'log'](
          'Download the Vue Devtools extension for a better development experience:\n' +
          'https://github.com/vuejs/vue-devtools'
        );
      }
    }
    if (false
    ) {
      console[console.info ? 'info' : 'log'](
        "You are running Vue in development mode.\n" +
        "Make sure to turn on production mode when deploying for production.\n" +
        "See more tips at https://vuejs.org/guide/deployment.html"
      );
    }
  }, 0);
}

/*  */

var defaultTagRE = /\{\{((?:.|\r?\n)+?)\}\}/g;
var regexEscapeRE = /[-.*+?^${}()|[\]\/\\]/g;

var buildRegex = cached(function (delimiters) {
  var open = delimiters[0].replace(regexEscapeRE, '\\$&');
  var close = delimiters[1].replace(regexEscapeRE, '\\$&');
  return new RegExp(open + '((?:.|\\n)+?)' + close, 'g')
});



function parseText (
  text,
  delimiters
) {
  var tagRE = delimiters ? buildRegex(delimiters) : defaultTagRE;
  if (!tagRE.test(text)) {
    return
  }
  var tokens = [];
  var rawTokens = [];
  var lastIndex = tagRE.lastIndex = 0;
  var match, index, tokenValue;
  while ((match = tagRE.exec(text))) {
    index = match.index;
    // push text token
    if (index > lastIndex) {
      rawTokens.push(tokenValue = text.slice(lastIndex, index));
      tokens.push(JSON.stringify(tokenValue));
    }
    // tag token
    var exp = parseFilters(match[1].trim());
    tokens.push(("_s(" + exp + ")"));
    rawTokens.push({ '@binding': exp });
    lastIndex = index + match[0].length;
  }
  if (lastIndex < text.length) {
    rawTokens.push(tokenValue = text.slice(lastIndex));
    tokens.push(JSON.stringify(tokenValue));
  }
  return {
    expression: tokens.join('+'),
    tokens: rawTokens
  }
}

/*  */

function transformNode (el, options) {
  var warn = options.warn || baseWarn;
  var staticClass = getAndRemoveAttr(el, 'class');
  if (false) {
    var res = parseText(staticClass, options.delimiters);
    if (res) {
      warn(
        "class=\"" + staticClass + "\": " +
        'Interpolation inside attributes has been removed. ' +
        'Use v-bind or the colon shorthand instead. For example, ' +
        'instead of <div class="{{ val }}">, use <div :class="val">.',
        el.rawAttrsMap['class']
      );
    }
  }
  if (staticClass) {
    el.staticClass = JSON.stringify(staticClass);
  }
  var classBinding = getBindingAttr(el, 'class', false /* getStatic */);
  if (classBinding) {
    el.classBinding = classBinding;
  }
}

function genData (el) {
  var data = '';
  if (el.staticClass) {
    data += "staticClass:" + (el.staticClass) + ",";
  }
  if (el.classBinding) {
    data += "class:" + (el.classBinding) + ",";
  }
  return data
}

var klass$1 = {
  staticKeys: ['staticClass'],
  transformNode: transformNode,
  genData: genData
};

/*  */

function transformNode$1 (el, options) {
  var warn = options.warn || baseWarn;
  var staticStyle = getAndRemoveAttr(el, 'style');
  if (staticStyle) {
    /* istanbul ignore if */
    if (false) {
      var res = parseText(staticStyle, options.delimiters);
      if (res) {
        warn(
          "style=\"" + staticStyle + "\": " +
          'Interpolation inside attributes has been removed. ' +
          'Use v-bind or the colon shorthand instead. For example, ' +
          'instead of <div style="{{ val }}">, use <div :style="val">.',
          el.rawAttrsMap['style']
        );
      }
    }
    el.staticStyle = JSON.stringify(parseStyleText(staticStyle));
  }

  var styleBinding = getBindingAttr(el, 'style', false /* getStatic */);
  if (styleBinding) {
    el.styleBinding = styleBinding;
  }
}

function genData$1 (el) {
  var data = '';
  if (el.staticStyle) {
    data += "staticStyle:" + (el.staticStyle) + ",";
  }
  if (el.styleBinding) {
    data += "style:(" + (el.styleBinding) + "),";
  }
  return data
}

var style$1 = {
  staticKeys: ['staticStyle'],
  transformNode: transformNode$1,
  genData: genData$1
};

/*  */

var decoder;

var he = {
  decode: function decode (html) {
    decoder = decoder || document.createElement('div');
    decoder.innerHTML = html;
    return decoder.textContent
  }
};

/*  */

var isUnaryTag = makeMap(
  'area,base,br,col,embed,frame,hr,img,input,isindex,keygen,' +
  'link,meta,param,source,track,wbr'
);

// Elements that you can, intentionally, leave open
// (and which close themselves)
var canBeLeftOpenTag = makeMap(
  'colgroup,dd,dt,li,options,p,td,tfoot,th,thead,tr,source'
);

// HTML5 tags https://html.spec.whatwg.org/multipage/indices.html#elements-3
// Phrasing Content https://html.spec.whatwg.org/multipage/dom.html#phrasing-content
var isNonPhrasingTag = makeMap(
  'address,article,aside,base,blockquote,body,caption,col,colgroup,dd,' +
  'details,dialog,div,dl,dt,fieldset,figcaption,figure,footer,form,' +
  'h1,h2,h3,h4,h5,h6,head,header,hgroup,hr,html,legend,li,menuitem,meta,' +
  'optgroup,option,param,rp,rt,source,style,summary,tbody,td,tfoot,th,thead,' +
  'title,tr,track'
);

/**
 * Not type-checking this file because it's mostly vendor code.
 */

// Regular Expressions for parsing tags and attributes
var attribute = /^\s*([^\s"'<>\/=]+)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var dynamicArgAttribute = /^\s*((?:v-[\w-]+:|@|:|#)\[[^=]+\][^\s"'<>\/=]*)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var ncname = "[a-zA-Z_][\\-\\.0-9_a-zA-Z" + (unicodeRegExp.source) + "]*";
var qnameCapture = "((?:" + ncname + "\\:)?" + ncname + ")";
var startTagOpen = new RegExp(("^<" + qnameCapture));
var startTagClose = /^\s*(\/?)>/;
var endTag = new RegExp(("^<\\/" + qnameCapture + "[^>]*>"));
var doctype = /^<!DOCTYPE [^>]+>/i;
// #7298: escape - to avoid being passed as HTML comment when inlined in page
var comment = /^<!\--/;
var conditionalComment = /^<!\[/;

// Special Elements (can contain anything)
var isPlainTextElement = makeMap('script,style,textarea', true);
var reCache = {};

var decodingMap = {
  '&lt;': '<',
  '&gt;': '>',
  '&quot;': '"',
  '&amp;': '&',
  '&#10;': '\n',
  '&#9;': '\t',
  '&#39;': "'"
};
var encodedAttr = /&(?:lt|gt|quot|amp|#39);/g;
var encodedAttrWithNewLines = /&(?:lt|gt|quot|amp|#39|#10|#9);/g;

// #5992
var isIgnoreNewlineTag = makeMap('pre,textarea', true);
var shouldIgnoreFirstNewline = function (tag, html) { return tag && isIgnoreNewlineTag(tag) && html[0] === '\n'; };

function decodeAttr (value, shouldDecodeNewlines) {
  var re = shouldDecodeNewlines ? encodedAttrWithNewLines : encodedAttr;
  return value.replace(re, function (match) { return decodingMap[match]; })
}

function parseHTML (html, options) {
  var stack = [];
  var expectHTML = options.expectHTML;
  var isUnaryTag$$1 = options.isUnaryTag || no;
  var canBeLeftOpenTag$$1 = options.canBeLeftOpenTag || no;
  var index = 0;
  var last, lastTag;
  while (html) {
    last = html;
    // Make sure we're not in a plaintext content element like script/style
    if (!lastTag || !isPlainTextElement(lastTag)) {
      var textEnd = html.indexOf('<');
      if (textEnd === 0) {
        // Comment:
        if (comment.test(html)) {
          var commentEnd = html.indexOf('-->');

          if (commentEnd >= 0) {
            if (options.shouldKeepComment) {
              options.comment(html.substring(4, commentEnd), index, index + commentEnd + 3);
            }
            advance(commentEnd + 3);
            continue
          }
        }

        // http://en.wikipedia.org/wiki/Conditional_comment#Downlevel-revealed_conditional_comment
        if (conditionalComment.test(html)) {
          var conditionalEnd = html.indexOf(']>');

          if (conditionalEnd >= 0) {
            advance(conditionalEnd + 2);
            continue
          }
        }

        // Doctype:
        var doctypeMatch = html.match(doctype);
        if (doctypeMatch) {
          advance(doctypeMatch[0].length);
          continue
        }

        // End tag:
        var endTagMatch = html.match(endTag);
        if (endTagMatch) {
          var curIndex = index;
          advance(endTagMatch[0].length);
          parseEndTag(endTagMatch[1], curIndex, index);
          continue
        }

        // Start tag:
        var startTagMatch = parseStartTag();
        if (startTagMatch) {
          handleStartTag(startTagMatch);
          if (shouldIgnoreFirstNewline(startTagMatch.tagName, html)) {
            advance(1);
          }
          continue
        }
      }

      var text = (void 0), rest = (void 0), next = (void 0);
      if (textEnd >= 0) {
        rest = html.slice(textEnd);
        while (
          !endTag.test(rest) &&
          !startTagOpen.test(rest) &&
          !comment.test(rest) &&
          !conditionalComment.test(rest)
        ) {
          // < in plain text, be forgiving and treat it as text
          next = rest.indexOf('<', 1);
          if (next < 0) { break }
          textEnd += next;
          rest = html.slice(textEnd);
        }
        text = html.substring(0, textEnd);
      }

      if (textEnd < 0) {
        text = html;
      }

      if (text) {
        advance(text.length);
      }

      if (options.chars && text) {
        options.chars(text, index - text.length, index);
      }
    } else {
      var endTagLength = 0;
      var stackedTag = lastTag.toLowerCase();
      var reStackedTag = reCache[stackedTag] || (reCache[stackedTag] = new RegExp('([\\s\\S]*?)(</' + stackedTag + '[^>]*>)', 'i'));
      var rest$1 = html.replace(reStackedTag, function (all, text, endTag) {
        endTagLength = endTag.length;
        if (!isPlainTextElement(stackedTag) && stackedTag !== 'noscript') {
          text = text
            .replace(/<!\--([\s\S]*?)-->/g, '$1') // #7298
            .replace(/<!\[CDATA\[([\s\S]*?)]]>/g, '$1');
        }
        if (shouldIgnoreFirstNewline(stackedTag, text)) {
          text = text.slice(1);
        }
        if (options.chars) {
          options.chars(text);
        }
        return ''
      });
      index += html.length - rest$1.length;
      html = rest$1;
      parseEndTag(stackedTag, index - endTagLength, index);
    }

    if (html === last) {
      options.chars && options.chars(html);
      if (false) {
        options.warn(("Mal-formatted tag at end of template: \"" + html + "\""), { start: index + html.length });
      }
      break
    }
  }

  // Clean up any remaining tags
  parseEndTag();

  function advance (n) {
    index += n;
    html = html.substring(n);
  }

  function parseStartTag () {
    var start = html.match(startTagOpen);
    if (start) {
      var match = {
        tagName: start[1],
        attrs: [],
        start: index
      };
      advance(start[0].length);
      var end, attr;
      while (!(end = html.match(startTagClose)) && (attr = html.match(dynamicArgAttribute) || html.match(attribute))) {
        attr.start = index;
        advance(attr[0].length);
        attr.end = index;
        match.attrs.push(attr);
      }
      if (end) {
        match.unarySlash = end[1];
        advance(end[0].length);
        match.end = index;
        return match
      }
    }
  }

  function handleStartTag (match) {
    var tagName = match.tagName;
    var unarySlash = match.unarySlash;

    if (expectHTML) {
      if (lastTag === 'p' && isNonPhrasingTag(tagName)) {
        parseEndTag(lastTag);
      }
      if (canBeLeftOpenTag$$1(tagName) && lastTag === tagName) {
        parseEndTag(tagName);
      }
    }

    var unary = isUnaryTag$$1(tagName) || !!unarySlash;

    var l = match.attrs.length;
    var attrs = new Array(l);
    for (var i = 0; i < l; i++) {
      var args = match.attrs[i];
      var value = args[3] || args[4] || args[5] || '';
      var shouldDecodeNewlines = tagName === 'a' && args[1] === 'href'
        ? options.shouldDecodeNewlinesForHref
        : options.shouldDecodeNewlines;
      attrs[i] = {
        name: args[1],
        value: decodeAttr(value, shouldDecodeNewlines)
      };
      if (false) {
        attrs[i].start = args.start + args[0].match(/^\s*/).length;
        attrs[i].end = args.end;
      }
    }

    if (!unary) {
      stack.push({ tag: tagName, lowerCasedTag: tagName.toLowerCase(), attrs: attrs, start: match.start, end: match.end });
      lastTag = tagName;
    }

    if (options.start) {
      options.start(tagName, attrs, unary, match.start, match.end);
    }
  }

  function parseEndTag (tagName, start, end) {
    var pos, lowerCasedTagName;
    if (start == null) { start = index; }
    if (end == null) { end = index; }

    // Find the closest opened tag of the same type
    if (tagName) {
      lowerCasedTagName = tagName.toLowerCase();
      for (pos = stack.length - 1; pos >= 0; pos--) {
        if (stack[pos].lowerCasedTag === lowerCasedTagName) {
          break
        }
      }
    } else {
      // If no tag name is provided, clean shop
      pos = 0;
    }

    if (pos >= 0) {
      // Close all the open elements, up the stack
      for (var i = stack.length - 1; i >= pos; i--) {
        if (false
        ) {
          options.warn(
            ("tag <" + (stack[i].tag) + "> has no matching end tag."),
            { start: stack[i].start, end: stack[i].end }
          );
        }
        if (options.end) {
          options.end(stack[i].tag, start, end);
        }
      }

      // Remove the open elements from the stack
      stack.length = pos;
      lastTag = pos && stack[pos - 1].tag;
    } else if (lowerCasedTagName === 'br') {
      if (options.start) {
        options.start(tagName, [], true, start, end);
      }
    } else if (lowerCasedTagName === 'p') {
      if (options.start) {
        options.start(tagName, [], false, start, end);
      }
      if (options.end) {
        options.end(tagName, start, end);
      }
    }
  }
}

/*  */

var onRE = /^@|^v-on:/;
var dirRE = /^v-|^@|^:|^#/;
var forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
var forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
var stripParensRE = /^\(|\)$/g;
var dynamicArgRE = /^\[.*\]$/;

var argRE = /:(.*)$/;
var bindRE = /^:|^\.|^v-bind:/;
var modifierRE = /\.[^.\]]+(?=[^\]]*$)/g;

var slotRE = /^v-slot(:|$)|^#/;

var lineBreakRE = /[\r\n]/;
var whitespaceRE$1 = /\s+/g;

var invalidAttributeRE = /[\s"'<>\/=]/;

var decodeHTMLCached = cached(he.decode);

var emptySlotScopeToken = "_empty_";

// configurable state
var warn$2;
var delimiters;
var transforms;
var preTransforms;
var postTransforms;
var platformIsPreTag;
var platformMustUseProp;
var platformGetTagNamespace;
var maybeComponent;

function createASTElement (
  tag,
  attrs,
  parent
) {
  return {
    type: 1,
    tag: tag,
    attrsList: attrs,
    attrsMap: makeAttrsMap(attrs),
    rawAttrsMap: {},
    parent: parent,
    children: []
  }
}

/**
 * Convert HTML string to AST.
 */
function parse (
  template,
  options
) {
  warn$2 = options.warn || baseWarn;

  platformIsPreTag = options.isPreTag || no;
  platformMustUseProp = options.mustUseProp || no;
  platformGetTagNamespace = options.getTagNamespace || no;
  var isReservedTag = options.isReservedTag || no;
  maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };

  transforms = pluckModuleFunction(options.modules, 'transformNode');
  preTransforms = pluckModuleFunction(options.modules, 'preTransformNode');
  postTransforms = pluckModuleFunction(options.modules, 'postTransformNode');

  delimiters = options.delimiters;

  var stack = [];
  var preserveWhitespace = options.preserveWhitespace !== false;
  var whitespaceOption = options.whitespace;
  var root;
  var currentParent;
  var inVPre = false;
  var inPre = false;
  var warned = false;

  function warnOnce (msg, range) {
    if (!warned) {
      warned = true;
      warn$2(msg, range);
    }
  }

  function closeElement (element) {
    trimEndingWhitespace(element);
    if (!inVPre && !element.processed) {
      element = processElement(element, options);
    }
    // tree management
    if (!stack.length && element !== root) {
      // allow root elements with v-if, v-else-if and v-else
      if (root.if && (element.elseif || element.else)) {
        if (false) {
          checkRootConstraints(element);
        }
        addIfCondition(root, {
          exp: element.elseif,
          block: element
        });
      } else if (false) {
        warnOnce(
          "Component template should contain exactly one root element. " +
          "If you are using v-if on multiple elements, " +
          "use v-else-if to chain them instead.",
          { start: element.start }
        );
      }
    }
    if (currentParent && !element.forbidden) {
      if (element.elseif || element.else) {
        processIfConditions(element, currentParent);
      } else {
        if (element.slotScope) {
          // scoped slot
          // keep it in the children list so that v-else(-if) conditions can
          // find it as the prev node.
          var name = element.slotTarget || '"default"'
          ;(currentParent.scopedSlots || (currentParent.scopedSlots = {}))[name] = element;
        }
        currentParent.children.push(element);
        element.parent = currentParent;
      }
    }

    // final children cleanup
    // filter out scoped slots
    element.children = element.children.filter(function (c) { return !(c).slotScope; });
    // remove trailing whitespace node again
    trimEndingWhitespace(element);

    // check pre state
    if (element.pre) {
      inVPre = false;
    }
    if (platformIsPreTag(element.tag)) {
      inPre = false;
    }
    // apply post-transforms
    for (var i = 0; i < postTransforms.length; i++) {
      postTransforms[i](element, options);
    }
  }

  function trimEndingWhitespace (el) {
    // remove trailing whitespace node
    if (!inPre) {
      var lastNode;
      while (
        (lastNode = el.children[el.children.length - 1]) &&
        lastNode.type === 3 &&
        lastNode.text === ' '
      ) {
        el.children.pop();
      }
    }
  }

  function checkRootConstraints (el) {
    if (el.tag === 'slot' || el.tag === 'template') {
      warnOnce(
        "Cannot use <" + (el.tag) + "> as component root element because it may " +
        'contain multiple nodes.',
        { start: el.start }
      );
    }
    if (el.attrsMap.hasOwnProperty('v-for')) {
      warnOnce(
        'Cannot use v-for on stateful component root element because ' +
        'it renders multiple elements.',
        el.rawAttrsMap['v-for']
      );
    }
  }

  parseHTML(template, {
    warn: warn$2,
    expectHTML: options.expectHTML,
    isUnaryTag: options.isUnaryTag,
    canBeLeftOpenTag: options.canBeLeftOpenTag,
    shouldDecodeNewlines: options.shouldDecodeNewlines,
    shouldDecodeNewlinesForHref: options.shouldDecodeNewlinesForHref,
    shouldKeepComment: options.comments,
    outputSourceRange: options.outputSourceRange,
    start: function start (tag, attrs, unary, start$1, end) {
      // check namespace.
      // inherit parent ns if there is one
      var ns = (currentParent && currentParent.ns) || platformGetTagNamespace(tag);

      // handle IE svg bug
      /* istanbul ignore if */
      if (isIE && ns === 'svg') {
        attrs = guardIESVGBug(attrs);
      }

      var element = createASTElement(tag, attrs, currentParent);
      if (ns) {
        element.ns = ns;
      }

      if (false) {
        if (options.outputSourceRange) {
          element.start = start$1;
          element.end = end;
          element.rawAttrsMap = element.attrsList.reduce(function (cumulated, attr) {
            cumulated[attr.name] = attr;
            return cumulated
          }, {});
        }
        attrs.forEach(function (attr) {
          if (invalidAttributeRE.test(attr.name)) {
            warn$2(
              "Invalid dynamic argument expression: attribute names cannot contain " +
              "spaces, quotes, <, >, / or =.",
              {
                start: attr.start + attr.name.indexOf("["),
                end: attr.start + attr.name.length
              }
            );
          }
        });
      }

      if (isForbiddenTag(element) && !isServerRendering()) {
        element.forbidden = true;
        "production" !== 'production' && warn$2(
          'Templates should only be responsible for mapping the state to the ' +
          'UI. Avoid placing tags with side-effects in your templates, such as ' +
          "<" + tag + ">" + ', as they will not be parsed.',
          { start: element.start }
        );
      }

      // apply pre-transforms
      for (var i = 0; i < preTransforms.length; i++) {
        element = preTransforms[i](element, options) || element;
      }

      if (!inVPre) {
        processPre(element);
        if (element.pre) {
          inVPre = true;
        }
      }
      if (platformIsPreTag(element.tag)) {
        inPre = true;
      }
      if (inVPre) {
        processRawAttrs(element);
      } else if (!element.processed) {
        // structural directives
        processFor(element);
        processIf(element);
        processOnce(element);
      }

      if (!root) {
        root = element;
        if (false) {
          checkRootConstraints(root);
        }
      }

      if (!unary) {
        currentParent = element;
        stack.push(element);
      } else {
        closeElement(element);
      }
    },

    end: function end (tag, start, end$1) {
      var element = stack[stack.length - 1];
      // pop stack
      stack.length -= 1;
      currentParent = stack[stack.length - 1];
      if (false) {
        element.end = end$1;
      }
      closeElement(element);
    },

    chars: function chars (text, start, end) {
      if (!currentParent) {
        if (false) {
          if (text === template) {
            warnOnce(
              'Component template requires a root element, rather than just text.',
              { start: start }
            );
          } else if ((text = text.trim())) {
            warnOnce(
              ("text \"" + text + "\" outside root element will be ignored."),
              { start: start }
            );
          }
        }
        return
      }
      // IE textarea placeholder bug
      /* istanbul ignore if */
      if (isIE &&
        currentParent.tag === 'textarea' &&
        currentParent.attrsMap.placeholder === text
      ) {
        return
      }
      var children = currentParent.children;
      if (inPre || text.trim()) {
        text = isTextTag(currentParent) ? text : decodeHTMLCached(text);
      } else if (!children.length) {
        // remove the whitespace-only node right after an opening tag
        text = '';
      } else if (whitespaceOption) {
        if (whitespaceOption === 'condense') {
          // in condense mode, remove the whitespace node if it contains
          // line break, otherwise condense to a single space
          text = lineBreakRE.test(text) ? '' : ' ';
        } else {
          text = ' ';
        }
      } else {
        text = preserveWhitespace ? ' ' : '';
      }
      if (text) {
        if (!inPre && whitespaceOption === 'condense') {
          // condense consecutive whitespaces into single space
          text = text.replace(whitespaceRE$1, ' ');
        }
        var res;
        var child;
        if (!inVPre && text !== ' ' && (res = parseText(text, delimiters))) {
          child = {
            type: 2,
            expression: res.expression,
            tokens: res.tokens,
            text: text
          };
        } else if (text !== ' ' || !children.length || children[children.length - 1].text !== ' ') {
          child = {
            type: 3,
            text: text
          };
        }
        if (child) {
          if (false) {
            child.start = start;
            child.end = end;
          }
          children.push(child);
        }
      }
    },
    comment: function comment (text, start, end) {
      // adding anything as a sibling to the root node is forbidden
      // comments should still be allowed, but ignored
      if (currentParent) {
        var child = {
          type: 3,
          text: text,
          isComment: true
        };
        if (false) {
          child.start = start;
          child.end = end;
        }
        currentParent.children.push(child);
      }
    }
  });
  return root
}

function processPre (el) {
  if (getAndRemoveAttr(el, 'v-pre') != null) {
    el.pre = true;
  }
}

function processRawAttrs (el) {
  var list = el.attrsList;
  var len = list.length;
  if (len) {
    var attrs = el.attrs = new Array(len);
    for (var i = 0; i < len; i++) {
      attrs[i] = {
        name: list[i].name,
        value: JSON.stringify(list[i].value)
      };
      if (list[i].start != null) {
        attrs[i].start = list[i].start;
        attrs[i].end = list[i].end;
      }
    }
  } else if (!el.pre) {
    // non root node in pre blocks with no attributes
    el.plain = true;
  }
}

function processElement (
  element,
  options
) {
  processKey(element);

  // determine whether this is a plain element after
  // removing structural attributes
  element.plain = (
    !element.key &&
    !element.scopedSlots &&
    !element.attrsList.length
  );

  processRef(element);
  processSlotContent(element);
  processSlotOutlet(element);
  processComponent(element);
  for (var i = 0; i < transforms.length; i++) {
    element = transforms[i](element, options) || element;
  }
  processAttrs(element);
  return element
}

function processKey (el) {
  var exp = getBindingAttr(el, 'key');
  if (exp) {
    if (false) {
      if (el.tag === 'template') {
        warn$2(
          "<template> cannot be keyed. Place the key on real elements instead.",
          getRawBindingAttr(el, 'key')
        );
      }
      if (el.for) {
        var iterator = el.iterator2 || el.iterator1;
        var parent = el.parent;
        if (iterator && iterator === exp && parent && parent.tag === 'transition-group') {
          warn$2(
            "Do not use v-for index as key on <transition-group> children, " +
            "this is the same as not using keys.",
            getRawBindingAttr(el, 'key'),
            true /* tip */
          );
        }
      }
    }
    el.key = exp;
  }
}

function processRef (el) {
  var ref = getBindingAttr(el, 'ref');
  if (ref) {
    el.ref = ref;
    el.refInFor = checkInFor(el);
  }
}

function processFor (el) {
  var exp;
  if ((exp = getAndRemoveAttr(el, 'v-for'))) {
    var res = parseFor(exp);
    if (res) {
      extend(el, res);
    } else if (false) {
      warn$2(
        ("Invalid v-for expression: " + exp),
        el.rawAttrsMap['v-for']
      );
    }
  }
}



function parseFor (exp) {
  var inMatch = exp.match(forAliasRE);
  if (!inMatch) { return }
  var res = {};
  res.for = inMatch[2].trim();
  var alias = inMatch[1].trim().replace(stripParensRE, '');
  var iteratorMatch = alias.match(forIteratorRE);
  if (iteratorMatch) {
    res.alias = alias.replace(forIteratorRE, '').trim();
    res.iterator1 = iteratorMatch[1].trim();
    if (iteratorMatch[2]) {
      res.iterator2 = iteratorMatch[2].trim();
    }
  } else {
    res.alias = alias;
  }
  return res
}

function processIf (el) {
  var exp = getAndRemoveAttr(el, 'v-if');
  if (exp) {
    el.if = exp;
    addIfCondition(el, {
      exp: exp,
      block: el
    });
  } else {
    if (getAndRemoveAttr(el, 'v-else') != null) {
      el.else = true;
    }
    var elseif = getAndRemoveAttr(el, 'v-else-if');
    if (elseif) {
      el.elseif = elseif;
    }
  }
}

function processIfConditions (el, parent) {
  var prev = findPrevElement(parent.children);
  if (prev && prev.if) {
    addIfCondition(prev, {
      exp: el.elseif,
      block: el
    });
  } else if (false) {
    warn$2(
      "v-" + (el.elseif ? ('else-if="' + el.elseif + '"') : 'else') + " " +
      "used on element <" + (el.tag) + "> without corresponding v-if.",
      el.rawAttrsMap[el.elseif ? 'v-else-if' : 'v-else']
    );
  }
}

function findPrevElement (children) {
  var i = children.length;
  while (i--) {
    if (children[i].type === 1) {
      return children[i]
    } else {
      if (false) {
        warn$2(
          "text \"" + (children[i].text.trim()) + "\" between v-if and v-else(-if) " +
          "will be ignored.",
          children[i]
        );
      }
      children.pop();
    }
  }
}

function addIfCondition (el, condition) {
  if (!el.ifConditions) {
    el.ifConditions = [];
  }
  el.ifConditions.push(condition);
}

function processOnce (el) {
  var once$$1 = getAndRemoveAttr(el, 'v-once');
  if (once$$1 != null) {
    el.once = true;
  }
}

// handle content being passed to a component as slot,
// e.g. <template slot="xxx">, <div slot-scope="xxx">
function processSlotContent (el) {
  var slotScope;
  if (el.tag === 'template') {
    slotScope = getAndRemoveAttr(el, 'scope');
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "the \"scope\" attribute for scoped slots have been deprecated and " +
        "replaced by \"slot-scope\" since 2.5. The new \"slot-scope\" attribute " +
        "can also be used on plain elements in addition to <template> to " +
        "denote scoped slots.",
        el.rawAttrsMap['scope'],
        true
      );
    }
    el.slotScope = slotScope || getAndRemoveAttr(el, 'slot-scope');
  } else if ((slotScope = getAndRemoveAttr(el, 'slot-scope'))) {
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "Ambiguous combined usage of slot-scope and v-for on <" + (el.tag) + "> " +
        "(v-for takes higher priority). Use a wrapper <template> for the " +
        "scoped slot to make it clearer.",
        el.rawAttrsMap['slot-scope'],
        true
      );
    }
    el.slotScope = slotScope;
  }

  // slot="xxx"
  var slotTarget = getBindingAttr(el, 'slot');
  if (slotTarget) {
    el.slotTarget = slotTarget === '""' ? '"default"' : slotTarget;
    el.slotTargetDynamic = !!(el.attrsMap[':slot'] || el.attrsMap['v-bind:slot']);
    // preserve slot as an attribute for native shadow DOM compat
    // only for non-scoped slots.
    if (el.tag !== 'template' && !el.slotScope) {
      addAttr(el, 'slot', slotTarget, getRawBindingAttr(el, 'slot'));
    }
  }

  // 2.6 v-slot syntax
  {
    if (el.tag === 'template') {
      // v-slot on <template>
      var slotBinding = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding) {
        if (false) {
          if (el.slotTarget || el.slotScope) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.parent && !maybeComponent(el.parent)) {
            warn$2(
              "<template v-slot> can only appear at the root level inside " +
              "the receiving component",
              el
            );
          }
        }
        var ref = getSlotName(slotBinding);
        var name = ref.name;
        var dynamic = ref.dynamic;
        el.slotTarget = name;
        el.slotTargetDynamic = dynamic;
        el.slotScope = slotBinding.value || emptySlotScopeToken; // force it into a scoped slot for perf
      }
    } else {
      // v-slot on component, denotes default slot
      var slotBinding$1 = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding$1) {
        if (false) {
          if (!maybeComponent(el)) {
            warn$2(
              "v-slot can only be used on components or <template>.",
              slotBinding$1
            );
          }
          if (el.slotScope || el.slotTarget) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.scopedSlots) {
            warn$2(
              "To avoid scope ambiguity, the default slot should also use " +
              "<template> syntax when there are other named slots.",
              slotBinding$1
            );
          }
        }
        // add the component's children to its default slot
        var slots = el.scopedSlots || (el.scopedSlots = {});
        var ref$1 = getSlotName(slotBinding$1);
        var name$1 = ref$1.name;
        var dynamic$1 = ref$1.dynamic;
        var slotContainer = slots[name$1] = createASTElement('template', [], el);
        slotContainer.slotTarget = name$1;
        slotContainer.slotTargetDynamic = dynamic$1;
        slotContainer.children = el.children.filter(function (c) {
          if (!c.slotScope) {
            c.parent = slotContainer;
            return true
          }
        });
        slotContainer.slotScope = slotBinding$1.value || emptySlotScopeToken;
        // remove children as they are returned from scopedSlots now
        el.children = [];
        // mark el non-plain so data gets generated
        el.plain = false;
      }
    }
  }
}

function getSlotName (binding) {
  var name = binding.name.replace(slotRE, '');
  if (!name) {
    if (binding.name[0] !== '#') {
      name = 'default';
    } else if (false) {
      warn$2(
        "v-slot shorthand syntax requires a slot name.",
        binding
      );
    }
  }
  return dynamicArgRE.test(name)
    // dynamic [name]
    ? { name: name.slice(1, -1), dynamic: true }
    // static name
    : { name: ("\"" + name + "\""), dynamic: false }
}

// handle <slot/> outlets
function processSlotOutlet (el) {
  if (el.tag === 'slot') {
    el.slotName = getBindingAttr(el, 'name');
    if (false) {
      warn$2(
        "`key` does not work on <slot> because slots are abstract outlets " +
        "and can possibly expand into multiple elements. " +
        "Use the key on a wrapping element instead.",
        getRawBindingAttr(el, 'key')
      );
    }
  }
}

function processComponent (el) {
  var binding;
  if ((binding = getBindingAttr(el, 'is'))) {
    el.component = binding;
  }
  if (getAndRemoveAttr(el, 'inline-template') != null) {
    el.inlineTemplate = true;
  }
}

function processAttrs (el) {
  var list = el.attrsList;
  var i, l, name, rawName, value, modifiers, syncGen, isDynamic;
  for (i = 0, l = list.length; i < l; i++) {
    name = rawName = list[i].name;
    value = list[i].value;
    if (dirRE.test(name)) {
      // mark element as dynamic
      el.hasBindings = true;
      // modifiers
      modifiers = parseModifiers(name.replace(dirRE, ''));
      // support .foo shorthand syntax for the .prop modifier
      if (modifiers) {
        name = name.replace(modifierRE, '');
      }
      if (bindRE.test(name)) { // v-bind
        name = name.replace(bindRE, '');
        value = parseFilters(value);
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        if (
          false
        ) {
          warn$2(
            ("The value for a v-bind expression cannot be empty. Found in \"v-bind:" + name + "\"")
          );
        }
        if (modifiers) {
          if (modifiers.prop && !isDynamic) {
            name = camelize(name);
            if (name === 'innerHtml') { name = 'innerHTML'; }
          }
          if (modifiers.camel && !isDynamic) {
            name = camelize(name);
          }
          if (modifiers.sync) {
            syncGen = genAssignmentCode(value, "$event");
            if (!isDynamic) {
              addHandler(
                el,
                ("update:" + (camelize(name))),
                syncGen,
                null,
                false,
                warn$2,
                list[i]
              );
              if (hyphenate(name) !== camelize(name)) {
                addHandler(
                  el,
                  ("update:" + (hyphenate(name))),
                  syncGen,
                  null,
                  false,
                  warn$2,
                  list[i]
                );
              }
            } else {
              // handler w/ dynamic event name
              addHandler(
                el,
                ("\"update:\"+(" + name + ")"),
                syncGen,
                null,
                false,
                warn$2,
                list[i],
                true // dynamic
              );
            }
          }
        }
        if ((modifiers && modifiers.prop) || (
          !el.component && platformMustUseProp(el.tag, el.attrsMap.type, name)
        )) {
          addProp(el, name, value, list[i], isDynamic);
        } else {
          addAttr(el, name, value, list[i], isDynamic);
        }
      } else if (onRE.test(name)) { // v-on
        name = name.replace(onRE, '');
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        addHandler(el, name, value, modifiers, false, warn$2, list[i], isDynamic);
      } else { // normal directives
        name = name.replace(dirRE, '');
        // parse arg
        var argMatch = name.match(argRE);
        var arg = argMatch && argMatch[1];
        isDynamic = false;
        if (arg) {
          name = name.slice(0, -(arg.length + 1));
          if (dynamicArgRE.test(arg)) {
            arg = arg.slice(1, -1);
            isDynamic = true;
          }
        }
        addDirective(el, name, rawName, value, arg, isDynamic, modifiers, list[i]);
        if (false) {
          checkForAliasModel(el, value);
        }
      }
    } else {
      // literal attribute
      if (false) {
        var res = parseText(value, delimiters);
        if (res) {
          warn$2(
            name + "=\"" + value + "\": " +
            'Interpolation inside attributes has been removed. ' +
            'Use v-bind or the colon shorthand instead. For example, ' +
            'instead of <div id="{{ val }}">, use <div :id="val">.',
            list[i]
          );
        }
      }
      addAttr(el, name, JSON.stringify(value), list[i]);
      // #6887 firefox doesn't update muted state if set via attribute
      // even immediately after element creation
      if (!el.component &&
          name === 'muted' &&
          platformMustUseProp(el.tag, el.attrsMap.type, name)) {
        addProp(el, name, 'true', list[i]);
      }
    }
  }
}

function checkInFor (el) {
  var parent = el;
  while (parent) {
    if (parent.for !== undefined) {
      return true
    }
    parent = parent.parent;
  }
  return false
}

function parseModifiers (name) {
  var match = name.match(modifierRE);
  if (match) {
    var ret = {};
    match.forEach(function (m) { ret[m.slice(1)] = true; });
    return ret
  }
}

function makeAttrsMap (attrs) {
  var map = {};
  for (var i = 0, l = attrs.length; i < l; i++) {
    if (
      false
    ) {
      warn$2('duplicate attribute: ' + attrs[i].name, attrs[i]);
    }
    map[attrs[i].name] = attrs[i].value;
  }
  return map
}

// for script (e.g. type="x/template") or style, do not decode content
function isTextTag (el) {
  return el.tag === 'script' || el.tag === 'style'
}

function isForbiddenTag (el) {
  return (
    el.tag === 'style' ||
    (el.tag === 'script' && (
      !el.attrsMap.type ||
      el.attrsMap.type === 'text/javascript'
    ))
  )
}

var ieNSBug = /^xmlns:NS\d+/;
var ieNSPrefix = /^NS\d+:/;

/* istanbul ignore next */
function guardIESVGBug (attrs) {
  var res = [];
  for (var i = 0; i < attrs.length; i++) {
    var attr = attrs[i];
    if (!ieNSBug.test(attr.name)) {
      attr.name = attr.name.replace(ieNSPrefix, '');
      res.push(attr);
    }
  }
  return res
}

function checkForAliasModel (el, value) {
  var _el = el;
  while (_el) {
    if (_el.for && _el.alias === value) {
      warn$2(
        "<" + (el.tag) + " v-model=\"" + value + "\">: " +
        "You are binding v-model directly to a v-for iteration alias. " +
        "This will not be able to modify the v-for source array because " +
        "writing to the alias is like modifying a function local variable. " +
        "Consider using an array of objects and use v-model on an object property instead.",
        el.rawAttrsMap['v-model']
      );
    }
    _el = _el.parent;
  }
}

/*  */

function preTransformNode (el, options) {
  if (el.tag === 'input') {
    var map = el.attrsMap;
    if (!map['v-model']) {
      return
    }

    var typeBinding;
    if (map[':type'] || map['v-bind:type']) {
      typeBinding = getBindingAttr(el, 'type');
    }
    if (!map.type && !typeBinding && map['v-bind']) {
      typeBinding = "(" + (map['v-bind']) + ").type";
    }

    if (typeBinding) {
      var ifCondition = getAndRemoveAttr(el, 'v-if', true);
      var ifConditionExtra = ifCondition ? ("&&(" + ifCondition + ")") : "";
      var hasElse = getAndRemoveAttr(el, 'v-else', true) != null;
      var elseIfCondition = getAndRemoveAttr(el, 'v-else-if', true);
      // 1. checkbox
      var branch0 = cloneASTElement(el);
      // process for on the main node
      processFor(branch0);
      addRawAttr(branch0, 'type', 'checkbox');
      processElement(branch0, options);
      branch0.processed = true; // prevent it from double-processed
      branch0.if = "(" + typeBinding + ")==='checkbox'" + ifConditionExtra;
      addIfCondition(branch0, {
        exp: branch0.if,
        block: branch0
      });
      // 2. add radio else-if condition
      var branch1 = cloneASTElement(el);
      getAndRemoveAttr(branch1, 'v-for', true);
      addRawAttr(branch1, 'type', 'radio');
      processElement(branch1, options);
      addIfCondition(branch0, {
        exp: "(" + typeBinding + ")==='radio'" + ifConditionExtra,
        block: branch1
      });
      // 3. other
      var branch2 = cloneASTElement(el);
      getAndRemoveAttr(branch2, 'v-for', true);
      addRawAttr(branch2, ':type', typeBinding);
      processElement(branch2, options);
      addIfCondition(branch0, {
        exp: ifCondition,
        block: branch2
      });

      if (hasElse) {
        branch0.else = true;
      } else if (elseIfCondition) {
        branch0.elseif = elseIfCondition;
      }

      return branch0
    }
  }
}

function cloneASTElement (el) {
  return createASTElement(el.tag, el.attrsList.slice(), el.parent)
}

var model$1 = {
  preTransformNode: preTransformNode
};

var modules$1 = [
  klass$1,
  style$1,
  model$1
];

/*  */

function text (el, dir) {
  if (dir.value) {
    addProp(el, 'textContent', ("_s(" + (dir.value) + ")"), dir);
  }
}

/*  */

function html (el, dir) {
  if (dir.value) {
    addProp(el, 'innerHTML', ("_s(" + (dir.value) + ")"), dir);
  }
}

var directives$1 = {
  model: model,
  text: text,
  html: html
};

/*  */

var baseOptions = {
  expectHTML: true,
  modules: modules$1,
  directives: directives$1,
  isPreTag: isPreTag,
  isUnaryTag: isUnaryTag,
  mustUseProp: mustUseProp,
  canBeLeftOpenTag: canBeLeftOpenTag,
  isReservedTag: isReservedTag,
  getTagNamespace: getTagNamespace,
  staticKeys: genStaticKeys(modules$1)
};

/*  */

var isStaticKey;
var isPlatformReservedTag;

var genStaticKeysCached = cached(genStaticKeys$1);

/**
 * Goal of the optimizer: walk the generated template AST tree
 * and detect sub-trees that are purely static, i.e. parts of
 * the DOM that never needs to change.
 *
 * Once we detect these sub-trees, we can:
 *
 * 1. Hoist them into constants, so that we no longer need to
 *    create fresh nodes for them on each re-render;
 * 2. Completely skip them in the patching process.
 */
function optimize (root, options) {
  if (!root) { return }
  isStaticKey = genStaticKeysCached(options.staticKeys || '');
  isPlatformReservedTag = options.isReservedTag || no;
  // first pass: mark all non-static nodes.
  markStatic$1(root);
  // second pass: mark static roots.
  markStaticRoots(root, false);
}

function genStaticKeys$1 (keys) {
  return makeMap(
    'type,tag,attrsList,attrsMap,plain,parent,children,attrs,start,end,rawAttrsMap' +
    (keys ? ',' + keys : '')
  )
}

function markStatic$1 (node) {
  node.static = isStatic(node);
  if (node.type === 1) {
    // do not make component slot content static. this avoids
    // 1. components not able to mutate slot nodes
    // 2. static slot content fails for hot-reloading
    if (
      !isPlatformReservedTag(node.tag) &&
      node.tag !== 'slot' &&
      node.attrsMap['inline-template'] == null
    ) {
      return
    }
    for (var i = 0, l = node.children.length; i < l; i++) {
      var child = node.children[i];
      markStatic$1(child);
      if (!child.static) {
        node.static = false;
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        var block = node.ifConditions[i$1].block;
        markStatic$1(block);
        if (!block.static) {
          node.static = false;
        }
      }
    }
  }
}

function markStaticRoots (node, isInFor) {
  if (node.type === 1) {
    if (node.static || node.once) {
      node.staticInFor = isInFor;
    }
    // For a node to qualify as a static root, it should have children that
    // are not just static text. Otherwise the cost of hoisting out will
    // outweigh the benefits and it's better off to just always render it fresh.
    if (node.static && node.children.length && !(
      node.children.length === 1 &&
      node.children[0].type === 3
    )) {
      node.staticRoot = true;
      return
    } else {
      node.staticRoot = false;
    }
    if (node.children) {
      for (var i = 0, l = node.children.length; i < l; i++) {
        markStaticRoots(node.children[i], isInFor || !!node.for);
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        markStaticRoots(node.ifConditions[i$1].block, isInFor);
      }
    }
  }
}

function isStatic (node) {
  if (node.type === 2) { // expression
    return false
  }
  if (node.type === 3) { // text
    return true
  }
  return !!(node.pre || (
    !node.hasBindings && // no dynamic bindings
    !node.if && !node.for && // not v-if or v-for or v-else
    !isBuiltInTag(node.tag) && // not a built-in
    isPlatformReservedTag(node.tag) && // not a component
    !isDirectChildOfTemplateFor(node) &&
    Object.keys(node).every(isStaticKey)
  ))
}

function isDirectChildOfTemplateFor (node) {
  while (node.parent) {
    node = node.parent;
    if (node.tag !== 'template') {
      return false
    }
    if (node.for) {
      return true
    }
  }
  return false
}

/*  */

var fnExpRE = /^([\w$_]+|\([^)]*?\))\s*=>|^function(?:\s+[\w$]+)?\s*\(/;
var fnInvokeRE = /\([^)]*?\);*$/;
var simplePathRE = /^[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*|\['[^']*?']|\["[^"]*?"]|\[\d+]|\[[A-Za-z_$][\w$]*])*$/;

// KeyboardEvent.keyCode aliases
var keyCodes = {
  esc: 27,
  tab: 9,
  enter: 13,
  space: 32,
  up: 38,
  left: 37,
  right: 39,
  down: 40,
  'delete': [8, 46]
};

// KeyboardEvent.key aliases
var keyNames = {
  // #7880: IE11 and Edge use `Esc` for Escape key name.
  esc: ['Esc', 'Escape'],
  tab: 'Tab',
  enter: 'Enter',
  // #9112: IE11 uses `Spacebar` for Space key name.
  space: [' ', 'Spacebar'],
  // #7806: IE11 uses key names without `Arrow` prefix for arrow keys.
  up: ['Up', 'ArrowUp'],
  left: ['Left', 'ArrowLeft'],
  right: ['Right', 'ArrowRight'],
  down: ['Down', 'ArrowDown'],
  // #9112: IE11 uses `Del` for Delete key name.
  'delete': ['Backspace', 'Delete', 'Del']
};

// #4868: modifiers that prevent the execution of the listener
// need to explicitly return null so that we can determine whether to remove
// the listener for .once
var genGuard = function (condition) { return ("if(" + condition + ")return null;"); };

var modifierCode = {
  stop: '$event.stopPropagation();',
  prevent: '$event.preventDefault();',
  self: genGuard("$event.target !== $event.currentTarget"),
  ctrl: genGuard("!$event.ctrlKey"),
  shift: genGuard("!$event.shiftKey"),
  alt: genGuard("!$event.altKey"),
  meta: genGuard("!$event.metaKey"),
  left: genGuard("'button' in $event && $event.button !== 0"),
  middle: genGuard("'button' in $event && $event.button !== 1"),
  right: genGuard("'button' in $event && $event.button !== 2")
};

function genHandlers (
  events,
  isNative
) {
  var prefix = isNative ? 'nativeOn:' : 'on:';
  var staticHandlers = "";
  var dynamicHandlers = "";
  for (var name in events) {
    var handlerCode = genHandler(events[name]);
    if (events[name] && events[name].dynamic) {
      dynamicHandlers += name + "," + handlerCode + ",";
    } else {
      staticHandlers += "\"" + name + "\":" + handlerCode + ",";
    }
  }
  staticHandlers = "{" + (staticHandlers.slice(0, -1)) + "}";
  if (dynamicHandlers) {
    return prefix + "_d(" + staticHandlers + ",[" + (dynamicHandlers.slice(0, -1)) + "])"
  } else {
    return prefix + staticHandlers
  }
}

function genHandler (handler) {
  if (!handler) {
    return 'function(){}'
  }

  if (Array.isArray(handler)) {
    return ("[" + (handler.map(function (handler) { return genHandler(handler); }).join(',')) + "]")
  }

  var isMethodPath = simplePathRE.test(handler.value);
  var isFunctionExpression = fnExpRE.test(handler.value);
  var isFunctionInvocation = simplePathRE.test(handler.value.replace(fnInvokeRE, ''));

  if (!handler.modifiers) {
    if (isMethodPath || isFunctionExpression) {
      return handler.value
    }
    return ("function($event){" + (isFunctionInvocation ? ("return " + (handler.value)) : handler.value) + "}") // inline statement
  } else {
    var code = '';
    var genModifierCode = '';
    var keys = [];
    for (var key in handler.modifiers) {
      if (modifierCode[key]) {
        genModifierCode += modifierCode[key];
        // left/right
        if (keyCodes[key]) {
          keys.push(key);
        }
      } else if (key === 'exact') {
        var modifiers = (handler.modifiers);
        genModifierCode += genGuard(
          ['ctrl', 'shift', 'alt', 'meta']
            .filter(function (keyModifier) { return !modifiers[keyModifier]; })
            .map(function (keyModifier) { return ("$event." + keyModifier + "Key"); })
            .join('||')
        );
      } else {
        keys.push(key);
      }
    }
    if (keys.length) {
      code += genKeyFilter(keys);
    }
    // Make sure modifiers like prevent and stop get executed after key filtering
    if (genModifierCode) {
      code += genModifierCode;
    }
    var handlerCode = isMethodPath
      ? ("return " + (handler.value) + "($event)")
      : isFunctionExpression
        ? ("return (" + (handler.value) + ")($event)")
        : isFunctionInvocation
          ? ("return " + (handler.value))
          : handler.value;
    return ("function($event){" + code + handlerCode + "}")
  }
}

function genKeyFilter (keys) {
  return (
    // make sure the key filters only apply to KeyboardEvents
    // #9441: can't use 'keyCode' in $event because Chrome autofill fires fake
    // key events that do not have keyCode property...
    "if(!$event.type.indexOf('key')&&" +
    (keys.map(genFilterCode).join('&&')) + ")return null;"
  )
}

function genFilterCode (key) {
  var keyVal = parseInt(key, 10);
  if (keyVal) {
    return ("$event.keyCode!==" + keyVal)
  }
  var keyCode = keyCodes[key];
  var keyName = keyNames[key];
  return (
    "_k($event.keyCode," +
    (JSON.stringify(key)) + "," +
    (JSON.stringify(keyCode)) + "," +
    "$event.key," +
    "" + (JSON.stringify(keyName)) +
    ")"
  )
}

/*  */

function on (el, dir) {
  if (false) {
    warn("v-on without argument does not support modifiers.");
  }
  el.wrapListeners = function (code) { return ("_g(" + code + "," + (dir.value) + ")"); };
}

/*  */

function bind$1 (el, dir) {
  el.wrapData = function (code) {
    return ("_b(" + code + ",'" + (el.tag) + "'," + (dir.value) + "," + (dir.modifiers && dir.modifiers.prop ? 'true' : 'false') + (dir.modifiers && dir.modifiers.sync ? ',true' : '') + ")")
  };
}

/*  */

var baseDirectives = {
  on: on,
  bind: bind$1,
  cloak: noop
};

/*  */





var CodegenState = function CodegenState (options) {
  this.options = options;
  this.warn = options.warn || baseWarn;
  this.transforms = pluckModuleFunction(options.modules, 'transformCode');
  this.dataGenFns = pluckModuleFunction(options.modules, 'genData');
  this.directives = extend(extend({}, baseDirectives), options.directives);
  var isReservedTag = options.isReservedTag || no;
  this.maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };
  this.onceId = 0;
  this.staticRenderFns = [];
  this.pre = false;
};



function generate (
  ast,
  options
) {
  var state = new CodegenState(options);
  var code = ast ? genElement(ast, state) : '_c("div")';
  return {
    render: ("with(this){return " + code + "}"),
    staticRenderFns: state.staticRenderFns
  }
}

function genElement (el, state) {
  if (el.parent) {
    el.pre = el.pre || el.parent.pre;
  }

  if (el.staticRoot && !el.staticProcessed) {
    return genStatic(el, state)
  } else if (el.once && !el.onceProcessed) {
    return genOnce(el, state)
  } else if (el.for && !el.forProcessed) {
    return genFor(el, state)
  } else if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.tag === 'template' && !el.slotTarget && !state.pre) {
    return genChildren(el, state) || 'void 0'
  } else if (el.tag === 'slot') {
    return genSlot(el, state)
  } else {
    // component or element
    var code;
    if (el.component) {
      code = genComponent(el.component, el, state);
    } else {
      var data;
      if (!el.plain || (el.pre && state.maybeComponent(el))) {
        data = genData$2(el, state);
      }

      var children = el.inlineTemplate ? null : genChildren(el, state, true);
      code = "_c('" + (el.tag) + "'" + (data ? ("," + data) : '') + (children ? ("," + children) : '') + ")";
    }
    // module transforms
    for (var i = 0; i < state.transforms.length; i++) {
      code = state.transforms[i](el, code);
    }
    return code
  }
}

// hoist static sub-trees out
function genStatic (el, state) {
  el.staticProcessed = true;
  // Some elements (templates) need to behave differently inside of a v-pre
  // node.  All pre nodes are static roots, so we can use this as a location to
  // wrap a state change and reset it upon exiting the pre node.
  var originalPreState = state.pre;
  if (el.pre) {
    state.pre = el.pre;
  }
  state.staticRenderFns.push(("with(this){return " + (genElement(el, state)) + "}"));
  state.pre = originalPreState;
  return ("_m(" + (state.staticRenderFns.length - 1) + (el.staticInFor ? ',true' : '') + ")")
}

// v-once
function genOnce (el, state) {
  el.onceProcessed = true;
  if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.staticInFor) {
    var key = '';
    var parent = el.parent;
    while (parent) {
      if (parent.for) {
        key = parent.key;
        break
      }
      parent = parent.parent;
    }
    if (!key) {
      "production" !== 'production' && state.warn(
        "v-once can only be used inside v-for that is keyed. ",
        el.rawAttrsMap['v-once']
      );
      return genElement(el, state)
    }
    return ("_o(" + (genElement(el, state)) + "," + (state.onceId++) + "," + key + ")")
  } else {
    return genStatic(el, state)
  }
}

function genIf (
  el,
  state,
  altGen,
  altEmpty
) {
  el.ifProcessed = true; // avoid recursion
  return genIfConditions(el.ifConditions.slice(), state, altGen, altEmpty)
}

function genIfConditions (
  conditions,
  state,
  altGen,
  altEmpty
) {
  if (!conditions.length) {
    return altEmpty || '_e()'
  }

  var condition = conditions.shift();
  if (condition.exp) {
    return ("(" + (condition.exp) + ")?" + (genTernaryExp(condition.block)) + ":" + (genIfConditions(conditions, state, altGen, altEmpty)))
  } else {
    return ("" + (genTernaryExp(condition.block)))
  }

  // v-if with v-once should generate code like (a)?_m(0):_m(1)
  function genTernaryExp (el) {
    return altGen
      ? altGen(el, state)
      : el.once
        ? genOnce(el, state)
        : genElement(el, state)
  }
}

function genFor (
  el,
  state,
  altGen,
  altHelper
) {
  var exp = el.for;
  var alias = el.alias;
  var iterator1 = el.iterator1 ? ("," + (el.iterator1)) : '';
  var iterator2 = el.iterator2 ? ("," + (el.iterator2)) : '';

  if (false
  ) {
    state.warn(
      "<" + (el.tag) + " v-for=\"" + alias + " in " + exp + "\">: component lists rendered with " +
      "v-for should have explicit keys. " +
      "See https://vuejs.org/guide/list.html#key for more info.",
      el.rawAttrsMap['v-for'],
      true /* tip */
    );
  }

  el.forProcessed = true; // avoid recursion
  return (altHelper || '_l') + "((" + exp + ")," +
    "function(" + alias + iterator1 + iterator2 + "){" +
      "return " + ((altGen || genElement)(el, state)) +
    '})'
}

function genData$2 (el, state) {
  var data = '{';

  // directives first.
  // directives may mutate the el's other properties before they are generated.
  var dirs = genDirectives(el, state);
  if (dirs) { data += dirs + ','; }

  // key
  if (el.key) {
    data += "key:" + (el.key) + ",";
  }
  // ref
  if (el.ref) {
    data += "ref:" + (el.ref) + ",";
  }
  if (el.refInFor) {
    data += "refInFor:true,";
  }
  // pre
  if (el.pre) {
    data += "pre:true,";
  }
  // record original tag name for components using "is" attribute
  if (el.component) {
    data += "tag:\"" + (el.tag) + "\",";
  }
  // module data generation functions
  for (var i = 0; i < state.dataGenFns.length; i++) {
    data += state.dataGenFns[i](el);
  }
  // attributes
  if (el.attrs) {
    data += "attrs:" + (genProps(el.attrs)) + ",";
  }
  // DOM props
  if (el.props) {
    data += "domProps:" + (genProps(el.props)) + ",";
  }
  // event handlers
  if (el.events) {
    data += (genHandlers(el.events, false)) + ",";
  }
  if (el.nativeEvents) {
    data += (genHandlers(el.nativeEvents, true)) + ",";
  }
  // slot target
  // only for non-scoped slots
  if (el.slotTarget && !el.slotScope) {
    data += "slot:" + (el.slotTarget) + ",";
  }
  // scoped slots
  if (el.scopedSlots) {
    data += (genScopedSlots(el, el.scopedSlots, state)) + ",";
  }
  // component v-model
  if (el.model) {
    data += "model:{value:" + (el.model.value) + ",callback:" + (el.model.callback) + ",expression:" + (el.model.expression) + "},";
  }
  // inline-template
  if (el.inlineTemplate) {
    var inlineTemplate = genInlineTemplate(el, state);
    if (inlineTemplate) {
      data += inlineTemplate + ",";
    }
  }
  data = data.replace(/,$/, '') + '}';
  // v-bind dynamic argument wrap
  // v-bind with dynamic arguments must be applied using the same v-bind object
  // merge helper so that class/style/mustUseProp attrs are handled correctly.
  if (el.dynamicAttrs) {
    data = "_b(" + data + ",\"" + (el.tag) + "\"," + (genProps(el.dynamicAttrs)) + ")";
  }
  // v-bind data wrap
  if (el.wrapData) {
    data = el.wrapData(data);
  }
  // v-on data wrap
  if (el.wrapListeners) {
    data = el.wrapListeners(data);
  }
  return data
}

function genDirectives (el, state) {
  var dirs = el.directives;
  if (!dirs) { return }
  var res = 'directives:[';
  var hasRuntime = false;
  var i, l, dir, needRuntime;
  for (i = 0, l = dirs.length; i < l; i++) {
    dir = dirs[i];
    needRuntime = true;
    var gen = state.directives[dir.name];
    if (gen) {
      // compile-time directive that manipulates AST.
      // returns true if it also needs a runtime counterpart.
      needRuntime = !!gen(el, dir, state.warn);
    }
    if (needRuntime) {
      hasRuntime = true;
      res += "{name:\"" + (dir.name) + "\",rawName:\"" + (dir.rawName) + "\"" + (dir.value ? (",value:(" + (dir.value) + "),expression:" + (JSON.stringify(dir.value))) : '') + (dir.arg ? (",arg:" + (dir.isDynamicArg ? dir.arg : ("\"" + (dir.arg) + "\""))) : '') + (dir.modifiers ? (",modifiers:" + (JSON.stringify(dir.modifiers))) : '') + "},";
    }
  }
  if (hasRuntime) {
    return res.slice(0, -1) + ']'
  }
}

function genInlineTemplate (el, state) {
  var ast = el.children[0];
  if (false) {
    state.warn(
      'Inline-template components must have exactly one child element.',
      { start: el.start }
    );
  }
  if (ast && ast.type === 1) {
    var inlineRenderFns = generate(ast, state.options);
    return ("inlineTemplate:{render:function(){" + (inlineRenderFns.render) + "},staticRenderFns:[" + (inlineRenderFns.staticRenderFns.map(function (code) { return ("function(){" + code + "}"); }).join(',')) + "]}")
  }
}

function genScopedSlots (
  el,
  slots,
  state
) {
  // by default scoped slots are considered "stable", this allows child
  // components with only scoped slots to skip forced updates from parent.
  // but in some cases we have to bail-out of this optimization
  // for example if the slot contains dynamic names, has v-if or v-for on them...
  var needsForceUpdate = el.for || Object.keys(slots).some(function (key) {
    var slot = slots[key];
    return (
      slot.slotTargetDynamic ||
      slot.if ||
      slot.for ||
      containsSlotChild(slot) // is passing down slot from parent which may be dynamic
    )
  });

  // #9534: if a component with scoped slots is inside a conditional branch,
  // it's possible for the same component to be reused but with different
  // compiled slot content. To avoid that, we generate a unique key based on
  // the generated code of all the slot contents.
  var needsKey = !!el.if;

  // OR when it is inside another scoped slot or v-for (the reactivity may be
  // disconnected due to the intermediate scope variable)
  // #9438, #9506
  // TODO: this can be further optimized by properly analyzing in-scope bindings
  // and skip force updating ones that do not actually use scope variables.
  if (!needsForceUpdate) {
    var parent = el.parent;
    while (parent) {
      if (
        (parent.slotScope && parent.slotScope !== emptySlotScopeToken) ||
        parent.for
      ) {
        needsForceUpdate = true;
        break
      }
      if (parent.if) {
        needsKey = true;
      }
      parent = parent.parent;
    }
  }

  var generatedSlots = Object.keys(slots)
    .map(function (key) { return genScopedSlot(slots[key], state); })
    .join(',');

  return ("scopedSlots:_u([" + generatedSlots + "]" + (needsForceUpdate ? ",null,true" : "") + (!needsForceUpdate && needsKey ? (",null,false," + (hash(generatedSlots))) : "") + ")")
}

function hash(str) {
  var hash = 5381;
  var i = str.length;
  while(i) {
    hash = (hash * 33) ^ str.charCodeAt(--i);
  }
  return hash >>> 0
}

function containsSlotChild (el) {
  if (el.type === 1) {
    if (el.tag === 'slot') {
      return true
    }
    return el.children.some(containsSlotChild)
  }
  return false
}

function genScopedSlot (
  el,
  state
) {
  var isLegacySyntax = el.attrsMap['slot-scope'];
  if (el.if && !el.ifProcessed && !isLegacySyntax) {
    return genIf(el, state, genScopedSlot, "null")
  }
  if (el.for && !el.forProcessed) {
    return genFor(el, state, genScopedSlot)
  }
  var slotScope = el.slotScope === emptySlotScopeToken
    ? ""
    : String(el.slotScope);
  var fn = "function(" + slotScope + "){" +
    "return " + (el.tag === 'template'
      ? el.if && isLegacySyntax
        ? ("(" + (el.if) + ")?" + (genChildren(el, state) || 'undefined') + ":undefined")
        : genChildren(el, state) || 'undefined'
      : genElement(el, state)) + "}";
  // reverse proxy v-slot without scope on this.$slots
  var reverseProxy = slotScope ? "" : ",proxy:true";
  return ("{key:" + (el.slotTarget || "\"default\"") + ",fn:" + fn + reverseProxy + "}")
}

function genChildren (
  el,
  state,
  checkSkip,
  altGenElement,
  altGenNode
) {
  var children = el.children;
  if (children.length) {
    var el$1 = children[0];
    // optimize single v-for
    if (children.length === 1 &&
      el$1.for &&
      el$1.tag !== 'template' &&
      el$1.tag !== 'slot'
    ) {
      var normalizationType = checkSkip
        ? state.maybeComponent(el$1) ? ",1" : ",0"
        : "";
      return ("" + ((altGenElement || genElement)(el$1, state)) + normalizationType)
    }
    var normalizationType$1 = checkSkip
      ? getNormalizationType(children, state.maybeComponent)
      : 0;
    var gen = altGenNode || genNode;
    return ("[" + (children.map(function (c) { return gen(c, state); }).join(',')) + "]" + (normalizationType$1 ? ("," + normalizationType$1) : ''))
  }
}

// determine the normalization needed for the children array.
// 0: no normalization needed
// 1: simple normalization needed (possible 1-level deep nested array)
// 2: full normalization needed
function getNormalizationType (
  children,
  maybeComponent
) {
  var res = 0;
  for (var i = 0; i < children.length; i++) {
    var el = children[i];
    if (el.type !== 1) {
      continue
    }
    if (needsNormalization(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return needsNormalization(c.block); }))) {
      res = 2;
      break
    }
    if (maybeComponent(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return maybeComponent(c.block); }))) {
      res = 1;
    }
  }
  return res
}

function needsNormalization (el) {
  return el.for !== undefined || el.tag === 'template' || el.tag === 'slot'
}

function genNode (node, state) {
  if (node.type === 1) {
    return genElement(node, state)
  } else if (node.type === 3 && node.isComment) {
    return genComment(node)
  } else {
    return genText(node)
  }
}

function genText (text) {
  return ("_v(" + (text.type === 2
    ? text.expression // no need for () because already wrapped in _s()
    : transformSpecialNewlines(JSON.stringify(text.text))) + ")")
}

function genComment (comment) {
  return ("_e(" + (JSON.stringify(comment.text)) + ")")
}

function genSlot (el, state) {
  var slotName = el.slotName || '"default"';
  var children = genChildren(el, state);
  var res = "_t(" + slotName + (children ? ("," + children) : '');
  var attrs = el.attrs || el.dynamicAttrs
    ? genProps((el.attrs || []).concat(el.dynamicAttrs || []).map(function (attr) { return ({
        // slot props are camelized
        name: camelize(attr.name),
        value: attr.value,
        dynamic: attr.dynamic
      }); }))
    : null;
  var bind$$1 = el.attrsMap['v-bind'];
  if ((attrs || bind$$1) && !children) {
    res += ",null";
  }
  if (attrs) {
    res += "," + attrs;
  }
  if (bind$$1) {
    res += (attrs ? '' : ',null') + "," + bind$$1;
  }
  return res + ')'
}

// componentName is el.component, take it as argument to shun flow's pessimistic refinement
function genComponent (
  componentName,
  el,
  state
) {
  var children = el.inlineTemplate ? null : genChildren(el, state, true);
  return ("_c(" + componentName + "," + (genData$2(el, state)) + (children ? ("," + children) : '') + ")")
}

function genProps (props) {
  var staticProps = "";
  var dynamicProps = "";
  for (var i = 0; i < props.length; i++) {
    var prop = props[i];
    var value = transformSpecialNewlines(prop.value);
    if (prop.dynamic) {
      dynamicProps += (prop.name) + "," + value + ",";
    } else {
      staticProps += "\"" + (prop.name) + "\":" + value + ",";
    }
  }
  staticProps = "{" + (staticProps.slice(0, -1)) + "}";
  if (dynamicProps) {
    return ("_d(" + staticProps + ",[" + (dynamicProps.slice(0, -1)) + "])")
  } else {
    return staticProps
  }
}

// #3895, #4268
function transformSpecialNewlines (text) {
  return text
    .replace(/\u2028/g, '\\u2028')
    .replace(/\u2029/g, '\\u2029')
}

/*  */



// these keywords should not appear inside expressions, but operators like
// typeof, instanceof and in are allowed
var prohibitedKeywordRE = new RegExp('\\b' + (
  'do,if,for,let,new,try,var,case,else,with,await,break,catch,class,const,' +
  'super,throw,while,yield,delete,export,import,return,switch,default,' +
  'extends,finally,continue,debugger,function,arguments'
).split(',').join('\\b|\\b') + '\\b');

// these unary operators should not be used as property/method names
var unaryOperatorsRE = new RegExp('\\b' + (
  'delete,typeof,void'
).split(',').join('\\s*\\([^\\)]*\\)|\\b') + '\\s*\\([^\\)]*\\)');

// strip strings in expressions
var stripStringRE = /'(?:[^'\\]|\\.)*'|"(?:[^"\\]|\\.)*"|`(?:[^`\\]|\\.)*\$\{|\}(?:[^`\\]|\\.)*`|`(?:[^`\\]|\\.)*`/g;

// detect problematic expressions in a template
function detectErrors (ast, warn) {
  if (ast) {
    checkNode(ast, warn);
  }
}

function checkNode (node, warn) {
  if (node.type === 1) {
    for (var name in node.attrsMap) {
      if (dirRE.test(name)) {
        var value = node.attrsMap[name];
        if (value) {
          var range = node.rawAttrsMap[name];
          if (name === 'v-for') {
            checkFor(node, ("v-for=\"" + value + "\""), warn, range);
          } else if (name === 'v-slot' || name[0] === '#') {
            checkFunctionParameterExpression(value, (name + "=\"" + value + "\""), warn, range);
          } else if (onRE.test(name)) {
            checkEvent(value, (name + "=\"" + value + "\""), warn, range);
          } else {
            checkExpression(value, (name + "=\"" + value + "\""), warn, range);
          }
        }
      }
    }
    if (node.children) {
      for (var i = 0; i < node.children.length; i++) {
        checkNode(node.children[i], warn);
      }
    }
  } else if (node.type === 2) {
    checkExpression(node.expression, node.text, warn, node);
  }
}

function checkEvent (exp, text, warn, range) {
  var stripped = exp.replace(stripStringRE, '');
  var keywordMatch = stripped.match(unaryOperatorsRE);
  if (keywordMatch && stripped.charAt(keywordMatch.index - 1) !== '$') {
    warn(
      "avoid using JavaScript unary operator as property name: " +
      "\"" + (keywordMatch[0]) + "\" in expression " + (text.trim()),
      range
    );
  }
  checkExpression(exp, text, warn, range);
}

function checkFor (node, text, warn, range) {
  checkExpression(node.for || '', text, warn, range);
  checkIdentifier(node.alias, 'v-for alias', text, warn, range);
  checkIdentifier(node.iterator1, 'v-for iterator', text, warn, range);
  checkIdentifier(node.iterator2, 'v-for iterator', text, warn, range);
}

function checkIdentifier (
  ident,
  type,
  text,
  warn,
  range
) {
  if (typeof ident === 'string') {
    try {
      new Function(("var " + ident + "=_"));
    } catch (e) {
      warn(("invalid " + type + " \"" + ident + "\" in expression: " + (text.trim())), range);
    }
  }
}

function checkExpression (exp, text, warn, range) {
  try {
    new Function(("return " + exp));
  } catch (e) {
    var keywordMatch = exp.replace(stripStringRE, '').match(prohibitedKeywordRE);
    if (keywordMatch) {
      warn(
        "avoid using JavaScript keyword as property name: " +
        "\"" + (keywordMatch[0]) + "\"\n  Raw expression: " + (text.trim()),
        range
      );
    } else {
      warn(
        "invalid expression: " + (e.message) + " in\n\n" +
        "    " + exp + "\n\n" +
        "  Raw expression: " + (text.trim()) + "\n",
        range
      );
    }
  }
}

function checkFunctionParameterExpression (exp, text, warn, range) {
  try {
    new Function(exp, '');
  } catch (e) {
    warn(
      "invalid function parameter expression: " + (e.message) + " in\n\n" +
      "    " + exp + "\n\n" +
      "  Raw expression: " + (text.trim()) + "\n",
      range
    );
  }
}

/*  */

var range = 2;

function generateCodeFrame (
  source,
  start,
  end
) {
  if ( start === void 0 ) start = 0;
  if ( end === void 0 ) end = source.length;

  var lines = source.split(/\r?\n/);
  var count = 0;
  var res = [];
  for (var i = 0; i < lines.length; i++) {
    count += lines[i].length + 1;
    if (count >= start) {
      for (var j = i - range; j <= i + range || end > count; j++) {
        if (j < 0 || j >= lines.length) { continue }
        res.push(("" + (j + 1) + (repeat$1(" ", 3 - String(j + 1).length)) + "|  " + (lines[j])));
        var lineLength = lines[j].length;
        if (j === i) {
          // push underline
          var pad = start - (count - lineLength) + 1;
          var length = end > count ? lineLength - pad : end - start;
          res.push("   |  " + repeat$1(" ", pad) + repeat$1("^", length));
        } else if (j > i) {
          if (end > count) {
            var length$1 = Math.min(end - count, lineLength);
            res.push("   |  " + repeat$1("^", length$1));
          }
          count += lineLength + 1;
        }
      }
      break
    }
  }
  return res.join('\n')
}

function repeat$1 (str, n) {
  var result = '';
  if (n > 0) {
    while (true) { // eslint-disable-line
      if (n & 1) { result += str; }
      n >>>= 1;
      if (n <= 0) { break }
      str += str;
    }
  }
  return result
}

/*  */



function createFunction (code, errors) {
  try {
    return new Function(code)
  } catch (err) {
    errors.push({ err: err, code: code });
    return noop
  }
}

function createCompileToFunctionFn (compile) {
  var cache = Object.create(null);

  return function compileToFunctions (
    template,
    options,
    vm
  ) {
    options = extend({}, options);
    var warn$$1 = options.warn || warn;
    delete options.warn;

    /* istanbul ignore if */
    if (false) {
      // detect possible CSP restriction
      try {
        new Function('return 1');
      } catch (e) {
        if (e.toString().match(/unsafe-eval|CSP/)) {
          warn$$1(
            'It seems you are using the standalone build of Vue.js in an ' +
            'environment with Content Security Policy that prohibits unsafe-eval. ' +
            'The template compiler cannot work in this environment. Consider ' +
            'relaxing the policy to allow unsafe-eval or pre-compiling your ' +
            'templates into render functions.'
          );
        }
      }
    }

    // check cache
    var key = options.delimiters
      ? String(options.delimiters) + template
      : template;
    if (cache[key]) {
      return cache[key]
    }

    // compile
    var compiled = compile(template, options);

    // check compilation errors/tips
    if (false) {
      if (compiled.errors && compiled.errors.length) {
        if (options.outputSourceRange) {
          compiled.errors.forEach(function (e) {
            warn$$1(
              "Error compiling template:\n\n" + (e.msg) + "\n\n" +
              generateCodeFrame(template, e.start, e.end),
              vm
            );
          });
        } else {
          warn$$1(
            "Error compiling template:\n\n" + template + "\n\n" +
            compiled.errors.map(function (e) { return ("- " + e); }).join('\n') + '\n',
            vm
          );
        }
      }
      if (compiled.tips && compiled.tips.length) {
        if (options.outputSourceRange) {
          compiled.tips.forEach(function (e) { return tip(e.msg, vm); });
        } else {
          compiled.tips.forEach(function (msg) { return tip(msg, vm); });
        }
      }
    }

    // turn code into functions
    var res = {};
    var fnGenErrors = [];
    res.render = createFunction(compiled.render, fnGenErrors);
    res.staticRenderFns = compiled.staticRenderFns.map(function (code) {
      return createFunction(code, fnGenErrors)
    });

    // check function generation errors.
    // this should only happen if there is a bug in the compiler itself.
    // mostly for codegen development use
    /* istanbul ignore if */
    if (false) {
      if ((!compiled.errors || !compiled.errors.length) && fnGenErrors.length) {
        warn$$1(
          "Failed to generate render function:\n\n" +
          fnGenErrors.map(function (ref) {
            var err = ref.err;
            var code = ref.code;

            return ((err.toString()) + " in\n\n" + code + "\n");
        }).join('\n'),
          vm
        );
      }
    }

    return (cache[key] = res)
  }
}

/*  */

function createCompilerCreator (baseCompile) {
  return function createCompiler (baseOptions) {
    function compile (
      template,
      options
    ) {
      var finalOptions = Object.create(baseOptions);
      var errors = [];
      var tips = [];

      var warn = function (msg, range, tip) {
        (tip ? tips : errors).push(msg);
      };

      if (options) {
        if (false) {
          // $flow-disable-line
          var leadingSpaceLength = template.match(/^\s*/)[0].length;

          warn = function (msg, range, tip) {
            var data = { msg: msg };
            if (range) {
              if (range.start != null) {
                data.start = range.start + leadingSpaceLength;
              }
              if (range.end != null) {
                data.end = range.end + leadingSpaceLength;
              }
            }
            (tip ? tips : errors).push(data);
          };
        }
        // merge custom modules
        if (options.modules) {
          finalOptions.modules =
            (baseOptions.modules || []).concat(options.modules);
        }
        // merge custom directives
        if (options.directives) {
          finalOptions.directives = extend(
            Object.create(baseOptions.directives || null),
            options.directives
          );
        }
        // copy other options
        for (var key in options) {
          if (key !== 'modules' && key !== 'directives') {
            finalOptions[key] = options[key];
          }
        }
      }

      finalOptions.warn = warn;

      var compiled = baseCompile(template.trim(), finalOptions);
      if (false) {
        detectErrors(compiled.ast, warn);
      }
      compiled.errors = errors;
      compiled.tips = tips;
      return compiled
    }

    return {
      compile: compile,
      compileToFunctions: createCompileToFunctionFn(compile)
    }
  }
}

/*  */

// `createCompilerCreator` allows creating compilers that use alternative
// parser/optimizer/codegen, e.g the SSR optimizing compiler.
// Here we just export a default compiler using the default parts.
var createCompiler = createCompilerCreator(function baseCompile (
  template,
  options
) {
  var ast = parse(template.trim(), options);
  if (options.optimize !== false) {
    optimize(ast, options);
  }
  var code = generate(ast, options);
  return {
    ast: ast,
    render: code.render,
    staticRenderFns: code.staticRenderFns
  }
});

/*  */

var ref$1 = createCompiler(baseOptions);
var compile = ref$1.compile;
var compileToFunctions = ref$1.compileToFunctions;

/*  */

// check whether current browser encodes a char inside attribute values
var div;
function getShouldDecode (href) {
  div = div || document.createElement('div');
  div.innerHTML = href ? "<a href=\"\n\"/>" : "<div a=\"\n\"/>";
  return div.innerHTML.indexOf('&#10;') > 0
}

// #3663: IE encodes newlines inside attribute values while other browsers don't
var shouldDecodeNewlines = inBrowser ? getShouldDecode(false) : false;
// #6828: chrome encodes content in a[href]
var shouldDecodeNewlinesForHref = inBrowser ? getShouldDecode(true) : false;

/*  */

var idToTemplate = cached(function (id) {
  var el = query(id);
  return el && el.innerHTML
});

var mount = Vue.prototype.$mount;
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && query(el);

  /* istanbul ignore if */
  if (el === document.body || el === document.documentElement) {
    "production" !== 'production' && warn(
      "Do not mount Vue to <html> or <body> - mount to normal elements instead."
    );
    return this
  }

  var options = this.$options;
  // resolve template/el and convert to render function
  if (!options.render) {
    var template = options.template;
    if (template) {
      if (typeof template === 'string') {
        if (template.charAt(0) === '#') {
          template = idToTemplate(template);
          /* istanbul ignore if */
          if (false) {
            warn(
              ("Template element not found or is empty: " + (options.template)),
              this
            );
          }
        }
      } else if (template.nodeType) {
        template = template.innerHTML;
      } else {
        if (false) {
          warn('invalid template option:' + template, this);
        }
        return this
      }
    } else if (el) {
      template = getOuterHTML(el);
    }
    if (template) {
      /* istanbul ignore if */
      if (false) {
        mark('compile');
      }

      var ref = compileToFunctions(template, {
        outputSourceRange: "production" !== 'production',
        shouldDecodeNewlines: shouldDecodeNewlines,
        shouldDecodeNewlinesForHref: shouldDecodeNewlinesForHref,
        delimiters: options.delimiters,
        comments: options.comments
      }, this);
      var render = ref.render;
      var staticRenderFns = ref.staticRenderFns;
      options.render = render;
      options.staticRenderFns = staticRenderFns;

      /* istanbul ignore if */
      if (false) {
        mark('compile end');
        measure(("vue " + (this._name) + " compile"), 'compile', 'compile end');
      }
    }
  }
  return mount.call(this, el, hydrating)
};

/**
 * Get outerHTML of elements, taking care
 * of SVG elements in IE as well.
 */
function getOuterHTML (el) {
  if (el.outerHTML) {
    return el.outerHTML
  } else {
    var container = document.createElement('div');
    container.appendChild(el.cloneNode(true));
    return container.innerHTML
  }
}

Vue.compile = compileToFunctions;

/* harmony default export */ __webpack_exports__["a"] = (Vue);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4), __webpack_require__(18).setImmediate))

/***/ }),
/* 4 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]());

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(25),
  /* template */
  __webpack_require__(28),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(26),
  /* template */
  __webpack_require__(27),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%40/gi, '@').
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__(1);
var normalizeHeaderName = __webpack_require__(35);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(12);
  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    // For node use HTTP adapter
    adapter = __webpack_require__(12);
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var settle = __webpack_require__(36);
var buildURL = __webpack_require__(9);
var buildFullPath = __webpack_require__(38);
var parseHeaders = __webpack_require__(41);
var isURLSameOrigin = __webpack_require__(42);
var createError = __webpack_require__(13);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    var fullPath = buildFullPath(config.baseURL, config.url);
    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request.onreadystatechange = function handleLoad() {
      if (!request || request.readyState !== 4) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(createError('Request aborted', config, 'ECONNABORTED', request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = 'timeout of ' + config.timeout + 'ms exceeded';
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(createError(timeoutErrorMessage, config, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__(43);

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ?
        cookies.read(config.xsrfCookieName) :
        undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (!utils.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(37);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */
module.exports = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};

  var valueFromConfig2Keys = ['url', 'method', 'params', 'data'];
  var mergeDeepPropertiesKeys = ['headers', 'auth', 'proxy'];
  var defaultToConfig2Keys = [
    'baseURL', 'url', 'transformRequest', 'transformResponse', 'paramsSerializer',
    'timeout', 'withCredentials', 'adapter', 'responseType', 'xsrfCookieName',
    'xsrfHeaderName', 'onUploadProgress', 'onDownloadProgress',
    'maxContentLength', 'validateStatus', 'maxRedirects', 'httpAgent',
    'httpsAgent', 'cancelToken', 'socketPath'
  ];

  utils.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    }
  });

  utils.forEach(mergeDeepPropertiesKeys, function mergeDeepProperties(prop) {
    if (utils.isObject(config2[prop])) {
      config[prop] = utils.deepMerge(config1[prop], config2[prop]);
    } else if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (utils.isObject(config1[prop])) {
      config[prop] = utils.deepMerge(config1[prop]);
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  utils.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  var axiosKeys = valueFromConfig2Keys
    .concat(mergeDeepPropertiesKeys)
    .concat(defaultToConfig2Keys);

  var otherKeys = Object
    .keys(config2)
    .filter(function filterAxiosKeys(key) {
      return axiosKeys.indexOf(key) === -1;
    });

  utils.forEach(otherKeys, function otherKeysDefaultToConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  return config;
};


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_shortkey__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_shortkey___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_shortkey__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_touch__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_touch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_touch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_resource__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_analytics__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_analytics__);
/*jshint esversion: 6 */
/* The Vue build version to load with the `import` command
(runtime-only or standalone) has been set in webpack.base.conf with an alias. */

var path = __webpack_require__(17);










__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vuetify___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vue_shortkey___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6_vue_resource__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_5_vue_touch___default.a.config.swipe = {
  direction: 'horizontal',
  threshold: 10,
  velocity: 0.3,
  pointers: 1
};

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vue_touch___default.a, { name: 'v-touch' });

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_7_vue_analytics___default.a, {
  id: ['UA-137347938-1', 'UA-64435914-1'],
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  autoTracking: {
    pageviewTemplate: function pageviewTemplate(route) {
      return {
        page: path.join(window.location.pathname, route.path),
        title: document.title,
        location: window.location.href
      };
    }
  },
  debug: {
    enabled: false
  }
});

var app = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  data: {},
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_1__App___default.a);
  }
}).$mount('#app');

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// .dirname, .basename, and .extname methods are extracted from Node.js v8.11.1,
// backported and transplited with Babel, with backwards-compat fixes

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// resolves . and .. elements in a path array with directory names there
// must be no slashes, empty elements, or device names (c:\) in the array
// (so also no leading and trailing slashes - it does not distinguish
// relative and absolute paths)
function normalizeArray(parts, allowAboveRoot) {
  // if the path tries to go above the root, `up` ends up > 0
  var up = 0;
  for (var i = parts.length - 1; i >= 0; i--) {
    var last = parts[i];
    if (last === '.') {
      parts.splice(i, 1);
    } else if (last === '..') {
      parts.splice(i, 1);
      up++;
    } else if (up) {
      parts.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (allowAboveRoot) {
    for (; up--; up) {
      parts.unshift('..');
    }
  }

  return parts;
}

// path.resolve([from ...], to)
// posix version
exports.resolve = function() {
  var resolvedPath = '',
      resolvedAbsolute = false;

  for (var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--) {
    var path = (i >= 0) ? arguments[i] : process.cwd();

    // Skip empty and invalid entries
    if (typeof path !== 'string') {
      throw new TypeError('Arguments to path.resolve must be strings');
    } else if (!path) {
      continue;
    }

    resolvedPath = path + '/' + resolvedPath;
    resolvedAbsolute = path.charAt(0) === '/';
  }

  // At this point the path should be resolved to a full absolute path, but
  // handle relative paths to be safe (might happen when process.cwd() fails)

  // Normalize the path
  resolvedPath = normalizeArray(filter(resolvedPath.split('/'), function(p) {
    return !!p;
  }), !resolvedAbsolute).join('/');

  return ((resolvedAbsolute ? '/' : '') + resolvedPath) || '.';
};

// path.normalize(path)
// posix version
exports.normalize = function(path) {
  var isAbsolute = exports.isAbsolute(path),
      trailingSlash = substr(path, -1) === '/';

  // Normalize the path
  path = normalizeArray(filter(path.split('/'), function(p) {
    return !!p;
  }), !isAbsolute).join('/');

  if (!path && !isAbsolute) {
    path = '.';
  }
  if (path && trailingSlash) {
    path += '/';
  }

  return (isAbsolute ? '/' : '') + path;
};

// posix version
exports.isAbsolute = function(path) {
  return path.charAt(0) === '/';
};

// posix version
exports.join = function() {
  var paths = Array.prototype.slice.call(arguments, 0);
  return exports.normalize(filter(paths, function(p, index) {
    if (typeof p !== 'string') {
      throw new TypeError('Arguments to path.join must be strings');
    }
    return p;
  }).join('/'));
};


// path.relative(from, to)
// posix version
exports.relative = function(from, to) {
  from = exports.resolve(from).substr(1);
  to = exports.resolve(to).substr(1);

  function trim(arr) {
    var start = 0;
    for (; start < arr.length; start++) {
      if (arr[start] !== '') break;
    }

    var end = arr.length - 1;
    for (; end >= 0; end--) {
      if (arr[end] !== '') break;
    }

    if (start > end) return [];
    return arr.slice(start, end - start + 1);
  }

  var fromParts = trim(from.split('/'));
  var toParts = trim(to.split('/'));

  var length = Math.min(fromParts.length, toParts.length);
  var samePartsLength = length;
  for (var i = 0; i < length; i++) {
    if (fromParts[i] !== toParts[i]) {
      samePartsLength = i;
      break;
    }
  }

  var outputParts = [];
  for (var i = samePartsLength; i < fromParts.length; i++) {
    outputParts.push('..');
  }

  outputParts = outputParts.concat(toParts.slice(samePartsLength));

  return outputParts.join('/');
};

exports.sep = '/';
exports.delimiter = ':';

exports.dirname = function (path) {
  if (typeof path !== 'string') path = path + '';
  if (path.length === 0) return '.';
  var code = path.charCodeAt(0);
  var hasRoot = code === 47 /*/*/;
  var end = -1;
  var matchedSlash = true;
  for (var i = path.length - 1; i >= 1; --i) {
    code = path.charCodeAt(i);
    if (code === 47 /*/*/) {
        if (!matchedSlash) {
          end = i;
          break;
        }
      } else {
      // We saw the first non-path separator
      matchedSlash = false;
    }
  }

  if (end === -1) return hasRoot ? '/' : '.';
  if (hasRoot && end === 1) {
    // return '//';
    // Backwards-compat fix:
    return '/';
  }
  return path.slice(0, end);
};

function basename(path) {
  if (typeof path !== 'string') path = path + '';

  var start = 0;
  var end = -1;
  var matchedSlash = true;
  var i;

  for (i = path.length - 1; i >= 0; --i) {
    if (path.charCodeAt(i) === 47 /*/*/) {
        // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now
        if (!matchedSlash) {
          start = i + 1;
          break;
        }
      } else if (end === -1) {
      // We saw the first non-path separator, mark this as the end of our
      // path component
      matchedSlash = false;
      end = i + 1;
    }
  }

  if (end === -1) return '';
  return path.slice(start, end);
}

// Uses a mixed approach for backwards-compatibility, as ext behavior changed
// in new Node.js versions, so only basename() above is backported here
exports.basename = function (path, ext) {
  var f = basename(path);
  if (ext && f.substr(-1 * ext.length) === ext) {
    f = f.substr(0, f.length - ext.length);
  }
  return f;
};

exports.extname = function (path) {
  if (typeof path !== 'string') path = path + '';
  var startDot = -1;
  var startPart = 0;
  var end = -1;
  var matchedSlash = true;
  // Track the state of characters (if any) we see before our first dot and
  // after any path separator we find
  var preDotState = 0;
  for (var i = path.length - 1; i >= 0; --i) {
    var code = path.charCodeAt(i);
    if (code === 47 /*/*/) {
        // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now
        if (!matchedSlash) {
          startPart = i + 1;
          break;
        }
        continue;
      }
    if (end === -1) {
      // We saw the first non-path separator, mark this as the end of our
      // extension
      matchedSlash = false;
      end = i + 1;
    }
    if (code === 46 /*.*/) {
        // If this is our first dot, mark it as the start of our extension
        if (startDot === -1)
          startDot = i;
        else if (preDotState !== 1)
          preDotState = 1;
    } else if (startDot !== -1) {
      // We saw a non-dot and non-path separator before our dot, so we should
      // have a good chance at having a non-empty extension
      preDotState = -1;
    }
  }

  if (startDot === -1 || end === -1 ||
      // We saw a non-dot character immediately before the dot
      preDotState === 0 ||
      // The (right-most) trimmed path component is exactly '..'
      preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
    return '';
  }
  return path.slice(startDot, end);
};

function filter (xs, f) {
    if (xs.filter) return xs.filter(f);
    var res = [];
    for (var i = 0; i < xs.length; i++) {
        if (f(xs[i], i, xs)) res.push(xs[i]);
    }
    return res;
}

// String.prototype.substr - negative index don't work in IE8
var substr = 'ab'.substr(-1) === 'b'
    ? function (str, start, len) { return str.substr(start, len) }
    : function (str, start, len) {
        if (start < 0) start = str.length + start;
        return str.substr(start, len);
    }
;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(19);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4), __webpack_require__(2)))

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(21)
  __webpack_require__(22)
  __webpack_require__(23)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(24),
  /* template */
  __webpack_require__(46),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 21 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 22 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 23 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Reader_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Reader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Reader_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Settings_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__event_hub_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    pageNum: {
      type: Number,
      default: 0
    },
    ttlPages: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      pageNumber: this.pageNum,
      totalPages: this.ttlPages,
      info: false,
      buyBar: true,
      buyMenu: false,
      socialMenu: false,
      otherBooks: false,
      focused: false,
      dialogBuy: false,
      dialogShare: false,
      notifications: false,
      sound: true,
      widgets: false,
      show: false,
      iSize: 50,
      selectBook: "Books",
      home: this.$route.path,
      drawer: false,
      drawerRight: false,
      items: [],
      books: [],
      booksChanged: '',
      socials: [{
        title: "LinkedIn",
        img: "static/img/linkedin-logo.svg",
        url: "https://www.linkedin.com/shareArticle?mini=true&url=https://textcafe.co/books/Zgnlkc/%3F1708776416438&title=Washingtons.%20Volume%206%2C%20Part%201%2C%20The%20Washingtons%3A%20A%20Family%20History&summary=Part%20of%20a%20series%20filled%20with%20%1Cgratifying%20detail%1D%20about%20the%20ancestry%20of%20the%20first%20US%20President%2C%20this%20volume%20contains%20the%20tenth-generation%20descendants.%20%28Robert%20K.%20Krick%2C%20author%20of%20The%20Smoothbore%20Volley%20that%20Doomed%20the%20Confederacy%2C%20Stonewall%20Jackson%20at&source=LinkedIn",
        icon: "ion-social-linkedin"
      }, {
        title: "Facebook",
        img: "static/img/facebook-logo.svg",
        url: "https://www.facebook.com/sharer/sharer.php?u=https://textcafe.co/books/Zgnlkc/%3F1708776416438",
        icon: "ion-social-facebook"
      }, {
        title: "Twitter",
        img: "static/img/twitter-logo-silhouette.svg",
        url: "https://twitter.com/intent/tweet?text=Part%20of%20a%20series%20filled%20with%20%1Cgratifying%20detail%1D%20about%20the%20ancestry%20of%20the%20first%20US%20President%2C%20this%20volume%20contains%20the%20tenth-generation%20desc%0Dhttps://textcafe.co/books/Zgnlkc/%3F1708776416438&amp;via=textcafecom",
        icon: "ion-social-twitter"
      }, {
        title: "Tumblr",
        img: "static/img/tumblr-letter-logo.svg",
        url: "https://www.tumblr.com/widgets/share/tool?canonicalUrl=https://textcafe.co/books/Zgnlkc/%3F1708776416438&posttype=link&caption=Part%20of%20a%20series%20filled%20with%20%1Cgratifying%20detail%1D%20about%20the%20ancestry%20of%20the%20first%20US%20President%2C%20this%20volume%20contains%20the%20tenth-generation%20descendants.%20%28Robert%20K.%20Krick%2C%20author%20of%20The%20Smoothbore%20Volley%20that%20Doomed%20the%20Confederacy%2C%20Stonewall%20Jackson%20at",
        icon: "ion-social-tumblr"
      }, {
        title: "Pinterest",
        img: "static/img/pinterest-logo.svg",
        url: "http://www.pinterest.com/pin/create/button/?url=https://textcafe.co/books/Zgnlkc/%3F1708776416438&description=Part%20of%20a%20series%20filled%20with%20%1Cgratifying%20detail%1D%20about%20the%20ancestry%20of%20the%20first%20US%20President%2C%20this%20volume%20contains%20the%20tenth-generation%20descendants.%20%28Robert%20K.%20Krick%2C%20author%20of%20The%20Smoothbore%20Volley%20that%20Doomed%20the%20Confederacy%2C%20Stonewall%20Jackson%20at&media=https://textcafe.co/books/Zgnlkc/tc-custom/9781940669311.jpg",
        icon: "ion-social-pinterest"
      }],
      buys: [{
        title: 'Amazon US',
        img: 'https://textcafe.co/domain-icons/Amazon.com_A_Smile.svg',
        url: 'https://www.amazon.com/s?k=9781940669311&i=stripbooks&linkCode=qs&tag=mobilebookcom-20',
        alt: 'None'
      }, {
        title: 'Google Play',
        img: 'https://textcafe.co/global-css/img/Google_Play_symbol.svg',
        url: 'https://play.google.com/store/books/details?id=rxpqBgAAQBAJ&amp;rdid=book-rxpqBgAAQBAJ&amp;rdot=1&amp;source=gbs_atb&amp;pcampaignid=books_booksearch_atb&gl=us',
        alt: 'None'
      }],
      right: null,
      left: null
    };
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('https://www.textcafe.com/widget/get-samples.json?related=9781940669311').then(function (response) {
      return _this.books = response.data.map(function (item) {
        return {
          title: item.title,
          img: item.coverImagePath,
          url: item.socialUrl,
          alt: "This image is the cover for the book " + item.title
        };
      });
    }).catch(function (error) {
      return (
        // handle error
        console.log(error)
      );
    });
  },

  created: function created() {
    var _this2 = this;

    this.$router.options.routes.forEach(function (route) {
      _this2.items.push({
        path: route.path,
        name: route.name,
        component: route.component,
        //image: "static/img/ilG6Mf.jpg"
        image: '/books/Zgnlkc/tc-custom/9781940669311.jpg?1708776416438',
        alt: 'Washingtons. Volume 6, Part 1, The Washingtons: A Family History'
      });
    });
    __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$on("pageNum", function (newValue) {
      _this2.pageNum = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$on("ttlPages", function (newValue) {
      _this2.ttlPages = newValue;
    });
  },
  watch: {
    $route: function $route(to, from) {
      if (to.path === "/") {
        this.home = this.$route.path;
      } else {
        this.home = null;
      }
    },

    iSize: function iSize(newValue) {
      __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$emit("iSizeChanged", newValue);
    },
    books: function books(newValue) {
      __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$emit("booksChanged", Date.now());
    }
  },
  methods: {
    resetScroll: function resetScroll() {
      var page = this.$el.querySelector(".book-page");
      page.scrollLeft = 0;
    },
    onBlur: function onBlur() {
      if (this.show === true) {
        this.show = false;
        this.$emit("blur");
      }
    },
    onFocus: function onFocus() {
      if (this.show === false) {
        this.show = true;
        this.$el.querySelector(".book-page").$emit("focus");
      }
    },
    buyClick: function buyClick(url) {
      //const url = '/foo/bar'
      // this.$ga.query('send', 'event', 'outbound', 'click', url, {
      //     transport: 'beacon',
      //     hitCallback () {
      //        //document.location = url
      //     }
      // })
      this.$ga.event({
        eventCategory: 'purchase',
        eventAction: 'click',
        eventLabel: url
        // eventValue: 123
      });
    },
    shareClick: function shareClick(network) {
      this.$ga.event({
        eventCategory: 'share',
        eventAction: 'click',
        eventLabel: network
        // eventValue: 123
      });
    }
  },
  components: {
    settings: __WEBPACK_IMPORTED_MODULE_1__components_Settings_vue___default.a,
    reader: __WEBPACK_IMPORTED_MODULE_0__components_Reader_vue___default.a
  }
});

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_hub_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Settings__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var SLIDE_TIME = document.documentElement.clientWidth > 480 ? 500 : 300;

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "reader",
  props: {
    value1: {
      type: Number,
      default: 22
    },
    selected: {
      type: String
    },
    ex8: {
      type: String,
      default: "Auto"
    },
    value2: {
      type: Number
    },
    value3: {
      type: Number,
      default: 100
    }
  },
  data: function data() {
    return {
      pageNum: 0,
      pageNumber: 1,
      ttlPages: 0,
      totalPages: 0,
      home: false,
      div: 0,
      prevX: null,
      xDownEnd: null,
      fontSize: this.value1,
      fontFamily: this.selected,
      columns: this.ex8,
      widthSize: this.value2,
      brightness: this.value3,
      currentColor: "#f3f3f3",
      cols: "2 220px",
      position: { scrollTop: 0, scrollLeft: 0 },
      offset: null,
      height: 0,
      isOver: false,
      routeNames: ["home", "05_contents", "06_introduction", "07_acknowledgement", "08_abbreviation", "09_ch01", "last"],
      routeTransition: "slide-left",
      rest: true,
      selectedView: "Book1",
      progress: 0,
      hiddenEl: false,
      brandReaderUrl: "",
      brandLogoUrl: "",
      currentUrl: "https://textcafe.co/books/Zgnlkc/",
      waiting: false
    };
  },

  created: function created() {
    var _this = this;

    document.addEventListener("mousewheel", this.onScroll, false);
    window.addEventListener('resize', this.resize);
    this.resize();
    this.getTtlPages();

    if (document.documentElement.offsetWidth >= 768) {
      this.hiddenEl = true;
    } else {
      this.hiddenEl = false;
    }

    this.$router.options.routes.forEach(function (route) {
      _this.routeNames.push(route.name);
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("fontSizeChanged", function (newValue) {
      _this.fontSize = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("fontFamilyChanged", function (newValue) {
      _this.fontFamily = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("columnsCountChanged", function (newValue) {
      _this.columns = newValue;
      if (_this.columns === "Single") {
        _this.cols = "1 auto";
      } else if (_this.columns === "Auto") {
        _this.cols = "2 220px";
      }
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("widthChanged", function (newValue) {
      _this.widthSize = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("brightnessChanged", function (newValue) {
      _this.brightness = newValue;
    });
  },

  destroyed: function destroyed() {
    document.removeEventListener("mousewheel", this.onScroll, false);
    document.removeEventListener("resize", this.resize, false);
  },
  updated: function updated() {
    this.getTtlPages();
    this.resize();
    var links = document.getElementsByTagName("a");
    for (var i = 0; i < links.length; i++) {
      var that = this;
      var url = "/" + document.location.hash.split("#/")[1];
      if (links[i].href.split("#")[1] === url) {
        links[i].style.textDecoration = "underline";
        links[i].style.textDecorationStyle = "dotted";
        links[i].onclick = function (e) {
          e.preventDefault();
          var refr = this.href.split("#")[2];
          that.linkTo(refr);
        };
      };
    };
  },
  mounted: function mounted() {
    this.resize();

    var links = document.getElementsByTagName("a");
    for (var i = 0; i < links.length; i++) {
      var that = this;
      var url = "/" + document.location.hash.split("#/")[1];
      if (links[i].href.split("#")[1] === url) {
        links[i].style.textDecoration = "underline";
        links[i].style.textDecorationStyle = "dotted";
        links[i].onclick = function (e) {
          e.preventDefault();
          var refr = this.href.split("#")[2];
          that.linkTo(refr);
        };
      };
    };

    this.getTtlPages();

    var bgColor = document.getElementsByClassName("book-content")[0].style.backgroundColor,
        hexDigits = new Array("0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "a", "b", "c", "d", "e", "f");
    function rgb2hex(rgb) {
      rgb = rgb.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/);
      return "#" + hex(rgb[1]) + hex(rgb[2]) + hex(rgb[3]);
    }
    function hex(x) {
      return isNaN(x) ? "00" : hexDigits[(x - x % 16) / 16] + hexDigits[x % 16];
    }
    this.currentColor = rgb2hex(bgColor);
  },

  watch: {
    $route: function $route(to, from, next) {
      var toDepth = this.routeNames.indexOf(to.name);
      var fromDepth = this.routeNames.indexOf(from.name);
      this.routeTransition = toDepth < fromDepth ? "slide-right" : "slide-left";

      this.progress = 0;
      this.pageNumber = 1;
    },

    pageNum: function pageNum(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("pageNum", newValue);
    },
    ttlPages: function ttlPages(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("ttlPages", newValue);
    }
  },
  methods: {
    resize: function resize() {
      this.height = document.documentElement.clientHeight;
    },
    linkTo: function linkTo(refName) {
      var element = document.getElementById(refName);
      var elementOffset = Math.ceil(element.offsetLeft);
      var page = this.$el.querySelector(".book-page");
      var gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10);
      var onStart = Math.ceil(page.scrollLeft);
      var destinationOffset = Math.floor(elementOffset / (page.offsetWidth + gap));
      var target = destinationOffset * (page.offsetWidth + gap) - onStart;
      if (destinationOffset + 1 !== this.pageNumber) {
        this.scrollIt(target, 300, "easeOutQuad", false);
        var scrollArea = page.scrollWidth - page.offsetWidth;
        var pctScrolled = Math.floor(destinationOffset * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;
        this.pageNumber = destinationOffset + 1;
      }
    },
    getTtlPages: function getTtlPages() {
      this.$nextTick(function () {
        var page = this.$el.querySelector(".book-page");

        var gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10);

        var scrollArea = page.scrollWidth - page.offsetWidth;
        var ttlPages = Math.round(scrollArea / (page.offsetWidth + gap));
        this.ttlPages = ttlPages;
        this.totalPages = this.ttlPages + 1;
      });
    },
    tapped: function tapped() {
      var el = this.$el.querySelector(".touch-swipe");
      this.hiddenEl = !this.hiddenEl;
    },
    tappedIn: function tappedIn() {
      var el = this.$el.querySelector(".touch-swipe");
      this.hiddenEl = !this.hiddenEl;
    },
    scrollIt: function scrollIt(destination) {
      var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 200;

      var _this2 = this;

      var easing = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "easeInOutQuart";
      var callback = arguments[3];

      var easings = {
        linear: function linear(t) {
          return t;
        },
        easeInQuad: function easeInQuad(t) {
          return t * t;
        },
        easeOutQuad: function easeOutQuad(t) {
          return t * (2 - t);
        },
        easeInOutQuad: function easeInOutQuad(t) {
          return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
        },
        easeInCubic: function easeInCubic(t) {
          return t * t * t;
        },
        easeOutCubic: function easeOutCubic(t) {
          return --t * t * t + 1;
        },
        easeInOutCubic: function easeInOutCubic(t) {
          return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
        },
        easeInQuart: function easeInQuart(t) {
          return t * t * t * t;
        },
        easeOutQuart: function easeOutQuart(t) {
          return 1 - --t * t * t * t;
        },
        easeInOutQuart: function easeInOutQuart(t) {
          return t < 0.5 ? 8 * t * t * t * t : 1 - 8 * --t * t * t * t;
        },
        easeInQuint: function easeInQuint(t) {
          return t * t * t * t * t;
        },
        easeOutQuint: function easeOutQuint(t) {
          return 1 + --t * t * t * t * t;
        },
        easeInOutQuint: function easeInOutQuint(t) {
          return t < 0.5 ? 16 * t * t * t * t * t : 1 + 16 * --t * t * t * t * t;
        }
      };

      var page = this.$el.querySelector(".book-page");
      var gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
          offset = page.offsetWidth + gap;

      var start = Math.ceil(page.scrollLeft);

      var startTime = "now" in window.performance ? performance.now() : new Date().getTime();

      var documentWidth = Math.max(page.scrollWidth || page.offsetWidth || page.clientWidth);

      var windowWidth = window.innerWidth || window.clientWidth;

      var destinationOffsetToScroll = start + destination;

      function scroll() {
        var now = "now" in window.performance ? performance.now() : new Date().getTime();
        var time = Math.min(1, (now - startTime) / duration);
        var timeFunction = easings[easing](time);
        page.scroll(Math.ceil(timeFunction * (destinationOffsetToScroll - start) + start), 0);
        if (timeFunction === 1 || start === destinationOffsetToScroll) {
          if (callback) {
            callback();
          }
          return;
        }
        requestAnimationFrame(scroll);
      }
      scroll();
      setTimeout(function () {
        _this2.waiting = false;
      }, 250);
    },


    next: function next(e) {
      var el = this.$el.querySelector(".touch-swipe");
      if (el) el.style.pointerEvents = "auto";
      var book = this.$el.querySelector(".book-content");
      var page = this.$el.querySelector(".book-page"),
          gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
          offset = page.offsetWidth + gap,
          index = this.routeNames.indexOf(this.$route.name);

      var scrollArea = page.scrollWidth - page.offsetWidth;
      var windowWidth = window.innerWidth || window.clientWidth;
      var trackLength = scrollArea - (page.offsetWidth + gap);

      // var pageNum = Math.floor(page.scrollLeft / (page.offsetWidth + gap));
      var scrollLeft = Math.ceil(page.scrollLeft);
      var pageNum = Math.floor(scrollLeft / (page.offsetWidth + gap));

      this.pageNum = pageNum;

      pageNum += 1;

      this.pageNumber += 1;

      if (page.scrollWidth - (scrollLeft + page.offsetWidth) !== 0 && pctScrolled !== 100) {
        var currentPage = Math.floor(pageNum * (page.offsetWidth + gap));

        var nextPage = Math.floor(pageNum * (page.offsetWidth + gap));

        var destination = nextPage - scrollLeft;

        this.scrollIt(destination, 300, "easeOutQuad", false);
      } else {
        this.$router.push({ name: this.routeNames[index + 1] });

        this.pageNumber = 1;
        pageNum = 0;
        var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;
      }
      var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
      this.progress = pctScrolled;
    },
    prev: function prev(e) {
      var el = this.$el.querySelector(".touch-swipe");
      if (el) el.style.pointerEvents = "auto";

      var page = this.$el.querySelector(".book-page"),
          gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
          offset = page.offsetWidth + gap,
          index = this.routeNames.indexOf(this.$route.name);

      var scrollArea = page.scrollWidth - page.offsetWidth;

      var scrollLeft = Math.ceil(page.scrollLeft);
      var pageNum = Math.round(scrollLeft / (page.offsetWidth + gap));
      var ttlPages = Math.round(scrollArea / (page.offsetWidth + gap));

      this.pageNum = pageNum;

      this.pageNumber -= 1;

      var currentPage = Math.floor(pageNum * (page.offsetWidth + gap));

      if (scrollLeft !== 0 && pageNum !== 0) {
        var pageNum = Math.round(scrollLeft / (page.offsetWidth + gap));
        var pageNumber = Math.floor(scrollLeft / (page.offsetWidth + gap));

        pageNum -= 1;
        var prevPage = Math.floor(pageNum * (page.offsetWidth + gap));

        var destination = -1 * (scrollLeft - prevPage);

        this.scrollIt(destination, 300, "easeOutQuad", false);
      } else {
        this.$router.push({ name: this.routeNames[index - 1] });

        this.pageNumber = 1;

        pageNum = 0;
        var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;
      }
      var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
      this.progress = pctScrolled;
    },
    over: function over() {
      this.isOver = true;
    },
    out: function out() {
      this.isOver = false;
    },
    onScroll: function onScroll(e, position) {
      this.position = position;
      if (this.isOver === true) {
        var page = this.$el.querySelector(".book-page"),
            gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
            deltaX = Math.max(-1, Math.min(1, e.wheelDelta || -e.detail)),
            end = page.scrollWidth - (page.scrollLeft + page.offsetWidth),
            offset = page.offsetWidth + gap;

        var scrollArea = page.scrollWidth - page.offsetWidth;
        var pageNum = Math.round(page.scrollLeft / (page.offsetWidth + gap));

        var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;

        if (deltaX === 1) {
          if (page.scrollLeft !== 0) {
            if (this.waiting) {
              return;
            }
            this.waiting = true;

            pageNum -= 1;

            this.pageNumber -= 1;
            var prevPage = Math.floor(pageNum * (page.offsetWidth + gap));

            var destination = -1 * (page.scrollLeft - prevPage);

            this.scrollIt(destination, 300, "easeOutQuad", false);

            var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
            this.progress = pctScrolled;
          }
        } else if (deltaX === -1) {
          if (page.scrollWidth - (page.scrollLeft + page.offsetWidth) !== 0) {
            if (this.waiting) {
              return;
            }
            this.waiting = true;

            pageNum += 1;

            this.pageNumber += 1;
            var nextPage = Math.floor(pageNum * (page.offsetWidth + gap));

            var destination = nextPage - page.scrollLeft;

            this.scrollIt(destination, 300, "easeOutQuad", false);

            var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
            this.progress = pctScrolled;
          }
        }
      } else {
        return;
      }
    },
    fadeIn: function fadeIn() {
      var page = this.$el.querySelector(".book-page");
      page.style.opacity = 0;
      var last = +new Date();
      var tick = function tick() {
        page.style.opacity = +page.style.opacity + (new Date() - last) / 400;
        last = +new Date();
        if (+page.style.opacity < 1) {
          window.requestAnimationFrame && requestAnimationFrame(tick) || setTimeout(tick, 16);
        }
      };
      tick();
    },

    resetScroll: function resetScroll() {
      var page = this.$el.querySelector(".book-page");
      page.scrollLeft = 0;
    }
  },
  computed: {
    isMobile: function isMobile() {
      var check = false;
      (function (a) {
        if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true;
      })(navigator.userAgent || navigator.vendor || window.opera);
      return check;
    }
  },
  components: {
    Settings: __WEBPACK_IMPORTED_MODULE_1__components_Settings___default.a
  }
});

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_hub_js__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "settings",
  data: function data() {
    return {
      events: [],
      value1: 22,
      value2: 70,
      value3: 100,
      ex8: "Auto",
      selected: "Old-Cabin",
      fonts: ["Old-Cabin", "Raleway-Bitter", "Ubuntu-Abel", "Droid-Abril", "Garamond-Clicker", "Alice-Playfair", "Judson-Quando"],
      classes: ["white", "black", "sepia"]
    };
  },

  watch: {
    value1: function value1(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("fontSizeChanged", newValue);
    },
    selected: function selected(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("fontFamilyChanged", newValue);
    },
    ex8: function ex8(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("columnsCountChanged", newValue);
    },
    value2: function value2(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("widthChanged", newValue);
    },
    value3: function value3(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("brightnessChanged", newValue);
    }
  },
  methods: {
    reloadBook: function reloadBook() {
      window.location.reload(true);
    },
    changeClassWhite: function changeClassWhite() {
      var el = document.getElementsByClassName("book-content")[0];
      var el2 = document.getElementsByClassName("nav-btn")[0];
      var el3 = document.getElementsByClassName("nav-btn")[1];
      var el4 = document.getElementsByTagName("footer")[0];
      console.log(document.getElementsByTagName("footer")[0]);
      if (el.classList && el2.classList && el3.classList && el4.classList) {
        el.classList.remove("black");
        el2.classList.remove("black");
        el3.classList.remove("black");
        el4.classList.remove("black");
        el.classList.remove("sepia");
        el2.classList.remove("sepia");
        el3.classList.remove("sepia");
        el4.classList.remove("sepia");
        el.classList.add("white");
        el2.classList.add("white");
        el3.classList.add("white");
        el4.classList.add("white");
      } else {
        el.className += " white";
        el2.className += " white";
        el3.className += " white";
        el4.className += " white";
      }
    },
    changeClassBlack: function changeClassBlack() {
      var el = document.getElementsByClassName("book-content")[0];
      var el2 = document.getElementsByClassName("nav-btn")[0];
      var el3 = document.getElementsByClassName("nav-btn")[1];
      var el4 = document.getElementsByTagName("footer")[0];
      if (el.classList && el2.classList && el3.classList && el4.classList) {
        el.classList.remove("white");
        el2.classList.remove("white");
        el3.classList.remove("white");
        el4.classList.remove("white");
        el.classList.remove("sepia");
        el2.classList.remove("sepia");
        el3.classList.remove("sepia");
        el4.classList.remove("sepia");
        el.classList.add("black");
        el2.classList.add("black");
        el3.classList.add("black");
        el4.classList.add("black");
      } else {
        el.className += " black";
        el2.className += " black";
        el3.className += " black";
        el4.className += " black";
      }
    },
    changeClassSepia: function changeClassSepia() {
      var el = document.getElementsByClassName("book-content")[0];
      var el2 = document.getElementsByClassName("nav-btn")[0];
      var el3 = document.getElementsByClassName("nav-btn")[1];
      var el4 = document.getElementsByTagName("footer")[0];
      if (el.classList && el2.classList && el3.classList && el4.classList) {
        el.classList.remove("black");
        el2.classList.remove("black");
        el3.classList.remove("black");
        el4.classList.remove("black");
        el.classList.remove("white");
        el2.classList.remove("white");
        el3.classList.remove("white");
        el4.classList.remove("white");
        el.classList.add("sepia");
        el2.classList.add("sepia");
        el3.classList.add("sepia");
        el4.classList.add("sepia");
      } else {
        el.className += " sepia";
        el2.className += " sepia";
        el3.className += " sepia";
        el4.className += " sepia";
      }
    }
  }
});

/***/ }),
/* 27 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "settings"
  }, [_c('ul', {
    staticClass: "settings-list"
  }, [_c('li', [_c('span', [_vm._v("Reload book: ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "id": "reloadBookBtn",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.reloadBook()
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-loop-strong")])], 1)], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Font:")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.fonts,
      "overflow": "",
      "single-line": "",
      "return-objectauto": "",
      "append-icon": "ion-ios-arrow-down",
      "hide-details": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawerRight = true
      }
    },
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  })], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Font size:")]), _vm._v(" "), _c('p', {
    staticClass: "bold-font",
    domProps: {
      "innerHTML": _vm._s(_vm.value1 + 'px' || null)
    }
  }), _vm._v(" "), _c('v-slider', {
    attrs: {
      "min": 17,
      "max": 27,
      "step": 1
    },
    model: {
      value: (_vm.value1),
      callback: function($$v) {
        _vm.value1 = $$v
      },
      expression: "value1"
    }
  })], 1), _vm._v(" "), _c('li', {
    staticClass: "columns-setting"
  }, [_c('span', [_vm._v("Page columns:")]), _c('br'), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Auto",
      "value": "Auto",
      "flat": "",
      "ripple": false,
      "prepend-icon": ""
    },
    model: {
      value: (_vm.ex8),
      callback: function($$v) {
        _vm.ex8 = $$v
      },
      expression: "ex8"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Single",
      "value": "Single",
      "flat": "",
      "ripple": false,
      "prepend-icon": ""
    },
    model: {
      value: (_vm.ex8),
      callback: function($$v) {
        _vm.ex8 = $$v
      },
      expression: "ex8"
    }
  })], 1), _vm._v(" "), _c('li', {
    staticClass: "width-setting"
  }, [_c('span', [_vm._v("Page width:")]), _vm._v(" "), _c('p', {
    staticClass: "bold-font",
    domProps: {
      "innerHTML": _vm._s(_vm.value2 + '%' || null)
    }
  }), _vm._v(" "), _c('v-slider', {
    attrs: {
      "min": 50,
      "max": 90
    },
    model: {
      value: (_vm.value2),
      callback: function($$v) {
        _vm.value2 = $$v
      },
      expression: "value2"
    }
  })], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Brightness:")]), _vm._v(" "), _c('p', {
    staticClass: "bold-font",
    domProps: {
      "innerHTML": _vm._s((_vm.value3 - 100) + '%' || null)
    }
  }), _vm._v(" "), _c('v-slider', {
    attrs: {
      "step": 1,
      "min": 0,
      "max": 200
    },
    model: {
      value: (_vm.value3),
      callback: function($$v) {
        _vm.value3 = $$v
      },
      expression: "value3"
    }
  })], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Color mode:")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    attrs: {
      "id": "colors"
    }
  }, [_c('v-btn', {
    attrs: {
      "flat": "",
      "id": "white",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeClassWhite()
      }
    }
  }, [_vm._v("\n          White\n        ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "id": "black",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeClassBlack()
      }
    }
  }, [_vm._v("\n          Black\n        ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "id": "sepia",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeClassSepia()
      }
    }
  }, [_vm._v("\n          Sepia\n        ")])], 1)])])])
},staticRenderFns: []}

/***/ }),
/* 28 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrap",
    style: ({
      'filter': 'brightness(' + _vm.brightness + '%)',
      'height': _vm.height - 49 + 'px'
    })
  }, [_c('v-progress-linear', {
    model: {
      value: (_vm.progress),
      callback: function($$v) {
        _vm.progress = $$v
      },
      expression: "progress"
    }
  }), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "shortkey",
      rawName: "v-shortkey",
      value: (['arrowleft']),
      expression: "['arrowleft']"
    }],
    staticClass: "nav-btn left",
    style: ({
      width: (100 - _vm.widthSize) + '%'
    }),
    attrs: {
      "ripple": false
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.prev($event)
      },
      "shortkey": _vm.prev
    }
  }, [_c('v-icon', {
    style: ({
      'left': (_vm.widthSize / 3.5) + '%'
    })
  }, [_vm._v("ion-ios-arrow-left")])], 1), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "shortkey",
      rawName: "v-shortkey",
      value: (['arrowright']),
      expression: "['arrowright']"
    }],
    staticClass: "nav-btn right",
    style: ({
      width: (100 - _vm.widthSize) + '%'
    }),
    attrs: {
      "ripple": false
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.next($event)
      },
      "shortkey": _vm.next
    }
  }, [_c('v-icon', {
    style: ({
      'right': (_vm.widthSize / 3.5) + '%'
    })
  }, [_vm._v("ion-ios-arrow-right")])], 1), _vm._v(" "), _c('div', {
    staticClass: "book-content",
    style: ({
      'width': _vm.widthSize + '%',
      'background-color': _vm.currentColor,
      'height': _vm.height - 78 + 'px'
    }),
    on: {
      "mouseenter": _vm.over,
      "mouseleave": _vm.out
    }
  }, [(_vm.isMobile) ? _c('v-touch', {
    staticClass: "touch-swipe",
    class: {
      active: _vm.hiddenEl
    },
    on: {
      "swipeleft": _vm.next,
      "swiperight": _vm.prev,
      "tap": _vm.tapped
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    key: _vm.div,
    staticClass: "book-page",
    class: _vm.fontFamily,
    style: ({
      'font-size': _vm.fontSize + 'px',
      'columns': _vm.cols
    }),
    attrs: {
      "enable-resize-watcher": ""
    },
    on: {
      "tap": _vm.tappedIn,
      "swipe": _vm.tappedIn,
      "click": _vm.tappedIn
    }
  }, [_c('transition', {
    attrs: {
      "name": _vm.routeTransition,
      "mode": "out-in"
    }
  }, [_c('router-view', {
    key: _vm.$route.name,
    staticClass: "view"
  })], 1)], 1)], 1), _vm._v(" "), _c('footer', {
    class: _vm.fontFamily,
    style: ({
      'font-size': (_vm.fontSize - 5) + 'px'
    })
  }, [(_vm.brandReaderUrl) ? _c('div', [_c('v-btn', {
    staticClass: "HC-footer-button",
    attrs: {
      "flat": "",
      "ripple": false,
      "tag": "a",
      "href": _vm.brandReaderUrl,
      "target": "_blank"
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = false, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('i', [_c('img', {
    attrs: {
      "src": _vm.brandLogoUrl
    }
  })])])], 1) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('div', {
    staticClass: "foots"
  }, [_c('span', [_c('em', [_vm._v(_vm._s(this.$route.name))])]), _vm._v(" - page "), _c('span', [_c('em', [_vm._v(_vm._s(this.pageNumber))])]), _vm._v(" "), (this.totalPages > 1) ? _c('span', [_c('em', [_vm._v(_vm._s("/ " + this.totalPages))])]) : _vm._e()]), _vm._v(" "), _c('v-spacer')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(30);

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var bind = __webpack_require__(8);
var Axios = __webpack_require__(31);
var mergeConfig = __webpack_require__(14);
var defaults = __webpack_require__(11);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(mergeConfig(axios.defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(15);
axios.CancelToken = __webpack_require__(44);
axios.isCancel = __webpack_require__(10);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(45);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var buildURL = __webpack_require__(9);
var InterceptorManager = __webpack_require__(32);
var dispatchRequest = __webpack_require__(33);
var mergeConfig = __webpack_require__(14);

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = arguments[1] || {};
    config.url = arguments[0];
  } else {
    config = config || {};
  }

  config = mergeConfig(this.defaults, config);

  // Set config.method
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = 'get';
  }

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

Axios.prototype.getUri = function getUri(config) {
  config = mergeConfig(this.defaults, config);
  return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var transformData = __webpack_require__(34);
var isCancel = __webpack_require__(10);
var defaults = __webpack_require__(11);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(13);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  if (!validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }

  error.request = request;
  error.response = response;
  error.isAxiosError = true;

  error.toJSON = function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code
    };
  };
  return error;
};


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isAbsoluteURL = __webpack_require__(39);
var combineURLs = __webpack_require__(40);

/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */
module.exports = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
};


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
    (function standardBrowserEnv() {
      var msie = /(msie|trident)/i.test(navigator.userAgent);
      var urlParsingNode = document.createElement('a');
      var originURL;

      /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
      function resolveURL(url) {
        var href = url;

        if (msie) {
        // IE needs attribute set twice to normalize properties
          urlParsingNode.setAttribute('href', href);
          href = urlParsingNode.href;
        }

        urlParsingNode.setAttribute('href', href);

        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
          href: urlParsingNode.href,
          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
          host: urlParsingNode.host,
          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
          hostname: urlParsingNode.hostname,
          port: urlParsingNode.port,
          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
            urlParsingNode.pathname :
            '/' + urlParsingNode.pathname
        };
      }

      originURL = resolveURL(window.location.href);

      /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
      return function isURLSameOrigin(requestURL) {
        var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
        return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
      };
    })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return function isURLSameOrigin() {
        return true;
      };
    })()
);


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
    (function standardBrowserEnv() {
      return {
        write: function write(name, value, expires, path, domain, secure) {
          var cookie = [];
          cookie.push(name + '=' + encodeURIComponent(value));

          if (utils.isNumber(expires)) {
            cookie.push('expires=' + new Date(expires).toGMTString());
          }

          if (utils.isString(path)) {
            cookie.push('path=' + path);
          }

          if (utils.isString(domain)) {
            cookie.push('domain=' + domain);
          }

          if (secure === true) {
            cookie.push('secure');
          }

          document.cookie = cookie.join('; ');
        },

        read: function read(name) {
          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
          return (match ? decodeURIComponent(match[3]) : null);
        },

        remove: function remove(name) {
          this.write(name, '', Date.now() - 86400000);
        }
      };
    })() :

  // Non standard browser env (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return {
        write: function write() {},
        read: function read() { return null; },
        remove: function remove() {}
      };
    })()
);


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(15);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),
/* 46 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    attrs: {
      "toolbar": ""
    }
  }, [_c('v-dialog', {
    attrs: {
      "fullscreen": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.info = !_vm.info
      }
    },
    model: {
      value: (_vm.info),
      callback: function($$v) {
        _vm.info = $$v
      },
      expression: "info"
    }
  }, [_c('v-card', {
    staticClass: "infoDialog"
  }, [_c('div', {
    staticClass: "menuIns"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-navicon")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-ios-browsers-outline")])], 1), _vm._v(" "), _c('div', {
    staticClass: "menuInsTip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Contents")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Navigate to book chapters")])]), _vm._v(" "), _c('div', {
    staticClass: "menuInsTip2"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Related Books")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Other books you might like")])]), _vm._v(" "), _c('div', {
    staticClass: "socMenu"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-linkedin")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-facebook")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-twitter")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-tumblr")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-pinterest")])], 1), _vm._v(" "), _c('div', {
    staticClass: "socMenuMob"
  }, [_c('v-icon', [_vm._v("ion-android-share-alt")])], 1), _vm._v(" "), _c('div', {
    staticClass: "socMenuTip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Share Book")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Share book to your social network")])]), _vm._v(" "), _c('div', {
    staticClass: "resize-settings"
  }, [_c('v-icon', [_vm._v("ion-ios-gear-outline")])], 1), _vm._v(" "), _c('div', {
    staticClass: "resize-settings-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Settings button")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Change colors and fonts")])]), _vm._v(" "), _c('div', {
    staticClass: "left-button"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-ios-arrow-left")])], 1), _vm._v(" "), _c('div', {
    staticClass: "left-button-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Left/Previous")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Go to previous page or chapter in book view."), _c('br'), _vm._v("On touch screen swipe right.")])]), _vm._v(" "), _c('div', {
    staticClass: "right-button"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-ios-arrow-right")])], 1), _vm._v(" "), _c('div', {
    staticClass: "right-button-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Right/Next")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Go to next page or chapter in book view."), _c('br'), _vm._v("On touch screen swipe left.")])]), _vm._v(" "), _c('div', {
    staticClass: "buy-buttons"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-bag")])], 1), _vm._v(" "), _c('div', {
    staticClass: "buy-buttons-mob"
  }, [_c('v-icon', [_vm._v("ion-bag")])], 1), _vm._v(" "), _c('div', {
    staticClass: "buy-buttons-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Buy Book")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Click to stores where you can buy this book")])]), _vm._v(" "), _c('div', {
    staticClass: "headline"
  }, [_vm._v("Instructions")]), _vm._v(" "), _c('v-btn', {
    staticClass: "closeDialog",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.info = false
      }
    }
  }, [_vm._v("Close")])], 1)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "menu",
    attrs: {
      "temporary": "",
      "hide-overlay": "",
      "clipped": "",
      "enable-resize-watcher": "",
      "disable-route-watcher": "",
      "touchless": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = !_vm.drawer
      }
    },
    model: {
      value: (_vm.drawer),
      callback: function($$v) {
        _vm.drawer = $$v
      },
      expression: "drawer"
    }
  }, [_c('v-list', _vm._l((_vm.items), function(item) {
    return _c('v-list-tile', {
      key: item.name,
      attrs: {
        "href": item.path,
        "to": item.path,
        "exact": "",
        "ripple": false,
        "width": "100%"
      }
    }, [_c('v-list-tile-action', [_c('img', {
      attrs: {
        "height": "55px",
        "alt": item.alt,
        "src": item.image
      }
    })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      attrs: {
        "active": ""
      }
    }, [_vm._v(_vm._s(item.name))])], 1)], 1)
  }), 1)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "otherBooks",
    attrs: {
      "temporary": "",
      "hide-overlay": "",
      "clipped": "",
      "enable-resize-watcher": "",
      "disable-route-watcher": "",
      "touchless": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.otherBooks = !_vm.otherBooks
      }
    },
    model: {
      value: (_vm.otherBooks),
      callback: function($$v) {
        _vm.otherBooks = $$v
      },
      expression: "otherBooks"
    }
  }, [_c('v-list', [_c('h6', [_vm._v("Other books you might like:")]), _vm._v(" "), _vm._l((_vm.books), function(book) {
    return _c('v-list-tile', {
      key: book.title,
      attrs: {
        "href": book.url,
        "target": "_blank",
        "ripple": false,
        "width": "100%"
      }
    }, [_c('v-list-tile-action', [_c('img', {
      attrs: {
        "alt": book.alt,
        "src": book.img
      }
    })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      attrs: {
        "active": ""
      }
    }, [_vm._v(_vm._s(book.title))])], 1)], 1)
  })], 2)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "settings-drawer",
    attrs: {
      "temporary": "",
      "hide-overlay": "",
      "clipped": "",
      "right": "",
      "enable-resize-watcher": "",
      "touchless": ""
    },
    model: {
      value: (_vm.drawerRight),
      callback: function($$v) {
        _vm.drawerRight = $$v
      },
      expression: "drawerRight"
    }
  }, [_c('v-list', [_c('settings')], 1)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "mini-bar",
    attrs: {
      "mini-variant": "",
      "enable-resize-watcher": "",
      "touchless": ""
    },
    model: {
      value: (_vm.buyBar),
      callback: function($$v) {
        _vm.buyBar = $$v
      },
      expression: "buyBar"
    }
  }, [_c('v-list', {
    attrs: {
      "ripple": false
    }
  }, [_vm._v("Shop:\n      "), _vm._l((_vm.buys), function(buy) {
    return _c('v-list-tile', {
      key: buy.title,
      attrs: {
        "href": buy.url,
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          return _vm.buyClick(buy.url)
        }
      }
    }, [_c('img', {
      attrs: {
        "alt": buy.alt,
        "src": buy.img
      }
    })])
  })], 2)], 1), _vm._v(" "), _c('v-toolbar', {
    staticClass: "main-menu",
    attrs: {
      "fixed": "",
      "persistent": ""
    }
  }, [_c('v-btn', {
    staticClass: "main-menu-button",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = !_vm.drawer, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-navicon")])], 1), _vm._v(" "), (_vm.books.length > 0) ? _c('v-btn', {
    key: _vm.booksChanged,
    staticClass: "otherBooks-button",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.otherBooks = !_vm.otherBooks, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.drawer = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-browsers-outline")])], 1) : _vm._e(), _vm._v(" "), _c('v-toolbar', {
    staticClass: "desktop-social-btn",
    staticStyle: {
      "margin-left": "5%"
    }
  }, _vm._l((_vm.socials), function(social) {
    return _c('v-btn', {
      key: social.title,
      attrs: {
        "flat": "",
        "href": social.url,
        "target": "_blank",
        "ripple": false
      },
      on: {
        "click": function($event) {
          return _vm.shareClick(social.title)
        }
      }
    }, [_c('v-icon', [_vm._v(_vm._s(social.icon))])], 1)
  }), 1), _vm._v(" "), _c('v-btn', {
    staticClass: "mobile-buy-btn",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.buyMenu = !_vm.buyMenu, _vm.info = false, _vm.drawer = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-bag")])], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "buy-menu",
    attrs: {
      "width": "100vw",
      "height": "auto",
      "hide-overlay": "",
      "temporary": "",
      "clipped": "",
      "disable-route-watcher": "",
      "touchless": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.buyMenu = !_vm.buyMenu
      }
    },
    model: {
      value: (_vm.buyMenu),
      callback: function($$v) {
        _vm.buyMenu = $$v
      },
      expression: "buyMenu"
    }
  }, [_c('v-list', [_c('span', [_vm._v("Purchase this book: ")]), _vm._v(" "), _vm._l((_vm.buys), function(buy) {
    return _c('v-list-tile', {
      key: buy.title,
      attrs: {
        "href": buy.url,
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          return _vm.buyClick(buy.url)
        }
      }
    }, [_c('v-list-tile-action', [_c('img', {
      attrs: {
        "alt": buy.alt,
        "src": buy.img
      }
    })]), _vm._v(" "), _c('v-list-tile-title', {
      domProps: {
        "innerHTML": _vm._s(buy.title)
      }
    })], 1)
  })], 2)], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "mobile-social-btn",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.socialMenu = !_vm.socialMenu, _vm.info = false, _vm.buyMenu = false, _vm.drawer = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-android-share-alt")])], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "social-menu",
    attrs: {
      "width": "100vw",
      "height": "auto",
      "hide-overlay": "",
      "temporary": "",
      "clipped": "",
      "disable-route-watcher": "",
      "persistent": "",
      "touchless": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.socialMenu = !_vm.socialMenu
      }
    },
    model: {
      value: (_vm.socialMenu),
      callback: function($$v) {
        _vm.socialMenu = $$v
      },
      expression: "socialMenu"
    }
  }, [_c('v-list', [_c('span', [_vm._v("Share this book: ")]), _vm._v(" "), _vm._l((_vm.socials), function(social) {
    return _c('v-list-tile', {
      key: social.title,
      attrs: {
        "href": social.url,
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          return _vm.shareClick(social.title)
        }
      }
    }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v(_vm._s(social.icon))])], 1), _vm._v(" "), _c('v-list-tile-title', {
      domProps: {
        "innerHTML": _vm._s(social.title)
      }
    })], 1)
  })], 2)], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "info-btn",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.info = !_vm.info, _vm.drawer = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-information-outline")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "settings-button",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawerRight = !_vm.drawerRight, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawer = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-gear-outline")])], 1)], 1), _vm._v(" "), _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('reader')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Reader__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Reader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Reader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_home__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_01_cover__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_01_cover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_01_cover__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_01_title__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_01_title___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_01_title__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_02_photo1__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_02_photo1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_02_photo1__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_03_dedication__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_03_dedication___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_03_dedication__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_04_copyright__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_04_copyright___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_04_copyright__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_05_contents__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_05_contents___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_05_contents__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_06_introduction__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_06_introduction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_06_introduction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_07_acknowledgement__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_07_acknowledgement___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_07_acknowledgement__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_08_abbreviation__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_08_abbreviation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_08_abbreviation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_09_ch01__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_09_ch01___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_09_ch01__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_10_img1__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_10_img1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_10_img1__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_11_ch011__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_11_ch011___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_11_ch011__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_12_img2__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_12_img2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_12_img2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_13_ch012__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_13_ch012___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_13_ch012__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_14_img3__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_14_img3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_14_img3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_15_ch013__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_15_ch013___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__components_15_ch013__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_20_bibliography__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_20_bibliography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__components_20_bibliography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_last__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_last___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__components_last__);
/*jshint esversion: 6 */
























__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    "path": "/",
    "name": "home",
    "component": __WEBPACK_IMPORTED_MODULE_3__components_home___default.a
  }, {
    "path": "/05_contents",
    "name": "05_contents",
    "component": __WEBPACK_IMPORTED_MODULE_9__components_05_contents___default.a
  }, {
    "path": "/06_introduction",
    "name": "06_introduction",
    "component": __WEBPACK_IMPORTED_MODULE_10__components_06_introduction___default.a
  }, {
    "path": "/07_acknowledgement",
    "name": "07_acknowledgement",
    "component": __WEBPACK_IMPORTED_MODULE_11__components_07_acknowledgement___default.a
  }, {
    "path": "/08_abbreviation",
    "name": "08_abbreviation",
    "component": __WEBPACK_IMPORTED_MODULE_12__components_08_abbreviation___default.a
  }, {
    "path": "/09_ch01",
    "name": "09_ch01",
    "component": __WEBPACK_IMPORTED_MODULE_13__components_09_ch01___default.a
  }, {
    "path": "/last",
    "name": "last",
    "component": __WEBPACK_IMPORTED_MODULE_21__components_last___default.a
  }]
}));

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
  * vue-router v2.8.1
  * (c) 2017 Evan You
  * @license MIT
  */
/*  */

function assert (condition, message) {
  if (!condition) {
    throw new Error(("[vue-router] " + message))
  }
}

function warn (condition, message) {
  if (false) {
    typeof console !== 'undefined' && console.warn(("[vue-router] " + message));
  }
}

function isError (err) {
  return Object.prototype.toString.call(err).indexOf('Error') > -1
}

var View = {
  name: 'router-view',
  functional: true,
  props: {
    name: {
      type: String,
      default: 'default'
    }
  },
  render: function render (_, ref) {
    var props = ref.props;
    var children = ref.children;
    var parent = ref.parent;
    var data = ref.data;

    data.routerView = true;

    // directly use parent context's createElement() function
    // so that components rendered by router-view can resolve named slots
    var h = parent.$createElement;
    var name = props.name;
    var route = parent.$route;
    var cache = parent._routerViewCache || (parent._routerViewCache = {});

    // determine current view depth, also check to see if the tree
    // has been toggled inactive but kept-alive.
    var depth = 0;
    var inactive = false;
    while (parent && parent._routerRoot !== parent) {
      if (parent.$vnode && parent.$vnode.data.routerView) {
        depth++;
      }
      if (parent._inactive) {
        inactive = true;
      }
      parent = parent.$parent;
    }
    data.routerViewDepth = depth;

    // render previous view if the tree is inactive and kept-alive
    if (inactive) {
      return h(cache[name], data, children)
    }

    var matched = route.matched[depth];
    // render empty node if no matched route
    if (!matched) {
      cache[name] = null;
      return h()
    }

    var component = cache[name] = matched.components[name];

    // attach instance registration hook
    // this will be called in the instance's injected lifecycle hooks
    data.registerRouteInstance = function (vm, val) {
      // val could be undefined for unregistration
      var current = matched.instances[name];
      if (
        (val && current !== vm) ||
        (!val && current === vm)
      ) {
        matched.instances[name] = val;
      }
    }

    // also register instance in prepatch hook
    // in case the same component instance is reused across different routes
    ;(data.hook || (data.hook = {})).prepatch = function (_, vnode) {
      matched.instances[name] = vnode.componentInstance;
    };

    // resolve props
    var propsToPass = data.props = resolveProps(route, matched.props && matched.props[name]);
    if (propsToPass) {
      // clone to prevent mutation
      propsToPass = data.props = extend({}, propsToPass);
      // pass non-declared props as attrs
      var attrs = data.attrs = data.attrs || {};
      for (var key in propsToPass) {
        if (!component.props || !(key in component.props)) {
          attrs[key] = propsToPass[key];
          delete propsToPass[key];
        }
      }
    }

    return h(component, data, children)
  }
};

function resolveProps (route, config) {
  switch (typeof config) {
    case 'undefined':
      return
    case 'object':
      return config
    case 'function':
      return config(route)
    case 'boolean':
      return config ? route.params : undefined
    default:
      if (false) {
        warn(
          false,
          "props in \"" + (route.path) + "\" is a " + (typeof config) + ", " +
          "expecting an object, function or boolean."
        );
      }
  }
}

function extend (to, from) {
  for (var key in from) {
    to[key] = from[key];
  }
  return to
}

/*  */

var encodeReserveRE = /[!'()*]/g;
var encodeReserveReplacer = function (c) { return '%' + c.charCodeAt(0).toString(16); };
var commaRE = /%2C/g;

// fixed encodeURIComponent which is more conformant to RFC3986:
// - escapes [!'()*]
// - preserve commas
var encode = function (str) { return encodeURIComponent(str)
  .replace(encodeReserveRE, encodeReserveReplacer)
  .replace(commaRE, ','); };

var decode = decodeURIComponent;

function resolveQuery (
  query,
  extraQuery,
  _parseQuery
) {
  if ( extraQuery === void 0 ) extraQuery = {};

  var parse = _parseQuery || parseQuery;
  var parsedQuery;
  try {
    parsedQuery = parse(query || '');
  } catch (e) {
    "production" !== 'production' && warn(false, e.message);
    parsedQuery = {};
  }
  for (var key in extraQuery) {
    parsedQuery[key] = extraQuery[key];
  }
  return parsedQuery
}

function parseQuery (query) {
  var res = {};

  query = query.trim().replace(/^(\?|#|&)/, '');

  if (!query) {
    return res
  }

  query.split('&').forEach(function (param) {
    var parts = param.replace(/\+/g, ' ').split('=');
    var key = decode(parts.shift());
    var val = parts.length > 0
      ? decode(parts.join('='))
      : null;

    if (res[key] === undefined) {
      res[key] = val;
    } else if (Array.isArray(res[key])) {
      res[key].push(val);
    } else {
      res[key] = [res[key], val];
    }
  });

  return res
}

function stringifyQuery (obj) {
  var res = obj ? Object.keys(obj).map(function (key) {
    var val = obj[key];

    if (val === undefined) {
      return ''
    }

    if (val === null) {
      return encode(key)
    }

    if (Array.isArray(val)) {
      var result = [];
      val.forEach(function (val2) {
        if (val2 === undefined) {
          return
        }
        if (val2 === null) {
          result.push(encode(key));
        } else {
          result.push(encode(key) + '=' + encode(val2));
        }
      });
      return result.join('&')
    }

    return encode(key) + '=' + encode(val)
  }).filter(function (x) { return x.length > 0; }).join('&') : null;
  return res ? ("?" + res) : ''
}

/*  */


var trailingSlashRE = /\/?$/;

function createRoute (
  record,
  location,
  redirectedFrom,
  router
) {
  var stringifyQuery$$1 = router && router.options.stringifyQuery;

  var query = location.query || {};
  try {
    query = clone(query);
  } catch (e) {}

  var route = {
    name: location.name || (record && record.name),
    meta: (record && record.meta) || {},
    path: location.path || '/',
    hash: location.hash || '',
    query: query,
    params: location.params || {},
    fullPath: getFullPath(location, stringifyQuery$$1),
    matched: record ? formatMatch(record) : []
  };
  if (redirectedFrom) {
    route.redirectedFrom = getFullPath(redirectedFrom, stringifyQuery$$1);
  }
  return Object.freeze(route)
}

function clone (value) {
  if (Array.isArray(value)) {
    return value.map(clone)
  } else if (value && typeof value === 'object') {
    var res = {};
    for (var key in value) {
      res[key] = clone(value[key]);
    }
    return res
  } else {
    return value
  }
}

// the starting route that represents the initial state
var START = createRoute(null, {
  path: '/'
});

function formatMatch (record) {
  var res = [];
  while (record) {
    res.unshift(record);
    record = record.parent;
  }
  return res
}

function getFullPath (
  ref,
  _stringifyQuery
) {
  var path = ref.path;
  var query = ref.query; if ( query === void 0 ) query = {};
  var hash = ref.hash; if ( hash === void 0 ) hash = '';

  var stringify = _stringifyQuery || stringifyQuery;
  return (path || '/') + stringify(query) + hash
}

function isSameRoute (a, b) {
  if (b === START) {
    return a === b
  } else if (!b) {
    return false
  } else if (a.path && b.path) {
    return (
      a.path.replace(trailingSlashRE, '') === b.path.replace(trailingSlashRE, '') &&
      a.hash === b.hash &&
      isObjectEqual(a.query, b.query)
    )
  } else if (a.name && b.name) {
    return (
      a.name === b.name &&
      a.hash === b.hash &&
      isObjectEqual(a.query, b.query) &&
      isObjectEqual(a.params, b.params)
    )
  } else {
    return false
  }
}

function isObjectEqual (a, b) {
  if ( a === void 0 ) a = {};
  if ( b === void 0 ) b = {};

  // handle null value #1566
  if (!a || !b) { return a === b }
  var aKeys = Object.keys(a);
  var bKeys = Object.keys(b);
  if (aKeys.length !== bKeys.length) {
    return false
  }
  return aKeys.every(function (key) {
    var aVal = a[key];
    var bVal = b[key];
    // check nested equality
    if (typeof aVal === 'object' && typeof bVal === 'object') {
      return isObjectEqual(aVal, bVal)
    }
    return String(aVal) === String(bVal)
  })
}

function isIncludedRoute (current, target) {
  return (
    current.path.replace(trailingSlashRE, '/').indexOf(
      target.path.replace(trailingSlashRE, '/')
    ) === 0 &&
    (!target.hash || current.hash === target.hash) &&
    queryIncludes(current.query, target.query)
  )
}

function queryIncludes (current, target) {
  for (var key in target) {
    if (!(key in current)) {
      return false
    }
  }
  return true
}

/*  */

// work around weird flow bug
var toTypes = [String, Object];
var eventTypes = [String, Array];

var Link = {
  name: 'router-link',
  props: {
    to: {
      type: toTypes,
      required: true
    },
    tag: {
      type: String,
      default: 'a'
    },
    exact: Boolean,
    append: Boolean,
    replace: Boolean,
    activeClass: String,
    exactActiveClass: String,
    event: {
      type: eventTypes,
      default: 'click'
    }
  },
  render: function render (h) {
    var this$1 = this;

    var router = this.$router;
    var current = this.$route;
    var ref = router.resolve(this.to, current, this.append);
    var location = ref.location;
    var route = ref.route;
    var href = ref.href;

    var classes = {};
    var globalActiveClass = router.options.linkActiveClass;
    var globalExactActiveClass = router.options.linkExactActiveClass;
    // Support global empty active class
    var activeClassFallback = globalActiveClass == null
            ? 'router-link-active'
            : globalActiveClass;
    var exactActiveClassFallback = globalExactActiveClass == null
            ? 'router-link-exact-active'
            : globalExactActiveClass;
    var activeClass = this.activeClass == null
            ? activeClassFallback
            : this.activeClass;
    var exactActiveClass = this.exactActiveClass == null
            ? exactActiveClassFallback
            : this.exactActiveClass;
    var compareTarget = location.path
      ? createRoute(null, location, null, router)
      : route;

    classes[exactActiveClass] = isSameRoute(current, compareTarget);
    classes[activeClass] = this.exact
      ? classes[exactActiveClass]
      : isIncludedRoute(current, compareTarget);

    var handler = function (e) {
      if (guardEvent(e)) {
        if (this$1.replace) {
          router.replace(location);
        } else {
          router.push(location);
        }
      }
    };

    var on = { click: guardEvent };
    if (Array.isArray(this.event)) {
      this.event.forEach(function (e) { on[e] = handler; });
    } else {
      on[this.event] = handler;
    }

    var data = {
      class: classes
    };

    if (this.tag === 'a') {
      data.on = on;
      data.attrs = { href: href };
    } else {
      // find the first <a> child and apply listener and href
      var a = findAnchor(this.$slots.default);
      if (a) {
        // in case the <a> is a static node
        a.isStatic = false;
        var extend = _Vue.util.extend;
        var aData = a.data = extend({}, a.data);
        aData.on = on;
        var aAttrs = a.data.attrs = extend({}, a.data.attrs);
        aAttrs.href = href;
      } else {
        // doesn't have <a> child, apply listener to self
        data.on = on;
      }
    }

    return h(this.tag, data, this.$slots.default)
  }
};

function guardEvent (e) {
  // don't redirect with control keys
  if (e.metaKey || e.altKey || e.ctrlKey || e.shiftKey) { return }
  // don't redirect when preventDefault called
  if (e.defaultPrevented) { return }
  // don't redirect on right click
  if (e.button !== undefined && e.button !== 0) { return }
  // don't redirect if `target="_blank"`
  if (e.currentTarget && e.currentTarget.getAttribute) {
    var target = e.currentTarget.getAttribute('target');
    if (/\b_blank\b/i.test(target)) { return }
  }
  // this may be a Weex event which doesn't have this method
  if (e.preventDefault) {
    e.preventDefault();
  }
  return true
}

function findAnchor (children) {
  if (children) {
    var child;
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      if (child.tag === 'a') {
        return child
      }
      if (child.children && (child = findAnchor(child.children))) {
        return child
      }
    }
  }
}

var _Vue;

function install (Vue) {
  if (install.installed && _Vue === Vue) { return }
  install.installed = true;

  _Vue = Vue;

  var isDef = function (v) { return v !== undefined; };

  var registerInstance = function (vm, callVal) {
    var i = vm.$options._parentVnode;
    if (isDef(i) && isDef(i = i.data) && isDef(i = i.registerRouteInstance)) {
      i(vm, callVal);
    }
  };

  Vue.mixin({
    beforeCreate: function beforeCreate () {
      if (isDef(this.$options.router)) {
        this._routerRoot = this;
        this._router = this.$options.router;
        this._router.init(this);
        Vue.util.defineReactive(this, '_route', this._router.history.current);
      } else {
        this._routerRoot = (this.$parent && this.$parent._routerRoot) || this;
      }
      registerInstance(this, this);
    },
    destroyed: function destroyed () {
      registerInstance(this);
    }
  });

  Object.defineProperty(Vue.prototype, '$router', {
    get: function get () { return this._routerRoot._router }
  });

  Object.defineProperty(Vue.prototype, '$route', {
    get: function get () { return this._routerRoot._route }
  });

  Vue.component('router-view', View);
  Vue.component('router-link', Link);

  var strats = Vue.config.optionMergeStrategies;
  // use the same hook merging strategy for route hooks
  strats.beforeRouteEnter = strats.beforeRouteLeave = strats.beforeRouteUpdate = strats.created;
}

/*  */

var inBrowser = typeof window !== 'undefined';

/*  */

function resolvePath (
  relative,
  base,
  append
) {
  var firstChar = relative.charAt(0);
  if (firstChar === '/') {
    return relative
  }

  if (firstChar === '?' || firstChar === '#') {
    return base + relative
  }

  var stack = base.split('/');

  // remove trailing segment if:
  // - not appending
  // - appending to trailing slash (last segment is empty)
  if (!append || !stack[stack.length - 1]) {
    stack.pop();
  }

  // resolve relative path
  var segments = relative.replace(/^\//, '').split('/');
  for (var i = 0; i < segments.length; i++) {
    var segment = segments[i];
    if (segment === '..') {
      stack.pop();
    } else if (segment !== '.') {
      stack.push(segment);
    }
  }

  // ensure leading slash
  if (stack[0] !== '') {
    stack.unshift('');
  }

  return stack.join('/')
}

function parsePath (path) {
  var hash = '';
  var query = '';

  var hashIndex = path.indexOf('#');
  if (hashIndex >= 0) {
    hash = path.slice(hashIndex);
    path = path.slice(0, hashIndex);
  }

  var queryIndex = path.indexOf('?');
  if (queryIndex >= 0) {
    query = path.slice(queryIndex + 1);
    path = path.slice(0, queryIndex);
  }

  return {
    path: path,
    query: query,
    hash: hash
  }
}

function cleanPath (path) {
  return path.replace(/\/\//g, '/')
}

var isarray = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};

/**
 * Expose `pathToRegexp`.
 */
var pathToRegexp_1 = pathToRegexp;
var parse_1 = parse;
var compile_1 = compile;
var tokensToFunction_1 = tokensToFunction;
var tokensToRegExp_1 = tokensToRegExp;

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g');

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = [];
  var key = 0;
  var index = 0;
  var path = '';
  var defaultDelimiter = options && options.delimiter || '/';
  var res;

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0];
    var escaped = res[1];
    var offset = res.index;
    path += str.slice(index, offset);
    index = offset + m.length;

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1];
      continue
    }

    var next = str[index];
    var prefix = res[2];
    var name = res[3];
    var capture = res[4];
    var group = res[5];
    var modifier = res[6];
    var asterisk = res[7];

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path);
      path = '';
    }

    var partial = prefix != null && next != null && next !== prefix;
    var repeat = modifier === '+' || modifier === '*';
    var optional = modifier === '?' || modifier === '*';
    var delimiter = res[2] || defaultDelimiter;
    var pattern = capture || group;

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    });
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index);
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path);
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options))
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length);

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$');
    }
  }

  return function (obj, opts) {
    var path = '';
    var data = obj || {};
    var options = opts || {};
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent;

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i];

      if (typeof token === 'string') {
        path += token;

        continue
      }

      var value = data[token.name];
      var segment;

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix;
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j]);

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment;
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value);

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment;
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys;
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g);

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      });
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = [];

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source);
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options));

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  var strict = options.strict;
  var end = options.end !== false;
  var route = '';

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i];

    if (typeof token === 'string') {
      route += escapeString(token);
    } else {
      var prefix = escapeString(token.prefix);
      var capture = '(?:' + token.pattern + ')';

      keys.push(token);

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*';
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?';
        } else {
          capture = prefix + '(' + capture + ')?';
        }
      } else {
        capture = prefix + '(' + capture + ')';
      }

      route += capture;
    }
  }

  var delimiter = escapeString(options.delimiter || '/');
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?';
  }

  if (end) {
    route += '$';
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)';
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}

pathToRegexp_1.parse = parse_1;
pathToRegexp_1.compile = compile_1;
pathToRegexp_1.tokensToFunction = tokensToFunction_1;
pathToRegexp_1.tokensToRegExp = tokensToRegExp_1;

/*  */

// $flow-disable-line
var regexpCompileCache = Object.create(null);

function fillParams (
  path,
  params,
  routeMsg
) {
  try {
    var filler =
      regexpCompileCache[path] ||
      (regexpCompileCache[path] = pathToRegexp_1.compile(path));
    return filler(params || {}, { pretty: true })
  } catch (e) {
    if (false) {
      warn(false, ("missing param for " + routeMsg + ": " + (e.message)));
    }
    return ''
  }
}

/*  */

function createRouteMap (
  routes,
  oldPathList,
  oldPathMap,
  oldNameMap
) {
  // the path list is used to control path matching priority
  var pathList = oldPathList || [];
  // $flow-disable-line
  var pathMap = oldPathMap || Object.create(null);
  // $flow-disable-line
  var nameMap = oldNameMap || Object.create(null);

  routes.forEach(function (route) {
    addRouteRecord(pathList, pathMap, nameMap, route);
  });

  // ensure wildcard routes are always at the end
  for (var i = 0, l = pathList.length; i < l; i++) {
    if (pathList[i] === '*') {
      pathList.push(pathList.splice(i, 1)[0]);
      l--;
      i--;
    }
  }

  return {
    pathList: pathList,
    pathMap: pathMap,
    nameMap: nameMap
  }
}

function addRouteRecord (
  pathList,
  pathMap,
  nameMap,
  route,
  parent,
  matchAs
) {
  var path = route.path;
  var name = route.name;
  if (false) {
    assert(path != null, "\"path\" is required in a route configuration.");
    assert(
      typeof route.component !== 'string',
      "route config \"component\" for path: " + (String(path || name)) + " cannot be a " +
      "string id. Use an actual component instead."
    );
  }

  var pathToRegexpOptions = route.pathToRegexpOptions || {};
  var normalizedPath = normalizePath(
    path,
    parent,
    pathToRegexpOptions.strict
  );

  if (typeof route.caseSensitive === 'boolean') {
    pathToRegexpOptions.sensitive = route.caseSensitive;
  }

  var record = {
    path: normalizedPath,
    regex: compileRouteRegex(normalizedPath, pathToRegexpOptions),
    components: route.components || { default: route.component },
    instances: {},
    name: name,
    parent: parent,
    matchAs: matchAs,
    redirect: route.redirect,
    beforeEnter: route.beforeEnter,
    meta: route.meta || {},
    props: route.props == null
      ? {}
      : route.components
        ? route.props
        : { default: route.props }
  };

  if (route.children) {
    // Warn if route is named, does not redirect and has a default child route.
    // If users navigate to this route by name, the default child will
    // not be rendered (GH Issue #629)
    if (false) {
      if (route.name && !route.redirect && route.children.some(function (child) { return /^\/?$/.test(child.path); })) {
        warn(
          false,
          "Named Route '" + (route.name) + "' has a default child route. " +
          "When navigating to this named route (:to=\"{name: '" + (route.name) + "'\"), " +
          "the default child route will not be rendered. Remove the name from " +
          "this route and use the name of the default child route for named " +
          "links instead."
        );
      }
    }
    route.children.forEach(function (child) {
      var childMatchAs = matchAs
        ? cleanPath((matchAs + "/" + (child.path)))
        : undefined;
      addRouteRecord(pathList, pathMap, nameMap, child, record, childMatchAs);
    });
  }

  if (route.alias !== undefined) {
    var aliases = Array.isArray(route.alias)
      ? route.alias
      : [route.alias];

    aliases.forEach(function (alias) {
      var aliasRoute = {
        path: alias,
        children: route.children
      };
      addRouteRecord(
        pathList,
        pathMap,
        nameMap,
        aliasRoute,
        parent,
        record.path || '/' // matchAs
      );
    });
  }

  if (!pathMap[record.path]) {
    pathList.push(record.path);
    pathMap[record.path] = record;
  }

  if (name) {
    if (!nameMap[name]) {
      nameMap[name] = record;
    } else if (false) {
      warn(
        false,
        "Duplicate named routes definition: " +
        "{ name: \"" + name + "\", path: \"" + (record.path) + "\" }"
      );
    }
  }
}

function compileRouteRegex (path, pathToRegexpOptions) {
  var regex = pathToRegexp_1(path, [], pathToRegexpOptions);
  if (false) {
    var keys = Object.create(null);
    regex.keys.forEach(function (key) {
      warn(!keys[key.name], ("Duplicate param keys in route with path: \"" + path + "\""));
      keys[key.name] = true;
    });
  }
  return regex
}

function normalizePath (path, parent, strict) {
  if (!strict) { path = path.replace(/\/$/, ''); }
  if (path[0] === '/') { return path }
  if (parent == null) { return path }
  return cleanPath(((parent.path) + "/" + path))
}

/*  */


function normalizeLocation (
  raw,
  current,
  append,
  router
) {
  var next = typeof raw === 'string' ? { path: raw } : raw;
  // named target
  if (next.name || next._normalized) {
    return next
  }

  // relative params
  if (!next.path && next.params && current) {
    next = assign({}, next);
    next._normalized = true;
    var params = assign(assign({}, current.params), next.params);
    if (current.name) {
      next.name = current.name;
      next.params = params;
    } else if (current.matched.length) {
      var rawPath = current.matched[current.matched.length - 1].path;
      next.path = fillParams(rawPath, params, ("path " + (current.path)));
    } else if (false) {
      warn(false, "relative params navigation requires a current route.");
    }
    return next
  }

  var parsedPath = parsePath(next.path || '');
  var basePath = (current && current.path) || '/';
  var path = parsedPath.path
    ? resolvePath(parsedPath.path, basePath, append || next.append)
    : basePath;

  var query = resolveQuery(
    parsedPath.query,
    next.query,
    router && router.options.parseQuery
  );

  var hash = next.hash || parsedPath.hash;
  if (hash && hash.charAt(0) !== '#') {
    hash = "#" + hash;
  }

  return {
    _normalized: true,
    path: path,
    query: query,
    hash: hash
  }
}

function assign (a, b) {
  for (var key in b) {
    a[key] = b[key];
  }
  return a
}

/*  */


function createMatcher (
  routes,
  router
) {
  var ref = createRouteMap(routes);
  var pathList = ref.pathList;
  var pathMap = ref.pathMap;
  var nameMap = ref.nameMap;

  function addRoutes (routes) {
    createRouteMap(routes, pathList, pathMap, nameMap);
  }

  function match (
    raw,
    currentRoute,
    redirectedFrom
  ) {
    var location = normalizeLocation(raw, currentRoute, false, router);
    var name = location.name;

    if (name) {
      var record = nameMap[name];
      if (false) {
        warn(record, ("Route with name '" + name + "' does not exist"));
      }
      if (!record) { return _createRoute(null, location) }
      var paramNames = record.regex.keys
        .filter(function (key) { return !key.optional; })
        .map(function (key) { return key.name; });

      if (typeof location.params !== 'object') {
        location.params = {};
      }

      if (currentRoute && typeof currentRoute.params === 'object') {
        for (var key in currentRoute.params) {
          if (!(key in location.params) && paramNames.indexOf(key) > -1) {
            location.params[key] = currentRoute.params[key];
          }
        }
      }

      if (record) {
        location.path = fillParams(record.path, location.params, ("named route \"" + name + "\""));
        return _createRoute(record, location, redirectedFrom)
      }
    } else if (location.path) {
      location.params = {};
      for (var i = 0; i < pathList.length; i++) {
        var path = pathList[i];
        var record$1 = pathMap[path];
        if (matchRoute(record$1.regex, location.path, location.params)) {
          return _createRoute(record$1, location, redirectedFrom)
        }
      }
    }
    // no match
    return _createRoute(null, location)
  }

  function redirect (
    record,
    location
  ) {
    var originalRedirect = record.redirect;
    var redirect = typeof originalRedirect === 'function'
        ? originalRedirect(createRoute(record, location, null, router))
        : originalRedirect;

    if (typeof redirect === 'string') {
      redirect = { path: redirect };
    }

    if (!redirect || typeof redirect !== 'object') {
      if (false) {
        warn(
          false, ("invalid redirect option: " + (JSON.stringify(redirect)))
        );
      }
      return _createRoute(null, location)
    }

    var re = redirect;
    var name = re.name;
    var path = re.path;
    var query = location.query;
    var hash = location.hash;
    var params = location.params;
    query = re.hasOwnProperty('query') ? re.query : query;
    hash = re.hasOwnProperty('hash') ? re.hash : hash;
    params = re.hasOwnProperty('params') ? re.params : params;

    if (name) {
      // resolved named direct
      var targetRecord = nameMap[name];
      if (false) {
        assert(targetRecord, ("redirect failed: named route \"" + name + "\" not found."));
      }
      return match({
        _normalized: true,
        name: name,
        query: query,
        hash: hash,
        params: params
      }, undefined, location)
    } else if (path) {
      // 1. resolve relative redirect
      var rawPath = resolveRecordPath(path, record);
      // 2. resolve params
      var resolvedPath = fillParams(rawPath, params, ("redirect route with path \"" + rawPath + "\""));
      // 3. rematch with existing query and hash
      return match({
        _normalized: true,
        path: resolvedPath,
        query: query,
        hash: hash
      }, undefined, location)
    } else {
      if (false) {
        warn(false, ("invalid redirect option: " + (JSON.stringify(redirect))));
      }
      return _createRoute(null, location)
    }
  }

  function alias (
    record,
    location,
    matchAs
  ) {
    var aliasedPath = fillParams(matchAs, location.params, ("aliased route with path \"" + matchAs + "\""));
    var aliasedMatch = match({
      _normalized: true,
      path: aliasedPath
    });
    if (aliasedMatch) {
      var matched = aliasedMatch.matched;
      var aliasedRecord = matched[matched.length - 1];
      location.params = aliasedMatch.params;
      return _createRoute(aliasedRecord, location)
    }
    return _createRoute(null, location)
  }

  function _createRoute (
    record,
    location,
    redirectedFrom
  ) {
    if (record && record.redirect) {
      return redirect(record, redirectedFrom || location)
    }
    if (record && record.matchAs) {
      return alias(record, location, record.matchAs)
    }
    return createRoute(record, location, redirectedFrom, router)
  }

  return {
    match: match,
    addRoutes: addRoutes
  }
}

function matchRoute (
  regex,
  path,
  params
) {
  var m = path.match(regex);

  if (!m) {
    return false
  } else if (!params) {
    return true
  }

  for (var i = 1, len = m.length; i < len; ++i) {
    var key = regex.keys[i - 1];
    var val = typeof m[i] === 'string' ? decodeURIComponent(m[i]) : m[i];
    if (key) {
      params[key.name] = val;
    }
  }

  return true
}

function resolveRecordPath (path, record) {
  return resolvePath(path, record.parent ? record.parent.path : '/', true)
}

/*  */


var positionStore = Object.create(null);

function setupScroll () {
  // Fix for #1585 for Firefox
  window.history.replaceState({ key: getStateKey() }, '');
  window.addEventListener('popstate', function (e) {
    saveScrollPosition();
    if (e.state && e.state.key) {
      setStateKey(e.state.key);
    }
  });
}

function handleScroll (
  router,
  to,
  from,
  isPop
) {
  if (!router.app) {
    return
  }

  var behavior = router.options.scrollBehavior;
  if (!behavior) {
    return
  }

  if (false) {
    assert(typeof behavior === 'function', "scrollBehavior must be a function");
  }

  // wait until re-render finishes before scrolling
  router.app.$nextTick(function () {
    var position = getScrollPosition();
    var shouldScroll = behavior(to, from, isPop ? position : null);

    if (!shouldScroll) {
      return
    }

    if (typeof shouldScroll.then === 'function') {
      shouldScroll.then(function (shouldScroll) {
        scrollToPosition((shouldScroll), position);
      }).catch(function (err) {
        if (false) {
          assert(false, err.toString());
        }
      });
    } else {
      scrollToPosition(shouldScroll, position);
    }
  });
}

function saveScrollPosition () {
  var key = getStateKey();
  if (key) {
    positionStore[key] = {
      x: window.pageXOffset,
      y: window.pageYOffset
    };
  }
}

function getScrollPosition () {
  var key = getStateKey();
  if (key) {
    return positionStore[key]
  }
}

function getElementPosition (el, offset) {
  var docEl = document.documentElement;
  var docRect = docEl.getBoundingClientRect();
  var elRect = el.getBoundingClientRect();
  return {
    x: elRect.left - docRect.left - offset.x,
    y: elRect.top - docRect.top - offset.y
  }
}

function isValidPosition (obj) {
  return isNumber(obj.x) || isNumber(obj.y)
}

function normalizePosition (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : window.pageXOffset,
    y: isNumber(obj.y) ? obj.y : window.pageYOffset
  }
}

function normalizeOffset (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : 0,
    y: isNumber(obj.y) ? obj.y : 0
  }
}

function isNumber (v) {
  return typeof v === 'number'
}

function scrollToPosition (shouldScroll, position) {
  var isObject = typeof shouldScroll === 'object';
  if (isObject && typeof shouldScroll.selector === 'string') {
    var el = document.querySelector(shouldScroll.selector);
    if (el) {
      var offset = shouldScroll.offset && typeof shouldScroll.offset === 'object' ? shouldScroll.offset : {};
      offset = normalizeOffset(offset);
      position = getElementPosition(el, offset);
    } else if (isValidPosition(shouldScroll)) {
      position = normalizePosition(shouldScroll);
    }
  } else if (isObject && isValidPosition(shouldScroll)) {
    position = normalizePosition(shouldScroll);
  }

  if (position) {
    window.scrollTo(position.x, position.y);
  }
}

/*  */

var supportsPushState = inBrowser && (function () {
  var ua = window.navigator.userAgent;

  if (
    (ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) &&
    ua.indexOf('Mobile Safari') !== -1 &&
    ua.indexOf('Chrome') === -1 &&
    ua.indexOf('Windows Phone') === -1
  ) {
    return false
  }

  return window.history && 'pushState' in window.history
})();

// use User Timing api (if present) for more accurate key precision
var Time = inBrowser && window.performance && window.performance.now
  ? window.performance
  : Date;

var _key = genKey();

function genKey () {
  return Time.now().toFixed(3)
}

function getStateKey () {
  return _key
}

function setStateKey (key) {
  _key = key;
}

function pushState (url, replace) {
  saveScrollPosition();
  // try...catch the pushState call to get around Safari
  // DOM Exception 18 where it limits to 100 pushState calls
  var history = window.history;
  try {
    if (replace) {
      history.replaceState({ key: _key }, '', url);
    } else {
      _key = genKey();
      history.pushState({ key: _key }, '', url);
    }
  } catch (e) {
    window.location[replace ? 'replace' : 'assign'](url);
  }
}

function replaceState (url) {
  pushState(url, true);
}

/*  */

function runQueue (queue, fn, cb) {
  var step = function (index) {
    if (index >= queue.length) {
      cb();
    } else {
      if (queue[index]) {
        fn(queue[index], function () {
          step(index + 1);
        });
      } else {
        step(index + 1);
      }
    }
  };
  step(0);
}

/*  */

function resolveAsyncComponents (matched) {
  return function (to, from, next) {
    var hasAsync = false;
    var pending = 0;
    var error = null;

    flatMapComponents(matched, function (def, _, match, key) {
      // if it's a function and doesn't have cid attached,
      // assume it's an async component resolve function.
      // we are not using Vue's default async resolving mechanism because
      // we want to halt the navigation until the incoming component has been
      // resolved.
      if (typeof def === 'function' && def.cid === undefined) {
        hasAsync = true;
        pending++;

        var resolve = once(function (resolvedDef) {
          if (isESModule(resolvedDef)) {
            resolvedDef = resolvedDef.default;
          }
          // save resolved on async factory in case it's used elsewhere
          def.resolved = typeof resolvedDef === 'function'
            ? resolvedDef
            : _Vue.extend(resolvedDef);
          match.components[key] = resolvedDef;
          pending--;
          if (pending <= 0) {
            next();
          }
        });

        var reject = once(function (reason) {
          var msg = "Failed to resolve async component " + key + ": " + reason;
          "production" !== 'production' && warn(false, msg);
          if (!error) {
            error = isError(reason)
              ? reason
              : new Error(msg);
            next(error);
          }
        });

        var res;
        try {
          res = def(resolve, reject);
        } catch (e) {
          reject(e);
        }
        if (res) {
          if (typeof res.then === 'function') {
            res.then(resolve, reject);
          } else {
            // new syntax in Vue 2.3
            var comp = res.component;
            if (comp && typeof comp.then === 'function') {
              comp.then(resolve, reject);
            }
          }
        }
      }
    });

    if (!hasAsync) { next(); }
  }
}

function flatMapComponents (
  matched,
  fn
) {
  return flatten(matched.map(function (m) {
    return Object.keys(m.components).map(function (key) { return fn(
      m.components[key],
      m.instances[key],
      m, key
    ); })
  }))
}

function flatten (arr) {
  return Array.prototype.concat.apply([], arr)
}

var hasSymbol =
  typeof Symbol === 'function' &&
  typeof Symbol.toStringTag === 'symbol';

function isESModule (obj) {
  return obj.__esModule || (hasSymbol && obj[Symbol.toStringTag] === 'Module')
}

// in Webpack 2, require.ensure now also returns a Promise
// so the resolve/reject functions may get called an extra time
// if the user uses an arrow function shorthand that happens to
// return that Promise.
function once (fn) {
  var called = false;
  return function () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    if (called) { return }
    called = true;
    return fn.apply(this, args)
  }
}

/*  */

var History = function History (router, base) {
  this.router = router;
  this.base = normalizeBase(base);
  // start with a route object that stands for "nowhere"
  this.current = START;
  this.pending = null;
  this.ready = false;
  this.readyCbs = [];
  this.readyErrorCbs = [];
  this.errorCbs = [];
};

History.prototype.listen = function listen (cb) {
  this.cb = cb;
};

History.prototype.onReady = function onReady (cb, errorCb) {
  if (this.ready) {
    cb();
  } else {
    this.readyCbs.push(cb);
    if (errorCb) {
      this.readyErrorCbs.push(errorCb);
    }
  }
};

History.prototype.onError = function onError (errorCb) {
  this.errorCbs.push(errorCb);
};

History.prototype.transitionTo = function transitionTo (location, onComplete, onAbort) {
    var this$1 = this;

  var route = this.router.match(location, this.current);
  this.confirmTransition(route, function () {
    this$1.updateRoute(route);
    onComplete && onComplete(route);
    this$1.ensureURL();

    // fire ready cbs once
    if (!this$1.ready) {
      this$1.ready = true;
      this$1.readyCbs.forEach(function (cb) { cb(route); });
    }
  }, function (err) {
    if (onAbort) {
      onAbort(err);
    }
    if (err && !this$1.ready) {
      this$1.ready = true;
      this$1.readyErrorCbs.forEach(function (cb) { cb(err); });
    }
  });
};

History.prototype.confirmTransition = function confirmTransition (route, onComplete, onAbort) {
    var this$1 = this;

  var current = this.current;
  var abort = function (err) {
    if (isError(err)) {
      if (this$1.errorCbs.length) {
        this$1.errorCbs.forEach(function (cb) { cb(err); });
      } else {
        warn(false, 'uncaught error during route navigation:');
        console.error(err);
      }
    }
    onAbort && onAbort(err);
  };
  if (
    isSameRoute(route, current) &&
    // in the case the route map has been dynamically appended to
    route.matched.length === current.matched.length
  ) {
    this.ensureURL();
    return abort()
  }

  var ref = resolveQueue(this.current.matched, route.matched);
    var updated = ref.updated;
    var deactivated = ref.deactivated;
    var activated = ref.activated;

  var queue = [].concat(
    // in-component leave guards
    extractLeaveGuards(deactivated),
    // global before hooks
    this.router.beforeHooks,
    // in-component update hooks
    extractUpdateHooks(updated),
    // in-config enter guards
    activated.map(function (m) { return m.beforeEnter; }),
    // async components
    resolveAsyncComponents(activated)
  );

  this.pending = route;
  var iterator = function (hook, next) {
    if (this$1.pending !== route) {
      return abort()
    }
    try {
      hook(route, current, function (to) {
        if (to === false || isError(to)) {
          // next(false) -> abort navigation, ensure current URL
          this$1.ensureURL(true);
          abort(to);
        } else if (
          typeof to === 'string' ||
          (typeof to === 'object' && (
            typeof to.path === 'string' ||
            typeof to.name === 'string'
          ))
        ) {
          // next('/') or next({ path: '/' }) -> redirect
          abort();
          if (typeof to === 'object' && to.replace) {
            this$1.replace(to);
          } else {
            this$1.push(to);
          }
        } else {
          // confirm transition and pass on the value
          next(to);
        }
      });
    } catch (e) {
      abort(e);
    }
  };

  runQueue(queue, iterator, function () {
    var postEnterCbs = [];
    var isValid = function () { return this$1.current === route; };
    // wait until async components are resolved before
    // extracting in-component enter guards
    var enterGuards = extractEnterGuards(activated, postEnterCbs, isValid);
    var queue = enterGuards.concat(this$1.router.resolveHooks);
    runQueue(queue, iterator, function () {
      if (this$1.pending !== route) {
        return abort()
      }
      this$1.pending = null;
      onComplete(route);
      if (this$1.router.app) {
        this$1.router.app.$nextTick(function () {
          postEnterCbs.forEach(function (cb) { cb(); });
        });
      }
    });
  });
};

History.prototype.updateRoute = function updateRoute (route) {
  var prev = this.current;
  this.current = route;
  this.cb && this.cb(route);
  this.router.afterHooks.forEach(function (hook) {
    hook && hook(route, prev);
  });
};

function normalizeBase (base) {
  if (!base) {
    if (inBrowser) {
      // respect <base> tag
      var baseEl = document.querySelector('base');
      base = (baseEl && baseEl.getAttribute('href')) || '/';
      // strip full URL origin
      base = base.replace(/^https?:\/\/[^\/]+/, '');
    } else {
      base = '/';
    }
  }
  // make sure there's the starting slash
  if (base.charAt(0) !== '/') {
    base = '/' + base;
  }
  // remove trailing slash
  return base.replace(/\/$/, '')
}

function resolveQueue (
  current,
  next
) {
  var i;
  var max = Math.max(current.length, next.length);
  for (i = 0; i < max; i++) {
    if (current[i] !== next[i]) {
      break
    }
  }
  return {
    updated: next.slice(0, i),
    activated: next.slice(i),
    deactivated: current.slice(i)
  }
}

function extractGuards (
  records,
  name,
  bind,
  reverse
) {
  var guards = flatMapComponents(records, function (def, instance, match, key) {
    var guard = extractGuard(def, name);
    if (guard) {
      return Array.isArray(guard)
        ? guard.map(function (guard) { return bind(guard, instance, match, key); })
        : bind(guard, instance, match, key)
    }
  });
  return flatten(reverse ? guards.reverse() : guards)
}

function extractGuard (
  def,
  key
) {
  if (typeof def !== 'function') {
    // extend now so that global mixins are applied.
    def = _Vue.extend(def);
  }
  return def.options[key]
}

function extractLeaveGuards (deactivated) {
  return extractGuards(deactivated, 'beforeRouteLeave', bindGuard, true)
}

function extractUpdateHooks (updated) {
  return extractGuards(updated, 'beforeRouteUpdate', bindGuard)
}

function bindGuard (guard, instance) {
  if (instance) {
    return function boundRouteGuard () {
      return guard.apply(instance, arguments)
    }
  }
}

function extractEnterGuards (
  activated,
  cbs,
  isValid
) {
  return extractGuards(activated, 'beforeRouteEnter', function (guard, _, match, key) {
    return bindEnterGuard(guard, match, key, cbs, isValid)
  })
}

function bindEnterGuard (
  guard,
  match,
  key,
  cbs,
  isValid
) {
  return function routeEnterGuard (to, from, next) {
    return guard(to, from, function (cb) {
      next(cb);
      if (typeof cb === 'function') {
        cbs.push(function () {
          // #750
          // if a router-view is wrapped with an out-in transition,
          // the instance may not have been registered at this time.
          // we will need to poll for registration until current route
          // is no longer valid.
          poll(cb, match.instances, key, isValid);
        });
      }
    })
  }
}

function poll (
  cb, // somehow flow cannot infer this is a function
  instances,
  key,
  isValid
) {
  if (instances[key]) {
    cb(instances[key]);
  } else if (isValid()) {
    setTimeout(function () {
      poll(cb, instances, key, isValid);
    }, 16);
  }
}

/*  */


var HTML5History = (function (History$$1) {
  function HTML5History (router, base) {
    var this$1 = this;

    History$$1.call(this, router, base);

    var expectScroll = router.options.scrollBehavior;

    if (expectScroll) {
      setupScroll();
    }

    var initLocation = getLocation(this.base);
    window.addEventListener('popstate', function (e) {
      var current = this$1.current;

      // Avoiding first `popstate` event dispatched in some browsers but first
      // history route not updated since async guard at the same time.
      var location = getLocation(this$1.base);
      if (this$1.current === START && location === initLocation) {
        return
      }

      this$1.transitionTo(location, function (route) {
        if (expectScroll) {
          handleScroll(router, route, current, true);
        }
      });
    });
  }

  if ( History$$1 ) HTML5History.__proto__ = History$$1;
  HTML5History.prototype = Object.create( History$$1 && History$$1.prototype );
  HTML5History.prototype.constructor = HTML5History;

  HTML5History.prototype.go = function go (n) {
    window.history.go(n);
  };

  HTML5History.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      pushState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      replaceState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.ensureURL = function ensureURL (push) {
    if (getLocation(this.base) !== this.current.fullPath) {
      var current = cleanPath(this.base + this.current.fullPath);
      push ? pushState(current) : replaceState(current);
    }
  };

  HTML5History.prototype.getCurrentLocation = function getCurrentLocation () {
    return getLocation(this.base)
  };

  return HTML5History;
}(History));

function getLocation (base) {
  var path = window.location.pathname;
  if (base && path.indexOf(base) === 0) {
    path = path.slice(base.length);
  }
  return (path || '/') + window.location.search + window.location.hash
}

/*  */


var HashHistory = (function (History$$1) {
  function HashHistory (router, base, fallback) {
    History$$1.call(this, router, base);
    // check history fallback deeplinking
    if (fallback && checkFallback(this.base)) {
      return
    }
    ensureSlash();
  }

  if ( History$$1 ) HashHistory.__proto__ = History$$1;
  HashHistory.prototype = Object.create( History$$1 && History$$1.prototype );
  HashHistory.prototype.constructor = HashHistory;

  // this is delayed until the app mounts
  // to avoid the hashchange listener being fired too early
  HashHistory.prototype.setupListeners = function setupListeners () {
    var this$1 = this;

    var router = this.router;
    var expectScroll = router.options.scrollBehavior;
    var supportsScroll = supportsPushState && expectScroll;

    if (supportsScroll) {
      setupScroll();
    }

    window.addEventListener(supportsPushState ? 'popstate' : 'hashchange', function () {
      var current = this$1.current;
      if (!ensureSlash()) {
        return
      }
      this$1.transitionTo(getHash(), function (route) {
        if (supportsScroll) {
          handleScroll(this$1.router, route, current, true);
        }
        if (!supportsPushState) {
          replaceHash(route.fullPath);
        }
      });
    });
  };

  HashHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      pushHash(route.fullPath);
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HashHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      replaceHash(route.fullPath);
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HashHistory.prototype.go = function go (n) {
    window.history.go(n);
  };

  HashHistory.prototype.ensureURL = function ensureURL (push) {
    var current = this.current.fullPath;
    if (getHash() !== current) {
      push ? pushHash(current) : replaceHash(current);
    }
  };

  HashHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    return getHash()
  };

  return HashHistory;
}(History));

function checkFallback (base) {
  var location = getLocation(base);
  if (!/^\/#/.test(location)) {
    window.location.replace(
      cleanPath(base + '/#' + location)
    );
    return true
  }
}

function ensureSlash () {
  var path = getHash();
  if (path.charAt(0) === '/') {
    return true
  }
  replaceHash('/' + path);
  return false
}

function getHash () {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var index = href.indexOf('#');
  return index === -1 ? '' : href.slice(index + 1)
}

function getUrl (path) {
  var href = window.location.href;
  var i = href.indexOf('#');
  var base = i >= 0 ? href.slice(0, i) : href;
  return (base + "#" + path)
}

function pushHash (path) {
  if (supportsPushState) {
    pushState(getUrl(path));
  } else {
    window.location.hash = path;
  }
}

function replaceHash (path) {
  if (supportsPushState) {
    replaceState(getUrl(path));
  } else {
    window.location.replace(getUrl(path));
  }
}

/*  */


var AbstractHistory = (function (History$$1) {
  function AbstractHistory (router, base) {
    History$$1.call(this, router, base);
    this.stack = [];
    this.index = -1;
  }

  if ( History$$1 ) AbstractHistory.__proto__ = History$$1;
  AbstractHistory.prototype = Object.create( History$$1 && History$$1.prototype );
  AbstractHistory.prototype.constructor = AbstractHistory;

  AbstractHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(location, function (route) {
      this$1.stack = this$1.stack.slice(0, this$1.index + 1).concat(route);
      this$1.index++;
      onComplete && onComplete(route);
    }, onAbort);
  };

  AbstractHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(location, function (route) {
      this$1.stack = this$1.stack.slice(0, this$1.index).concat(route);
      onComplete && onComplete(route);
    }, onAbort);
  };

  AbstractHistory.prototype.go = function go (n) {
    var this$1 = this;

    var targetIndex = this.index + n;
    if (targetIndex < 0 || targetIndex >= this.stack.length) {
      return
    }
    var route = this.stack[targetIndex];
    this.confirmTransition(route, function () {
      this$1.index = targetIndex;
      this$1.updateRoute(route);
    });
  };

  AbstractHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    var current = this.stack[this.stack.length - 1];
    return current ? current.fullPath : '/'
  };

  AbstractHistory.prototype.ensureURL = function ensureURL () {
    // noop
  };

  return AbstractHistory;
}(History));

/*  */

var VueRouter = function VueRouter (options) {
  if ( options === void 0 ) options = {};

  this.app = null;
  this.apps = [];
  this.options = options;
  this.beforeHooks = [];
  this.resolveHooks = [];
  this.afterHooks = [];
  this.matcher = createMatcher(options.routes || [], this);

  var mode = options.mode || 'hash';
  this.fallback = mode === 'history' && !supportsPushState && options.fallback !== false;
  if (this.fallback) {
    mode = 'hash';
  }
  if (!inBrowser) {
    mode = 'abstract';
  }
  this.mode = mode;

  switch (mode) {
    case 'history':
      this.history = new HTML5History(this, options.base);
      break
    case 'hash':
      this.history = new HashHistory(this, options.base, this.fallback);
      break
    case 'abstract':
      this.history = new AbstractHistory(this, options.base);
      break
    default:
      if (false) {
        assert(false, ("invalid mode: " + mode));
      }
  }
};

var prototypeAccessors = { currentRoute: { configurable: true } };

VueRouter.prototype.match = function match (
  raw,
  current,
  redirectedFrom
) {
  return this.matcher.match(raw, current, redirectedFrom)
};

prototypeAccessors.currentRoute.get = function () {
  return this.history && this.history.current
};

VueRouter.prototype.init = function init (app /* Vue component instance */) {
    var this$1 = this;

  "production" !== 'production' && assert(
    install.installed,
    "not installed. Make sure to call `Vue.use(VueRouter)` " +
    "before creating root instance."
  );

  this.apps.push(app);

  // main app already initialized.
  if (this.app) {
    return
  }

  this.app = app;

  var history = this.history;

  if (history instanceof HTML5History) {
    history.transitionTo(history.getCurrentLocation());
  } else if (history instanceof HashHistory) {
    var setupHashListener = function () {
      history.setupListeners();
    };
    history.transitionTo(
      history.getCurrentLocation(),
      setupHashListener,
      setupHashListener
    );
  }

  history.listen(function (route) {
    this$1.apps.forEach(function (app) {
      app._route = route;
    });
  });
};

VueRouter.prototype.beforeEach = function beforeEach (fn) {
  return registerHook(this.beforeHooks, fn)
};

VueRouter.prototype.beforeResolve = function beforeResolve (fn) {
  return registerHook(this.resolveHooks, fn)
};

VueRouter.prototype.afterEach = function afterEach (fn) {
  return registerHook(this.afterHooks, fn)
};

VueRouter.prototype.onReady = function onReady (cb, errorCb) {
  this.history.onReady(cb, errorCb);
};

VueRouter.prototype.onError = function onError (errorCb) {
  this.history.onError(errorCb);
};

VueRouter.prototype.push = function push (location, onComplete, onAbort) {
  this.history.push(location, onComplete, onAbort);
};

VueRouter.prototype.replace = function replace (location, onComplete, onAbort) {
  this.history.replace(location, onComplete, onAbort);
};

VueRouter.prototype.go = function go (n) {
  this.history.go(n);
};

VueRouter.prototype.back = function back () {
  this.go(-1);
};

VueRouter.prototype.forward = function forward () {
  this.go(1);
};

VueRouter.prototype.getMatchedComponents = function getMatchedComponents (to) {
  var route = to
    ? to.matched
      ? to
      : this.resolve(to).route
    : this.currentRoute;
  if (!route) {
    return []
  }
  return [].concat.apply([], route.matched.map(function (m) {
    return Object.keys(m.components).map(function (key) {
      return m.components[key]
    })
  }))
};

VueRouter.prototype.resolve = function resolve (
  to,
  current,
  append
) {
  var location = normalizeLocation(
    to,
    current || this.history.current,
    append,
    this
  );
  var route = this.match(location, current);
  var fullPath = route.redirectedFrom || route.fullPath;
  var base = this.history.base;
  var href = createHref(base, fullPath, this.mode);
  return {
    location: location,
    route: route,
    href: href,
    // for backwards compat
    normalizedTo: location,
    resolved: route
  }
};

VueRouter.prototype.addRoutes = function addRoutes (routes) {
  this.matcher.addRoutes(routes);
  if (this.history.current !== START) {
    this.history.transitionTo(this.history.getCurrentLocation());
  }
};

Object.defineProperties( VueRouter.prototype, prototypeAccessors );

function registerHook (list, fn) {
  list.push(fn);
  return function () {
    var i = list.indexOf(fn);
    if (i > -1) { list.splice(i, 1); }
  }
}

function createHref (base, fullPath, mode) {
  var path = mode === 'hash' ? '#' + fullPath : fullPath;
  return base ? cleanPath(base + '/' + path) : path
}

VueRouter.install = install;
VueRouter.version = '2.8.1';

if (inBrowser && window.Vue) {
  window.Vue.use(VueRouter);
}

/* harmony default export */ __webpack_exports__["a"] = (VueRouter);


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(50),
  /* template */
  __webpack_require__(51),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import Navigation from '@/components/Navigation'
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'home',
  data: function data() {
    return {};
  },

  components: {
    // 'navigation': Navigation
  }
});

/***/ }),
/* 51 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/Zgnlkc/tc-custom/9781940669311.jpg?1708776416438",
      "alt": "This image is the cover for the book Washingtons. Volume 6, Part 1, The Washingtons: A Family History"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Washingtons. Volume 6, Part 1, The Washingtons: A Family History\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Part of a series filled with “gratifying detail” about the ancestry of the first US President, this volume contains the tenth-generation descendants. (Robert K. Krick, author of "), _c('i', [_vm._v("The Smoothbore Volley that Doomed the Confederacy, Stonewall Jackson at Cedar Mountain,")]), _vm._v(" and "), _c('i', [_vm._v("Lee’s Colonels")]), _vm._v(")")]), _c('br'), _c('br'), _vm._v("This is the sixth volume of Dr. Justin Glenn’s comprehensive history that traces the “Presidential line” of the Washingtons, the vast family originated by the immigrant John Washington, who settled in Westmoreland Co., Va., in 1657, married Anne Pope, and became the great-grandfather of President George Washington. This volume contains the late nineteenth and twentieth century born descendants of John Washington’s daughter, Anne (Washington) Wright and as such transports the reader through many of the major historical events of those eras by providing the stories of the family members who lived through them. "), _c('br'), _c('br'), _vm._v("Although structured in a genealogical format for the sake of clarity, this is no bare bones genealogy but a true family history with over 1,200 detailed biographical narratives. These in turn strive to convey the greatness of the family that produced not only The Father of His Country but many others, great and humble, who struggled to build that country."), _c('br'), _c('br'), _vm._v("“It is surprising that no comprehensive family history has been published. Justin M. Glenn’s "), _c('i', [_vm._v("The Washingtons: A Family History")]), _vm._v(" finally fills this void for the branch to which General and President George Washington belonged, identifying some 63,000 descendants.” —John Frederick Dorman, editor of "), _c('i', [_vm._v("The Virginia Genealogist")]), _vm._v(" (1957–2006) and author of "), _c('i', [_vm._v("Adventurers of Purse and Person")])])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Justin Glenn\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Justin Matthews Glenn was born in Little Rock, Arkansas, and raised in Glendale and Phoenix, Arizona. He graduated from Stanford University [B.A., Classics, 1967; magna cum laude, Phi Beta Kappa] and was a Woodrow Wilson Fellow at Princeton University [M.A., Classics, 1969; Ph.D., Classics, 1970]. His career as a professor of Classics at the University of Georgia and Florida State University spanned thirty-five years, and he has published over seventy articles, notes, and reviews in his field. A distant cousin of George Washington, he has served as Registrar General of the National Society of the Washington Family Descendants since 2002.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Savas Publishing\n   ")])])])
}]}

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(53),
  /* template */
  __webpack_require__(54),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 54 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [
    [_c('div', {
      staticClass: "chapter"
    }, [_c('div', {
      staticClass: "inner_page"
    }, [
      [_vm._m(0)]
    ], 2)])]
  ], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(56),
  /* template */
  __webpack_require__(57),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 57 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [
    [_c('div', {
      staticClass: "chapter"
    }, [_c('div', {
      staticClass: "inner_page"
    }, [
      [_vm._m(0)]
    ], 2)])]
  ], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(59),
  /* template */
  __webpack_require__(60),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 60 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [
    [_c('div', {
      staticClass: "chapter"
    }, [_c('div', {
      staticClass: "inner_page"
    }, [
      [_vm._m(0)]
    ], 2)])]
  ], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(62),
  /* template */
  __webpack_require__(63),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 63 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [
    [_c('div', {
      staticClass: "chapter"
    }, [_c('div', {
      staticClass: "inner_page"
    }, [
      [_vm._m(0)]
    ], 2)])]
  ], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(65),
  /* template */
  __webpack_require__(66),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 66 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [
    [_c('div', {
      staticClass: "chapter"
    }, [_c('div', {
      staticClass: "inner_page"
    }, [
      [_vm._m(0)]
    ], 2)])]
  ], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(68),
  /* template */
  __webpack_require__(69),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 69 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "chapterTitle"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "paraCenterTop"
  }, [_c('a', {
    attrs: {
      "href": "#/06_introduction"
    }
  }, [_vm._v("Introduction")]), _vm._v(", "), _c('a', {
    attrs: {
      "href": "#/07_acknowledgement"
    }
  }, [_vm._v("Acknowledgments")]), _vm._v(", and "), _c('a', {
    attrs: {
      "href": "#/08_abbreviation"
    }
  }, [_vm._v("Abbreviations")])]), _vm._v(" "), _c('p', {
    staticClass: "paraCenterTop"
  }, [_c('a', {
    attrs: {
      "href": "#/09_ch01"
    }
  }, [_vm._v("The Washington Line (descendants of Lawrence Washington and John Washington, Jr.)")])]), _vm._v(" "), _c('p', {
    staticClass: "paraCenterTop"
  }, [_c('span', {
    attrs: {
      "href": "#/20_bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliographical Abbreviations (The complete bibliography for Volume 6 is found at the end of Part 2)")])])])])
}]}

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(71),
  /* template */
  __webpack_require__(72),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 72 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "frontMatterPage",
    attrs: {
      "id": "fm_1"
    }
  }, [_c('p', {
    staticClass: "chapterTitle"
  }, [_vm._v("Introduction")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("This history traces the “Presidential line” of the Washingtons. This is the vast family originated by the immigrant John Washington who settled in Westmoreland Co., Va., in 1657, married Anne Pope, and was the great-grandfather of President George Washington.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("My long odyssey began in the summer of 1973, when I learned from a surgeon that I had a melanoma; there was a significant chance that within five years I would be dead. At the time I was twenty-eight years old and had embarked on a university teaching career in the field of Classics three years earlier. This medical revelation had a strange impact. Certain things that had long lain dormant on a far horizon of my life began to stir and even acquire an uncanny urgency. Foremost among these was a vague curiosity about my family’s ancestry. When I asked my parents about the subject, my mother replied, “Ask my brother John—he’s trying to get a book written on our family.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Thus began my correspondence with my uncle John Pope Matthews, a prominent land developer in Little Rock, Arkansas. At that same time, I struck up a friendship with Gloria Counts, the local genealogist whom John had hired to research the Matthews family. As a small side-job, she did some very limited work on a rather notable maternal line. John’s mother (my grandmother), Agnes (Somers) Matthews, was the granddaughter of Worden Pope, whose great-grandfather and namesake, Worden Pope, was the great-grandson of Nathaniel Pope I of Westmoreland County, Virginia. It turned out that Nathaniel Pope had descendants by his son Nathaniel Pope II (my mother’s ancestor) and his daughter Anne Pope, who married the young immigrant named John Washington. These same John and Anne (Pope) Washington were the great-grandparents of President George Washington.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("I was astonished to learn that no one had published anything approaching a comprehensive genealogy of either the Pope or the Washington family. Slowly, without even realizing it at first, I began to compile such a history by collecting cousins, as many descendants of Nathaniel Pope I as I could find. These included the Washingtons, of course, and over the course of the next decade they gradually came to dominate my research.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The critical turn in this long quest came in the fall of 1992. While rather casually working on another maternal line, I made contact with Brice McAdoo Clagett, a distant cousin (now deceased) who was a prominent lawyer and noted genealogist in Washington, D.C. Learning of my interest in the Popes and Washingtons, he mentioned that he frequently had lunch with an investment adviser who had an office nearby: “His name is John Augustine Washington, and he is "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("the")]), _vm._v(" expert on the family.” With Brice’s help I immediately wrote to John, who was the namesake and direct descendant of a younger brother of George Washington. I purchased copies of his two excellent Washington charts, and then finally summoned the courage to send him samples of what I had been working up on the family. A few days later I received a telephone call, which began, “John Washington here.” He was kind enough to say that he liked my material and asked about the state of my research:")]), _vm._v(" "), _c('div', {
    staticClass: "extract"
  }, [_c('p', {
    staticClass: "extractNoIndent"
  }, [_vm._v("“So far I’ve collected about 9,000 descendants of your immigrant ancestor John Washington.”")]), _vm._v(" "), _c('p', {
    staticClass: "extractNoIndent"
  }, [_vm._v("“That’s not a bad start.”")]), _vm._v(" "), _c('p', {
    staticClass: "extractNoIndent"
  }, [_vm._v("“About how many have "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("you")]), _vm._v(" found?”")]), _vm._v(" "), _c('p', {
    staticClass: "extractNoIndent"
  }, [_vm._v("“I don’t know exactly—but quite a few more than you. Of course, I’ve been at it a lot longer. But I can see that you take your Washington genealogy quite seriously. You’ll be hearing from me.”")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("A few days later I received in the mail a roll of microfilm, and rushing to the library I soon realized that his research far exceeded anything that had ever been published on the family. I spent most of the next several weekends at the library photocopying the microfilm, and then many months enormously expanding and often correcting my computer files on the Washingtons. ")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The 30-year-old roll of microfilm was a flawed treasure. It had already begun to decompose and was dotted with blotches that rendered some names and dates illegible. For fear of seeming ungrateful, I long hesitated to send John a photocopy of a disfigured page. When I finally did, he immediately telephoned me and apologized profusely. Unaware of the microfilm’s poor condition, he promised to send me an updated and greatly expanded version of his “Outline.” At regular intervals over the next few months, he sent me about thirty packets, which together filled a three-foot drawer in my file cabinet. It was all hand-written in a small but very precise script. These updated versions of the old microfilm material brought my total number of Washington descendants to perhaps 25,000.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("That began a lengthy period of correspondence. I long urged John to join with me in co-authoring a genealogical history of the Washingtons. He always demurred, pleading his lack of time (he was still a very active financial adviser), and he had become very interested in working on the Lee family of Virginia. For about 40 years, John had devoted his spare time to developing a basic outline of the Washingtons—dates of birth, marriage, and death. On the back of each sheet (especially for the earliest generations) he had made some brief notations on profession, places of birth, marriage, residence, and death, and occasionally some sources. But there were virtually no biographical details or sketches, the sort of thing that I especially enjoyed writing. Thus, when examining a recently arrived batch of John’s material, I was amazed to find the name “Lee Marvin.” Quickly turning the page, I found a one-word annotation on the back: “actor.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("During the following years, I added many thousands of additional descendants from new sources and correspondents that I located on the internet. I also slowly began to expand my computer files by writing over one thousand detailed biographical sketches (of both Washington descendants and their spouses). Even at that stage I continued to suggest that John join me in co-authoring a genealogical history of the Washingtons; after all, I was deriving an enormous amount of my material directly from his files. He said emphatically one day, “No, I assembled the skeleton, but you’ve put flesh on it and brought it to life. This is your project now.” Perhaps his metaphor is apt, but anyone who has done much genealogy will quickly confirm that assembling skeletons is infinitely more difficult than adding flesh. He has helped me at every turn and saved me from countless mistakes.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The reader should be forewarned that my formal training in American history is very limited. When I attended my first class of The History of Western Civilization at Stanford in the Fall of 1963, my History instructor promptly informed us (as best as I can recall):")]), _vm._v(" "), _c('div', {
    staticClass: "extract"
  }, [_c('p', {
    staticClass: "extractNoIndent"
  }, [_vm._v("No doubt most of you were indoctrinated in high school with the utterly false notion that history involves the study of guns, boats, and dates. True history has nothing to do with such things. There will be no discussion of guns, boats, and dates in this class.")])]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("History, as I went on to discover during that course, consisted of roughly equal parts of sociology, economics, philosophy, and political ideology. Sadly, I have proved a poor student. Not only have I written a book teeming with guns, boats, and (most of all) dates, but I have had the temerity to think of it as a family "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("history")]), _vm._v(" and not merely a genealogy. Part of the blame I must assign to the professors under whom I later studied Greek and Roman history at Stanford and Princeton—Antony Raubitschek, Ronald Mellor, John Fine, Robert Connor, and Frank Bourne. They still clung to the outmoded concept that chronology, as well as military and naval events, are important elements of history.")]), _vm._v(" "), _c('p', {
    staticClass: "centerImage2"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/star.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("I am keenly aware that, in spite of my best efforts and many years of work, this book has numerous errors. These creep into genealogies with lamentable ease, especially in the case of dates. When a date of birth, marriage, or death is entered on a computer, it is appallingly easy to hit a wrong numeral key, and once entered the mistake often becomes virtually undetectable in subsequent proofreading. Although I strove to use reasonable caution, I am keenly aware that numerous mistakes must still remain. Any corrections (especially when documented) from readers will be gratefully received and carefully stored for a supplemental volume that I hope to publish someday.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Since this is essentially a history of a Southern family, I have generally used the Southern names of Civil War battles (e.g., Manassas for Bull Run, Sharpsburg for Antietam, and Murfreesboro for Stones River). Exceptions are battles for which the Northern title is almost universally used today (e.g., Pea Ridge for Elk Horn Tavern, Shiloh for Pittsburg Landing, and Brice’s Cross Roads for Tishomingo Creek). For the sake of convenience, I use the term “Civil War” for what I deem the more technically correct but more awkward “War Between the States.”")]), _vm._v(" "), _c('p', {
    staticClass: "centerImage2"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/star.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("I also need to ask the reader’s patience with several inconsistencies that evolved as my multi-volume book traversed many chronological and geographical boundaries.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Army Air Service/USAF")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("For U.S. military aviation veterans of World War I, I have universally adopted the term “Army Air Service,” although technically this term was used only from May 24, 1918 to July 2, 1926. Previous official designations in 1917–1918 were “Aviation Section, U.S. Signal Corps” and “Division of Military Aeronautics.” ")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("For U.S. World War II-era and later military aviation veterans, I have universally adopted the term “USAF” (U.S. Air Force), although this technically was not created until Sept. 18, 1947. Previous designations were U.S. Army Air Corps (July 1926-June 1941) and U.S. Army Air Force (June 1941-Sept. 1947).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Charlestown/Charles Town (West) Virginia ")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("In 1786 Charles Washington (the youngest brother of the future President) donated 80 acres to establish a town that was named in his honor, Charles Town. Originally located in Berkeley County, Va., the town became part of newly formed Jefferson County, Virginia in 1801. From the outset, there was confusion about the name of the town: Charlestown or Charles Town? Both forms were used by its residents in early wills, deeds, and other official documents. In 1863 the administration of President Lincoln included Jefferson County and its neighboring Berkeley County among the counties that were cut out of Virginia to form the new state of West Virginia. Both geographically and politically, Jefferson and Berkeley Counties were closely aligned with Virginia and not West Virginia. The major motive of the Lincoln administration was to assure that the vital Baltimore and Ohio Railroad remained entire within the borders of the United States. Most of the adult male citizens of Jefferson County were either in the Confederate Army or were known Confederate sympathizers, and on those grounds were not permitted to vote in the election that set the borders of West Virginia.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("In 1866 the Virginia legislature brought suit against West Virginia to restore Berkeley and Jefferson County to the Old Dominion. The case dragged on for five years, and in 1871 the Supreme Court finally issued a decision which refused to change the borders of West Virginia. Meanwhile, the confusion in the spelling “Charles Town” and “Charlestown” was compounded by the similarity to Charles"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ton")]), _vm._v(", located Kanawha County, which was named the capital of the newly formed state of West Virginia in 1863. When rural mail delivery was first established in 1896, the West Virginia state legislature voted to end the confusion once and for all by formally naming the small town in Jefferson County “Charles Town.” In the present work I have consistently attempted to use the spelling “Charles Town” for the town established by Charles Washington.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("“Independent Cities” in Virginia")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Since many of the most basic genealogical records in the U.S. are county documents, it has become a customary courtesy in modern genealogical writing to attempt to cite not only city and state but county as well. This is especially important, of course, for rural areas and small hamlets which are obscure and in some cases have faded completely out of existence. In general, I have attempted to include counties in my numerous entries, except for a few of the largest cities.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("One of the most perplexing and confusing contradictions that faces students of Virginia genealogy is the problem of classifying Virginia’s larger towns and cities in terms of counties. (A somewhat similar problem prevails in Connecticut, which essentially abolished county governments in 1960. In addition, the state of Alaska is divided into boroughs, not counties). Since the 1870s, most of Virginia’s towns and cities have been classified as “Independent Cities” and are technically separate political entities from the counties that in many cases completely surround them. This spawns a host of unavoidable and vexing inconsistencies. Many individuals who lived their entire life in the same house were classified as residents of a certain county up until the 1870s but not afterward. The situation is inherently odd: Salem, Va., for example, is completely surrounded by Roanoke County, and it both contains the Roanoke County Court House and functions as the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("de facto")]), _vm._v(" county seat of Roanoke County. Since 1871, however, it is technically an “Independent City” and not part of Roanoke County.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("To compound the chaos, U.S. Federal documents are hopelessly inconsistent on the subject, even if we restrict ourselves to just the post-1870s period. Depending on the year and the census taker, census records sometimes list the same persons, living in the same house, as residents of (for example) “Richmond, Independent City,” and sometimes as residents of “Richmond, Henrico County, Va.” Also, World War I Draft records were organized basically by state and county, so a man registering for the draft in (say) Danville, Va., was classified in Federal records as registering in “Danville, Pittsylvania County,” even though the state of Virginia would technically classify this location as “Danville, Independent City.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("In addition, the towns in the Norfolk/Hampton Roads area have undergone a bewildering series of mergers and consolidations that, once again, make consistency virtually impossible. A rather extreme case is Warwick County, Va., which in 1952 ceased being a county and became simply the city of Warwick, and then in 1958 disappeared altogether when it was incorporated into the city of Newport News. In the face of such chaos, I can only alert readers to the problem and ask their forbearance.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("“Index”/“Record”")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("There is great inconsistency among the titles of the birth, death, and marriage on-line databases (e.g., Death "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Records")]), _vm._v(" vs. Death "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Index")]), _vm._v("). For the sake of consistency (and my sanity), I have adopted the uniform term “"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Index.")]), _vm._v("”")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("First names/Last Names")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("As I began to write fairly lengthy biographical sketches for hundreds of Washington descendants and their spouses, I encountered the obvious problem of how to name them. It seemed eccentrically formal to speak of children by their last names, but at what point does one suddenly cease using their first names and shift to last names? Writers of biographical histories would normally use last names to refer to their subjects, especially in the case of adults. Genealogical entries, however, pose peculiar difficulties. Different family members (most having the same last name) tend to weave in and out of the narrative, so to refer to the principal subject simply by his or her last name becomes inherently confusing. I eventually chose as a general rule to refer to the principal subjects of each entry by their first names, even as adults, for the sake of both clarity and consistency. At times, I confess, this produces a rather awkward familiarity, for which I ask the reader’s indulgence.")])])])])
}]}

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(74),
  /* template */
  __webpack_require__(75),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 75 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "frontMatterPage",
    attrs: {
      "id": "fm_2"
    }
  }, [_c('p', {
    staticClass: "chapterTitle"
  }, [_vm._v("Acknowledgments")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("My most pleasant task in writing this history is also the most daunting: to acknowledge the many people whose generous assistance and encouragement have sustained me in my lengthy journey. (I have already acknowledged, of course, my supreme debt to my mentor John Augustine Washington). The long lapse of years makes me fearful that I might accidentally omit some of the scores of correspondents who supplied information on their branch of the Washington family. I have attempted to list them all in the section headed “Contributors” (a wide category that includes postings on the Internet) found near the beginning of my bibliography. At the risk of seeming ungrateful to others, however, I here make an attempt to single out (in alphabetical order) some who have been extraordinarily generous in supplying massive amounts of information.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("I must also add that I asked John A. Washington if he had kept a list of correspondents who had assisted him in compiling his monumental “Outline.” He replied that much to his regret he did not, and, for fear of accidentally omitting important helpers, he declined to submit such a list. He did wish, however, that I acknowledge the extraordinary assistance that he received from a genealogist who was a critical partner in his life-long genealogical quest—Prentiss Price. As John would be the first to attest, thousands of names in his Washington “Outline” were collected and contributed by Prentiss Price, who died in August 1979.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("I begin with a special “thank you” to my supportive wife, Jody Glenn, who assisted in proofreading and patiently has endured my genealogy addiction. I am also deeply grateful to Ted Savas of Savas Beatie Publishers, who had faith in my unusually lengthy book and took the risk of publishing it in the depths of a severe and seemingly endless economic recession. I am also much indebted to The National Society of the Washington Family Descendants for a subvention toward the publication of this book. Among the many correspondents who contributed family records, the following were especially generous in contributing extensive and critical information:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("Stuart Alexander Anderson (Madison, Ala.) ")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Robert Stanley Arnold (St. Peters, Mo.) ")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Robert James Asbury (Liberty Lake, Wash.) ")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Thomas Esrie Ball (Gulf Shores, Ala.) ")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("James Houston Barr III (Louisville, Ky.).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Deborah Faye O’Quinn Battles (Paris, Tenn.)")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Marion Singleton Bedinger (Port Angeles, Wash.)")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Kerry Ross Boren (Draper, Ut.) ")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Robert Thomas Botts III ")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("McLemore Bouchelle (Rancho Cucamonga, Cal.) ")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("James Boulton (Richmond, Va.)")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Jerry C. Breast (Rear Admiral, USN Retired, Nashville, Tenn.)")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Doyle Brittain (Athens, Ga.) ")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("James Rayford Brotherton (Asheville, N.C.) and Mark Edwin Brotherton (Warner Robins, Ga.) ")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Charles Eugene Brown (Ash Grove, Mo.) ")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("George Landon Browning III (La Cañada Flint Ridge, Cal.) ")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Ronald J. Brummette, Jr. (Louisville, Ky.)")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Winstead Thomas Buckner (Lexington, Ky.) ")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("William Scott Campbell (Valencia, Cal.) ")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Mary R. Catalfamo (Manuscript Librarian at Nimitz Library, U.S. Naval Academy, Annapolis)")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Tracy Ayres Cavendish (Hillsboro, Oh.)")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Douglas R. Chandler (Phoenix, Ariz.) ")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Patricia Lynn Brown Claytor")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Pat Beeson Coleman (Sulphur Springs, Tex.)")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Margaretta Barton Colt (New York, N.Y.) ")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Jane Washington Pendleton Cook (Wilmington, N.C.) ")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Davis Griffith-Cox (Terrell, Tex.)")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Charles F. Crabtree (Granbury, Tex.) and Marilyn E. Crabtree Sanderlin (Lake Charles, La.)")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Carla Cramer and Julia Horigan (Tallahassee, Fla.) ")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Alice Creighton (chief archivist at the Nimitz Library, U.S. Naval Academy, Annapolis)")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Willis D. Crittenberger (Maj. General, USA Retired)")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Alice Thompson Cross (Virginia Beach, Va.), ")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Betsy Bowman Davis")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Estella L. W. Davis (Bonita Springs, Fla.)")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("William A. Davis (Gallatin, Tenn.) ")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("John Thomas DeBell (Catharpin, Va.) ")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Michelle Detwiler (Buckley, Wash.) ")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Nichole Ashley Dillinger (Raleigh, N.C.) ")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("John E. Donohew (Rockville, Md.) ")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Vernon Henry Drewa (Keller, Tex.) ")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Robert Dupree (Tulsa, Okla.), incorporating the research of Emma Rose Moore")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Charlotte Cross Crowder Durham (Coffee County, Tenn.) assisted by George Wayne Chumbley ")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Sanford Grant Etheridge (New Orleans, La.) ")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("James E. Evers (Shreveport, La.) ")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Mildred S. Ezell and Margaret P. Ezell, Ph.D. (Germantown, Md.).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Patrick Anthony Fancher (Marshall, Tex.)")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Randalin Black Ferguson (Princeton, Mo.) assisted by Claire J. Southers (Matthews, N.C.)")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Ruth Williams Finger (Phoenix, Ariz.) ")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Wanda Lee Norvell Flynn (Escondido, Cal.)")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("William Innis Forbes (Evans Mills, N.Y.) ")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Walter E. Forehand (Tallahassee, Fla.)")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Johnabeth Frost (Vinita, Okla.) ")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Michael David Frost (Shawnee Mission, Kans.) ")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Janet Clayton Gardner (Huntsville, Tex.)")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("John H. Garner (Grandview, Mo.)")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Douglas Garnett ")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Shirley Stanton Smiley Gartin (Duncanville, Tex.) ")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("George and Betty Jane (Johnson) Gerber (McLean, Va.)")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Earlene Davison Giglierano (Iowa City, Iowa) ")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Eleanor Page Lee Glascock (Upperville, Va.)")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Jerry Glenn (Southgate, Ky.) ")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Patricia Ann Broyles Gohlke")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Mary Doris Wright Gooch (Merritt Island, Fla.)")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Donald E. Gradeless (Winona Lake, Ind.) ")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Robert Noel Grant (Menlo Park, Cal.) ")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("John Bachman Lee Greer III (Texarkana, Tex.) assisted by Marinelle Kellner Greer")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Dorothy Delina Groves ")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Linda Ann Carstarphen Gugin (Evansville, Ind.) ")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Andrew Witold Gutowski (McLean, Va.)")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Gareth Robert Habel (Alexandria, Va.).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Sue Matych-Hager")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Bobbie Evangeline Owen Haggard (Louisville, Miss.) ")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Zadeea Graham Harris (Aztec, N.M.)")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("James S. Harry (Baltimore, Md.)")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("James Richard Hawks (Olive Branch, Miss.) ")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Kathryn Williams Hege (Yadkin County, N.C.) ")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Lewis Marshall Helm (Bethesda, Md.) ")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Charles Mason Hess")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Truman Hickerson (San Pedro, Cal.)")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Sharon “Kay” Cox Hlava (Greenwood, Ind.) ")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Lucille McDaniel Ray Hodges (Abilene, Tex.)")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Armistead Jake Holmes, Jr. (Brewton, Ala.) ")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("William Alphonso Holtshouser IV (Raleigh, N.C.)")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Rex Hopson (Albuquerque, N.M.) and Merlin Mitchell (Tallahassee, Fla.) ")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Dorothy Atkinson Hudson (Brevard, N.C.) ")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("J. Alan Hunton (Albuquerque, N.M.) ")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("William Moore Hurst, Jr. (McKinney, Tex.)")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Kristy Louise Hyatt (Augusta, Ga.)")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Eric James (Dana Point, Cal.) ")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Linda McGowan Jamison (Liberty, Tex.) ")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Katherine Marie Johnson (Honolulu, Hawaii)")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Susan Deupree Jones (Cary, N.C.)")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Karen Jorgensen (Bedford, Tex.)")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Beth Burdick Kalal (Coronado, Cal.)")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Jo Ann Harris Landrum (Conroe, Tex.) ")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Claudia Eoline Stewart Lane")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Charles Laurens Latimer, Jr. (Greenville, S.C.) and Edward Brandt Latimer (Columbia, S.C.) ")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("James Fugate Lawrence (Brig. Gen., USMC Retired, Fort Belvoir, Va.)")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Robert deTreville Lawrence IV (Warrenton, Va.)")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Verdie Denice Jackson Lipscomb (Waxahachie, Tex.) ")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Joseph Dandridge Logan III (Roanoke, Va.)")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Peter Hotchkiss Lyons")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Henry C. Mackall (Fairfax, Va.) ")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Ross and Virginia Mackenzie (Manakin-Sabot, Va.).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Lois Maschmeyer (Corning, N.Y.)")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Richard Earl Mather ")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Janie Wilkey May")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Janet Gough McMurray")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Patrick Kim McVicker (Toledo, Oh.)")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Paul Mears (Walterboro, S.C.) ")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Thomas Glover Medders (West Blocton, Ala.) and Stan Medders (Pacifica, Cal.) ")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Anne Manning Miller")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Gerald Alva Miller and his wife Helen Irene Williams Miller (Topeka, Kans.)")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Hal C. Miller (Owensboro, Ky.).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Lancelot Longstreet Minor III (Memphis, Tenn.)")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Sally Bonham Mohle (Fairfax, Va.) ")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Joseph Moore (Henry County, Ga.) ")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Mary Utley Murphy (Pewee Valley, Ky.) ")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Virginia Sanders Mylius (Birmingham, Ala.) ")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Charlene Oerding")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Tammy Howard Ofsanik (Charlotte, N.C.) ")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Carolyn and Jerry Pape (Pendleton County, Ky.) ")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Thomas W. Pearson (Helena, Mont.) ")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Patricia Howard Peterson (Mounds, Okla.) ")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Jesse Pettey (Houston, Tex.)")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Anne (Aynn) Puckett Kirtley Phillips (Albany, Ga.)")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Henry T. Poole (Warner Robins, Ga.) ")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Elaine Powell (Orlando, Fla.) ")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Rita Frances Powers (Manchester, Tenn.) ")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Helen Anderson Pruitt (Charleston, S.C.) ")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Harry Elwell Raber (Montgomery, Ala.) ")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Marianne Rankin (Gulfport, Miss.)")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Robert Scott Reynolds (Scottsboro, Ala.).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("David J. Rice (Hingham, Mass.) ")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("John Frost Riley (Montevallo, Ala.) ")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Rupert Riley (Oak Island, N.C.) ")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Adeline Marye Robertson (Arlington, Va.) ")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Nola Miles Rogers (Licking County, Oh.) ")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Ben Lacy Rose (Richmond, Va.)")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Barbara Elaine Hunt Rowe (Renton, Wash.) ")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Katherine Royal (Boxborough, Mass.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Fred Salter (Palmdale, Cal.) ")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Delores Estelle Pickering Sanders (Forest, Miss.) ")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Karen and Fleming Saunders V (Burke, Va.) ")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Winton Forrest Scott, Jr. (Portland, Me.) ")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Sarah Strider Seemann (Rockville, Md.) ")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Barbara Linton Segar (King George, Va.) ")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Linda Sexton")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("David Paul Shaffner ")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Mary Washington Shaffner (Alexandria, Va.) ")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Sharon Sheets (Loveland, Colo.) ")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Eugene Edmund Sherburne (Flippin, Ark.) ")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Beth Shields (Seminole, Fla.).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Carolyn Smotherman (College Grove, Tenn.) ")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Brother Thomas W. Spalding, Jr., CFX (Bardstown and Louisville, Ky.) ")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Louise Grose Stewart (Lewisville, N.C.) ")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("William Clarkson Stribling, Jr. (Markham, Va.) ")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Mary Kathleen “Corky” Swanson (Abilene, Tex.)")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Roger O. Taylor (Stockton, Cal.) ")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("William Robert Taylor (Gallatin, Tenn.)")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Carolyn Watson Tharp (Norman, Okla.)")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("William Tidwell")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("James Irving Tims (Cleveland, Miss.) ")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Margaret Kirtley Tippens (Knoxville, Tenn.)")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Ilaine Upton ")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Richard Warren Vallandingham (Beaufort, S.C.)")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Lachlan Cumming Vass III (Dallas, Tex.) and Lachlan Maury Vass, Jr. (Bush, La.) ")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Robert Brown Veech (Jacksonville, Fla.).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Lisa Verlo (Los Angeles, Cal.) ")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Carcy Koch Vreeland (Denver, Pa.) ")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Elreeta Crain Weathers (Hamilton, Tex.)")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Patricia Louise Whipp (La Verne, Cal.)")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Justus Perkins White, Jr. (Sedona, Ariz.) ")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Elizabeth Maury (Vass) Guerin Wilkerson (Laurens, South Carolina)")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Helen Jane (Kopecky) Wilson (Rowlett, Tex.) ")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("James Julius Winn (Reisterstown, Md.) and Julie Sullivan Winn.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("George Edward Withers III ")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Norma Harrall Wood (Clinton, Okla.) ")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Debra Lee Hardin Woody (Roanoke, Va.) ")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Daniel Lloyd Wright (Michigan City, Ind.) ")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Norman Thomas Wright, Jr. (Franklin County, Va.) ")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Winter Wright (Savannah, Ga.) ")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("Finally, I wish to thank for their patient support a long line of interlibrary loan librarians (and their assistants) at Florida State University’s Strozier Library, especially Phyllis Holzenburg, Carolyn Reynolds, Anna Campbell, Ann Spangler, and Cynthia Hearn.")])])])])
}]}

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(77),
  /* template */
  __webpack_require__(78),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 78 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "frontMatterPage",
    attrs: {
      "id": "fm_3"
    }
  }, [_c('p', {
    staticClass: "chapterTitle"
  }, [_vm._v("Abbreviations")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("[Note: additional abbreviations for frequently cited books and standard reference works are found at the beginning of the bibliography]")]), _vm._v(" "), _c('div', {
    staticClass: "extract"
  }, [_c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("ABA = American Bar Association")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("AEF = Allied Expeditionary Force (World War I)")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("AlaDI = Alabama Death Index (database on "), _c('a', {
    attrs: {
      "href": "http://Ancestry.com",
      "target": "_blank"
    }
  }, [_vm._v("Ancestry.com")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("AlaDivI = Alabama Divorce Index (database on "), _c('a', {
    attrs: {
      "href": "http://Ancestry.com",
      "target": "_blank"
    }
  }, [_vm._v("Ancestry.com")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("AlaMI = Alabama Marriage Index (database on "), _c('a', {
    attrs: {
      "href": "http://Ancestry.com",
      "target": "_blank"
    }
  }, [_vm._v("Ancestry.com")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("AMA = American Medical Association")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("Anc. = Ancestor(s)/Ancestry")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_c('a', {
    attrs: {
      "href": "http://Anc.com",
      "target": "_blank"
    }
  }, [_vm._v("Anc.com")]), _vm._v(" = "), _c('a', {
    attrs: {
      "href": "http://Ancestry.com",
      "target": "_blank"
    }
  }, [_vm._v("Ancestry.com")])]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_c('a', {
    attrs: {
      "href": "http://Anc.com",
      "target": "_blank"
    }
  }, [_vm._v("Anc.com")]), _vm._v("/Historical Newspapers = Historical Newspapers, Birth, Marriage & Death Announcements, 1851–2003 (database on "), _c('a', {
    attrs: {
      "href": "http://Ancestry.com",
      "target": "_blank"
    }
  }, [_vm._v("Ancestry.com")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_c('a', {
    attrs: {
      "href": "http://Anc.com",
      "target": "_blank"
    }
  }, [_vm._v("Anc.com")]), _vm._v("/Dept. of Veterans Affairs = U.S. Department of Veterans Affairs BIRLS Death File, 1850–2010 (database on "), _c('a', {
    attrs: {
      "href": "http://Ancestry.com",
      "target": "_blank"
    }
  }, [_vm._v("Ancestry.com")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("ANV = Army of Northern Virginia")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("ArizMI = Arizona Marriage Index (“Arizona Marriages”; database on "), _c('a', {
    attrs: {
      "href": "http://Ancestry.com",
      "target": "_blank"
    }
  }, [_vm._v("Ancestry.com")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("ArkDI = Arkansas Death Index (database on "), _c('a', {
    attrs: {
      "href": "http://Ancestry.com",
      "target": "_blank"
    }
  }, [_vm._v("Ancestry.com")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("ArkMI = Arkansas Marriage Index (“Arkansas Marriages”; database on "), _c('a', {
    attrs: {
      "href": "http://Ancestry.com",
      "target": "_blank"
    }
  }, [_vm._v("Ancestry.com")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("Assn. = Association")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("AWOL = absent without leave")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("AWT = Ancestry World Tree (database on "), _c('a', {
    attrs: {
      "href": "http://Ancestry.com",
      "target": "_blank"
    }
  }, [_vm._v("Ancestry.com")]), _vm._v(")")])]), _vm._v(" "), _c('div', {
    staticClass: "extract"
  }, [_c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("b. = born")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("B.C. = British Columbia")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("B.D. = Bachelor of Divinity")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("B.F.A. = Bachelor of Fine Arts")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("bibliog. = bibliography")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("Biog. = Biography/Biographical")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("B.N. = Bachelor of Nursing")])]), _vm._v(" "), _c('div', {
    staticClass: "extract"
  }, [_c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("CalBI = California Birth Index (database on "), _c('a', {
    attrs: {
      "href": "http://Ancestry.com",
      "target": "_blank"
    }
  }, [_vm._v("Ancestry.com")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("CalDI = California Death Records (database on "), _c('a', {
    attrs: {
      "href": "http://Ancestry.com",
      "target": "_blank"
    }
  }, [_vm._v("Ancestry.com")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("CalMI = California Marriage Index (database on "), _c('a', {
    attrs: {
      "href": "http://Ancestry.com",
      "target": "_blank"
    }
  }, [_vm._v("Ancestry.com")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("Capt. = Captain")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("CDA = National Society of the Colonial Dames of America")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("cem. = cemetery")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("CEO = Chief Executive Officer")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("CFO = Chief Financial Officer")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("chap. = chapter")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("CIA = Central Intelligence Agency")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("Co. (in clearly military contexts) = Company")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("Co. (except in military contexts) = County")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("ConnDI = Connecticut Death Index (database on "), _c('a', {
    attrs: {
      "href": "http://Ancestry.com",
      "target": "_blank"
    }
  }, [_vm._v("Ancestry.com")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("CPA = Certified Public Accountant")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("Cpl. = Corporal")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("CPO = Chief Petty Officer")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("CSA = Confederate States Army")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("CSN = Confederates States Navy")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("CV = Confederate Veteran")])]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("CV = Curriculum Vitae")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("Cycl. = Cyclop(a)edia")])]), _vm._v(" "), _c('div', {
    staticClass: "extract"
  }, [_c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("d. = died")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("DAR and NSDAR = National Society of the Daughters of the American Revolution")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("D.D. = Doctor of Divinity")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("desc. = descendant(s)")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("DFC = Distinguished Flying Cross")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("Dicty. = Dictionary")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("Dir. = Directory")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("Div. = Division (except in academic degrees, where it means “Divinity”)")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("D.Min. = Doctor of Ministry")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("d.s.p.")]), _vm._v(" = died without issue ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("decessit sine prole")]), _vm._v(")")])]), _vm._v(" "), _c('div', {
    staticClass: "extract"
  }, [_c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("E.D. = Enumeration District")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("Enc. = Encyclop(a)edia")])]), _vm._v(" "), _c('div', {
    staticClass: "extract"
  }, [_c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("Fam. = Family/Families")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_c('a', {
    attrs: {
      "href": "http://FamSearch.org",
      "target": "_blank"
    }
  }, [_vm._v("FamSearch.org")]), _vm._v(" = "), _c('a', {
    attrs: {
      "href": "http://FamilySearch.org",
      "target": "_blank"
    }
  }, [_vm._v("FamilySearch.org")]), _vm._v(" (a non-profit website maintained by the Church of Jesus Christ of Latter-day Saints)")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_c('a', {
    attrs: {
      "href": "http://FamSearch.org",
      "target": "_blank"
    }
  }, [_vm._v("FamSearch.org")]), _vm._v("/AF = "), _c('a', {
    attrs: {
      "href": "http://FamilySearch.org",
      "target": "_blank"
    }
  }, [_vm._v("FamilySearch.org")]), _vm._v("/Ancestry File (database on "), _c('a', {
    attrs: {
      "href": "http://FamilySearch.org",
      "target": "_blank"
    }
  }, [_vm._v("FamilySearch.org")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_c('a', {
    attrs: {
      "href": "http://FamSearch.org",
      "target": "_blank"
    }
  }, [_vm._v("FamSearch.org")]), _vm._v("/PRF = "), _c('a', {
    attrs: {
      "href": "http://FamilySearch.org",
      "target": "_blank"
    }
  }, [_vm._v("FamilySearch.org")]), _vm._v("/Pedigree Resource File (database on "), _c('a', {
    attrs: {
      "href": "http://FamilySearch.org",
      "target": "_blank"
    }
  }, [_vm._v("FamilySearch.org")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("FGS = Family Group Sheet (an unpublished genealogical chart, often undocumented and based on personal knowledge)")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("FlaDI = Florida Death Index (database on "), _c('a', {
    attrs: {
      "href": "http://Ancestry.com",
      "target": "_blank"
    }
  }, [_vm._v("Ancestry.com")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("FlaDivI = Florida Divorce Index (database on "), _c('a', {
    attrs: {
      "href": "http://Ancestry.com",
      "target": "_blank"
    }
  }, [_vm._v("Ancestry.com")]), _vm._v(")")])]), _vm._v(" "), _c('div', {
    staticClass: "extract"
  }, [_c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("GaDI = Georgia Death Index (database accessible on "), _c('a', {
    attrs: {
      "href": "http://Ancestry.com",
      "target": "_blank"
    }
  }, [_vm._v("Ancestry.com")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("Ga. Tech = Georgia Institute of Technology")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("GEDCOM = GEnealogical Data COMmunication (electronically shared family tree; more technically, a process for sharing data between different genealogy software programs)")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_c('a', {
    attrs: {
      "href": "http://Gen.com",
      "target": "_blank"
    }
  }, [_vm._v("Gen.com")]), _vm._v("/WFT = "), _c('a', {
    attrs: {
      "href": "http://Genealogy.com",
      "target": "_blank"
    }
  }, [_vm._v("Genealogy.com")]), _vm._v("/World Family Tree")])]), _vm._v(" "), _c('div', {
    staticClass: "extract"
  }, [_c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("HEW = U.S. Department of Health, Education and Welfare")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("Hist. = History/Historical")])]), _vm._v(" "), _c('div', {
    staticClass: "extract"
  }, [_c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("ibid. = in the same place")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("IdaDI = Idaho Death Index (database on "), _c('a', {
    attrs: {
      "href": "http://Ancestry.com",
      "target": "_blank"
    }
  }, [_vm._v("Ancestry.com")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("IdaMI = Idaho Marriage Index (database on "), _c('a', {
    attrs: {
      "href": "http://Ancestry.com",
      "target": "_blank"
    }
  }, [_vm._v("Ancestry.com")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("IGI")]), _vm._v(" = International Genealogical Index (accessible on the web-site "), _c('a', {
    attrs: {
      "href": "http://FamilySearch.org",
      "target": "_blank"
    }
  }, [_vm._v("FamilySearch.org")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("IllDI = Illinois Death Index (“Illinois Deaths and Stillbirths,” a database on "), _c('a', {
    attrs: {
      "href": "http://Ancestry.com",
      "target": "_blank"
    }
  }, [_vm._v("Ancestry.com")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("IllMarrI = Illinois Marriage Records (database on "), _c('a', {
    attrs: {
      "href": "http://Ancestry.com",
      "target": "_blank"
    }
  }, [_vm._v("Ancestry.com")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("IndBI = Indiana Birth Index (database on "), _c('a', {
    attrs: {
      "href": "http://Ancestry.com",
      "target": "_blank"
    }
  }, [_vm._v("Ancestry.com")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("IndMI = Indiana Marriage Index (database on "), _c('a', {
    attrs: {
      "href": "http://Ancestry.com",
      "target": "_blank"
    }
  }, [_vm._v("Ancestry.com")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("IowaBI = Iowa Birth Index (database on "), _c('a', {
    attrs: {
      "href": "http://Ancestry.com",
      "target": "_blank"
    }
  }, [_vm._v("Ancestry.com")]), _vm._v(")")])]), _vm._v(" "), _c('div', {
    staticClass: "extract"
  }, [_c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("JAG = Judge Advocate General")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("J.A.W. = John Augustine Washington (of Chevy Chase, later Bethesda, Md.; author of the unpublished "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(" that became a major component of the current book. For many years he collaborated extensively with Prentiss Price, of Rogersville, Tenn.)")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("Jur.Sc.D. = Doctor of Legal Science")])]), _vm._v(" "), _c('div', {
    staticClass: "extract"
  }, [_c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("KyBI = Kentucky Birth Index (database on "), _c('a', {
    attrs: {
      "href": "http://Ancestry.com",
      "target": "_blank"
    }
  }, [_vm._v("Ancestry.com")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("KyDI = Kentucky Death Index (database on "), _c('a', {
    attrs: {
      "href": "http://Ancestry.com",
      "target": "_blank"
    }
  }, [_vm._v("Ancestry.com")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("KyMI = Kentucky Marriage Records (database on "), _c('a', {
    attrs: {
      "href": "http://Ancestry.com",
      "target": "_blank"
    }
  }, [_vm._v("Ancestry.com")]), _vm._v(") "), _c('span', {
    staticClass: "bold"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "extract"
  }, [_c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("LCT = Landing Craft Tanks")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("LDS = Church of Jesus Christ of Latter-day Saints")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("LL.B. = Bachelor of Laws")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("LL.D. = Doctor of Laws")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("LL.M. = Master of Laws")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("LPN = Licensed Practical Nurse")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("LSM = Landing Ship Medium")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("LST = Landing Ship Tank")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("LSU = Louisiana State University")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("Lt. = Lieutenant")])]), _vm._v(" "), _c('div', {
    staticClass: "extract"
  }, [_c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("m. = married")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("Maj. = Major")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("marr. = marriage")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("MassDI = Massachusetts Death Index (database on "), _c('a', {
    attrs: {
      "href": "http://Ancestry.com",
      "target": "_blank"
    }
  }, [_vm._v("Ancestry.com")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("M.A.T. = Master of Arts in Teaching")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("MichDI = Michigan Death Index (database on "), _c('a', {
    attrs: {
      "href": "http://Ancestry.com",
      "target": "_blank"
    }
  }, [_vm._v("Ancestry.com")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("MinnBI = Minnesota Birth Index (database on "), _c('a', {
    attrs: {
      "href": "http://Ancestry.com",
      "target": "_blank"
    }
  }, [_vm._v("Ancestry.com")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("MinnDI = Minnesota Death Index (database on "), _c('a', {
    attrs: {
      "href": "http://Ancestry.com",
      "target": "_blank"
    }
  }, [_vm._v("Ancestry.com")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("MissMI = Mississippi Marriage Index (database on "), _c('a', {
    attrs: {
      "href": "http://Ancestry.com",
      "target": "_blank"
    }
  }, [_vm._v("Ancestry.com")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("MIT = Massachusetts Institute of Technology")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("M.L.S. = Master in Library Science")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("M.M.Sc. = Master of Medical Science")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("MoDI = Missouri Death Index (Missouri Death Records, database on "), _c('a', {
    attrs: {
      "href": "http://Ancestry.com",
      "target": "_blank"
    }
  }, [_vm._v("Ancestry.com")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("MoMI = Missouri Marriage Index (database on "), _c('a', {
    attrs: {
      "href": "http://Ancestry.com",
      "target": "_blank"
    }
  }, [_vm._v("Ancestry.com")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("MontDI = Montana Death Index (database on "), _c('a', {
    attrs: {
      "href": "http://Ancestry.com",
      "target": "_blank"
    }
  }, [_vm._v("Ancestry.com")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("mss. = manuscript(s)")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("M.St. = Master of Studies")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("M.S.W. = Master of Social Work")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("M.Th. = Master of Theology")])]), _vm._v(" "), _c('div', {
    staticClass: "extract"
  }, [_c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("NASW = National Association of Social Workers")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("Natl. = National")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("NCarBI = North Carolina Birth Index (database on "), _c('a', {
    attrs: {
      "href": "http://Ancestry.com",
      "target": "_blank"
    }
  }, [_vm._v("Ancestry.com")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("NCarDI = North Carolina Death Index (database on "), _c('a', {
    attrs: {
      "href": "http://Ancestry.com",
      "target": "_blank"
    }
  }, [_vm._v("Ancestry.com")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("NCarMI = North Carolina Marriage Index (database on "), _c('a', {
    attrs: {
      "href": "http://Ancestry.com",
      "target": "_blank"
    }
  }, [_vm._v("Ancestry.com")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("NCO = Non-Commissioned Officer")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("n.d. = no date (of publication) indicated")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("NevMI = Nevada Marriage Index (database on "), _c('a', {
    attrs: {
      "href": "http://Ancestry.com",
      "target": "_blank"
    }
  }, [_vm._v("Ancestry.com")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("New York Passenger Lists = New York Passenger Lists, 1820–1957 (database on "), _c('a', {
    attrs: {
      "href": "http://Ancestry.com",
      "target": "_blank"
    }
  }, [_vm._v("Ancestry.com")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("NIH = National Institutes of Health")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("n.p. = no place (of publication) indicated")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("N.S. = New Series")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("NSCDA = See CDA")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("NSDAR = see DAR")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("NSSAR = see SAR")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("NSWFD = The National Society of the Washington Family Descendants")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("NYU = New York University")])]), _vm._v(" "), _c('div', {
    staticClass: "extract"
  }, [_c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("OCS = Officer Candidate School")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("OhBI = Ohio Birth Index (database on "), _c('a', {
    attrs: {
      "href": "http://Ancestry.com",
      "target": "_blank"
    }
  }, [_vm._v("Ancestry.com")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("OhDI = Ohio Death Index (“Ohio Deaths,” database on "), _c('a', {
    attrs: {
      "href": "http://Ancestry.com",
      "target": "_blank"
    }
  }, [_vm._v("Ancestry.com")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("on-line census index = that provided by "), _c('a', {
    attrs: {
      "href": "http://Ancestry.com",
      "target": "_blank"
    }
  }, [_vm._v("Ancestry.com")])]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("OreDI = Oregon Death Index (database on "), _c('a', {
    attrs: {
      "href": "http://Ancestry.com",
      "target": "_blank"
    }
  }, [_vm._v("Ancestry.com")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("OWT = One World Tree (database on "), _c('a', {
    attrs: {
      "href": "http://Ancestry.com",
      "target": "_blank"
    }
  }, [_vm._v("Ancestry.com")]), _vm._v(")")])]), _vm._v(" "), _c('div', {
    staticClass: "extract"
  }, [_c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("p. = page (pp. = pages)")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("PFC = Private First Class")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("PMT = Public Member Tree (database on "), _c('a', {
    attrs: {
      "href": "http://Ancestry.com",
      "target": "_blank"
    }
  }, [_vm._v("Ancestry.com")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("POW = Prisoner of War")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("P.P. = Prentiss Price (of Rogersville, Tenn.; an exceptionally gifted genealogist, for many years he collaborated extensively with John Augustine Washington [of Chevy Chase, later Bethesda, Md.], whose “Outline” is the basis for much of the current book).")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("PRF = Pedigree Resource File (database on "), _c('a', {
    attrs: {
      "href": "http://FamilySearch.org",
      "target": "_blank"
    }
  }, [_vm._v("FamilySearch.org")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("Prof. = Professor")])]), _vm._v(" "), _c('div', {
    staticClass: "extract"
  }, [_c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("q.v. = whom see ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("quem vide")]), _vm._v(")")])]), _vm._v(" "), _c('div', {
    staticClass: "extract"
  }, [_c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("RAF = Royal Air Force")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("Reg. = Register/Registration")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("Regt. = Regiment")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("Rev. War = Revolutionary War")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("RhodeIslandMI = Rhode Island Marriage Records (database on "), _c('a', {
    attrs: {
      "href": "http://Ancestry.com",
      "target": "_blank"
    }
  }, [_vm._v("Ancestry.com")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("R.N. = Registered Nurse")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("RN = Royal Navy")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("ROTC = Reserve Officers Training Corps")])]), _vm._v(" "), _c('div', {
    staticClass: "extract"
  }, [_c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("SAR = National Society, Sons of the American Revolution")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("SAR Membership Applications = U.S., Sons of the American Revolution Membership Applications, 1889–1970 (database on "), _c('a', {
    attrs: {
      "href": "http://Ancestry.com",
      "target": "_blank"
    }
  }, [_vm._v("Ancestry.com")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("SCarDI = South Carolina Death Index (database on "), _c('a', {
    attrs: {
      "href": "http://Ancestry.com",
      "target": "_blank"
    }
  }, [_vm._v("Ancestry.com")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("S.C., Clemson U. (Ag. College) = South Carolina, Clemson University (Agricultural College) Directory of Graduates, 1896–1940 (database on "), _c('a', {
    attrs: {
      "href": "http://Ancestry.com",
      "target": "_blank"
    }
  }, [_vm._v("Ancestry.com")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("S.C., Clemson U. Student Military Records = South Carolina, Clemson University Student Military Service Records, 1894–1944 (database on "), _c('a', {
    attrs: {
      "href": "http://Ancestry.com",
      "target": "_blank"
    }
  }, [_vm._v("Ancestry.com")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("S.C. Delayed Births = South Carolina Delayed Births, 1766–1900 (database on "), _c('a', {
    attrs: {
      "href": "http://Ancestry.com",
      "target": "_blank"
    }
  }, [_vm._v("Ancestry.com")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("SCV = Sons of Confederate Veterans")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("SDakMI = South Dakota Marriage Index (database on "), _c('a', {
    attrs: {
      "href": "http://Ancestry.com",
      "target": "_blank"
    }
  }, [_vm._v("Ancestry.com")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("Ser. = Series")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("Sgt. = Sergeant")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("SMU = Southern Methodist University")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("SSDI = Social Security Death Index")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("S.T.D. = Doctor of Sacred Theology")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("S.T.M. = Master of Sacred Theology")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("SUNY = State University of New York")])]), _vm._v(" "), _c('div', {
    staticClass: "extract"
  }, [_c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("TennBI = Tennessee Birth Index (Tennessee, Delayed Birth Records, database on "), _c('a', {
    attrs: {
      "href": "http://Ancestry.com",
      "target": "_blank"
    }
  }, [_vm._v("Ancestry.com")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("TennDI = Tennessee Death Index (Tennessee Deaths and Burials Index, database on "), _c('a', {
    attrs: {
      "href": "http://Ancestry.com",
      "target": "_blank"
    }
  }, [_vm._v("Ancestry.com")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("TennMI = Tennessee Marriage Index (Tennessee State Marriages, database on "), _c('a', {
    attrs: {
      "href": "http://Ancestry.com",
      "target": "_blank"
    }
  }, [_vm._v("Ancestry.com")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("TexBI = Texas Birth Index (database on "), _c('a', {
    attrs: {
      "href": "http://Ancestry.com",
      "target": "_blank"
    }
  }, [_vm._v("Ancestry.com")]), _vm._v("; these extremely useful records are also available at "), _c('a', {
    attrs: {
      "href": "http://http://www.tdh.state.tx.us/bvs/registra/index.htm",
      "target": "_blank"
    }
  }, [_vm._v("http://www.tdh.state.tx.us/bvs/registra/index.htm")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("TexDI = Texas Death Index (database on "), _c('a', {
    attrs: {
      "href": "http://Ancestry.com",
      "target": "_blank"
    }
  }, [_vm._v("Ancestry.com")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("TexDivI = Texas Divorce Index (database on "), _c('a', {
    attrs: {
      "href": "http://Ancestry.com",
      "target": "_blank"
    }
  }, [_vm._v("Ancestry.com")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("TexMI = Texas Marriage Index (database on "), _c('a', {
    attrs: {
      "href": "http://Ancestry.com",
      "target": "_blank"
    }
  }, [_vm._v("Ancestry.com")]), _vm._v(")")])]), _vm._v(" "), _c('div', {
    staticClass: "extract"
  }, [_c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("UCLA = University of California-Los Angeles")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("UCV = United Confederate Veterans")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("UDC = United Daughters of the Confederacy")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("unm. = unmarried")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("U.P. = University Press")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("U.S.(A.) = United States (of America)")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("USA = U.S. Army")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("USAF = U.S. Air Force (also used for U.S. Army Air Corps and U.S. Army Air Force)")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("USA, Register of Enlistments = U.S. Army, Register of Enlistments, 1798–1914 (database on "), _c('a', {
    attrs: {
      "href": "http://Ancestry.com",
      "target": "_blank"
    }
  }, [_vm._v("Ancestry.com")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("U. of S.C. = University of South Carolina")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("USCG = U.S. Coast Guard")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("USDA = U.S. Department of Agriculture")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("USMA = U.S. Military Academy, West Point, N.Y.")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("USMC = United States Marine Corps")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("USMCR = United States Marine Corps Reserve")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("USMilRecords, 1925 = U.S. Military Records, 1925: Official National Guard Register (database on "), _c('a', {
    attrs: {
      "href": "http://Ancestry.com",
      "target": "_blank"
    }
  }, [_vm._v("Ancestry.com")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("USN = U.S. Navy")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("USNA = U.S. Naval Academy, Annapolis, Md.")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("USO = United Service Organizations (a non-profit organization to support U.S. Armed Forces)")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("U.S. Passport Applications = U.S. Passport Applications, 1795–1925 (database on "), _c('a', {
    attrs: {
      "href": "http://Ancestry.com",
      "target": "_blank"
    }
  }, [_vm._v("Ancestry.com")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("USPRI = U.S. Public Records Index (database available on "), _c('a', {
    attrs: {
      "href": "http://Ancestry.com",
      "target": "_blank"
    }
  }, [_vm._v("Ancestry.com")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("U.S. Veterans Cemeteries = U.S. Veterans Cemeteries, ca. 1806–2006 (database on "), _c('a', {
    attrs: {
      "href": "http://Ancestry.com",
      "target": "_blank"
    }
  }, [_vm._v("Ancestry.com")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("U.S. Veterans Gravesites = U.S. Veterans Gravesites, ca. 1775–2006 (database on "), _c('a', {
    attrs: {
      "href": "http://Ancestry.com",
      "target": "_blank"
    }
  }, [_vm._v("Ancestry.com")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("U.S. WW II Navy Muster Rolls = U.S. World War II Navy Muster Rolls, 1938–1949 (database on "), _c('a', {
    attrs: {
      "href": "http://Ancestry.com",
      "target": "_blank"
    }
  }, [_vm._v("Ancestry.com")]), _vm._v(")")])]), _vm._v(" "), _c('div', {
    staticClass: "extract"
  }, [_c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("VaMarrI = Virginia Marriage Index (“Virginia Marriages, 1851–1900”; database on "), _c('a', {
    attrs: {
      "href": "http://Ancestry.com",
      "target": "_blank"
    }
  }, [_vm._v("Ancestry.com")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("VMI = Virginia Military Institute")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("vols. = volumes")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("Vols. = Volunteers")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("VPI = Virginia Polytechnic Institute (now Virginia Tech)")])]), _vm._v(" "), _c('div', {
    staticClass: "extract"
  }, [_c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("W(A)AC = Women’s (Auxiliary) Army Corps (WW II-era women’s branch of the U.S. Army)")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("WashBI = Washington (State) Birth Index (database on "), _c('a', {
    attrs: {
      "href": "http://Ancestry.com",
      "target": "_blank"
    }
  }, [_vm._v("Ancestry.com")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("WashDI = Washington (State) Death Index (database on "), _c('a', {
    attrs: {
      "href": "http://Ancestry.com",
      "target": "_blank"
    }
  }, [_vm._v("Ancestry.com")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("WashMI = Washington (State) Marriage Index (database on "), _c('a', {
    attrs: {
      "href": "http://Ancestry.com",
      "target": "_blank"
    }
  }, [_vm._v("Ancestry.com")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("WAVE(S) = Women Accepted for Volunteer Emergency Service (WW II-era women’s branch of the U.S. Navy)")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("WCP = World Connect Project (database on "), _c('a', {
    attrs: {
      "href": "http://RootsWeb.com",
      "target": "_blank"
    }
  }, [_vm._v("RootsWeb.com")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("WiscDI = Wisconsin Death Index (database on "), _c('a', {
    attrs: {
      "href": "http://Ancestry.com",
      "target": "_blank"
    }
  }, [_vm._v("Ancestry.com")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("WiscMI = Wisconsin Marriage Index (database on "), _c('a', {
    attrs: {
      "href": "http://Ancestry.com",
      "target": "_blank"
    }
  }, [_vm._v("Ancestry.com")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("WPA = Works Progress Administration")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("WVaBI = West Virginia Birth Index (database on "), _c('a', {
    attrs: {
      "href": "http://Ancestry.com",
      "target": "_blank"
    }
  }, [_vm._v("Ancestry.com")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("WVaMI = West Virginia Marriage Index (database on "), _c('a', {
    attrs: {
      "href": "http://Ancestry.com",
      "target": "_blank"
    }
  }, [_vm._v("Ancestry.com")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("WW I Draft Reg. = WW I Civilian Draft Registrations (database on "), _c('a', {
    attrs: {
      "href": "http://Ancestry.com",
      "target": "_blank"
    }
  }, [_vm._v("Ancestry.com")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("WW II AER = U.S. World War II Army Enlistment Records (database on "), _c('a', {
    attrs: {
      "href": "http://Ancestry.com",
      "target": "_blank"
    }
  }, [_vm._v("Ancestry.com")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("WW II & KCV = World War II and Korean Conflict Veterans Interred Overseas Record (database on "), _c('a', {
    attrs: {
      "href": "http://Ancestry.com",
      "target": "_blank"
    }
  }, [_vm._v("Ancestry.com")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("WW II Draft Reg. = WW II Civilian Draft Registration Cards (database on "), _c('a', {
    attrs: {
      "href": "http://Ancestry.com",
      "target": "_blank"
    }
  }, [_vm._v("Ancestry.com")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("WW II POWs = World War II Prisoners of War, 1941–1946 (database on "), _c('a', {
    attrs: {
      "href": "http://Ancestry.com",
      "target": "_blank"
    }
  }, [_vm._v("Ancestry.com")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("WW II USN Aircraft Carrier Muster Rolls = WW II U.S. Navy Aircraft Carrier Muster Rolls (database on "), _c('a', {
    attrs: {
      "href": "http://Ancestry.com",
      "target": "_blank"
    }
  }, [_vm._v("Ancestry.com")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "FMaltPara"
  }, [_vm._v("WW II USN, USMC, & USCG Casualties = WW II Navy, Marine Corps, and Coast Guard Casualties, 1941–1945 (database on "), _c('a', {
    attrs: {
      "href": "http://Ancestry.com",
      "target": "_blank"
    }
  }, [_vm._v("Ancestry.com")]), _vm._v(")")])])])])])
}]}

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(80),
  /* template */
  __webpack_require__(81),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 81 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch01"
    }
  }, [_c('p', {
    staticClass: "chapterTitle"
  }, [_vm._v("Generation Ten")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("12128. Mildred Jackson (born ca. 1903; married in Williamson Co., Tex. [Sept. 20, 1922] Robert Lee Logan [born in Georgetown, Williamson Co., Tex., Oct. 30, 1897; died ibid., Oct. 29, 1964]. They resided in Georgetown, Tex., where he managed a dry cleaning company in 1930 and was “solicitor” of the Lower Colorado River Authority in 1940.Mildred supplemented the family income by working as a saleslady in a dry goods store in 1940).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Child:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+22624. Jackson Davis Logan. ["), _c('a', {
    attrs: {
      "href": "http://FamSearch.org",
      "target": "_blank"
    }
  }, [_vm._v("FamSearch.org")]), _vm._v("/Tex. Marriages; 1930 census Williamson Co., Tex., E.D. 2, p. 4B; 1940 census ibid., E.D. 246–2A, p. 2B; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11244–23121]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12129. John William Washington (born in Waco, McLennan Co., Tex., Dec. 27, 1908; SAR member national #80145, he was president of Texas Casualty Insurance Company in Austin, Travis Co., Tex. He married [Jan. 8, 1939] Willa B. Morelock [born Nov. 27, 1916; last resided in Travis Co., Tex., and she died in Travis Co., Tex., May 6, 2010]. During WW II, he was a member of the examining staff of the War Damage Corporation in Washington, D.C. He died in Austin, Tex., July 5, 1990).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Child:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22625. Janice Willa Washington (born in Galveston Co., Tex., Aug. 16, 1940). ["), _c('a', {
    attrs: {
      "href": "http://Anc.com",
      "target": "_blank"
    }
  }, [_vm._v("Anc.com")]), _vm._v("/SAR Membership Applications; SSDI; TexBI; TexDI; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11244–23241]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12130. Nancy Imogene Washington (born in Waco, McLennan Co., Tex., Aug. 24, 1910; married [Nov. 3, 1934] Edward Clifton Robinson, Jr. [born Dec. 17, 1910; resided in Waco, Tex., where he died March 29, 1979]).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22626. Edward Clifton Robinson III (born in McLennan Co., Tex., Oct. 14, 1937).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22627. Nancy Alice Robinson (born ibid., July 28, 1946). [TexBI; TexDI; NSWFD #58 (Nancy Imogene Washington); J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11244–23242]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12131. Mary Alice Washington (born in Tex., Sept. 21, 1914; married [Dec. 21, 1934] John Virgil Cottle, Jr. [born in Tex., Aug. 1, 1912; he was manager of a credit company, 1940. He died June 12, 1992]. They resided in Waco, McLennan Co., Tex., but they moved by 1940 to Houston, Tex. Mary died in San Antonio, Tex., March 17, 1999. They were buried at Bosqueville Cemetery in Bosqueville, McLennan Co., Tex.).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22628. John Virgil Cottle III (born in Waco, Tex., March 31, 1936; he was General Counsel and Vice-President of Refining for Diamond Shamrock and Valero for over thirty years. He married Sammye Charles Kinkade, and he died in Austin, Travis Co., Tex., July 27, 2012. They had two children:")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("[1]. John Charles Cottle [born in Nueces Co., Tex., July 19, 1960; married Michelle Elena Paulsen. They had three children: Lindsey Cottle, Madeline Cottle, and Logan Cottle].")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("[2]. Mary Ellen Cottle [born in Potter Co., Tex., July 8, 1963; married Philip Harland Doak. They had three children: Andrew Philip Doak (born in Travis Co., Tex., March 12, 1991), Molly Ellen Doak (born ibid., Sept. 27, 1993), and Spencer John Doak (born ibid., June 16, 1996)]).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22629. David Cottle (born 1942; married Carolyn ___, and they resided in Fla., 2012). [1940 census Harris Co., Tex., E.D. 258–243, p. 8B; TexBI; TexDI; SSDI; obit. of John V. Cottle III in the Austin (Tex.) "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("American-Statesman")]), _vm._v(", 8/1/2012; "), _c('a', {
    attrs: {
      "href": "http://www.findagrave.com",
      "target": "_blank"
    }
  }, [_vm._v("www.findagrave.com")]), _vm._v("; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11244–23243]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12132. William Gorham Washington (born in Waco, McLennan Co., Tex., July 3, 1924; graduated from Baylor U. [LL.B., 1949]. A lawyer and claims manager, he worked in the southwestern regional office of the Providence Washington Insurance Group in Austin, Travis Co., Tex. He married [Dec. 21, 1947] Caroline [or Frances Carolyn] Chambless [born June 7, 1924; died in Travis Co., Tex., Nov. 7, 2002]. They also resided in Waco, Tex., and he died in McLennan Co., Tex., July 17, 1999).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22630. Alice Caroline Washington (born in McLennan Co., Tex., July 7, 1949).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22631. Judith Ann Washington (born in Travis Co., Tex., 27, 1951). ["), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Who’s Who Ins.")]), _vm._v(", 1975; TexBI; "), _c('a', {
    attrs: {
      "href": "http://www.findagrave.com",
      "target": "_blank"
    }
  }, [_vm._v("www.findagrave.com")]), _vm._v("; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11244–23244]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12133. Charles Sprague Moore (born in Chilhowee, Johnson Co., Mo., April 10, 1897; married in Phillipsburg, Phillips Co., Kans. [1"), _c('sup', [_vm._v("st")]), _vm._v("] Jessie Delcina Arbogast [born in Mound City, Linn Co., Kans., Nov. 23, 1887; died in Lowry City, St. Clair Co., Mo., April 25, 1959]. They farmed in Alcona Township, Rooks Co., Kans., 1940. He married [2"), _c('sup', [_vm._v("nd")]), _vm._v(", on Aug. 23, 1961] Elizabeth Trarbach [born Aug. 8, 1907; died in WaKeeney, Trego Co., Kans., Oct. 1986]. He last resided in Ellis, Ellis Co., Kans., and he died in Hayes, Ellis Co., Kans., Feb. 4, 1984).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children (by his 1"), _c('sup', [_vm._v("st")]), _vm._v(" wife):")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+22632. John William Moore.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22633. Donna Marie Moore (born in Stockton, Rooks Co., Kans., Aug. 12, 1932; died ibid., July 17, 1942). [1940 census Rooks Co., Kans., E.D. 82–1, p. 1A; SSDI; FGS by KJMM; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11244–23311, rev.]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12136. Amos Augustus Moore (born in Mo., Jan. 28, 1907; married [1"), _c('sup', [_vm._v("st")]), _vm._v("] Cara Odena Newman [born in Okla., Jan. 7, 1910; died Jan. 29, 1983]. They resided in Wichita, Sedgwick Co., Kans., 1940, where he was an accountant for an investment company. He married [2"), _c('sup', [_vm._v("nd")]), _vm._v(", ca. 1986] Mrs. Hazel Metzger [died ca. 1988]. He resided in Hutchinson, Reno Co., Kans., and he died Dec. 1, 1993).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Child (by his 1"), _c('sup', [_vm._v("st")]), _vm._v(" wife):")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+22634. Patricia Joan Moore. [1940 census Sedgwick Co., Kans., E.D. 107–2B, p. 2A; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11244–23314, rev.]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12137. Frank Michael Baker (born in Kans., Oct. 16, 1903; married Flossie Lee Wolford [born in Mo., Feb. 9, 1914; died in Riverside Co., Cal., March 4, 1983]. They resided in Santa Ana, Orange Co., Cal., 1940, where he was a bookkeeper for a trucking company. They resided in Santa Ana, Cal., and he died July 31, 1976).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+22635. William Hosea Baker.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+22636. Garry Michael Baker.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+22637. Nancy Arlene Baker. [CalDI; 1940 census Orange Co., Fla., E.D. 30–101, p. 9B; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11244–23321, rev.]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12149. George Woodie Coleman, Jr. (born in Kans., ca. May 1926; married [1947] Troyce Wynette Rhodes [born 1928]. They resided in Bethany, Oklahoma Co., Okla. and Abernathy, Hale Co., Tex.).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+22638. Gweneta Troyce Coleman.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22639. Sharon Kay Coleman (born in Hale Co., Tex., July 10, 1950).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22640. Carolyn Diane Coleman (born ibid., Dec. 25, 1951).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22641. Woodie Reginald Coleman (born ibid., Sept. 1, 1954).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+22642. Randall Kent Coleman. [TexBI; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11244–23531]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12150. Maurine Byrd (born in Okla., 1913; married [1935] Deane D. Raley [born in White City, Morris Co., Kans., Jan. 17, 1913; graduated from Okla. School of Pharmacy, 1933. He served as a Navy officer in WW II. He served as president of the Oklahoma Pharmaceutical Association in 1949, and he was president of the Oklahoma Board of Pharmacy]. They resided in Oklahoma City, Oklahoma Co., and Tulsa, Tulsa Co., Okla. They resided in Tulsa, Okla., 1940, where he was a traveling pharmaceutical salesman. He died May 25, 1991).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22643. Deane D. Raley, Jr. (born 1935).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22644. David Raley (born 1941).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22645. Bruce Raley (born 1945). [1940 census Tulsa Co., Okla., E.D. 79–120, p. 11B; SSDI; "), _c('a', {
    attrs: {
      "href": "http://www.findagrave.com",
      "target": "_blank"
    }
  }, [_vm._v("www.findagrave.com")]), _vm._v(" (with obit. of Deane D. Raley); J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11244–23571]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12151. Carl Edward Knoepfel, Jr. (born in Oklahoma City, Oklahoma Co., Okla., Oct. 7, 1923; a WW II veteran, he enlisted in the Air Force in Oklahoma City, Okla., Dec. 10, 1942. He married [1953] Christina F. Hanson [born 1927]. They resided in Oklahoma City, Okla., and later moved to Stafford, Fort Bend Co., Tex. He died in a hospital in Sugar Land, Fort Bend Co., Tex., Dec. 14, 2011).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22646-a. Bruce Edward Knoepfel (born 1956; married Susan Wentworth, and they had one child: Alex Carl Knoepfel).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22646-b. Sherrie Kay Knoepfel. [1930 census Oklahoma Co., Okla., E.D. 47, p. 16B; WW II AER; obit. of Carl E. Knoepfel, Jr. on "), _c('a', {
    attrs: {
      "href": "http://www.davisgreenlawnfh.com",
      "target": "_blank"
    }
  }, [_vm._v("www.davisgreenlawnfh.com")]), _vm._v("; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11244–235x]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12153. Aubrey Bowden Fletcher (born in Centerville, Leon Co., Tex., Oct. 15, 1893; graduated from Texas Christian U. A teacher of art and music, she was a member of DAR, NSWFD, The National Society of Magna Charta Dames and Barons, and numerous other lineage societies. She married [Dec. 28, 1919] Sim Joe Smith [born Oct. 30, 1893; served in WW I as Lt. in the Field Artillery, USA. He graduated from Trinity U. (A.B.), Columbia U. (M.A.) and U. of Texas-Austin (LL.B.), and he was superintendent of schools in New Rochelle, Westchester Co., N.Y., and Lewisville, Denton Co., Tex. He died Feb. 26, 1990]. She last resided in Bradenton, Manatee Co., Fla., but she died in Denton Co., Tex., July 22, 1993).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+22647. Sim Joe Smith, Jr.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+22648. Aubrey Jeanne Smith. [A. ADAMS-d’ANGERVILLE, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Living Descendants of Royal Blood")]), _vm._v(", 3:441 and 4:930–932; SSDI; TexDI; M. SANDERLIN-C. CRABTREE, “Desc. Emily F. Washington,” 10; NSWFD #29 (Aubrey B. Fletcher); J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11244–24121]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12155. Eunice Aubrey Lewis (born in Tex., Jan. 23, 1887; a teacher, she married [Dec. 22, 1904] William Seth Orr [born ibid., 1885]. They farmed in Hillsboro, Hill Co., Tex.).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+22649. Seth Gwynn Orr.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22650. Margaret Virginia Orr (born in Tex., Aug. 9, 1913; married [Nov. 14, 1947] Carl M. McAfee, Jr. [worked for Castle Oil Company]. They resided in San Angelo, Tom Green Co., Tex.). [1920 census Hill Co., Tex., E.D. 33, p. 8B; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11244–24131]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12156. Minor Bibb Lewis (born Feb. 10, 1889; a farmer, he married in Hill Co., Tex. [July 21, 1909] Mattie Page [born June 25, 1889; died in Hill Co., Tex., Jan. 22, 1984]. They resided primarily in Hillsboro, Hill Co., Tex., but he died in Dallas Co., Tex., March 29, 1964).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22651. Helen Lewis (born Aug. 31, 1913; graduated from North Texas State College [B.S.] and Baylor U. [M.S.]. She married [April 19, 1946] Weldon Plienty Hunter [born Jan. 17, 1914; an insurance salesman, he died in Hillsboro, Tex., Jan. 19, 1989]. They resided in Hillsboro, Tex.).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22652. Gwendolyn Lewis (born Aug. 14, 1916; graduated from Baylor U. [B.S., M.S.]. A teacher, she married [Aug. 14, 1941] Velton Otis Sullins [born in Hill Co., Tex., Oct. 4, 1918; an insurance salesman, he died in Hill Co., Tex., May 23, 1972]. They resided in Hillsboro, Hill Co., Tex., and she died Oct. 14, 1998). ["), _c('a', {
    attrs: {
      "href": "http://FamSearch.org",
      "target": "_blank"
    }
  }, [_vm._v("FamSearch.org")]), _vm._v("/Tex. Births and Tex. Marriages; SSDI; TexDI; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11244–24132]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12157. Lola Bell Lewis (born in Tex., June 12, 1891; married [Oct. 26, 1911] Earl S. Orr [born ibid., Oct. 11, 1891; a farmer, he resided in Hillsboro, Hill Co., Tex., and later in Abbott, Hill Co., Tex. He died in Hillsboro, Tex., April 18, 1974]. She died in Harris Co., Tex., Oct. 1, 1965).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+22653. Kenneth Lewis Orr.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+22654. Mary Bell Orr.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22655. Beatrice Ruth Orr (born in Tex., June 7, 1918; married Donald A. Cappock [served in the military for nine years]. They resided in Roswell, Chaves Co., N.M.).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+26656. Billy Earl Orr. [1930 census Hill Co., Tex., E.D. 9, p. 12A; SSDI; "), _c('a', {
    attrs: {
      "href": "http://FamSearch.org",
      "target": "_blank"
    }
  }, [_vm._v("FamSearch.org")]), _vm._v("/Tex. Deaths; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11244–24133]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12159. Laura Wilson Lewis (born in Tex., Sept. 28, 1896; married [Oct. 31, 1916] William Albert Boswell [born ibid., March 4, 1896; last resided in Athens, Henderson Co., Tex., where he died Jan. 19, 1968]. They resided in San Angelo, Tom Green, Tex., 1930, where he worked as a machinist for the Western Iron Works. She last resided in Athens, Tex., but she died in Smith Co., Tex., July 1, 1980).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Child:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+22657. Gwynn Albert Boswell. [1930 census Tom Green Co., Tex., E.D. 9, p. 7A; SSDI; TexDI; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11244–24135]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12160. Hugh Dawson Lewis (born in Tex., Sept. 25, 1900; married [Aug. 14, 1919] Otis Hazel Kuykendall [born ibid., Sept. 13, 1900; died July 1984]. They resided in Hillsboro, Hill Co., Tex., where he was a farm laborer in 1930 and a public school bus driver in 1940. They also resided in Ore., Kans., and finally in Greeley, Weld Co., Colo. He died Feb. 1966).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+22658. Martha Jane Lewis.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22659. Alice Juanita Lewis (born in Hillsboro, Tex., May 27, 1925).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22660. Donald Hugh Lewis (born ibid., April 17, 1929; married [Nov. 11, 1949] Jeanette Shellmutt [born 1933]). [1930 census Hill Co., Tex., E.D. 7, p. 5A; 1940 census ibid., E.D. 109–40A, p. 3B; SSDI; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11244–24136]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12162. Waller Archibald McMillan (born in Tex., May 29, 1884; a farmer and minister in the Church of the Christ, he married in Coryell Co., Tex. [March 29, 1903] Media Clark [born ibid., Sept. 5, 1881]. They resided in Runnels Co., Tex., 1930, and at another time in Levita, Coryell Co., Tex., which is now described as a “ghost town.” He died June 26, 1960).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+22661. Thomas Carnett McMillan.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22662. Nina Glenn McMillan (born July 18, 1906; died 1907).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+22663. Ermine Lois McMillan.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22664. Willis Gayton McMillan (born Nov. 14, 19__; died Jan. 11, 1911).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+22665. Garnett Eldred McMillan.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22666. Grady Waller McMillan (born in Hill Co., Tex., Nov. 8, 1913; died in Lometa, Lampasas Co., Tex., Dec. 29, 1919).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+22667. Mary Virginia McMillan.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22668. Mildren (sic) McMillan (born May 28, 1919; died young).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22669. Roy Lewis McMillan (born in Tex., April 27, 1921; enlisted in the Navy at Houston, Tex., on Feb. 14, 1942. Two months later he was serving aboard the transport "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Henderson")]), _vm._v(", ferrying troops from the U.S. West Coast to Hawaii. In July 1942, he joined the crew of the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Sonoma")]), _vm._v(". This ancient fleet tug, built in 1911, went on to compile a proud record in WW II, earning five battle stars. In the summer of 1942, the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Sonoma")]), _vm._v(" towed a floating drydock to the Allied base at New Caledonia. For the following year, the boat carried out numerous towing and salvage assignments while based at Noumea in the South Pacific. Roy saw his first combat in support of the Allied invasion of Lae in New Guinea. Soon after approaching the beaches, the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Sonoma")]), _vm._v(" was bracketed by four bombs but escaped with only minor damage. The boat also came under fire from shore batteries while assisting damaged Allied ships.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Still aboard the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Sonom")]), _vm._v("a and now a Machinist 2"), _c('sup', [_vm._v("nd")]), _vm._v(" Class, Roy sailed with the 7"), _c('sup', [_vm._v("th")]), _vm._v(" Fleet for the invasion of Leyte in early Oct. 1944. The tug supported the Fleet in the amphibious landings at Leyte Gulf from October 20–23. On the morning of Oct. 24, Roy’s boat was moored to the transport "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Augustus Thomas")]), _vm._v(". When air raid sirens erupted, the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Sonoma")]), _vm._v(" slipped her lines and her crew manned the few anti-aircraft guns. Soon after opening up on several low-flying bombers, the sailors looked up in horror as a flaming twin-engine bomber streaked towards them. The kamikaze crashed into the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Sonoma")]), _vm._v("’s starboard side, and the aircraft’s fuel ignited in a fireball. Seconds later, two secondary explosions rocked the boat, which soon began listing heavily. Casualties were evacuated and the flames were extinguished, but the doomed tug sank when a weakened bulkhead gave way. Among the dead was Roy Lewis McMillan).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+22670. Ola Laverne McMillan. ["), _c('a', {
    attrs: {
      "href": "http://FamSearch.org",
      "target": "_blank"
    }
  }, [_vm._v("FamSearch.org")]), _vm._v("/Tex. Marriages; 1930 census Runnels Co., Tex., E.D. 5, p. 3B; "), _c('a', {
    attrs: {
      "href": "http://FamSearch.org",
      "target": "_blank"
    }
  }, [_vm._v("FamSearch.org")]), _vm._v("/Tex. Deaths; "), _c('a', {
    attrs: {
      "href": "http://Anc.com",
      "target": "_blank"
    }
  }, [_vm._v("Anc.com")]), _vm._v("/GPIR, U.S. WW II Navy Muster Rolls, U.S. Rosters of WW II Dead, and U.S. WW II Military Personnel Missing in Action or Lost at Sea; "), _c('a', {
    attrs: {
      "href": "http://www.navsource.org/archives/09/64/64012.htm",
      "target": "_blank"
    }
  }, [_vm._v("www.navsource.org/archives/09/64/64012.htm")]), _vm._v("; B. C. NOONAN, website “Desc. of Edward III”; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11244–24141]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12163. Josey Sims McMillan (born in Hillsboro, Hill Co., Tex., Aug. 30, 1887; a telegraph operator, he married [1911] Louise Haston [born in Tenn., Dec. 13, 1874; died in San Antonio, Tex., Oct. 18, 1949]. They resided in Prosper, Collin Co., Tex., 1920, where he was a “railroad agent.” They also resided at one time in Denver, Colo., and later in Houston, Tex., where he was a mechanic in the telegraph department of a railroad, 1940. He died in Houston, Tex., Dec. 18, 1941).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22671. William Lewis McMillan (born in Colo., 1912; a life insurance salesman, he married Jessie L. ___ [born in Tex., ca. 1911]. They resided with his parents in Houston, Tex., 1940).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22672. Theo McMillan (daughter; born in Tex., ca. 1916). [1920 census Collin Co., Tex., E.D. 27, p. 21A; 1940 census Harris Co., Tex., E.D. 258–76, p. 9B; "), _c('a', {
    attrs: {
      "href": "http://FamSearch.org",
      "target": "_blank"
    }
  }, [_vm._v("FamSearch.org")]), _vm._v("/Tex. Deaths; "), _c('a', {
    attrs: {
      "href": "http://Anc.com",
      "target": "_blank"
    }
  }, [_vm._v("Anc.com")]), _vm._v("/AWT; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11244–24142]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12164. Garnet Eldred McMillan (born Jan. 8, 1890; married Lillie Ethel Robinson [born in S.C., ca. 1883; resided as a widow with her mother Eugenia Robinson in Charleston, Charleston Co., S.C., 1920]. He died in Charleston, S.C., 1918, while serving in the Navy during WW I).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Child:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22673. Eldred Ernest McMillan (born in S.C., Oct. 1917). [1920 census Charleston Co., S.C., E.D. 63, p. 8A, which also lists another child, Augusta McMillan (born in S.C., ca. 1910); B. C. NOONAN, website “Desc. of Edward III”; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11244–24143]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12165. Ernest Lewis McMillan (born in Tex., Aug. 19, 1892; apparently served in both the Navy and Army during WW I. A life insurance agent in 1930, he also worked as a reporter and stock breeder. He married [June 1, 1919] Eva H. Wilks [born in Tex., Dec. 23, 1895]. They resided in Beaumont, Jefferson Co., Tex., 1930, and they also resided in Houston and elsewhere in Texas. They last resided in Kerrville, Kerr Co., Tex., where he died March 17, 1978).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+22674. Alton Lewis McMillan.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+22675. Jean Ruth. [1930 census Jefferson Co., Tex., E.D. 3, p. 11A; TexDI; SSDI; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11244–24144]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12168. Elgin Gwynn McMillan (twin; born in Tex., Feb. 6, 1899; a carpenter, he resided in Lampasas Co., Tex., when he registered for the draft Sept. 12, 1918. He married [Sept. 26, 1920] Marguerite Elaine Thomas [born Sept. 22, 1902; died in Sun Valley, Los Angeles Co., Cal., May 1976]. He died in Sun Valley, Cal., April 1976).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+22676. Phyllis Virginia McMillan.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22677. Betty Dee Jewell McMillan (born in Tex., Dec. 31, 1924; died unm. in Sun Valley, Cal., May 1976).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+22678. Richard Gwynn McMillan. [WW I Draft Reg.; CalDI; SSDI; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11244–24147, which uniquely gives Elgin G. McMillan’s year of birth as 1898]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12170. Franklin John McMillan (born in Tex., Feb. 6, 1901; served as a mechanic with the Army Air Service in France during or shortly after WW I. He also served as a civilian worker during WW II at the Army Ordnance Center at Camp Wallace, Tex. He married [1"), _c('sup', [_vm._v("st")]), _vm._v(", on Sept. 17, 1921] Mary C. Jackson [born in Tex., Aug. 5, 1901]. He married [2"), _c('sup', [_vm._v("nd")]), _vm._v("] Rollin Marye Blakeney [born May 25, 1899; died in Beaumont, Jefferson Co., Tex., Aug. 29, 1964]. They resided in Houston, Tex., 1930, where he was a manager of a battery store. He later worked for many years as a traveling parts salesman for Beard and Stone Electric Company in Houston, Tex. He resided in Pidcoke, Lometa, and finally Beaumont, Tex., where he died July 21, 1973).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children (by his 1"), _c('sup', [_vm._v("st")]), _vm._v(" wife):")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+22679. Mary Ruth McMillan.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+22680. Marjorie McMillan. [1930 census Harris Co., Tex., E.D. 30, p. 19B; SSDI; TexDI; FGS by MMIL; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11244–24149]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12171. John Waller Lewis (born in Tex., Oct. 1, 1898; served in the Navy in WW I, and he later worked in the Customs Office along the Texas-Mexico border. He married [Sept. 7, 1930] Maurine Louise Hunter [born March 7, 1908; graduated from Southern Methodist U. (B. Music, 1930). She served as organist and choir director of the First Methodist Church in Laredo, Webb Co., Tex. She last resided in Arlington, Tarrant Co., Tex., where she died Nov. 21, 1986]. They resided in El Paso, El Paso Co., and Laredo, Tex. He last resided in San Antonio, Tex., and he died Feb. 26, 1980. He was buried at Fort Sam Houston National Cemetery in San Antonio, Tex.).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+22681. Charleen Lewis.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+22682. Patsy Jean Lewis. [SSDI; TexDI; U.S. Veterans Gravesites; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11244–24151]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12172. Gladys Lewis (born in Tex., Nov. 12, 1900; married [Jan. 7, 1918] Donald Allison Spencer [born ibid., June 8, 1897; a WW I veteran, he was a “federal officer” in Beaumont, Jefferson Co., Tex., 1930. He died at Fort Sam Houston, Bexar Co., Tex., Nov. 12, 1964]. They also resided in San Antonio, Tex. She last resided in Marble Falls, Burnet Co., Tex., but she died in San Antonio, Tex., June 25 1977).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+22683. Lida Marguerite Spencer.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+22684. Mary Lucille Spencer. [1930 census Jefferson Co., Tex., E.D. 39, p. 11B; "), _c('a', {
    attrs: {
      "href": "http://FamSearch.org",
      "target": "_blank"
    }
  }, [_vm._v("FamSearch.org")]), _vm._v("/Tex. Deaths; SSDI; TexDI; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11244–24152]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12173. Gabriel William Lewis (born in Tex., June 4, 1907; graduated from Texas A&M [B.S., 1930] and U. of Texas [M.A., 1933]. He served as Colonel, USA, and he married [Oct. 29, 1937] Kathryn Mallett [born Aug. 19, 1913]).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22685. Nancy Kathryn Lewis (born in Eastland Co., Tex., Dec. 10, 1940; married [June 17, 1961] John S. Haggerty).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22686. Martha June Lewis (born July 5, 1943).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22687. Susan Margaret Lewis (born Sept. 9, 1948). [TexBI; B. C. NOONAN, website “Descendants of Edward III”; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11244–24153]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12176. Eoline America Nash (born in Tex., March 17, 1902; she was attending the U. of Texas-Austin when her mother died in 1921. Her father instructed her to withdraw from the university and return home “to keep house for him.” The following year, however, she married [Oct. 12, 1922] John Hamilton Adkisson [born in Centerville, Leon Co., Tex., Aug. 29, 1893; A veteran of WW I, he was a lawyer, farmer, and cattleman, and he was later a County Attorney and County Judge in Leon Co., Tex. He last resided in Centerville, Tex., and he died Nov. 23, 1970]. Eoline eventually resumed her studies, and she graduated from the U. of Texas-Austin. She resided in Centerville, Tex., and later College Station, Brazos Co., Tex., where she died Aug. 2, 1979).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Child:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+22688. Bettie Nell Adkisson. [Quotation and FGS from CESL. See also: 1930 census Leon Co., Tex., E.D. 20, p. 3A; TexDI; SSDI; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11244–24162]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12180. Nina Glenn Haydon (born in Leona, Leon Co., Tex., Oct. 22, 1897; attended San Marcos [Tex.] College. A teacher, she married in Mart, McLennan Co., Tex. [Dec. 22, 1918] Joseph Edward Sansom [born in Oletha, Limestone Co., Tex., June 24, 1895; a grocer and newspaper distributor, he died in Mart, Tex., March 12, 1974]. They resided for over 50 years at 806 Limestone Avenue in Mart, Tex., where she died May 3, 1989).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+22689. Nina Nell Sansom.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+22690. Thomas Edward Sansom.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+22691. James Newton Sansom.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+22692. Clara Lea Sansom.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22693. Jo Glenn Sansom (born in Mart, Tex., Oct. 1, 1928; a real estate broker, she married ibid. [1"), _c('sup', [_vm._v("st")]), _vm._v(", on June 24, 1951] Howard Clay Weisiger [born March 16, 1898; served on the Texas border with the Texas National Guard and later in WW I. A railroad conductor, he died in Mart, Tex., June 18, 1974]. She married in Waco, Tex. [2"), _c('sup', [_vm._v("nd")]), _vm._v(", on April 8, 1983] Lawrence Edward Koehne [born in Mart, Tex., April 7, 1927; lying about his age, he enlisted at the age of sixteen in the Navy ca. 1943 and served on in the Pacific. On Dec. 11, 1944, he joined the crew of the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("McConnell")]), _vm._v(". In the spring of 1945, this destroyer escorted three convoys to Guam and Saipan. For the remainder of the war, the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("McConnell")]), _vm._v(" patrolled near bypassed islands in the Marshalls. In addition to bombarding shore installations, she assisted in rescuing both downed airmen and friendly natives who were under threat from the Japanese. Following the Japanese capitulation, the deck of the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("McConnell")]), _vm._v(" was the setting for the formal surrender ceremony of enemy forces at the island of Jaluit.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Lawrence later joined the Army and went on to fight in Korea. Remaining in the Army as a career, Lawrence later served several tours of duty in Vietnam as a door gunner on Huey helicopters before retiring in 1973. His numerous decorations included the Bronze Star, and he died in Mart, Tex., Nov. 1, 1998]. Jo was a dedicated genealogist and a member of many lineage societies, including the DAR, UDC, Daughters of the Republic of Texas, and the Magna Charta Dames. A successful real estate agent for many years, she died in Waco, McLennan Co., Tex., Nov. 23, 2012).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+22694. Margaret Ann Sansom. [NAVY DEPT. (James L. MOODY et al., eds.), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Dicty. of American Naval Fighting Ships")]), _vm._v(", 4:292; U.S. Navy WW II Muster Rolls; SSDI; TexDI; obit. of Jo Sansom Koehne in the Waco (Tex.) "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Tribune-Herald")]), _vm._v(", 11/28/2012; "), _c('a', {
    attrs: {
      "href": "http://Anc.com",
      "target": "_blank"
    }
  }, [_vm._v("Anc.com")]), _vm._v("/AWT, entry by Hadley Soc.; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11244–24173]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12182. Mattie Ruth Lewis (born in Tex., Nov. 15, 1903; married [1935] Lennox Oran Wright [born March 28, 1902; last resided in Normangee, Leon Co., Tex., where he died March 9, 1984]. She died in Normangee, Tex., June 1983).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Child:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+22695. Sara Beth Wright. [TexBI; TexDI; B. C. NOONAN, website “Desc. of Edward III”; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11244–24211]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12185. Robert Gwynn Ross (born in Bryan, Brazos Co., Tex., Sept. 9, 1899; an engineer, he married [ca. 1929] Golda Maxine Allen [born in Tex., Sept. 5, 1911; died in Spicewood, Travis Co., Tex., Jan. 29, 1992]. They resided in Reagan Co., Tex., 1930, and he last resided in Spicewood, Tex., where he died April 24, 1978).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22696. Cecil Jack Ross (born April 17, 1930; served in the Korean War as 1"), _c('sup', [_vm._v("st")]), _vm._v(" Lt., USAF. He died Aug. 22, 2001, and he was buried at Haynie Flat Cemetery in Spicewood, Tex.).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+22697. Robert Gaylon Ross.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22698. Billy Joe Ross (born in Ector Co., Tex., Nov. 18, 1934). [1930 census Reagan Co., Tex., E.D. 3, p. 1B; "), _c('a', {
    attrs: {
      "href": "http://RootsWeb.com",
      "target": "_blank"
    }
  }, [_vm._v("RootsWeb.com")]), _vm._v("/WCP, entry by PEC; SSDI; TexBI; TexDI; U.S. Veterans Gravesites; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11244–24222]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12186. Lois E. Ross (born in Tex., ca. 1902; married Allen E. Crouse [born in Ariz., ca. 1899; a WW I veteran, he later worked as a mechanic for an automobile agency]. They resided in Breckenridge, Stephens Co., Tex., 1930, and they later resided in Fort Worth, Tarrant Co., Tex.).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Child:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22699. Robert A. Crouse (born in Tex., ca. June 1927). [1930 census Stephens Co., Tex., E.D. 4, p. 13B; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11244–24223]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12191. Elna Mills Lewis (born in Tex., Dec. 22, 1910; an oil refinery worker, he enlisted in the Navy at Houston, Tex., on Sept. 29, 1943. On Jan. 24, 1944, he joined the crew of the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Tangier")]), _vm._v(" at San Diego, Cal. For the remainder of the war, he served aboard this cargo ship that had been converted to a seaplane tender. After reaching Brisbane, Australia, on March 21, 1944, she was designated the flagship of the Commander of Aircraft for the U.S. Seventh Fleet. In addition to serving in this headquarters role in McArthur’s conquest of New Guinea, the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Tangier")]), _vm._v(" also tended large numbers of Catalina PBY Flying Boats. From late Sept. 1944 to Dec. 1, 1944, she sustained intermittent air attacks while supporting the Allied invasion of the island of Morotai in what is now eastern Indonesia. From late Dec. 1944 to June 1945, she supported various operations in the Philippines. The "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Tangier")]), _vm._v(" was then ordered back to the West Coast for an extensive overhaul, which was still in progress when the war ended.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Elna married [Feb. 19, 1941] Olene Fontella Turner [born Jan. 2, 1907; resided in Centerville, Leon Co., Tex., where she died April 20, 1994]. They resided at one time in Harris Co., Tex., and later in Leon Co., Tex., where he died Oct. 20, 1983).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22700. Richard Allen Lewis (born in Harris Co., Tex., Sept. 9, 1946).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22701. Dennis Elna Lewis (born ibid., Dec. 31, 1952). [NAVY DEPT. (James L. MOODY et al., eds.), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Dicty. of American Naval Fighting Ships")]), _vm._v(", 7:40–41; U.S. WW II Navy Muster Rolls; TexBI; TexDI; SSDI; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11244–24232]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12192. Joseph Carrol Lewis (born in Leon Co., Tex., Nov. 23, 1916; served in the Army during WW II. His record is badly confused. According to data collected by J.A.W., he married [May 29, 1943] Bernice Gatchell [born March 26, 1909], and they had no children. According to Noonan, however, Joseph married Ruby Mae Adams, and they had two children whom I list below. The Texas Birth Index does confirm that “Joseph Carrol Lewis” and “Ruby Mae Adams” are the parents of these two children).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22702. Ruby Caroline Lewis (born in Cherokee Co., Tex., Feb. 4, 1940; married Harold Davis, and they had one child: Joseph Stephen Davis [born ibid.., Jan. 26, 1961]).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22703. Sandra Kay Lewis (born ibid., May 11, 1947). [1920 census Leon Co., Tex., E.D. 75, pp. 4B-5A; B. C. NOONAN, website “Desc. of Edward III”; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11244–24223]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12193. James Clarence Boyer (born in Greenville, Bond Co., Ill., May 13, 1883; a railway postal mail clerk, he worked the line from Fort Worth, Tex., to Oklahoma City, Okla. He married in Leon Co., Tex. [Nov. 3, 1903] Christian [or “Christina”] Sanders Collard [born in Normangee, Leon Co., Tex., Aug. 13, 1884; died in Fort Worth, Tarrant Co., Tex., Jan. 29, 1981]. They resided in Fort Worth, Tex., where he died April 21, 1943).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+22704. Violet Nell Boyer.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22705. Joseph Carroll Boyer (born in Fort Worth, Tex., Jan. 7, 1907; married [July 4, 1927] Essie Belle McCoy [born Jan. 11, 1908; died in Johnson Co., Tex., Jan. 10, 1991]. An officer in the Air Force during WW II, he "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("d.s.p.")]), _vm._v(" in Fort Worth, Tex., March 12, 1975).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22706. Doris Boyer (born Oct. 9, 1910; married [Oct. 27, 1934] William K. Evans [born 1903]. They owned and operated a retail store in Providence, Providence Co., R.I., and they were divorced in 1948. After her divorce, she returned to Fort Worth, Tex., where she initially operated a secretarial service. She then became the executive secretary to the owner of the McKinley Ironworks in Fort Worth. “She later started, with a partner, a precision casting foundry named Texas Bronze Company. The operation was highly successful in supplying precision aluminum, magnesium and other metal castings to the commercial and military aircraft industry. After her partner’s death she sold the company and retired to her ‘Windy Hill’ estate in Rendon, Tex.” She last resided in Fort Worth, Tex., where she died Dec. 3, 1999).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+22707. Jack Wesley Boyer. [Quotation from M. SANDERLIN-C. CRABTREE, “Desc. Emily F. Washington,” 10–11. See also: D. BOYER, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Am. Boyers")]), _vm._v(", 413; A. ADAMS-d’ANGERVILLE, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Desc. of Blood Royal")]), _vm._v(", 4:137; SSDI; TexDI; "), _c('a', {
    attrs: {
      "href": "http://Anc.com",
      "target": "_blank"
    }
  }, [_vm._v("Anc.com")]), _vm._v("/AWT, entry by The Meriwether Soc.; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11244–24421]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12194. Lewis Kendal Boyer (born in Ill., April 20, 1885; said to have served in the Navy aboard the battleship "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Maine")]), _vm._v(", but this is dubious since the 1930 census indicates that he was not a veteran. [If true, this tradition would refer not to the famous ship that exploded and sank in Havana harbor in 1898, but rather to its successor, the battleship that was commissioned in 1902]. He married Sarah Anne Marston [born in N.H., Dec. 26, 1886]. They resided in Springfield, Hampden Co., Mass., where he worked for a railroad in 1920. He died Feb. 4, 1956).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Child:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+22708. Robert Richard Boyer. [A. ADAMS-d’ANGERVILLE, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Living")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Desc. of Blood Royal")]), _vm._v(", 3:611; 1920 census Hampden Co., Mass., E.D. 159, p. 14A; 1930 census ibid., E.D. 88, p. 16B; M. SANDERLIN-C. CRABTREE, “Desc. Emily F. Washington,” 11; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11244–24422]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12196. Reuben Ernest Boyer (born in Greenville, Bond Co., Ill., Aug. 8, 1890; married [Sept. 24, 1909] Jessie Alleen Wilkes [born in Fort Worth, Tarrant Co., Tex., Nov. 27, 1892; died in Columbia Falls, Flathead Co., Mont., March 1986]. They resided in Whitefish, Flathead Co., Mont., 1930, where he was a railroad conductor and where he died Aug. 29, 1948).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+22709. Beulah Helen Boyer.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+22710. Dorothy Courtenay Boyer.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+22711. Laura Maude Boyer.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+22712. Reuben Ernest Boyer. [A. ADAMS-d’ANGERVILLE, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Living Desc. of Blood Royal")]), _vm._v(", 3:611; 1920 census Flathead Co., Mont., E.D. 53, pp. 23A-B; SSDI; "), _c('a', {
    attrs: {
      "href": "http://Anc.com",
      "target": "_blank"
    }
  }, [_vm._v("Anc.com")]), _vm._v("/AWT, entry by The Meriwether Soc.; M. SANDERLIN-C. CRABTREE, “Desc. Emily F. Washington,” 11; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11244–24424]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12197. Edwin Homer Boyer (born in Greenville, Bond Co., Ill., Sept. 8, 1892; married [1"), _c('sup', [_vm._v("st")]), _vm._v(", on July 21, 1920] Ruby Rae Nance [born Nov. 2, 1892; died in Fort Worth, Tarrant Co., Tex., Feb. 17, 1966]. He married [2"), _c('sup', [_vm._v("nd")]), _vm._v("] Estelle ___ [born Aug. 2, 1894; last resided in Brownfield, Terry Co., Tex., and she died Oct. 1977]. They resided in Fort Worth, Tex., where he died Oct. 29, 1973).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Child (by his 1"), _c('sup', [_vm._v("st")]), _vm._v(" wife):")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+22713. Edwin Homer Boyer, Jr. [A. ADAMS-d’ANGERVILLE, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Living Desc. of Blood Royal")]), _vm._v(", 3:611; TexDI; M. SANDERLIN-C. CRABTREE, “Desc. Emily F. Washington,” 12; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11244–24425]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12198. Mary Helen Boyer (born in Ill., Sept. 6, 1895; a pianist and organist, in 1948 she began an extensive correspondence with J.A.W., Prentiss Price, and other researchers on the Washington family. A member of DAR [#419409] and a charter member of NSWFD, her research has been published in books by Boyer, d’Angerville, and Meriwether, as cited in this entry. She married [July 22, 1920] Charles Franklin Crabtree II [born in Fort Worth, Tarrant Co., Tex., Feb. 11, 1894; studied electrical engineering at Texas A&M. Drafted into the Signal Corps, USA, in WW I, he was assigned to I Troop, 8"), _c('sup', [_vm._v("th")]), _vm._v(" Cav., as signalman, serving along the Texas-Mexico border. Following his discharge in June 1919, he worked as a surveyor for the city of Fort Worth, Tex., where he also worked for the Ford Motor Company in helping set up their assembly line.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("He was an electrical engineer for North Texas Traction Company, and during WW II he was a civilian automotive advisor for the Army at the Red River Arsenal, Texarkana, Tex. After the war, he worked for the VA hospital in Waco, McLennan Co., Tex., where he developed and supervised a manual arts therapy school for recuperating veterans. He later worked for the Army as technical advisor for the 1"), _c('sup', [_vm._v("st")]), _vm._v(" Armored Cav. at Fort Hood. He was an avid ham radio operator, and as a member of the USA MARS Network he assisted in relaying emergency messages to and from U.S. servicemen worldwide. He died in Temple, Bell Co., Tex., Aug. 13, 1987]. They resided in Waco and Houston, Tex., and she died in Waco, Tex., Nov. 28, 1968).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+22714. Marilyn Elaine Crabtree.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+22715. Charles Franklin Crabtree III. [D. BOYER, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Am. Boyers")]), _vm._v(", 410–415; A. ADAMS-d’ANGERVILLE, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Desc. of Blood Royal")]), _vm._v(", 3:611; E. MERIWETHER, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Recollections")]), _vm._v(", 595–600; WW I Draft Reg.; "), _c('a', {
    attrs: {
      "href": "http://FamSearch.org",
      "target": "_blank"
    }
  }, [_vm._v("FamSearch.org")]), _vm._v("/Tex. Deaths; M. SANDERLIN-C. CRABTREE, “Desc. Emily F. Washington,” 12–13; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11244–24426]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12200. James Oscar Boyer (born in Bryan, Brazos Co., Tex., March 3, 1902; an executive with the Boy Scouts of America, he was Scout Executive of the Brooklyn, N.Y., Council, the second largest council in the nation. He married in Fort Worth, Tarrant Co., Tex. [Sept. 9, 1922] Mary Augusta Holder [born in Fort Worth, Tex., Jan. 23, 1903; last resided in Fort Worth, Tex., but died in Va., according to "), _c('a', {
    attrs: {
      "href": "http://Ancestry.com",
      "target": "_blank"
    }
  }, [_vm._v("Ancestry.com")]), _vm._v("/AWT, Oct. 18, 1995]. They resided in Rockville Center, Nassau Co., N.Y., and Malvern, Chester Co., Pa., before retiring in Fort Worth, Tex., where he died March 11, 1988).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22716. Robert Leroy Boyer (born June 14, 1923; died Feb. 28, 1924).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+22717. Edward Rogers Boyer.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22718. Anne Mae (Boyer) Beaufort (born 1947; married [1"), _c('sup', [_vm._v("st")]), _vm._v("] James Millican. After a divorce, she legally changed her surname to “Beaufort.” She began her teaching career in 1969 as a Head Start teacher in Prince George’s Co., Md. She then moved to the San Francisco Bay Area, where she initially taught English at the high school and community college level. She attended a Bay Area Writing Project Summer Institute at the U. of Cal.-Berkeley, and was as a columnist for a weekly newspaper. She went on to work as a corporate communications writer, editor, and trainer for ten years in San Francisco and the Silicon Valley. She married [2"), _c('sup', [_vm._v("nd")]), _vm._v(", on Jan. 5, 1992] Guy Wulfing [born 1943], although she retained Beaufort as her professional name.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("She graduated from Stanford [Ph.D., Language, Literacy, and Culture, 1995]. She then taught as assistant professor at American U. in Washington, D.C., and as associate professor at the State U. of N.Y.-Stony Brook. In 2006 she joined the Interdisciplinary Arts and Sciences Program at the U. of Wash.-Tacoma as writing-across-the-curriculum coordinator. She also wrote two books: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Writing in the Real World: Making the Transition from School to Work")]), _vm._v(" [Teachers College Press, 1999] and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("College Writing and Beyond: A New Framework for University Writing Instruction")]), _vm._v(" [Utah State U. Press, 2007]. Her first book was honored as the best book in science/technical communications by the National Council of Teachers of English in 2001). [A. ADAMS-d’ANGERVILLE, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Desc. of Blood Royal")]), _vm._v(", 3:612; SSDI; M. SANDERLIN-C. CRABTREE, “Desc. Emily F. Washington,” 13; "), _c('a', {
    attrs: {
      "href": "http://Anc.com",
      "target": "_blank"
    }
  }, [_vm._v("Anc.com")]), _vm._v("/AWT, entry by The Meriwether Soc.; faculty profile of Anne Beaufort on the U. of Washington-Tacoma website; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11244–24428]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12201. Dollye Erin Boyer (born in Fort Worth, Tarrant Co., Tex. Sept. 12, 1904; married ibid. [Nov. 25, 1922] David Tupper Shepherd [born in Mexico, Audrain Co., Mo., Dec. 25, 1902; chief cattle buyer for Swift & Company, he died in San Antonio, Tex., Nov. 3, 1971]. They resided in San Antonio, Tex., where she died Aug. 4, 1973).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+22719. David Boyer Shepherd.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22720. Jerry Don Shepherd (adopted; born 1933; married ___, and they had three children: Jerry Shepherd, Deborah Shepherd, and Catherine Shepherd [born 1959]).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+22721. Carolyn Frances Shepherd. [A. ADAMS-d’ANGERVILLE, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Desc. of Blood Royal")]), _vm._v(", 3:612 and 4:138; B. C. NOONAN, website “Desc. of Edward III”; M. SANDERLIN-C. CRABTREE, “Desc. Emily F. Washington,” 13–14; SSDI; TexDI; "), _c('a', {
    attrs: {
      "href": "http://Anc.com",
      "target": "_blank"
    }
  }, [_vm._v("Anc.com")]), _vm._v("/AWT, entry by The Meriwether Soc.; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11244–24429]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12202. Clayton T. Sandifer (born in Mo., ca. March 6, 1900 [but “age 32” in the 1930 census]; married Irene Elizabeth Schrour [born ibid., July 17, 1900]. They resided in Newburg, Phelps Co., Mo., 1930, where he was a locomotive engineer. He died Feb. 24, 1956).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Child:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22722. James C. Sandifer (born in Mo., ca. 1924). [1930 census Phelps Co., Mo., E.D. 1, p. 2A; M. SANDERLIN-C. CRABTREE, “Desc. Emily F. Washington,” 8; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11244–24441]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12203. Frances Mae Bennett (born in Ill., Feb. 20, 1895; married [Nov. 17, 1912] Robert E. Kizer [born in Miss., April 30, 1887; died in Dallas, Tex., Aug. 23, 1976]. They resided in Dallas, Tex., where he was a commercial photographer).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+22723. Annie Mae Kizer.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+22724. Frances Jane Kizer.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+22725. Emily Gibson Kizer.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+22726. Margrette Wynn Kizer. [1930 census Dallas Co., Tex., E.D. 55, p. 51A; TexDI; SSDI; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11244–24463]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12204. James Thomas Bennett (born in Fort Worth, Tarrant Co., Tex., July 18, 1898; married [1"), _c('sup', [_vm._v("st")]), _vm._v(", in 1917] Iva (?) Lillian Chumly [she appears as “Iva (?) L.” in the 1930 census; born in Tex., ca. 1905]. He married [2"), _c('sup', [_vm._v("nd")]), _vm._v("] Patricia Watkins [born Oct. 24, 1907], and he married [3"), _c('sup', [_vm._v("rd")]), _vm._v("] ___. He worked as a sign painter in Fort Worth, Tex., 1930. He died in Burleson, Johnson Co., Tex., Jan. 1, 1968).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children (by his 1"), _c('sup', [_vm._v("st")]), _vm._v(" wife):")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+22727. James Thomas Bennett, Jr.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+22728. Enid Irene Bennett.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Child (by his 2"), _c('sup', [_vm._v("nd")]), _vm._v(" wife):")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+22729. Frances Alton Bennett. [1930 census Tarrant Co., Tex., E.D. 69, p. 89A; TexBI; "), _c('a', {
    attrs: {
      "href": "http://FamSearch.org",
      "target": "_blank"
    }
  }, [_vm._v("FamSearch.org")]), _vm._v("/Tex. Deaths; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11244–24464]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12209. Edith Elizabeth Steinkamp (born Sept. 5, 1903; married James Van Etter, and she died Aug. 29, 1936).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22730. James Robert Etter (born ca. 1922; died in WW II, 1941, age 19).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22731. John William Etter (married ___, and he had one child: Robert Etter). [J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11244–24475]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12211. Durward Valdamir Sandifer (born in Tamalco, Bond Co., Ill., July 26, 1900; graduated from Eureka [Ill.] College [A.B., 1924], where he was subsequently instructor in Rhetoric and Argumentation in addition to coach of the debate team [1924–1927]. From there he went on to earn three advanced degrees at Columbia [M.A., 1928; LL.B., 1931; Ph.D., 1939]. After teaching political science at Rutgers [1931–1934], he began a distinguished career in the U.S. State Department. From 1934 to 1942 he served as assistant to the Department’s legal adviser, spending much of 1937–1940 preparing the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Digest of International Law")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("In 1942 he became assistant chief of the State Department’s new Division of Political Studies and Special Research, whose main duties were to formulate the foundations for a post-war international organization to cope with international problems and preserve world peace. This remained the focus of Sandifer’s long tenure in the State Department. His numerous posts in the following years included: associate chief and chief of the Division of International Security and Organization, deputy director of the Office of Special Political Affairs [1945–1947], deputy director of the Office of U.N. Affairs [1947–1948], and Deputy Assistant Secretary of State for the Bureau of U.N. Affairs [1949–1954]. Throughout this period he participated in numerous important conferences, including the Dumbarton Oaks Conference [1944] and the Conference on International Organization in San Francisco [1945]. He was also senior legal adviser to the U.S. delegation at the U.N. General Assembly in 1946–1947 and 1951–1952. Some of his more important duties in this period included prominent roles in the establishment of the International Refugee Organization and the drafting of the Declaration of Human Rights adopted at the third U.N. General Assembly in 1948. In recognition of his contributions, his alma mater Eureka College conferred on him an honorary LL.D. degree in 1947.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Sandifer was designated a foreign service officer, class I, in 1954, and served for three years as political counselor at the U.S. embassy in Buenos Aires. In 1958–1959, he was assigned to the staff of the International Cooperation Administration and participated prominently in the political and economic appraisal of U.S. foreign policy in the Philippines, Pakistan, and the Caribbean. At the time of his retirement in 1960, he was the State Department and foreign affairs adviser to the Industrial College of the Armed Forces at Fort McNair. In 1960 he accepted a professorship of International Relations at the School of International Service of American U. in Washington, D.C.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("He was the author of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Production of Evidence Before International Tribunals")]), _vm._v(" (1939) and co-author of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Foundations of Freedom")]), _vm._v(" (1966). He also contributed articles to professional journals as well as reports to government bulletins. He married in Mount Pulaski, Logan Co., Ill. [1"), _c('sup', [_vm._v("st")]), _vm._v(", on June 23, 1925] Irene Reiterman [born in Latham, Logan Co., Ill., March 22, 1902; graduated from Eureka College (A.B., 1924) and Columbia U. (M.A., History, 1928). She served as president of the League of Women Voters for both Montgomery Co., Md., and for the state of Maryland, and she was president of the Board of Education for Montgomery Co., Md. She privately published (1975) a biography of Eleanor Roosevelt, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Mrs. Roosevelt as We Knew Her")]), _vm._v(". Irene died in Washington, D.C., April 8, 1977].")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("He married [2"), _c('sup', [_vm._v("nd")]), _vm._v("] Virginia Tannar [born Aug. 1, 1902; graduated from Eureka College (Ill.), and she initially worked as a public school teacher. In 1935 she received a Temporary Emergency Relief Administration scholarship to attend the New York School of Social Work (now Columbia U.). She earned a master’s degree in Social Work in 1942, and Eureka College conferred upon her an honorary Doctor of Humane Letters degree in 1982. In the late 1930s, her career as a social worker advanced rapidly in the New York City Department of Welfare. She was initially a caseworker, then a supervisor and staff development teacher. She later served as a field instructor with the New York School of Social Work, directing the first student unit established in the public assistance program of the New York Department of Public Affairs. She became professor of Social Work with Case Western Reserve U. in 1943, and in the following years she was frequently invited to give short courses and seminars for the Council on Social Work Education and numerous colleges and government agencies throughout the country.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("In 1961 she began to work extensively with the U.S. Department of Health, Education, and Welfare, culminating in her book "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Case Work Concepts for Public Welfare Workers")]), _vm._v(", published by the U.S. Government Printing Office. After accepting a full-time position at the Department of HEW, she directed and taught training workshops, in addition to writing materials to assist family and child welfare departments. She also participated in a series of United Nations workshops that were presented in Hong Kong, Bangkok, and Manila. She was in charge of preparing the final report of this project, which was published in May 1971. Also a talented artist, she avidly pursued her hobby after her retirement in 1973. She died in Washington, D.C., Dec. 14, 1999]. Durward died May 31, 1981).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Child (by his 1"), _c('sup', [_vm._v("st")]), _vm._v(" wife):")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+22732. Muriel Sandifer. ["), _c('em', {
    staticClass: "italic"
  }, [_vm._v("NCAB")]), _vm._v(", “K”:143–145; "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ConAu")]), _vm._v(", vol. 108, pp. 427–428; SSDI; unidentified obit. of Irene R. Sandifer provided by SJT; obit. of Virginia T. Sandifer in the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Washington Post")]), _vm._v(", 12/16/1999, and tribute posted on the website of the NASW Foundation ("), _c('a', {
    attrs: {
      "href": "http://http://www.naswfoundation.org/pioneers/t/tannar.htm",
      "target": "_blank"
    }
  }, [_vm._v("http://www.naswfoundation.org/pioneers/t/tannar.htm")]), _vm._v("); M. SANDERLIN-C. CRABTREE, “Desc. Emily F. Washington,” 15; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11244–24741]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12213. Marcella A. Sandifer (born in Ill., June 1, 1907; married Riverton, Sangamon Co., Ill. [June 1, 1929] Russell Wiley [born in Ill., ca. Dec. 31, 1892; died Feb. 14, 1952]. They resided in Riverton, Ill., where he was unemployed in 1930. She taught at Riverton Elementary School for 33 years, and she died in DeKalb Co., Ill., Jan. 21, 1990).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Child:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22733. Darrell B. Wiley (born Feb. 7, 1933; a physician, he resided in Sycamore, DeKalb Co., Ill., and he died unm.). [1930 census Sangamon Co., Ill., E.D. 54, pp. 15A-B; USPRI; unidentified newspaper obit. of Marcella S. Wiley, provided by SJT; "), _c('a', {
    attrs: {
      "href": "http://Anc.com",
      "target": "_blank"
    }
  }, [_vm._v("Anc.com")]), _vm._v("/PMT; M. SANDERLIN-C. CRABTREE, “Desc. Emily F. Washington,” 15; SSDI; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11244–24743]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12214. Courtenay Ellen Sandifer (born in Brownstown, Fayette Co., Ill., Feb. 13, 1912; attended Millikin U. in Decatur, Ill. An accomplished musician, she married [ca. 1935] Glen B. Ray [born 1915; died April 1978]. Later divorced, she resided in Greenville, Bond Co., Ill., and then O’Fallon, St. Clair Co., Ill., where she died Jan. 1985).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+22734. David Ray.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+22735. Donald Gene Ray.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+22736. Norman Wilson Ray. [SSDI; unidentified newspaper obit. of Courtenay E. Ray provided by SJT; "), _c('a', {
    attrs: {
      "href": "http://Anc.com",
      "target": "_blank"
    }
  }, [_vm._v("Anc.com")]), _vm._v("/PMT; M. SANDERLIN-C. CRABTREE, “Desc. Emily F. Washington,” 15; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11244–24744]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12215. Kenneth Wilson Sandifer (born in Ill., ca. April 1916; a photographer, he married [1935] Mary Jane Denny [born in Ill., ca. 1916]. They resided in Port Washington, Ozaukee Co., Wisc., 1940, and he died 1957).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+22737. Judith Anne Sandifer.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22738. Mary Lynn Sandifer (born 1947; married [1969] Michael A. McLintock).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22739. Scott Denny Sandifer (born 1953; resided in Owensboro, Daviess Co., Ky.). [1940 census Ozaukee Co., Wisc., E.D. 45–13, p. 7A; USPRI; M. SANDERLIN-C. CRABTREE, “Desc. Emily F. Washington,” 9; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11244–24745]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12216. Harry Francis Titus (born in Collinsville, Madison Co., Ill., Feb. 27, 1904; married in Peoria, Peoria Co., Ill. [1"), _c('sup', [_vm._v("st")]), _vm._v(", on Feb. 9, 1936] Marjorie Anne Lucas [born in Peoria, Ill., Aug. 9, 1910; died in Mira Loma, Riverside Co., Cal., Sept. 3, 1980]. Later divorced, he married [2"), _c('sup', [_vm._v("nd")]), _vm._v(", in 1954] Nancy Curless. They resided in Peoria, Ill., later in Bartonville, Peoria Co., Ill., and finally in Havana, Mason Co., Ill. He died in Springfield, Sangamon Co., Ill., April 26, 1987).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children (by his 1"), _c('sup', [_vm._v("st")]), _vm._v(" wife):")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22740. Stephen James Titus (born in Canton, Fulton Co., Ill., April 11, 1938; married in Salem, Marion Co., Ore. [July 7, 1962] Kay Eliadene McWhirter [born in Coeur d’Alene, Kootenai Co., Ida.; died Jan. 19, 1989]. They were divorced in San Diego, Cal., Sept. 1971. NSWFD member #1071, he generously supplied information on his family).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+22741. Elizabeth Shannon Titus. [M. SANDERLIN-C. CRABTREE, “Desc. Emily F. Washington,” 15–16, 25; SSDI; FGS by SJT (NSWFD member #1071), which I follow; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11244–24751]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12217. Nellie Maude Titus (born in Smithboro, Bond Co., Ill., Aug. 7, 1906; graduated from Eastern Illinois Teacher’s College. She married in Greenville, Bond Co., Ill. [May 31, 1930] Charles Oliver Altom [born in Clay City, Clay Co., Ill., Jan. 18, 1908; died in Greenville, Ill., June 1974]. Together they ran a photographic business. She resided primarily in Greenville, Ill., but she moved as a widow to Lancaster, Grant Co., Wisc., 1979. She died at the age of 103 in Fennimore, Grant Co., Wisc., Dec. 1, 2009).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Child:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+22742. Linda Ann Altom. [SSDI; "), _c('a', {
    attrs: {
      "href": "http://www.findagrave.com",
      "target": "_blank"
    }
  }, [_vm._v("www.findagrave.com")]), _vm._v(" (with obit. of Nellie T. Altom); M. SANDERLIN-C. CRABTREE, “Desc. Emily F. Washington,” 16; FGS by SJT; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11244–24752]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12218. Artie May Sandifer (born in Tex., Aug. 12, 1907; married [1"), _c('sup', [_vm._v("st")]), _vm._v(", in 1929] Hodge Schroeder. Later divorced, she married [2"), _c('sup', [_vm._v("nd")]), _vm._v(", in 1939] Joseph Martin Norman [born Nov. 4, 1895]. They resided in Alpine, Brewster Co., Tex., and Los Angeles, Cal. She died in Los Angeles Co., Cal., June 19, 1951).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Child (by her 2"), _c('sup', [_vm._v("nd")]), _vm._v(" husband):")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+22743. Mark Sandifer Norman. [CalDI; M. SANDERLIN-C. CRABTREE, “Desc. Emily F. Washington,” 16; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11244–24761]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12220. Annie Kate Sandifer (born in Alpine, Brewster Co., Tex., June 25, 1913; married [1"), _c('sup', [_vm._v("st")]), _vm._v(", in 1934] Monroe M.Barron. Later divorced, she married [2"), _c('sup', [_vm._v("nd")]), _vm._v(", in 1952] William N. Lamb. She died in Los Angeles Co., Cal., Dec. 26, 1969).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Child (by her 1"), _c('sup', [_vm._v("st")]), _vm._v(" husband):")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22744. Robert Arthur Barron (born 1935; married [1960] Carolyn E. Trindall. Later divorced in 1964, they had no children). [CalDI; M. SANDERLIN-C. CRABTREE, “Desc. Emily F. Washington,” 16; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11244–24763]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12221. Bonnie Pearl Sandifer (born in Alpine, Brewster Co., Tex., Sept. 16, 1915; married [1937] Horace C. Rogers [born in Tex., ca. 1914]. They resided in Somerset, Bexar Co., Tex., 1940, where he was a public school teacher. They last resided in Coleman, Johnston Co., Okla., and she died Oct. 1978).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Child:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+22745. Diana Rogers. [1940 census Bexar Co., Tex., E.D. 15–27, p. 5B; SSDI; M. SANDIFER-C. CRABTREE, “Desc. Emily F. Washington,” 16; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11244–24764]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12222. Jonas Henry Sandifer (born in Ill., Jan. 25, 1914; married [May 1, 1946] Darlene Moeller [born 1924 or 1927]. They resided in South Bend, St. Joseph Co., Ind.).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Child:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22746. Nancy Jo Sandifer (born 1948; married [1971] James Sako). [M. SANDIFER-C. CRABTREE, “Desc. Emily F. Washington,” 16–17, which gives his name as “Jones Henry Sandifer”; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11244–247a1]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12231. Warner Blair Washington III (born in Clarksville, Red River Co., Tex., Feb. 20, 1934; married Geraldine Merle Witkop).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+22747. Warner Blair Washington IV.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22748. Mary Catherine Washington (born in Dallas Co., Tex., Sept. 23, 1961). [J. McGILL, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Beverley")]), _vm._v(", 107; TexBI; USPRI; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11244–72131]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12236. William Edward Porter (born 1940; married [1"), _c('sup', [_vm._v("st")]), _vm._v("] Barbara Woodson, and he married [2"), _c('sup', [_vm._v("nd")]), _vm._v("] Becki Ray).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children (by which wife is not stated):")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22749. Barbara Gayle Porter.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22750. William Edward Porter, Jr. [J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11244–84921, rev.]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12237. Martha Lanier Porter (born 1948; married John Siewertsen).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22751. James McDonald Siewertsen (born in Warren Co., Ky., Jan. 14, 1971).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22752. John Christian Siewertsen (born in Jefferson Co., Ky., June 17, 1974).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22753. Emily Anna Siewertsen (born ibid., April 1, 1977). [KyBI; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11244–84922, rev.]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12239. Lamar Washington, Jr. (born in Port Washington, Nassau Co., N.Y., May 7, 1923; graduated from MIT. He married in Corona, Riverside Co., Cal. [July 20, 1946] Dawn Ardyce Cain [born June 10, 1925; died in Elmira, Yates Co., N.Y., Oct. 1987]. According to J.A.W., they had six children).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children (partial list?):")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+22754. William Hunter Washington.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22755. Josephine Helen Washington (married Rick Saunders, and together they were prominent realtors in the Northern Virginia area. She was president of Virginia Estates, Inc., and their main office was Fairfax Realty, Inc., in Falls Church, Va.).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22756. Dawne Washington (born in Pomona, Los Angeles Co., Cal., Jan. 5, 1949; as a teenager, she was an accomplished equestrienne, jumping four-foot fences and riding in fox hunts. In high school she was a drummer in several bands. She married in Framingham, Middlesex Co., Mass [1"), _c('sup', [_vm._v("st")]), _vm._v(", on Jan. 14, 1967] Jeffrey Paul Stetson. Later divorced, she graduated from Northeastern U. [B.S., Respiratory Therapy]. She participated in a work-study program at Massachusetts General Hospital and Boston Children’s Hospital, and Boston City hospital. She then moved to Utah, where she met and married in Salt Lake City, Salt Lake Co. [2"), _c('sup', [_vm._v("nd")]), _vm._v(", on Nov. 17, 1975] John Anthony Martoccia. She worked in the heart clinic at St. Luke’s Regional Medical Center in Boise, Ada Co., Ida., for fifteen years, and she received intensive training in high risk deliveries for the Neonatal Unit. After 35 years as a health professional, she retired and devoted much of her time to genealogy. She joined DAR as member #897918.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Dawne had one child by her first husband Jeffrey: Troy Matthew Stetson [born in Framingham, Mass., Dec. 13, 1967; he was later adopted by Dawne’s second husband John, and his name legally became Troy Matthew Martoccia. Troy married in Clarksville, Montgomery Co., Tenn. [Dec. 31, 1987] Jennifer Brashear, and they had three children: Mercedes Nichole Martoccia [born in Clarksville, Tenn., June 24, 1989], Christian Martoccia [born ibid., April 10, 1991], and Alexis Brooke Martoccia [born in Nashville, Tenn., April 6, 1995].")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Dawne had three children by her second husband John:")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("[1]. Michael Anthony Martoccia (born in Roosevelt, Duchesne Co., Ut., Jan. 20, 1977; married in Boise, Ada Co., Ida. [April 17, 2000] Darcy Dayne Gill. They had one child: Chloe Grace Martoccia [born in Boise, Ida., Oct. 13, 2005]).")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("[2]. Jennifer Dawn Martoccia (born in Salt Lake City, Ut., July 29, 1978).")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("[3]. Christina Maria Martoccia (born ibid., Oct. 6, 1981; married in Boise, Ida. [April 21, 2001] Danny Durham. They had three children: Hunter Xavier Durham [twin; born in Boise, Ida., Sept. 4, 2001], Dylan Troy Durham [twin; born ibid., Sept. 4, 2001], and Zane Grey Durham [born ibid., Sept. 2, 2003]). [Posting by LM on "), _c('a', {
    attrs: {
      "href": "http://www.genealogy.com/users",
      "target": "_blank"
    }
  }, [_vm._v("www.genealogy.com/users")]), _vm._v("; "), _c('a', {
    attrs: {
      "href": "http://dcarearealestate.com",
      "target": "_blank"
    }
  }, [_vm._v("dcarearealestate.com")]), _vm._v("; FGS by DWZ (DAR member #897918); J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11244–85112, rev.]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12241. Alan Washington (born in Murfreesboro, Rutherford Co., Tenn., Jan. 29, 1920; graduated from Cumberland College. A pilot in WW II, he continued to serve later in the Navy Reserve after the war. In all he flew 116 missions in the Pacific, including 41 in combat. As the pilot of a Martin Mariner in early 1945, he and his crew were credit with sinking 212 tons of Japanese shipping off the coast of Formosa and China. He also rescued two downed pilots and evacuated seventeen wounded American soldiers and Filipino guerillas. For his wartime service, he was recommended by his commanding officer for the Distinguished Flying Cross and three Air Medals. According to a family tradition posted on "), _c('a', {
    attrs: {
      "href": "http://Ancestry.com",
      "target": "_blank"
    }
  }, [_vm._v("Ancestry.com")]), _vm._v("/PMT, he occasionally flew USO performers during the war in the South Pacific, including the comedian Jack Benny.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("He married [1"), _c('sup', [_vm._v("st")]), _vm._v(", on March 3, 1942] Elizabeth Hopkins [following a divorce, she later married Alan Washington’s first cousin, John Williams Washington, the son of Howell Washington]. He married [2"), _c('sup', [_vm._v("nd")]), _vm._v(", on Nov. 21, 1956] Lillian Maxine Crabtree. After the war, he earned a law degree and had a law practice in Murfreesboro, Tenn. He later worked for the Atomic Energy Agency in Oak Ridge, Tenn. He last resided in Knoxville, Knox Co., Tenn., where he died Jan. 26, 1994).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children (by his 1"), _c('sup', [_vm._v("st")]), _vm._v(" wife):")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22757. Jerald Washington (born in Nashville, Tenn., Jan. 11, 1944; graduated from Middle Tenn. State U. [B.S.] and U. of Tenn. [M.A., Ph.D., Political Science]. He served in Vietnam as Capt., USA. He married [1"), _c('sup', [_vm._v("st")]), _vm._v("] Georgeianne Dunavant, and he married [2"), _c('sup', [_vm._v("nd")]), _vm._v("] Denise Stanfill. He married [3"), _c('sup', [_vm._v("rd")]), _vm._v("] Anne Rowland, and he married [4"), _c('sup', [_vm._v("th")]), _vm._v("] Suanne Adams. Divorced three times, he was associate professor of Political Science at Sul Ross U. and the U. of Tenn. He was also co-founder of the National Coalition for Homeless Veterans with headquarters in Washington, D.C. He died in Jacksonville, Fla., March 19, 2001. He and his second wife Denise adopted one child: Tony Washington [born in El Paso, El Paso Co., Tex., March 10, 1976]).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22758. Suzanne Washington (born in Nashville, Tenn., Aug. 23, 1948; graduated from U. of Houston [B.A., Spanish, 1982] and South Texas College of Law [J.D., 1986]. After working as an insurance underwriter [1966–1978], she later practiced law for 24 years in Houston, Tex. DAR national member #821733, she was an Elder in the Presbyterian Church USA. She married in Nashville, Tenn. [March 22, 1965] Kenneth L. Ross, Jr. [born in Nashville, Tenn., 1946; graduated from U. of Tenn.-Knoxville (B. Architecture, 1971). A Fellow of the American Institute of Architects (AIA), he was a founding principal of WHR Architects, Inc., in Houston, Tex. He was later vice-president for Design and Practice for the AIA, and he also served as an Elder in the Presbyterian Church USA]. They retired on a farm in Culpeper Co., Va.).")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("They had two children:")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("[1]. Kimberly Lynne Ross (born in Knoxville, Tenn., Oct. 21, 1965; a homemaker and substitute teacher, she married in Houston, Tex. [Aug. 20, 1988] John C. Flint [graduated from Texas Women’s U (B.S., 1991), and he was a physical therapist]. They resided in Texarkana, Bowie Co., Tex. They had four children: Jessica R. Flint [born in Houston, Tex., May 19, 1990; married (Sept. 23, 2012) Ian P. Weiner, and they had one child: Zion David Weiner], Abigail S. Flint [born ibid., Sept. 28, 1991], Nicholas R. Flint [born in Texarkana, Tex., May 10, 1993], and Elliot J. Flint [born ibid., Jan. 20, 1997]).")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("[2]. Kara Lea Ross (born in Houston, Tex., July 28, 1972; graduated from the U. of Houston [B.S., Hilton School of Hotel and Restaurant Management, 1998]. She was an entrepreneur in Houston, Tex., where she married [1"), _c('sup', [_vm._v("st")]), _vm._v(", on Aug. 1, 1992] Jorge L. Garza II. Divorced in 2005, she married [2"), _c('sup', [_vm._v("nd")]), _vm._v(", on July 29, 2006] Paul A. Conrad, a CPA. She had three children by her first husband: Sarah J. Garza [born in Houston, Tex., May 12, 2000], Jacob E. Garza [born ibid., June 3, 2003], and Kathryn A. Garza [born ibid., Aug. 25, 2004]).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children (by his 2"), _c('sup', [_vm._v("nd")]), _vm._v(" wife):")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22759. Clay Washington (born in Chattanooga, Hamilton Co., Tenn., March 27, 1958; served as an Army officer [1981–1985]. He married Cindy Sims, and they were divorced. They had one child: Blake Washington [born in Elizabethtown, Hardin Co., Ky., Jan. 12, 1986]).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22760. Donna Washington (born in Knoxville, Tenn., Sept. 1, 1959; graduated from U. of Tenn.-Knoxville [B.S., Wildlife & Fisheries Science, 1981; certification in Elementary Education, 2000]. She married in Knoxville, Tenn. [1981] Alan D. Lyons, and they were divorced in 1997. They had two children: Douglas A. Lyons [born in Homewood, Jefferson Co., Ala., Oct. 11, 1990] and Leslie M. Lyons [born ibid., July 20, 1994]).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22761. Karen Washington (born in Knoxville, Tenn., March 5, 1961; graduated from Middle Tenn. State U. [B.S., Elementary Education, 1983]. She married [April 19, 1986] Nelson Bryan Smith. She was thrice voted Teacher of the Year at Gresham Middle School in Knoxville, Tenn. [1994, 2001, 2007]).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22762. Scott Washington (born in Knoxville, Tenn., July 5, 1962; an electrical engineer, he married [1"), _c('sup', [_vm._v("st")]), _vm._v(", on April 6, 1985] Rhonda Louise Mauldin. Divorced in 2002, he married [2"), _c('sup', [_vm._v("nd")]), _vm._v(", on April 5, 2003] Stormy Leigh Weathers. He had three children by his first wife Rhonda: Austin Jacob Washington [born Dec. 6, 1990; married (June 2012) Elizabeth Robinson], Madison Anne Washington [twin; born Nov. 10, 1998] and Elijah Tanner Washington [twin; born Nov. 10, 1998]).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22763. Sara Washington (born in Knoxville, Tenn., Dec. 27, 1966; graduated from U. of Tenn.-Knoxville [B.A., Italian Literature], U. of Wisc. [M.A., Italian Literature], and U. of N.C.-Chapel Hill [Information Science]. For eight years she taught English in Florence and Rome, Italy). [“Nashville Officer Has Flown 41 Combat Missions in Pacific,” "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Nashville Tennessean")]), _vm._v(", 7/6/1945; "), _c('a', {
    attrs: {
      "href": "http://Anc.com",
      "target": "_blank"
    }
  }, [_vm._v("Anc.com")]), _vm._v("/PMT; FGS by SWR and EWB]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12242. Robert Howell Washington (born in Tenn., April 29, 1923; a military pilot in WW II, he worked after the war as a pilot for Pan American Airlines in Miami, Fla. Later he was stationed in San Francisco, Cal., from which he flew international flights on a Pan American 747. He married [Aug. 21, 1943] Caroline Reinke, and he died in Contra Costa Co., Cal., Nov. 17, 1972).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22764-a. Robert Howell Washington, Jr.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22764-b. Janet Washington. [SSDI; "), _c('a', {
    attrs: {
      "href": "http://Anc.com",
      "target": "_blank"
    }
  }, [_vm._v("Anc.com")]), _vm._v("/PMT; J.A.W., 11244–85313]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12243. Barbara Washington (born in Murfreesboro, Rutherford Co., Tenn., Jan. 21, 1925; DAR member #553935, she married in Davidson Co., Tenn. [April 3, 1943] Granville Sumner Dismukes, Jr. [born Feb. 14, 1921; a farmer and WW II veteran, he enlisted in the Army at Fort Oglethorpe, Ga., Jan. 4, 1944. He died May 14, 2006]. They resided in Rutherford Co., Tenn.).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22765. Granville Sumner Dismukes III.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+22766. Sharon Dismukes.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22767. Barbara Dismukes.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22768. Jeffrey Smith Dismukes.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22769. Percy Wade Dismukes. [WW II AER; Barbara W. Dismukes, DAR approved application, Natl. #553935; FGS by PWB (NSWFD member #1082)]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12245. Joel Washington (born in Tenn., Aug. 3, 1928; married [1"), _c('sup', [_vm._v("st")]), _vm._v("] Bertha Steers. He married [2"), _c('sup', [_vm._v("nd")]), _vm._v("] Adelaide ___).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children (by his 1"), _c('sup', [_vm._v("st")]), _vm._v(" wife):")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22770. Monica Washington.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22771. William Hunter Washington.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children (by his 2"), _c('sup', [_vm._v("nd")]), _vm._v(" wife):")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22772. Stephanie Washington.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22773. Marcella Washington. [FGS by EWB and PWB (NSWFD member #1082)]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12250. Emily Fairfax MacRae (born in N.C., May 19, 1901; graduated from Winthrop College [B.A.]. She married [Feb. 14, 1941] Benjamin Carter West [born Dec. 8, 1895; he was an engineer with AT&T]. They resided Westfield, Union Co., N.J., and later West Palm Beach, Palm Beach Co., Fla. She died Aug. 1989).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Child:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22774. Farinda Washington West (born Aug. 8, 1943). [J. McGILL, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Beverley")]), _vm._v(", 111; SSDI; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11244-x1121]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12251. Cameron Farquhar MacRae, Jr. (born in Wilmington, New Hanover Co., N.C., Dec. 26, 1905; graduated from the U. of N.C.-Chapel Hill [B.S., Civil Engineering, 1926]. He was a postgraduate student at Pittsburgh School of Accountancy [1929–1930], and he graduated from N.Y. Law School [J.D., 1937]. Later serving as Colonel, USA, in WW II, his decorations included the Legion of Merit. He was a senior partner in a New York City law firm [1958–1980] and counsel to the firm [1980-ca. 1990]. A member of the board of directors of The Hobe Sound Company, he published a number of articles in professional journals. He also served as president of the North Carolina Society of New York [1958–1960], president of the Federal Energy Bar Association [1969–1970], and chairman of the National Energy Forum, Scientists and Engineers for Secure Energy [1980–1982]. He married [Dec. 24, 1935] Jane B. Miller, and they resided in Hobe Sound, Martin Co., Fla. He died May 29, 2000).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Child:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+22775. Cameron Farquhar MacRae III. ["), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Who’s Who Am.")]), _vm._v(", 1990–91; B. PAYNE, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Paynes")]), _vm._v(", 202; J. McGILL, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Beverley")]), _vm._v(", 111; SSDI; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11244-x1122]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12253. Robert Aubrey Parsley, Jr. (born in New Hanover Co., N.C., Dec. 1, 1909; served in the Navy in WW II, advancing from Lt. [jg] to Lt. Commander, Bureau of Ships. In the spring of 1943, he served briefly aboard the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Housatonic")]), _vm._v(", an oiler that served in the Mediterranean to support Allied operations in North Africa, Sicily, and southern Italy. Later an executive with Esso Standard Oil Company, he married [March 13, 1943] Frances Carolyn Gentry [born Feb. 13, 1922]. They resided in Nashville, Tenn., and he died in New Hanover Co., N.C., Dec. 26, 1965).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22776. Margaret Parsley (twin; born July 23, 1947).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22777. Carter Parsley (twin; born July 23, 1947). [J. McGILL, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Beverley")]), _vm._v(", 111; NAVY DEPT. (James L. MOODY et al., eds.), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Dicty. of American Naval Fighting Ships")]), _vm._v(", 3:374; U.S. WW II Navy Muster Rolls; NCarBI; "), _c('a', {
    attrs: {
      "href": "http://Anc.com",
      "target": "_blank"
    }
  }, [_vm._v("Anc.com")]), _vm._v("/N.C. Death Certificates; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11244-x1132]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12254. Henry Nutt Parsley (born in Wilmington, New Hanover Co., N.C., Oct. 20, 1912; graduated from U. of N.C.-Chapel Hill, where he was editor of the university yearbook, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Yackety Yack")]), _vm._v(", and also a member of the university’s oldest and highest honorary society, The Order of the Golden Fleece. He later graduated from Virginia Theological Seminary [B.D., ca. 1936]. Ordained an Episcopal priest in 1937, he initially served as assistant at Grace Church in Amherst, Mass., and as assistant chaplain at Amherst College. In 1947 he accepted a call as associate rector of St. John’s Church in Memphis, Tenn. In 1950 he became head of the Canterbury Club and Episcopal chaplain at Vanderbilt U. He later served as rector of St. Stephen’s Church in Louisville, Ky., and he then returned as rector of St. John’s Church in Memphis, Tenn., where he retired in 1977. He married in Memphis, Tenn. [Nov. 8, 1947] Barbara Brown Burch [born in Memphis, Tenn., Dec. 26, 1924; a kindergarten teacher and member of the Colonial Dames of America, she died in Memphis, Tenn., June 13, 1996]. He died in Memphis, Tenn., Aug. 5, 1994).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Child:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+22778. Henry Nutt Parsley, Jr. [J. McGILL, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Beverley")]), _vm._v(", 111; unidentified obit. of Henry N. Parsley, Sr., plus other data from the archives of St. John’s Church in Memphis, generously contributed by the parish registrar, Kay Sowell; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11244-x1133]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12255. Charles Fairfax Payne (born in Newport News, Va., Aug. 9, 1911; graduated from MIT [Chemical Engineering], and he was a supervisor for Eastman Kodak Company. He married in Rochester, Monroe Co., N.Y. [July 16, 1933] Marcia Burrus Lane [born in Buffalo, Erie Co., N.Y., July 7, 1912; attended Rollins College. During the family’s extensive overseas travel, she initiated Teen-Age Diplomat exchanges in France, Germany, Italy, and Turkey. She was president of the Association for Teen-Age Diplomats and the International Sister cities of Rochester. She died in Hendersonville, Henderson Co., N.C., July 11, 2007]. They resided in Fairport, Monroe Co., N.Y., and later Port St. Lucie, St. Lucie Co., Fla. He died Feb. 9, 1993).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22779. Peter Fairfax Payne (born Sept. 8, 1934; died Oct. 2, 1936).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22780. Marcia Bradfield Payne (born Oct. 10, 1938).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+22781. Duncan MacRae Payne.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22782. Robert Ridley Payne (born July 29, 1942). [J. McGILL, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Beverley")]), _vm._v(", 110; B. PAYNE, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Paynes")]), _vm._v(", 218; SSDI; obit. of Marcia L. Payne posted on "), _c('a', {
    attrs: {
      "href": "http://www.blueridgenow.com",
      "target": "_blank"
    }
  }, [_vm._v("www.blueridgenow.com")]), _vm._v("; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11244-x1141]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12256. James Harvey Payne, Jr. (born in Md., Jan. 3, 1913; married [Sept. 17, 1939] Winifred Faye Ralston [born in Buncombe Co., N.C., Jan. 15, 1921; died in Ashe Co., N.C., Aug. 30, 1998]. They resided in West Jefferson, Ashe Co., N.C., and he died in Ashe Co., N.C., Oct. 6, 1995).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22783. James Harvey Payne III (born in Buncombe Co., N.C., Jan. 12, 1941).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22784. Farinda Fairfax Payne (born April 1, 1943).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22785. Eleanor Prussia Payne (born June 17, 1944). [J. McGILL, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Beverley")]), _vm._v(", 111–112; B. PAYNE, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Paynes")]), _vm._v(", 202; NCarBI; NCarDI; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11244-x1142]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12258. Elizabeth Cary Stuart (born April 24, 1926; married [April 7, 1947] Stanley Duane Premer [born April 17, 1922; served in WW II in the 485"), _c('sup', [_vm._v("th")]), _vm._v(" Heavy Bombardment Group, USAF from the time it was activated in Sept. 1943. After training with B-24s, his Group was assigned to the 15"), _c('sup', [_vm._v("th")]), _vm._v(" Air Force in the Mediterranean Theater and stationed in Italy. Entering combat in May 1944, they flew against targets in Italy, France, Germany, Austria, Hungary, Romania, and Yugoslavia. The Group was transferred back to the U.S. in May 1945, and equipped with B-29s. Premer was honorably discharged on Nov. 21, 1945, and his decorations included the Air Medal with one Oak Leaf Cluster. He died April 1967]. They resided in Bettendorf, Scott Co., Iowa).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Child:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22786. Paul Stuart Premer (born Aug. 23, 1948). [J. McGILL, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Beverley")]), _vm._v(", 112; SSDI; "), _c('a', {
    attrs: {
      "href": "http://www.armyairforces.com",
      "target": "_blank"
    }
  }, [_vm._v("www.armyairforces.com")]), _vm._v("/dbgroups; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11244-x1341]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12259. Jane Fairfax Dudley (born in Wilmington, New Castle Co., Dela., Aug. 22, 1929; attended Madison College [now James Madison U.] for one year. She dropped out to take a job as a typist and file clerk for her uncle John Dudley, a lawyer in Middleburg, Va. She was soon dating and “almost engaged” to a Washington & Lee law student, John O. Marsh, Jr. [He later was elected to the House of Representatives and served as Secretary of the Army under Ronald Reagan from 1981 to 1989]. She broke off her relationship with Marsh, however, and she married in Middleburg, Va. [1"), _c('sup', [_vm._v("st")]), _vm._v(", on Sept. 24, 1949] William Alexander Eliason [born in Hagerstown, Washington Co., Md., March 21, 1925; graduated from VMI (B.S., Electrical Engineering, 1946) and Southeastern U. (M.B.A., 1979). At the time of their marriage, he had recently founded a Chevrolet and Oldsmobile dealership in Middleburg, Va. He was also serving on the vestry of Emanuel Episcopal Church.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("He worked in various executive roles for the Chrysler Corp. in Baltimore, Md., Dallas, Tex., Portland, Ore., Boston, Mass., and Detroit, Mich., 1955–1966. Concerned with the crime in Detroit at that time, he returned to Massachusetts to become Director of Marketing Services for the New England Division of Texas Instruments in 1966. He later was vice-president of marketing for Air Products and Chemicals, Inc., in Allentown, Pa. He finished his organizational career as Director of Operations for the non-profit CloseUp Foundation in Washington, D.C., and he generously contributed a biographical sketch. He was the grandson of Dr. Talcott Eliason, CSA, the chief surgeon of General J. E. B. Stuart’s Cavalry Corps. The famed “Fighting Surgeon” rode with Stuart in many battles, and had his horse killed under him early in the Dumfries Raid. General Fitz Lee once remarked that Dr. Eliason was “as conspicuous with his pistol making wounds as he was afterward with other instruments healing them.” His health finally broke under the strain after the Gettysburg campaign, and he was forced to resign in late July 1863].")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Soon after the birth of her son, Jane agreed to teach a ballroom dancing class at a local private school. To gain some more experience and observe teaching techniques, she took some lessons at an Arthur Murray school in Washington, D.C. A few months later she announced that she was leaving her husband and her child in order to pursue a career as an Arthur Murray Dance instructor. Soon afterward, she and a companion moved to Frankfurt am Main, Germany, and opened an Arthur Murray franchise. Jane and William were thus separated in 1954 and divorced in 1956. She later married [2"), _c('sup', [_vm._v("nd")]), _vm._v("] Michael Thorne, and she married [3"), _c('sup', [_vm._v("rd")]), _vm._v("] John Boyle. She died in Richmond, Va., Oct. 19, 1999. Her son, Charles, was raised by his stepmother Nancy Carol Eliason).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Child (by her 1"), _c('sup', [_vm._v("st")]), _vm._v(" husband):")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22787. Charles Henry Eliason (born in Washington, D.C., Va., Sept. 25, 1951; graduated from Penn State-Middletown. He married [1"), _c('sup', [_vm._v("st")]), _vm._v("] Debra ___, and he married [2"), _c('sup', [_vm._v("nd")]), _vm._v("] Jane ___ [died 2004]. They resided in San Francisco, Cal. His only child, a daughter by his first wife, died in infancy. He later resided in Lakeland, Polk Co., Fla.). [Quotations from a biographical sketch by William A. Eliason and R. J. TROUT, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("They Followed the Plume")]), _vm._v(", 100 (see also 99–102) See also: J. McGILL, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Beverley")]), _vm._v(", 113; "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Who’s Who F&I")]), _vm._v(", 1979–1980; USPRI; FGS by WAE; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11244-x5211]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12264. Peter Manning Wells (born in Cal., Aug. 31, 1930; served in the Navy. He married [1"), _c('sup', [_vm._v("st")]), _vm._v(", on June 8, 1954] Sigrid Ann Nordwall [born Nov. 15, 1930]. Later divorced in 1977, he married [2"), _c('sup', [_vm._v("nd")]), _vm._v("] Dorothy ___. Divorced again, he married [3"), _c('sup', [_vm._v("rd")]), _vm._v("] Jane ___, and they resided in Rowan Co., N.C., where he died Sept. 16, 1994).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22788. Darrell Manning Wells (born in San Diego Co., Cal., Nov. 13, 1955).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+22789. Peter Byron Wells. [J. McGILL, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Beverley")]), _vm._v(", 113; file of Peter Katz Wells from Nimitz Library, USNA, Annapolis; CalBI; NCarDI; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11244-x5231]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12271. Mildred Warner Washington (born in Mass., Nov. 17, 1915; attended private academies, the Lawrence School in Hewlett, Long Island, and the Mary C. Wheeler School in Providence, R.I. She was interested in wildlife, a fascination shared by her Latin teacher at the Lawrence School, Carl Buchheister. He suggested that she attend the newly established Audubon Camp for Adult Leaders at Hog Island, Maine. One of the leaders of the camp was the young but already well-known ornithologist, Roger Tory Peterson. Mildred was one of the first campers to arrive after the opening in June 1936. Just three months later, on Sept. 24, 1936, an announcement of her engagement to Peterson appeared in the society page of the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("New York Times")]), _vm._v(". In a very formal marriage [“top hat and tails” for the groom], she married at St. Philip’s Church in Wiscasset, Lincoln Co., Maine [Dec. 19, 1936] Roger Tory Peterson [born in Jamestown, Chautauqua Co., N.Y., Aug. 28, 1908].")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("An authorized biography of Roger T. Peterson later recorded:")]), _vm._v(" "), _c('div', {
    staticClass: "extract"
  }, [_c('p', {
    staticClass: "extractText"
  }, [_vm._v("Mildred was a very strong-willed and spirited girl, and she and Roger, although strongly attracted to each other physically, had emotional incompatibilities from the time they met. In fact there was some arguing at the wedding that made some members of the wedding party nervous for the future of the marriage. One guest wondered if they would—or should—go through with it.")]), _vm._v(" "), _c('p', {
    staticClass: "extractText"
  }, [_vm._v("Roger and Mildred spent their honeymoon at the Chateau Frontenac in Quebec. ‘It was hardly the place to do any birding,’ said Roger, ‘being the Christmas season. The only bird I recall seeing, and only one, was an Iceland gull on the open water of the St. Lawrence River near the city docks of Quebec.’")])]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Indeed, from a fairly early time their marriage was stressful and tempestuous. As Peterson’s biography later states,")]), _vm._v(" "), _c('div', {
    staticClass: "extract"
  }, [_c('p', {
    staticClass: "extractText"
  }, [_vm._v("Said Mildred, ‘Basically, we had little in common except birds … Roger did not love children. He wanted no young fry.’ Said Roger, ‘I did want children, but not until our marriage was emotionally stable.’")])]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Roger was busy with writing, painting, and lecturing. His reputation as an ornithologist soared with his prolific and magnificent books. Mildred volunteered, full-time, five days a week at St. Luke’s hospital, an outreach program to underprivileged families.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("To judge from Peterson’s authorized biography, the highlight of their marriage was a birding trip to the Singer Tract in Madison Parish of northern Louisiana. There in 1942 they arduously pursued and finally spotted the nearly extinct ivory-billed woodpecker. Roger was delighted; Mildred was ecstatic—the quest had been an obsession for her since childhood. Later that same year, “after one of their mutual ‘colossal’ tantrums,” Mildred and Roger separated; they were divorced in 1943.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Mildred went back to her volunteer work, and several years later she married [2"), _c('sup', [_vm._v("nd")]), _vm._v(", on Sept. 6, 1947] Herbert A. Busse, an electrical engineer. They had three children, but eventually this marriage, too, ended in divorce. Roger T. Peterson’s biography offers these parting glimpses of his first wife’s final years in Freeport, Maine:")]), _vm._v(" "), _c('div', {
    staticClass: "extract"
  }, [_c('p', {
    staticClass: "extractText"
  }, [_vm._v("Mildred lived in a weathered, shingled house, built on the foundation of an eighteenth-century house that had burned down many years before. There, in a room full of antiques and walls of books, Mildred welcomed her guests graciously among the fading upholstered furniture. The ashtrays were full of cigarette stubs, and on the table was an original copy of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("A Field Guide to the Birds")]), _vm._v(", worn from use… .")]), _vm._v(" "), _c('p', {
    staticClass: "extractText"
  }, [_vm._v("Mildred, who enjoyed boating, often sailed alone among the islands in the salty bays near her home in Maine. One midsummer day in July 1977 her boat was found capsized; it was empty. Later her body was recovered. Although she was a good swimmer, she had drowned.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("[Roger Tory Peterson went on to a career as certainly the greatest ornithologist of the twentieth century, and in some opinions has eclipsed Audubon as the greatest of all time. An unknown young author in the depths of the Depression, he was rejected by five publishers before Houghton Mifflin agreed to publish a cautious printing of 2,000 copies of his "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Field Guide to the Birds (Eastern North America")]), _vm._v(") in 1934. The printing sold out in two weeks, and by 1994 his two North American field guides to birds (East and West) had sold more than seven million copies. He was also the author or co-author of eighteen other books, and illustrated seven more. His numerous academic awards include at least 22 honorary doctorates (in Science, Humanities, Humane Letters, and Fine Arts) from such institutions as Ohio State U., Wesleyan, Amherst, and Yale. He received the Presidential Medal of Freedom, the nation’s highest civilian award, from President Jimmy Carter in 1980, and he was nominated for the Nobel Peace Prize in 1983. His hometown, Jamestown, N.Y., held a straw ballot in 1975 to select and honor its most distinguished native son or daughter. By a margin of one vote, the actress Lucille Ball came in second to Roger Tory Peterson. According to the noted Stanford U. ecologist Paul R. Ehrlich, \"In this [twentieth] century, no one has done more to promote an interest in living creatures than Roger Tory Peterson, the inventor of the modern field guide.\" He died at his home in Old Lyme, Conn., July 28, 1996]).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children (by her 2"), _c('sup', [_vm._v("nd")]), _vm._v(" husband):")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22790. Peter Washington Busse (born July 20, 1948; “killed by a hit and run driver, a day or two before Thanksgiving, Nov. 1964,” as his uncle, John W. Washington, informed J.A.W.).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22791. Anny Wendtlandt Busse (born 1950; married ___ Terry).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22792. Stephen Washington Busse (born 1957). [Quotations from J. DEVLIN-G. NAISMITH, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("World of R. T. Peterson")]), _vm._v(", 88, 95, 99, 100. See also: R. T. PETERSON-R. HOGLUND, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Roger T. Peterson")]), _vm._v(", esp. pp. 195–204; J. I. MERRITT, “Roger T. Peterson,” "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("passim")]), _vm._v("; "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ConAu")]), _vm._v(", new rev. series, 1:505–506; "), _c('a', {
    attrs: {
      "href": "http://www.answers.com",
      "target": "_blank"
    }
  }, [_vm._v("www.answers.com")]), _vm._v("/topic/roger_tory_peterson; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11244-a2111]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12274. John Whiting Washington (born in New York, N.Y., Feb. 7, 1925; married [1"), _c('sup', [_vm._v("st")]), _vm._v(", on Dec. 28, 1946] Joan Eliot [born Aug. 3, 1926; later resided in Lake Oswego, Clackamas Co., Ore.]. Later divorced, he married [2"), _c('sup', [_vm._v("nd")]), _vm._v(", on Oct. 30, 1965] Phyllis Idun [Aasgaard] Ogg [born Sept. 10, 1924; died Sept. 1990]. He resided in San Francisco, Cal., and Montclair, Essex Co., N.J. Later he resided in East Boothbay, Lincoln Co., Maine, where he operated a bed and breakfast. He died July 29, 2004).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Child (by his 1"), _c('sup', [_vm._v("st")]), _vm._v(" wife):")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22793. Christina Washington (born 1948; a freelance writer, she was unm. and attending a college in Oregon in 2004). [NSWFD #848 (John Whiting Washington); J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11244-a2114]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12276. Fairfax A. Jones (born in N.J., Jan. 27, 1896; a WW I veteran, he married Lillian M. [born in Pa., ca. 1895]. They resided in Linwood, Atlantic Co., N.J., 1930, where he was a switchboard operator. He last resided in Linwood, N.J., and he died Nov. 1969).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22794. Lillian M. Jones (born in N.J., ca. 1916).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22795. Fairfax C. Jones (born ibid., Nov. 5, 1921; a WW II veteran, he enlisted in Camden, N.J., Aug. 11, 1942. He died in Linwood, N.J., Jan. 7, 2005).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22796. Lee G. Jones (born in N.J., ca. Jan. 1926). [1930 census Atlantic Co., N.J., E.D. 55, p. 15B; SSDI; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11244-a3111]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12285. Alexandra L. Todd (born in Cal., 1923; married [1949] Frederick Chauncey Tanner, Jr. [born 1917]. They resided in San Francisco, Cal.).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22797. Alexandra Tanner (born in San Francisco, Cal., June 21, 1951).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22798. Fredericka Tanner (born ibid., Nov. 9, 1952). [1930 census Los Angeles Co., Cal., E.D. 1245, p. 3B; CalBI; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11244-a6331]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12293. Whitson Beazley Etheridge (born in Conroe, Montgomery Co., Tex., Nov. 1, 1917; graduated from the U. of Texas-Austin [B.A., Journalism, 1939]. After working as deputy tax collector of Montgomery Co., Tex., he was a “trouble shooter” for the Columbian Carbon Company from 1943 to 1958. Meanwhile he graduated from South Texas School of Law, Houston [LL.B., 1952], and he entered into a private legal practice in Conroe, Tex., in 1958. He served as president of the Montgomery Co. [Tex.] Bar Association. A prominent lay leader in the Baptist Church, he served as a deacon in his local church from 1946 to ca. 2003. He was also a member of the executive board of the Texas Baptist Convention [1962–1966] and a trustee of Houston Baptist U. [1984–1991]. He married in Austin, Travis Co., Tex. [1"), _c('sup', [_vm._v("st")]), _vm._v(", on June 27, 1939] Lillian Marie Mueller [born at “Three Oaks” near Floresville, Wilson Co., Tex., Dec. 29, 1919; graduated from the U. of Texas-Austin. She died in Houston, Tex., Nov. 21, 1995]. They resided in Conroe, Tex. As a widower he married in Montgomery Co., Tex. [2"), _c('sup', [_vm._v("nd")]), _vm._v(", on Dec. 1, 1996] Dorothy Anders [born ca. 1927]. He died Dec. 26, 2012).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+22799. Ann Marie Etheridge.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+22800. Mary Faye Etheridge.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+22801. Whitson Beazley Etheridge, Jr.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+22802. Jo Carol Etheridge. ["), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Who’s Who Am")]), _vm._v("., 2003; A. M. WASHINGTON, “Living Desc. of J. Washington,” 608; TexMI; obit. of Whitson B. Etheridge, Sr., posted on "), _c('a', {
    attrs: {
      "href": "http://obit.dignitymemorial.com",
      "target": "_blank"
    }
  }, [_vm._v("obit.dignitymemorial.com")]), _vm._v("; S. ETHERIDGE, “Etheridge,” 1–7; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11244-j1111]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12294. Kenneth Alexander Etheridge (born in Conroe, Montgomery Co., Tex., Dec. 16, 1919; graduated from the U. of Texas-Austin [B.S., Civil Engineering, 1947]. A civil engineer, he married in Austin, Travis Co., Tex. [July 9, 1941] Merle Marie Lawler [born May 11, 1916]. They settled in 1951 in Abilene, Taylor Co., Tex., where he was City Manager for two years before establishing his own engineering and surveying business. A licensed pilot, he was also an active lay leader at University Baptist Church in Abilene, serving as a deacon and Sunday School teacher. They moved in 1995 to Austin, Tex., where he died Feb. 28, 2005).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+22803. Merilyn Kae Etheridge.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+22804. Kenneth Mark Etheridge.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+22805. Laura Jan Etheridge.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+22806. Karen Gayle Etheridge. [A. M. WASHINGTON, “Living Desc. of J. Washington,” 608; obit. of Kenneth A. Etheridge in the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Abilene Reporter News")]), _vm._v(", 3/10/2005; SSDI; S. ETHERIDGE, “Etheridge,” 8–13; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11244-j1112]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12295. Obie Leonard Etheridge (born in Conroe, Montgomery Co., Tex., Nov. 12, 1924; graduated from the U. of Texas-Austin [B.S., Civil Engineering, 1951]. He married [Dec. 30, 1943] Gladys O’Neil Turner [born in San Augustine, San Augustine Co., Tex., June 1, 1925]. They resided in Austin, Travis Co., and later in Corpus Christi, Nueces Co., Tex. Prominent in the Masonic movement, he was named a Distinguished Brother of the Order of the Purple Cross of York with the rank of Associate Regent of the York Rite Sovereign College of North America, 1990).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+22807. Robert Neil Etheridge.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+22808. Barbara Evelyn Etheridge.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22809. Rebecca Gay Etheridge (born in Travis Co., Tex., March 12, 1952).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+22810. Dennis Lynn Etheridge. [TexBI; "), _c('a', {
    attrs: {
      "href": "http://www.albertpikedemolay.org",
      "target": "_blank"
    }
  }, [_vm._v("www.albertpikedemolay.org")]), _vm._v("; S. ETHERIDGE, “Etheridge,” 13–16; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11244-j1113]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12296. Sanford Grant Etheridge (born in Conroe, Montgomery Co., Tex., Aug. 23, 1927; graduated from U. Texas-Austin [B.A., Philosophy, 1948]. He studied French in Grenoble [1949], Classics at Saarbrücken [1950–1952], and both Classics and Sanskrit at Bonn [1952–1954]. He served several years in Army intelligence in Germany, and he then graduated from Harvard [Ph.D., Classics, 1961]. Beginning in 1961, he taught for many years in the Classics Department of Tulane University, advancing through the ranks to full professor. He published numerous articles in professional journals, and he was co-author of a book, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Scepticism, Man, and God: Selections from the Major Writings of Sextus Empiricus")]), _vm._v(" [1964; reissued, 1985].")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("A gifted linguist, he mastered French, German, Greek, Latin, Sanskrit, Irish, Russian, and several American Indian dialects. While studying in Germany, he met and married [April 25, 1953] Helga Maria Gisela Pfitzer [born in Saarbrücken, Germany, Aug. 7, 1929]. They resided in New Orleans, La. A fine amateur genealogist, he composed some excellent, lengthy family sketches which he communicated to J.A.W. and Prentiss Price ca. 1960 [see my bibliography]. In his retirement, he continued to pursue genealogical research, and he generously shared with me his extensive computerized files [nearly 100 pages] on the Beazley branch of the Washington family).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+22811. Julia Cornelia Etheridge.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22812. George Richard Etheridge (twin; born and died Aug. 21, 1961).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22813. Thomas Whitson Etheridge (twin; born and died Aug. 21, 1961).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+22814. Lucy Caroline Etheridge.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22815. Emily Charlotte Etheridge (born in New Orleans, La., 1965; married in Middletown, Jefferson Co., Ky. [Nov. 22, 1997] Michael David Christopher Fuzette [born in New Orleans, La., 1966]. They bred and showed champion pedigree dogs in Louisville, Jefferson Co., Ky.). [Tribute to S. G. Etheridge in the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Louisiana Classicist")]), _vm._v(", vol. 13, no. 2 [1994], p. 3, which erroneously gives his middle initial as “B”; "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Dir. Am. Schol")]), _vm._v("., 1982, 3:151; A. M. WASHINGTON, “Living Desc. of J. Washington,” 608; S. ETHERIDGE, “Etheridge,” 16–18; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11244-j1114]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12297. Florence Shirley Etheridge (born in Conroe, Montgomery Co., Tex., March 11, 1934; graduated from Baylor U. [B. Music, 1956]. She married in Conroe, Tex. [June 13, 1959] Edwin Pate Hughes [born in Shelby Co., Tex., April 25, 1929; worked for Shell Oil & Refinery]. They resided in Pasadena, Harris Co., Tex.).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+22816. Laura Dee Hughes.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+22817. Martha Florence Hughes.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22818. David Pate Hughes (born in Harris Co., Tex., Nov. 21, 1966). [TexBI; S. ETHERIDGE, “Etheridge,” 18–19; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11244-j1115]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12298. Betty Lynn Hunt (born in Conroe, Montgomery Co., Tex., April 19, 1928; graduated from the U. of Texas-Austin [B.F.A., 1947]. A librarian, she married [May 30, 1947] Richard Ludwick Anton Sterba [born in Chicago, June 6, 1923; graduated from the U. of Texas-Austin (B.A., Economics and Philosophy, 1947; M.A., Economics, 1950). A professor at the U. of Fla., he died in Houston, Tex., Aug. 16, 1985]. She resided in Houston, Tex., 1999).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22819. Wendy Ellen Sterba (born in Kansas City, Mo. or Kans., 1955; married [Oct. 1969] Donald Stafford Renshaw, Jr. [he was a librarian]).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22820. Sandra Leigh Sterba (born in Gainesville, Alachua Co., Fla., 1958; married in Travis Co., Tex. [May 29, 1983] Blair David Boatwright [born in Paris, France, 1959; graduated from Swarthmore College (B.A., Mathematics, 1980), U. of Texas-Austin (Ph.D., Mathematics, 1987) and Texas A&M U. (M.S., Statistics, 2006). Author of several articles in profession journals, he received the Presidential Excellence Awards at St. Edward’s U., Spring 1989. He was later associate professor of Mathematics and Interim Chair of Mathematics and Statistics at Texas A&M U.-Corpus Christi campus]).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+22821. Mindy Hunt Sterba. [TexMI; A. M. WASHINGTON, “Living Desc. of J. Washington,” 612; "), _c('a', {
    attrs: {
      "href": "http://http://math.tamucc.ed/faculty",
      "target": "_blank"
    }
  }, [_vm._v("http://math.tamucc.ed/faculty")]), _vm._v("; S. ETHERIDGE, “Hunt,” 1–3; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11244-j1121]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12299. Alice Christine Hunt (born in Conroe, Montgomery Co., Tex., Jan. 8, 1930; graduated from Sam Houston State Teachers College [B.S., 1951]. She married [April 15, 1956] Donald Beardsley Larson [graduated from Ill. Institute of Tech. (B.S., 1947); he was a mechanical engineer]. They resided in Irving, Dallas Co., Tex., and in Mountainburg, Crawford Co., Ark., 1999).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22822. Thomas Dolph Larson (born in Huntsville, Madison Co., Ala., 1965).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+22823. Kyle Emil Larson. [A. M. WASHINGTON, “Living Desc. of J. Washington,” 612; S. ETHERIDGE, “Hunt,” 3–4; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11244-j1122]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12301. Carolyn Joyce Tribe (born in Harris Co., Tex., Jan. 23, 1940; a nurse, she married [1"), _c('sup', [_vm._v("st")]), _vm._v(", on Nov. 29, 1958] Billy Ray Barrett. She married in Las Vegas, Clark Co., Nev. [2"), _c('sup', [_vm._v("nd")]), _vm._v(", in 1973] James DeWitt Crawford [died of a heart attack in Jan. 1978]. She married [3"), _c('sup', [_vm._v("rd")]), _vm._v(", in Nov. 1979] Anthony Henry, and they were divorced in 1982).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children (by her 1"), _c('sup', [_vm._v("st")]), _vm._v(" husband):")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+22824. Billy Ray Barrett, Jr.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+22825. Janet Darlene Barrett.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22826. Dan Louis Barrett (born Jan. 21, 1963; died Jan. 24, 1973).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22827. David Russell Barrett (born July 21, 1964; died Dec. 17, 1977).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22828. John Charles Barrett (born 1966).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Child (by her 2"), _c('sup', [_vm._v("nd")]), _vm._v(" husband):")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22829. Karan D’Anne Crawford (born 1974; married Michael Cowan, and they had child: Michael James Jarold Cowan). [TexBI; B. C. NOONAN, website “Desc. of Edward III”; S. ETHERIDGE, “Beazley File,” 14–17; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11244-j1831]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12302. Charles Russell Tribe (born in Harris Co., Tex., Sept. 28, 1941; married [1"), _c('sup', [_vm._v("st")]), _vm._v("] Donna K. Green, and they were divorced in Harris Co., Tex., March 30, 1973. He married [2"), _c('sup', [_vm._v("nd")]), _vm._v("] Carol Allbritton, and he married [3"), _c('sup', [_vm._v("rd")]), _vm._v("] Elizabeth Christine Ermel [born in Polk Co., Tex., Aug. 20, 1949]).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Child (by his 3"), _c('sup', [_vm._v("rd")]), _vm._v(" wife):")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22830. Charles Russell Tribe, Jr. (born in Harris Co., Tex., Jan. 15, 1977). [TexBI; TexDivI; B. C. NOONAN, website “Desc. of Edward III”; S. ETHERIDGE, “Beazley File,” 17–18; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11244-j1832]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12303. Gaye Lynn Tribe (born in Tarrant Co., Tex., Sept. 12, 1943; married [1"), _c('sup', [_vm._v("st")]), _vm._v(", on Feb. 5, 1964] Charles Ellis Price [he was an architect]. Later divorced in 1991, she married [2"), _c('sup', [_vm._v("nd")]), _vm._v(", on June 13, 1992] Ronald Dean Watley [born 1940]. They resided in Houston, Tex.).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children (by her 1"), _c('sup', [_vm._v("st")]), _vm._v(" husband):")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+22831. David Lee Price.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+22832. Darren Christopher Price.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22833. Devin Michael Price (born in Harris Co., Tex., Nov. 9, 1973). [TexBI; TexMI; B. C. NOONAN, website “Desc. of Edward III”; S. ETHERIDGE, “Beazley File,” 18–19; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11244-j1833]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12304. Gloria Ann Tribe (born in Polk Co., Tex., Nov. 3, 1949; a nurse, she married in Harris Co., Tex. [Jan. 3, 1967] Clifton Lee Allbritton [born in Harris Co., Tex., Jan. 17, 1948]. They resided in Hockley, Harris Co., Tex.).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+22834. Patty Ann Allbritton.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+22835. Tana Leigh Allbritton.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22836. Stuart Lee Allbritton (born in Harris Co., Tex., Jan. 21, 1974).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22837. Eric Wayne Allbritton (born in Montgomery Co., Tex., Oct. 21, 1984). [TexBI; TexMI; USPRI; B. C. NOONAN, website “Desc. of Edward III”; S. ETHERIDGE, “Beazley File,” 20–22; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11244-j1834]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12305. Jerry Don Tribe (born in Polk Co., Tex., July 5, 1951; married in Harris Co., Tex. [1"), _c('sup', [_vm._v("st")]), _vm._v(", on March 10, 1973] Janet Marie Laird. Later divorced, he married in Montgomery Co., Tex. [2"), _c('sup', [_vm._v("nd")]), _vm._v(", on June 23, 1984] Kathy Sue Miller. They resided in Conroe, Montgomery Co., Tex.).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children (by his 1"), _c('sup', [_vm._v("st")]), _vm._v(" wife):")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22838. Heather Renee Tribe (born in Harris Co., Tex., April 5, 1977).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22839. Jerry Colin Tribe (born ibid., March 2, 1979).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children (by his 2"), _c('sup', [_vm._v("nd")]), _vm._v(" wife):")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22840. Lauren Louise Tribe (born in Montgomery Co., Tex., Dec. 4, 1989).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22841. Jill Dana Tribe (twin; born in Conroe, Tex., Feb. 16, 1993).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22842. Kari Lenay Tribe (twin; born ibid., Feb. 16, 1993).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22843. Travis Brady Tribe (born ibid., Aug. 16, 1995). [TexBI; TexMI; B. C. NOONAN, website “Desc. of Edward III”; S. ETHERIDGE, “Beazley File,” 22–23; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11244-f1835]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12306. Shirley Jean Tribe (born in Polk Co., Tex., Sept. 26, 1953; married in Fort Bend Co., Tex. [1"), _c('sup', [_vm._v("st")]), _vm._v(", on Sept. 27, 1971] Thomas Gary Baker [born ca. 1952; later resided in Raleigh, Wake Co., N.C., 1995]. Later divorced in 1974, she married in Bexar Co., Tex. [2"), _c('sup', [_vm._v("nd")]), _vm._v(", on Jan. 17, 1976] William Mackley Hansard [born ca. 1953]. Again divorced ca. 1977, she resided in Houston, Tex., and she married [3"), _c('sup', [_vm._v("rd")]), _vm._v("] Harry Neal Dunham. She married [4"), _c('sup', [_vm._v("th")]), _vm._v("] James Dorsey Cloud [born 1960], and they resided in Houston, Tex.).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children (by her 1"), _c('sup', [_vm._v("st")]), _vm._v(" husband):")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+22844. Shawna Michelle Baker.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+22845. Misty Sarah Baker.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Child (by her 3"), _c('sup', [_vm._v("rd")]), _vm._v(" husband):")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22846. Kristopher Neal Tribe (born in Houston, April 10, 1979; apparently took his mother’s maiden name, or possibly “Baker”). [TexBI; TexMI; B. C. NOONAN, website “Desc. of Edward III”; S. ETHERIDGE, “Beazley File,” 23–24; USPRI; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11244-j1836]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12307. Doris Ann Tribe (born in Houston, Tex. Feb. 10, 1935; married in Highlands, Harris Co., Tex. [April 4, 1954] Charles Junior Payne [born in Harris Co., Tex., Sept. 16, 1929]. They resided in Texas City, Galveston Co., Tex.).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+22847. Kelli Ann Payne.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22848. Kristi Ann Payne (born in Galveston Co., Tex., Oct. 8, 1971). [TexBI; B. C. NOONAN, website “Desc. of Edward III”; S. ETHERIDGE, “Beazley File,” 25–26; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11244-j1841]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12308. Sylvia Jean Tribe (born in Baytown, Harris Co., Tex., Feb. 22, 1936; married in Highlands, Harris Co., Tex. [Nov. 5, 1953] Calvin Riley Jennings [born in Harris Co., Tex., Dec. 15, 1935]. They resided in Houston, Tex.).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22849. Calvin Riley Jennings, Jr. (born in Riverside Co., Cal., Jan. 25, 1956).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+22850. Sherry Lynn Jennings.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22851. Tami Faye Jennings (born in Houston, Tex., Jan. 25, 1961; married in Harris Co., Tex. [Oct. 16, 1999] David L. Doyle). [TexBI; TexMI; CalBI; S. ETHERIDGE, “Beazley File,” 26; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11244-j1842]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12309. Billie Dell Tribe (born in Harris Co., Tex., Nov. 10, 1937; married [June 14, 1957] Richard M. Wolfe, and they resided in Texas City, Galveston Co., Tex.).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22852. Richard Wayne Wolfe (born in Galveston Co., Tex., Jan. 27, 1960).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22853. Rex Hamilton Wolfe (born ibid., Aug. 16, 1964; married in Harris Co., Tex. [1"), _c('sup', [_vm._v("st")]), _vm._v(", on Feb. 22, 1992] Julie M. Hendren [born 1971]. Divorced in Galveston Co., Tex., Oct. 6, 1997, he married in Galveston Co., Tex. [2"), _c('sup', [_vm._v("nd")]), _vm._v(", on Jan. 15, 2000] Tara M. Cox. They were divorced June 17, 2002).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22854. Randall Eugene Wolfe (born in Galveston Co., Tex., March 9, 1971, and he resided in League City, Galveston Co., Tex.). [TexBI; TexMI; TexDivI; B. C. NOONAN, website “Desc. of Edward III”; S. ETHERIDGE, “Beazley File,” 26–27; USPRI; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11244-j1843]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12310. Albert Hamilton Tribe, Jr. (born Jan. 19, 1946; married in Galveston Co., Tex. [June 2, 1973] Linda Jean Williams. They resided in Longview, Gregg Co., Tex.).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22855. James Slade Tribe (born in Galveston Co., Tex., Sept. 15, 1970).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22856. Shane Tribe (born in Lubbock Co., Tex., Jan. 25, 1975). [TexBI; TexMI; TexDI; USPRI; S. ETHERIDGE, “Etheridge File,” 27; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11244-j1844]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12311. Michael Hamilton Tribe (born in Houston, Tex., Sept. 9, 1943; attended Baylor U. A USMC veteran and a real estate agent, he married in Harris Co., Tex. [March 20, 1976] Martha R. Russell [born ca. 1953]. They resided in Houston, Tex., and he died Dec. 26, 1991).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22857. Holly Marrs Tribe.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22858. Michael Honda Tribe (born in Harris Co., Tex., Aug. 27, 1982). [TexBI; TexMI; B. C. NOONAN, website “Desc. of Edward III”; S. ETHERIDGE, “Beazley File,” 27–28; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11244-j1851]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12312. Julianne Tribe (born in Houston, Tex., Nov. 22, 1946; married ibid. [March 24, 1967] Bobby Ray Dunn).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Child:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+22859. Angela Rae Dunn. [TexBI; TexMI; S. ETHERIDGE, “Beazley File,” 28–29; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11244-j1852]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12314. Thomas Ephram Barron (born in Polk Co., Tex., Jan. 15, 1954; married in Harris Co., Tex. [Jan. 4, 1975] Patricia Ann Turner [born ca. 1956]. They were divorced Feb. 2, 1987, and he resided in Houston, Tex.).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22860. Thomas Alexander Barron (born in Harris Co., Tex., May 5, 1979).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22861. Kristie Lynn Barron (twin; born ibid., July 28, 1982).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22862. Mistie Ann Barron (twin; born ibid., July 28, 1982). [TexBI; TexMI; TexDivI; USPRI; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11244-j1c12]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12315. John Harvey Modesett, Jr. (born in Nueces Co., Tex., Dec. 4, 1936; married [Dec. 30, 1961] Marcia Marie Heine [born July 3, 1941; graduated from Bennett College, presumably that in Greensboro, N.C., 1961]. They resided in Houston, Tex.).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+22863. John Harvey Modesett III.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+22864. David Andrew Modesett.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+22865. Laura Anne Modesett. [TexBI; USPRI; S. ETHERIDGE, “Beazley File,” 34–35]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12316. Nan Vallera Modesett (born in Houston, Tex., Feb. 18, 1939; married [1"), _c('sup', [_vm._v("st")]), _vm._v(", on May 9, 1956] Fred Forrest Morgan, Jr. [born in Corpus Christi, Nueces Co., Tex., Aug. 22, 1936; graduated from Rice U., 1958]. She married in Nueces Co., Tex. [2"), _c('sup', [_vm._v("nd")]), _vm._v(", on Nov. 7, 1969] John Jones Garrett, and she resided in Houston, Tex.).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children (by her 1"), _c('sup', [_vm._v("st")]), _vm._v(" husband):")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22866. Elizabeth Jane Morgan (born in Houston, Tex., Jan. 11, 1957).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22867. Kelly Nan Morgan (born in Corpus Christi, Tex., Aug. 20, 1959).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children (by her 2"), _c('sup', [_vm._v("nd")]), _vm._v(" husband):")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22868. Nan Modesett Garrett (born in Harris Co., Tex., Dec. 24, 1970).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22869. John Jones Garrett, Jr. (born ibid., Oct. 21, 1972). [TexBI; S. ETHERIDGE, “Beazley File,” 35; B. C. NOONAN, website “Desc. of Edward III”]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12319. Emily June Davison (born in Nacogdoches, Nacogdoches Co., Tex., Jan. 15, 1916; married Glevis Woodrow Cleveland [born Aug. 25, 1916; M.D. and a physician, he died Nov. 9, 1972]. They resided in Austin, Travis Co., Tex., and she died Sept. 3, 1980).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+22870. Virginia Ann Cleveland.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+22871. John Patrick Cleveland.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22872. Judith Lynn Cleveland (born in Travis Co., Tex., Oct. 10, 1945; married [Dec. 31, 1966] Wilbur Leroy Smith [born April 3, 1923]).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+22873. Cynthia Cleveland. [A. M. WASHINGTON, “Living Desc. of J. Washington,” 607; S. ETHERIDGE, “Beazley File,” 45–46, which gives Dr. Cleveland’s first name as “Blevis”; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11244-j6141, rev.]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12320. Thomas Seale Davison (born in Nacogdoches, Nacogdoches Co., Tex., March 28, 1920; graduated from the U. of Texas-Austin [B.A., Journalism, 1941]. During WW II, he served in the Army as a field correspondent for "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Yank")]), _vm._v(" Magazine. His assignments took him to Iceland, England, North Africa, Iran, and the Soviet Union. He had six campaign ribbons when he was discharged in 1945. A sports writer for the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Houston Post")]), _vm._v(" for fifteen years, he later moved back to Nacogdoches and went into the savings and loan business with his father. NSWFD member #845, he married [May 28, 1950] Flora Enid Yeager [born in Lexington, Lee Co., Tex. Oct. 14, 1925; died 2005]. They later resided in Austin, Travis Co., Tex., where he died Nov. 25, 2010).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Child:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+22874. Anne Elliece Davison. [A. M. WASHINGTON, “Living Desc. of J. Washington,” 607; obit. of Thomas S. Davison in the Austin "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("American Statesman")]), _vm._v(", 11/28/2010; NSWFD #845 (Thomas S. Davison); S. ETHERIDGE, “Beazley File,” 46; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11244-j6142, rev.]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12321. Robert Wade Davison (born in Galveston, Galveston Co., Tex., Oct. 11, 1919; a WW II veteran, he enlisted in Houston, Tex., March 14, 1941. He married [July 18, 1942] Vera Catherine Porter [born Jan. 18, 1925]. He died Oct. 3, 2002, and he was buried at Arkansas State Veterans Cemetery).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+22875. Susan Davison.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+22876. Pamela Davison. [A. M. WASHINGTON, “Living Desc. of J. Washington,” 607; WW II AER; U.S. Veterans Cemeteries; S. ETHERIDGE, “Beazley File,” 47–48; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11244-j6151, rev.]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12322. Jean Lee Davison (born in Galveston, Galveston Co., Tex., Aug. 31, 1921; married [Feb. 27, 1943] M. Val Wynn [born Dec. 28, 1920]. They resided in Houston, Tex.).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22877. Gary Joe Wynn (born in Houston, Tex., Oct. 15, 1947; married [May 18, 1985] Jennifer Ford [born Feb. 3, 1962]).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22878. Nancy Wynn (born ibid., April 12, 1949).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22879. Melissa Gay Wynn (born ibid., Jan. 9, 1961; married [Aug. 24, 1984] Gregory Dean Baldwin [born Sept. 13, 1960]). [A. M. WASHINGTON, “Living Desc. of J. Washington,” 607; S. ETHERIDGE, “Beazley File,” 48–49; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11244-j6152, rev.]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12323. Lucy Fairfax Leake (born in Cleveland, Oh., March 6, 1922; graduated from Case Institute [B.S.], U. of Houston [B.S., cum laude, 1959] and Kent State U. [M.A., 1962]. While still in her teens, she moved to New York City and landed roles as a chorus girl in “Best Foot Forward” and other Broadway shows. After the U.S. entry into WW II, “she worked with entertainers like Bob Hope, Ingrid Bergman and Red Skelton on the USO circuit in Europe.” In the 1960s, she moved to Elizabeth City, Pasquotank Co., N.C., where she taught speech and drama at the College of the Albemarle, directing four productions per year for more than 20 years. Shortly before her death she wrote and directed “USO Camp Show,” a musical revue based on her experiences during the war. She married in Fort Wayne, Allen Co., Ind. [1"), _c('sup', [_vm._v("st")]), _vm._v(", on April 14, 1953] John Thomas Vaughan [born in Hudson, Summit Co., Oh., Sept. 25, 1915]. She married [2"), _c('sup', [_vm._v("nd")]), _vm._v("] C. Donald Hays, and she died in Elizabeth City, N.C., Jan. 28, 1996).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Child (by her 1"), _c('sup', [_vm._v("st")]), _vm._v(" husband):")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+22880. John Thomas Vaughan. [Quotation from undated obit. clipping from (Elizabeth City, N.C.) "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Daily Advance")]), _vm._v(", quoted in S. ETHERIDGE, “Beazley File,” 49–51. See also: A. M. WASHINGTON, “Living Desc. of J. Washington,” 614; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11244-j6161, rev.]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12324. Robert Edward Leake (born in Canton, Stark Co., Oh., Sept. 3, 1926; married in Dallas, Tex. [March 15, 1949] Virginia Louise Sluss [born in Butler Co., Kans., July 4, 1921; died Jan. 10, 2005]. They resided in Dallas, Houston, and Austin, Travis Co., Tex., and he died Sept. 16, 1985. He was buried at Hillcrest Cemetery in Temple, Bell Co., Tex.).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+22881. Robert Edward Leake, Jr.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+22882. Allison Gail Leake. [A. M. WASHINGTON, “Living Desc. of J. Washington,” 614; "), _c('a', {
    attrs: {
      "href": "http://www.findagrave.com",
      "target": "_blank"
    }
  }, [_vm._v("www.findagrave.com")]), _vm._v("; S. ETHERIDGE, “Beazley File,” 51; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11244-j6162, rev.]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12325. Lucille Warner Davison (born in Galveston, Galveston Co., Tex., March 6, 1920; attended Texas State College for Women in Denton. An artist, she married [June 27, 1942] William Thomas Anderson [born Oct. 14, 1919; he was a supervisor for Monsanto Chemical Company]. They resided in Tampa, Hillsborough Co., Fla., and Texas City, Galveston Co., Tex.).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22883. Billie Jean Sorrells Anderson (born in Denton, Denton Co., Tex., March 30, 1943; married [March 9, 1963] Richard Lee Duble [born in Galveston Co., Tex., May 31, 1940; graduated from Texas A&M (B.S., 1962; M.S., 1965; Ph.D., Plant and Soil Science, 1967). He taught at Texas A&M U. as assistant professor (1970–1973), associate professor (1973–1974), and professor (1975-ca. 2005) of Agronomy]. They were divorced in Smith Co., Tex., April 7, 1969).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+22884. William Thomas Anderson.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22885. Michael John Anderson (born in Galveston Co., Tex., Nov. 1, 1958; married ___).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22886. David Wayne Anderson (born ibid., Aug. 30, 1961). ["), _c('em', {
    staticClass: "italic"
  }, [_vm._v("AmM&WSci")]), _vm._v(", 2005, 2:833; TexBI; TexDivI; S. ETHERIDGE, “Beazley File,” 52–53; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11244-j6181, rev.]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12326. Barbara Fairfax Lawes (born in Friendswood, Galveston Co., Tex., May 19, 1931; graduated from Southern Methodist U. [B.A., Biology, 1951]. She was an active genealogist and member of NSWFD [#836], contributing family information to both JAW and the author. For many years she served faithfully as the editor of the NSWFD’s annual publication, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Washington Words")]), _vm._v(". She married in Galveston, Galveston Co., Tex. [1"), _c('sup', [_vm._v("st")]), _vm._v(", on Aug. 31, 1951] Arthur Frank Click, Jr. [born in St. Louis, Mo., March 31, 1927; enlisted in the Navy, March 1945. He served on the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("LST 122")]), _vm._v(" in China from late 1945 to early May 1946, bringing relief supplies up the Yangtze River. During this humanitarian mission, his ship came under fire from Chinese Communist guerillas. He graduated from Lamar U. (B.S., Geology, 1953) and worked for Sun Oil until 1953. He was later regional manager for Perkin-Elmer Corp. in their Houston office, 1957 to 1973. He died in Houston, Tex., June 30, 1989].")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("She married [2"), _c('sup', [_vm._v("nd")]), _vm._v(", on Oct. 2, 1993] Carl Jefferson Hopper [born in Garza Co., Tex., Aug. 22, 1920; graduated from Texas A&M (B.S., Civil Engineering, 1941). He served as Capt., USA, 1321"), _c('sup', [_vm._v("st")]), _vm._v(" Engineers, in the European Theater in WW II, and his decorations included Bronze Star. He was transferred to the Pacific for the anticipated invasion of Japan and had reached Okinawa when the war ended. He was later production petroleum engineer for Humble Oil, which later became Exxon, 1946–1978. He died March 7, 2012]. They resided in Houston, Tex.).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children (by her 1"), _c('sup', [_vm._v("st")]), _vm._v(" husband):")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22887. Laura Ellen Click (born in Galveston Co., Tex., Sept. 4, 1952; married [May 21, 1988] Charles Anthony Corridan [of Co. Kerry, Ireland]. They were later divorced).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22888. Barbara Anne Click (born in Galveston Co., Tex., Jan. 11, 1954; NSWFD member #998, she married in Harris Co., Tex. [1"), _c('sup', [_vm._v("st")]), _vm._v(", on May 2, 1992] Jeffrey J. Brashier. Later divorced, she married in Harris Co., Tex. [2"), _c('sup', [_vm._v("nd")]), _vm._v(", on Dec. 5, 1998] Mark Asher Schusterman [born Jan. 10, 1955; graduated from Emory U. (B.S.) and U. of Louisville (M.D.). Professor of Surgical Oncology at M. D. Anderson Hospital in Houston, Tex., he was later clinical professor of Plastic Surgery at Baylor College of Medicine in Houston, Tex. Author of more than 160 scientific articles and book chapters, he has been visiting professor at the Catholic U. in Rome, Italy, the Cleveland Clinic Foundation, Duke U. and Memorial Sloan-Kettering Cancer Center in New York City. His book "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Microsurgical Reconstruction of the Cancer Patient")]), _vm._v(" was published by Lippincott-Raven in 1997]. They resided in Bellaire, Tex., and they were later divorced. Barbara served as Chaplain and 2"), _c('sup', [_vm._v("nd")]), _vm._v(" Vice-President of the NSWFD).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22889. Arthur Frank Click III (born in Galveston Co., Tex., Dec. 2, 1955). [NAVY DEPT. (James L. MOODY et al., eds.), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Dicty. of American Naval Fighting Ships")]), _vm._v(", 7:587; S. ETHERIDGE, “Beazley File,” 54–55; "), _c('a', {
    attrs: {
      "href": "http://http://www.implantinfo.com",
      "target": "_blank"
    }
  }, [_vm._v("http://www.implantinfo.com")]), _vm._v("/plastic_surugeons; U.S. WW II Navy Muster Rolls; FGS by BFLH; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11244-j6191, rev.]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12327. William Mitchell Lawes (born in Galveston Co., Tex., Nov. 7, 1938; graduated from Southern Methodist U. [Kappa Alpha]. He married in Galveston, Galveston Co., Tex. [June 24, 1963] Elyshia Pratorius [born 1943]. He died in Galveston, Tex., April 28, 1967).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Child:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+22890. Leigh Anne Lawes. [TexBI; "), _c('a', {
    attrs: {
      "href": "http://FamSearch.org",
      "target": "_blank"
    }
  }, [_vm._v("FamSearch.org")]), _vm._v("/Tex. Deaths; S. ETHERIDGE, “Beazley File,” 54; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11244-j6192, rev.]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12328. Joy Joyce (born in Tillman Co., Okla., June 24, 1927; graduated from Rice [Phi Beta Kappa, 1946] and Columbia [M.A., 1948]. She married [April 30, 1949] Norman Goree Kittrell III [born in Houston, Tex., Aug. 27, 1925; his father served one term in the Texas state legislature, 1919–1920]).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+22891. Norman Goree Kittrell IV.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+22892. Katherine Frances Kittrell.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+22893. Susan Ann Kittrell. [TexBI; S. ETHERIDGE, “Beazley File,” 55–56; "), _c('a', {
    attrs: {
      "href": "http://www.texastribune.org/library/data",
      "target": "_blank"
    }
  }, [_vm._v("www.texastribune.org/library/data")]), _vm._v("; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11244-j61x1, rev.]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12329. John Hill Wilshusen (born in Galveston, Galveston Co., Tex., Sept. 24, 1927; graduated from Texas A&M [B.S., Petroleum Engineering]. He married in Houston, Tex. [Aug. 14, 1948] Jo Anne Donaldson [born in Little Rock, Pulaski Co., Ark., June 27, 1927; she was a registered medical technologist at Rice U. and St. Joseph’s Hospital, Houston, Tex.]. NSWFD member #889, he served for many years as treasurer of the NSWFD. They resided in Corpus Christi, Nueces Co., Tex.).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+22894. John Douglas Wilshusen.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+22895. Michael Scott Wilshusen.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+22896. Brian Gregory Wilshusen. [SSDI; S. ETHERIDGE, “Beazley File,” 56–57; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11244-j61a1, rev.]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12330. George Herbert Wilshusen (born in Travis Co., Tex., Jan. 1, 1931; married [Aug. 27, 1948] Joan Elizabeth Hughes [born in Harris Co., Tex., May 9, 1931; graduated from the U. of Houston (B.A., Education)]. They resided in Houston, Tex.).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+22897. David Craig Wilshusen.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+22898. Mark Steven Wilshusen.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+22899. Richard West Wilshusen. [TexBI; S. ETHERIDGE, “Beazley File,” 57; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11244-j61a2, rev.]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12331. William Paul Wilshusen (born in Harris Co., Tex., Feb. 14, 1934; married [1"), _c('sup', [_vm._v("st")]), _vm._v("] Margaret Rao. He married [2"), _c('sup', [_vm._v("nd")]), _vm._v(", on June 8, 1962] Mabel Dorothy Hammond [born ibid., Feb. 6, 1936]. They resided ibid.).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Child (by his 1"), _c('sup', [_vm._v("st")]), _vm._v(" wife):")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+22900. Leslie Alice Wilshusen.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children (by his 2"), _c('sup', [_vm._v("nd")]), _vm._v(" wife):")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22901. Jeffrey Paul Wilshusen (born in Harris Co., Tex., May 19, 1967).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+22902. Elizabeth Kay Wilshusen. [TexBI; S. ETHERIDGE, “Beazley File,” 58, who gives William’s first wife’s surname as “Roo”; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11244-j61a3, rev.]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12332. Janet Davison (born in Nacogdoches, Nacogdoches Co., Tex., Sept. 17, 1930; graduated from the U. of Texas-Austin [B.A., 1951]. An active genealogist and NSWFD member #730, she served ably as the Society’s president [1998–2000] and Parliamentarian [2000–2008]. She was also member #16914 of the Daughters of the Republic of Texas. She married in Durant, Bryan Co., Okla. [1"), _c('sup', [_vm._v("st")]), _vm._v(", June 17, 1950] Dr. Tom Edwin Miller [born in Savoy, Fannin Co., Tex., April 12, 1929; graduated from Austin College (B.A., 1949) and U. of Texas (M.D., 1954). He died Dec. 21, 1988]. Later divorced in 1965, she married [2"), _c('sup', [_vm._v("nd")]), _vm._v("] L. Max Fry, and they resided in Lufkin, Angelina Co., Tex.).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+22903. Laura May Miller.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+22904. Linda Miller.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22905. James Wesley Miller (born in Galveston Co., Tex., Dec. 23, 1958; married in Travis Co., Tex. [April 5, 1991] Elizabeth Harte Bruns [born in Harris Co., Tex., Nov. 25, 1959]).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+22906. Elizabeth Ann Miller. [DAUGHTERS OF THE REPUBLIC OF TEXAS, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Founders and Patriots, Book VI")]), _vm._v(", 142; TexBI; S. ETHERIDGE, “Beazley File,” 59; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11244-f61b1, rev.]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12335. Diane Frances Webster (born 1943; married in Houston, Tex. [June 11, 1966] Wynne Louis Creekmore, Jr. [born in Harris Co., Tex., Dec. 20, 1940]. They were divorced in Harris Co., Tex., Dec. 1, 2000).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22907. Cynthia Jeanne Creekmore (born 1971).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22908. Sarah Warner Creekmore (twin; born in Harris Co., Tex., July 1, 1974).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22909. Suzanne Howard Creekmore (twin; born ibid., July 1, 1974). [TexBI; TexDivI; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11244-j61c2]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12337. William Charles Sheehan (born in Ventura, Ventura Co., Cal., March 10, 1923; graduated from Rice U. [B.S., Mechanical Engineering, 1944]. He married in St. Patrick’s Cathedral, New York, N.Y. [Aug. 23, 1946] Claire Dorothy Ennis [born in New York, N.Y., Feb. 21, 1927]. He died in Denver, Colo., July 3, 1982).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22910. Brooks John Sheehan (born 1947).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+22911. Mark William Sheehan.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22912. James Scott Sheehan (born in Staten Island, N.Y., 1950).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22913. Randall Russell Sheehan (born ibid., 1952).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22914. Thomas Sheehan (born in Nassau Co., Long Island, N.Y.).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22915. David Sheehan (born ibid., 1960). [S. ETHERIDGE, “Beazley File,” 40–41; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11244-j6213, who calls William Charles Sheehan “William "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Lewis")]), _vm._v(" Sheehan”]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12339. Phyllis Holley Foster (born in Hollywood, Los Angeles Co., Cal., Dec. 13, 1923 or 1924; married in Pomona, Los Angeles Co., Cal. [Nov. 11, 1943] Stafford E. Stearns [born in Spur, Dickens Co., Tex., Aug. 26, 1918; during WW II he served in the Army Ordnance truck section, stationed part of that time in England. After the war they moved to Texas, where he farmed and raised cattle. In 1953 they returned to California, where he later worked at Freightliner. After retiring in 1981, he resided in Dallas, Tex., and finally McMinnville, Yamhill Co., Ore, where he died Aug. 5, 2006]).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22916. Carol Anne Stearns (born in Pomona, Los Angeles Co., Cal., July 11, 1944; married ___ Dodge, and they resided in McMinnville, Ore.).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22917. William Michael Stearns (born in Los Angeles Co., Cal., April 15, 1948; resided in Houston, Tex.).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22918. Virginia Kay Stearns (born in Lubbock, Lubbock Co., Tex., Aug. 12, 1949; married ___ Parks, and they resided in Newberg, ___).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22919. Jeffrey Bruce Stearns (born in Pomona, Cal., June 10, 1957). [CalBI; obit. of Stafford Stearns in the McMinnville (Ore.) "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("News-Register")]), _vm._v(", 8/9/2006; OreDI; SSDI; S. ETHERIDGE, “Beazley File,” 42–43; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11244-j6233]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12350. James Seddon Allen, Jr. (born in Shelby Co., Tenn., Nov. 22, 1919; during WW II he was a pilot and flight instructor. While stationed in Texas, he met a young lady from Houston, whom he courted ardently. On one date, which was interrupted by a fierce hurricane, they sought shelter under a dining room table, where he proposed. She accepted, and he thus married Hester Botts Stewart. He graduated from the U. of Va., and he was a lawyer in Memphis, Tenn. He died Feb. 11, 2006).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+22920. Cornelia Cargill Allen.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+22921. James Seddon Allen III.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22922. John Stewart Allen (born in Harris Co., Tex., July 19, 1950; married Caroline Hand Burwell [raised in Jackson, Hinds Co., Miss.]. He was a computer specialist, and they resided in Sarasota, Sarasota Co., Fla.). [TexBI; FGS by CGAS]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12351. Newton Perkins Allen (born in Memphis, Tenn., Jan. 3, 1922; graduated from Princeton [A.B., 1943] and U. of Va. [J.D., 1948]. A prominent member of the Memphis bar for many years, he also contributed a number of articles to professional journals. He served on the executive board of his local council of the Boys Scouts of America [1961–1969] and was vice-chairman of the board of the LeBonheur Children’s Hospital. A prominent civic leader in many fields, he has served as president of the board of trustees of St. Mary’s Episcopal School [1966–1967], chairman of the Greater Memphis Council on Crime and Delinquency [1976–1980], and president of the Memphis Orchestra Society [1979–1981]. He married [Oct. 4, 1947] Malinda Lobdell Nobles [died Nov. 1986]. He resided in Memphis, Tenn., and he died March 9, 2008).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22923. John Lobdell Allen.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22924. Malinda Nobles Allen.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+22925. Newton Perkins Allen, Jr. ["), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Who’s Who Am")]), _vm._v("., 2002; SSDI]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12354. Katharine Allen Aiken (born in Memphis, Tenn., Feb. 26, 1918; married in Pass Christian, Harrison Co., Miss. [Aug. 19, 1941] George Pilkington Phillips, Jr. [born Feb. 28, 1918; died April 23, 1983]. They resided in Memphis, Tenn., and for many years Katherine served as Headmistress of St. Mary’s Girl’s School).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+22926. Katharine Allen Phillips.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+22927. Jean Aiken Phillips. [FGS by WA; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11245–21x31]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12355. Warwick Aiken, Jr. (born in Memphis, Tenn., May 8, 1920; graduated from Dallas Theological Seminary. An Episcopal priest, he married in Picayune, Pearl River Co., Miss. [Sept. 7, 1946] Marianne Sewell [born in New Orleans, La., April 14, 1926]. They resided in Eden, Rockingham Co., N.C., 2006).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+22928. Warwick Aiken III.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+22929. Everall Aiken. [FGS by WA; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11245–21x32]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12375. Louise Funsten Kinsey (born in Rappahannock Co., Va., Oct. 1889; married [ca. 1909] Robert Warwick Miller [born in Va., ca. 1879]. They farmed in Hawthorne, Rappahannock Co., Va., 1930).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22930. Robert E. Miller (born in Va., ca. 1910).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22931. George K. Miller (born ibid., ca. 1915).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22932. John R. Miller (born ibid., ca. July 1929). [H. RANDOLPH, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Funsten-Meade")]), _vm._v(", 7; 1930 census Rappahannock Co., Va., E.D. 3, p. 5A; "), _c('a', {
    attrs: {
      "href": "http://Anc.com",
      "target": "_blank"
    }
  }, [_vm._v("Anc.com")]), _vm._v("/AWT, entry by AJB; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11247–41111]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12377. Wade Hampton Massie, Jr. (born in Rappahannock Co., Va., Sept. 10, 1898; a farmer, he married Ada May Miller [born in Va., June 1, 1899; last resided in Washington, Rappahannock Co., Va., and she died July 1974]. They resided in Hampton, Rappahannock Co., Va., 1930, and at one time later resided in Fla. They had four children).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children (partial list):")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22933. Jaculine (sic) M. Massie (born in Va., ca. 1926).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22934. Wade Hampton Massie III (born ibid., ca. March 1930; married Grace Wallihan. He was chairman of the board of the Rappahannock National bank in Washington, Va., and he also raised cattle and thoroughbred horses. They had four children:")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("[1]. Wade Hampton Massie IV (resided in Bristol, Va.).")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("[2]. Michael Miller Massie (born 1955; owner of Hampton Stock Farm in Washington, Va., he married in Nantucket, Mass. [July 12, 1986] Antonia du Pont Bredin [born 1955; graduated from Sweet Briar College]).")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("[3]. Mary Brooke Massie (born June 9, 1958; graduated from the U. of Va. [B.A., Government, magna cum laude; J.D., 1983, editor of the law school’s tax journal]. She resided in Bristol, Va., and she died July 19, 2004).")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("[4]. Nancy Hampton Massie (attended Vanderbilt U., and in Aug. 2000 she was engaged to marry Justin Hugh Wiley. They later resided in Orange, Va.). [H. RANDOLPH, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Funsten-Meade")]), _vm._v(", 7; WW I Draft Reg.; 1930 census Rappahannock Co., Va., E.D. 2, p. 10A; Bredin-Massie wedding announcement in the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("New York Times")]), _vm._v(", 7/13/1986; obit. of Mary Brooke Massie in the Bristol (Va.) "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Herald Courier")]), _vm._v(", 7/23/2004; USPRI; SSDI; "), _c('a', {
    attrs: {
      "href": "http://Anc.com",
      "target": "_blank"
    }
  }, [_vm._v("Anc.com")]), _vm._v("/AWT, entry by AJB; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline,")]), _vm._v(" 11247–41121]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12388. Edward Barrington Lee (born in White Post, Clarke Co., Va., March 9, 1912; married in Frederick Co., Md. [July 21, 1931] Page Chapman Orr [born in Leesburg, Loudoun Co., Va., May 24, 1914; died March 8, 1997]. He died Jan. 26, 1986).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+22935. Edward Barrington Lee, Jr.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+22936. John Clayton Lee.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+22937. Eleanor Page Lee.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+22938. Louise Brockenbrough Lee. [T. MARKHAM, website “Desc. John C. Lee”; "), _c('a', {
    attrs: {
      "href": "http://Anc.com",
      "target": "_blank"
    }
  }, [_vm._v("Anc.com")]), _vm._v("/AWT; FGS by EPLG; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11247–4332, rev.]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12391. William Meade Fletcher, Jr. (born in Chicago, Ill., March 29, 1897; a member of SAR, he served as served as Ensign, USN in WW I, and he graduated from Princeton [A.B., 1919] and U. of Pa. Law School [LL.B., 1922]. A lawyer in Washington, D.C., he married [1"), _c('sup', [_vm._v("st")]), _vm._v("] Jane Gordon Coxe. Later divorced, he married in King Co., Wash. [2"), _c('sup', [_vm._v("nd")]), _vm._v(", on Jan. 12, 1935] Augusta Ware Trimble ["), _c('em', {
    staticClass: "italic"
  }, [_vm._v("d.s.p.")]), _vm._v(" 1947]. He married [3"), _c('sup', [_vm._v("rd")]), _vm._v(", ca. 1949] Mary J. [Nelson] Legg Walker).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children (by his 1"), _c('sup', [_vm._v("st")]), _vm._v(" wife):")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22939. Jane Gordon Fletcher (born ca. 1930; married [ca. 1961] John F. Higgins [graduated from Lehigh, 1953]. They resided in Pa.).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22940. Ann Lea Fletcher (born ca. 1931; married Alfred P. C. Prime, and they had two children: Joan Prime and Mark C. Prime).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+22941. Joan C. Fletcher. ["), _c('a', {
    attrs: {
      "href": "http://Anc.com",
      "target": "_blank"
    }
  }, [_vm._v("Anc.com")]), _vm._v("/Cook Co., Ill. Birth Certificates; WashMI; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11247–44111, rev.]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12392. Anne Buckner Fletcher (born Aug. 24, 1915; married [Sept. 14, 1935] Francis Percival Smith II, and they resided in Madison, Va.).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22942. Anne Meade Smith (born Oct. 25, 1936; resided in Va.).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22943. Frances Fletcher Smith (born July 22, 1940; resided in Fort Smith, Sebastian Co., Ark.). [J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11247–44112]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12393. James William Fletcher (born in Sperryville, Rappahannock Co., Va., Oct. 19, 1918; graduated from the U. of Richmond [undergraduate degree, 1937; LL.B., 1940]. A lawyer, he was chairman of the Rappahannock County Democratic Committee [1940s-1970] and chairman of the 7"), _c('sup', [_vm._v("th")]), _vm._v(" Congressional District Democratic Committee [ca. 1940 to ca. 1971]. He was also a member of the Virginia Commission for the Study of Public Education [ca. 1950 to ca. 1970] and a member of the board of visitors of the Virginia School for the Deaf and Blind [1963–1970], as well as chairman of the Virginia State Board of Elections [1964–1971]. He married [Oct. 21, 1939] his 7"), _c('sup', [_vm._v("th")]), _vm._v(" cousin, Mildred Miller Thornton [born April 15, 1919; #15617, she last resided in Sperryville, Va., and she died Sept. 23, 1985]. They resided at “Thornton Hill” in Sperryville, Va., and he died March 10, 1998).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22944. Mildred Buckner Fletcher (born 1945; married George N. Slater, and they resided in Upperville, Loudoun Co., Va.).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22945. Catherine Meade Fletcher (born 1946; married Trowbridge Littleton, and they resided in Coles Point, Westmoreland Co., Va.).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22946. Louise Miller Fletcher (born 1948; married Edward D. Taylor II, and they resided in Charlottesville, Va.).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22947. James William Fletcher, Jr. (born 1952; resided in Sperryville, Va.).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22948. Martha Stuart Thornton Fletcher (born 1954; married ___ Trope, and she resided in Richmond, Va.). [M. HITE, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Rappahannock")]), _vm._v(", 119–120; "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Who’s Who Am. Politics")]), _vm._v(", 1971–72; SSDI; "), _c('a', {
    attrs: {
      "href": "http://www.findagrave.com",
      "target": "_blank"
    }
  }, [_vm._v("www.findagrave.com")]), _vm._v(" (with obit. of James William Fletcher, Sr., from the Richmond "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Times-Dispatch")]), _vm._v(", 3/14/1998); J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11247–44113 and 11515–32132 (Mildred Miller Thornton)]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12402. Montrose Pallen McArdle, Jr. (born in Mo., Jan. 23, 1894; married Carol Coggeshall [born ibid., ca. 1898]. They resided in Center Township, St. Louis Co., Mo., in 1930, where he worked as a contractor).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22949. Montrose Pallen McArdle III (born in Mo., April 9, 1916; last resided in Santa Rosa Beach, Walton Co., Fla., and he died Oct. 4, 1989).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22950. John Coggeshall McArdle (born in Mo., Aug. 13, 1917). [H. RANDOLPH, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Funsten-Meade")]), _vm._v(", 16; 1930 census St. Louis Co., Mo., E.D. 69, p. 1B; SSDI; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11247–45121]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12407. William Everard Reed (born in Mo., Sept. 28, 1921; graduated from Princeton, 1943. During WW II he served as a combat officer in a B-29 squadron and was wounded in action. In 1945 he began work as a salesman for the Reed Rubber Company that had been founded by his father in St. Louis, Mo. He eventually served as president of the firm and retired in 1994. He married [1"), _c('sup', [_vm._v("st")]), _vm._v("] Nancy Weber [died 1988], and he later married [2"), _c('sup', [_vm._v("nd")]), _vm._v("] Nancy Forsyth. Owner and pilot of his own airplane, he died in St. Louis, Mo., May 24, 1996).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children (by his 1"), _c('sup', [_vm._v("st")]), _vm._v(" wife):")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22951. William Reed (married [1"), _c('sup', [_vm._v("st")]), _vm._v("] Bev Boyer [she was the daughter of Ernest Boyer, the Secretary of Education under President Jimmy Carter]. They had three children: Leah Reed, Adria Reed, and Benjamin Reed. William later lived in Japan for several decades, and he married [2"), _c('sup', [_vm._v("nd")]), _vm._v("] Kumi ___, and they had one daughter: Natsuki Reed. Following Kumi’s death, William married [3"), _c('sup', [_vm._v("rd")]), _vm._v("] Kyoko ___).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22952. Morgan Weber Reed (married Marie-Aimee Boulme, and they were later divorced. They had one son: Tristan Fairfax Reed).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22953. Clark Addington Reed (married Anne Lobban, who was born and raised in South Africa. They resided in St. Louis, Mo., and they had two children: Alexandra Reed and Oliver Reed).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22954. Nancy Gardner Reed (graduated from Princeton. Beginning ca. 1995, she worked as an educator and consultant both nationally and internationally. For two years she lived in Japan and worked with a wide range of clients, including executives and managers. A serious student of drama, she dubbed eight full-length Japanese films into English for Japan Airlines. In 2012 she was a Certified Professional Life Coach and Energy Leadership Index Master Practitioner.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("She married Ian Stuart Twiss [graduated from Princeton (1994) and the U. of Mich. (M.F.A., Creative Writing, 1997). He later discerned a call to the ministry and he graduated from Seabury Western Theological Seminary (M.Div.). He was ordained as an Episcopal priest in 2007, and in 2012 he served a congregation that was half-Episcopal and half-Lutheran in Saline, Washtenaw Co., Mich.]. They resided in Ann Arbor, Washtenaw Co., Mich., and they had three children: Adrian Birch Reed Twiss, Miranda Cayce Reed Twiss, and Devon Meddaugh Reed Twiss). [N. A. REED, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Family Papers")]), _vm._v(", 612; H. RANDOLPH, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Funsten-Meade")]), _vm._v(", 13, 17; obit. of William Everard Reed in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Princeton Alumni Weekly")]), _vm._v(", 9/11/1996; 1930 census St. Louis Co., Mo., E.D. 243, pp. 15A-B; SSDI; "), _c('a', {
    attrs: {
      "href": "http://RootsWeb.com",
      "target": "_blank"
    }
  }, [_vm._v("RootsWeb.com")]), _vm._v("/WCP, entry by AJB; "), _c('a', {
    attrs: {
      "href": "http://www.coachesconsole.com",
      "target": "_blank"
    }
  }, [_vm._v("www.coachesconsole.com")]), _vm._v("; FGS by NRT; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11247–45161]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("11409. Nelson Addington Reed (born in St. Louis, Mo., April 6, 1926; served in the infantry, USA, European Theater, 1944–1945, and he was wounded in the Allied attack on the Siegfried line along the German frontier. His decorations included the Bronze Star and Purple Heart with cluster. He graduated from Washington U. [B.F.A., 1950]. He was secretary, later vice-president, and finally [beginning 1985] president of the company founded by his father, the Reed Rubber Company in St. Louis, Mo. He was also a research associate at Washington U., beginning 1965, receiving the Page One Civic award from the St. Louis Newspaper Guild, 1966.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("He participated extensively in archaeological expeditions throughout Central America, including exploration of the Ix Can River and underwater archaeology in Lake Peten, Guatemala, and he was the author of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Caste War of Yucatan")]), _vm._v(" [Stanford U. Press, 1964]. He was also contributor to Melvin L. Fowler [ed.], "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Explorations into Cahokia Archaeology")]), _vm._v(" [Illinois Archeological Survey, 1969]. He married [Aug. 11, 1952] Juliette Octavie Deconinck [born 1926; she was a teacher]. They resided in St. Louis, Mo., and in 1990 he published an excellent history of his ancestors, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Family Papers")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Child:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22955. Nelson Fairfax Reed (born 1962). ["), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ConAu")]), _vm._v(", vol. 9R; H. RANDOLPH, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Funsten-Meade")]), _vm._v(", 13, 17; "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Who’s Who in Midwest")]), _vm._v(", 1992–93; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11247–45163]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12412. William Page Dame, Jr. (born in Baltimore, Md., March 4, 1907; a member of SAR, he graduated from the U. of Va. [B.A. and LL.B., 1932]. He was a lawyer on the staff of the U.S. Fidelity and Guaranty Company in Baltimore, Md., and he served in WW II as Lt., USNR. He married in Ruxton, Baltimore Co., Md. [Oct. 19, 1934] Harriet “Hally” Carrington Brent [born in Ruxton, Md., Aug. 30, 1913; attended the Greenwood School and a private school in Florence, Italy. She served on the board of trustees of the Pickersgill Home in Baltimore, Md. (the historic home of Mary Young Pickersgill, who made the famous Star-Spangled Banner that flew over Fort McHenry). She was also chair of the Maryland House & Garden Pilgrimage and a trustee of the Anna Emory Warfield Fund and the Mount Clare Historic Site. An avid student of history and genealogy, she was a frequent lecturer for the Maryland Historical Society and a member of the Society of the Ark and the Dove. She died Aug. 11, 2006. She was the granddaughter of acting Brig. General Joseph Lancaster Brent, CSA, famous for his daring attack that captured the Union ironclad "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Indianola")]), _vm._v("]. They resided in Ruxton, Md., and he died in 1987).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+22956. Harriett Carrington Dame.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+22957. William Page Dame III. ["), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Enc. of Am. Biog., ")]), _vm._v("N.S"), _c('em', {
    staticClass: "italic"
  }, [_vm._v(".")]), _vm._v(", 320; "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Burke’s Am. Fam")]), _vm._v("., 2647; J. McGILL, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Beverley")]), _vm._v(", 491; B. ALLARDICE, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("More Generals in Gray")]), _vm._v(", 42–44; obits. of Harriet C. B. Dame in the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Baltimore Sun")]), _vm._v(", 8/17/2006 and the North Hatley Club newsletter ("), _c('a', {
    attrs: {
      "href": "http://http://www.nhclub.org/2007NHC/passages.htm",
      "target": "_blank"
    }
  }, [_vm._v("http://www.nhclub.org/2007NHC/passages.htm")]), _vm._v("); J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11247–45222]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12413. Josephine Putney Dame (born in Baltimore, Md., Dec. 26, 1910; on Christmas, 1920, the eve of her tenth birthday, she received a copy of the newly published book "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("From the Rapidan to Richmond")]), _vm._v(". It was written by her grandfather, the Rev. William Meade Dame, who had served in his teens in the Richmond Howitzers, CSA. The book was inscribed:")]), _vm._v(" "), _c('div', {
    staticClass: "extract"
  }, [_c('p', {
    staticClass: "extractNoIndent"
  }, [_vm._v("My dear Josephine,")]), _vm._v(" "), _c('p', {
    staticClass: "extractText"
  }, [_vm._v("In the days to come—when you can understand it better than now—it may be that you will read this book again.")]), _vm._v(" "), _c('p', {
    staticClass: "extractText"
  }, [_vm._v("Besides other things, I hope that you will gather from it this assurance—that in the great conflict which made such stern call upon the manhood of our race—your Grandfather was in his right place, doing his duty as becomes a Virginian, fighting to defend Virginia.")]), _vm._v(" "), _c('p', {
    staticClass: "extractText"
  }, [_vm._v("I should love to feel that my granddaughter will always be sure of that.")]), _vm._v(" "), _c('p', {
    staticClass: "paraCenter"
  }, [_vm._v("Your loving Grandfather")]), _vm._v(" "), _c('p', {
    staticClass: "paraCenter"
  }, [_vm._v("William Meade Dame")])]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("She graduated from St. Catherine’s School in Richmond, Va., where she was the student body president. A member of CDA, she was also president of the Town Garden Club of Bolton Hill. She married in Bolton Hill, Baltimore, Md. [Nov. 23, 1935] Daniel Dulany DeButts [born in Delaplane, Fauquier Co., Va., March 14, 1906; worked in the railway supply business, and he died Sept. 30, 1968. He was buried at Ivy Hill Cemetery in Upperville, Fauquier Co., Va.]. They resided in Baltimore, Md., and she died at the age of 101 on May 27, 2012).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22958. Josephine Dame DeButts (born March 1, 1940; resided in Baltimore, Md.).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22959. Ann Ashby DeButts (born Sept. 26, 1943; married [1"), _c('sup', [_vm._v("st")]), _vm._v("] Thomas H. DeLashmutt, and they were later divorced. She married [2"), _c('sup', [_vm._v("nd")]), _vm._v("] ___ Thompson, and she resided in Rogers Forge, Baltimore Co., Md.).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+22960. Susan M. DeButts. [Quotation from W. M. DAME, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Rapidan")]), _vm._v(", rev. ed. (1987), xxv. See also: J. McGILL, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Beverley")]), _vm._v(", 491; F. PYNE, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Desc. of the Signers, Va.")]), _vm._v(", 688; L. F. REESE, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Ashby Book")]), _vm._v(", "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Thomas Ashby")]), _vm._v(", 938; "), _c('a', {
    attrs: {
      "href": "http://www.findagrave.com",
      "target": "_blank"
    }
  }, [_vm._v("www.findagrave.com")]), _vm._v("; obit. of Josephine P. D. DeButts in the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Baltimore Sun")]), _vm._v(", 6/13/2012; SSDI; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11247–45223]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12414. Elizabeth Lee Dame (born in Baltimore, Md., Dec. 6, 1913; married [March 11, 1939] Samuel Stevens Sands, Jr. [born Oct. 19, 1911; graduated from Harvard, 1934. He died near Easton, Talbot Co., Md., July 1976]. They resided in Baltimore, Md., and they owned a farm near Easton, Md.).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22961. Elizabeth Lee Sands (born in Baltimore, Md., May 2, 1942).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22962. Samuel Stevens Sands III (born ibid., March 30, 1944; married Rosa H. L. Beckwith, and they had two children: Samuel Stevens Sands IV and William Page Sands). [J. McGILL, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Beverley")]), _vm._v(", 491; F. PYNE, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Desc. of the Signers, Va.")]), _vm._v(", 688; SSDI; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11247–45224]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12418. Robert Emmett Funsten III (born in St. Louis, Mo., Sept. 15, 1905; married ibid. [ca. 1936] his 1"), _c('sup', [_vm._v("st")]), _vm._v(" cousin, Virginia Lee Funsten [born Oct. 6, 1912; #12421, she died in San Antonio, Tex., 1996]. He died in San Antonio, Tex., Oct. 1966).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22963. Virginia Lee Funsten (born in St. Louis, Mo., 1938; died in La Jolla, San Diego Co., Cal., 2001).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22964. Susan Fitzhugh Funsten (married Ray Hull, and they had two children: Carolyn Barr Hull and Donna Hull). ["), _c('a', {
    attrs: {
      "href": "http://Anc.com",
      "target": "_blank"
    }
  }, [_vm._v("Anc.com")]), _vm._v("/Tex. Death Certificates; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11247–45421 and 11247–45432 (Virginia Lee Funsten)]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12429. Florence I. Funsten (born in San Francisco Co., Cal., Jan. 19, 1921; married Joseph Valentine Costello [born ibid., May 24, 1926]).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22965. Joseph Valentine Costello, Jr. (born in San Francisco Co., Cal., Jan. 12, 1952).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22966. Patricia W. Costello (born ibid., May 11, 1957). [CalBI; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11247–45711]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12431. Kenneth Reed Funsten (born in San Francisco, Cal., Feb. 3, 1923; married [Aug. 8, 1945] Margon McGuire. He last resided in Healdsburg, Sonoma Co., Cal., and he died Nov. 2, 2007).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22967. Kenneth Reed Funsten, Jr. (born in San Francisco, Cal., June 12, 1946; died ibid., Jan. 4, 1996).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22968. Susan Meade Funsten (born ibid., July 16, 1948).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22969. Peter Little Funsten (born ibid., May 20, 1951). [H. RANDOLPH, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Funsten-Meade")]), _vm._v(", 20; "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Who Was Who Am.")]), _vm._v(", vol. 5; CalBI; CalDI; SSDI; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11247–45721]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12432. Reed Little Funsten (born in San Francisco, Cal., July 24, 1926; enlisted in the Air Force on July 28, 1944. He married [1953] Margaret Cranston).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22970. Leslie Reed Funsten (daughter; born in San Francisco, Cal., June 30, 1954).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22971. Bryan Funsten (born ibid., Aug. 30, 1955). [CalBI; WW II AER; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11247–45722]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12434. Betty Flye (born in Cal., March 15, 1921; married Charles Lohse, and they resided in Alameda Co., Cal. She last resided in Orinda, Contra Costa Co., Cal., and she died March 16, 1992).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22972. Betty Glover Lohse (born in Alameda Co., Cal., March 2, 1948).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22973. Sarah Louise Lohse (born ibid., April 18, 1951).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22974. Deborah Howard Lohse (born ibid., Sept. 29, 1953). [CalBI; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11247–45731]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12440. Jane Meade Noyes (born July 14, 1925; “adopted by her half great-aunt Harriet H. [Meade] Brown,” she married [July 23, 1955] Richard Lee Baker [born in Guilford Co., N.C., July 4, 1927; he was “on his way to Okinawa, 1958.” He died in Greensboro, Guilford Co., N.C., May 25, 2002]).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22975. Richard Noyes Baker (born March 16, 1956).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22976. Thomas Meade Fox Baker (born Oct. 7, 1957).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22977. Jackie Baker (born 1959).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22978. Ginny Baker (born 1962). [NCarDI; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11247–46332]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12443. Walter Nelson Munster (born in San Pedro, Los Angeles Co., Cal., Sept. 21, 1916; graduated from the U. of Mich. [B.S., Chemistry, 1937] and U. of Cal.-Berkeley [M.S.]. A doctoral candidate in Nuclear Engineering at the U. of Va., “he was called to work for the national synthetic rubber program to assist the country in obtaining needed rubber for military uses after Japan had cut off the rubber supply.” After the war he joined the Atomic Energy Commission, and he assisted Finland and Australia to develop nuclear energy programs. In 1964 he became one of the first directors of the American Society of Cybernetics.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("He spent a long and active retirement on his Glen Bolton Farm in The Plains, Fauquier Co., Va. From 1977 to 2001, he represented Scott Magisterial District on the Fauquier County [Va.] Planning Commission, serving as president of the Commission for six years. He married [1"), _c('sup', [_vm._v("st")]), _vm._v(", in 1947] Charlotte Robertson. Later divorced, he married [2"), _c('sup', [_vm._v("nd")]), _vm._v(", in 1997] Mary Taylor. He died on his Glen Bolton Farm, April 3, 2008).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children (by his 1"), _c('sup', [_vm._v("st")]), _vm._v(" wife):")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22979. Charlotte N. Munster (married Thomas Steven Landvoigt, and they had two children: Timothy Landvoigt and Noel Landvoigt).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22980. Catherine D. Munster (married Christopher Stilling).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22981. Walter Nelson Munster, Jr. (born 1955; married Colleen Gavin, and they had two children: Drayton Munster and Cameron Carr Munster). [Quotation from Fauquier County Board of Supervisors, “A Proclamation Honoring the Life of Walter Nelson Munster,” posted on "), _c('a', {
    attrs: {
      "href": "http://www.fauquiercounty.gov",
      "target": "_blank"
    }
  }, [_vm._v("www.fauquiercounty.gov")]), _vm._v(". See also: S. E. BROWN-L. MYERS, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Pocahontas’ Descendants")]), _vm._v(", Third Corrections and Additions, 5; CalBI; obit. of Walter N. Munster in the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Fauquier Times")]), _vm._v(", ca. April 5, 2008; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11247–46351]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12446. Sarah Jane Washburn Bauer (born 1938; married Wayne Douglas Kryszak [born in Canton, Stark Co., Oh., Nov. 9, 1936; graduated from Kent State U. (B.S., Business Administration, 1958; M.L.S., 1965). He worked in the Washington, D.C. Public Library, initially as a reader’s advisor [1961–1968] and later as the chief of the Business Division. He was the author of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Small Business Index")]), _vm._v(" (1978) and a contributor to the book "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Not of One Mind")]), _vm._v(" (1976), as well as a volunteer fire fighter with the Cottage City Fire Company]. They resided in Mitchellville, Prince George’s Co., Md.).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22982. Peter John Kryszak (born 1961).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22983. Douglas Michael Kryszak (born 1963). [L. ASH et al., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Who’s Who in Library Service")]), _vm._v(", 384; J. M. LEE, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Who’s Who Library")]), _vm._v(", 273; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11247–463x1]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12447. Jacob Willard Bauer (born March 29, 1941; married [1"), _c('sup', [_vm._v("st")]), _vm._v("] Phyllis Novy. They had no children and were later divorced. He worked for the Firestone Tire and Rubber Company, and he was transferred in 1973 to São Paulo, Brazil. There he married [2"), _c('sup', [_vm._v("nd")]), _vm._v("] Brigitha Smart [born in Heiloo, Holland; she moved as a child to Brazil with her family]. They were also divorced).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Child (by his 2"), _c('sup', [_vm._v("nd")]), _vm._v(" wife):")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22984. Natasha Fairfax Bauer (born 1979; resided in Melbourne, Australia). [FGS by JWB; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11247–463x]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12448. Henry DeGrotte Kerfoot, Jr. (born 1934; married Angela Luxford [born 1936], and they resided in Winchester, Va.).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22985. Margaret Meade Kerfoot (born 1960).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22986. Kristen Anne Kerfoot (born 1961).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22987. Henry DeGrotte Kerfoot III (born 1963). [J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11247–463b1]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12449. Sarah Elizabeth Kerfoot (born 1938; married [1"), _c('sup', [_vm._v("st")]), _vm._v("] Tom Sullivan, and she married [2"), _c('sup', [_vm._v("nd")]), _vm._v("] Philip Kirkpatrick).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children (by her 1"), _c('sup', [_vm._v("st")]), _vm._v(" husband):")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22988. Tom Sullivan (born 1955; married Leslie Peoples).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22989. Linda Lee Sullivan. [J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11247–463b2]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12461. Margaret E. Kruger (born in Breckinridge Co., Ky., Oct. 24, 1929; married ___ Voyles, and she last resided in Hawesville, Hancock Co., Ky. She died Nov. 10, 2005).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+22990. Juanita K. Voyles.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+22991. Joseph L. Voyles. [KyBI; SSDI; B. C. NOONAN, website “Desc. of Edward III”]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12463. Alberta L. Kruger (born in Breckinridge Co., Ky., Oct. 15, 1935; married ___ Kaiser).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+22992. Judith A. Kaiser.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22993. Deborah Faye Kaiser (born in Jefferson Co., Ky., April 5, 1963; married ibid. [June 6, 1987] Carl L. Ash [born ca. 1960]). [KyBI; KyMI; B. C. NOONAN, website “Desc. of Edward III”]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12477. Joseph C. Carroll (born in Jefferson Co., Ky., Aug. 29, 1950; married ibid. [1"), _c('sup', [_vm._v("st")]), _vm._v(", on Sept. 1, 1973] Nancy K. Hodgkins [born ca. 1950]. Later divorced, he married ibid. [2"), _c('sup', [_vm._v("nd")]), _vm._v(", on April 22, 1977] Betty A. Tomlin [born ca. 1946]).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Child (by his 1"), _c('sup', [_vm._v("st")]), _vm._v(" wife):")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22994. Adrienne Leigh Carroll (born in Jefferson Co., Ky., July 6, 1974). [Ibid.]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12478. Paul L. Carroll (born in Jefferson Co., Ky., Oct. 2, 1953; married ibid. [Dec. 20, 1973] Carol D. Harman [born ca. 1954]).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Child:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22995. Matthew Paul Carroll (born in Jefferson Co., Ky., Sept. 15, 1980). [Ibid.]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12481. Katherine Frazier Mathes (married Mark Lafayette Hurt [died in Nashville, Tenn., Aug. 12, 1956]).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22996. Thomas William Hurt (said to have died at birth).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22997. Allen Lafayette Hurt.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22998. John Warren Hurt (born in Madison, Davidson Co., Tenn., Sept. 2 and died Sept. 4, 1938).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("22999. Katherine Marcia Hurt (married John William Anderson, and they had one child: Marcus William Anderson). ["), _c('a', {
    attrs: {
      "href": "http://Anc.com",
      "target": "_blank"
    }
  }, [_vm._v("Anc.com")]), _vm._v("/OWT; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 1124a-32111]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12484. Harold Fairfax Buck, Jr. (born in Olympia, Thurston Co., Wash., July 18, 1925; a WW II veteran, he resided in Washington, San Joaquin Co., Cal., when he enlisted in Sacramento, Cal., on Nov. 16, 1943. He married [1"), _c('sup', [_vm._v("st")]), _vm._v("] Beverly Lorene Keebaugh [born in Poynette, Columbia Co., Wisc., Sept. 12, 1927]. He married [2"), _c('sup', [_vm._v("nd")]), _vm._v("] Clara Mozelle Collins Russell [born in Bath, Knott Co., Ky., Jan. 10, 1935]. He later resided in Yacolt, Clark Co., Wash., and he generously contributed information on his family).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children (by his 1"), _c('sup', [_vm._v("st")]), _vm._v(" wife):")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23000. Larry Randall Buck (born in Stockton, San Joaquin Co., Cal., Aug. 17, 1954; married Gladys Murphy).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23001. Howard Jonathan Buck (born in Spokane, Spokane Co., Wash., Feb. 4, 1960). [CalBI; WW II AER; FGS by HFB; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 1124a-63112]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12485. Donald Karlin Buck (born in San Diego, Cal., July 16, 1932; married Virginia Clair Duncan [born March 10, 1933; died in Stockton, San Joaquin Co., Cal., July 31, 1996]).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23002. Laura Kathleen Buck.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23003. Karen Elaine Buck.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23004. Kathleen Lorraine Buck.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23005. Robert James Buck. [CalBI; CalDI; FGS by HFB; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 1124a-63113]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12492. Eugene Edmund Sherburne (born in Houston, Tex., Sept. 25, 1943; served in the USAF, 1960–1963, and he was attached to 11"), _c('sup', [_vm._v("th")]), _vm._v(" Bomb Wing, 2"), _c('sup', [_vm._v("nd")]), _vm._v(" Air Force during Cuban missile crisis. He also served in Vietnam in 1964, and his decorations included the Presidential Unit Citation with Oak Leaf Cluster. As Gene wrote me in 2001, “My trip to Vietnam was short although not sweet. I wouldn’t take a million for the experience or pay a dime to do it again. I went there TDY (temporary duty). I was involved in Operation 32 … I was with a group that worked out of a Savoy base (Special Forces) near An Loc dropping supplies to troops crossing the border into Laos. As you know, at that time troops were not allowed the chase the enemy into Laos or Cambodia. Everything was fine for awhile until Time-Life photographers took pictures of our planes. The Air Force denied it for a long time before ever admitting the truth. I guess you could say I was one of the guys that wasn’t there. It was a joint operation with all branches of the military involved. The planes we used belonged to Air America [CIA].”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("He married [1"), _c('sup', [_vm._v("st")]), _vm._v(", in 1961] Pauline Cannon [born 1943; died 2000]. He married [2"), _c('sup', [_vm._v("nd")]), _vm._v(", in 1967] Leslie Frances [Roach] Wadsworth [born in Houston, Tex. Dec. 17, 1936; she had three children by a prior marriage]. He resided in Flippin, Marion Co., Ark., and he generously supplied several generations of his family record).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children (by his 1"), _c('sup', [_vm._v("st")]), _vm._v(" wife):")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23006. Regina Lynne Sherburne.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23007. Paula Christine Sherburne.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Child (by his 2"), _c('sup', [_vm._v("nd")]), _vm._v(" wife):")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23008. Eric Eugene Sherburne. [Quotation and FGS from EES]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12493. Stewart Minor Woodward (born in Gordonsville, Orange Co., Va., July 14, 1870; married [April 25, 1900] Zoe [or Josephine] Goldsborough Trail [born Nov. 5, 1871; died March 8, 1935]. He died May 19, 1941).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23009. Stewart Minor Woodward, Jr.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23010. Amelia Poe Woodward (born April 6, 1908; married [May 6, 1933] Maurice Davier [born Jan. 4, 1906; died Jan. 1964]).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23011. Louise Trail Woodward. [J. McGILL, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Beverley")]), _vm._v(", 25; M. SORLEY, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Lewis")]), _vm._v(", 133; SSDI; "), _c('a', {
    attrs: {
      "href": "http://www.rinokids/Genealogy",
      "target": "_blank"
    }
  }, [_vm._v("www.rinokids/Genealogy")]), _vm._v("; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11251–11211]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12494. Edmund Lee Woodward (born in Richmond, Va., Jan. 29, 1873; graduated from the U. of Va. [B.A. and M.A., 1896; M.D., 1897] and Polyclinic Post-Graduate School in Philadelphia, Pa. [1899]. After obtaining his medical training, he worked as a medical missionary in China (1899–1914), and he was the founder and director of St. James Hospital in Anking. After returning to the U.S., he graduated from Theological Seminary of Va. [B.D., 1910]. He then married in Richmond, Va. [June 22, 1910] Frances Peyton Gibson. Returning to China as an Episcopal priest, he became the first dean of Cathedral of Our Saviour in Anking [1910–1914]. He then returned permanently to the U.S., where he became rector of Grace Church in The Plains, Va. [1914–1921]. During this period, he also served as dean of the Piedmont convocation of the Diocese of Virginia [1916–1917, 1920–1921] and dean of the Richmond convocation [1922–1923]. Among many other duties, he also served as dean of the Valley convocation [1935–1937], editor-in-chief of the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Virginia Churchman")]), _vm._v(", and dean and trustee of Church Schools in the Diocese of Virginia.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The Rev. Dr. and Mrs. Woodward maintained a summer home in Orkney Springs, Va., where they founded in 1925 the Cathedral Shrine of the Transfiguration, and where he served as rector from 1925 to 1941. Under their loving guidance, this Shrine evolved into the diocesan retreat and conference center Shrine Mont, from which “he could send people back into the world rested, refreshed, and inspired to do greater things for Christ and the Church.” His publications included "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Mid-China Syllabary")]), _vm._v(". They resided at Shrine Mont, Orkney Springs, Va., and he died Feb. 2, 1948).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children (both adopted):")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23012. David Stewart Woodward (born July 4, 1914; last resided in Berlin, Worcester Co., Md., and he died Oct. 9, 1987).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23013. John Minor Woodward (born Dec. 25, 1916). [Quotation from "), _c('a', {
    attrs: {
      "href": "http://www.saintgeorgeschurch.org",
      "target": "_blank"
    }
  }, [_vm._v("www.saintgeorgeschurch.org")]), _vm._v(". See also: J. McGILL, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Beverley")]), _vm._v(", 26; M. SORLEY, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Lewis")]), _vm._v(", 133; "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Who Was Who Am.")]), _vm._v(", vol. 2; "), _c('a', {
    attrs: {
      "href": "http://FamSearch.org",
      "target": "_blank"
    }
  }, [_vm._v("FamSearch.org")]), _vm._v("/Va. Marriages; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11251–11212]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12495. Mary Stuart Woodward (born in Richmond, Va., June 9, 1876; in the winter of 1895, while she was skating backwards on a frozen pond in Richmond, a young man rushed up and bumped her so hard that she fell down. He apologetically pointed out that she was just a few feet away from a break in the ice that would have plunged her into the icy pond. She skated together with her rescuer for the rest of the afternoon. A few months later, while visiting a friend in Glen Allen, Va., she was introduced to another guest—actually reintroduced, for it was her ice-skating hero. In July 1896 they became secretly engaged, aware that their parents considered him too young to marry. Two years later, with their families’ blessing, she married at her parents’ home in Richmond, Va. [July 21, 1898] Rudolf Bolling Teusler, Jr. [born in Rome, Floyd Co., Ga., Feb. 25, 1876; at age three he moved with his parents to Virginia, where they soon settled in Norfolk. An only child, he and his mother were left penniless when his father dropped dead of a heart attack while visiting Wytheville, Va., in 1881. His mother took a few courses and then embarked on a career as a high school teacher of German in Richmond, Va.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("A precocious medical student, he was only sixteen years old when he entered the Medical College of Va. in the fall of 1892. He graduated two years later [M.D., 1894], just two months after his eighteenth birthday. State law prevented anyone under the age of twenty-one from practicing medicine, so he became an assistant under the supervision of Dr. Lewis C. Bosher, professor of Anatomy at the Medical College. He went on to complete post-graduate studies and internships at Bellevue Hospital in New York City and other hospitals in Baltimore, Montreal, and Quebec. He then joined the faculty of the Medical College of Va. as assistant professor of Pathology and Bacteriology. He also served as Assistant Surgeon and later Surgeon in the 1"), _c('sup', [_vm._v("st")]), _vm._v(" Regt., Va. Vols., Inf.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("After their marriage, they lived in a modest home in Richmond, with his medical office in the basement and his shingle hung outside. In the summer of 1899, his brother-in-law, Dr. Edmund Lee Woodward, came to Richmond for a brief visit. Rudolph listened silently while Edmund discussed his imminent departure for the Orient to serve there as a medical missionary. Then Rudolph spoke up:")]), _vm._v(" "), _c('div', {
    staticClass: "extract"
  }, [_c('p', {
    staticClass: "extractText"
  }, [_vm._v("You know, that appeals immensely to me—to do work no one else will do. If I should stay here, there is every prospect of building up a good practice in my profession, but there are a score of men who would gladly take my place.")])]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("After a few moments of stunned silence, Mary responded, “If you want to go, I’ll go with you.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("In subsequent discussions with missionary officials in New York City, Rudolph learned of a small, dilapidated hospital in Tokyo that was vacant. Under the aegis of the Foreign Missionary Society of the Episcopal Church, Rudolph and Mary sailed in Jan. 1900 from San Francisco aboard the steamer "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Hong Kong Maru")]), _vm._v(", bound for Tokyo, Japan. They promptly moved into their dilapidated and unheated home, and then it was on to his new hospital, which the local Episcopal bishop John McKim described as “a little shanty.” It proved to be “destitute of anything that could fairly be termed furniture or equipment,” but immediately Rudolph threw all of his energy into a seemingly hopeless task of renovating it.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("In his limited spare time, he began to see private patients, and he was soon the personal physician of many senior foreign embassy officials in Tokyo. He donated all of his sizeable fees to his hospital, and meanwhile he assiduously devoted himself to learning the Japanese language and making contacts with Japanese leaders. Under his tireless leadership, St. Luke’s Hospital opened its doors in Feb. 1902. He initially ran the facility himself with the help of only a single nurse. In a surprisingly short time, however, it became a major medical center in Tokyo. As the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("DAB")]), _vm._v(" summed up, “He combined single-hearted unselfishness with indomitable perseverance, resourcefulness, personal charm, rare gifts as an organizer, and marked skill as a surgeon.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("In 1904–1905, concerns about Mary’s health prompted a trip to the U.S., where her condition improved and Rudolph labored to raise money for his work in Japan. They returned to Tokyo in 1905, bearing $12,000 in accumulated contributions. By 1909 the hospital had grown to a modern facility five times the size of the original “shack.” Among many other duties, Rudolph also supervised the Hospital of St. Barnabas in Osaka, developed the first college for nurses in Japan, and instituted revolutionary programs in public health, child welfare, and preventive medicine.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Throughout these years of growth and great labors, and indeed for his entire career, he never neglected the religious component of his vocation as a medical "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("missionary")]), _vm._v(". An active member of the Episcopal Church in Tokyo, he organized and headed the city’s chapter of The Brotherhood of St. Andrew, a men’s group devoted to Bible study and active lay ministry. A patient at St. Luke’s once asked the doctor why he left the comforts and security of his American medical practice. Rudolph replied that “he had been brought up a Christian and wanted fully to lead a Christian life.” In 1913–1914, he spearheaded a massive expansion and renovation of the hospital, now to be called St. Luke’s International Hospital. In the midst of his fundraising, he received a $25,000 donation from the Emperor of Japan, an unprecedented gift to a Christian ministry.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("By the summer of 1918, as WW I was reaching a crescendo on the Western Front, a great humanitarian crisis was emerging in Siberia. Hundreds and thousands of displaced persons, including a large force of Czech and Slovak veterans, were trapped amid the fighting of the Russian Revolution. A desperate appeal from the International Red Cross went out to Dr. Teusler to head up a large-scale relief effort. He promptly answered the call. Sleeping on the deck of a crowded steamer, he arrived with three diplomatic companions in the port of Vladivostok on July 29, 1918. Plans that he had set in motion even before his departure from Japan soon began to bear fruit, and a small corps of doctors and nurses soon began arriving from Japan.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Although his role was strictly humanitarian, on Nov. 8, 1918, he accepted an appointment as Red Cross commissioner for Siberia, with the rank of Lt. Colonel. His original mission was to supply medical relief to the Czech, Slovak, and White Russian forces that were fighting the Bolsheviks in Siberia. Starting with literally nothing, within a year he had organized field hospitals with over 5,500 beds, along with medical teams ranging throughout the vast interior of Siberia. After some initial successes, the anti-Bolshevik forces faltered and then collapsed. The advancing Red army put an end to operations, and an exhausted Teusler left Russia in the waning days of 1919.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("By 1920 he was back at work on the plans for the new St. Luke’s International Hospital. Finally, in May 1923, he left for the U.S. on a major fund-raising effort. While staying in New York City, he was awakened in the early hours of Sept. 2, 1923, by a frantic telephone call. The famous Tokyo earthquake and accompanying fire had destroyed one third of the city and reduced the hospital to a smoking pile of rubble. “[T]he staff of physicians and nurses displayed great heroism in ministering to the sufferers from the disaster,” and amid the rapidly approaching walls of fire they miraculously transported every patient to safety. For an extended period, the staff toiled virtually around the clock with scanty supplies and only two small meals a day for both staff and patients.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Meanwhile, Dr. Teusler rushed to Washington, D.C., hoping to secure a U.S. Army Field Hospital unit for St. Luke’s. From the Red Cross National Headquarters, he learned that only the signature of the Secretary of War could authorize such a unit. In those pre-Pentagon days, Dr. Teusler made his way through the labyrinthine halls of the old State, War, and Navy Department Building. His efforts seemed doomed to failure, since the Secretary of War was out of town and unavailable. As he dejectedly started to leave, he noticed a sign on a door: “General John J. Pershing.” An aide agreed to pass word to the general that a certain “Dr. Teusler” urgently needed his help. The general promptly appeared and warmly greeted his old friend. Years before, as Capt. Pershing, he had served as military attaché in Tokyo and had been a patient of Dr. Teusler in St. Luke’s Hospital for several weeks. The general assured the doctor that as Acting Secretary of War he had the authority to rush a Field Hospital to Tokyo, and he promptly signed the order.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Over the following weeks, news of the Tokyo disaster triggered a welcome stream of donations to St. Luke’s. With these funds Dr. Teusler quickly improvised a new barracks-style hospital facility, only to see over half of it destroyed by another fire a few months later. Again, quick work by the heroic staff safely evacuated all 145 patients. With characteristic resilience and energy, he sought funds from both Japan and America to raise a splendid new facility, St. Luke’s International Medical Center in Tokyo. Much of his fund-raising effort came at the depths of the Depression, but in spite of all obstacles the new Hospital was dedicated in June 1933. One great turning point came in the summer of 1931, when Colonel and Mrs. Charles A. Lindbergh visited Tokyo and spent five days as a guest in the Teuslers’ home. The famous aviator was so impressed by Dr. Teusler’s work that he agreed to serve as a director of the American Council of St. Luke’s International Medical Center, and he helped to secure the support of prominent American business and professional leaders.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Amid all these labors, Teusler’s health began to fail in the winter of 1930–1931. A wealthy friend and benefactor, Colonel William Cooper Procter, was so disturbed by his appearance that he threatened to withhold his $500,000 gift unless the doctor agreed to take a four months’ vacation. Urgent demands on his time induced Teusler to postpone the much needed rest, but he finally left for the U.S. on Sept. 14, 1933. After spending the fall in the mountains overlooking Los Angeles, he spent the winter months at a ranch near Tucson, Ariz. In the spring of 1934, he traveled to New York City, where he consulted a leading cardiologist. The examination confirmed that his heart condition was terminal. Determined to die in the harness, he sailed with his wife for Tokyo, arriving on July 11, 1934. He was still working in his office on Aug. 7, when he finally agreed to be admitted to St. Luke’s as a patient. He died in his sleep of a heart attack on Aug. 10, 1934. Among his many awards and decorations were the Russian Order of St. Vladimir and the (Japanese) Order of the Rising Sun].")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Throughout Dr. Teusler’s long and distinguished career, his wife Mary was “a constant help and inspiration to her husband.” He himself described her as “his wisest counselor,” and his biographers Robbins and MacNaught add:")]), _vm._v(" "), _c('div', {
    staticClass: "extract"
  }, [_c('p', {
    staticClass: "extractNoIndent"
  }, [_vm._v("Temperamentally he needed her counsel, for she was calm, quiet, reserved, a woman of great depth of character and of sound judgment. His plans were bold and constructive but sometimes so audacious that they exceeded the limits of what was practicable. As hers was a critical influence, she was able to take his enthusiasm and anchor it to solid foundations.")])]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("After her husband’s death, she remained in Tokyo until the new Chapel at St. Luke’s International Medical Center was dedicated on Dec. 13, 1936, and Rudolph’s ashes were buried under the altar. A few months later, Japan invaded China, and U.S.-Japanese relations deteriorated dangerously as an anti-Western militarism gripped the country. Mary felt compelled by these tragic events to return to her native Virginia, and she died at her home in Richmond on Jan. 12, 1941. St. Luke’s International Hospital, temporarily seized and renamed by the Japanese government during WW II, survived unscathed amid the Tokyo bombings of 1944–1945. Under its old name it has grown into an even more impressive, modern medical facility).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23014. Mary Stuart Teusler.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23015. Virginia Bolling Teusler.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23016. Mildred Minor Teusler.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23017. Rudolph Bolling Teusler III (born April 19, 1912; a physician, he died unm. in Granville Co., N.C., May 16, 1977). [Quotations from "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("DAB")]), _vm._v(" and H. ROBBINS-G. MacNAUGHT, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Dr. Rudolph B. Teusler")]), _vm._v(", 20–21, 28, 45–46, 64 (see also "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("passim")]), _vm._v("). See also: M. SORLEY, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Lewis")]), _vm._v(", 133; obit. of Mary W. Teusler in the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Japanese Christian Year-Book")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("for 1941")]), _vm._v(", chap. 10, “Missionary Obituaries,” posted on "), _c('a', {
    attrs: {
      "href": "http://http://www.archive.org/stream/japanchristian39unknuoft/japanchristian39unknuoft_djvu.text",
      "target": "_blank"
    }
  }, [_vm._v("http://www.archive.org/stream/japanchristian39unknuoft/japanchristian39unknuoft_djvu.text")]), _vm._v("; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11251–11213]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12509. John Forrest Workman (born in Charleston, Charleston Co., S.C., Oct. 13, 1886; married Eliza Anderson [born in S.C., Feb. 19, 1883; died in S.C., May 30, 1964]. He was a pharmacist in Sumter Co., S.C., and he died in S.C., Feb. 15, 1963).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23018. Rose Abbott Workman (born in Bishopville, Lee Co., S.C., ca. 1912; she was vice-president and treasurer of Korn Industries, and she died unm. in Sumter, Sumter Co., S.C., Nov. 2, 2003).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23019. Frances Douglas Workman (born in S.C., Jan. 24, 1914; graduated from Coker College, 1935. There she was twice president of her class, and in her senior year she was president of the Student Government Association. She married in Sumter, S.C. [Feb. 25, 1939] Leland M. Murray, Jr. [born in Holly Hill, Orangeburg Co., S.C., Dec. 19, 1911; died in Holly Hill, S.C., July 31, 1994]. She died in Holly Hill, S.C., Jan. 5, 2000, and they reportedly had three children).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23020. Bonnie A. Workman (born in S.C., ca. 1922; died unm. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ante")]), _vm._v(" 2003).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23021. Sarah E. Workman (born ibid., ca. 1923; married Cornelius Gerard Van Dalen [born in Quincy, Norfolk Co., Mass., Nov. 27, 1921; graduated from Tulane U. (undergraduate degree and LL.B.; Phi Beta Kappa). He was a director of the Louisiana Maritime Development Corporation and the Southeastern Admiralty Law Institute during its formative years. He was also an advisory editor of the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Tulane Maritime Law Journal")]), _vm._v(" and the author of several articles in professional journals. An instructor at the U. of New Orleans, he established a course in Admiralty Law. He died in New Orleans, La., June 21, 1992]. They had three children: John Forrest Van Dalen, Cornelius Gerard Van Dalen, Jr., and Julie Ann Van Dalen [married ___ Davis]). [1910 census Charleston Co., S.C., E.D. 19, p. 29A; 1930 census Sumter Co., S.C., E.D. 27, pp. 7B-8A; WW I Draft Reg.; marriage announcement of Frances and Leland Murray in the Charleston (S.C.) "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("News and Courier")]), _vm._v(", 2/26/1939, p. 7; SSDI; obit. of Rose A. Workman in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The")]), _vm._v(" Sumter (S.C.) "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Item")]), _vm._v(", 11/3/2009; obit. of Cornelius G. Van Dalen in the New Orleans "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Times Picayune")]), _vm._v(", 6/24/1992; "), _c('a', {
    attrs: {
      "href": "http://Anc.com",
      "target": "_blank"
    }
  }, [_vm._v("Anc.com")]), _vm._v("/PMT and OWT]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12518. Mary M. Townsend (born in Tenn., April 1875; married [1"), _c('sup', [_vm._v("st")]), _vm._v(", ca. 1891] James Bynum [born in Ill., Feb. 1861]. They resided in Carroll Co., Tenn., 1900, where he was a wood chopper. She married [2"), _c('sup', [_vm._v("nd")]), _vm._v("] Hugh Warren Lynn [born in Tipton Co., Tenn., Nov. 24, 1876; died in Ballinger, Runnels Co., Tex., Feb. 14, 1948]. They resided in Winters, Runnells Co., Tex., 1920, where he was manager of an oil company).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children (by her 1"), _c('sup', [_vm._v("st")]), _vm._v(" husband):")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23022. Martha Bynum (born in Carroll Co., Tenn., May 29, 1896).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23023. Minnie Bynum (born ibid., Aug. 17, 1898).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23024. Billie Bynum (born ca. 1900; died Dec. 6, 1918).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23025. Benjamin Roosevelt Bynum (born ibid., Feb. 17, 1905; died in South Beloit, Winnebago Co., Ill., March 28, 1991).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23026. E. Bynum (born in Tenn., Jan. 1907). [1880 census Tipton Co., Tenn., E.D. 153, p. 304A; 1900 census Carroll Co., Tenn., E.D. 135, p. 4A; 1920 census Runnells Co., Tex., E.D. 222, p. 2A; SSDI; "), _c('a', {
    attrs: {
      "href": "http://FamSearch.org",
      "target": "_blank"
    }
  }, [_vm._v("FamSearch.org")]), _vm._v("./Tex. Deaths; "), _c('a', {
    attrs: {
      "href": "http://Anc.com",
      "target": "_blank"
    }
  }, [_vm._v("Anc.com")]), _vm._v("/PMT]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12531. Collis Ormsby Campbell (born in Ky., April 1890; secretary and general manager of the Campbell Company, he married Elizabeth Haldeman [born in Ky., ca. 1897]. They resided in Louisville, Jefferson Co., Ky., where he died May 11, 1946).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Child:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23027. Elizabeth Campbell (born in Ky., ca. July 1918). [T. BODLEY-S. M. WILSON, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Hist. of Ky")]), _vm._v("., 4:748–749; 1900 census Jefferson Co., Ky., E.D. 78, p. 5A; 1920 census ibid., E.D. 133, p. 5A; KyDI; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11251–1311]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12532. Edith Dumesnil Campbell (born in Ky., Nov. 17 or 19, 1892; married [1917] James White Bruce [born ibid., Oct. 27, 1886; graduated from Yale (1912) and U. of Pa. (M.D., 1917). He served as a Captain in the Medical Corps, USA, in WW I, and he later became a prominent pediatrician in Louisville, Jefferson Co., Ky. He died March 1, 1967. His distinguished father, Helm Bruce of Louisville, was a prominent lawyer and civic leader. Helm Bruce’s father was a Confederate Congressman, and his grandfather, John Larue Helm, was twice Governor of Kentucky. As Barr documents, John Larue Helm was a direct descendant of Nathaniel Pope, whose daughter Anne Pope married the immigrant, Colonel John Washington]. Edith died July 23, 1970, and both were buried at Cave Hill Cemetery in Louisville, Ky.).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23028. Edith Dumesnil Bruce.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23029. Louise Reid Bruce.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23030. Mary Ormsby Bruce. [T. BODLEY-S. M. WILSON, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Hist. of Ky")]), _vm._v("., 4:748–749; H. TAPP-F. WALLIS, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Sesqui-Centennial Hist. of Ky.")]), _vm._v(", 4:1884–1886; J. BARR, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Nathaniel Pope")]), _vm._v(", 199–200; FGS by JHB; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11251–1311]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12536. Joseph Leslie Luckett (born in Ky., Nov. 6, 1892; married in Milton, Trimble Co., Ky. [June 6, 1914] Rinnie Mat Fisher [born in Trimble Co., Ky., Jan. 27, 1892; died in Trimble Co., Ky., Nov. 20, 1978]. In 1930 they resided in Louisville, Jefferson Co., Ky., where he was a road tester for an automobile company. By 1963 he resided in Trimble Co., Ky., where he died June 17, 1971).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23031. Gayle Francis Luckett.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23032. Leah Rill Luckett.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23033. Lewis King Luckett. ["), _c('a', {
    attrs: {
      "href": "http://FamSearch.org",
      "target": "_blank"
    }
  }, [_vm._v("FamSearch.org")]), _vm._v("/Ky. Marriages; 1930 census Jefferson Co., Ky., E.D. 174, p. 3A; KyDI; obits. of Joseph and Rinnie Luckett in “Obits. from Trimble Democrat,” 1970–1979,” "), _c('a', {
    attrs: {
      "href": "http://www.ole.net/˜maggie/trimble/5obit70.htm",
      "target": "_blank"
    }
  }, [_vm._v("www.ole.net/˜maggie/trimble/5obit70.htm")]), _vm._v("; J.A.W., 11251–31322]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12537. Helen Aleen Luckett (born in Milton, Trimble Co., Ky., Aug. 20, 1899; married in New Castle, Henry Co., Ky. [Dec. 24, 1924] Wilson Brook Joyce [born in Milton, Ky., Jan. 13, 1896; a WW I veteran, he died in Carroll Co., Ky., June 5, 1965]. They farmed in Milton, Ky. J.A.W. gives Helen’s year of birth as 1900, but the correct year 1899 is confirmed by her presence as a nine-month old infant in the 1900 census taken June 26, 1900).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23034. Mary Carolyn Joyce (born in Madison, Madison Co., Ky., Dec. 2, 1925; graduated from Hanover College, Madison, Ind. [B.S., 1948]. She married in Carrabelle, Franklin Co., Fla. [April 5, 1950] James Thomas Etheridge [born in Quincy, Gadsden Co., Fla., Dec. 11, 1928; graduated from Georgia Teacher’s College, 1944. He served in the Army (1951–1953) and graduated from Auburn U. (M.A., 1954)]. They resided in Fort Myers, Lee Co., Fla. He taught high school, and she taught the fourth grade).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23035. Sarah Kathleen Joyce.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23036. Nancy Joe Joyce. [1900 census Trimble Co., Ky., E.D. 75, pp. 14A-B; 1930 census ibid., E.D. 3, p. 5A; KyDI; USPRI; J.A.W., 11251–31323]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12539. Florence Mable Luckett (born in Ky., Aug. 13, 1901; married [April 2, 1919] John Barringer [born ibid., Aug. 9, 1894; he was a WW I veteran]. They resided in Milton, Trimble Co., Ky., 1930, where he was manager of a pool hall).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23037. Eva Lorene Barringer.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23038. Leroy Barringer. [1930 census Trimble Co., Ky., E.D. 1, p. 3B; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11251–31332]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12540. Lawrence Calvert Luckett (born in Trimble Co., Ky., Oct. 23, 1907; married in Madison, Jefferson Co., Ind. [June 29, 1929] Bertha Wilson [born in Ind., ca. 1908]. They resided in Milton, Trimble Co., Ky., where he appears in the 1930 census at the depths of the Depression as an unemployed “laborer, odd jobs.” They resided in Milton, Ky., and he died March 4, 1991).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23039. Lois Luckett.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23040. Lorena Luckett.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23041. Ruth Ann Luckett.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23042. Dennis Wayne Luckett (born May 21, 1949). [1930 census Trimble Co., Ky., E.D. 1, p. 3B; SSDI; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11251–31333]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12543. Blanche Ray (born in Trimble Co., Ky., March 25, 1894; married [March 20, 1918] Gilbert Green [born in Ky., ca. 1883]. They farmed in Milton, Trimble Co., Ky., and she died Sept. 20, 1990).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Child:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23043. LaVelle Ray (or “Ray L.”) Green. [1930 census Trimble Co., Ky., E.D. 3, p. 1A; SSDI; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11251–31341]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12545. John Bain Ray, Jr. (born in Trimble Co., Ky., Aug. 18, 1907; graduated from Butler School of Pharmacy, 1932. He married in Indianapolis, Ind. [Feb. 4, 1932] Crystal Bernice Reeves [graduated from Methodist Hospital School of Nursing, 1929]. They resided in Greencastle, Putnam Co., Ind.).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23044. Mary Joan Ray.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23045. John Robert Ray (born in Greencastle, Ind., 1939; graduated from Rose Polytechnical Institute, 1961, and he was later a graduate student at Ohio State U.). [J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11251–31343]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12546. Dorothy Lee Ray (born in Trimble Co., Ky., June 7, 1911; married in Covington, Kenton Co., Ky. [June 8, 1935] George Meyer. They resided in Louisville, Jefferson Co., Ky., and she died Oct. 1988).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Child:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23046. Bonnie Meyer (born 1943; attended the U. of Louisville). [SSDI; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11251–31344]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12548. Adam Jefferson Luckett (born in Trimble Co., Ky., May 26, 1916; married in Jeffersonville, Clark Co., Ind. [Oct. 2, 1936] Josie Mildred Foist [born in Jackson Co., Ind., Jan. 31, 1915]. They resided in Columbus, Bartholomew Co., Ind.).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Child:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23047. Loretta Jean Luckett (born in Madison, Jefferson Co., Ind., July 3, 1937; died March 13, 1953). ["), _c('a', {
    attrs: {
      "href": "http://FamSearch.org",
      "target": "_blank"
    }
  }, [_vm._v("FamSearch.org")]), _vm._v("/Ind. Marriages; KyBI; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11251–31362]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12549. Lena Mae Luckett (born in Madison, Jefferson Co., Ind., March 28, 1918; married [July 3, 1936] Henry M. Shinfessel. They resided in Vevay, Switzerland Co., Ind.).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23048. Patric(k) Wayne Shinfessel (born 1938; attended Purdue U. and Chicago Tech. He married in Jeffersonville, Clark Co., Ind. [Sept. 30, 1961] Martha H. Hunger).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23049. Marlene Shinfessel (born and died in Madison, Ind., April 23, 1941). [J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11251–31363]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12551. Robert Gale Luckett (born in Trimble Co., Ky., July 21, 1921; served in the Army during WW II, and he married in Madison, Jefferson Co., Ind. [April 7, 1942] Thelma Jean Jones. He last resided in Yuma, Yuma Co., Ariz., and he died July 2, 2007).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Child:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23050. Dennis Gale Luckett (born 1943; attended Texas A&M U.). [J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11251–31365]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12552. Gladys Ruth Luckett (born in Trimble Co., Ky., June 28, 1923; married in Chicago, Ill. [Aug. 10, 1945] James M. Scott. They resided in Madison, Jefferson Co., Ind., and she died March 27, 1953).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23051. Dianna Kay Scott (born in Madison, Ind., 1947).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23052. Deborah Frances Scott (born ibid., 1949).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23053. Madah Dee Scott (born ibid., 1953). [J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11251–31366]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12556. Clara Fraser Lewis (born in Tex., Sept. 17, 1905; married in Bexar Co., Tex. [Sept. 17, 1924] Dan Chandler [born Sept. 17, 1901; died Oct. 15 or 18, 1993]. They resided in Dallas, Tex., and she died June 12, 1953).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23054. Lewis Chandler.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23055. Christy Chandler (born Jan. 30, 1927; served in the Army, ca. 1953–1954, and he resided in Houston, Tex.). ["), _c('a', {
    attrs: {
      "href": "http://FamSearch.org",
      "target": "_blank"
    }
  }, [_vm._v("FamSearch.org")]), _vm._v("/Tex. Marriages; SSDI; FGS by LC; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11251–31422]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12557. Zelime Lewis (born in Tex., 1908; married [1"), _c('sup', [_vm._v("st")]), _vm._v("] Perry Joshua Lewis [born 1905; died in Bexar Co., Tex., May 8, 1942]. She married [2"), _c('sup', [_vm._v("nd")]), _vm._v("] W. B. Lupe [born 1910]. She is presumably the Texas Death Index’s “Zelime L. Lewis, died as a widow in Bexar Co., Tex., April 23, 1970”).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Child (by her 1"), _c('sup', [_vm._v("st")]), _vm._v(" husband):")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23056. Perry Joshua Lewis, Jr. (born in Bexar Co., Tex., Feb. 11, 1938; married Memrie Taylor Mosier, and they had one child: Memrie F. Lewis [born in Tarrant Co., Tex., March 17, 1973]). [TexBI; TexDI; "), _c('a', {
    attrs: {
      "href": "http://FamSearch.org",
      "target": "_blank"
    }
  }, [_vm._v("FamSearch.org")]), _vm._v("/Tex. Deaths; B. C. NOONAN, website “Desc. of Edward III”; FGS by LC; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11251–31423]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12560. Clifton Price Cooper (born in Ky., June 28, 1896; a WW I veteran, he married Louise Clemons [born in Ky., Feb. 10, 1902; died April 14, 1962]. He was a bank cashier in Adairsville, Logan Co., Ky., 1930. He last resided in Adairsville, Ky., where he died Feb. 22, 1972, and both were buried at Greenwood Cemetery).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Child:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23057. Paul E. Cooper (born in Ky., ca. Feb. 1930). [1930 census Logan Co., Ky., E.D. 9, p. 1A; "), _c('a', {
    attrs: {
      "href": "http://www.findagrave.com",
      "target": "_blank"
    }
  }, [_vm._v("www.findagrave.com")]), _vm._v("; KyDI]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12571. Pauline Pottinger (born in Ky., Nov. 22, 1896, although the 1900 census says “Sept. 1896”; married Carl Lee Monroe [born ibid., Sept. 11, 1886; died Sept. 26, 1949]. They resided in Auburn, Logan Co., Ky., 1930, where he was a railroad clerk. She died Dec. 24, 1967, and both were buried at Auburn Cemetery in Auburn, Ky.).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Child:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23058. Arthur Dale Monroe (born in Logan Co., Ky., Aug. 8, 1916; died ibid., July 3, 1976, and he was buried at Auburn Cemetery in Auburn, Ky.). [1930 census Logan Co., Ky., E.D. 17, pp. 8A-B; "), _c('a', {
    attrs: {
      "href": "http://www.findagrave.com",
      "target": "_blank"
    }
  }, [_vm._v("www.findagrave.com")]), _vm._v("; "), _c('a', {
    attrs: {
      "href": "http://FamSearch.org",
      "target": "_blank"
    }
  }, [_vm._v("FamSearch.org")]), _vm._v("/AF v4.19; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11251–31526]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12573. Harvie Whitlock Breathitt (born in Hopkinsville, Christian Co., Ky., Nov. 9, 1894; served in the Navy in WW I. He married [1"), _c('sup', [_vm._v("st")]), _vm._v(", on April 19, 1922] Kate McLeod [born in Fla., ca. 1898]. They resided in Lakeland, Polk Co., Fla., 1930, where he owned a drug store. He married [2"), _c('sup', [_vm._v("nd")]), _vm._v("] Helen Baily, and he married [3"), _c('sup', [_vm._v("rd")]), _vm._v("] Dorothy Wilson. He last resided in Spartanburg, Spartanburg Co., S.C., where he died Jan. 31, 1963, and was buried at Greenlawn Memorial Gardens).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children (by his 1"), _c('sup', [_vm._v("st")]), _vm._v(" wife):")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23059. Harvie Whitlock Breathitt, Jr. (born April 17, 1925; last resided in Lakeland, Fla., where he died April 1, 1977).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23060. Douglas Howell Breathitt.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Child (by his 3"), _c('sup', [_vm._v("rd")]), _vm._v(" wife):")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23061. Joanne Starling Breathitt (born 1946). [M. SORLEY, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Lewis")]), _vm._v(", 135; 1930 census Polk Co., Fla., E.D. 76, p. 30B; FlaDI; SSDI; "), _c('a', {
    attrs: {
      "href": "http://www.findagrave.com",
      "target": "_blank"
    }
  }, [_vm._v("www.findagrave.com")]), _vm._v("; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11251–33331]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12578. Belle Gainer (born in Brazos Co., Tex., Jan. 4, 1900; graduated from Baylor-Belton College. She married Charles Stuart Pipkin [born in Selma, Dallas Co., Ala., Feb. 1, 1895; moved with his family to Brazos Co., Tex., in 1906. He enlisted in the Army in May 1917 and served in France with the 33"), _c('sup', [_vm._v("rd")]), _vm._v(" Division. After the war he enrolled at the U. of Texas-Austin and graduated in 1923 (LL.B.). He promptly began a law practice in Beaumont, Jefferson Co., Tex., and he was also Assistant U.S. Attorney for the Eastern District of Texas (1931–1937). He died in Beaumont, Tex., Nov. 13, 1989]. Belle died ibid., Aug. 9, 1985, and both were buried at Bryan City Cemetery in Brazos Co., Tex.).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23062. Virginia Gainer Pipkin (born in Beaumont, Tex., Aug. 25, 1925; married __ Schneider).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23063. Charles Stuart Pipkin, Jr. [T. C. RICHARDSON, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("East Texas")]), _vm._v(", 4:92–93; S. TROTTER, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Trotter Genealogy")]), _vm._v(", 170; WW I Draft Reg.; 1930 census Jefferson Co., Tex., E.D. 15, p. 2A; SSDI; TexBI; TexDI; "), _c('a', {
    attrs: {
      "href": "http://www.findagrave.com",
      "target": "_blank"
    }
  }, [_vm._v("www.findagrave.com")]), _vm._v("; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11251–55222]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12581. William Dunlap Johnson (born in Tex., Aug. 10, 1902; married Maelan McGill [born in Tex., ca. 1905]. They resided in Austin, Travis Co., Tex., 1930, where he was an engineer with a construction company. He died in Houston, Tex., July 7, 1984).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Child:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23064. Joann(e) Johnson (born in Tex., ca. 1929). [S. TROTTER, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Trotter Genealogy")]), _vm._v(", 171; 1930 census Travis Co., Tex., E.D. 39, p. 17A; SSDI; TexDI; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11251–55241]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12582. Samuel Francis Johnson (born in Tex., Sept. 21, 1905; married in Houston, Tex. [June 7, 1934] Alice Catherine Word [born Feb. 1915; died in San Antonio, Tex., Dec. 17, 2001]. They resided in Houston, Tex., and later in San Antonio, Tex., where he died Feb. 1998).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23065. Julie Johnson.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23066. Alice Katherine Johnson. [S. TROTTER, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Trotter Genealogy")]), _vm._v(", 171; NSWFD #766 (Alice Johnson Roberts); "), _c('a', {
    attrs: {
      "href": "http://Anc.com",
      "target": "_blank"
    }
  }, [_vm._v("Anc.com")]), _vm._v("/PMT; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11251–55242]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12583. Kathleen McClelland (born in Ariz. Territory, 1896; married [ca. 1927] Fred Saunders Bennett [born in Tex., Feb. 11, 1875; he was deputy sheriff of Cochise Co., Ariz. He last resided in Tombstone, Cochise Co., Ariz., and he died Feb. 1967]. They resided in Tombstone, Ariz., 1930, and he established a ranch in the rugged Dragoon Mountains near Tombstone).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23067. Freda Marion Bennett (born in Cal., ca. Dec. 1928; married ___ Parrott).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23068. Frank Shelby Bennett. [S. TROTTER, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Trotter Genealogy")]), _vm._v(", 171–172; 1930 census Cochise Co., Ariz., E.D. 65, p. 7A; SSDI; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11251–55311]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12585. Matia McClelland (born in Ariz., ca. 1899; married [1"), _c('sup', [_vm._v("st")]), _vm._v("] E. Elmer Burk. She resided as a public school teacher in Paradise, Cochise Co., Ariz., 1930, where the census lists her as married but mentions neither husband nor children. She later married [2"), _c('sup', [_vm._v("nd")]), _vm._v("] John Sidney Roome).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children (by her 1"), _c('sup', [_vm._v("st")]), _vm._v(" husband; order uncertain):")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23069. Helen Gertrude Burk.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23070. Ralph (Sims) Burk.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23071. Roy (Sims) Burk. [S. TROTTER, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Trotter Genealogy")]), _vm._v(", 171; 1930 census Cochise Co., Ariz., E.D. 56, p. 1A; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11251–55313]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12586. Marion McClelland (born 1902; married Dowell Bryan Kohl [he is presumably the California Death Index’s “Dowell B. Kohl, born in Tex., March 31, 1897, and died in Los Angeles Co., Cal., Sept. 29, 1986.” He appears in the 1930 census Los Angeles Co., Cal., as a WW I veteran, working as a clerk for a railroad, “married” but with no wife mentioned, and residing with his parents]).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Child:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23072. Donald Henry Kohl. [S. TROTTER, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Trotter Genealogy")]), _vm._v(", 171–172; CalDI; 1930 census Los Angeles Co., Cal., E.D. 789, p. 2A; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11251–55314]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12586. Jean Jacquiline McClelland (born in Ariz., Oct. 30, 1905; a newspaper writer, she married Curtis Mitchell Nuttall [born in Okla., ca. 1905; died 1951]. They resided in Dragoon, Cochise Co., Ariz., 1930, where his occupation was “signal maintenance for a railroad.” They later resided in Tombstone, Cochise Co., Ariz., and finally Tucson, Pima Co., Ariz. She died Feb. 1983).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23073. Dixie Lee Nuttall (born in Los Angeles Co., Cal., Oct. 8, 1928; raised in Dragoon, Ariz., she graduated from the U. of Ariz., 1952. She married Elmer Dunn, and she established the first pet cemetery in Tucson, Ariz. She last resided in Tucson, Ariz., and she "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("d.s.p.")]), _vm._v(" Oct. 19, 2003).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23074. Ruby May Nuttall. [S. TROTTER, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Trotter Genealogy")]), _vm._v(", 172; CalBI; 1930 census Cochise Co., Ariz., E.D. 42, p. 1B; USPRI; SSDI; obit. of Dixie L. N. Dunn in the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("San Pedro Valley (Ariz.) News-Sun")]), _vm._v(", 12/5/2003; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11251–55315]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12600. Mary Alice Hollingsworth (born in Okla., Dec. 22, 1913; raised in Columbus, Lowndes Co., Miss., she was an accomplished musician and played the organ for many years at the United Methodist Church in Crawford, Lowndes Co., Miss. She married [1"), _c('sup', [_vm._v("st")]), _vm._v(", in 1934] John Peter Hairston [born in Miss., Dec. 21, 1912; died ibid., May 24, 1963, and he was buried at Oaklimb Cemetery near Crawford, Lowndes Co., Miss.]. They resided in Crawford, Miss., and after her husband’s death she graduated from Miss. U. for Women in Columbus, Miss. [B.S.] and U. of Tenn. [M.S., Social Science]. She then worked for the Department of Human Services in several counties. She married [2"), _c('sup', [_vm._v("nd")]), _vm._v("] Leonard C. Gibson [he was a postmaster and artist]. They lived in Columbus, Miss., and she died in West Point, Clay Co., Miss., Sept. 17, 2007).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children (by her 1"), _c('sup', [_vm._v("st")]), _vm._v(" husband):")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23075. John Peter Hairston, Jr.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23076. James Lamar Hairston.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23077. Nanette Montague Hairston.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23078. Alice Evans Hairston.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23079. William Watt Hairston. [S. TROTTER, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Trotter Genealogy")]), _vm._v(", 174; obit. of Mary A. H. H. Gibson in the (Tupelo) "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Northeast Mississippi Journal")]), _vm._v(", 9/20/2007; USPRI; "), _c('a', {
    attrs: {
      "href": "http://Anc.com",
      "target": "_blank"
    }
  }, [_vm._v("Anc.com")]), _vm._v("/AWT, entry by EJB; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11251–55713]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12601. Marjorie Bess Hollingsworth (born in New Orleans, La., Aug. 12, 1918; a teacher, she married [June 21, 1941] Lowry Lamar Tims [born in McCool, Attala Co., Miss., March 8, 1910; as a boy he moved with his family to Boyle, Bolivar Co., Miss., where his father was a postal worker and later the town clerk. With assistance from his uncle, Austin Tims, Lowry managed even in the depths of the depression to obtain a good education. After two years as a student at St. Mary’s College in San Antonio, Tex., he went on to graduate from the U. of Texas-Austin with a B.S. degree in Accounting.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("He then initially worked for the State of Mississippi as Chief LP Gas Inspector. Later, in the 1940s, he borrowed enough money to buy his own LP Gas delivery truck, thus founding the Lowry Tims Company in Cleveland, Miss. Using this as a base, he went on to establish five branches serving a wide region of the rural Mississippi Delta region. In 1957 he branched out into the manufacture of propane tanks, co-founding the Quality Steel Corp. He was later the principal owner of Commonwealth National Life Insurance Company. He resided in Cleveland, Bolivar Co., Miss., where he died Dec. 8, 1975]. Marjorie died in Cleveland, Miss., Oct. 31, 1997).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23080. Lowry Lamar Tims, Jr.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23081. James Irving Tims.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23082. Douglas Austin Tims.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23083. Robert Lewis Tims. [S. TROTTER, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Trotter Genealogy")]), _vm._v(", 174–178; Z. CHASTAIN, “Miss. Master Plan,” "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("LP/Gas")]), _vm._v(", Sept. 1999, 1–5; T. T. KARLSEN, website “Anc. of Trudy Annette Tims” and also the website “Quality Steel Corp.”; 1930 census Lowndes Co., Miss., E.D. 42, p. 5B; R. D. JAMES and M. LOWERY, website “Oaklimb Cem.”; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11251–5571]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12605. Ira Clinton Dimmick, Jr. (born in Shuteson, Vermilion Parish, La., Jan. 14, 1922; a WW II veteran, he enlisted in the National Guard, Nov. 25, 1940. He served initially in the 156"), _c('sup', [_vm._v("th")]), _vm._v(" Inf. of the National Guard, and finally in the European Theater as a Lt. in the 516"), _c('sup', [_vm._v("th")]), _vm._v(" Field Artillery, USA. He married in Sulphur, Calcasieu Parish, La. [July 2, 1946] Eleanor Edna Vincent [born in Sulphur, La., Oct. 9, 1920; died in Hapeville, Ga., Oct. 27, 1997]. They resided in Lake Charles, Calcasieu Parish, La.).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23084. Alice Diane Dimmick (born in Lake Charles, La., 1949).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23085. Carol Jean Dimmick (born ibid., 1950; married in Reno, Washoe Co., Nev. [March 5, 1976] Joseph Morris Pugh [died Sept. 7, 1996]).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23086. Dorothy Louise Dimmick. [S. TROTTER, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Trotter Genealogy")]), _vm._v(", 175; WW II AER; FGS by AEDH and MES; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11251–55751]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12606. Alice Elizabeth Dimmick (born in Columbus, Lowndes Co., Miss., Oct. 10, 1923; married in Lake Charles, Calcasieu Parish, La. [Nov. 2, 1946] Horace Leonard Hutchison, Jr. [born in Cassville, Barry Co., Mo., Feb. 9, 1915; a direct descendant of President Thomas Jefferson, Horace died June 15, 1994]. They resided in Lake Charles, La.).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23087. Janet Elizabeth Hutchison.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23088. Hal Thomas Hutchison.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23089. Mary Lynn Hutchison.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23090. Susan Frances Hutchison (born Oct. 19, 1957; married [Aug. 26, 1997] Stephen Akira Kiyono [born 1961]). ["), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Burke’s")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Pres. Fam")]), _vm._v("., 82; F. PYNE, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Desc. of the Signers, Va.")]), _vm._v(", 297; FGS by AEDH and MES; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11251–55752]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12607. Mary Frances Dimmick (born in Opelousas, St. Landry Parish, La., Nov. 9, 1925; married in Lake Charles, Calcasieu Parish, La. [April 25, 1953] John McGraw III [born in Shreveport, Caddo Parish, La., Jan. 18, 1923]. They resided in Lake Charles, La.).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23091. Terri McGraw (born in Lake Charles, La., 1955; married ibid. [March 27, 1982] Harry Michael Clayton).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23092. Jerri McGraw.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23093. Forres McGraw.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23094. Tim McGraw. [S. TROTTER, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Trotter Genealogy")]), _vm._v(", 175; FGS by AEDH and MES; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11251–55753]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12608. James Willis Dimmick (born in Opelousas, St. Landry Parish, La., Oct. 13, 1929; graduated from LSU [B.S., Business Administration, 1951]. He married in Lake Charles, Calcasieu Parish, La. [May 14, 1955] Betty JoAnn Thorson [born in La Crosse, La Crosse Co., Wisc., Jan. 20, 1930]. They resided in Lake Charles, La.).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23095. Robert Byron Dimmick (born in Lake Charles, La., 1963).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23096. Laura Catherine Dimmick. [S. TROTTER, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Trotter Genealogy")]), _vm._v(", 175; FGS by AEDH and MES; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11251–55754]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12609. Thomas Evans Dimmick (born in Opelousas, St. Landry Parish, La., May 1, 1931; married in Gulfport, Harrison Co., Miss. [July 1, 1957] Joan Dosher [born in Lake Charles, Calcasieu Parish, La., Jan. 28, 1933]. They resided in Lafayette, Lafayette Parish, La.).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23097. Stephen Moss Dimmick.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23098. Matt Evans Dimmick.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23099. Kelley Jean Dimmick.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23100. Dee Ann Dimmick (born in Lake Charles, La., 1962).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23101. Mary Christi Dimmick (born in Jackson, Hinds Co., Miss., 1969). [S. TROTTER, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Trotter Genealogy")]), _vm._v(", 175; FGS by AEDH and MES; USPRI; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11251–55755]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12614. Anne Mason Berry (born in Va., ca. 1902; married [Jan. 14, 1930] William Evans Chapin [born in Va., May 25, 1898; a physician, he died in Winston-Salem, Forsyth Co., N.C., May 6, 1992]. They resided in Westover Hills, Chesterfield Co., Va., 1940. She died in Va., Oct. 1992).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23102. Anne Mason Chapin (born in Va., 1932; married [Nov. 20, 1954] Richard Vernon Neill, and they had one child: Ann Mason Neill).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23103. Mary Grymes Chapin (born ibid., 1936).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23104. William Evans Chapin, Jr. (born ibid., 1938).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23105. Virginia Washington Chapin (born ibid., 1939).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23106. Lucius Thacker Chapin. [1940 census Chesterfield Co., Va., E.D. 21–9, p. 16B; Gunston Hall Plantation website, “Desc. of George Mason”; NCarDI; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 23274–5115]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12617. Lloyd Washington Berry (married Marguerite Rollins).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23107. Elizabeth Ann Berry (married Ballard Cheatham, and they had one son: Charles Lloyd Cheatham).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23108. Carolyn Willantha Berry.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23109. Sarah Janice Berry.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23110. Mary Berry. [J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 23274–5152]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12621. Eugene Washington Stuart (born in Va., Feb. 25, 1902; married [Nov. 5, 1927] Marion Fryer [born April 21, 1902; last resided in St. Petersburg, Pinellas Co., Fla., and she died March 17, 1974]. He died Aug. 14, 1965, and both were buried at St. Paul’s Episcopal Church Cemetery in King George Co., Va.).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23111. Mary Katherine Stuart.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23112. Eugene Washington Stuart, Jr. [SSDI; FGS by SAA; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 23733–2x12]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12622. John Wilbur Stuart (born in Va., March 23, 1910; married [June 25, 1942] Marguerite Elizabeth Smith [died Feb. 15, 2001, age 88]. He died 1954, and his widow resided in Cleveland, Oh.).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23113. Carol Ann Stuart.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23114. Marguerite Elizabeth Stuart.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23115. John Arthur Stuart. [FGS by AJSC; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 23733–2x13]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12624. Mary Washington Stuart (born in Washington, D.C., May 23, 1915; married ibid. [1"), _c('sup', [_vm._v("st")]), _vm._v(", in Dec. 1937] Lochrane Atlee Gary, Jr. [born in Spartanburg, Spartanburg Co., S.C., March 4, 1917; a WW II veteran of the China-Burma-India Theater, he died in Hines, Cook Co., Ill., April 15, 1971]. Later divorced, she married in Washington, D.C. [2"), _c('sup', [_vm._v("nd")]), _vm._v(", on July 2, 1955] Raymond James Haggerty [born in Pittsburgh, Pa., Aug. 5, 1909; served in the Air Force in the European Theater in WW II. He died in Deerfield Beach, Broward Co., Fla., June 27, 1999]).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Child (by her 1"), _c('sup', [_vm._v("st")]), _vm._v(" husband):")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23116. Lochrane Atlee Gary III. ["), _c('a', {
    attrs: {
      "href": "http://Anc.com",
      "target": "_blank"
    }
  }, [_vm._v("Anc.com")]), _vm._v("/AWT; FGS by AJSC & LAG; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 23733–2x41]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12625. Rosalie Eugenia Stuart (born in Va., Jan. 7 or 17, 1917; married in Washington, D.C. [Oct. 8, 1938] Glenn McInturff Windel [born in Shenandoah Co., Va., Feb. 16, 1907; died in Boynton Beach, Palm Beach Co., Fla., May 29, 2006]. They resided in Chevy Chase, Montgomery Co., Md., and later in Boynton Beach, Fla. She died in Palm Beach Co., Fla., Aug. 17, 2009).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23117. Marian Kathleen Windel (born May 21, 1946; an Episcopal priest, she graduated from Virginia Theological Seminary [M.Div.]. She has served as vicar of Peace in the Valley Episcopal Mission in Nellysford, Nelson Co., Va., and rector of Westover Church in Charles City, Va., as well as Hospice chaplain for Montgomery Co., Md. A member of the Diocese of Virginia Committee on Aging, she has also served on the executive committee of Chaplain Services of the Churches of Virginia, Inc. More recently she has served as executive director of Sophia House, a religious community and retreat center near Louisa in Louisa Co., Va.).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23118. Linda Sue Windel.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23119. Glenn Carlton Stuart Windel (born 1964; married [1"), _c('sup', [_vm._v("st")]), _vm._v("] Tracy Christine Potter; married [2"), _c('sup', [_vm._v("nd")]), _vm._v("] Lisa Sturgill). [SSDI; "), _c('a', {
    attrs: {
      "href": "http://Anc.com",
      "target": "_blank"
    }
  }, [_vm._v("Anc.com")]), _vm._v("/AWT, entry; "), _c('a', {
    attrs: {
      "href": "http://http://www.sophiahouse.org",
      "target": "_blank"
    }
  }, [_vm._v("http://www.sophiahouse.org")]), _vm._v("; FGS by AJSC; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 23733–2x42]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12628. Jane Elizabeth Stuart (born in Passaic, Passaic Co., N.J., Sept. 15, 1915; graduated from Hood College in Frederick, Md., ca. 1936. She married in Passaic, N.J. [July 15, 1939] William Raymond Jewett [born in Passaic, N.J., Sept. 24, 1914; graduated from Pratt Institute in Brooklyn, N.Y. (Mechanical Engineering, ca. 1936). During WW II, he was production manager at the Bendix Aviation Pioneer Division in Hasbrouck Heights, N.J., which made most of the cockpit instruments used by the U.S. in military aircraft. They resided in N.J. before retiring in Boynton Beach, Palm Beach Co., Fla., and he died June 1, 1991]).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23120. David Stuart Jewett.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23121. Nancy Jane Jewett. [SSDI; FGS by David S. Jewett; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 23733–2x51]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12629. Virginia Grymes Washington (born Nov. 22, 1916; married [June 20, 1942] Richard James Gros [born Dec. 26, 1915]. They resided in Dahlgren, King George Co., Va. She last resided in Rockingham Co., Va., and she died Feb. 23, 2006).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23122. James Washington Gros (born 1943; married [Sept. 20, 1979] Donna Marie Hamilton. They were divorced in 1980, and she resided in Silver Spring, Montgomery Co., Md.).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23123. Eugene Washington Gros (born 1952).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23124. Sylvia Washington Gros (born 1959). [SSDI; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11262–21841]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12630. Mary Elizabeth Washington (born Oct. 18, 1920; married [1"), _c('sup', [_vm._v("st")]), _vm._v(", on Oct. 14, 1944] Ralph David Drosd [born April 16, 1913; died April 1, 1965. He and his son Walter were buried at St. Paul’s Episcopal Church Cemetery in Owens, King George Co., Va.]. She married [2"), _c('sup', [_vm._v("nd")]), _vm._v(", on March 28, 1970] Robert John Carter [born March 26, 1917]. They resided in Silver Spring, Montgomery Co., Md., and Kensington, Montgomery Co., Md.).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children (by her 1"), _c('sup', [_vm._v("st")]), _vm._v(" husband):")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23125. Walter Lloyd Drosd (born in Washington, D.C., July 15, 1948; resided in Kensington, Md., when he joined the USMC in 1967. He began a tour of duty in Vietnam on Aug. 29, 1967. Reaching the rank of Lance Cpl. and serving in the 5"), _c('sup', [_vm._v("th")]), _vm._v(" Communications Battalion, he was killed by enemy mortar or artillery fire in Quang Tri Province, South Vietnam, May 28, 1968. This action came during the second phase of the Tet Offensive. His name is inscribed on Panel 64W, Row 8 of the Vietnam Memorial Wall in Washington, D.C.)")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23126. Robert Mickel Drosd (born 1951; married [Jan. 5, 1980] Carolyn Elizabeth Peightal [born 1948]).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23127. Roger David Drosd (born 1953). [SSDI; "), _c('a', {
    attrs: {
      "href": "http://www.marinestogetherweserved.com",
      "target": "_blank"
    }
  }, [_vm._v("www.marinestogetherweserved.com")]), _vm._v("; "), _c('a', {
    attrs: {
      "href": "http://www.thevirtualwall.org",
      "target": "_blank"
    }
  }, [_vm._v("www.thevirtualwall.org")]), _vm._v("; "), _c('a', {
    attrs: {
      "href": "http://www.findagrave.com",
      "target": "_blank"
    }
  }, [_vm._v("www.findagrave.com")]), _vm._v("; website “St. Paul’s Episcopal Church Cemetery” ("), _c('a', {
    attrs: {
      "href": "http://http://kykinfolk.com/stafford/cemeteries/stpaulsepiscem.htm",
      "target": "_blank"
    }
  }, [_vm._v("http://kykinfolk.com/stafford/cemeteries/stpaulsepiscem.htm")]), _vm._v("); J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11262–21842]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12631. William Henry Washington III (born 1933; married Cary Upshur).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23128. William Henry Washington IV.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23129. Thomas Upshur Washington (married Catherine Spotswood Morgan, and they had one child: Cassandra Mae Washington).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23130. Charles Thacker Washington. [Gunston Hall Plantation website, “Desc. of George Mason”; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11262–21861]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12632. Robert Nelson Washington (born 1935; married Ellen ___).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Child:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23131. Dixie Lee Washington (born in Alexandria, Va.; married in King George Co., Va., Gary Lee Tolley [born in Mecca, Trumbull Co., Oh.]). [Gunston Hall Plantation website, “Mason Fam. Gen.”; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11262–21862]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12633. William Thomas Drinkard, Jr. (born in Md., April 19, 1911; his social security card was issued in Washington, D.C. He married Ruth Anita G., and he died in Cocoa, Brevard Co., Fla., June 10, 1986).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23132. Ruth Marie Drinkard.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23133. Carroll Jeannette Drinkard. [SSDI; FlaDI; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11262–21911, rev.]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12634. Edward Washington Drinkard (born in Md., July 17, 1916; a WW II veteran, he enlisted in Baltimore, Md., March 20, 1941. He married Frances “Faye” Virginia Herbert [born in Chesapeake, Va., July 3, 1921; died in Norfolk, Va., March 13, 2010]. He resided in Virginia Beach and Norfolk, Va. He died in Norfolk, Va., Jan. 1987).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23134. Pamela Drinkard (married Bill Hiner, and they resided in Norfolk, Va.).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23135. Thomas Edward Drinkard (married Colleen ___, and they resided in Virginia Beach, Va.). [1920 census Charles Co., Md., E.D. 31, p. 1B; 1930 census Washington, D.C., E.D. 53, p. 19A; WW II AER; SSDI; obit. of Frances H. Drinkard in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The (Norfolk) Virginian Pilot")]), _vm._v(", 3/16/2010; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11262–21912, rev.]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12636. Virginia W. Washington (born in Cal., ca. 1917; married Marshall A. Creed [born June 4, 1917; resided in Amador Co., Cal., when he enlisted in the Army in San Francisco, Cal., Feb. 28, 1946. He died in Santa Clara Co., Cal., Feb. 9, 1964]. They resided in Cal.).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23136. Betty Ann Creed (born in San Francisco Co., Cal., Oct. 28, 1939).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23137. Judith Lucinda Creed (born ibid., Dec. 29, 1940).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23138. Michael Anthony Creed (born March 16, 1943).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23139. Georgia Joan Creed (born in Amador Co., Cal., Sept. 5, 1944). [CalBI; WW II AER; CalDI; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11262–21922, rev.]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12638. John Bernard Scott, Jr. (born in Va., ca. Jan. 1908; married [1938] Mary F. Lanier. They resided in Jacksonville, Fla., and later Winter Haven, Polk Co., Fla.).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23140. Gay Lanier Scott.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23141. Ann Mason Scott. [J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11262–21951]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12639. Eleanor Washington Scott (born in Md., ca. 1910; married [1936] Berry Iglehart [the “i” in his surname is long. He left his wife when she was pregnant with her second child, and they were subsequently divorced. He died 1982]. A long-time resident of Winter Haven, Polk Co., Fla., she moved in 1992 to Tallahassee, Leon Co., Fla., where she died June 2, 1998).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23142. Edward Scott Iglehart.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23143. Robert Eden Iglehart. [Telephone interview with MAI, 4/17/2011; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11262–21952]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12640. Martha Washington Hansen (born in Cal., ca. 1913; married Clarence Klitz Jones).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23144. Ann Mason Jones.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23145. Charlotte Kathryne Jones (married Richard Dorworth and they had one child: Scott Howard Dorworth [born in Santa Clara Co., Cal., July 3, 1960]). [1920 census Sacramento Co., Cal., E.D. 104, p. 7A; CalBI; "), _c('a', {
    attrs: {
      "href": "http://FamSearch.org",
      "target": "_blank"
    }
  }, [_vm._v("FamSearch.org")]), _vm._v("/AF v4.19; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11262–21961]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12641. Charles Beverley Hansen (born in Sacramento, Sacramento Co., Cal., June 18, 1917; raised in Sacramento and Reno, Nev., he developed a love of flying in his teens and soon obtained a pilot’s license. After working for Standard Oil in northern California for five years, he moved to Provo, Ut., where he met and married [1"), _c('sup', [_vm._v("st")]), _vm._v("] Carmen E. Davis [born March 20, 1922; died April 29, 1997]. They moved to Mesa, Maricopa Co., Ariz., where he was an instructor for RAF aviation cadets during WW II. They later moved to Stockton, Cal., where he worked for his father in the wholesale grocery business for fifteen years. He later an office manager for Cal-Wool Marketing. He married [2"), _c('sup', [_vm._v("nd")]), _vm._v(", in 1998] Miriam Prince. He retired in St. George, Washington Co., Utah, where he died June 13, 2003).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children (by his 1"), _c('sup', [_vm._v("st")]), _vm._v(" wife):")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23146-a. Caren Ann Hansen (married Bruce Hampton and they had two children: Veronica Ann Hampton [born in San Joaquin Co., Cal., Jan. 1, 1964] and Linette A. Hampton [born ibid., March 25, 1966]).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23146-b. Michael Charles Hansen (born in San Joaquin Co., Cal., Jan. 10, 1946).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23146-c. John Larry Hansen (born ibid., Dec. 13, 1948).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23146-d. Carl Gregory Hansen (born ibid., March 10, 1953; married Miriam Louise Foutz and they had four children: Gregory Seth Hansen, Jason Charles Hansen, Hanna Marie Hansen, and Jesse Evan Hansen).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23146-e. Charlene Amanda Hansen (born ibid., July 2, 1957). [1920 census Sacramento Co., Cal., E.D. 104, p. 7A; CalBI; "), _c('a', {
    attrs: {
      "href": "http://FamSearch.org",
      "target": "_blank"
    }
  }, [_vm._v("FamSearch.org")]), _vm._v("/AF v4.19; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11262–21962]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12647. Margaret Linton Fairfax (born in N.Y., March 10, 1896; married [1"), _c('sup', [_vm._v("st")]), _vm._v(", on July 9, 1918] Warren Murdock [born ibid., ca. 1890; a WW I veteran, he was a real estate agent in Glen Cove, Nassau Co., N.Y., 1930]. Later divorced, she married [2"), _c('sup', [_vm._v("nd")]), _vm._v(", on Dec. 27, 1952] Arthur Piel. They resided in Santa Barbara, Santa Barbara Co., Cal., where she died April 26, 1975).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children (by her 1"), _c('sup', [_vm._v("st")]), _vm._v(" marriage):")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23147. (Linton) Fairfax Murdock (born in N.Y., Sept. 10, 1920; married [1"), _c('sup', [_vm._v("st")]), _vm._v("] Elizabeth Hardy. They had no children and were later divorced. He married [2"), _c('sup', [_vm._v("nd")]), _vm._v("] Dorothy Clark, and they too were divorced without children. He married [3"), _c('sup', [_vm._v("rd")]), _vm._v("] Patricia Kochs).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23148-a. Warren Murdock (born ibid., April 1, 1923; married [April 4, 1954] Winifred Hall, and they resided in Santa Monica, Los Angeles Co., Cal. He died in Los Angeles Co., Cal., Sept. 8, 1996).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23148-b. Harvey Kirk Murdock (born in N.Y., Oct. 27, 1927). [1930 census Nassau Co., N.Y., E.D. 6, p. 28B; CalDI; SSDI; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11262–34312]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12648. Laurence Washington Fairfax (born in N.Y., July 9, 1904; married Dorothy Ransome, and they resided in Pelham Manor, Westchester Co., N.Y.).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23149. Sally Kirk Fairfax (born ca. 1944).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23150. Marilynn Ransome Fairfax (born ca. 1947). [J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11262–34313]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12649. John Fairfax Stafford (born Oct. 29, 1904; married [1"), _c('sup', [_vm._v("st")]), _vm._v("] Mildred Brown [died ca. 1954]. Later divorced, he married [2"), _c('sup', [_vm._v("nd")]), _vm._v(", on Aug. 14, 1933] Dorothy Bauman [born May 22, 1905; died in Naples, Collier Co., Fla., April 1980]. He died in Collier Co., Fla., May 5, 1987).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Child (by his 1"), _c('sup', [_vm._v("st")]), _vm._v(" wife):")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23151. Jane Stafford.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23152. Sally Fairfax Stafford. [SSDI; FlaDI; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11262–34351]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12651. Virginia Stafford (born in La., ca. 1908; married [1933] Franklin Gardiner [born in N.Y., ca. 1909; he was a lawyer]. They resided in New Orleans, La., 1940, and they were later divorced).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23153. Lynn Gardiner (born in La., ca. 1935; married ___).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23154. Franklin Gardiner, Jr. (born ibid., ca. 1938). [1940 census Orleans Parish, La., E.D. 36–338, p. 12A; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11262–34353]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12665. Clara Vivian Mauney (born in Ga., May 5, 1893; married Francis Rowan Partee [born Oct. 20, 1889; died Dec. 1, 1955]. She died in Gadsden, Ala., May 12, 1941, and both were buried at Crestwood Memorial Cemetery in East Gadsden, Ala.).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23155. Francis Rowan Partee, Jr. (born 1919; died 1975).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23156. Max Dewitt Partee (born in Ala., Feb. 11, 1921; died in Gadsden, Ala., Sept. 15, 1988).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23157. Clara Maudine Partee (born 1924; married ___ Davis, and she died 2011).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23158. Abner Dawson Partee (born in Birmingham, Jefferson Co., Ala., Oct. 20, 1925; apparently lying about his age, he enlisted in the USMC at the age of sixteen on Feb. 2, 1942. Soon he was assigned to Co. H., 2"), _c('sup', [_vm._v("nd")]), _vm._v(" Battalion, 7"), _c('sup', [_vm._v("th")]), _vm._v(" Regiment, 1"), _c('sup', [_vm._v("st")]), _vm._v(" Marine Division. They landed on Guadalcanal on Sept. 18, 1942, nearly six weeks into the legendary campaign that would grind on for another four months. They faced probably their toughest challenge at the pivotal Battle for Henderson Field, Oct. 25–26, 1942. The 2"), _c('sup', [_vm._v("nd")]), _vm._v(" Battalion was dug in on the left flank of Lt. Colonel “Chesty” Puller’s 1"), _c('sup', [_vm._v("st")]), _vm._v(" Battalion, just a few hundred yards in advance of the two vital air strips Henderson Field and Fighter One. In vicious night combat, often hand-to-hand and against desperate odds, the Marines held on by the narrowest margin. At one point in the 2"), _c('sup', [_vm._v("nd")]), _vm._v(" Battalion’s sector, a Japanese unit succeeded in infiltrating and occupying high ground that dominated both the airfields and the battle ground. The Executive Officer of the 2"), _c('sup', [_vm._v("nd")]), _vm._v(" Battalion, Maj. Odell Conoley, launched a counter-attack with every spare man he could find—seventeen in all, including a cook, a “bandsman,” a kitchen mess team, a few communication specialists, and a few riflemen. They fought their way up, seized the high ground, and held it.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Abner played a cameo role in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Into the Valley: Marines at Guadalcanal")]), _vm._v(", a history written by youthful war correspondent and later Pulitzer Prize-winning novelist John Hersey:")]), _vm._v(" "), _c('div', {
    staticClass: "extract"
  }, [_c('p', {
    staticClass: "extractText"
  }, [_vm._v("Across the road, Abner Partee (‘Private, sir—most popular rank in the service’) played his accustomed game of pretending to shirk. One of his officers told me he was actually a pretty hard-working fellow, but he liked to talk in his lazy Georgia [sic: read ‘Alabama’] drawl about doing less. ‘I got a hunderd thirty rounds of machine gun ammunition over here I’m a-hankerin’ to fire. If I should happen to shoot a mess of Japs and if I should happen to run out’n ammunition, then I reckon I wouldn’t have to carry it, would I?’")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("According to his obituary on "), _c('a', {
    attrs: {
      "href": "http://www.findagrave.com",
      "target": "_blank"
    }
  }, [_vm._v("www.findagrave.com")]), _vm._v(", he also fought in the horrific struggle for Peleliu, and we should presumably add New Britain. [For details, see the entry for Lt. General John Taylor Selden, USMC, Vol. 2, entry #15335]. Abner’s decorations included the Purple Heart. For 35 years he was a millwright at Republic Steel, and he served on the Gadsden City Council. He married Dorothy ___, and he died in Gadsden, Ala., Oct. 8, 2007. They had two children: Allen Dawson Partee [1952–2003] and Brenda Partee [married ___ Howard]).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23159. Margaret Earl Partee (born in Birmingham, Ala., Aug. 6, 1928; married Edward R. Peyton, and she "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("d.s.p")]), _vm._v(". in Gadsden, Ala., Feb. 11, 2009). [Quotation from J. HERSEY, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Into the Valley")]), _vm._v(", 7–8. See also: R. FRANK, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Guadalcanal")]), _vm._v(", esp. 361–365, 414–423; 1870 census Polk Co., Ga., p. 313; 1910 census Etowah Co., Ala., E.D. 58, p. 21A; "), _c('a', {
    attrs: {
      "href": "http://www.findagrave.com",
      "target": "_blank"
    }
  }, [_vm._v("www.findagrave.com")]), _vm._v(" (with annotations and photos by Georgina “Gina” Louise Townley Swinburn); "), _c('a', {
    attrs: {
      "href": "http://Anc.com",
      "target": "_blank"
    }
  }, [_vm._v("Anc.com")]), _vm._v("/USMC Muster Rolls; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11262–3515]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12667. Leafy Virginia Mauney (born in Oneonta, Blount Co., Ala., Nov. 12, 1899; married Volen William Townley [born in East Gadsden, Etowah Co., Ala., Feb. 26, 1893; before the sudden onslaught of the Great Depression, he was co-owner of the Coca Cola bottling company in Gadsden, Etowah Co., Ala. He then lost his business, and “he was cheated by a good friend in business and suffered an emotional collapse,” according to a family tradition preserved by his granddaughter Georgina Townley Swinburn. The story continues that he was hospitalized in a mental facility, where he jumped from a second-story window:")]), _vm._v(" "), _c('div', {
    staticClass: "extract"
  }, [_c('p', {
    staticClass: "extractNoIndent"
  }, [_vm._v("The jump did not kill him but left him with a lifetime of limitations far worse than any mental health issues. My grandmother, Leafy, picked him up from the sanatorium stating that if they couldn’t do any better than that, then she’d just keep him at home. And she did, until his death.")])]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Left without financial resources, Leafy supported her family initially by making sandwiches that her three young sons carried around their local town in a wagon and sold on the street. He died in Gadsden, Etowah Co., Ala., Jan. 1977]. They resided in East Gadsden, Ala., 1930, where he worked for a stove foundry. Leafy died in East Gadsden, Ala., Feb. 1979).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23160. Clyde William Townley (born in East Gadsden, Ala., Aug. 7, 1917; a WW II veteran, he enlisted in Montgomery, Ala., July 27, 1940. He served in the European Theater, and he was struck by a shell in the Battle of the Bulge. He was “hospitalized for 38 weeks, and when he left the hospital he had a limp, a brace on his leg, and a cane.” His decorations included the Silver Star and the Purple Heart with an Oak Leaf Cluster. He worked as an administrator with the Finance and Accounting departments at Fort McClellan. He married [1"), _c('sup', [_vm._v("st")]), _vm._v("] Marjorie Carter, and he married [2"), _c('sup', [_vm._v("nd")]), _vm._v("] Phoebe Maxine Smith [born Sept. 15, 1923; died in Gadsden, Etowah Co., Ala., April 30, 2003]. He died in Gadsden, Ala., 1971.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Clyde had two children by his first wife Marjorie: Clydette Townley and Carter Townley. He also had one child by his second wife Phoebe: Elizabeth Clyde Townley [married Robert Reeder Price (born in Florence, Lauderdale Co., Ala., March 10, 1969; died in Gallatin Co., Mont., Feb. 24, 2011). They had two children: Gracie Elizabeth Price and William Townley Price]).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23161. Herman George Townley (born in Gadsden, Ala., Feb. 22, 1919; as a boy, helped support the family by selling sandwiches and operating a newspaper route. he and his brothers served in the Air Force in WW II. He married in Rome, Floyd Co., Ga. [1941] Margaret Louise Maddox [born in Gadsden, Ala., Aug. 1, 1922; died Dec. 11, 1995]. He died in Orange, Orange Co., Tex., Oct. 10, 2000. They had two children:")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("[1]. Georgina “Gina” Louise Townley (married ___ Swinburn, and they resided in Vinton, Calcasieu Parish, La. She generously contributed information on her family, and she has posted valuable family records and photos on "), _c('a', {
    attrs: {
      "href": "http://www.findagrave.com",
      "target": "_blank"
    }
  }, [_vm._v("www.findagrave.com")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("[2]. Lisa Anne Townley.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23162. Robert Edward Townley (born East Gadsden, Etowah Co., Ala., May 3, 1921; a WW II veteran, he enlisted at Fort McClellan, Ala., Sept. 16, 1942. He served in the Air Force and was stationed in Italy. He married Gene Johnson. After the war, he graduated from Jacksonville [Ala.] State U., and he reenlisted in the Air Force. He reached the rank of Major and was a radar bombardier on B-52 bombers. In early Jan. 1964, his plane few to Europe as part of a “Chrome Dome” alert, a protocol that kept a certain number of B-52s constantly in the air, armed with nuclear bombs, and assigned a specific target in the Soviet Union. After returning to the U.S., and still carrying nuclear bombs, his B-52D bomber took off from Westover [Mass.] Air Force Base, headed for Turner Air Force Base in Albany, Ga. While flying over southern Pennsylvania, the plane encountered a ferocious winter storm. The extreme turbulence snapped off the plane’s huge vertical stabilizer, and the pilot ordered the crew to bail out. Robert was the only crew member who apparently was unable to escape from the doomed bomber. He died when it crashed into Savage Mountain near Barton, Garrett Co., Md., on Jan. 13, 1964. Robert and Gene had two children: Don Townley and Ben Reed Townley).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23163. Gloria Ramona Townley (born in Gadsden, Ala., June 16, 1928; a gifted artist and seamstress, she married Ernest Cumley Hofferbert. She died in Rainbow City, Etowah Co., Ala., April 9, 2005. They had three children: Ernest Cumley Hofferbert, Jr., Theresa Hofferbert, and Gretchen Hofferbert). [Quotations from "), _c('a', {
    attrs: {
      "href": "http://www.findagrave.com",
      "target": "_blank"
    }
  }, [_vm._v("www.findagrave.com")]), _vm._v(" (annotations by Georgina “Gina” Louise Townley Swinburn, who also shared further details). See also D. WHETZEL, “A Night to Remember,” "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Mountain Discoveries")]), _vm._v(", 48–51; 1930 census Etowah Co., Ala., E.D. 444, p. 2B; WW II AER; ; "), _c('a', {
    attrs: {
      "href": "http://www.findagrave.com",
      "target": "_blank"
    }
  }, [_vm._v("www.findagrave.com")]), _vm._v(" (with annotations and photos by Georgina “Gina” Louise Townley Swinburn); J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11262–35151]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12671. Florence Estelle Rumph (born Sept. 4, 1878; taught briefly at Central High School in Birmingham, Jefferson Co., Ala., and she then married [1900] James Martin Smith [born Feb. 28, 1871; died Sept. 13, 1929]. She died Oct. 22, 1943).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23164. James Martin Smith, Jr.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23165. Mary Althea Smith (born Nov. 15, 1906; married [July 16, 1937] James Thomas Dickinson. Later divorced in Nov. 1946, they had no children).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23166. Cornelius Mandeville Smith.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23167. Florence Lee Smith. [J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11262–35212]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12676. Mildred Coley Rumph (twin; born in Ala., June 28, 1892; married [ca. 1919] Joseph Emerson Carter [born in Ga., ca. 1890; died 1933]. They resided in Birmingham, Jefferson Co., Ala.).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23168. Joseph Emerson Carter, Jr. (born in Ala., Oct. 28, 1921; married ___, and they had at least one child: Joseph Emerson Carter III [born ca. 1951]).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23169. Mary Hume Carter (born ibid., Nov. 1922).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23170. Mildred Alice Carter (born ibid., June 1924). [1930 census Jefferson Co., Ala., E.D. 1, p. 18B; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11262–35217]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12677. Olive Wride Rumph (twin; born in Ala., June 28, 1892; married [ca. 1924] James Sydney McGee [born ibid., ca. 1892; a veteran of WW I, he worked as a clerk in a grocery store]. They resided in Birmingham, Jefferson Co., Ala., 1930, and by 1940 in Eutaw, Greene Co., Ala. She died Aug. 1980).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23171. James Sydney McGee (born in Ala., ca. 1925; married Betty Banks).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23172. Virginia Louise McGee (born ibid., ca. 1929; married Frank Stabler, and they had at least two children). [1930 census Jefferson Co., Ala., E.D. 20, p. 98A; 1940 census Greene Co., Ala., E.D. 32–1, p. 22A; SSDI; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11262–35218]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12679. Dorothy Rumph (born in Ala., ca. 1900; married Benjamin F. Whittner [born in Fla., ca. 1896; a WW I veteran, he was later a “farmer—florist”]. They resided in Sanford, Seminole Co., Fla., 1930, and she died ca. 1950).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Child:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23173. Dorothy A. Whittner (born in Fla., ca. Feb. 1930). [1930 census Seminole Co., Fla., E.D. 3, p. 12B; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11262–35262]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12684. Eva Howard Seawell Fosque (born in Gloucester Co., Va., June 25, 1880; married ibid. Henry Lisk Carmine [born ibid., Nov. 6, 1872; died Dec. 2, 1949]. They farmed in Abingdon, Gloucester Co., Va. She died July 28, 1975, and both were buried at Providence Cemetery in Gloucester, Va.).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23174. John Harry Carmine (born in Gloucester Co., Va., Nov. 1, 1901; married Edith C. Lewis [born ca. 1905; died 1986]. He last resided in Port Haywood, Mathews Co., Va., and he died March 1986).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23175. Cecil Howard Carmine (born in Gloucester Co., Va., ca. 1905; a WW II Army veteran, he enlisted in Richmond, Va., Oct. 5, 1942. He last resided in Port Haywood, Mathews Co., Va., although his last Social Security benefit was sent to Gloucester Point, Gloucester Co., Va. He died in Mathews Co., Va., May 1980).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23176. Paul Thomas Carmine (born in Gloucester Co., Va., ca. 1908; married Nellie Balkus [born 1914; died 1968]. He died in New Haven, Conn., Nov. 13, 1956).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23177. Claude Irving Carmine (born in Gloucester Co., Va., Dec. 4, 1908; married [1958] Clarice Virginia Hogg [born Sept. 15, 1914; died Sept. 1982]. He last resided in Wicomico, Gloucester Co., Va., and he died Oct. 27, 1990).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23178. Lillian Mae Carmine.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23179. Annie Mildred Carmine.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23180. Mary Clements Carmine.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23181. Eva Estelle Carmine (born in Gloucester Co., Va., July 16, 1924; married [1951] William Nathan Prince [born 1910; died 1977]. She worked for the Veterans Administration, and she died in Jacksonville, Fla., March 14, 2007. They had three children: June Prince, Warren Prince, and Wayne Prince). ["), _c('a', {
    attrs: {
      "href": "http://FamSearch.org",
      "target": "_blank"
    }
  }, [_vm._v("FamSearch.org")]), _vm._v("/Va. Marriages; 1910 census Gloucester Co., Va., E.D. 45, p. 19B; 1920 census ibid., E.D. 52, p. 5A; 1930 census ibid., E.D. 1, p. 17B; WW II AER; obit. of Eva C. Prince in the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Florida Times-Union")]), _vm._v(", 3/17/2007; SSDI; “Descendants of Smith R. Carmine of Accomack Co., VA,” "), _c('a', {
    attrs: {
      "href": "http://http://hdhdata.org/roots/c4049.html",
      "target": "_blank"
    }
  }, [_vm._v("http://hdhdata.org/roots/c4049.html")]), _vm._v("; C. RILEE, “Desc. J. Perrin,” 9; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11263–22133, rev.]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12686. John Thomas Fosque, Jr. (born in Wicomico, Gloucester Co., Va., June 15, 1884; married Julia Lee Rilee. Self-employed, he and Julia resided in Wicomico, Va., when he registered for the draft ca. 1942. He last resided in Williamsburg, Va., and he died Jan. 3, 1969. He was buried at Providence Cemetery in Gloucester, Va.).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23182. Joan Fosque (married Bert Emmerson, and they had two children: Kimberley Emmerson and Bart Emmerson).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23183. Annette Fosque (married Mike Taylor, and they had one daughter: Hedi Taylor, who married ___ Gross). [WW II Draft Reg.; SSDI; "), _c('a', {
    attrs: {
      "href": "http://www.findagrave.com",
      "target": "_blank"
    }
  }, [_vm._v("www.findagrave.com")]), _vm._v("; "), _c('a', {
    attrs: {
      "href": "http://Gen.com",
      "target": "_blank"
    }
  }, [_vm._v("Gen.com")]), _vm._v("/WFT; C. RILEE, “Desc. J. Perrin,” 9–10; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11263–22133, rev.]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12691. John Henry Perrin Seawell, Jr. (born in Gloucester Co., Va., April 1889; a stove keeper for a railroad, he married ibid. [June 30, 1913] Geneva Sterling [born May 7, 1894; died Jan. 19, 1919]. He resided in Norfolk, Va., 1920).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Child:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23184. Alma Geneva Seawell. ["), _c('a', {
    attrs: {
      "href": "http://FamSearch.org",
      "target": "_blank"
    }
  }, [_vm._v("FamSearch.org")]), _vm._v("/Va. Marriages; 1900 census Gloucester Co., Va., E.D. 32, p. 19B; 1920 census Norfolk Co., Va., E.D. 257, p. 1B; C. RILEE, “Desc. J. Perrin,” 10; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11263–22142, rev.]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12704. Elsie Carrington Minor (born ca. 1900; married [1"), _c('sup', [_vm._v("st")]), _vm._v("] ___ Armstrong. She married [2"), _c('sup', [_vm._v("nd")]), _vm._v(", on June 30, 1921] Herman Douglas Buck [born Nov. 10, 1897; died June 23, 1926]).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Child (by her 2"), _c('sup', [_vm._v("nd")]), _vm._v(" husband):")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23185. John Seawell Buck. [C. RILEE, “Desc. J. Perrin,” 10; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11263–22276, rev.]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12706. Effie May Anderson (born in Mo., Feb. 18, 1871; married at St. Paul’s Church near Center, Ralls Co., Mo. [Feb. 19, 1890] Benjamin E. Roland [born in Mo., Oct. 15, 1867]. They resided with her parents in Center, Mo., 1900, where he was a laborer. She died July 16, 1903).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23186. Vera Evelyn Roland.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23187. James Raymond Roland.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23188. Percy Anderson Roland (born Aug. 28, 1895; died unm. in San Francisco, Cal., Jan. 15, 1951). [R. MUDD, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Mudd Fam")]), _vm._v("., 2:1506; 1900 census Ralls Co., Mo., E.D. 98, p. 15A; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11333–11121]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12709. Mary Chloe Anderson (born in Mo., ca. 1864; married in Laddonia, Audrain Co., Mo. [Jan. 11, 1897] William Thomas Reighley [born in Ky., April 1860; died in Ill., March 19, 1935, according to "), _c('a', {
    attrs: {
      "href": "http://Ancestry.com",
      "target": "_blank"
    }
  }, [_vm._v("Ancestry.com")]), _vm._v("/PMT]. They resided in Audrain Co., Mo., 1900, where he was a merchant. Mary’s younger sister Jenny lived with them. According to the 1910 census, Mary and William had two children, but only one was still living. Their entry is at the bottom of the page in the 1910 census, which is torn off just at that point. William’s wife is “_ary C.,” obviously “Mary C.”, and they have the one daughter listed below. I cannot locate this family in the 1920 census. According to "), _c('a', {
    attrs: {
      "href": "http://Ancestry.com",
      "target": "_blank"
    }
  }, [_vm._v("Ancestry.com")]), _vm._v("/PMT, both Mary and William were buried at Calvary Cemetery in Edwardsville, Madison Co., Ill.).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23189. Thomas Frazer Reighley (the name is supplied by D. Wood’s entry on "), _c('a', {
    attrs: {
      "href": "http://Ancestry.com",
      "target": "_blank"
    }
  }, [_vm._v("Ancestry.com")]), _vm._v("; Thomas died young "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ante")]), _vm._v(" 1900).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23190. __ey Anne Reighley (daughter; born in Mo., ca. 1901; D. Wood’s entry on "), _c('a', {
    attrs: {
      "href": "http://Ancestry.com",
      "target": "_blank"
    }
  }, [_vm._v("Ancestry.com")]), _vm._v(", which gives only her last name, states that she married Chester Francis Moore and that they had four children. The first name is only partially legible in the 1910 census). [Audrain Co., Mo. Marriage Bk. 4:28 (see "), _c('a', {
    attrs: {
      "href": "http://Anc.com",
      "target": "_blank"
    }
  }, [_vm._v("Anc.com")]), _vm._v("/Audrain Co., Mo. Marriages); 1910 census Audrain Co., Mo., E.D. 1, p. 2B; "), _c('a', {
    attrs: {
      "href": "http://Anc.com",
      "target": "_blank"
    }
  }, [_vm._v("Anc.com")]), _vm._v("/PMT, entry Cecil Nelson and AWT, entry by DW]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12714. Georgia E. Anderson (born Oct. 1874; “Eddy” in the 1880 census, she married Perlie Logene Beshears [born in Mo., Sept. 1878; died Jan. 20, 1901]. They resided in Cuivre, Audrain Co., Mo., 1900, where he was a furniture dealer. In spite of the discrepancies, she is presumably the “Georgia Beshears, age 32, born in Mo., widow,” who resided in Monroe Township, Monroe Co., Mo., 1910, with one child: Roger Beshears, age 10. That census confirms that she had had only one child and that child was living).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Child:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23191. George (Roger?) Beshears (born in Mo., Aug. 1899). [1900 census Audrain Co., Mo., E.D. 3, p. 9A; 1910 census Monroe Co., Mo., E.D. 126, p. 12B]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12715. John Lewis Anderson (born in Ralls Co., Mo., June 9, 1875; married in Audrain Co., Mo. [Aug. 7, 1902] Fannie Beulah Daniel [born in Vandalia, Audrain Co., Mo., Aug. 8, 1881]. They moved from Missouri to Louisiana ca. 1910, and by 1920 they resided in Jennings, Jefferson Davis Parish, La., where he was an “oil operator.” He died in Baton Rouge, East Baton Rouge Parish, La., Oct. 1941).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23192. John Lewis Anderson, Jr. (born in Mo., ca. 1904).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23193. Daniel Anderson (born ibid., ca. 1906).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23194. Fannie B. Anderson (born ibid., ca. 1908).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23195. Thomas Ned Anderson (born in La., ca. 1911; married Barbara Alimont Kenyon [born in La., ca. 1914]. They resided without children in Shreveport, Caddo Parish, La., 1940, where he was a field clerk for an oil company. They reportedly had two children later: Margaret Gay Anderson and Barbara Jean Anderson).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23196. Joseph Anderson (born in La., ca. 1914).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23197. Richard Anderson (born ibid., ca. Jan. 1919). [Audrain Co., Mo. Marriage Bk. 5:515 (see "), _c('a', {
    attrs: {
      "href": "http://Anc.com",
      "target": "_blank"
    }
  }, [_vm._v("Anc.com")]), _vm._v("/Audrain Co., Mo. Marriages, which gives the bride’s name as “Tiny Beulah Daniel”); 1920 census Jefferson Davis Parish, La., E.D. 75, p. 4A; 1940 census Caddo Parish, La., E.D. 9–68A, p. 8B (for Thomas and Barbara Anderson); "), _c('a', {
    attrs: {
      "href": "http://Anc.com",
      "target": "_blank"
    }
  }, [_vm._v("Anc.com")]), _vm._v("/OWT]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12719. Mary Ann “Mamie” Osbourne (born in Mo., July 11, 1881; married in Ralls Co., Mo. [Feb. 19, 1906] Elmer Homer Keithly [born in Mo., Jan. 6, 1884; died Dec. 16, 1937]. They resided in Center, Ralls Co., Mo., where he operated a dairy in 1920. They moved by 1930 to York, DuPage Co., Ill., where he was a “golf course laborer.” She died April 12, 1951, and both were buried at St. Peter’s Catholic Cemetery in Brush Creek, Mo.).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23198. Elmo N. Keithly (born in Mo., Nov. 3, 1908; last resided in Hull, Pike Co., Ill., and he died Nov. 11, 1998).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23199. Mary V. Keithly (born in Mo., ca. 1910).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23200. Edwin C. Keithly (born ibid., May 16, 1912; last resided in East Peoria, Tazewell Co., Ill., and he died Feb. 22, 2002).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23201. Josephine Keithly (born in Mo., ca. Sept. 1919). [1920 census Ralls Co., Mo., E.D. 150, p. 6A; 1930 census DuPage Co., Ill., E.D. 3, p. 3A; SSDI; "), _c('a', {
    attrs: {
      "href": "http://Anc.com",
      "target": "_blank"
    }
  }, [_vm._v("Anc.com")]), _vm._v("/AWT, entry by DW, which spells the name “Keithley”]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12730. Josephine Yeager (born in Mo., ca. 1872; married [Oct. 14, 1897] Frederick G. Walters [born in Ill., ca. 1873; graduated from Medico-Chirurgical College of Philadelphia, Pa. (M.D., 1898). He was licensed to practice medicine in Neb., 1902, and Tex., 1907]. They settled in Perry, Ralls Co., Mo.).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23202. Frederick Walters (born in Mo., Aug. 1898).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23203. Mary Harte Walters (born ibid., March 1900; DAR member #156665, she married ___ Mauk, and they had no children). ["), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Dir. Dec. Am. Phys.,")]), _vm._v(" 2:1620; 1900 census Ralls Co., Mo., E.D. 105, p. 6A; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11333–11412]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12732. Maude Muller Beshears (born in Vandalia, Audrain Co., Mo., Oct. 18, 1876; DAR member #141857, she married in Caldwell, Canyon Co., Ida. [Oct. 2, 1895] John Campbell Rice [born in Virginia, Cass Co., Ill., Jan. 27, 1864; graduated from Illinois College in Jacksonville, Ill., 1885. He taught in the public school at Chapin, Ill. (1885–1886) and then for one year as a mathematics instructor at his alma mater, Illinois College. He studied law at the U. of Mich., and then he entered the law school of Cornell U. After obtaining his LL.B. degree in 1890, he promptly headed west. A “big lantern-jawed man,” he soon settled in the frontier boom town of Caldwell, Canyon Co., Ida., where he became a prominent lawyer and built an elegant, turreted Queen Anne mansion with four porches.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("John maintained an office on the second floor of Frank Steunenberg’s Caldwell Banking and Trust Company Bank. John was a close business associate of Steunenberg, a former governor of Idaho whose murder in 1905 sparked the sensational trial of the Socialist politician-union activist William Haywood. The famous defense lawyer Clarence Darrow won an acquittal for Haywood. Elected to the Idaho state assembly in 1897, John served as chairman of the House Judiciary Committee. Retiring after one term, he was promptly elected as a member of the city council and then mayor [1902] of Caldwell, Ida. John later served as a justice of the Idaho State Supreme Court from 1916 to 1922, and he was a trustee of the College of Idaho at Caldwell. He died in Caldwell, Ida., March 7, 1937]. They resided in Caldwell, Ida., except for his years on the state’s Supreme Court, when their official residence was in Boise, Ada Co., Ida. Maude died in Caldwell, Ida., June 30, 1924).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23204. Elbert Gallatin Rice.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23205. Homer Beshears Rice.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23206. Martha B. Rice (born in Caldwell, Ida., July 30, 1899; died July 1963).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23207. Mary Lois Rice (born ibid., May 20, 1901; married in Boise, Ida. [June 13, 1917] John L. Heathcote, who served in the Navy. She died Aug. 1963).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23208. Josephine E. Rice (born in Caldwell, Ida., Jan. 20, 1906; married Doug Polivka [born in Ore., ca. 1912; he was a lawyer]. They resided without children in Boise, Ida., 1940, and she died in Multnomah Co., Ore., 1965). [Quotation from J. A. LUKAS, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Big Trouble")]), _vm._v(", 22 (see also "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("passim")]), _vm._v("). See also: Anon., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Hist. of Idaho, Gem of the Mountains")]), _vm._v(", 2:25–26; H. T. FRENCH, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Hist. of Idaho")]), _vm._v(", 2:695; "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("LB-DAR")]), _vm._v(", 142:271 (#141857); 1900 census Canyon Co., Ida., E.D. 135, p. 4A; 1920 census Ada Co., Ida., E.D. 17, p. 2A; 1940 census ibid., E.D. 1–1A, p. 1A (for Josephine and Doug Polivka); IdaMI; IdaDI; OreDI; "), _c('a', {
    attrs: {
      "href": "http://www.idahohistory.net",
      "target": "_blank"
    }
  }, [_vm._v("www.idahohistory.net")]), _vm._v("; "), _c('a', {
    attrs: {
      "href": "http://Anc.com",
      "target": "_blank"
    }
  }, [_vm._v("Anc.com")]), _vm._v("/PMT and AWT, entry by JN; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11333–11451]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12733. Lottie C. Barnett (married in Audrain Co., Mo. [Nov. 23, 1881] Clarence B. Jamison. Certainly Lottie and quite possibly her husband also were dead by 1900, when their sons were living with Lottie’s parents, Jesse and Dorothy Barnett, in Audrain Co., Mo. That same census entry’s for Lottie’s mother, Dorothy Barnett, confirms that both of Dorothy's two children had died by 1900).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23209. Ira C. C. Jamison (born in Mo., May 1885).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23210. James C. C. Jamison (born ibid., May 1888). [Audrain Co., Mo. Marriage Bk. 1:30 (see "), _c('a', {
    attrs: {
      "href": "http://Anc.com",
      "target": "_blank"
    }
  }, [_vm._v("Anc.com")]), _vm._v("/Audrain Co., Mo. Marriages); 1900 census Audrain Co., Mo., E.D. 3, p. 3A; "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("IGI")]), _vm._v(" v4.01; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11333–12211]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12736. Amelia Phillips (born in Mo., April 1869; married William (or “John W.”) Jamison [born in Ky., ca. 1863]. They resided in Joplin, Jasper Co., Mo., where he owned and operated a pharmacy).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23211. Howard C. Jamison (born in Mo., Aug. 1890).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23212. Glen T. Jamison. [1900 census Jasper Co., Mo., E.D. 69, p. 89A; 1920 census ibid., E.D. 54, p. 10A; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11333–12322]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12737. Mary Eva Phillips (born in Mo., ca. 1871; married in New London, Ralls Co., Mo. [June 13, 1889] Eugene Mayhall [born in Mo., April 29, 1858; he was a newspaper editor in Frederick, Tillman Co., Okla., and a printer in Oklahoma City, Oklahoma Co., Okla., 1910. He died in St. Louis, Mo., Aug. 24, 1919]. In the [Jan.] 1920 census, Mary was a widow living with her older sister Amelia [Phillips] Jamison in Joplin, Jasper Co., Mo. Mary died soon afterward in Joplin, Mo., March 9, 1920).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23213. Samuel Vernon Mayhall (born in Perry, Ralls Co., Mo., Aug. 22, 1890; unm. and working as a printer for a newspaper, he resided in El Paso, El Paso Co., Tex., when he registered for the draft on June 5, 1917).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23214. Champ Mayhall (born in Mo., ca. 1897).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23215. George Mayhall (born ibid., ca. 1900). [1910 census Oklahoma Co., Okla., E.D. 225, p. 11A; 1920 census Jasper Co., Mo., E.D. 54, p. 10A; WW I Draft Reg.; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11333–12323]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12742. Aida “Addie” Mae Evans (born in Vandalia, Audrain Co., Mo., Feb. 16, 1876; her birth year is given by both the 1880 and 1900 census as 1876, although her gravestone and "), _c('a', {
    attrs: {
      "href": "http://Ancestry.com",
      "target": "_blank"
    }
  }, [_vm._v("Ancestry.com")]), _vm._v("/PMT give the year as 1878. She married Ora Lamont Buckmaster [born in Moulton Appanoose Co., Iowa, June 1872; resided as a boarder in the household that included his future bride Addie in Kirksville, Adair Co., Mo., 1900. Addie and Ora resided with her widowed mother in St. Louis, Mo., 1910. He died in Orlando, Orange Co., Fla., 1942]. She died in St. Cloud, Osceola Co., Fla., Feb. 7, 1961).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Child:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23216. Roberta M. Buckmaster (born in St. Louis, Mo., 1908). [Audrain Co., Mo. Marriage Bk. B:159 (see "), _c('a', {
    attrs: {
      "href": "http://Anc.com",
      "target": "_blank"
    }
  }, [_vm._v("Anc.com")]), _vm._v("/Audrain Co., Mo. Marriages); 1880 census Audrain Co., Mo., E.D. 1, p. 30C; 1900 census Adair Co., Mo., E.D. 3, p. 4A; 1910 census St. Louis Co., Mo., E.D. 444, p. 3A; "), _c('a', {
    attrs: {
      "href": "http://www.findagrave.com",
      "target": "_blank"
    }
  }, [_vm._v("www.findagrave.com")]), _vm._v("; "), _c('a', {
    attrs: {
      "href": "http://Anc.com",
      "target": "_blank"
    }
  }, [_vm._v("Anc.com")]), _vm._v("/PMT; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11333–12332]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12751. Errol Amos Collins (born in Ogden, Weber Co., Ut., Nov. 26, 1896; a WW I veteran, he married [Oct. 1, 1919] Dorothy Elvira Shaw [born ibid., Dec. 27, 1896]. He sold bonds in Salt Lake City, Salt Lake Co., Ut., 1930. They later resided in Pocatello, Bannock Co., Ida., where he died July 16, 1968).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23217. Mary Alice Collins (born in Ut., June 7, 1920).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23218. Helen Mira Collins (born ibid., June 24, 1923). [M. SORLEY, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Lewis")]), _vm._v(", 147; F. VIRKUS, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("CAG")]), _vm._v(", 2:127–128; 1930 census Salt Lake Co., Ut., E.D. 74, p. 21A; "), _c('a', {
    attrs: {
      "href": "http://Anc.com",
      "target": "_blank"
    }
  }, [_vm._v("Anc.com")]), _vm._v("/AWT, entry by PS; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11333–12511]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12753. Bayliss R. Byrns (born in Mo., Sept. 10, 1885; in spite of his age, he listed himself as a “student” when he registered for the draft in Shawnee, Pottawatomie Co., Okla., Sept. 12, 1918. He listed as his next of kin “Mrs. T. [first name illegible] Gertrude Byrns,” who resided in Shawnee, Okla. Listed as a farmer in the 1910 census Tillman Co., Okla., Bayliss resided with his wife “Gertrude T.” and two children listed below, in Hazel Township. His wife was Gertrude Tryona Autry [born in Tex., Dec. 13, 1887; died in Broomfield, Boulder Co., Colo., Jan. 10, 1971]. He later reportedly became a Baptist minister and principal of the high school in Dale, Okla. Gertrude resided as a widow in Frederick, Tillman Co., Tex., 1930. Bayliss died Feb. 12, 1926, and both were buried at Frederick Memorial Cemetery in Frederick, Okla.).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23219. Orris M. Byrns (son; born in Okla., ca. 1908).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23220. Cecil A. Byrns (born ibid., ca. Sept. 1909).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23221. Ralph T. Byrns (born ibid., ca. 1911).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23222. Florence Leo Byrns (born in Springdale, Washington Co., Ark., Nov. 17, 1913; married Clifford Aaron Yarnell [born in Mason Co., Tex., Feb. 22, 1916; died in Grass Valley, Nevada Co., Cal., Dec. 15, 2003]. He worked as a bell hop at a hotel in San Angelo, Tom Green Co., Tex., 1940. She died in Grass Valley, Cal., July 21, 2003. Both were buried at Frederick Memorial Cemetery in Frederick, Okla. They had two children: Neil Yarnell [born in Tex., ca. 1933] and Clifford Aaron Yarnell, Jr. [born in Tom Green Co., Tex., Sept. 19, 1939]).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23223. Floyd J. Byrns (born in Okla., ca. 1919).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23224. Mary E. Byrns (born ibid., ca. 1924). [1900 census Audrain Co., Mo., E.D. 9, p. 7B; 1910 census Tillman Co., Okla., E.D. 250, p. 14A; 1930 census ibid., E.D. 5, p. 10B; 1940 census Tom Green Co., Tex., E.D. 226–9, p. 4B; WW I Draft Reg.; TexBI; SSDI; "), _c('a', {
    attrs: {
      "href": "http://www.findagrave.com",
      "target": "_blank"
    }
  }, [_vm._v("www.findagrave.com")]), _vm._v(" (with annotations)]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12757. Lemuel Peyton Spotswood (born in Perry, Ralls Co., Mo., March 2, 1889; a carpenter, he married in Audrain Co., Mo. [Dec. 20, 1914] Hazel Irenelda Mayes [born in Mo., Aug. 1, 1892; died in St. Charles, St. Charles Co., Mo., Aug. 27, 1992]. They resided in Salt River Township, Audrain Co., Mo., 1920, but moved by 1930 to St. Ferdinand Township, St. Louis Co., Mo. Lemuel died in Berkeley, St. Louis Co., Mo., Jan. 23, 1959).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23225. Leland E. Spotswood (born in Mo., Oct. 17, 1915; resided in St. Charles, St. Louis Co., Mo., and he died Nov. 27, 1995).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23226. Merle Spotswood (born in Mo., ca. 1919).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23227. Aaron E. Spotswood (born ibid., May 26, 1921; resided in St. Louis, Mo., and he died Sept. 7, 1994).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23228. Stanley L. Spotswood (born in Mo., ca. July 1927).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23229. David Timothy Spotswood. [1920 census Audrain Co., Mo., E.D. 15, p. 2A; 1930 census St. Louis Co., Mo., E.D. 138, p. 12A; Audrain Co., Mo., Marriage Bk. 9:305 ("), _c('a', {
    attrs: {
      "href": "http://Anc.com",
      "target": "_blank"
    }
  }, [_vm._v("Anc.com")]), _vm._v("/Audrain Co., Mo., Marriages); SSDI; "), _c('a', {
    attrs: {
      "href": "http://Gen.com",
      "target": "_blank"
    }
  }, [_vm._v("Gen.com")]), _vm._v("/WFT; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11333–12x41, rev.]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12759. Ruby Wilmoth Spotswood (born in Mo., ca. 1892; married in Audrain Co., Mo. [Dec. 5, 1912] Roy Sims [born in Mo., ca. 1892]. They resided in Audrain Co., Mo., where he was a farmer in 1920 and a laborer in a brick plant in 1930. Note that in her slot within this family, the 1900 census gives “Elisabeth Spotswood, born in Mo., Feb. 1893”).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Child:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23230. Bessie P. Sims (born in Mo., ca. 1921). [Audrain Co., Mo., Marriage Bk. 9, p. 98 (see "), _c('a', {
    attrs: {
      "href": "http://Anc.com",
      "target": "_blank"
    }
  }, [_vm._v("Anc.com")]), _vm._v("/Audrain Co., Mo., Marriages); 1900 census Montgomery Co., Kans., E.D. 128, p. 23A; 1920 census Audrain Co., Mo., E.D. 20, p. 5A; 1930 census ibid., E.D. 19, p. 10B; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11333–12x41]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12760. George Thornton Spotswood (born in Mo., Oct. 1894; a farmer, he married Florence ___ [born in Mo., ca. 1901]. They resided in Salt River Township, Audrain Co., Mo., 1930, and he died in Audrain Co., Mo., July 1978).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23231. Glen Spotswood (born in Mo., ca. 1923).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23232. Lloyd Spotswood (born ibid., ca. 1926).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23233. Lenore Spotswood (born ibid., ca. Jan. 1930). [1900 census Montgomery Co., Kans., E.D. 128, p. 23A; 1930 census Audrain Co., Mo., E.D. 19, p. 3B; SSDI; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11333–12x44]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12765. Luther Seibert Spotswood (born in Mo., July 2, 1897; served as PFC, Quartermaster Corps, in WW I. He married Adelaide [or “Opal I,” according to the census] ___ [born in Iowa, ca. 1910]. They resided in Denver, Colo., 1940, where he was apparently unemployed and she was a punch key operator for the state Highway Planning Commission. He died at a Veterans Hospital in Illinois, Nov. 25, 1957. He was buried at Elmwood Cemetery in Mexico, Audrain Co., Mo., on Nov. 29, 1957. They had two additional children, a twin boy and girl, who died "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ante")]), _vm._v(" 1958).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children (partial list):")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23234. Charles H. Spotswood (born in Mo., ca. 1923).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23235. Betty E. Spotswood (born ibid., ca. 1925). [1940 census Denver Co., Colo., E.D. 16–222, p. 4B; "), _c('a', {
    attrs: {
      "href": "http://www.findagrave.com",
      "target": "_blank"
    }
  }, [_vm._v("www.findagrave.com")]), _vm._v("; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11333–12x51]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12766. Lillian Spotswood (according to J.A.W., she was born Dec. 1899, married Wade Adams, and they resided in Hammond, Lake Co., Ind. She is obviously “Lillian M. [born in Mo., age 30, and both parents born in Mo.]” in the 1930 census taken April 3, 1930, married to Elmer W. Adams [born in Tex., ca. 1897; a WW I veteran, he was working as a chemist for an oil refinery in Hammond, Ind., 1930. As “Elmer Wade Adams, born Oct. 7, 1897” he registered for the draft in Macomb, McDonough Co., Ill., Sept. 12, 1918]).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23236. Elmer Wade Adams, Jr. (born in Ill., ca. May 1925).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23237. Phyllis J. Adams (born ibid., ca. May 1929). [WW I Draft Reg.; 1930 census Lake Co., Ind., E.D. 138, p. 2A; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11333–12b52, rev.]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12768. William W. Spotswood (married ___, and they resided in Maywood, Cook Co., Ill., according to J.A.W. He is presumably the man so named in the 1930 Illinois census, born in Mo., age 28, married to Fern V. [born in Ill., age 23], working as a retail salesman in Chicago).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Child:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23238. W. J. Spotswood (a minister, he was pastor of First Christian Church in Cameron, Clinton Co., Mo. He married ___ [last name possibly “Love”], and they had two children: Mary Jo Spotswood and Randy Spotswood). [1930 census Cook Co., Ill., E.D. 967, p. 6A; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11333–12x54]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12772. Maggie Dorgan (born in Mo., Aug. 1892; married in Audrain Co., Mo. [March 22, 1916] Alfred Sanford Wilson [born in Mo., ca. 1884]. They farmed in Mexico, Audrain Co., Mo., and she died ca. 1943/1948).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23239. Julia Frances Wilson.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23240. Mable A. Wilson (born in Mo., ca. 1920).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23241. Naomi R. Wilson (born ibid., ca. 1923).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23242. Rosie M. Wilson (born ibid., ca. Oct. 1926). [1900 census Audrain Co., Mo., E.D. 9, p. 6A; 1930 census ibid., E.D. 15, pp. 11B-12A; Audrain Co., Mo. Marriage Bk. 9:434 (see "), _c('a', {
    attrs: {
      "href": "http://Anc.com",
      "target": "_blank"
    }
  }, [_vm._v("Anc.com")]), _vm._v("/Audrain Co., Mo. Marriages); J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11333–12b61]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12773. Mabel Dorgan (born in Mo., ca. 1900; married Harrison Martin [born ibid., ca. 1900]. They resided on a farm near Mexico, Audrain Co., Mo.).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23243. Harrison Martin, Jr. (born in Mo., ca. 1924).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23244. Becky Mae Martin (born ibid., ca. 1926).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23245. J. W. Martin (son; born ibid., ca. 1928). [1930 census Audrain Co., Mo., E.D. 14, p. 15B; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11333–12x62]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12774. Virgil Franklin Dorgan (born in Mo., May 11, 1903; married [1"), _c('sup', [_vm._v("st")]), _vm._v("] Ruby Brandenburg [born in Mo., ca. 1905]. They resided in Livermore, Alameda Co., Cal., 1930, where he worked as a hospital attendant. He died in Fresno Co., Cal., Jan. 25, 1990. The preceding data comes from J.A.W., the 1930 census, and the California Death Index. He is clearly the “Virgil Dorgan, born in Mo., age 36, occupation bartender, liquor store” who resided in Fresno, Fresno Co., Cal., in the 1940 census, taken April 12, 1940. In that census, however, he was married to “Roxie ___, born in Cal., age 33.” Her maiden name was Maloyan. The 1940 census indicates that in 1935 Virgil was living in Alameda Co., Cal.).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Child (by his 1"), _c('sup', [_vm._v("st")]), _vm._v(" wife):")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23246-a. Betty Jane Dorgan (born in Alameda Co., Cal., March 9, 1930).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children (by his 2"), _c('sup', [_vm._v("nd")]), _vm._v(" wife):")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23246-b. James Floyd Dorgan (born in Alameda Co., Cal., June 5, 1935).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23246-c. Madeline May Dorgan (born in Fresno, Cal., Oct. 18, 1936). [1930 census Alameda Co., Cal., E.D. 258, p. 8A; 1940 census Fresno Co., Cal., E.D. 10–52, p. 5B; CalBI (the source for the maiden names of the children’s mothers); CalDI; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11333–12b63]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12775. Margaret Elizabeth Spotswood (born in Mo., June 1, 1899; married [1"), _c('sup', [_vm._v("st")]), _vm._v("] Melvin P. Weigel [born in Mo., ca. 1902; he was an engineer]. They resided in St. Louis, Mo., 1930. Later divorced, she married [2"), _c('sup', [_vm._v("nd")]), _vm._v("] Fred Kassab. She later resided in Springfield Gardens, Long Island, N.Y.).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Child (by her 1"), _c('sup', [_vm._v("st")]), _vm._v(" husband):")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23247. Virginia Mary Alice Weigel (born Nov. 25, 1938). [1930 census St. Louis Co., Mo., E.D. 61, p. 16B; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11333–12x71]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12783. Alexander Spotswood Goodall (born in Hopkinsville, Christian Co., Ky., Sept. 2, 1861; orphaned at the age of thirteen, he found his stepfather harsh and unloving. In his early teens, he was raised along with his younger brother Charles by their grandmother Mildred [Jouett] Goodall in Hopkinsville, Ky. At the age of seventeen, he headed to Indiana to make a living as a farm laborer. By 1880 he was working on the farm of a widow, Mrs. Barbara Debes, in Marrs Township, Posey Co., Ind. In 1883–1884. He briefly attended a Presbyterian preparatory school in Parksville, near Kansas City, Mo. He soon returned to farming, however, and he married in Mount Vernon, Posey Co., Ind. [July 14, 1887] Eudora Lewis [born in Mount Vernon, Ind., Jan. 1863; died in Mount Vernon, Ind., 1944]. By 1910 they resided in Arkadelphia, Clark Co., Ark. He died in Mount Vernon, Ind., 1942).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23248. Sudie Goodall (born April 1889).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23249. Jeannette Goodall.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23250. Lela May Goodall.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23251. Jouett James Goodall.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23252. Lowell Evert Goodall (born in Ark., May 6, 1902; married [Aug. 18, 1931] Edith Marie Fisher. They resided in Rockport, Spencer Co., Ind., where he died Sept. 27, 1995).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23253. Harry Dean Goodall. [1880 census Posey Co., Ind., E.D. 94, p. 46A; 1910 census Clark Co., Ark., E.D. 51, p. 2A; IndMI; SSDI; M. D. FROST, “Goodall Fam. Hist.,” esp. pp. 60–76; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11333–13112, rev.]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12784. Charles Jouett Goodall (born in Christian Co., Ky., ca. June/July 1862, although another tradition gives “March 1863”; after his mother’s death in Feb. 1875, young Charles lived for a few years with his grandmother Mildred [Jouett] Goodall in Hopkinsville, Christian Co., Ky. He left home at an early age and became a traveling salesman. Later, feeling that he had been cheated out of a joint inheritance by his older brother Alexander, he became completely estranged from him.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("His commercial travels took Charles through Kansas City, Mo., where he stayed at a boarding house in the Quality Hill District on the southern shore of the Missouri River. The co-owner of the boarding house had a sister working there as a maid. Quite smitten by the handsome boarder, the maid confided to her sister, “I’m going to marry that man.” And so she did: Charles married in Kansas City, Jackson Co., Mo. [May 20, 1893] Margaret Ann Krohn [born in Boone Co., Ky., Feb. 14, 1872; left a widow by her husband’s premature death, she later re-married twice, surviving both of these later husbands. She died in Polk Township, Cass Co., Mo., Aug. 4, 1966].")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("In the years immediately after their marriage, they had two sons, and then in the early spring of 1899 the young family joined Margaret’s youngest sister, Emily, and her husband on an adventure. They set out on Emily’s houseboat, floating ca. 300 miles down the Missouri River from Kansas City to St. Louis. Along the way Charles fell ill with typhoid fever, perhaps from contaminated drinking water. His condition worsened, and, after pneumonia developed, he died on the houseboat near St. Louis, Mo., March 10, 1899. His young widow took him ashore and had him buried in a now forgotten cemetery that overlooked the great river).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23254. Harry Edward Goodall.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23255. Charles Krohn Goodall. [1910 census Cook Co., Ill., E.D. 957, p. 13B; M. D. FROST, “Goodall Fam. Hist.,” 50; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11333–13113, rev.]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12786. Nanine Ormsby Hardin (born in Louisville, Jefferson Co., Ky., Oct. 19, 1883; married ibid. [Nov. 16, 1904] Abram Huston Fairleigh [born in Brandenburg, Meade Co., Ky., Oct. 27, 1883; graduated from Kentucky Military Institute. He served in France during WW I as 1"), _c('sup', [_vm._v("st")]), _vm._v(" Lt., 326"), _c('sup', [_vm._v("th")]), _vm._v(" Field Artillery, USA. He was later an executive in a construction business, and he died in Louisville, Ky., Sept. 28 or 29, 1937]. She died in Louisville, Ky., Sept. 13, 1955).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23256. Helen Spotswood Fairleigh.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23257. Emma Graham Fairleigh. [1920 Jefferson Co., Ky., E.D. 81, p. 15B, where the on-line census index misreads the husband’s name as “A. Hucter Farleigh”; KyMI; KyDI; NSWFD #36 (Helen Fairleigh); FGS by MRD; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11333–13241]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12789. Blanche Goodall (born in Nashville, Tenn., May 23, 1872; married in Davidson Co., Tenn. [March 12, 1906] Alfred Blackman Battle [born in Rutherford Co., Tenn., Sept. 2, 1868; died in Nashville, Tenn., Dec. 8, 1943]. They resided in Nashville, Tenn., where he worked as a furniture salesman in 1930. She died ibid., Sept. 4, 1951).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23258. Anna Elizabeth Battle (born in Tenn., Dec. 25, 1906; a public school teacher and a member of CDA, she resided unm. with her parents in Nashville, Tenn., 1930).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23259. Alfred Blackman Battle, Jr. (born May 15, 1909; died Jan. 17, 1910). ["), _c('a', {
    attrs: {
      "href": "http://FamSearch.org",
      "target": "_blank"
    }
  }, [_vm._v("FamSearch.org")]), _vm._v("/Tenn. Marriages; 1930 census Davidson Co., Tenn., E.D. 66, p. 12A; "), _c('a', {
    attrs: {
      "href": "http://Anc.com",
      "target": "_blank"
    }
  }, [_vm._v("Anc.com")]), _vm._v("/PMT; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11333–13311]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12791. Anna Jerellien Goodall (born in Tenn., April 21, 1877; raised in Nashville, Tenn., she married in Davidson Co., Tenn. [June 18, 1902] Horace Jennings Bowers [born in Tenn., Oct. 26, 1873; died 1952]. They resided in Tracy City, Grundy Co., Tenn., where he worked as a cashier in a bank. She died in Cleveland, Bradley Co., Tenn., March 10, 1962).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23260. Frances Jerellien Bowers.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23261. Robert Madison Bowers. ["), _c('a', {
    attrs: {
      "href": "http://FamSearch.org",
      "target": "_blank"
    }
  }, [_vm._v("FamSearch.org")]), _vm._v("/Tenn. Marriages; WW I Draft Reg.; 1920 census Grundy Co., Tenn., E.D. 41, p. 9B; obit. of Anna Goodall Bowers in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Pulaski (Tenn.) Citizen")]), _vm._v(", 3/14/1962; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11333–13313]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12792. Jessie Williams Goodall (born in Tenn., Feb. 19, 1879; married [March 14, 1906] James Ethelbert Houk [born in Ky., Nov. 1, 1875; a merchant in Nashville, Tenn., he died May 17, 1929]).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23262. Robert Leroy Houk.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23263. James Goodall Houk (born in Ind., May 31, 1914; a WW II veteran, he enlisted in Richmond, Va., May 6, 1941. He married Ann Russell McClearen [born in Tenn., Dec. 31, 1918; an administrator for American Airlines, she died Nov. 7, 2005]. He resided in Nashville, Tenn., and he died Jan. 29, 1989. Both were buried at Bethel Cemetery in Hickman Co., Tenn. They had two children: Ann Houk [married ___ Bain] and James G. Houk, Jr.). [WW I Draft Reg. (for James E. Houk); 1920 census Davidson Co., Tenn., E.D. 87, p. 7A; WW II AER; SSDI; "), _c('a', {
    attrs: {
      "href": "http://www.findagrave.com",
      "target": "_blank"
    }
  }, [_vm._v("www.findagrave.com")]), _vm._v(" (with obit. of Ann R. M. Houk); J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11333–13314]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12801. John Allen King (born in Tenn., April 19, 1882; married [Dec. 26, 1916] Dorothy Whitcomb [born in Mass., ca. 1891]. They resided in Forest Hills, Queens, New York, N.Y., where he was a dress manufacturer. Their household in 1920 also included Dorothy’s mother, “Marje Witcomb” [sic]. John died April 15, 1932).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23264. John Allen King, Jr.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23265. Virginia Spottswood King (born March 11, 1920). [1920 census Queens, N.Y., E.D. 443, p. 10A; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11333–13333]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12802. Robert Montgomery Goodall, Jr. (born in Tenn., Oct. 28, 1895; resided in Birmingham, Jefferson Co., Ala., unm. and working as a salesman for “Goodall-Brown Dry Goods Company” when he registered for the draft on June 5, 1917. Listed as a WW I veteran in the 1930 census, he is obviously “2"), _c('sup', [_vm._v("nd")]), _vm._v(" Lt. Robert M. Goodall, USA; hometown: Birmingham, Ala.,” who served in the 321"), _c('sup', [_vm._v("st")]), _vm._v(" Machine-Gun Battalion, 82"), _c('sup', [_vm._v("nd")]), _vm._v(" Division in the AEF during WW I and whose decorations included the Distinguished Service Cross. According to the accompanying citation,")]), _vm._v(" "), _c('div', {
    staticClass: "extract"
  }, [_c('p', {
    staticClass: "extractNoIndent"
  }, [_vm._v("The Distinguished Service Cross is presented to Robert M. Goodall, Second Lieutenant, U.S. Army, for extraordinary heroism in action at Belair Farm, near Pont-a-Mousson, France, Sept. 12, 1918. When our forces were attacked on the right flank at Belair Farm, Lieutenant Goodall defended this flank alone with his pistol, preventing the enemy from coming upon the trenches until the infantry could form to resist the attack. Throughout a very trying and critical time this officer displayed utter disregard of personal danger, and by his remarkable personal bravery inspired confidence among his own men and cooperating troops [General Orders No. 13, W.D., 1919].")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("After the war he resided unm. with his mother in Birmingham, Ala., 1920. There he later married [Oct. 28, 1924] Virginia J. [born in Ala., ca. 1902]. They resided in Birmingham, Ala., where he owned and operated a sporting goods store).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23266. Virginia J. Goodall (born in Ala., ca. Sept. 1925).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23267. Louise W. Goodall (born ibid., ca. June 1927). [Quotation from "), _c('a', {
    attrs: {
      "href": "http://http://www.homeofheroes.com/valor/1_Citations01_wwi_dsc_05wwi_Army_FG.html",
      "target": "_blank"
    }
  }, [_vm._v("http://www.homeofheroes.com/valor/1_Citations01_wwi_dsc_05wwi_Army_FG.html")]), _vm._v(". See also: "), _c('a', {
    attrs: {
      "href": "http://FamSearch.org",
      "target": "_blank"
    }
  }, [_vm._v("FamSearch.org")]), _vm._v("/Ala. Marriages; WW I Draft Reg.; 1920 census Jefferson Co., Ala., E.D. 88, pp. 24B-25A; 1930 census ibid., E.D. 169, p. 12A]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12803. Gillian Goodall (born in Tenn., Jan. 4, 1897; she is oddly listed as “Gabrella Goodall” in the 1900 census, although in the 1920 census she is clearly “Gillian,” residing unm. with her widowed mother and her brothers Robert M. and Yancey. She married in Birmingham, Jefferson Co., Ala. [June 9, 1921] Hugh Moss Comer, Jr. [born in Birmingham, Ala., June 9, 1892; graduated from the U. of Ala. (B.S., 1914; LL.D.). He served in WW I as 1"), _c('sup', [_vm._v("st")]), _vm._v(" Lt., 82"), _c('sup', [_vm._v("nd")]), _vm._v(" Division, USA. In a long career with the major cotton manufacturer Avondale Mills, he rose to the posts of president and chairman of the board and served on the board of directors of several banks and other companies. He was also national vice-president of the National Association of Manufacturers. He died Sept. 18, 1962]. They maintained homes in Sylacauga and Birmingham, Ala., and she died Feb. 1983).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23268. Susan Gabriella “Gay” Comer.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23269. Gillian Elizabeth Comer (born April 27, 1924; married Dr. Robert Hoyt Yoe. They had three children: Robert Hoyt Yoe III, Hugh Comer Yoe, and John Yoe). ["), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Who Was Who Am")]), _vm._v("., vol. 4; "), _c('a', {
    attrs: {
      "href": "http://FamSearch.org",
      "target": "_blank"
    }
  }, [_vm._v("FamSearch.org")]), _vm._v("/Ala. Marriages; SSDI; FGS by GWGoodrich; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11333–13351]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12805. Jennie Campbell (born in Chattanooga, Hamilton Co., Tenn., Oct. 28, 1877; DAR member #48178, she married ibid. [May 19, 1898] Charles Leonard Hall [born in Tenn., June 20, 1875 or 1876]. They resided in Chattanooga, Tenn., 1900 and 1910, where he worked as a hardware merchant. In 1920 they resided in Mission Ridge near Chattanooga in Hamilton Co., Tenn., where he was a salesman).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23270. Charles Leonard Hall, Jr.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23271. Robert Hall (born in Tenn., ca. 1907). [1900 census Hamilton Co., Tenn., E.D. 55, p. 7B; 1910 census ibid., E.D. 87, p. 19A; 1920 census ibid., E.D. 208, p. 4B; FGS by WSC, who lists only one child, Charles L. Hall, Jr.]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12808. William Lewis Campbell (born in Chattanooga, Hamilton Co., Tenn., Oct. 15, 1890; married [1"), _c('sup', [_vm._v("st")]), _vm._v("] Lula Brown. He married ibid. [2"), _c('sup', [_vm._v("nd")]), _vm._v(", on March 8, 1923] Fay Elizabeth Raulston [born ibid., March 2, 1894; died in Los Angeles, Cal., Dec. 9, 1988]. Soon after their marriage, they moved to Los Angeles, Cal., where he worked as an architect. During WW II he used his professional skills as a civilian employee for the USN. He died in Los Angeles, Cal., Dec. 9, 1988, and he was buried in Glendale, Los Angeles Co., Cal.).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children (by his 2"), _c('sup', [_vm._v("nd")]), _vm._v(" wife):")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23272. William Lewis Campbell, Jr.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23273. Mary Adeline Campbell. [1930 census Los Angeles Co., Cal., E.D. 108, p. 16A; FGS by WSC]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12811. Elizabeth Williams Goodall (born in Nashville, Tenn., Dec. 25, 1894; DAR member #102738, she married Robert Lee Pillow, Jr. She resided as a widow in Galveston, Galveston Co., Tex., 1930, where she later died Feb. 15, 1972).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Child:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23274. Roberta Elizabeth Lee Pillow (born in Tenn., Jan. 21, 1914; resided in Galveston, Tex.). [M. SORLEY, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Lewis")]), _vm._v(", 145–146; "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("LB-DAR")]), _vm._v(", 103:227 (#102738); 1930 census Galveston Co., Tex., E.D. 35, p. 1A; SSDI; "), _c('a', {
    attrs: {
      "href": "http://FamSearch.org",
      "target": "_blank"
    }
  }, [_vm._v("FamSearch.org")]), _vm._v("/Tex. Deaths; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11333–13373]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12818. Louise/Louisa Maria Hider (born in Ky., Aug. 28, 1876; married in Greenville, Washington Co., Miss. [Oct. 6, 1903] Arthur Morson Shepherd [born Nov. 26, 1872; struck by lightning and died July 20, 1913]. They farmed in Wilkinson Co., Miss., 1910, and she died March 29, 1948).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23275. Richard Butler Hooke Shepherd (born in Miss., Feb. 10, 1905).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23276. Emma Hider Shepherd.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23277. Kate Berry Shepherd (born June 26, 1910). [1910 census Wilkinson Co., Miss., E.D. 116, p. 1A; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11333–13711]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12822. George Turner Hider (born in Louisville, Jefferson Co., Ky., Oct. 13, 1886; served as Pvt., USA, in WW I, and he later owned a cotton gin. He married [1934] Virginia Cecelia Benjamin [born in La., Dec. 5, 1907; resided in Lake Providence, East Carroll Parish, La., where she died April 29, 2000]. They resided in Lake Providence, La., where he died Oct. 3 or 10, 1978).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23278. Virginia Hider (born in Miss., Nov. 4, 1935).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23279. George Ann Hider (born ibid., Dec. 13, 1938). [WW I Draft Reg.; 1940 census East Carroll Parish, La., E.D. 18–6, p. 9B; USPRI; SSDI; "), _c('a', {
    attrs: {
      "href": "http://www.findagrave.com",
      "target": "_blank"
    }
  }, [_vm._v("www.findagrave.com")]), _vm._v("; "), _c('a', {
    attrs: {
      "href": "http://Anc.com",
      "target": "_blank"
    }
  }, [_vm._v("Anc.com")]), _vm._v("/PMT; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11333–13715]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12823. George Turner Anderson, Jr. (born in Ark., July 13, 1891; a WW I veteran and merchant, he married [June 27, 1920] Hattie Law [born in Mo., April 10, 1884]. They resided without children in 1930 with her brother, William J. Law, in Marston, New Madrid Co., Mo. They resided at one time in Cape Girardeau, Cape Girardeau Co., Mo., and he died March 24, 1952).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Child:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23280. Margaret Edna Anderson. [1930 census New Madrid Co., Mo., E.D. 12, p. 2A; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11333–13721]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12824. Edna Anderson (born in Miss., July 5, 1892; married [March 1913] William Heard. They resided in Greenville, Washington Co., Miss., and she died Jan. 18, 1918).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Child:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23281. William C. Heard. [J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11333–13722]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12826. Edgar Courtnay Bird, Jr. (born in Louisville, Jefferson Co., Ky., Aug. 25, 1892; a WW I veteran, he married in New York, N.Y. [Oct. 29, 1919] Olive Sophia Upton-Davis Bates [born in Brooklyn, N.Y., July 4, 1893; died in Old Saybrook, Middlesex Co., Conn., Aug. 3, 1979]. A buyer for a business firm, he resided in Lynbrook, Nassau Co., N.Y., in 1930. He died in Deland, Volusia Co., Fla., Feb. 10, 1956).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23282. Mary Elizabeth Bird.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23283. Jane Bird. [1930 census Nassau Co., N.Y., E.D. 58, p. 17B; FGS by NAD]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12829. Walter Scott Miller (born in Ky., Nov. 11, 1870; married [June 9, 1910] Rose English [born ibid., Feb. 5, 1879]. They resided in Louisville, Jefferson Co., Ky., 1920, where he was a manager of an insurance company. He died May 29, 1938).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23284. Walter Scott Miller, Jr.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23285. Peter Galt Miller (born in Ky., Aug. 4, 1914). [1920 census Jefferson Co., Ky., E.D. 81, p. 8A; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11333–14213]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12830. Florence Miller (born in Ky., Aug. 22, 1872; married in Louisville, Jefferson Co., Ky. [July 17, 1912] William Black [born in N.J., Sept. 3, 1876; died April 19, 1930]. They resided in Louisville, Ky., 1930, where he was president of a plow factory).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23286. Florence Miller Black (born in Ky., July 23, 1913).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23287. William Black. ["), _c('a', {
    attrs: {
      "href": "http://FamSearch.org",
      "target": "_blank"
    }
  }, [_vm._v("FamSearch.org")]), _vm._v("/Ky. Marriages; 1930 census Jefferson Co., Ky., E.D. 21, p. 16A; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11333–14214]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12832. Harry Elmer Dodge (born in Ky., Jan. 3, 1876; married [April 30, 1915] Margaret Ellen Petty [born in Washington, D.C., Sept. 25, 1878]. They resided in Washington, D.C., 1920, and he died in Takoma Park, Montgomery Co., Md., June 20, 1944).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Child:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23288. Harry Petty Dodge. [1920 census Washington, D.C., E.D. 354, p. 3A; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11333–14221]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12833. Cora Dodge (born in Ky., May 25, 1879; married in Jeffersonville, Clark Co., Ind. [Oct. 12 or 15, 1903] George Beauford Reeves [born in Ind., Aug. 25, 1866; died June 11, 1929]. They resided in Louisville, Jefferson Co., Ky., 1920, where he worked as an auditor for a railroad. In spite of the age discrepancy, she is perhaps the Kentucky Death Index’s “Cora E. Reeves, died in Jefferson Co., Ky., Nov. 13, 1965, age 89”).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23289. Martha Middleton Reeves.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23290. Virginia Dodge Reeves.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23291. George Beauford Reeves (born in Ky., Dec. 10, 1919; in spite of the slight discrepancy, he is presumably the SSDI’s “George B. Reeves, born Dec. "), _c('span', {
    staticClass: "underline"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("2")])]), _vm._v("0, 1919; last resided in Louisville, Ky., and died Dec. 24, 1994”). ["), _c('a', {
    attrs: {
      "href": "http://FamSearch.org",
      "target": "_blank"
    }
  }, [_vm._v("FamSearch.org")]), _vm._v("/Ind. Marriages; 1920 census Jefferson Co., Ky., E.D. 81, p. 8A; KyDI; SSDI; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11333–14222]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12836. Ada Stratton (born in Ky., Oct. 12, 1877; married [Aug. 17, 1900] Ben Heistand Wilson [born in Ky., Sept. 19, 1873; resided at one time in Rushville, Rush Co., Ind., according to J.A.W.]. They resided in Louisville, Jefferson Co., Ky., 1910, where he was a real estate salesman. She died Feb. 22, 1918, and two of their three children died at birth).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Child (surviving):")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23292. Ruth Wilson. [1910 census Jefferson Co., Ky., E.D. 119, p. 4A; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11333–14241]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12837. Mary E. Dodge (born in Tenn., May 1867; married in Kansas City, Clay Co., Mo. [Feb. 23, 1888] William Hubbard Hodges [born in Winchester, Franklin Co., Tenn., May 22, 1866; died in Kansas City, Clay Co., Mo., Jan. 25, 1923]. They resided in Kansas City, Jackson Co., Mo., where he was a bookkeeper for a packing company. Also living with them was Mary’s mother “Louvicia Anderson,” born in Tenn., July 1847).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23293. Clarence Gray Hodges.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23294. Louisa E. Hodges (born in Tenn., Jan. 1891).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23295. Carl K. Hodges (born ibid., Dec. 1892).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23296. Lois G. Hodges (born ibid., Jan. 1894).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23297. C. Hal Hodges (born in Mo., Nov. 29, 1897; resided in Kansas City, Mo., working as a purchasing agent for the Swift Packing Company, when he registered for the draft on Sept. 12, 1918). [1900 census Jackson Co., Mo., E.D. 123, pp. 16B-17A; 1920 census ibid., E.D. 60, p. 14A; WW I Draft Reg.; "), _c('a', {
    attrs: {
      "href": "http://Anc.com",
      "target": "_blank"
    }
  }, [_vm._v("Anc.com")]), _vm._v("/PMT; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11333–1432]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12840. Elizabeth Spotswood Dodge (born in Bolivar Co., Miss., July 16, 1897; graduated from Cincinnati Conservatory of Music. A member of DAR, she married [Feb. 16, 1918] Stuart Harrison Ralph [born in Oil City, Venango Co., Pa., March 27, 1893; attended Boston U. He worked as eastern manager, later general sales manager, then vice-president, and eventually director of The Flintkote Company in Boston, Mass. He was also president and director of the Insulation Board Institute, as well as president and director of the Insulating Siding Association. He died Sept. 6, 1956]. They resided in Westport, Fairfield Co., Conn., and she died Sept. 1975).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23298. Elizabeth Spotswood Dodge Ralph.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23299. Virginia Bates Washington Ralph. [M. SORLEY, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Lewis")]), _vm._v(", 146–147; F. VIRKUS, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("CAG")]), _vm._v(", 3:388–389 and 4:687; "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Who Was Who Am.")]), _vm._v(", vol. 3; SSDI; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11333–14362]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12844. Mattie Milton Countess (born in Saltville, Washington Co., Va., June 19, 1873; married [ca. 1896] Oscar John Hill [born in Bonham, Fannin Co., Tex., Oct. 10, 1875; died Aug. 2, 1950]. They farmed in Oak View Township, Logan Co., Okla., 1910, and Ardmore Co., Okla., 1920. She died in Tulsa, Tulsa Co., Okla., Aug. 12, 1946).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23300. Hubert Hill.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23301. Ralph Hill.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23302. Wynnefred Hill (born in Tex., ca. 1900).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23303. Rex Hill (born ibid., ca. 1902).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23304. Thad Hill (born ibid., ca. 1904).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23305. Mary Hill (born ibid., ca. 1908; married ___ Crosby).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23306. Milton Hill (born in Okla., ca. 1911).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23307. Ran Hill (born ibid., ca. 1913). [1910 census Logan Co., Okla., E.D. 138, p. 6A; 1920 census Ardmore Co., Okla., E.D. 43, p. 5; FGS by SLS (NSWFD member #979)]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12848. Mitchell J. Bree (apparently “Mitchell James Bree,” he is surely the “James M. Bree, age 1,” in the 1880 census Nevada Co., Cal. According to the 1920 census, Mitchell was born in Cal., 1879, and his father was born in England–all of which fits. Mitchell married Amy M. [born in Cal., ca. 1879], and they farmed in Grass Valley, Nev. Co., Cal., 1920).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23308. Constance E. Bree (born in Cal., ca. 1906).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23309. Edna M. Bree (born ibid., ca. 1909).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23310. Frances E. Bree (born ibid., ca. 1911).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23311. William J. Bree (born ibid., ca. 1915). [1880 census Nevada Co., Cal., E.D. 62, p. 106B; 1920 census ibid., E.D. 55, p. 2B; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11333–14612]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12857. Lucille Dodge White (born in Appleton City, St. Clair Co., Mo., Dec. 24, 1900; a member of DAR, she married [May 9, 1934] D. E. Alexander. They last resided in Napa, Napa Co., Cal., where she died May 17, 1997).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Child:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23312. Deruelle (or “Desnelle”) Eugene Alexander (born in Alameda Co., Cal., Oct. 22, 1936). [CalBI; CalDI; SSDI; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11333–1468]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12861. James Edwin True (born in Colo., Jan. 16, 1908; married [April 23, 1934] Caroline Isabel Rose [born Nov. 10, 1907]. Working as a traveling salesman of building materials, he was married but living alone in Pasadena, Los Angeles Co., Cal., 1940. His wife and children resided with James’s father Roy True in Pasadena, Cal., 1940).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23313. Dan B. True (born in Ariz., Feb. 8, 1935; graduated from the U. of Idaho, 1958. He last resided in Denver, Colo., where he died April 17, 2003).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23314. Sarah Ann True. [1940 census Los Angeles Co., Cal., E.D. 19–458, p. 61A; "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("U. of Idaho Magazine")]), _vm._v(", Fall 2004, p. 40; SSDI; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11333–146b2]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12862. Adelen (or “Aileen”) Galloway (born in Tenn., ca. 1880; married Enos Kincheloe Cox [born in Tenn., May 25, 1880; resided as a widower in Gloster, Amite Co., Miss., 1930, where he was a Baptist minister]. They resided in Nashville, Tenn., 1910, and Sweetwater, Monroe Co., Tenn., 1920, where he was pastor of Baptist Churches).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23315. Clara Rhea Cox.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23316. William Cox (born in Tenn., ca. 1904; married Mamie Shumate).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23317. Juliette E. Cox (born ibid., ca. 1906).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23318. Philip Hunter Cox (born ibid., July 17, 1910; died in Solano Co., Cal., Feb. 5, 1942, while serving in the Navy).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23319. Mary Edythe Cox (died in infancy). [WATAUGA ASSN. OF GENEALOGISTS, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Hist. of Washington Co.")]), _vm._v(", 335; 1910 census Davidson Co., Tenn., E.D. 82, p. 4B; 1920 census Monroe Co., Tenn., E.D. 91, p. 19B; 1930 census Amite Co., Miss., E.D. 7, p. 3B; WW I Draft Reg.; "), _c('a', {
    attrs: {
      "href": "http://Anc.com",
      "target": "_blank"
    }
  }, [_vm._v("Anc.com")]), _vm._v("/PMT; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11333–14711]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12864. Edyth Albert Galloway (born Sept. 24, 1891; married John West Glaze [born Feb. 1, 1890; he was a farmer and not yet married, residing in Washington Co., Tenn., when he registered for the draft on June 5, 1917. He last resided in Johnson City, Washington Co., Tenn., and he died Sept. 1979]. She died 1953).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Child:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23320. John Albert Glaze (born Oct. 4, 1929; submitted a valuable sketch of his family, residing in Johnson City, Tenn., that was published in the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("History of Washington Co., Tenn.")]), _vm._v("). [WATAUGA ASSN. OF GENEALOGISTS, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Hist. of Washington Co.")]), _vm._v(", 344, 355; WW I Draft Reg.; SSDI; "), _c('a', {
    attrs: {
      "href": "http://TNGenWeb.org",
      "target": "_blank"
    }
  }, [_vm._v("TNGenWeb.org")]), _vm._v(" (Crouch/Galloway Cem.); J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11333–14713]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12873. Thomas Sanders Stealey (born in San Francisco, Cal., March 1865, where he later resided and practiced dentistry. He married Nellie Slayback [born in Cal., ca. March 1865; “born in Cal., March 1864, age 34,” according to the mathematically dubious 1900 census]).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23321. Thomas Ashton Stealey.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23322. Claire Stealey.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23323. Ruth Stealey (born in Cal., July 10, 1901; married Rex A. Daddisman [born in Cal., Aug. 6, 1900; still unm. and a civil engineer for a public utilities company in 1930, he died in San Francisco, Cal., Dec. 1966]. They resided by 1940 in San Francisco, Cal., where she "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("d.s.p.")]), _vm._v(" Feb. 8, 1973). [M. SORLEY, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Lewis")]), _vm._v(", 144; 1900 census San Francisco Co., Cal., E.D. 172, p. 3B; 1930 census ibid., E.D. 313, p. 3A; 1940 census ibid., E.D. 34–128C, p. 61B; CalDI; SSDI; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11333–15223]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12874. Emma Valentine Stealey (born in San Francisco, Cal., Feb. 13, 1871; DAR member #19025, she married [1899] Albert John Raisch [born in Germany, May 29, 1860, although the 1920 census gives his age as 56. He resided in San Francisco, Cal., where he was a “roads contractor” in 1920, and where he died May 23, 1951]. Obviously a prosperous family, their household included three live-in servants in the 1920 census. She died in Santa Clara Co., Cal., Aug. 18, 1941).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23324. Albert Godfried Raisch.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23325. Angela Raisch (born in Cal., Sept. 13, 1901; married Richard Bennett [died "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ante")]), _vm._v(" 1948]. She "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("d.s.p.")]), _vm._v(" in San Francisco, Cal., Oct. 18, 1955).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23326. Leila Raisch (born in Cal., ca. 1896; resided unm. with her parents in 1920).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23327. John Washington Raisch (died 1908).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23328. Mary (or “Marie”) Louise Raisch (born in San Francisco Co., Cal., June 23, 1912). [M. SORLEY, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Lewis")]), _vm._v(", 144; "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("LB-DAR")]), _vm._v(", 20:11 (#19026); 1920 census San Francisco Co., Cal., E.D. 153, p. 8B; CalBI; CalDI; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11333–15224]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12875. Lulu Loftin Stealey (born in Mountain View, Santa Clara Co., Cal., Jan. 10, 1872; married David Chester Clark [according to Sorley, he was “a descendant of George Rogers Clark who was the companion of Meriwether Lewis,” but the Revolutionary War hero George Rogers Clark was actually the older brother of the explorer William Clark, colleague of Meriwether Lewis]. She resided as a widow in San Rafael, Marin Co., Cal., in 1920, working as a teacher in a public school, and she died in San Francisco, Cal., March 18, 1948).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23329. Maynor Chester Clark.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23330. Eloise Martha Clark (born Jan. 1, 1902; died unm. in San Francisco, Cal., July 18, 1966). [Quotation from M. SORLEY, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Lewis")]), _vm._v(", 144. See also: 1920 census Marin Co., Cal., E.D. 85, p. 18A; CalDI; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11333–15225]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12876. John Tilden Stealey (born Mountain View, Santa Clara Co., Cal., July 1874; he was an insurance executive in Alameda, Alameda Co., Cal., 1900 and later in San Francisco, Cal. He married Alice Bertha Sullivan [born in Cal., March 25, 1879; died in Marin Co., Cal., Sept. 27, 1949]).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23331. Margaret Emma Stealey (born in Cal., July 1898; a nurse, she resided unm. with her parents in 1930. She died in San Francisco Co., Cal., March 14, 1943).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23332. John Bailey Stealey (born in Cal., Dec. 1899; died age eight).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23333. John Tolmie Stealey (born in Marin Co., Cal., July 31, 1911).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23334. Patricia Marie Stealey (born in San Francisco, Cal., March 17, 1920).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23335. Kenneth Fielding Stealey (born ibid., Sept. 20, 1923; died ibid., April 24, 1951). [M. SORLEY, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Lewis")]), _vm._v(", 145; 1900 census Alameda Co., Cal., E.D. 313, p. 1B; 1920 census San Francisco Co., Cal., E.D. 293, p. 14B; 1930 census ibid., E.D. 230, p. 2A; CalDI; B. C. NOONAN, website “Desc. of Edward III”; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11333–15226]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12877. Edwin Matthew Stealey (born in Mountain View, Santa Clara Co., Cal., June 1876; resided and practiced dentistry in San Francisco, Cal. He married Eva Winifred Hawes [born in Cal., Oct. 12, 1876; as a widow she resided with her parents in San Francisco, Cal., 1910. She died in Santa Clara Co., Cal., July 27, 1966]).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23336. Eva Louise Stealey.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23337. Talton Edwin Stealey (born in Cal., Sept. 14, 1901; died in Santa Clara Co., Cal., Sept. 26, 1973). [M. SORLEY, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Lewis")]), _vm._v(", 145; 1900 census San Francisco Co., Cal., E.D. 99, p. 8A; 1910 census ibid., E.D. 172, p. 1B; CalDI; B. C. NOONAN, website “Desc. of Edward III”; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11333–15227]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12878. Mary Ethel Stealey (born in Mountain View, Santa Clara Co., Cal., ca. 1881; member of DAC and DAR #46559, she married Jesse Carl Martin, Jr. [born in Cal., ca. 1880; he was a consulting engineer and patent counsel]. They resided in San Francisco, Cal.).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23338. Jesse Sheldon Martin (born in San Francisco, Cal., Sept. 13, 1905; an engineer, he resided ibid.).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23339. Merva E. Martin. [M. SORLEY, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Lewis")]), _vm._v(", 145; "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("LB-DAR")]), _vm._v(", 47:253–254 (#46559); CalBI; 1910 census Marin Co., Cal., E.D. 52, p. 16A; CalDI; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11333–15228]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12882. Callie Wilson (born in Tex., April 9, 1904; married William Waldo Hampton [born in Ala., Jan. 8, 1898; died in Dallas, Tex., April 8, 1931]. They resided in Irving, Dallas Co., Tex., 1930, where his occupation was “laborer, levee construction.” She died in Hereford, Deaf Smith Co., Tex., July 1, 1990).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23340. William Waldo Hampton, Jr. (born in Denison Co., Tex., Sept. 17, 1923).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23341. John Glenn Hampton.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23342. Billy Joe Hampton. [1930 census Dallas Co., Tex., E.D. 141, p. 3A; "), _c('a', {
    attrs: {
      "href": "http://FamSearch.org",
      "target": "_blank"
    }
  }, [_vm._v("FamSearch.org")]), _vm._v("/Tex. Deaths; "), _c('a', {
    attrs: {
      "href": "http://Anc.com",
      "target": "_blank"
    }
  }, [_vm._v("Anc.com")]), _vm._v("/PMT]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12893. William Eskridge Gilkeson (born in Va., Aug. 25, 1884; a traveling salesman, he married [Dec. 10, 1907] Elizabeth Burwell Jones [born in Va., Nov. 5, 1881]. They resided in Beaver Pond, Mercer Co., W. Va., 1920. They later resided in Bluefield, Mercer Co., W. Va., and he died Jan. 26, 1931 or 1932).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23343. William Eskridge Gilkeson, Jr. (born in Va., Nov. 14, 1909; died May 9, 1934).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23344. Patricia Hope Gilkeson.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23345. Fillmore Bolling Gilkeson. [1920 census Mercer Co., W. Va., E.D. 80, p. 19B; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11333–52121]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12894. Janie Hale Gilkeson (born in Va., April 8, 1889; married [Nov. 27, 1912] Laurence White Wilson [born in Md., Sept. 7, 1887; died Dec. 4, 1951]. They farmed in Beverly Manor District, Augusta Co., Va., 1920. They moved by 1930 to Greensboro, Guilford Co., N.C., where he was an automobile salesman).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23346. Laurence White Wilson, Jr.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23347. Fillmore Gilkeson Wilson.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23348. Benjamin Eskridge Wilson. [1920 census Augusta Co., Va., E.D. 28, p. 16A; 1930 census Guilford Co., N.C., E.D. 26, p. 7B; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11333–52122]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12895. George Maslin Gilkeson (born in Va., Aug. 18, 1890; a WW I veteran and at one time sheriff of Augusta Co., Va., he married [Oct. 10, 1917] Helen Blackwood Patterson [born in Va., Sept. 24, 1894; died May 1985]. In 1930 they resided in South River, Augusta Co., Va., where he was a machinery salesman. They also resided in Staunton, Va., and he died June 10, 1953).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23349. Helen Blackwood Gilkeson.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23350. Elizabeth Eskridge Gilkeson.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23351. George Maslin Gilkeson, Jr. [1930 census Augusta Co., Va., E.D. 19, p. 19A; SSDI; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11333–52123]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12896. Edwin James Payne (born in Augusta Co., Va., ca. 1880; married in Staunton, Va. [April 4, 1907] Florence Tyree [born in Va., ca. 1882; “of Staunton, Va.”]. They resided in Baltimore, Md., 1920, where he was a wholesale dry goods traveling salesman. In 1930 he was manager of a company in High Point, Guilford Co., N.C.).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23352. Evelyn S. Payne (born in Va., ca. 1908; married Drayton Meyer, and they had one child: Evelyn Meyer).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23353. Edwin Payne.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23354. Richard Payne.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23355. Florence Payne. ["), _c('a', {
    attrs: {
      "href": "http://FamSearch.org",
      "target": "_blank"
    }
  }, [_vm._v("FamSearch.org")]), _vm._v("/Va. Marriages; 1920 census Baltimore Co., Md., E.D. 231, p. 10A; 1930 census Guilford Co., N.C., E.D. 49, p. 9A; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11333–52131]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12902. Matthew Michie Fletcher (born in Cal., Oct. 29, 1894; a veteran of WW I, he married [Feb. 23, 1922] Marcelle Antoinette Gimmet [born in France, May 7, 1897; died in Los Angeles Co., Cal., Aug. 14, 1971]. He worked as a salesman for an oil company, and he died at the age of 100 in Los Angeles, Cal., April 23, 1995).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Child:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23356. Briscoe Baldwin Fletcher (born in Los Angeles Co., Cal., March 29, 1923). [1930 census Los Angeles Co., Cal., E.D. 138, p. 23A; CalBI; CalDI; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11333–52262]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12903. Katherine Dorothea Fletcher (born in Cal., March 24, 1896; married [June 29, 1928] James William Tonner [born in Mo., Nov. 26, 1893; a WW I veteran, he last resided in Los Angeles, Cal., and he died June 1976]. They resided in Los Angeles, Cal., 1930, where he was an assistant sales manager for an oil company. She died April 18, 1934).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Child:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23357. Joanne Muse Tonner. [1930 census Los Angeles Co., Cal., E.D. 233, p. 12A, where the on-line index misreads the name as “Tanner”; CalBI; CalDI; SSDI; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11333–52263]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12906. Elizabeth Muse Fletcher (born in Cal., July 11, 1905; married [Sept. 6, 1930] Will Knight Smith, Jr. [born in Colo., May 25, 1901; salesman for a petroleum company in 1940, he died in Los Angeles Co., Cal., May 22, 1973]. They resided in Los Angeles, Cal., 1940).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23358. Will Knight Smith III (born in Cal., April 28, 1935).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23359. Barbara Muse Smith (born in Los Angeles Co., Cal., May 22, 1939). [CalBI; CalDI; 1940 census Los Angeles Co., Cal., E.D. 60–899, p. 14A; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11333–52266]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12907. Maude Alice Fletcher (born in Cal., Sept. 14, 1909; married [June 19, 1933] Charles Nelson Aselin [born in Wisc., Sept. 11, 1895; a railroad conductor, he resided in Los Angeles Co., Cal., when he registered for the draft on Sept. 12, 1918. By 1940 he was a police officer in Los Angeles Co., Cal., where he died April 21, 1956]).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23360. Adrienne Alice Aselin (born in Los Angeles Co., Cal., Nov. 12, 1939).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23361. Donald George Aselin (born ibid., Oct. 20, 1945; resided in San Juan Capistrano, Orange Co., Cal.). [WW I Draft Reg.; 1940 census Los Angeles Co., Cal., E.D. 60–1071, p. 5B (the on-line census index oddly misreads the quite legible surname “Aselin” as “Aschim”); CalBI; CalDI; SSDI; USPRI; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11333–5226]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12909. Mildred Woodward Cochran (born Aug. 5, 1909; grew up on her parents’ estate “Folly” near Staunton, Va. She attended Johns Hopkins U. and the Peabody Conservatory of Music in Baltimore, Md. She married [Sept. 6, 1933] Rev. David Cady Wright, Jr. [born in New Albany, Floyd Co., Ind., Oct. 24, 1903; graduated from Episcopal High School in Alexandra, Va., Kenyon College (Alpha Delta Phi; A.B., 1926), and Va. Theological Seminary at Alexandria [B.D., 1931]. Ordained an Episcopal priest in 1931, he served briefly at St. John’s Church in Waynesboro, Va. and Church of the Good Shepherd at Folly Mills, Va.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("In 1933 he began a long tenure as rector of Emmanuel Church in Athens, Clarke Co., Ga., where many of his parishioners were faculty and students of the U. of Ga. In 1947 he became rector of R. E. Lee Memorial Church in Lexington, Rockbridge Co., Va., serving until Feb. 1, 1951. He then became rector of St. Mary’s-on-the-Highlands Church in Birmingham, Ala., where in 1957 he was instrumental in founding a retirement community. This project later evolved into St. Martin’s-in-the Pines comprehensive Continuing Care Retirement Community, with 344 units for various stages of assisted living]).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23362. David Cady Wright III (born in Athens, Ga., Feb. 25, 1935).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23363. Lynn Cochran Wright (born ibid., Jan. 11, 1939).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23364. William McDowell Wright (born ibid., Aug. 2, 1940). [Unidentified newspaper clipping from Washington and Lee Archives, Tompkins Scrapbook vol. 5; website of St. "), _c('a', {
    attrs: {
      "href": "http://Martins-in-the-Pines.org",
      "target": "_blank"
    }
  }, [_vm._v("Martin’s-in-the-Pines.org")]), _vm._v("; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11333–52331]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12911. Joseph Smith Cochran, Jr. (born Sept. 27, 1914; married [April 26, 1941] Eleanor Braxton Flanigen/Flanigan [born Oct. 1, 1918]. They resided in Augusta Co., Va., and he died in Staunton, Va., Nov. 1977).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23365. Joseph Smith Cochran III (born Jan. 7, 1943).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23366. Douglas Woodward Cochran (born June 4, 1945).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23367. Eleanor Braxton Cochran (born ca. Nov. 4, 1946).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23368. Nancy Lee Cochran (born Sept. 18, 1949). [SSDI; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11333–52333]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12913. Anne Carter Brooke (born in Ky., July 31, 1904; married [Feb. 5, 1924] George Ossman [born Aug. 10, 1886; an Episcopal priest and D.D., he was rector of Monumental Church in Richmond, Va., 1931–1957]).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23369. George Ossman, Jr.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23370. Anne Carter Ossman (born Feb. 3, 1927; resided in Richmond, Va.).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23371. Robert Spotswood Brooke Ossman (born June 1, 1931; he was executive director of the Portsmouth/West Chesapeake Chapter of the American Red Cross). [FGS by SW; "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Virginian Pilot")]), _vm._v(", 8/20/1995, p. 8; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11333–52521]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12915. Elizabeth Washington Berry Brooke (born in Ky., Aug. 25, 1907; she was raised in Louisville, Jefferson Co., Ky., where she married [Aug. 12, 1926] James Albert Channon [born Oct. 18, 1903; in lieu of a traditional high school, he attended Morgan Park Military Academy, where he was first captain, president of the senior class, and lettered in three sports. He entered the USMA, West Point, in 1921, and graduated as Captain of “D” Company in 1925. He initially chose the Field Artillery, but in 1929 he decided to become a pilot and enrolled in flight school at Brooks Field. He won high praise from his instructors, but a previously undetected vision problem involving his depth perception forced him to withdraw. Bitterly disappointed, he soon resigned from the Army on Oct. 3, 1929.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("For the next decade, he was an editor at McGraw-Hill publishers in New York City, although he continued his military training through the New York National Guard. In Feb. 1941, he took charge of training the 955"), _c('sup', [_vm._v("th")]), _vm._v(" Battalion of the 187"), _c('sup', [_vm._v("th")]), _vm._v(" Field Artillery Regiment at Fort Ethan Allen, Vt. By March 1943, he was an artillery instructor at Fort Sill, Okla., and in May 1944 he was assigned to the 84"), _c('sup', [_vm._v("th")]), _vm._v(" Inf. Division then being trained at Camp Claiborne, La. He accompanied this Division to Europe as Lt. Colonel in the National Guard, eventually serving as the Chief of Staff of its artillery as it fought its way across the Ardennes, Rhineland, and into the heart of Germany from October 1944 until V-E Day. For his contributions to those campaigns, he was awarded the Legion of Merit and the Bronze Star with Oak Leaf Cluster.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("After the war, he accepted a commission as Lt. Colonel in the Regular Army, and from Feb. 1 to July 3, 1947, he was detached for special duty to assist the newly restored government of Greece in its civil war against Communist guerillas. During that critical period, he was executive secretary to the Chief of the American Mission for Aid to Greece. Returning to the U.S., he resumed his work in the Field Artillery, and during the Korean War he commanded the 142"), _c('sup', [_vm._v("nd")]), _vm._v(" Field Artillery Group. He retired at the rank of Colonel in 1958, and he joined the faculty of the Louisville (Ky.) Country Day School in his wife’s old hometown. He died Oct. 20, 1963]. Elizabeth survived him).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23372. James Brooke Channon (born Sept. 20, 1939; served as Lt., USA).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23373. Elizabeth Davidson Channon. [G. W. CULLUM, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Biog. Register of the USMA")]), _vm._v(", 9:483; obit. of Col. J. A. Channon in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Assembly")]), _vm._v(", (Summer 1964) 113; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11333–52523]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12916. Margaret Lyle Brooke (born in Ky., Nov. 10, 1909; married [Sept. 5, 1931] Oscar Edward Raidt [born in Ky., May 25, 1905; died in Louisville, Jefferson Co., Ky., Nov. 12, 1951]. By 1940 they resided in Miami, Dade Co., Fla., where he was a salesman for a flour mill).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Child:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23374. Anita A. Raidt (born in Jefferson Co., Ky., April 4, 1932; married Edwin Hampton Perry [born ibid.]). [1940 census Dade Co., Fla., E.D. 69–100B, p. 3B; KyBI; KyDI; "), _c('a', {
    attrs: {
      "href": "http://www.stithvalley.com/ancestry",
      "target": "_blank"
    }
  }, [_vm._v("www.stithvalley.com/ancestry")]), _vm._v("; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11333–52524]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12917. Roberta Spotswood Brooke (born in Ky., Oct. 25, 1915; married [Dec. 5, 1936] Charles Francis Hudson [born Feb. 13, 1912; graduated from Medical College of Va., Richmond (M.D., 1939). He served as surgeon, USN, and was a specialist in internal medicine. He last resided in Crystal River, Citrus Co., Fla., and he died Nov. 10, 2003]. They resided at one time in Coral Gables, Dade Co., Fla., and she died March 1974).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23375. Roberta Brooke Hudson (born 1938).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23376. Charles Francis Hudson (born 1940).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23377. Frances Langhorne Hudson (born 1944).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23378. William Spottswood Hudson (born 1946). ["), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Am. Med. Dir.")]), _vm._v(", 1950, p. 607; SSDI; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11333–52525]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12918. Herbert Chermside Pollock (born in Staunton, Va., June 13, 1913; graduated from the U. of Va. [B.A., 1933]. A Rhodes Scholar in Balliol College, Oxford U., he graduated from Oxford U. [Ph.D., 1937]. He was initially a research physicist for General Electric [1937–1943]. He then worked as director of the Radio Research Laboratory at Eglin Field Station near Fort Walton, Fla., in affiliation with Harvard U. [1943–1944]. During the final year of WW II, he was a staff member of the Radiation Laboratory at the U. of Cal.-Berkeley, part of the Manhattan Project that successfully developed the first atomic bomb [1944–1945]. In a long and distinguished career, he was a physicist in the Research and Development Center of General Electric Company [1944–1978]. While working with two colleagues in 1940, he succeeded in isolating U-235 and demonstrating that it was a fissionable isotope, a discovery that later proved to be critical importance in the development of the atomic bomb.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Keenly interested in education, he served as a member of the advisory board of the Center for Advanced Studies at the U. of Va. [1970–1976]. He was also president of the board of trustees of Dudley Observatory [1976–1980] and a trustee of the Alumni Patent Foundation of the U. of Va. [1978–1984]. The Herbert C. Pollock Award, to encourage innovative research in astronomy and astrophysics, was established in his honor by the board of trustees of the Dudley Observatory. He married [1"), _c('sup', [_vm._v("st")]), _vm._v(", on Nov. 28, 1942] Virginia Elizabeth Jones [born Nov. 23, 1917]. He married [2"), _c('sup', [_vm._v("nd")]), _vm._v(", in 1980] Patricia G. Jencks. He last resided in Wallingford, New Haven Co., Conn., and he died Nov. 24, 2000).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children (by his 1"), _c('sup', [_vm._v("st")]), _vm._v(" wife):")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23379. Herbert James Pollock (born 1946).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23380. Martha Avery Pollock (born 1947).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23381. Richard Chermside Pollock (born 1952).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23382. Robert Alexander Pollock (born 1954). ["), _c('em', {
    staticClass: "italic"
  }, [_vm._v("AmM&WSci")]), _vm._v(", 1995–96; "), _c('a', {
    attrs: {
      "href": "http://www.harvardsquarelibrary.org/unitarians/coolidge",
      "target": "_blank"
    }
  }, [_vm._v("www.harvardsquarelibrary.org/unitarians/coolidge")]), _vm._v("; SSDI; FGS by MAS; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11333–52831]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12920. Herbert Brooke Chermside, Jr. (born July 1, 1915; graduated from the U. of Va. Law School [J.D., 1938]. He married [Dec. 2, 1936] Susan Booth Bonnett [born July 8, 1915; last resided in Richmond, Va., and she died May 9, 2005]. He resided in Richmond, Va., 2001).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23383. Herbert Brooke Chermside III (born Sept. 17, 1937; died June 26, 2006, and he was buried in Charlotte Court House, Charlotte Co., Va.).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23384. Marjorie Susan Chermside (born ca. April 4, 1939; died ca. Jan. 19, 1940).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23385. Florence Booth Chermside (born 1941).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23386. Mary Eppleston Chermside (born 1946). ["), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Virginia Law")]), _vm._v(" on-line, Fall 2001; SSDI; "), _c('a', {
    attrs: {
      "href": "http://www.findagrave.com",
      "target": "_blank"
    }
  }, [_vm._v("www.findagrave.com")]), _vm._v("; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11333–52841]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12923. Juliet Lyle Brooke Bond (born in Madison, Dane Co., Wisc., Feb. 6, 1913; resided with her widowed grandmother Martha Chermside in Staunton, Va., 1920. Juliet twice received the Stuart Hall Scholarship for the highest grade average in Stuart Hall, Staunton, Va. She later earned the Freshman, Sophomore, and Junior Scholarship for the highest grade average in 1930, 1931, and 1933 at Randolph-Macon Women’s College [A.B., Sociology and Economics, 1934; Phi Beta Kappa]. In the mid-1930s, she worked as a social worker with the Baltimore Emergency Relief Commission, and she was later a graduate student at William and Mary, where she received a certificate in Social Case Work, Feb. 1938.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Extremely active in patriotic and lineage societies, she was vice-regent of the Thomas Johnson Chapter, Maryland DAR and chairman of Resolutions for the Maryland State DAR, 1959–1960. Especially prominent in U.S. Daughters of 1812, she served as National Chairman of the Correct Use of the Flag, Restoration of the Frigate "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Constellation")]), _vm._v(", and Resolutions. Her anthology of poetry, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Under a Tropic Sun")]), _vm._v(" [Driftwood Press, North Montpelier, Vt., 1944], was featured in her appearance on Mary Margaret McBride’s national NBC radio program. Her second book of poetry, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Winter has Come ")]), _vm._v("[Driftwood Press, North Montpelier, Vt., 1945] was praised by the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("New Haven Journal-Courier")]), _vm._v(", Dec. 18, 1945 as “one of the beauties that has come out of the horrors of war.” Her literary papers comprise the Juliet Brooke Ballard Collection in the George Arents Research Library at Syracuse U.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("She was a very prominent leader in the Association for Research and Enlightenment [A.R.E.], a movement founded by Edgar Cayce of Virginia Beach, Va. Joining the movement in 1957, she went on to contribute six main articles and numerous poems to the A.R.E.’s magazine "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Searchlight")]), _vm._v(", and was associate editor of the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("A.R.E. Journal")]), _vm._v(" from 1966 to 1970. Her numerous publications also include “Genetics, Past and Present” in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Edgar Cayce Reader")]), _vm._v(" [1969], and several books: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Seeker’s Trilogy")]), _vm._v(" [A.R.E. Press, 1981], "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Hidden Laws of the Earth")]), _vm._v(" [1979], "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Treasures from the Earth’s Storehouse")]), _vm._v(" [1980], and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Art of Living")]), _vm._v(" [1982; republished under the title "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Unto the Hills")]), _vm._v(", 1987]. Among other offices she was vice-chairman of the A.R.E. Congress Committee [1963] and member of the Publications Committee [1962–1966].")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("She married in Ruxton, Baltimore Co., Md. [Sept. 3, 1937] Lyttleton Waters Ballard [born in Baltimore, Md., Dec. 28, 1914; always interested in electronics, he became a licensed ham radio operator July 24, 1931, and graduated from Johns Hopkins U. (B. Engineering, 1937). For the next three years, he worked as an engineer with U.S. Steel, Pennsylvania Railroad, and the Lago Oil and Transport Company, in Aruba, Netherlands, West Indies. In Dec. 1940, he began work with the Signal Office of the V Corps, USA, at Fort Hayes, Ohio. With U.S. entry into WW II, he enlisted in the Navy on Jan. 24, 1942. He became a Navy electronics officer and successfully took the Defense Training Course in new RADAR technology at MIT, April-July 1942. He sailed in Sept. 1942 aboard the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Chaumont")]), _vm._v(" for duty at Kodiak, Alaska. He remained in Alaska until May 1943, when he sailed from Adak aboard the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Avocet")]), _vm._v(". He went on to serve in the Pacific with Night Carrier Air Group 52, which was stationed aboard the carrier "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Enterprise")]), _vm._v(". He was honorably discharged as Lt., USN, Jan. 31, 1946. From Aug. 1947 to Oct. 1961, he held a top secret security clearance as an electrical engineer in the Air Arm Division of Westinghouse in Baltimore. He later worked at the Naval Ship Engineering Center in Norfolk, Va., and he died Jan. 20, 1986]. She died in Silver Spring, Montgomery Co., Md., Oct. 2, 1998).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23387. Thomas Brooke Ballard (born in Aruba, Netherlands West Indies, 1939; he was valedictorian at both the Calvert School in Baltimore [1952] and Baltimore Polytechnic School [1956]. He graduated from Rensselaer Polytechnic Institute [B. Electrical Engineering, 1950], Cal. Institute of Technology [M.S. Electrical Engineering, 1960] and U. of Maryland [Ph.D., Electrical Engineering and Applied Mathematics]. In 1960–1961, he was a research scientist with the Arctic Institute of North America and spent the winter studying geophysical phenomena at Cape Hallett Station, Antarctica. From 1962 to 1972, he was a design engineer for spacecraft systems at the NASA Langley Research Center, and he testified before Congress as a member of the Board of Inquiry after the nearly disastrous flight of Apollo 13.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("He spent the next two years circumnavigating the globe in 46-foot ketch. From 1974 to 1994, he was an engineer with the Naval Surface Warfare Center, retiring as Chief Engineer of the Sensors and Electronics Division. During that period he wrote 27 technical papers on signal detection and analysis, also giving six invited lectures on submarine detection and tracking. In 1985 he was visiting professor at the USNA, Annapolis, where he was honored as “best professor” for the year. In 1986 he conducted underwater sound experiments on an ice flow in the Beaufort Sea [latitude 72.3 degrees]. In 1998 he became the head librarian and member of the board of the Historical Electronics Museum in Washington, D.C.).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23388. Juliet Lyle Ballard. ["), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Who’s Who Am. Women")]), _vm._v(", 1980; "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("International Authors")]), _vm._v(", 1980; 1920 census Augusta Co., Va., E.D. 135, p. 5A; U.S. WW II Navy Muster Rolls; "), _c('a', {
    attrs: {
      "href": "http://turrentinenews.tripod.com/id15.html",
      "target": "_blank"
    }
  }, [_vm._v("turrentinenews.tripod.com/id15.html")]), _vm._v("; FGS by JAL; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11333–52861]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12928. Francis Berkeley Robins (born in Richmond, Va., Sept. 17, 1900; married [1"), _c('sup', [_vm._v("st")]), _vm._v("] Margaret Boardman [born 1899]. Later divorced and with no children by his first marriage, he married [2"), _c('sup', [_vm._v("nd")]), _vm._v(", on April 15, 1941] Caroline Somerville Foy [born Sept. 21, 1910]).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children (by his 2"), _c('sup', [_vm._v("nd")]), _vm._v(" wife):")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23389. Caroline Perry Robins (born 1943).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23390. Evelyn Berkeley Robins (born 1945).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23391. Harriet Vaughn Robins (born 1948). ["), _c('a', {
    attrs: {
      "href": "http://FamSearch.org",
      "target": "_blank"
    }
  }, [_vm._v("FamSearch.org")]), _vm._v("/Va. Births; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11333–54611]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12929. Dorothea Randolph Robins (born in Va., Oct. 6, 1902; married [June 12, 1931] Robert Wren Powers Martin [born Nov. 29, 1901; died April 1954]).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23392. Robert Wren Powers Martin, Jr. (born 1932).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23393. Evelyn Berkeley Martin (born 1935). [R. HENRY, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Gen. of the Fam. of the Presidents")]), _vm._v(", 17; "), _c('a', {
    attrs: {
      "href": "http://Anc.com",
      "target": "_blank"
    }
  }, [_vm._v("Anc.com")]), _vm._v("/PMT; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11333–54612]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12930. Charles Russell Robins, Jr. (born in Va., June 28, 1905; graduated from Medical College of Va., Richmond [M.D., 1929]. He served as Lt. Colonel, Medical Corps, USA, and he was later a later surgeon in Richmond, Va. He married [1"), _c('sup', [_vm._v("st")]), _vm._v(", in Jan. 1935] Eleanor Lott, and, following a divorce, he married [2"), _c('sup', [_vm._v("nd")]), _vm._v(", on April 19, 1941] Susan Douglas Clay [born Aug. 2, 1914; she "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("d.s.p.")]), _vm._v(" 1950]. He married [3"), _c('sup', [_vm._v("rd")]), _vm._v("] Virginia Park. He last resided in Kilmarnock, Lancaster Co., Va., and he died May 1981).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Child (by his 1"), _c('sup', [_vm._v("st")]), _vm._v(" wife):")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23394. Eleanor Lott Robins (born 1935). ["), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Am. Med. Dir.")]), _vm._v(", 1961, p. 1107; SSDI; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11333–54613]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12931. Evelyn Berkeley Robins (born in Va., Sept. 11, 1906; married [Nov. 15, 1930] Robert Randolph Harrison, Jr. [born in Va., Nov. 2, 1904; an insurance inspector, he last resided in Richmond, Va., and he died Feb. 20, 1998]. She last resided in Richmond, Va., and she died Aug. 29, 2003).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23395. Robert Randolph Harrison III (born in Va., 1935).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23396. Evelyn Spotswood Harrison (born 1940).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23397. Charlotte Poindexter Harrison (born 1946). [1940 census Richmond (Independent City), Va., E.D. 118–10, p. 10A; SSDI; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11333–54614]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12932. Elisabeth Mebane Robins (born in Va., Nov. 8, 1907; married [June 21, 1930] James Edward Dowd [born Aug. 10, 1899; graduated from the U. of N.C.-Chapel Hill (A.B., 1920; Delta Kappa Epsilon). He was vice-president and general manager of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Charlotte Observer")]), _vm._v(", and he served as Lt., USNR, 1943–1944. He died March 12, 1966]. They resided primarily in Charlotte, Mecklenburg Co., N.C., but she died in Wilmington, New Hanover Co., N.C., Aug. 9, 1990).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23398. Cornelia Jordan Dowd.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23399. Berkeley Robins Dowd (born in Mecklenburg Co., N.C., June 3, 1936).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23400. Elisabeth Mebane Dowd (born ibid., Aug. 6, 1939). ["), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Who Was Who Am.")]), _vm._v(", vol. 4; NCarBI; SSDI; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11333–54615]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12933. Alexander Spotswood Robins (born in Va., Dec. 31, 1910; graduated from Medical College of Va., Richmond [M.D., 1936]. Board-certified in obstetrics-gynecology, he had a professorial appointment in the Medical College of Va., Richmond. He married [July 28, 1943] Sara Emma Hutcherson [Jan. 12, 1923]. He died in Richmond, Va., Dec. 20, 1995, where he was buried at Hollywood Cemetery).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23401. Alexander Spotswood Robins, Jr. (born 1944).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23402. William Randolph Robins (born 1945).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23403. Sarah Emma Robins (born 1948).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23404. Charles Russell Robins (born 1951). ["), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Am. Med. Dir.")]), _vm._v(", 1961, p. 1107; "), _c('a', {
    attrs: {
      "href": "http://www.findagrave.com",
      "target": "_blank"
    }
  }, [_vm._v("www.findagrave.com")]), _vm._v("; SSDI; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11333–54616]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12935. Jean Berkeley Bentley (born Dec. 11, 1914; married [Sept. 5, 1936] Frank John Martin [born Oct. 1910]).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23405. Jean Spotswood Martin (born 1943).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23406. Christopher Kennon Martin (born 1946). [J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11333–54672]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12939. Sarah Spotswood Berkeley (born Dec. 15, 1903; graduated from William and Mary [B.A.]. A teacher, she was also a DAR hostess at Colonial Williamsburg. She married [Aug. 9, 1927] Edward Arthur Watkins [born Feb. 3, 1905; attended VMI. An accountant, he died March 14, 1985]. She died Aug. 7, 1973).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23407. Edward Arthur Watkins, Jr.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23408. Spotswood Berkeley Watkins.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23409. Sarah Bumgardner Watkins. [FGS by CCB]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12941. Charles Carter Berkeley, Jr. (born in Augusta Co., Va., Oct. 15, 1907; the first Eagle Scout in the Virginia Peninsula Boy Scouts of America council, he was selected in a national competition as one of the 56 Boy Scouts to represent the U.S.A. at the World Scout International Jamboree in Copenhagen, Denmark, 1924. There the U.S. Troop won the world championship in competition against nineteen other nations. The following year he played right end on the Newport News High School football team that won the Virginia state championship. He lettered in football at VMI, and after his graduation [B.S., 1931] he was commissioned 2"), _c('sup', [_vm._v("nd")]), _vm._v(" Lt. in the Field Artillery Reserve. For the next four years he taught biology, history, and mathematics at Lexington [Va.] High School, where he also coached football, basketball, and baseball. He also served as scoutmaster of the local Boy Scout troop. For the next six years, he worked at various firms, including Newport News Shipbuilding and Dry Dock Company.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The day after the Japanese attack on Pearl Harbor, he requested the reinstatement of his commission in the Field Artillery Reserve, which he had allowed to lapse in 1936, but he was refused because of his age [34]. He subsequently obtained a commission as 1"), _c('sup', [_vm._v("st")]), _vm._v(" Lt. in the USMC Reserve in July 1942, but after his final physical exam he was told he had tuberculosis and was sent home. After a civilian physician found no trace of the disease, Berkeley requested another physical with the Marines. After passing this exam, he completed the 90-day USMC Officer Indoctrination Course, finishing second in a class of 93. Promoted to Captain in Feb. 1943, he was assigned command of Co. G, 2"), _c('sup', [_vm._v("nd")]), _vm._v(" Battalion, 24"), _c('sup', [_vm._v("th")]), _vm._v(" Regt., 4"), _c('sup', [_vm._v("th")]), _vm._v(" Marine Div., which he subsequently led in the Battle of Roi-Namur in the Marshall Islands. Later, as the battalion’s Operations and Training Officer, he participated in the Battles of Saipan and Tinian in the Marianas.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("In Sept. 1944, he was assigned as commander of Battalion Headquarters Company and Special Staff Officer to his Battalion Headquarters, and was promoted to Major in Jan. 1945. He came ashore at Iwo Jima on D-Day, and the following day he replaced the wounded Battalion S-3 [Operations Staff Officer]. He continued to serve in that post until the end of the bitter battle for the island. After being hospitalized in Hawaii for an infection, he was sent to Okinawa in anticipation of “Operation Olympic,” the invasion of Japan.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("With the end of the war a few weeks later, he was recommended for retention in the Regular USMC with the rank of Major. A change of regulations made this impossible because of his age [38], and he was mustered out. During a routine physical exam at the time of his discharge, he was again suspected of having tuberculosis. This, too, finally proved to be inaccurate, and after a long delay he finally returned to his job at the Newport News Shipbuilding and Dry Dock Company. Meanwhile, from 1946 to 1950 he served as a Major in the Virginia National Guard, being promoted to Lt. Colonel in April 1950. Two months later the Korean War broke out, and he was recalled to active duty as Lt. Colonel in command of the now federalized 710"), _c('sup', [_vm._v("th")]), _vm._v(" Anti-Aircraft Artillery Battalion of the Virginia National Guard. He served as its commander at Fort Stewart, Ga., and Fort Meyer, Va., until it reverted to state control in April 1952. Sent to Korea at the rank of Lt. Colonel in July 1952, he initially served as commander of the 68"), _c('sup', [_vm._v("th")]), _vm._v(" Anti-Aircraft Artillery [AAA] Battalion at Kimpo, Korea, defending the 4"), _c('sup', [_vm._v("th")]), _vm._v(" Fighter Wing. In 1953 he commanded the 773"), _c('sup', [_vm._v("rd")]), _vm._v(" AAA Battalion at Osan and for two months was interim commander of the Northwest AAA Sector, having command of seven artillery battalions.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("After subsequent duty in Japan, he returned to the U.S. and served as senior unit adviser of the Roanoke Virginia Area Reserves, which covered an area of 20 counties with 21 different types and sizes of Reserve units. In 1958 he was informed that because of his age he would not be able to continue on active duty at his rank. Retiring from the USAR as Lt. Colonel on Jan. 31, 1958, he enlisted in the Regular Army on March 1, 1958 as a Sgt. 1"), _c('sup', [_vm._v("st")]), _vm._v(" class and in 1959 was promoted to Master Sgt. After duty with artillery units Germany, he served with a HAWK Artillery Missile Battalion at Fort Bliss until his retirement on March 1, 1967. Advanced to the rank of Lt. Colonel on the Retired Reserve List, he went on to teach mathematics in an El Paso public school from 1967 to 1969. His decorations included the Bronze Star with three Oak Leaf Clusters, Asiatic Pacific Campaign Medal with four Battle Stars, the Army Commendation Medal, and two Presidential Unit Citations.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("He married [1"), _c('sup', [_vm._v("st")]), _vm._v(", on Nov. 30, 1933] Caroline McClure Montgomery, and they were divorced in 1954. He married [2"), _c('sup', [_vm._v("nd")]), _vm._v(", on April 8, 1955] Elsie Lunasco [born April 24, 1921; special services librarian with USA and USAF, she was the librarian for the 4"), _c('sup', [_vm._v("th")]), _vm._v(" Fighter Wing at Kimpo, Korea, 1952–1953, the furthest forward USAF Base during the Korean War. She was later a librarian in Hawaii and Okinawa]. In his retirement, he collected and preserved a great deal of genealogical information on his family, which he generously contributed to this project. He died at the age of 98 in San Antonio, Tex., Jan. 29, 2006).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Child (by his 1"), _c('sup', [_vm._v("st")]), _vm._v(" wife):")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23410. Charles Carter Berkeley III.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children (by his 2"), _c('sup', [_vm._v("nd")]), _vm._v(" wife):")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23411. Catherine Spotswood Berkeley.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23412. Norborn Carter Berkeley. [Obit. of Charles C. Berkeley, Jr., in the Staunton (Va.) "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("News Leader")]), _vm._v(", 2/1/2006; FGS by CCB]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12942. Malinda McCorkle Berkeley (born Dec. 27, 1912; attended William and Mary. A member of the National Society of Colonial Dames of America in the Commonwealth of Virginia, she married [Sept. 6, 1935] Finley McIlwaine Waddell [born Nov. 4, 1908; attended Washington and Lee. He served in the Navy during WW II, and he was president of the Waddell Insurance Company, as well as an elder in the Presbyterian Church. He died in Lexington, Va., Oct. 1974]. She died June 1, 1993).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23413. Betty Berkeley Waddell.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23414. Linda Harrington Waddell.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23415. Finley McIlwaine Waddell II. [SSDI; FGS by CCB; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11333–54734]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12944. Randolph Carter Berkeley, Jr. (born in Agana, Guam, Feb. 14, 1916; graduated from the USNA, Annapolis, 1938. From 2"), _c('sup', [_vm._v("nd")]), _vm._v(" Lt., USMC, 1938, he advanced to the rank of Colonel, USMC, 1960. He was a pilot and Commander of a Dive Bomber Squadron stationed at the Marshall Islands in WW II. He completed Amphibious Warfare School, Quantico, Va., ca. 1948–1949, and was assigned to Air Control Group, Marine Aircraft Group 14. He later was a staff officer of 2"), _c('sup', [_vm._v("nd")]), _vm._v(" Marine Air Wing, 1950–1953, and Executive Officer of a Marine Jet Group in the Korean War. Assigned to Korea in the closing weeks of the war, he managed to fly ca. six combat missions in Panther jets before the truce was declared in 1953. During his year in Korea, he served as Executive Officer of Marine Air Corps Group 2, Commander of Marine Tactical Air Control Squadron 2, and Executive Officer of Marine Aircraft Group 33. His decorations included the Bronze Star and Air Medal.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("He graduated from Naval War College in 1958 and Boston U. [M.S., Political Science, 1957]. He retired from the USMC in 1965, and he is known to have worked for the CIA, perhaps while he was a “research scientist” for Human Sciences Research, Inc. [1965–1967]. He later served as assistant Public Safety officer in the Pacification Program in Vietnam [1967–1972]. He married on Oahu, Hawaii [Thanksgiving Day, Nov. 26, 1942] Ruth Elizabeth Gates [born March 19, 1919; during the course of her husband’s far-flung military career, she “established eighteen homes for the family,” and she died Sept. 21, 1999]. They resided in McLean, Va., 1972, and he died in Matthews, Mecklenburg Co., N.C., Nov. 17, 2003. They were both buried at Arlington National Cemetery, where their tombstone reads: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("O’ we have slipped the surly bonds of earth to touch the face of God")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23416. Randolph Carter Berkeley III (born Aug. 11, 1946; attended George Washington U. He served in the Army in Vietnam for two years, and he married [Feb. 9, 1974] Wanda Kay England. They were later divorced and had no children).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23417. Phillips Boyd Berkeley (born Nov. 16, 1949; attended the U. of Maryland. He enlisted as Pvt., USMC, during Vietnam War, and he received an honorable medical discharge prior to completing basic training at Paris Island. He married [June 5, 1972] Susan Elizabeth Sherman [born Aug. 8, 1953; she was secretary to the Commanding General at the USMC recruit training depot at Paris Island, S.C.]).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23418. Janet Elizabeth Berkeley (born June 9, 1962). [Quotation from Anon., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("38–83")]), _vm._v(" (USNA Alumni publication, 45; 45"), _c('sup', [_vm._v("th")]), _vm._v(" Anniversary, Class of 1938), 57 (see also 56). See also: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Who’s Who in Gov.")]), _vm._v(", 1"), _c('sup', [_vm._v("st")]), _vm._v(" ed., 1972–1973; Anon., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("A Score for ‘38")]), _vm._v(", 18–19 (includes family photo; informal USNA alumni publication in file of Randolph C. Berkeley, Jr., Class of 1938, Nimitz Library, USNA, Annapolis); "), _c('a', {
    attrs: {
      "href": "http://www.arlingtoncemetery.net/rcberkeleyjr.htm",
      "target": "_blank"
    }
  }, [_vm._v("www.arlingtoncemetery.net/rcberkeleyjr.htm")]), _vm._v("; FGS by CCB; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11333–54742]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12945. Margaret Berkeley Simpson (born Jan. 11, 1913; graduated from the U. of Va. [B.A.]. She married [Sept. 1949] Benjamin Sackett, and they were later divorced).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Child:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23419. Anne Carter Sackett (born 1948; married B. Gavza, and they had one son: Ben Gavza). [FGS by CCB; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11333–54751]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12946. John Wistar Simpson (born in Glenn Springs, Spartanburg Co., S.C., Sept. 25, 1914; graduated from the USNA, Annapolis, 1937, but his eyesight prevented him from remaining in the Navy. Instead, that same year he began a long and distinguished career at Westinghouse. He initially worked two years at the East Pittsburgh plant as a design engineer. He was assigned from 1939 to 1946 to the Navy and Marine Switchboard Section, reaching the position of manager and meanwhile earning his Master’s degree at the U. of Pittsburgh [M.S., 1941]. Throughout WW II, his primary work was assuring that Westinghouse-supplied electrical switchboards functioned well under combat conditions aboard Navy vessels. During this period, beginning in 1939, he worked closely with a young, obscure Naval officer named Hyman Rickover.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("In 1946 he was sent by Westinghouse to work at Oak Ridge National Laboratory as manager of nuclear engineering of the Power Pile Division, a pioneering effort in the application of nuclear energy to the controlled generation of electricity. While there he lived in close proximity with Rickover and two other men in a four-bedroom house. Even so, he never achieved first-name familiarity with “Captain Rickover”—a brilliant but irascible man with a complex, aggressive, abrasive personality. During the long evenings, Simpson gradually began to give Rickover extended lessons on reactor engineering. Then one night Rickover announced, “John, I’m quitting your course.” Surprised and curious, Simpson mused: “Surely my course isn’t too tough for you.” “No,” Rickover replied, “but I already know more than any of the company presidents or government officials I’ll have to deal with. Any more detailed knowledge is just a waste of time. I’d do better to spend my efforts on the big picture, not a lot of technical detail.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Soon after returning to Westinghouse, Simpson was named assistant manager of engineering for the newly formed Bettis Atomic Power Laboratory, which Westinghouse operated for the Atomic Energy Commission. In 1952 he became assistant general manager in charge of all technical activities at Bettis. During his tenure, this facility was the site for the design and construction of the nuclear propulsion plants for the world’s first nuclear submarine [the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Nautilus")]), _vm._v("], the first Polaris-carrying nuclear submarine [the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("George Washington")]), _vm._v("], and the first nuclear surface ships [the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Long Beach")]), _vm._v(" and the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Enterprise")]), _vm._v("]. The guiding force behind all the projects was Admiral Hyman Rickover.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Simpson’s rise to a key executive position in these projects was personally engineered by Rickover. The critical turning point came in 1952, when Simpson was the assistant manager under Clarence Lynn. Soon after boarding a train, Rickover called Simpson into his roomette and announced that something must be done about Lynn. “What do you want me to do?” Simpson asked.")]), _vm._v(" "), _c('div', {
    staticClass: "extract"
  }, [_c('p', {
    staticClass: "extractNoIndent"
  }, [_vm._v("‘I want you to get rid of him.’")]), _vm._v(" "), _c('p', {
    staticClass: "extractNoIndent"
  }, [_vm._v("‘Admiral, he’s my boss. I couldn’t do that even if I wanted to.’")]), _vm._v(" "), _c('p', {
    staticClass: "extractNoIndent"
  }, [_vm._v("‘Listen, I know you are in very good standing at corporate headquarters. If you threaten to quit unless they moved Lynn, it will be done.’")]), _vm._v(" "), _c('p', {
    staticClass: "extractNoIndent"
  }, [_vm._v("‘C’mon, Admiral. You can’t ask me to do that.’")]), _vm._v(" "), _c('p', {
    staticClass: "extractNoIndent"
  }, [_vm._v("‘Look, if you don’t do it, I’ll have you fired. And I can do it.’")])]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Simpson managed to avoid giving any direct response and agonized over his situation the rest of the trip. He decided to relate the story, exactly as it happened, to Lynn’s boss at Westinghouse and await the results. Soon, Lynn was transferred, and Simpson moved up to become the technical director for all the vital atomic energy projects. This set the stage for Simpson’s playing a central role in designing and building the Submarine Thermal Reactor—the atomic engine for the world’s first atomic submarine, the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("USS Nautilus")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The problems associated with designing and building the revolutionary submarine were staggering. External pressures added great urgency: the outbreak of the Korean War soon brought the Cold War to a dangerous boiling point. The contract to begin the project had been signed on Dec. 10, 1948, and by March 29, 1953, the reactor of the new atomic engine was successfully started up and “went critical”—an historical landmark.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Extreme security and safety problems surrounding the project demanded an awkward arrangement. The prototype itself was built in the remote Idaho wilderness, the Atomic Energy Commission’s 400,000 acre National Reactor Testing Station [NRTS]. As technical problems were encountered, the results were immediately referred to G.E.’s advanced Bettis Laboratory in Pittsburgh, where Simpson and his team of scientists grappled with them. As problems were solved, the results were immediately incorporated into the actual submarine itself, which was taking shape at the Electric Boat plant in Groton, Conn. At a critical point, late March in 1952, Rickover became impatient with progress and demanded the removal of G.E.’s site manager at the Idaho facility. Under tight security—Rickover had cut the telephone connections between the NRTS and the Bettis Laboratory—Simpson arrived to take charge as G.E.’s site manager in early April. By late June, the crisis had passed—the atomic engine successfully passed a critical 24-hour endurance test on June 23, 1953.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The timing of this crucial test proved to be unfortunate. Several hours into the test, as all was proceeding smoothly, Simpson received an urgent personal telephone call: his wife was entering the hospital in Pittsburgh for the birth of their third child. He was scheduled to return to Pittsburgh in any event after this test. In a difficult decision, Simpson determined that the situation in Idaho was well in hand, so he immediately caught a plane for Pittsburgh. Soon after his departure, however, Rickover changed the test: instead of a 24-hours’ duration, it would now be a four-day run to simulate an underwater crossing of the Atlantic. Arriving in Pittsburgh just after the birth of his daughter Patricia, Simpson stayed on and monitored the situation in Idaho constantly by telephone.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("By the morning of the fourth day, a nagging problem was becoming critical: there was a slight radiation leak, and Rickover’s staff were pressing him to shut down the reactor. When informed of their opinion, Rickover said, “Call John Simpson. He’s in charge.” After anxious telephone consultation with his own staff at the Idaho facility, Simpson made the decision to continue the test. A little later, the Idaho site manager called to say that he was extremely concerned and was shutting down the engine unless Simpson gave him a direct order to continue. Simpson gave the order, and the test proceeded to a successful conclusion. In 1995 Simpson would write:")]), _vm._v(" "), _c('div', {
    staticClass: "extract"
  }, [_c('p', {
    staticClass: "extractText"
  }, [_vm._v("At stake here was the future of the nuclear submarine program, certainly, but not public safety. Since there was only a small amount of fission products, even a meltdown would not have been as serious as for a power reactor that had operated for a long time… . In any event, we were not gambling with the health or safety of the public. Our gamble, if it was one, was the future of nuclear submarines as a part of the U.S. Navy. An accident on the test run could have made the project politically impossible. On the other hand, since there were many in the Navy who thought that the nuclear submarine was just too complex to be practical, not being able to make the submerged crossing could have jeopardized the program… .")]), _vm._v(" "), _c('p', {
    staticClass: "extractText"
  }, [_vm._v("It’s interesting to ponder over this episode from Rickover’s point of view. He never mentioned the run to me at any time afterwards. Why did he place the burden of command decisions on me at this critical time? Was he, uncharacteristically, just following the straight line of command? Was he buying himself some personal career insurance? He was eager to have the run completed, of course, but perhaps he feared an accident for which he would need someone to blame. Did he see me as a possible ‘fall guy’ or did he believe I was in a better position technically to make the judgement calls?")])]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("The "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Nautilus")]), _vm._v(" was soon completed and ready for sea trials. After initial operations on Dec. 30, 1954, the submarine was able to flash the message “underway on nuclear power” on Jan. 17, 1955. In May the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Nautilus")]), _vm._v(" covered 1300 miles in 84 hours underwater; to travel a mere 40 miles underwater under full power would have strained the capacity of any other submarine in the world at that time.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("When Westinghouse received a contract in 1954 to build the nation’s first nuclear reactor at Shippingport, Pa., Simpson was named manager of the project. Late in that year, Westinghouse won the contract to build the power plant for the first nuclear-powered surface ships, the aircraft carrier "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Enterprise")]), _vm._v(" and the cruiser "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Long Beach")]), _vm._v(". Simpson was soon named General Manager of the Laboratory, thus becoming the top of the chain of command in this enormous undertaking. This honor brought with it the dubious distinction of working even more closely with “the admiral”—Hyman Rickover. Later, in his fascinating book, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Nuclear Power from Underseas to Outer Space,")]), _vm._v(" Simpson included an insightful and engaging collection of anecdotes [pp. 89–91] about some trials and tribulations of working with Rickover"), _c('em', {
    staticClass: "italic"
  }, [_vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("In that same year of 1955, Simpson served as a delegate to the International Conference on the Peaceful Uses of Atomic Energy in Geneva. There he presented a paper, nominally co-authored with Admiral Rickover, on the nuclear power plant at Shippingport. The challenging years that followed brought many memorable achievements. Especially rewarding was sailing aboard the first nuclear-powered supercarrier "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Enterprise")]), _vm._v(" during its phenomenal trial run. The nuclear power plant performed so well that the escorting destroyers were unable to keep up with the huge ship in the rough seas. Even the irascible Rickover was effusive with his praise. Simpson was also there to witness the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Nautilus")]), _vm._v("’s tumultuous welcome in New York harbor following its epoch-making voyage across the Pacific and then across the North Pole to the Atlantic in 1958. Among his memorabilia is a personal telegram from Capt. W. R. Anderson, skipper of the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Nautilus")]), _vm._v(", sent from the location “Ninety North”—the Pole.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Elected a Westinghouse vice-president in 1958, he was appointed general manager of the company’s newly formed atomic power divisions in 1959. Promotions came rapidly in the years that followed. At Westinghouse he went on to become vice-president for engineering and research [1962], vice-president of the electric utility group [1963], and president of power systems [1963-ca. 1990]. A major project in those years was the Nuclear Engine for Rocket Vehicle Applications, a nuclear-powered rocket for NASA that was begun in 1959. Finally cancelled in 1972, the rocket successfully completed ground testing but never reached the stage of flight testing. This project produced much useful “spinoff” technology and may someday be revived. Most of Simpson’s energy, however, was directed toward the development and construction of commercial nuclear power plants. From 1963 to 1977, Simpson was in the forefront of Westinghouse’s domination of the field, with a total of 53 large nuclear plants built in the U.S., 42 overseas, and 83 sold by its foreign licensees. In a typical year Simpson travelled more than 150,000 miles.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("By the early 1970s, the nuclear industry was coming under increasing pressure and attack from powerful environmental forces. Simpson found the technological problems confronting him increasingly overshadowed by questions of politics and public relations. In 1995 Simpson wrote:")]), _vm._v(" "), _c('div', {
    staticClass: "extract"
  }, [_c('p', {
    staticClass: "extractText"
  }, [_vm._v("Many of the antinuclear people no doubt were sincere in their objections, though almost none had any sound technical basis for their stand. Many, however, had been anti-Vietnam war activists looking for a new cause—the Jane Fondas of the world. They found it in nuclear power, where they could raise fears of the unknown… . Still others are professional activists making their living by objecting to and blocking nuclear power.")])]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Simpson was often a point-man for nuclear power industry, debating [e.g.] on the nationwide TV program "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Advocates")]), _vm._v(". In the midst of the 1970s energy crisis, he had a notable encounter with Ralph Nader in hearings before the House-Senate Joint Economic Committee. Simpson later recalled:")]), _vm._v(" "), _c('div', {
    staticClass: "extract"
  }, [_c('p', {
    staticClass: "extractNoIndent"
  }, [_vm._v("Nader made his statement first; he raked nuclear energy over the coals and advocated conservation and new nondepletable forms of energy. The only problem with his solution was that the new forms did not exist; they still play little part in the energy picture, and conservation is no complete solution for Third World countries.")]), _vm._v(" "), _c('p', {
    staticClass: "extractText"
  }, [_vm._v("My statement was next. I pulled out all the stops with the scenario that we were for the poor and downtrodden of the Third World. We did not want to deny, as some did, all people from being able to look forward to a rising economic standard, with jobs for all …")]), _vm._v(" "), _c('p', {
    staticClass: "extractText"
  }, [_vm._v("Nader broke into my statement, saying I was attacking him. I told the chairman that Nader was right—I was attacking him—and that was the most correct statement he had made all morning.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Meanwhile, Simpson continued to accumulate honors. A member of many scientific societies, he was once again a member of the U.S. delegation to the International Conference on the Peaceful Uses of Atomic Energy in 1958. He was elected to the National Academy in Engineering [1966] and awarded the Edison Medal by the Institute of Electrical and Electronics Engineers [1971]. He received an honorary D.Sc. degree from Seton Hill College [1968] and Wofford College [1973]. He also served on the Board of Trustees of Wofford College, Seton Hall College, and Point Park College [1973], as well as the Advisory Council for Science of Notre Dame University and the Board of Governors of the National Council of Churches. He established in 1969 an endowed scholarship in honor of his brother, Carter Berkeley Simpson, at Wofford College. In 1995 the American Nuclear Society published his largely autobiographical account, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Nuclear Power from Underseas to Outer Space")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("He married [Jan. 17, 1948] Esther Katherine Slattery [born March 20, 1921; she was a R.N., serving in WW II with the 23"), _c('sup', [_vm._v("rd")]), _vm._v(" General Hospital in Europe. She was also an airplane pilot, and she died in Hilton Head Island, Beaufort Co., S.C., Aug. 6, 2004].")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("A few years after Simpson retired from Westinghouse, I first attempted to contact him by writing to the Westinghouse office in Pittsburgh [his most recent address in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("American Men and Women of Science")]), _vm._v("]. There he had just ended his distinguished career as a leading executive, but Westinghouse returned the letter, marked “addressee unknown.” I finally located him through the USNA Alumni Association in Annapolis. He was a delightful gentleman, and he was extremely generous in contributing information to this project. In fact, genealogy became one of his major interests in his retirement at Hilton Head Island, S.C., where he died Jan. 4, 2007).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23420. John Wistar Simpson, Jr. (born Oct. 11, 1948; graduated from Point Park College [Pittsburgh; B.A., 1972]. He became instructor at the Photography and Multimedia Art Institute in Pittsburgh, Pa.).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23421. Carter Berkeley Simpson.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23422. Patricia Ann Simpson.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23423. Barbara Joan Simpson. [Quotations from J. W. SIMPSON, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Nuclear Power")]), _vm._v(", 10, 39, 55–57, 198, 277–278 (see also "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("passim")]), _vm._v("). See also: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("AmM&WSci")]), _vm._v(", 1989–1990; USPRI; Special Collections and Archives Div., Nimitz Library, USNA, Annapolis, class of 1937, file #12486; "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Twenty Year Fix")]), _vm._v(" (publ. 1957 by the USNA, class of 1937), pp. 172–173; obit. of John W. Simpson, Sr., in the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("New York Times")]), _vm._v(", 1/17/2007; obit. of John Wistar Simpson posted on "), _c('a', {
    attrs: {
      "href": "http://www.wofford.edu/newsroom",
      "target": "_blank"
    }
  }, [_vm._v("www.wofford.edu/newsroom")]), _vm._v("; FGS by JWS and CCB; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11333–54752]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12949. Anne Carter Berkeley (born in Tenn., Jan. 4, 1916; graduated from Emory U. An administrative assistant at the U. of Cal.-Berkeley, she married [1"), _c('sup', [_vm._v("st")]), _vm._v(", on June 6, 1942] E. F. Chadwell, and they had no children. She later married [2"), _c('sup', [_vm._v("nd")]), _vm._v(", on Jan. 14, 1948] S. J. R. Froelick. She married [3"), _c('sup', [_vm._v("rd")]), _vm._v(", on Dec. 1, 1962] R. G. Rasmussen, by whom she had no children).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Child (by her 2"), _c('sup', [_vm._v("nd")]), _vm._v(" husband):")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23424. Robert Berkeley Froelick (born in Los Angeles Co., Cal., April 15, 1950). [L. G. TYLER, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Enc. Va. Biog.")]), _vm._v(", 5:968–969; CalBI; FGS by CCB; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11333–54772]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12950. Ethel Adelaide Clark (born in Washington, D.C., June 13, 1891; married in McDowell Co., W. Va. [June 26, 1916] Edward Franklin Hoover [born in Va., Nov. 28, 1881]. They resided in Charleston, Kanawha Co., W. Va., where he was a traveling salesman in 1930).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23425. Edward Franklin Hoover, Jr.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23426. Carolyn Clark Hoover. ["), _c('a', {
    attrs: {
      "href": "http://FamSearch.org",
      "target": "_blank"
    }
  }, [_vm._v("FamSearch.org")]), _vm._v("/W. Va. Marriages; WW I Draft Reg.; 1930 census Kanawha Co., W. Va., E.D. 69, p. 42B; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11333–71211]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12951. Orren Spotswood Clark (born in Washington, D.C., April 22, 1903; married [Aug. 14, 1926] Claudine Petty Kesler [born in Va., June 19, 1900; “Pauline” in the 1940 census, she last resided in Roanoke, Va., and she died June 1976]. He was a supervisor for a telephone company in Roanoke, Va., 1940. He last resided in Salem, Va., and he died Dec. 1, 2000).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23427. Barbara Ann Clark (born in Va., 1931).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23428. Patricia Arline Clark (born ibid., 1934). [R. HENRY, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Gen. of the Fam. of the Presidents")]), _vm._v(", 19; 1940 census Roanoke (Independent City), Va., E.D. 119–44, p. 10A; SSDI; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11333–71212]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12953. Edwin Montilla Clark (born in Va., June 24, 1900; a WW I veteran, he married [Nov. 5, 1927] Eleanor McKay [born in Pa., ca. 1901]. They resided in Crafton, Allegheny Co., Pa., 1930, where he was assistant superintendent for the Bell Telephone Company).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Child:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23429. Jane E. Clark (born in Pa., ca. June 1929). [1920 census Pittsylvania Co., Va., E.D. 34, p. 3A; 1930 census Allegheny Co., Pa., E.D. 558, p. 6A; SSDI; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11333–71232]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12963. Richard Henry Clark (born in Cleveland, Oh., Dec. 7, 1912; attended the U. of Va., 1930–1933. A career civil service with Government Accounting Office in Washington, D.C., he was a member of the City Council of both Kensington, Montgomery Co., Md. [1952–1963] and the Village of Chevy Chase View, Montgomery Co., Md. [1965–1967]. He married [Dec. 27, 1932] Lucia Rittenhouse Shoemaker [born March 22, 1915; died Sept. 29, 2003]. They resided in Kensington, Md., and he died July 4, 2001).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23430. Lucia Taliaferro Clark (born March 22, 1934).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23431. Richard David Clark.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23432. Beverley Alexander Clark. [R. HENRY, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Gen. of the Fam. of the Presidents")]), _vm._v(", 20; "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Who’s Who Gov.")]), _vm._v(", 1977; SSDI; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11333–71255]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12964. Fitzhugh Taliaferro Clark (born Jan. 18, 1917; married [Oct. 3, 1942] Geraldine J. Valera [born Aug. 4, 1913; last resided in Boyertown, Berks Co., Pa., and she died July 13, 1999]. He died Oct. 20, 1991).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23433. Margaret Walsh Clark (born 1944).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23434. Geraldine Valera Clark (born 1946). [A. M. WASHINGTON, “Living Desc. of J. Washington,” 605; SSDI; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11333–71256]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12965. Ursula Byrd Beverley (born in Va., Jan. 8, 1906; married [Oct. 17, 1932] Ashby Pattison Perry [born in N.Y., Oct. 25, 1906; a banker, he last resided in Memphis, Tenn., and he died June 10, 1989]. She last resided in Sevierville, Sevier Co., Tenn., and she died Oct. 13, 1996).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23435. Katherine Spotswood Perry (born in Tenn., July 5, 1935).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23436. Beverley Ann(e) Perry (born ibid., Feb. 27, 1939). [1940 census Shelby Co., Tenn., E.D. 98–238, p. 5A; J. McGILL, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Beverly")]), _vm._v(", 565; SSDI; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11333–71261]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12967. Mary Spotswood Taliaferro (born in Va., Dec. 26, 1899; married [May 14, 1927] William Ernest Ewers [born in W. Va., Jan. 27, 1890; he was a farm laborer]. They resided with her parents in Locust Dale, Madison Co., Va., in 1930. They resided on their own farm ibid. in 1940, and she died ca. 1949).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Child:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23437. Virginia Lee Ewers (born in Va., Aug. 19, 1928; married ___). [1930 census Madison Co., Va., E.D. 1, p. 8A; 1940 census ibid., E.D. 57–2, p. 3A; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11333–71331]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12968. Walter Ellis Aylor (born in Madison Mills, Madison Co., Va., May 28, 1896; unm., he worked in a flour mill in Culpeper Co., Va., when he registered for the draft on June 5, 1917. He later married [Feb. 26, 1930] Cecelia Seymour Lewis [born in Mexico, ca. 1908]. They resided in Arlington, Va., 1940, and he worked for the Department of Agriculture as an investigator of the commodities exchange. He last resided in Washington, D.C., and he died June 15, 1969).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23438. Barbara Taliaferro Aylor (born in Washington, D.C., Sept. 13, 1931).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23439. John Lewis Aylor (born in San Francisco Co., Cal., Oct. 11, 1934). [1940 census Arlington (Independent City), Va., E.D. 7–6, p. 9A; CalBI; SSDI; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11333–71341]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12970. Charles Stuart Waugh (born in Orange, Orange Co., Va., Jan. 12, 1878; studied at Virginia Polytechnic School, but left in 1896 before graduating. After working three years for two construction companies, he started his own business with headquarters in Orange, Va. His initial job was laying track for the Norfolk & Western Railway. By 1920 he established his headquarters in Williamson, Mingo Co., W. Va., where he developed a thriving business in railroad and highway construction. He married in Wytheville, Wythe Co., Va. [1903] Margaret Esther Porter [born in Va., ca. 1883]. He was listed as a construction contractor in Madison District, Orange Co., Va., 1910. They moved by 1920 to Williamson, W. Va., and he later resided in Oak Hill, Fayette Co., W. Va., when he registered for the draft in 1942).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23440. Charles Stuart Waugh, Jr. (born in Va., ca. 1904).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23441. Porter Eugene Waugh.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23442. Margaret W. Waugh (born ibid., ca. 1907; she was described in a published family sketch as “one of the brightest pupils at the State Deaf and Blind Institute of Virginia”).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23443. Esther P. Waugh (born in Va., ca. Feb. 1910).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23444. Julia Waugh.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23445. Lee Waugh (born Sept. 28, 1918; served in WW II as Capt., USA, and he was killed by friendly fire July 25, 1944. He was buried at Oak Hill Cemetery in Oak Hill, W. Va.). [Quotation from Anon., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Hist. of West Virginia, Old and New")]), _vm._v(", 3:70–71. See also: WW II Draft Reg.; 1910 census Orange Co., Va., E.D. 89, p. 2B; 1920 census Mingo Co., W. Va., E.D. 117, p. 22B; SSDI; FGS by TP; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11333–71411]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12971. Frances Elizabeth Waugh (born in Orange Co., Va., March 12, 1880; a member of DAR, she married in Orange Co., Va. [Oct. 23, 1901] Luther Alville “Allie” Rhoades [born at Burr Hill, Orange Co., Va., Aug. 18, 1869; as a teenager, he was unable to find work in Orange Co., Va., so he prepared to journey north. Before leaving he sought unsuccessfully to buy some items on credit at the general store located on the Culpeper side of the Rapidan River at Raccoon Ford. He stormed out with an angry vow that he would return someday and buy the store.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("He then went north, where he joined the construction crews that were building dams and power works on the Niagara River. Returning home with modest funds and extensive construction experience, he went into business with the future wife’s family, the Waughs. The new “Waugh Brothers Construction Company” won contracts to build roads in West Virginia. According to a family tradition preserved by Frances’s grandson, Andrew Gutowski:")]), _vm._v(" "), _c('div', {
    staticClass: "extract"
  }, [_c('p', {
    staticClass: "extractNoIndent"
  }, [_vm._v("One evening they were invited to a home near the construction site for dinner. During dinner a shot rang out and a bullet went into a wall of the dining room. It seems the host was in the middle of a feud with a neighbor. My grandmother soon after thought it safer to return to Orange [Va.].")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The construction company also went on to build ten miles of the Blue Ridge Parkway and portions of the first hard surfaced Route 29 to Charlottesville, among many other projects. With his share of the profits “Allie” carried out his promise to buy the general store at Raccoon Ford, along with most of the businesses in the area. He also bought the mill located on Culpeper County shore of the Rapidan River, and they initially lived in the “miller’s house” on the high bluff above the ford. Later the family moved to a home across the river, explaining why some of the children were born in Orange Co., others in Culpeper Co., Va. “Allie” went on to purchase several estates along the Rapidan River, including “Goshen Farm” and “Hall Farm.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("For the sake of their children’s education, they moved to the town of Culpeper, Va., where their home “The Rhoades House” is still standing in the historic district. A member of the Culpeper Town Council and a prominent civic leader, he was weathering the Depression and directing important construction projects when he suddenly died in Culpeper Co., Va., June 27, 1934. He was buried at Fairview Cemetery in Culpeper Co., Va.]. Frances died in Charlottesville, Va., Nov. 1, 1959).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23446. Gladys Gordon Rhoades (born in W. Va., June 26, 1902; died ca. Aug. 1902, and she was buried at the Waugh-Pannill Cemetery in Orange Co., Va.).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23447. Frances Ann Rhoades (born in Raccoon Ford, Orange Co., Va., June 29, 1905; married in Culpeper Co., Va. [July 7, 1943] Clark M. R. Stover [born in N.Y., Dec. 7, 1910; a WW II veteran, he enlisted in Buffalo, N.Y., May 24, 1943. He last resided in Sanborn, Niagara Co., N.Y., and he died Nov. 1980]. She died in Sanborn, N.Y., Jan. 1, 1984).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23448. John Alville Rhoades (born in Raccoon Ford, Orange Co., Va., June 14, 1908; married Phyllis Wicker. He died in Culpeper Co., Va., Aug. 29, 1942, and he was buried at Fairview Cemetery in Culpeper Co., Va.).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23449. Edna Elizabeth Rhoades.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23450. Zillah Marye Rhoades.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23451. Lee Alexander Rhoades.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23452. Jeanne-Stuart Rhoades (born in Raccoon Ford, Orange Co., Va., Oct. 23, 1922; married in Rockville, Montgomery Co., Md. [Nov. 16, 1946] Miles Frederick Deeg. He was a soldier, and, after meeting at a USO dance, they married a few days later. Divorced soon afterward, they had no children and Jeanne-Stuart never re-married. A member of DAR and CDA, she was an ardent genealogist and did much to preserve the family record. She died in Culpeper Co., Va., Aug. 30, 1997). [1930 census Culpeper Co., Va., E.D. 19, p. 6B; U.S. Veterans Gravesites; FGS by AWG (NSWFD member #1041); "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Va. Tech Magazine Classnotes")]), _vm._v(", 2005, online; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11333–71412]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12973. Susan Lee Waugh (born in Orange Co., Va., ca. 1884; married ibid. [Oct. 18, 1905] Roland M. Clark [born ibid., ca. 1886]. They resided in Taylor District, Orange Co., Va., 1920, where he was a railroad foreman).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23453. Gladys Clark (born in Va., ca. 1906; married James E. Walters [born in W. Va., ca. 1900]. They resided without children in Fredericksburg, Va., 1940, where he was a dentist).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23454. William Clark (born in Va., ca. 1913; married ___ Conway). [1920 census Orange Co., Va., E.D. 97, p. 1B; 1940 census Fredericksburg (Independent City), Va., E.D. 107–3, p. 21B (for Gladys and James Walters); J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11333–71414]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12974. Rowena S. Waugh (born ca. 1886; married in Orange Co., Va. [Sept. 21, 1909] Elmo E. Gardner [born ca. 1880]. She is presumably the “Rowena Gardner” listed in the SSDI as born Sept. 4, 1886, last resided in Va., and died Nov. 1965).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23455. Charles Gardner (died unm.).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23456. James Gardner (married Hilda Carpenter).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23457. Peter Gardner (married Mrs. Marie [Weekley] ___). ["), _c('a', {
    attrs: {
      "href": "http://FamSearch.org",
      "target": "_blank"
    }
  }, [_vm._v("FamSearch.org")]), _vm._v("/Va. Marriages; SSDI; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11333–71415]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12976. Goree Gooch Waugh (born Oct. 12, 1917; enlisted in the Army on Sept. 22, 1944, and he served as PFC, USA. He married Virginia Hite, and he died June 18, 1967. He was buried at Culpeper [Va.] National Cemetery).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Child:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23458. Sandra Waugh (married Walter Burton). [US Veterans Gravesites; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11333–71417]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12984. Montgomery A. Jones (born in Va., March 1893; married ___, and he resided in Ohio. According to J.A.W., he is said to have sold his oil business for $1.5 million. He is undoubtedly “Montgomery Jones, age 37, born in Va.” who appears in the 1930 census taken April 8, 1930, working as a steam shovel operator in Ashland, Boyd Co., Ky., married to Emma ___ [born in Ky., ca. 1902], with the first two children listed below. By 1935, they resided in Uhrichsville, Tuscarawas Co., Oh., and by 1940 they had moved to Moncks Corner, Berkeley Co., S.C. He is also presumably the SSDI’s “Montgomery Jones,” Social Security card issued in Oh., born March 30, 1893 and died Jan. 1963).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23459. Ruby R. Jones (born in Ky., ca. Oct. 1925).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23460-a. Helen L. Jones (born ibid., ca. Aug. 1929).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23460-b. Elizabeth A. Jones (born ibid., ca. 1932). [1930 census Ashland Co., Ky., E.D. 13, p. 12A; 1940 census Berkeley Co., S.C., E.D. 8–17, pp. 7B-8A; SSDI; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11333–71463]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12988. Harry Montgomery Waugh (born in Pa. or Va., Jan. 22, 1885; the WW I Draft Registration and 1920 census list him as a contractor for a railroad and residing in Bluefield, Mercer Co., W. Va. He married Gertrude S. [born in Ky., ca. 1891]. A family tradition preserved by J.A.W. reports that he committed suicide after losing much of his considerable wealth).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23461. Harry Montgomery Waugh, Jr. (born in Ky.).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23462. Edgar S. Waugh (born ibid., ca. April 24, 1916; last resided in Punta Gorda, Charlotte Co., Fla., and he died June 17, 1988).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23463. Gorie Waugh (daughter; born in W. Va., ca. April 1918). [WW I Draft Reg.; 1920 census Mercer Co., W. Va., E.D. 80, p. 34A; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11333–71431]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("12995. Lula A. Waugh (born in Va., Feb. 1898; married Peyton T. Roberts [born ibid., ca. 1891], and they farmed in Taylor, Orange Co., Va.).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23464. Elizabeth M. Roberts (born in Va., ca. 1922).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23465. Peyton C. Roberts (born ibid., Feb. 25, 1925; he last resided in Orange, Orange Co., Va., and he died Aug. 15, 2006).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23466. Jimmie Roberts (born in Va., ca. 1927).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23467. Lewis S. Roberts (born ibid., ca. March 1930). [1900 census Orange Co., Va., E.D. 73, p. 1B; 1930 census ibid., E.D. 9, p. 6A; SSDI; J.A.W. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11333–7147]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13000. Henry Philip Goode (born in Lenexa, Johnson Co., Kans., Jan. 1, 1909; graduated from the U. of Kans. [B.S., Industrial Engineering, 1930]. He then moved to Chicago to work for Western Electric, designing a new factory to be built in New Jersey. With the sudden onset of the Depression, plans for the factory along with Henry’s job were cancelled. He soon found himself back working on the family farm in Lenexa, Kans., and helping to remodel their new home in Lawrence, Kans. He went on to earn a M.S. in Industrial Engineering and eventually a doctorate, and worked for the American Can Company in North Kansas City, Mo. He conducted research for the U.S. military at Stanford U. from 1941 to 1952, and then taught at Southern Methodist U. until 1957. He finished his career as professor of Industrial Engineering and Operations Research at Cornell U., retiring in 1974, and was named professor emeritus. He married in Chicago, Ill. [June, 1932] Margaret Grifenstein [born in Chicago, Ill., Oct. 26, 1909; a librarian, she died in Ithaca, Tompkins Co., N.Y., July 11, 1977]. He died in Ithaca, N.Y., Feb. 14, 2004).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23468. David Joseph Goode.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23469. Erika Katheryn Goode. [SSDI; FGS by GeraldAM; J.A.W. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11333–76331, rev.]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13001. Margaret Downs Goode (born in Lenexa, Johnson Co., Kans., Nov. 6, 1910; graduated from the U. of Kans. [B.S., 1936; M.D., 1944]. She married Ray Albert Clark [born in Welsh, Jefferson Davis Parish, La., March 16, 1907; a M.D. and physician, he practiced medicine in Kansas City, Kans., prior to WW II, and then served as medical officer for the 100"), _c('sup', [_vm._v("th")]), _vm._v(" Engineers in the South Pacific. Discharged at the rank of Lt. Colonel, he opened a medical practice in Lawrence, Kans., and was later a staff physician at the Veterans Administration Hospital from 1973 until his retirement in 1977. He died in Lake Charles, Calcasieu Parish, La., April 23, 1992]. Margaret maintained a thriving medical practice in Lawrence, Kans., for over thirty years, and she died there July 14, 1978).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Child:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23470. Ray Albert Clark, Jr. [FGS by GeraldAM; J.A.W. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11333–76332, rev.]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13003. William Joseph Goode (born in Lenexa, Johnson Co., Kans., Aug. 24, 1915; graduated from the U. of Kans. [B.A., Business and Economics]. A CPA, he worked in the office of Peat, Marwick, and Mitchell in San Francisco, Cal. He married in Overland Park, Johnson Co., Kans. [May 2, 1942] Edythe Pederson [born in Kansas City, Mo., March 15, 1921; as an infant she was adopted by James and Maude (Daily) Pedersen. From their surname came her nickname “Pete.” She attended the U. of Neb. for three years, and she later became a talented photographer. She died in Carmel, Monterey Co., Cal., Dec. 24, 2007]. They resided in Overland Park, Kans., until he was transferred and became a partner of KPMG in California. They subsequently resided in Menlo Park, San Mateo Co., Cal. and later Carmel-by-the-Sea, Monterey Co., Cal., where he died Dec. 2, 1976).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23471. William Joseph Goode, Jr. (born in Kansas City, Mo., May 10, 1948; served in the Army [1971–1974], and he graduated from Oregon State U. [B.A., 1975]. He resided in Los Angeles, Cal., where he operated a computer and drafting business. He moved to Kingman, Mohave Co., Ariz., 2009, and worked in the mining business).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23472. Douglas Stuart Goode (born in Palo Alto, Santa Clara Co., Cal., Dec. 16, 1951; graduated from the U. Cal.-Davis [B.A., History and Economics, 1974]. He later resided in Glendale, Los Angeles Co., Cal., and then Monterey, Cal. He was divorced and had no children). [CalDI; FGS by GeraldAM; SSDI; FGS by GeraldAM; J.A.W. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11333–76334]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13005. Harriet Elinor Hogan [born in Kansas City, Jackson Co., Mo., Jan. 22, 1917; married in San Francisco, Cal. [Sept. 15, 1951] Harris Shane Yeates [born in Starkville, Oktibbeha Co., Miss., Aug. 3, 1916; graduated from Miss. State College (B.S.). He served in the Army, making it a career and retiring at the rank of Chief Warrant Officer. He later worked for the Zoology Department of the U. of Cal.-Berkeley, and he died in San Mateo, San Mateo Co., Cal., Nov. 25, 1982]. Elinor died in Palo Alto, Santa Clara Co., Cal., 2003).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23473. Patricia Ann Yeates (born in Cal., Sept. 12, 1951; married but later divorced, she had no children. She was a claims investigator with California Blue Cross-Blue Shield in Berkeley, Cal.).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23474. Steven Charles Yeates. [FGS by GeraldAM; J.A.W. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11333–76351, rev.]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13006. Mary Virginia Hogan (born in Kansas City, Jackson Co., Mo., Feb. 29, 1924; graduated from the U. of Kans. [B.S., Nursing, 1946]. A R.N., she married ibid. [June 21, 1947] Marcus Hoppes [born in Corbin, Sumner Co., Kans., Nov. 6, 1924; a WW II veteran, he graduated from the U. of Kans. (B.S., Petroleum Engineering, 1950). He worked as an oil production engineer with Texaco and other oil companies, retiring after a severe heart attack in 1984. He died Nov. 11, 2003]. They resided in Tulsa, Tulsa Co., Okla.).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23475. David Fulton Hoppes.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23476. Steven Marcus Hoppes (born in Lyons, Rice Co., Kans., Jan. 30, 1951; graduated from the U. of Texas-Austin [M.S. and Ph.D., Physical Education]. He married in Austin, Travis Co., Tex. [June 16, 1984] Linda Kay Bell [born in Dallas, Tex., Jan. 10, 1952; graduated from Tarleton State U., Stephenville, Tex. (M.S., Sociology). They resided at one time in Reno, Washoe Co., Nev., and in 2006 he was associate professor of Rehabilitation Sciences at the U. of Okla. By 2013 they were retired and residing in Tulsa, Okla.).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23477. Marsha Carol Hoppes.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23478. Elizabeth Sue Hoppes.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23479. Marilyn Kay Hoppes. [Agenda of the Regular Meeting of the U. of Okla. Board of Regents, May 11–12, 2006; FGS by GeraldAM; TexMI; J.A.W. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11333–76352, rev.]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13008. Ruth Lucille Williams (born April 2, 1922; graduated from Seattle Pacific College [now U.; B.S., Mathematics, 1948]. She taught elementary and high school in Kansas and Arizona. She was also a school secretary and taught Physical Education at a college for two years. For ten years, she was secretary at the Light and Life Christian School in Phoenix, Ariz., and for nineteen years the volunteer treasurer at the Light and Life Free Methodist Church in Phoenix, Ariz. She married in McPherson, McPherson Co., Kans. [Dec. 27, 1949] Lester Howard Finger [born in Campbell, Hunt Co., Tex., Aug. 11, 1923; attended Greenville College, 1943. He then entered the Navy and became a pilot. He was stationed in the U.S. and also aboard the carrier "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Franklin D. Roosevelt")]), _vm._v(". After an honorable discharge in 1949, he graduated from McPherson College [B.S., 1950] and Oklahoma A&M [now Okla. State U.; M.S., 1952]. He later became a high school teacher and football coach. In 1959 he coached Phoenix Christian High School to a state championship in football and he was named both the Arizona AP and the Interscholastic Association Coach of the Year. He then taught and coached at Coronado High School in Scottsdale, Ariz., for 26 years. He died July 23, 2013]. They resided in Phoenix, Ariz., and Ruth generously contributed information on her family).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23480. Mary Catherine Finger.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23481. Barbara Jean Finger.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23482. Nancy Marie Finger.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23483. Naomi Ruth Finger.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23484. Carol Ann Finger. ["), _c('a', {
    attrs: {
      "href": "http://www.greenville.edu/events",
      "target": "_blank"
    }
  }, [_vm._v("www.greenville.edu/events")]), _vm._v("; obit. of Lester H. Finger from the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Arizona Republic")]), _vm._v(", 7/28/2013; FGS by RWF and GeraldAM; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11333–76381, rev.]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13009. Charles George Williams (born in Kansas City, Wyandotte Co., Kans., March 22, 1925; graduated from McPherson [Kans.] College [B.A., 1948] and Asbury Theological Seminary in Wilmore, Ky. [M. Divinity and D. Divinity]. A Free Methodist minister, he was pastor for churches in Michigan and Arizona, later serving as vice-president at both Los Angeles Pacific College [later merged with Azusa Pacific College] and Spring Arbor College in Spring Arbor, Mich. He then worked as a director, vice-president, and consultant for the Lilly Endowment in Indianapolis, Ind., and as a volunteer interim pastor for the newly formed John Wesley Free Methodist church. In the final years of his career, he was assistant to the president of the National Cities in School, and then executive director of Cities in School in Casa Grande, Pinal Co., Ariz. He married in McPherson, McPherson Co., Kans. [1"), _c('sup', [_vm._v("st")]), _vm._v(", on Sept. 20, 1945] Bessie Victoria Fairbairn [born in Ontario, Canada, Jan. 9, 1924; after her husband’s death, she resided in Lakeland, Polk Co., Fla., and Topeka, Shawnee Co., Kans.]. Following a divorce, he later reconciled with his ex-wife, whom he married a second time on Jan. 14, 1990. Six days later he died in Norwalk, Fairfield Co., Conn., Jan. 20, 1990).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23485. Charles Fairbairn Williams.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23486. Richard Dean Williams. [SSDI; FGS by GeraldAM, Helen W. Miller, and RWF; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11333–76382, rev.]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13010. Mary Nell Williams (born in Kansas City, Wyandotte Co., Kans., May 8, 1931; graduated from Seattle Pacific College [now U.] and the U. of Washington [B.S. Nursing, 1957]. A R.N., she married [June 21, 1958] Alfred W. Bauer [born in Germany, July 12, 1923; a M.D. and physician, he was a pediatrician in Seattle, Wash. He died in Kirkland, King Co., Wash., Jan. 10, 1998]. Later divorced in 1975, she resided in Edmonds, Snohomish Co., Wash., working as a school nurse. She retired in 1993 and later moved to Tucson, Pima Co., Ariz., in 2000).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23487. John Peter Bauer (born in Seattle, Wash.; graduated from Seattle U. [B.S., Nursing], and he resided in Tucson, Ariz.).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23488. Bettina Marie Bauer.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23489. Stephen Erik Bauer. [FGS by GeraldAM and Helen I. Miller; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11333–76383, rev.]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13011. Helen Irene Williams (born July 19, 1934; graduated from Seattle Pacific College [now U.; B.A., 1956]. A teacher and secretary, she was later executive assistant to the CEO of Hill’s Pet Nutrition, a Division of Colgate Palmolive Company, until her retirement in 1996. She married in Salina, Saline Co., Kans. [June 28, 1957] Gerald Alva Miller [born in Crawford, Dawes Co., Neb., Nov. 1, 1932; graduated from Chadron (Neb.) State College (B.S., Education) and U. of Kans. (M.S., Educational Psychology and Guidance). He was a teacher and guidance counselor, and later Director of Demographics for the Topeka Public Schools until his retirement in 1993. One of his major projects was collaborating with schools, administrators, and school boards to design a desegregation plan that was approved the Tenth Circuit Court in Denver, Colo.]. Gerald and Helen researched and published two copyrighted genealogical books about his ancestors and their descendants: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("History of the Skoglund-Svensson-Smith Family: From Sweden to the American Plains, 1847–1992")]), _vm._v(" [published 1993] and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Hawthorne Heritage and Family History—The Life and Descendants of James and Nancy [Clark] Hawthorne, 1774–2006")]), _vm._v(" [published 2007]. They also joined in conducting extensive genealogical research on Helen’s family, which they generously contributed]. They resided in Topeka, Shawnee Co., Kans.).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23490. David Gerald Miller.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23491. Sharon Irene Miller. [G. and H. MILLER, “Rev. H. D. P. Hogan,” 21; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11333–76383, rev.]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13023. Louise Gosey (born in Tenn., ca. 1904; married in Davidson Co., Tenn. [April 11, 1921] Louis Hamlett [born in Tenn., ca. 1889]. They resided in Davidson Co., Tenn., 1930, where he was a machinist for a railroad. She died in Antioch, Davidson Co., Tenn., Nov. 20, 1990).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23492. Thomas M. Hamlett (born in Tenn., ca. Feb. 1922).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23493. Andrew L. Hamlett (born ibid., ca. 1923).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23494-a. James A. Hamlett (born ibid., ca. 1927).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23494-b. Margaret L. Hamlett (born ibid., ca. 1931). [R. HENRY, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Gen. of the Fam. of the Presidents")]), _vm._v(", 22; "), _c('a', {
    attrs: {
      "href": "http://FamSearch.org",
      "target": "_blank"
    }
  }, [_vm._v("FamSearch.org")]), _vm._v("/Tenn. Marriages; 1920 census Davidson Co., Tenn., E.D. 113, p. 17A; 1930 census ibid., 216, p. 26A; 1940 census ibid., E.D. 19–22, p. 12A; SSDI; B. C. NOONAN, website “Desc. of Edward III”; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11333–76911]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13033. Ewing Chadwell Drumwright, Jr. (born in Tenn., ca. 1922; married in Williamson Co., Tenn. [June 6, 1948] Thelma Irene Cutrell [born in Tenn., Dec. 17, 1923]).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23495. Barbara Ann Drumwright.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23496. David Neal Drumwright.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23497. Richard Alvin Drumwright. [1930 census Davidson Co., Tenn., E.D. 218, p. 2B; TennMI; R. E. RAY, website “Desc. of (?) Cutrell”]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13048. Burnham Spottswood (daughter; born in Washington, D.C., 1948; graduated from Clark U. [B.A., International Relations, 1970] and U. of Maryland [M. Technical Management, 1998]. She received certificates in editing publications [George Washington U., 1974] and project management [Wharton Business School, 1980]. She married [Oct. 25, 1970] Jerome Samuel Morse [born in Worcester, Worcester Co., Mass., Feb. 25, 1947; graduated from Clark U. (B.A., International Relations, 1969; Phi Beta Kappa) and George Washington U. (M.A., International Affairs, 1971). He worked for the U.S. Department of Commerce in Washington, D.C., as an international trade specialist (1970–1978), deputy director of the Export Awareness Division (1978–1982), deputy director of the World’s Fair staff (1982–1984), project manager of Trade Development (1984–1992), director of the Planning and Management Division (1992–2002), and director of Office Machinery, beginning 2002. He was the recipient of a Congressional Fellowship from the American Political Science Association (1979), and he was vice-president of Multinational Marketing Associates (1986–1990). He was the author of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Complete Guide to Operating an Import/Export Business")]), _vm._v(" (1989)]. They resided in McLean, Fairfax Co., Va., and Bethany Beach, Sussex Co., Dela.).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23498. Jordana Eve Morse.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23499. Alexander Lewis Morse. [According to "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Who’s Who Am")]), _vm._v("., 2004, Burnham (and apparently her parents) changed the spelling of their name to Spo"), _c('span', {
    staticClass: "underline"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("tt")])]), _vm._v("swood; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11333–91651]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13049. William Augustus Devin, Jr. (born in Oxford, Granville Co., N.C., May 21, 1904; graduated from the U. of N.C.-Chapel Hill [A.B., 1926], where he was subsequently a post-graduate law student [1926–1928]. Admitted to the North Carolina state bar in 1928, he maintained a private practice in Durham [1928–1930] and Hickory [1930–1940], N.C. During this period he was also general counsel to several large mortgage corporations. In 1940 he moved to Washington, D.C., where he was head attorney for the Home Owners’ Loan Corporation [1940–1942]. He then worked as counsel, later assistant general counsel, for the Residential Finance Corp. [1942–1957] and the Federal Facilities Corp., both in Washington, D.C. Next he was assistant chief counsel, later counsel in the U.S. Department of the Treasury [beginning 1957]. He married in Greensboro, Guilford Co., N.C. [April 30, 1935] Margaret Peyton Jarboe [born in Greensboro, N.C., Nov. 1, 1909]. They resided in Silver Spring, Montgomery Co., Md.).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23500. Virginia Peyton Devin.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23501. William Augustus Devin III.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23502. Robert Spottswood Devin.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23503. Margaret Lewis Devin. ["), _c('em', {
    staticClass: "italic"
  }, [_vm._v("NCAB")]), _vm._v(", 46:135–136; "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Who’s Who Am")]), _vm._v("., 1980–1981; PEYTON SOC. OF VA., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Peytons of Va")]), _vm._v("., 2:509, 533; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11333–93211]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13052. Lucy Spotswood Allen (born March 10, 1911; daughter of a U.S. Naval officer, she married in St. John’s University Chapel in Shanghai, China [Oct. 17, 1933] William Young Allen, Jr. [born in San Antonio, Tex., Feb. 29, 1908; attended Sam Houston College in Huntsville (Tex.), 1925–1926, and then entered the USNA, Annapolis. There he was commander of the 6"), _c('sup', [_vm._v("th")]), _vm._v(" Company, Captain of the varsity lacrosse team, and was named All-American in 1929. After graduating from the Naval Academy in 1930, he served aboard the cruiser "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Houston")]), _vm._v(", flagship of the Asiatic fleet. Returning to the U.S. in 1934, he served as 1"), _c('sup', [_vm._v("st")]), _vm._v(" Lt. aboard the destroyer "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("MacDonough")]), _vm._v(" for two years before enrolling for post-graduate study at the USNA, Annapolis, and later the Field Officer’s School at Quantico, Va.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("In June 1939, he reported to Pearl Harbor in Hawaii for duty aboard the battleship "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Maryland")]), _vm._v(", and he was among the survivors when that ship was attacked and sunk in the Japanese attack on Dec. 7, 1941. By the summer of 1942, he was attending Fleet Sonar School in Key West, Fla., and that fall was hunting U-Boats in the Atlantic in command of the Destroyer "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Noa")]), _vm._v(". In April 1943, he reported to the Consolidated Steel Corp. in Orange, Tex., to superintend the outfitting of the Destroyer "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Wickes")]), _vm._v(", and became her first commanding officer when she was commissioned June 16, 1943. He was awarded the Bronze Star with Combat “V” for his service while commanding this ship against Japanese forces in the Kurile Islands, March 3–5 and June 13–26, 1944.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("After returning to the U.S. in July 1944, he became assistant operations officer on the staff of the Commander-in-Chief of the U.S. Fleet in Washington, D.C. From May 1946 to the end of 1947, he was commanding officer of the U.S. Naval Ammunition Department in Guam, and he then attended the Fleet Sonar and Combat School in San Diego. He next commanded Destroyer Division 132 in the U.S. Pacific Fleet before returning to the U.S. to become Ordnance Member on the Naval Board of Inspection with headquarters in San Francisco. In May 1952, he took command of the Destroyer "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Renville")]), _vm._v(", which operated off the coast of Korea in the final year of the Korean War.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("He taught Naval ROTC at Rice U. in Houston from Oct. 1953 to the summer of 1956, when he took command of the destroyer "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("H. W. Butner")]), _vm._v(". He retired the following year at the rank of Rear Admiral, and then taught physics and mathematics at St. Stephen’s Episcopal Prep School in Austin, Travis Co., Tex., where he died Nov. 5, 1973]. His wife Lucy is listed as his widow in his USN “Report of Casualty” [i.e., official death notice] in his USNA file at Annapolis, which also states that he died of a heart attack in Austin, Travis Co., Tex., and lists his children as “Lucy P. S. Allen, Meredith A. Edwards, and William A. C. Allen,” all of Austin, Tex. His obituary in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Shipmate")]), _vm._v(" states that he died in Annapolis, Md., and that “[a]mong his survivors is his daughter, Mrs. Dennis D. Neary, 4267 Hillview Dr., Pittsburg, CA 94565”).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23504. Lucy Page Spotswood Allen (born Nov. 5, 1942).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23505. Meredith R. Allen (daughter; born Sept. 5, 1945; married ___ Edwards, and they resided in Austin, Tex.).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23506. William Alexander Cato Allen (born Nov. 29, 1948). [File of W. Y. Allen, Jr., class of 1930, Nimitz Library, USNA, Annapolis, including obit. in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Shipmate")]), _vm._v(", March, 1974; T. ROSCOE, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("U.S. Destroyer Operations")]), _vm._v(", 402, 544; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11333–93311]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13053. Molly Castle (born in N.Y., April 23, 1915; married Arthur Otis Poole. They long resided in Rochester, Monroe Co., N.Y., where for many years she taught typing at the Harley School. She retired in Annapolis, Anne Arundel Co., Md., where she died Nov. 5, 2007).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Child:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23507. Barbara Poole (married ___ von Schilcher. She resided in Arnold, Anne Arundel Co., Md., and they had two children). ["), _c('em', {
    staticClass: "italic"
  }, [_vm._v("NCAB")]), _vm._v(", 51:76–77; 1930 census Monroe Co., N.Y., E.D. 83, p. 9B; obit. of Molly Castle Poole in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The (Annapolis, Md.) Capital")]), _vm._v(", 11/10/2007; USPRI; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11333–93321]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13056. Spotswood Isted Quinby (born in Solano Co., Cal., June 29, 1926; married [Feb. 1947] Mary Jane Hyman [born May 3, 1927]. He last resided in Rockville, Montgomery Co., Md., and he died April 1981).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23508. Karen Bassett Quinby (born 1948).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23509. Katherine Marion Spotswood Quinby (born 1950).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23510. Spotswood Isted Quinby, Jr. (born 1954; resided in Bethesda, Montgomery Co., Md.). [CalBI; SSDI; USPRI; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11333–93331]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13065. Nora E. Pannill (born in Va., ca. 1906; married in Orange Co., Va. [April 21, 1926] William W. Brooking [born in Va., ca. 1899]. They farmed in Madison District, Orange Co., Va., and they had four or five children).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children (partial list):")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23511. Edna Mae Brooking (born in Va., ca. March 1927).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23512. Willie W. Brooking, Jr. (daughter; born ibid., ca. Oct. 1928). ["), _c('a', {
    attrs: {
      "href": "http://FamSearch.org",
      "target": "_blank"
    }
  }, [_vm._v("FamSearch.org")]), _vm._v("/Va. Marriages; 1930 census Orange Co., Va., E.D. 7, pp. 2B-3A; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11333-c3222]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13082. William Clyde Johnson (born July 13, 1920; married [Dec. 25, 1943] Marie Blackwell).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23513. Cynthia Jill Johnson (born 1950).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23514. Jacquelin Marie Johnson (born 1953). [J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11333-c3441]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13084. Alexander Spotswood (born April 13, 1943; married [1"), _c('sup', [_vm._v("st")]), _vm._v(", on June 12, 1965] Joyce Ann Seay [born 1947]. Later divorced, he married [2"), _c('sup', [_vm._v("nd")]), _vm._v(", on Jan. 1, 1981] Mrs. Judith R. [Bennett] ___ [born July 10, 1950]).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23515. Alexander Spotswood, Jr. (born 1969).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23516. Jennifer Kirk Spotswood (born 1971). [J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11333-c3461]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13085. Robert Halsey Spotswood (born July 12, 1934; married [June 10, 1952] Jean Clatterbuck).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Child:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23517. Rocky Spotswood (born 1953). [J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11333-c3471]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13087. Bertie (or Bettie) Lou Eaton (born in Ga., April 12, 1929; married [June 7, 1946] John G. Carpenter).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Child:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23518. Bertie Lynn Carpenter (born 1949). [1940 census Orange Co., Va., E.D. 69–3, p. 3B; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11333-c3481]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13088. William Quarles Crichlow (born in Murfreesboro, Rutherford Co., Tenn., Aug. 1, 1917; married in Nashville, Tenn. [Aug. 3, 1940] Sarah Adeline Thweatt [born in Nashville, Tenn., April 7, 1919; died in Fort Meyers, Lee Co., Fla., Dec. 13, 1974]. He died in Decatur, DeKalb Co., Ga., Dec. 2, 1994).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23519. Sarah Adeline Crichlow.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23520. William Quarles Crichlow, Jr.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23521. John Crichlow (born and died Aug. 4, 1951).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23522. Robert Thweatt Crichlow. [MONTGOMERY CO. HIST. SOC., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Montgomery Co. Family History Book")]), _vm._v(", 277; FlaDI; GaDI; SSDI; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(" 11333-c4411, rev.]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13089. Emily Louise Crichlow (born in Murfreesboro, Rutherford Co., Tenn., Nov. 13, 1919; married ibid. [May 13, 1950] Andrew Carroll Buddenhagen [born in Brooklyn Heights, Cuyahoga Co., Oh., Jan. 23, 1917; a veteran of WW II, he served as an Army engineer in the China-Burma-India Theater and later helped in the reconstruction effort in Germany. After retiring as a civil engineer with the USA Corps of Engineers, he taught at Mary Institute in St. Louis, Mo. He last resided in Marietta, Cobb Co., Ga., where he died Feb. 15, 2005]. She died in Marietta, Ga., March 30, 1995).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23523. Martha Elizabeth Buddenhagen.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23524. Jessee Louisa Buddenhagen (born in Germany, 1954; resided in Marietta, Ga., 2005).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23525. Emily Ann Buddenhagen (born in Murfreesboro, Tenn., 1961; married ___ Brunmeier, and they resided in Denver, Colo., 2005, where they had one child: Matthew Brunmeier). [MONTGOMERY CO. HIST. SOC., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Montgomery Co. Family History Book")]), _vm._v(", 277; obit. of A.C. Buddenhagen on "), _c('a', {
    attrs: {
      "href": "http://http://www.jenningsandayers.com",
      "target": "_blank"
    }
  }, [_vm._v("http://www.jenningsandayers.com")]), _vm._v("/OBITS; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(" 11333-c4412, rev.]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13090. Newton Collier Crichlow, Jr. (born in Murfreesboro, Rutherford Co., Tenn., March 6, 1927; married in McMinnville, Warren Co., Tenn. [1957] Martha Elizabeth Ramsey [born in McMinnville, Tenn., Aug. 1918]).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23526. Newton Collier Crichlow III (born in Murfreesboro, Tenn., 1959).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23527. Martha Elizabeth Crichlow (born ibid., 1961). [MONTGOMERY CO. HIST. SOC., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Montgomery Co. Family History Book")]), _vm._v(", 277; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(" 11333-c4413, rev.]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13091. Martha Elizabeth Crichlow (born in Murfreesboro, Rutherford Co., Tenn., Sept. 3, 1933; married Lawrence J. Tierney, and she died in Fulton Co., Ga., Dec. 24, 1983).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23528. Bruce Tierney.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23529. Emily Tierney.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23530. Patrick Tierney. [MONTGOMERY CO. HIST. SOC., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Montgomery Co. Family History Book")]), _vm._v(", 277; GaDI; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(" 11333-c4414, rev.]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13093. Kenneth Reed Quarles (born in Mich., June 11, 1923; married [ca. 1942] Norma Johnson. He last resided in Owosso, Shiawassee Co., Mich., and he died Nov. 13, 2000).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23531. Camolin (sic) Quarles.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23532. Francis Quarles.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23533. Kimberly Quarles. [SSDI; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(" 11333-c4422, rev.]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13094. Norma Jean Quarles (born in Mich., Oct. 1927; married [ca. 1944] Edward Matzkanin, and they resided in Yuma, Yuma Co., Ariz.).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23534. S. Matzkanin.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23535. Nancy Matzkanin.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23536. Russell Matzkanin.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23537. Raymond Matzkanin. [USPRI; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(" 11333-c4423, rev.]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13096. Henrietta Sarah (Fitzhugh) Russell (born in La., Oct. 21, 1891 or 1892; married [Nov. 26, 1913] Frank Field Courts [born in New Orleans, La., Feb. 27, 1888; died Nov. 24, 1950]. They resided in New Iberia, Iberia Parish, La., 1930, where he was a sugar farmer. She last resided in New Iberia, La., and she died March 9, 1983).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23538. Katherine Sarah Courts (born in New Iberia, La., March 13, 1915; married [Sept. 4, 1937] Clarence DeLabraten Ferrero [born Aug. 5, 1903; "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("d.s.p.")]), _vm._v(" Nov. 6, 1954]).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23539. Frank Russell Courts. [F. VIRKUS, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("CAG")]), _vm._v(", 5:63; R. HENRY, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Gen. of the Fam. of the Presidents")]), _vm._v(", 23; 1930 census Iberia Parish, La., E.D. 9, p. 12B; SSDI; "), _c('a', {
    attrs: {
      "href": "http://Anc.com",
      "target": "_blank"
    }
  }, [_vm._v("Anc.com")]), _vm._v("/New Orleans Birth Records; FGS by KRC; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11334–11212]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13097. Archibald Quarrier Brockenbrough (born in Louisville, Jefferson Co., Ky., Jan. 4, 1866; married [1"), _c('sup', [_vm._v("st")]), _vm._v(", on Aug. 9, 1909] Frances Welsch Britton [born Aug. 24, 1878; died July 24, 1918]. He married [2"), _c('sup', [_vm._v("nd")]), _vm._v("] Marian Louise Clark [born 1875; "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("d.s.p.")]), _vm._v(" Oct. 6, 1946]. He resided on Madison Avenue in New York City, and he died Nov. 25, 1935).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children (by his 1"), _c('sup', [_vm._v("st")]), _vm._v(" wife):")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23540. Henrietta Quarrier Brockenbrough.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23541. Frances Britton Brockenbrough. [R. HENRY, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Gen. of the Fam. of the Presidents")]), _vm._v(", 23; B. C. NOONAN, website “Desc. of Edward III”; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11334–11311]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13098. May Fitzhugh Brockenbrough (born in Louisville, Jefferson Co., Ky., June 1, 1868; married [Oct. 19, 1899] George Robert Evans [born in Vt., Feb. 23, 1863; graduated from the USNA, Annapolis, 1885. He served in both the Atlantic and Pacific fleets aboard many ships, including the battleship "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Oregon")]), _vm._v(" and cruisers "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Chicago")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Cincinnati. ")]), _vm._v("He attained rank of Capt., USN, and he died April 20, 1931]).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23542. Brockenbrough Evans.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23543. May Fitzhugh Brockenbrough Evans (born in N.Y., March 8, 1903; married Shermer Douglas Brunt [born in Somerville, Somerset Co., N.J., Jan. 22, 1893; he was unm. and working as a bank clerk in Somerville, N.J., when he registered for the draft on June 5, 1917. He later worked for a shipbuilding company in Philadelphia, Pa., when he registered for the draft April 27, 1942]). [R. HENRY, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Gen. of the Fam. of the Presidents")]), _vm._v(", 23; 1920 census Washington, D.C., E.D. 271, p. 5B; Nimitz Library, USNA, Annapolis, file of George R. Evans; WW I Draft Reg.; WW II Draft Reg.; B. C. NOONAN, website “Desc. of Edward III”; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11334–11312]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13101. Archibald Belknap Quarrier (born in Ky., Nov. 27, 1873; married [Oct. 23, 1902] Frances Price Thompson [born in N.J., Nov. 8, 1879; died Dec. 1967]. They resided in Manhattan, New York, N.Y., 1910 and 1930, and Millburn, Essex Co., N.J., 1920. He was an engineer for a power company, and he died in New York, N.Y., Feb. 26, 1956).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23544. Archibald Monroe Quarrier (born in N.J., Aug. 23, 1903; graduated from Yale, where he excelled as a member of the crew team. In 1924 he was a member of the world champion crew team, winners of the men’s rowing gold medal at the Olympic Games in Paris, France. He died unm. May 1928).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23545. Sidney Sayre Quarrier.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23546. Fitzhugh Quarrier (born in Short Hills, Essex Co., N.J., Nov. 24, 1912; married in Englewood, Bergen Co., N.J. [June 12, 1941] Louise Vanderbilt [born in Englewood, N.J., Dec. 4, 1915; died in New Canaan, Conn., Aug. 18, 2007]. He died in New Canaan, Conn., Feb. 26, 2005. They had five children: William Quarrier, John Vanderbilt Quarrier, Keith Quarrier, Nicholas Quarrier, and Marian Quarrier). [R. HENRY, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Gen. of the Fam. of the Presidents")]), _vm._v(", 23; A. M. WASHINGTON, “Living Desc. of J. Washington,” 621; 1910 census Manhattan, N.Y., E.D. 1158, p. 2A; 1920 census Essex Co., N.J., E.D. 73, p. 27A; 1930 census Manhattan, N.Y., E.D. 1069, p. 13B; "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Bridgeport Conn. Telegram")]), _vm._v(", Sat., Oct. 22, 1927, p. 28; B. C. NOONAN, website “Desc. of Edward III”; "), _c('a', {
    attrs: {
      "href": "http://http://www.rowinghistory.net",
      "target": "_blank"
    }
  }, [_vm._v("http://www.rowinghistory.net")]), _vm._v("; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11334–11332, rev.]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13105. Theodorick Fitzhugh Murray (born in La., June 1899; married [Sept. 1928] Viola Hughes [born ibid., ca. 1906]. They resided with her parents in New Iberia, Iberia Parish, La., 1930, where he was an insurance agent).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23547. Mary Virginia Murray (born in La., ca. Oct. 1929; married John Ralston, and they had one child: Katherine Murray Ralston). [1930 census Iberia Parish, La., E.D. 11, p. 21B; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11334–11523]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13108. Susan F. Bell (born in La., Nov. 1874; married David B. Elliott [born in England, ca. 1878; immigrated to the U.S. in 1900 and became a naturalized citizen in 1917. He resided as a widower in Houston, Tex., 1920, where he worked as a yard foreman for a railroad]. She died "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ante")]), _vm._v(" 1920).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23548. Margaret Annie Elliott (born in Tex., ca. 1906; married Rodney Payten, and they had one daughter).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23549. Elizabeth Marsh Elliott (born ibid., ca. 1908; married Frederick Windisch. They had one daughter: Elizabeth Susan Windisch [born in Harris Co., Tex., Dec. 31, 1929]).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23550. David Bell Elliott (born in Tex., ca. 1912; married ___).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23551. Henrietta Bell Elliott (born ibid., ca. 1913).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23552. Mary Ashton Elliott (born ibid., ca. 1914). [1900 census Iberia Parish, La., E.D. 35, p. 18A; 1920 census Harris Co., Tex., E.D. 86, p. 5B; TexBI; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11334–11532]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13113. Willis F. Wilson (daughter; born in W. Va., May 1888; married [1"), _c('sup', [_vm._v("st")]), _vm._v("] Clement Barksdale Lathrop [born in Va., ca. 1883; vice-president of a building materials company, he died 1930, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("post")]), _vm._v(" April 15, 1930]. They resided in Richmond, Va., 1930, and later as a widow she married [2"), _c('sup', [_vm._v("nd")]), _vm._v("] Hiram Moore Smith, although they were later divorced).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children (by her 1"), _c('sup', [_vm._v("st")]), _vm._v(" husband).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23553. Clement Barksdale Lathrop, Jr.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23554. Henrietta Lathrop (born in Va., ca. 1913; married Thomas Ayers. Later divorced, she "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("d.s.p.")]), _vm._v(" ca. 1980. She is presumably the SSDI’s “Henrietta Ayers, born Sept. 25, 1913, last resided in Richmond, Va., and died July 1978”).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23555. Willis Wilson Lathrop. [R. HENRY, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Gen. of the Fam. of the Presidents")]), _vm._v(", 24; A. M. WASHINGTON, “Living Desc. of J. Washington,” 623; 1900 census Kanawha Co., W. V., E.D. 47, p. 17B; 1920 census Henrico Co., Va., E.D. 80, p. 7A; 1930 census ibid., E.D. 51, p. 34A; SSDI; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11334–11612]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13115. Sarah Katherine Cotton (born in W. Va., Jan. 12, 1893; married in Kanawha Co., W. Va. [Dec. 10, 1913] Samuel Lightfoot Flournoy, Jr. [born in Romney, Hampshire Co., W. Va., Jan. 7, 1886; a lawyer, he died May 17, 1961]. They resided in Charleston, Kanawha Co., W. Va., 1930, and she died Oct. 3, 1987).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23556. Nancy Margaret Flournoy.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23557. Samuel Lightfoot Flournoy III (born in W. Va., March 23, 1924; married [June 14, 1964] Virginia May [McManaway] Cox [born May 12, 1921]). [R. HENRY, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Gen. of the Fam. of the Presidents")]), _vm._v(", 24; "), _c('a', {
    attrs: {
      "href": "http://FamSearch.org",
      "target": "_blank"
    }
  }, [_vm._v("FamSearch.org")]), _vm._v("/W. Va. Marriages; 1930 census Kanawha Co., W. Va., E.D. 51, p. 4A; WW II Draft Reg.; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11334–11631]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13117. Mary Ashton Cotton (born in W. Va., Feb. 2, 1898; married John Michael Gallagher [born March 7, 1894]. She last resided in New Braunfels, Comal Co., Tex., and she died in Bexar Co., Tex., Oct. 29, 1985).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23558. John Michael Gallagher, Jr.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23559. Ashton Cotton Gallagher (born 1931; married [Oct. 26, 1968] Lawrence Conques [born Feb. 22, 1922; he retired as Colonel, USAF]. They had no children). [SSDI; TexDI; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11334–11633]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13122. Sarah Fitzhugh Donnally (born in W. Va., March 11, 1884; married in Charleston, Kanawha Co., W. Va. [1907] Lester Lorenzo Sheets [born in Ind., Sept. 30, 1879; worked as a traveling agent for a mining supplies company]. They resided in Charleston, W. Va., and she died March 6, 1932).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23560. Granville Donnally Sheets (born in W. Va., Nov. 13, 1908; a WW II veteran, he enlisted at Fort Thomas, Ky., Feb. 13, 1942. He married in Kanawha Co., W. Va. [1946] Dorothy Robinson Watson, and they resided in Charleston, W. Va., where he died Sept. 22, 1990. They had two children).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23561. William Boyd Sheets (born in W. Va., Feb. 18, 1922; married___ Richardson. He last resided in Charleston, W. Va., and he died March 1986. They had at least one child).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23562. Dorothy Donnally Sheets (born in W. Va., June 25, 1927). [R. HENRY, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Gen. of the Fam. of the Presidents")]), _vm._v(", 24–35; "), _c('a', {
    attrs: {
      "href": "http://FamSearch.org",
      "target": "_blank"
    }
  }, [_vm._v("FamSearch.org")]), _vm._v("/W. Va. Marriages; 1920 census Kanawha Co., W. Va., E.D. 109, p. 3B; 1930 census ibid., E.D. 72, p. 22B; WW II AER; WW II Draft Reg.; SSDI; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11334–11661, rev.]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13123. John Cotton Donnally (born in W. Va., June 8, 1885; attended Phillips-Exeter Academy and graduated from the U. of Va. A veteran of WW I, he married [March 1, 1923] Mary Annetta Myers [born in Mont., March 13, 1900; died Nov. 20, 1990]. In 1930 they resided in Washington, D.C., where he had a private law practice. He died March 1947).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23563. Mary Annetta Donnally.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23564. Henrietta Lee Donnally (born in Washington, D.C., March 30, 1933; she died apparently unm. Jan. 3, 1973). [R. HENRY, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Gen. of the Fam. of the Presidents")]), _vm._v(", 25; A. M. WASHINGTON, “Living Desc. of J. Washington,” 608; 1930 census Washington, D.C., E.D. 162, p. 4B; 1940 census ibid., E.D. 1–214, p. 8B; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11334–11662]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13127. Henry Fitzhugh Donnally (born in Charleston, Kanawha Co., W. Va., May 3, 1892; a veteran of WW I, he married in Kanawha Co., W. Va. [1920] Erdena McGraw [born in Kanawha Co., W. Va., July 4, 1892]. They resided in Loudoun District, Kanawha Co., W. Va., where he was a life insurance agent in 1930 and deputy county assessor in 1940. He last resided in Boynton Beach, Palm Beach Co., Fla., where he died March 1, 1977).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23565. Sallie Ashton Donnally (born in W. Va., July 21, 1922; married ___ Partridge. She last resided in Allentown, Lehigh Co., Pa., and she died June 1, 1997).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23566. Henry Fitzhugh Donnally, Jr. (born in W. Va., April 27, 1927).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23567. Susan Cotton Donnally (born ibid., ca. 1937; married ___). [R. HENRY, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Gen. of the Fam. of the Presidents")]), _vm._v(", 25; A. M. WASHINGTON, “Living Desc. of J. Washington,” 608; "), _c('a', {
    attrs: {
      "href": "http://FamSearch.org",
      "target": "_blank"
    }
  }, [_vm._v("FamSearch.org")]), _vm._v("/W. Va. Marriages; 1930 census Kanawha Co., W. Va., E.D. 72, p. 22B; 1940 census ibid., E.D. 20–101B, p. 2A; WW II Draft Reg.; SSDI; FlaDI; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11334–11666]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13130. Fitzhugh Donnally (born in W. Va., July 26, 1897; a veteran of WW I, he married [July 10, 1920] Ruth Turner [born in Ky., July 15, 1899; died March 14, 1963]. They resided in Fairmont District, Marion Co., W. Va., 1930, where he worked as an electrical engineer for a coal mine. He last resided in Bethesda, Montgomery Co., Md., and he died July 1987).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23568. Fitzhugh Donnally, Jr.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23569. Andrew Van Bibber Donnally. [R. HENRY, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Gen. of the Fam. of the Presidents")]), _vm._v(", 25; A. M. WASHINGTON, “Living Desc. of J. Washington,” 608; 1930 census Marion Co., W. Va., E.D. 13, p. 3B; SSDI; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11334–11669]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13131. Robert Ashton Donnally (born in W. Va., Aug. 18, 1899; married in Kanawha Co., W. Va. [1"), _c('sup', [_vm._v("st")]), _vm._v(", in 1923] Isabel Dixon Smiley [born ibid., ca. 1906]. They resided with his parents in Charleston, Kanawha Co., W. Va., 1930, where he was a hotel clerk. Later divorced, he married [2"), _c('sup', [_vm._v("nd")]), _vm._v("] Mildred ___. He last resided in Charleston, W. Va., and he died March 1973).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Child (by his 1"), _c('sup', [_vm._v("st")]), _vm._v(" wife):")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23570. Robert Ashton Donnally, Jr. (born in W. Va., Jan. 1925; married ___, and he was adopted by his stepfather, following the remarriage of his mother). [R. HENRY, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Gen. of the Fam. of the Presidents")]), _vm._v(", 25; A. M. WASHINGTON, “Living Desc. of J. Washington,” 608; "), _c('a', {
    attrs: {
      "href": "http://FamSearch.org",
      "target": "_blank"
    }
  }, [_vm._v("FamSearch.org")]), _vm._v("/W. Va. Marriages; 1930 census Kanawha Co., W. Va., E.D. 43, p. 5A; SSDI; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11334–1166x]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13136. Annette F. Preston (born in Va., ca. 1878; married [1"), _c('sup', [_vm._v("st")]), _vm._v("] Tom Payne Sharp. Later divorced, she married [2"), _c('sup', [_vm._v("nd")]), _vm._v("] J. Albert Davis, and she died 1955).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children (by her 1"), _c('sup', [_vm._v("st")]), _vm._v(" husband):")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23571. Tom Preston Sharp (Davis) (adopted by his stepfather).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23572. Roberta Preston Sharp (Davis) (adopted by her stepfather; she married Jack Dobbins).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Child (by her 2"), _c('sup', [_vm._v("nd")]), _vm._v(" husband):")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23573. Jack Davis (married Barbara ___, and they had about five children). [J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11334–11825]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13138. Laurabelle Preston (twin; born in W. Va., April 1, 1884, according to the 1910 census, although the 1920 census says “born in Ky.”; married [1"), _c('sup', [_vm._v("st")]), _vm._v("] R. Ashley Jeffreys [born in Fla., ca. 1880]. They resided in Fernandina, Nassau Co., Fla., 1910, where he was a clerk for a lumber company. Later divorced, according to J.A.W., she is listed as a widow, occupation “sales lady, dry goods” in the 1920 census, where she still resided in Fernandina, Fla. She later married [2"), _c('sup', [_vm._v("nd")]), _vm._v("] Oscar Meinhold, and she was then divorced again).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children (by her 1"), _c('sup', [_vm._v("st")]), _vm._v(" husband):")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23574. Laurabelle Jeffreys (born in Fla., ca. 1903; married Harry Holcombe).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23575. Nan(cy) Jeffreys.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("12576. Dorothy Fitzhugh Jeffreys (born ibid., ca. 1907; married Gordon Babcock. She was possibly divorced and married a second time).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23577. William O. Jeffreys (born ibid., ca. 1911; married Joyce Ball, and they had two children: Diana Preston Jeffreys and Janet Joyce Jeffreys). [R. HENRY, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Gen. of the Fam. of the Presidents")]), _vm._v(", 25; 1910 census Nassau Co., Fla., E.D. 101, p. 18B; 1920 census ibid., E.D. 140, p. 17B, where the badly scribbled surname is misread as “Jefferson” with alternate “Jeffrion” in the on-line census index; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11334–11827]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13139. Alice Evelyn Preston (born in Ala., May 20, 1887; married [1"), _c('sup', [_vm._v("st")]), _vm._v(", in 1912] William S. Yates [born in Fla., ca. 1888]. They resided in St. Marys, Camden Co., Ga., 1920, where he was a steamboat captain. Later divorced, she married [2"), _c('sup', [_vm._v("nd")]), _vm._v("] F. Lee Youngblood).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children (by her 1"), _c('sup', [_vm._v("st")]), _vm._v(" husband):")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23578. Susan Fitzhugh Yates.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23579. Barbara Yates (born in Ga., ca. June 1918; married ___ Chaplin).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23580. William S. Yates (born ca. 1920; a veteran of WW II, he married Dorothy MacDonald, and he died March 1955. They had one child: Vicki Lee Yates). [1920 census Camden Co., Ga., E.D. 48, p. 2A; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11334–11828]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13140. Henry Nicholas Fitzhugh (born in Ut., Nov. 13, 1888; married [ca. 1915] Emma Sidlo [born in Bohemia or Czechoslovakia, Feb. 18, 1892; died in Los Angeles Co., Cal., Aug. 5, 1969]. They resided in Los Angeles, Cal., 1930, where his occupation was “landscape gardener, construction.” He died in Los Angeles Co., Cal., Sept. 2, 1996).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Child:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23581. Rose Marie Fitzhugh (born in Los Angeles Co., Cal., July 18, 1923; died unm. in Los Angeles, Cal., June 30, 2004). [R. HENRY, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Gen. of the Fam. of the Presidents")]), _vm._v(", 26; 1900 census Sanpete Co., Ut., E.D. 125, p. 13A; 1930 census Los Angeles Co., Cal., E.D. 543, p. 21B; CalDI; B. C. NOONAN, website “Desc. of Edward III”; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11334–11831]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13142. Mary Fitzhugh Morris (born in Va., Nov. 2, 1882; married [Nov. 24, 1903] Clarence Thompson Starr [born in Pa., Jan. 20, 1880]. They resided in Lansford, Carbon Co., Pa., 1910, where he was a civil engineer for a coal company).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23582. Fisher Morris Starr.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23583. Henrietta Dyer Starr.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23584. Mary Morris Starr. [1910 census Carbon Co., Pa., E.D. 11, pp. 8B-9A; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11334–11841]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13144. Martha Shrewsbury Fitzhugh Morris (born in N.Y., May 19, 1886; married [Nov. 22, 1910] Harold Watson [born June 22, 1886; died June 1939]. By 1920 she was divorced and residing with her daughter in Lancaster, Lancaster Co., Pa., 1920. She last resided in Key West, Monroe Co., Fla., and she died July 1974).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Child:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23585. Martha Shrewsbury Fitzhugh Watson (born in Bucks Co., Pa., Sept. 17, 1912; married [Nov. 9, 1945] Robert F. Sauer [born Feb. 18, 1917; he was a lawyer in Key West, Fla.]. In 1936 she and her mother stopped by a travel agency in Miami, Fla., where they were entranced by a picture of Key West. She suggested to her mother, “Let’s go to Key West,” and so they did. Martha studied art under Townsend Morgan and other gifted artists, and she went on to celebrate the scenery of Key West in numerous watercolor paintings and drawings. Her works hang in private collections in North American, Europe, and Asia, and she exhibited one-person shows at the Institute of Cultural Relations in Mexico City, the Telfair Museum of Art in Savannah, Ga., and many other prestigious art venues. For many years she taught art and weaving at the Key West Art Center. She last resided in Key West, Fla., where she died Nov. 20, 2005). [Quotation from tribute to Martha W. Sauer on the website of the Key West Art & Historical Assn. ("), _c('a', {
    attrs: {
      "href": "http://www.kwahs.com",
      "target": "_blank"
    }
  }, [_vm._v("www.kwahs.com")]), _vm._v("); 1920 census Lancaster Co., Pa., E.D. 53, pp. 4B-5A; SSDI; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11334–11843]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13149. Charles Stuart Jones (born in Brunswick Co., Va., March 1, 1881; married [1"), _c('sup', [_vm._v("st")]), _vm._v(", on Nov. 24, 1914] Nanny Caldwell Buford ["), _c('em', {
    staticClass: "italic"
  }, [_vm._v("d.s.p.")]), _vm._v(" May 23, 1921]. He married in Washington, D.C. [2"), _c('sup', [_vm._v("nd")]), _vm._v(", on April 20, 1925] Lillian Bracey Clark [born in Alachua Co., Fla., Dec. 18, 1894; died in Charles Co., Md., Dec. 31, 1984]. They farmed in Totaro District, Brunswick Co., Va., and he died in Mecklenburg Co., Va., Oct. 21, 1966).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children (by his 2"), _c('sup', [_vm._v("nd")]), _vm._v(" wife):")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23586. Eula Clarke Jones.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23587. Mary Stuart Jones. [1930 census Brunswick Co., Va., E.D. 14, p. 14A; 1940 census ibid., E.D. 13–15, p. 7B; FGS by ECJH (NSWFD member #918)]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13150. Elizabeth Lewis Jones (born March 2, 1884; married [Jan. 29, 1903] James Percy Taylor, and she died Oct. 4, 1958).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Child:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23588. Jesse Ravenscroft Taylor (born Oct. 25, 1903; died June 27, 1904). [FGS by ECJH (NSWFD member #918)]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13156. Edward Stuart Lewis (born in Bristol, Washington Co., Va., March 30, 1895; a game warden with the Tennessee Conservation Service, he married in Sullivan Co., Tenn. [April 10, 1927] Reba Virginia Dermid [born in Bristol, Va., April 2, 1904; died in Bristol, Sullivan Co., Tenn., Nov. 11, 1998]. He died in Johnson City, Tenn., Aug. 14, 1955).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23589. Madge Elizabeth Fitzhugh Lewis (born 1934).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23590. Sallie Meriwether Lewis. [FGS by SLH; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 23252–5171]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13162. Alice Cary Scott (born in Va., Aug. 5, 1900; married [Aug. 18, 1928] George Gardiner Davies [born in Storrs, Tolland Co., Conn., Sept. 7, 1900; died Aug. 5, 1967]. She last resided in Easton, Talbot Co., Md., and she died Nov. 7, 1994).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Child:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23591. Rebecca Burr Davies. ["), _c('a', {
    attrs: {
      "href": "http://RootsWeb.com",
      "target": "_blank"
    }
  }, [_vm._v("RootsWeb.com")]), _vm._v("/WCP, entry by GIR; SSDI; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11334–12371]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13169. Anne Pendleton Turner (born in Port Royal, Caroline Co., Va., Jan. 16, 1900; married in Fredericksburg, Va. [Feb. 26, 1927] Charles H. Lewis [born in Va., ca. 1899]. They resided in Fredericksburg, Va., where he was a pharmacist).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Child:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23592. Charles Taylor Lewis (born in Va., March 30, 1929; married Betty Fay, and they had two children: Charles Taylor Lewis, Jr., and Michael Marshal Lewis). ["), _c('a', {
    attrs: {
      "href": "http://FamSearch.org",
      "target": "_blank"
    }
  }, [_vm._v("FamSearch.org")]), _vm._v("/Va. Marriages; 1930 census Fredericksburg (Independent City), Va., E.D. 1, p. 6A; 1940 census ibid., E.D. 107–3, p. 6A; "), _c('a', {
    attrs: {
      "href": "http://Anc.com",
      "target": "_blank"
    }
  }, [_vm._v("Anc.com")]), _vm._v("/PMT; FGS by ERTW; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11334–12721]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13170. Taylor Fitzhugh Turner (born in Port Royal, Va., June 17, 1903; graduated from the U. of Va. As a very young man, while visiting Vicksburg, Miss., he met an attractive girl named Alice on Clay Street in front of the YMCA. Years later, after an intermittent correspondence, they met again by chance in Louisiana. Soon afterward he married in Greenville, Washington Co., Miss. [Dec. 28, 1932] Alice Lake Alexander [born in Greenville, Miss., Aug. 27, 1908; graduated from Randolph Macon College. She died in Richmond, Va., June 28, 1993]. They resided in Fredericksburg, Va., where he was a purchasing agent for a factory, 1940. He last resided in Richmond, Va., where he died March 6, 1991).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23593. Taylor Fitzhugh Turner, Jr.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23594. Alexander Pendleton Turner. [1940 census Fredericksburg (Independent City), Va., E.D. 107–3, p. 6B; SSDI; "), _c('a', {
    attrs: {
      "href": "http://Anc.com",
      "target": "_blank"
    }
  }, [_vm._v("Anc.com")]), _vm._v("/PMT; FGS by ERTW (NSWFD member #1114); J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11334–12722]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13175. Ellen Elizabeth Vesey (born in Miss., Nov. 17, 1869 [age confirmed by the 1920 census, though contradicted by the 1930 census, which says “age 56”]. She married in Memphis, Tenn. [1"), _c('sup', [_vm._v("st")]), _vm._v(", on Feb. 6, 1888] George Henry McLeod [born ca. 1867; died in Gomez Palacio, Mexico, April 4, 1906]. She married in Amarillo, Potter Co., Tex. [2"), _c('sup', [_vm._v("nd")]), _vm._v(", on June 16, 1908] Silas Winfield Riggan [born in Miss., Dec. 2, 1866; died in San Diego Co., Cal., June 14, 1941]. They were farming in Swisher Co., Tex., 1910. They later resided in Trinidad, Las Animas Co., Colo., 1920, where he was repairing cars for a railroad. By 1930 they were living in Inyo Co., Cal., where he worked as an “oiler for a clay mill.” She died in Cal., Sept. 21, 1934, and is said to have had five children).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children (by her 2"), _c('sup', [_vm._v("nd")]), _vm._v(" husband; partial list):")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23595. Lex Era Riggan.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23596. Pearl Riggan (born in Tex., ca. 1896).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23597. Kate Riggan (born ibid., Sept. 3, 1901; married ___ Williams, and she died in Los Angeles Co., Cal., Sept. 9, 1982).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23598. Robbie K. Riggan. [1910 census Swisher Co., Tex., E.D. 211, p. 15A; 1920 census Las Animas Co., Colo., E.D. 140, p. 5B; 1930 census Inyo Co., Cal., E.D. 8, p. 1A; CalDI; SSDI; "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("IGI")]), _vm._v(" v4.01; "), _c('a', {
    attrs: {
      "href": "http://Anc.com",
      "target": "_blank"
    }
  }, [_vm._v("Anc.com")]), _vm._v("/AWT, entry by LauraM; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11334–15131]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13176. Annie Lucy Hyneman (born in Corinth, Alcorn Co., Miss., Nov. 25, 1869; married ibid. [Oct. 30, 1888] Green Croft Chandler [born in Miss., Dec. 30, 1864; graduated from Tulane U. (M.D., 1888). He was a city health officer for ten years in Shreveport, Caddo Parish, La., where he died Jan. 25, 1923]. She died in St. Maurice, Winn Parish, La., Sept. 23, 1890).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Child:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23599. Eugenia Chandler (born Sept. 9, 1889; married Merton Ragan Stribling [born in Ala., March 25, 1881; died in Corinth, Miss., Feb. 11, 1947]. They resided in Corinth, Miss., and she died Oct. 8, 1972, where both were buried at Henry Cemetery). ["), _c('em', {
    staticClass: "italic"
  }, [_vm._v("JAMA")]), _vm._v(", 80 (1923) 494; "), _c('a', {
    attrs: {
      "href": "http://www.findagrave.com",
      "target": "_blank"
    }
  }, [_vm._v("www.findagrave.com")]), _vm._v("; "), _c('a', {
    attrs: {
      "href": "http://FamSearch.org",
      "target": "_blank"
    }
  }, [_vm._v("FamSearch.org")]), _vm._v("/PRF; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11334–15141]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13178. Nina May Hyneman (born in Miss., May 12, 1874; married [June 2, 1898] Frank Saunders Elgin [born ibid., March 5, 1873; died in Memphis, Tenn., May 6, 1927]. They resided in Memphis, Tenn., where he was a lawyer. She died Sept. 20, 1969, and both were buried at Henry Cemetery in Corinth, Alcorn Co., Miss.).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23600. David H. Elgin (born in Tenn., June 27, 1900; died in Los Angeles Co., Cal., April 13, 1966).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23601. Frank Saunders Elgin, Jr. (born in Tenn., Dec. 16, 1906; died May 30, 1963, and he was buried at Henry Cemetery in Corinth, Miss.). [1910 census Shelby Co., Tenn., E.D. 226, p. 3A; 1920 census ibid., E.D. 154, p. 12A; "), _c('a', {
    attrs: {
      "href": "http://www.findagrave.com",
      "target": "_blank"
    }
  }, [_vm._v("www.findagrave.com")]), _vm._v("; "), _c('a', {
    attrs: {
      "href": "http://FamSearch.org",
      "target": "_blank"
    }
  }, [_vm._v("FamSearch.org")]), _vm._v("/Tenn. Deaths; CalDI; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11334–15143]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13179. Maggie Hyneman (born in Corinth, Alcorn Co., Miss., Nov. 8, 1876; married ibid. [June 6, 1899] Roy Leighton Young [born in Miss., March 12, 1874; died Sept. 13, 1943]. They resided in Corinth, Miss., 1910, where he was superintendent of a foundry. She died Feb. 6, 1963, and both were buried at Henry Cemetery in Corinth, Miss.).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23602. Roy H. Young (born in Miss., ca. 1900).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23603. Margaret Young (born ibid., ca. 1901).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23604. Eugene H. Young (born ibid., ca. 1904). [1910 census Alcorn Co., Miss., E.D. 3, p. 15A; "), _c('a', {
    attrs: {
      "href": "http://www.findagrave.com",
      "target": "_blank"
    }
  }, [_vm._v("www.findagrave.com")]), _vm._v("; "), _c('a', {
    attrs: {
      "href": "http://FamSearch.org",
      "target": "_blank"
    }
  }, [_vm._v("FamSearch.org")]), _vm._v("/PRF; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11334–15144]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13186. Anna Fentress Chester (born in Ark., ca. 1862; married in Columbia Co., Ark. [July 27, 1881] Hamilton [Hampton ?] P. Smead [born in Ark., Nov. 1853; a lawyer, he is presumably the H. P. Smead who represented Columbia Co., Ark., in the Arkansas state House of Representatives, 1883]. They resided in Camden, Ouachita Co., Ark., 1900, where she was a widow in 1910).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23605. Sula (?) Smead (daughter; born in Ark., May 1882).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23606. Chester C. Smead (born ibid., June 1883).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23607. Lamar B. Smead.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23608. Lucy R. Smead (born ibid., March 1891).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23609. Hamilton P. Smead, Jr. (born ibid., July 5, 1893; he signed his name as “Hamilton P. Smead” when he registered for the draft in Camden, Ark., June 5, 1917. At that time he was enrolled in a student officers’ training program at Fort Logan).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23610. Anna F. Smead (born in Ark., Oct. 1895).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23611. William Percival Smead (born ibid., Dec. 1896 or 1897; resided unm. in Camden, Ark., when he registered for the draft on May 31, 1918).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23612. Ritchie Smead (daughter; born in Ark., ca. 1900).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23613. Leonard C. Smead.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23614. Jack Smead (born ibid., ca. 1903). [Anon., (Goodspeed’s) "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Southern Ark. Hist. and Biog. Memoirs")]), _vm._v(", 458; 1900 census Ouachita Co., Ark., E.D. 136, p. 10A; 1910 census ibid., E.D. 118, p. 9B; WW I Draft Reg.; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11334–15411]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13192. Clara Dodd Chester (born in Ark., May 1878; married [1906] J. C. Moffatt. In 1920 she resided as a widow with her brother-in-law and sister, John P. and Fannie P. Hutchinson, in Cleburne, Johnson Co., Tex.).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23615. James C. Moffatt (born in Tex., ca. 1907).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23616. Ellen D. Moffatt (born ibid., ca. 1910).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23617. George W. Moffatt (born ibid., ca. July 1913).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23618. Jack D. Moffatt (born ibid., ca. Dec. 1918). [1900 census Lamar Co., Tex., E.D. 68, p. 10A; 1920 census Johnson Co., Tex., E.D. 37, p. 7A; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11334–15417]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13193. Fannie Perceval Chester (born in Ark., March 1880; married in Lamar Co., Tex. [Jan. 31, 1905] John P. Hutchinson [born in Tenn., ca. 1880]. They resided in Cleburne, Johnson Co., Tex., 1920, where he was manager of a laundry and she was a teacher. She "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("d.s.p.")]), _vm._v(" according to J.A.W., although the 1920 census indicates one “adopted child”).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Child (adopted):")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23619. William C. Hutchinson (born in Tex., ca. Feb. 1914). [1900 census Lamar Co., Tex., E.D. 68, pp. 9B-10A; 1920 census Johnson Co., Tex., E.D. 37, p. 7A; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11334–15418]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13194. Irene Chester (born in Ark., April 1881; married in Lamar Co., Tex. [Jan. 31, 1906] Edgar L. Storey [born in Miss., ca. 1867]. They resided in Brownwood, Brown Co., Tex., 1910, where he taught in a college. They moved by 1920 to Alvin, Brazoria Co., Tex., where he was a minister. The 1910 census confirms that one child died young).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Child (surviving):")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23620. Edgar L. Storey, Jr. (born in Tex., ca. 1916). ["), _c('a', {
    attrs: {
      "href": "http://FamSearch.org",
      "target": "_blank"
    }
  }, [_vm._v("FamSearch.org")]), _vm._v("/Tex. Marriages; 1910 census Brown Co., Tex., E.D. 95, p. 15A; 1920 census Brazoria Co., Tex., E.D. 5, p. 8A; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11334–15419]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13195. Joseph William Chester (born in Tex., ca. Dec. 1883; married [1909] Mabel Daley [born ibid., ca. 1880]. A chief clerk for a cotton company, he resided in Little Rock, Pulaski Co., Ark.).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23621. Joseph William Chester, Jr. (born in Tex., ca. 1911).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23622. John Chester (born in Ark., ca. Aug. 1918). [1900 census Lamar Co., Tex., E.D. 68, pp. 9B-10A; 1920 census Pulaski Co., Ark., E.D. 149, p. 5A; 1930 census ibid., E.D. 40, p. 7B; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11334–1541x]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13196. Willie Harper Leiper (born Nov. 11, 1867; married in Hot Spring Co., Ark. [Dec. 29 or 30, 1886] Leonard Bratt [apparently changed name to “Bradt”; born in Ind., ca. 1865; resided as a widower in St. Louis, Mo., 1910, where he owned a lumber company. She died May 3, 1901).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23623. Bruce Abram Bradt (born in Ark., Nov. 6, 1887).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23624. Albert Leonard Bradt (born ibid., Oct. 6, 1888; last resided in Kern Co., Cal., but he died in Los Angeles Co., Cal., Aug. 3, 1969). [1910 census St. Louis, Mo., E.D. 443, p. 4B; "), _c('a', {
    attrs: {
      "href": "http://FamSearch.org",
      "target": "_blank"
    }
  }, [_vm._v("FamSearch.org")]), _vm._v("/Ark. Marriages; CalDI; SSDI; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11334–15421]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13198. Mary Fitzhugh Leiper (born in Ark., Jan. 20, 1873 or 1874; married in Hot Spring Co., Ark. [Dec. 5, 1895] Augustus William Brassler [born in Germany, April 1869]. They resided in Malvern, Hot Spring Co., Ark., 1900, where he was jeweler. Mary died in Malvern, Ark., May 28, 1901).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Child:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23625. Priscilla Macon Brassler. [ArkMI; 1900 census Hot Spring Co., Ark., E.D. 60, p. 2A; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11334–15423]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13199. Samuel Harper Leiper (born in Ark., Aug. 22, 1875; a farmer, he married in Cross Co., Ark. [1"), _c('sup', [_vm._v("st")]), _vm._v(", on Sept. 10/18, 1895] Annie Ida Nail [also called “Annie Byrd Nail”; born in Miss., 1876]. He was manager of an ice plant in Malvern, Hot Spring Co., Ark., 1910, and they moved by 1920 to Fenter Township, Hot Spring Co., Ark. He married [2"), _c('sup', [_vm._v("nd")]), _vm._v("] Pearl Wilbank).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children (by his 1"), _c('sup', [_vm._v("st")]), _vm._v(" wife):")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23626. Hugh Nail Leiper.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23627. Lenna Harper Leiper.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23628. Annie Laura Leiper.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23629. William Harper Leiper. [ArkMI; 1910 census Hot Spring Co., Ark., E.D. 88, p. 6A; 1920 census ibid., E.D. 106, p. 3B; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11334–15424]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13201. Macon Anderson Leiper (born in Malvern, Hot Spring Co., Ark., July 25, 1879; graduated from Peabody College for Teachers, Nashville [A.B., 1901; Ph.D., 1926] and Columbia [A.M., 1905]. After post-graduate study at Princeton, 1906–1907, he was Latin instructor at Beauvoir College [Ark.], Galloway College [Ark.], and Maddox Seminary [Ark.], 1901–1904. He then began a long career as professor of English at West Ky. Teachers College in Bowling Green from 1908 until his death. He was author of several textbooks, including "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Latin Subordinate Clause Syntax")]), _vm._v(" [1913], "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Language Work in Elementary Schools")]), _vm._v(" [1916], and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("A New English Grammar")]), _vm._v(" [Macmillan, 1923]. He married [Nov. 27, 1907] Mary Elizabeth Taylor [born 1885; she was a librarian at West Ky. Teachers College]. They resided in Bowling Green, Warren Co., Ky., and he died June 17, 1936).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Child:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23630. Elizabeth Macon Leiper. ["), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Who Was Who Am.")]), _vm._v(", vol. 4; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11334–15426]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13202. Esther Agnes Leiper (born in Malvern, Hot Spring Co., Ark., Ark., Nov. 20, 1887; married ibid. [Dec. 22, 1909] Howard Henry Shumaker [born in Oh., ca. 1865; died 1949]. They resided in Little Rock, Pulaski Ark., 1920, where he was superintendent of a lumber company. She resided in Memphis, Tenn., and she died April 1985).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23631. George Leiper Shumaker.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23632. Priscilla Macon Shumaker. ["), _c('a', {
    attrs: {
      "href": "http://FamSearch.org",
      "target": "_blank"
    }
  }, [_vm._v("FamSearch.org")]), _vm._v("/Ark. Marriages; 1920 census Pulaski Co., Ark., E.D. 150, p. 1A, which spells the name “Shoemaker”; NSWFD #104 (Esther L. Shumaker); J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11334–15428]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13203. Rudolph Fitzhugh Lybrand (born in Grapevine, Grant Co., Ark., Oct. 18, 1886; unm., he was farming in Grant Co., Ark., when he registered for the draft June 5, 1917. He later married in Sheridan, Grant Co., Ark. [Aug. 21, 1919] Cloie Ann Funderburg [born in Ark., Nov. 18, 1897]. They resided in Pine Bluff, Jefferson Co., Ark., where he worked as a machinist for an auto body shop in 1930 and was unemployed in 1940. He died March 15, 1969).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23633. Calvin Jacob Lybrand (born in Ark., June 6, 1920).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23634. Rudolph Macon Lybrand.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23635. Elmer Ellsworth Lybrand.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23636. Benjamin Watson Lybrand.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23637. Sarah Mandy Lybrand. [WW I Draft Reg.; "), _c('a', {
    attrs: {
      "href": "http://FamSearch.org",
      "target": "_blank"
    }
  }, [_vm._v("FamSearch.org")]), _vm._v("/Ark. Marriages; 1930 census Jefferson Co., Ark., E.D. 46, p. 13A; 1940 census ibid., E.D. 35–63, p. 18B; SSDI, which I follow; NSWFD #474 (Elmer E. Lybrand); "), _c('a', {
    attrs: {
      "href": "http://Anc.com",
      "target": "_blank"
    }
  }, [_vm._v("Anc.com")]), _vm._v("/PMT; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11334–15431]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13204. Mary McKee Lybrand (born in Ark., ca. July 1, 1888; married in Grant Co., Ark. [July 9, 1904] Wylie Edward Gean [born in Ark., Oct. 13, 1883; died May 6, 1926]. They resided in Sheridan, Grant Co., Ark., 1910, where he was a grocery salesman. Mary died June 11, 1960).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23638. Lyndell Oline Gean.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23639. Macon Garret Gean (born in Ark., Dec. 25, 1907; foreman of a cotton mill, he married [Sept. 4, 1937] Opal Adell Brookreson [born in Tex., Oct. 19, 1910; died July 1995]. They resided without children in Las Cruces, Doña Ana Co., N.M., 1940. They later resided in Deming, Luna Co., N.M., and he died Jan. 27, 2001).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23640. Edwina Gean.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23641. W. Eldred Gean.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23642. Hilda Gean.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23643. Dickey Edward Gean (ca. 1919; died age 11 months). ["), _c('a', {
    attrs: {
      "href": "http://FamSearch.org",
      "target": "_blank"
    }
  }, [_vm._v("FamSearch.org")]), _vm._v("/Ark. Marriages; 1910 census Grant Co., Ark., E.D. 75, p. 12A; 1940 census Doña Ana Co., N.M., E.D. 7–6, p. 5A; SSDI; FGS by GMN; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11334–15432]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13205. Mary Fitzhugh Banks (born in Ark., ca. Oct. 1889; DAR member #151518, she married in Jefferson Co., Ark. [April 17, 1912] James Atkinson Hudson [born in Star City, Lincoln Co., Ark., Jan. 26, 1886; an insurance agent, he died July 25, 1973]. They resided in Helena, Phillips Co., Ark., and she died Oct. 16, 1954).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23644. Mary V. Hudson (born in Ark., Dec. 12, 1912).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23645. Jamie Fitzhugh Hudson. [E. SHUMAKER, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Genealogical Lineage of P. J. M. Leiper")]), _vm._v(", 33; "), _c('a', {
    attrs: {
      "href": "http://FamSearch.org",
      "target": "_blank"
    }
  }, [_vm._v("FamSearch.org")]), _vm._v("/Ark. Marriages; WW II Draft Reg.; 1940 census Phillips Co., Ark., E.D. 54–23, p. 10A; "), _c('a', {
    attrs: {
      "href": "http://Anc.com",
      "target": "_blank"
    }
  }, [_vm._v("Anc.com")]), _vm._v("/AWT, entry by RHB, citing 1920 census Phillips Co., Ark., E.D. 184, p. 7; SSDI; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11334–15451]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13207. Allie Robinson Banks (born in Ark., Jan. 20, 1894; married in Helena, Phillips Co., Ark. [Oct. 5, 1918] Lawrence E. Dawson [born in Miss., Sept. 9, 1890; he was a veteran of WW I. In 1930 he was working as an automobile salesman in Stephens, Ouachita Co., Ark. He died Sept. 19, 1943]. She last resided in Pine Bluff, Jefferson Co., Ark., and she died Oct. 1982).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23646. John Dawson (born in Ark., ca. 1921; married, he had two sons and one daughter).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23647. Alexander Banks Dawson (born in Camden, Ouachita Co., Ark., Aug. 8, 1922; married in Pine Bluff, Ark. [Aug. 6, 1961] Kathleen Louise [Patterson] Turner. They resided in Rison, Cleveland Co., Ark., and he was NSWFD member #579. They had two children: Alexander Banks Dawson, Jr. [born 1965] and Bruce Christopher Banks [born 1967]).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23648. Lawrence E. Dawson, Jr. (born in Shreveport, Caddo Parish, La., 1923; graduated from the U. of Ark. [J.D.]. He served as a U.S. Commissioner [1949–1952] and then was elected to one term in the Arkansas state legislature [1953–1954]. Later he was a Municipal Court Judge [1955–1958] and finally a Chancery Judge in Pine Bluff, Ark., beginning 1959. An active lay leader in his church, he was Moderator of the East Arkansas Presbyterian Church [1973–1974]. He was also vice-president of the Community Chest [now United Way; 1956–1957]. He was president of the Arkansas Judicial Council [1981–1982] and a member of the Board of Directors for the Salvation for many years. He married and had three daughters). [1930 census Ouachita Co., Ark., E.D. 22, p. 5B; SSDI; "), _c('a', {
    attrs: {
      "href": "http://http://pview.findlaw.com",
      "target": "_blank"
    }
  }, [_vm._v("http://pview.findlaw.com")]), _vm._v("/view/2395650_1; NSWFD member #519, ABD; NSWFD member #579 (Alexander Banks Dawson); J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11334–15453]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13208. Mary Maud Manry (born in Iran, Bossier Parish, La., Oct. 3 or 30, 1880; married in Bossier Parish, La. [Nov. 18, 1901] John Hubbart Wheeler [born in La., ca. 1879]. They resided in Terrell, Kaufman Co., Tex., 1910, where he was a barber. By 1920 they had moved to Plain Dealing, Bossier Parish, La.).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23649. Howard Ashton Wheeler (born in La., ca. 1904; married Neva Adelle Dolph [born ibid., ca. 1906]. They resided in Plain Dealing, La., 1940, where he owned a barber shop. They had two children: Henry Wheeler [born in La., ca. 1928] and Mary Wheeler [born ibid., ca. 1929]).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23650. Gordon Franklin Wheeler (born in La., ca. 1906).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23651. Ethel Gray Wheeler (born in Plain Dealing, La., Oct. 17, 1908; married ibid. [Sept. 2, 1938] Harry Steckol [born in Warsaw, Poland, July 10, 1884; died in Shreveport, Caddo Parish, La., Dec. 8, 1972]. NSWFD member #517, she resided in Plain Dealing, La.)")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23652. William Herbert Wheeler (born in La., Dec. 29, 1910; married Marguerite Mildred Van Reed [died 1996]. He died in Austin, Travis Co., Tex., March 18, 1981). [1910 census Kaufman Co., Tex., E.D. 30, p. 9B; 1920 census Bossier Parish, La., E.D. 23, p. 1B; 1940 census Bossier Parish, La., E.D. 8–14, p. 9A (for Howard and Neva Wheeler); SSDI; NSWFD #517 (Ethel G. W. Steckol); "), _c('a', {
    attrs: {
      "href": "http://FamSearch.org",
      "target": "_blank"
    }
  }, [_vm._v("FamSearch.org")]), _vm._v("/AF v4.19; "), _c('a', {
    attrs: {
      "href": "http://Anc.com",
      "target": "_blank"
    }
  }, [_vm._v("Anc.com")]), _vm._v("/search/“surname Wheeler”; "), _c('a', {
    attrs: {
      "href": "http://Gen.com",
      "target": "_blank"
    }
  }, [_vm._v("Gen.com")]), _vm._v("/WFT]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13210. Alexander Banks Manry (born in Iran, Bossier Parish, La., Dec. 14, 1884; married [1"), _c('sup', [_vm._v("st")]), _vm._v("] Lucy [Davis] Ivey [born in Tex., ca. 1891]. They resided in Tanner’s Creek, Norfolk Co., Va., 1910, where he was a storekeeper at the U.S. Navy base. They resided in Parsons, Labette Co., 1915. He married [2"), _c('sup', [_vm._v("nd")]), _vm._v("] Pat Taylor [died in Austin, Travis Co., Tex., Aug. 10, 1977]. He died in Norfolk, Va., Aug. 1, 1959).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children (by his 1"), _c('sup', [_vm._v("st")]), _vm._v(" wife):")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23653. Electra Manry (born in Tex., ca. 1910).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23654. William D. Manry (born in Kans., ca. 1914).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23655. Roy Manry (born ibid., ca. July 1916).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23656. Margaret Manry (born ibid., ca. Jan. 1918).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23657. Polly Manry.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23658. Jack Manry. [1915 Kans. State Census roll ks1915_119, line 23; 1920 census Norfolk Co., Va., E.D. 227, p. 27B; "), _c('a', {
    attrs: {
      "href": "http://FamSearch.org",
      "target": "_blank"
    }
  }, [_vm._v("FamSearch.org")]), _vm._v("/AF v4.19; "), _c('a', {
    attrs: {
      "href": "http://Gen.com",
      "target": "_blank"
    }
  }, [_vm._v("Gen.com")]), _vm._v("/WFT]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13211. Bessie Manry (born in Iran, Bossier Parish, La., Jan. 16, 1888; married [1"), _c('sup', [_vm._v("st")]), _vm._v(", on Feb. 27, 1911] William Henderson Kelly [died Dec. 11, 1915]. She married [2"), _c('sup', [_vm._v("nd")]), _vm._v(", on April 22, 1917] J. Ebb Newton [born in Ga., ca. 1891]. They resided in Webster Parish, La., 1930, where he was a pipe liner in an oil field. She died May 17, 1931).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Child (by her 1"), _c('sup', [_vm._v("st")]), _vm._v(" husband):")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23659. Radolph (sic) Kelly (daughter; born in La, ca. 1913).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children (by her 2"), _c('sup', [_vm._v("nd")]), _vm._v(" husband):")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23660. Elbert M. Newton (born in La., ca. 1917).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23661. Muriel W. Newton (born ibid., ca. 1920).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23662. Julian W. Newton (born ibid., ca. 1921).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23663. Selma Newton.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23664. Velma Newton. [1930 census Webster Parish, La., E.D. 9, p. 1A; "), _c('a', {
    attrs: {
      "href": "http://FamSearch.org",
      "target": "_blank"
    }
  }, [_vm._v("FamSearch.org")]), _vm._v("/AF v4.19; "), _c('a', {
    attrs: {
      "href": "http://Gen.com",
      "target": "_blank"
    }
  }, [_vm._v("Gen.com")]), _vm._v("/WFT]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13212. Ethel Fitzhugh Manry (born in Iran, Bossier Parish, La., Oct. 17, 1889; married [Feb. 14, 1914] Kendall E. Ball [born in La., ca. 1890; died in Vienna, Lincoln Parish, La., April 22, 1970]. They resided in Lincoln Parish, La., 1930, where he was a merchant).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23665. Fannie M. Ball (born in La., ca. 1915).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23666. Mary Helen Ball (born ibid., ca. 1918).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23667. Kendall E. Ball, Jr. (born ibid., ca. 1921).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23668. Jessie Alice Ball (born ibid., ca. 1923). [1930 census Lincoln Parish, La., E.D. 19, p. 2A; "), _c('a', {
    attrs: {
      "href": "http://FamSearch.org",
      "target": "_blank"
    }
  }, [_vm._v("FamSearch.org")]), _vm._v("/AF v4.19; "), _c('a', {
    attrs: {
      "href": "http://Gen.com",
      "target": "_blank"
    }
  }, [_vm._v("Gen.com")]), _vm._v("/WFT]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13213. James Manry (born in Iran, Bossier Parish, La., June 24, 1893; married [1"), _c('sup', [_vm._v("st")]), _vm._v(", in 1917] Mattie [Ball] Farley. He married [2"), _c('sup', [_vm._v("nd")]), _vm._v("] Gracie Marie Webb, and he died in Blanchard, Caddo Parish, La., Oct. 6, 1964.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The preceding record comes from undocumented Internet sites, "), _c('a', {
    attrs: {
      "href": "http://FamilySearch.org",
      "target": "_blank"
    }
  }, [_vm._v("FamilySearch.org")]), _vm._v("/AF and "), _c('a', {
    attrs: {
      "href": "http://Genealogy.com",
      "target": "_blank"
    }
  }, [_vm._v("Genealogy.com")]), _vm._v("/WFT. These sites assign James one child [James Manry, Jr.] by his first wife, and five children by his second wife: Nell Manry, Rose Marie Manry, Amelia Manry, Mary Edith Manry, and Larry Manry. The 1920 census Lincoln Parish, La., surely lists James Manry’s wife and children as residing with her parents in the following family:")]), _vm._v(" "), _c('div', {
    staticClass: "extract"
  }, [_c('p', {
    staticClass: "extractNoIndent"
  }, [_vm._v("BALL, Eugene C. Jr., head, age 64, born in La.")]), _vm._v(" "), _c('p', {
    staticClass: "extractNoIndent"
  }, [_vm._v("____, Fannie H., wife, age 56, born in Ala.")]), _vm._v(" "), _c('p', {
    staticClass: "extractNoIndent"
  }, [_vm._v("MANRY, Mattie, daughter, age 27, widow, born in La.")]), _vm._v(" "), _c('p', {
    staticClass: "extractNoIndent"
  }, [_vm._v("_____, Cecil, son, age 7, born in La.")]), _vm._v(" "), _c('p', {
    staticClass: "extractNoIndent"
  }, [_vm._v("_____, James A., son, age 1 year and 6 months, born in La.")])]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Mattie’s son Cecil [age seven in the 1920 census] was born several years before Mattie’s marriage to James Manry in 1917. Cecil is thus presumably “Cecil Farley,” Mattie’s child by her prior marriage to a Mr. Farley, or perhaps Cecil was adopted by his stepfather James Manry. I find no reference to either “Cecil Farley” or “Cecil Manry” in the 1930 census. Mattie apparently listed herself as a “widow” because of the social stigma attached to divorce at that time. As a stimulus to further research, I tentatively list James’s children as given in "), _c('a', {
    attrs: {
      "href": "http://FamilySearch.org",
      "target": "_blank"
    }
  }, [_vm._v("FamilySearch.org")]), _vm._v(" and "), _c('a', {
    attrs: {
      "href": "http://Genealogy.com",
      "target": "_blank"
    }
  }, [_vm._v("Genealogy.com")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Child (by his 1"), _c('sup', [_vm._v("st")]), _vm._v(" wife):")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23669. James Manry.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children (by his 2"), _c('sup', [_vm._v("nd")]), _vm._v(" wife):")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23670. Nell Manry.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23671. Rose Marie Manry.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23672. Amelia Manry.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23673. Mary Edith Manry.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23674. Larry Manry. [1920 census Lincoln Parish, La., E.D. 60, pp. 3B-4A; "), _c('a', {
    attrs: {
      "href": "http://FamSearch.org",
      "target": "_blank"
    }
  }, [_vm._v("FamSearch.org")]), _vm._v("/AF v4.19; "), _c('a', {
    attrs: {
      "href": "http://Gen.com",
      "target": "_blank"
    }
  }, [_vm._v("Gen.com")]), _vm._v("/WFT]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13215. William Ray Manry (born Iran, Bossier Parish, La., Jan. 13, 1898; a WW I veteran, he married in Shreveport, Caddo Parish, La. [1"), _c('sup', [_vm._v("st")]), _vm._v(", on Jan. 1, 1922] Ora Etta Meredith [born in La., Sept. 10, 1901; in 1940 she was divorced and residing in Cullendale, Ouachita Co., Ark., where her occupation was “reporter, Service Bureau.” She died in Shreveport, Caddo Parish, La., March 22, 1983]. They resided in Bossier City, Bossier Parish, La., 1930, where he operated a printing shop and she taught in a private kindergarten. He married [2"), _c('sup', [_vm._v("nd")]), _vm._v("] Bertie Fountain [born 1894; died in Dublin, Laurens Co., Ga., 1987]. William died in Dublin, Ga., Aug. 15, 1988).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children (by his 1"), _c('sup', [_vm._v("st")]), _vm._v(" wife):")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23675. Ameretta N. Manry (born in La., ca. 1923).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23676. Meredith Banks Manry (born in Shreveport, La., Nov. 13, 1927; married Margaret Ann Kromis. He was NSWFD member #709, and they resided in Dubberly, Webster Parish, La. They had six children: Mary Patricia Manry [born 1956], Michael Meredith Manry [born 1957], David William Manry [born 1959], Johanna Lynne Manry [born 1962], Timothy Charles Manry [twin; born 1963], and Theresa Catherine Manry [twin; born 1963]).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23677. Joy Manry (born in La., ca. 1931). [1930 census Bossier Parish, La., E.D. 5, p. 17A; 1940 census Ouachita Co., Ark., E.D. 52–15, p. 22A; NSWFD #769 (Meredith B. Manry); "), _c('a', {
    attrs: {
      "href": "http://FamSearch.org",
      "target": "_blank"
    }
  }, [_vm._v("FamSearch.org")]), _vm._v("/AF v4.19; "), _c('a', {
    attrs: {
      "href": "http://Gen.com",
      "target": "_blank"
    }
  }, [_vm._v("Gen.com")]), _vm._v("/WFT]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13216. John Ardis Manry (born in Plain Dealing, Bossier Parish, La., Nov. 5, 1903; a linotype operator for a newspaper, he married [Oct. 17, 1927] Maybelle Francis [born in Atlanta, Ga., March 7, 1904; died in New Orleans, La., Oct. 1, 1995]. They resided in Atlanta, Ga., and he died in Springhill, Webster Parish, La., Jan. 26, 1993).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23678. Mary Frances Manry (born in Ga., ca. June 1929).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23679. John Ardis Manry, Jr.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23680. Charles Manry (born in Ga., ca. 1936). [1930 census DeKalb Co., Ga., E.D. 10, p. 11A; 1940 census ibid., E.D. 44–42, p. 3B; NSWFD #518 (John Ardis Manry); "), _c('a', {
    attrs: {
      "href": "http://FamSearch.org",
      "target": "_blank"
    }
  }, [_vm._v("FamSearch.org")]), _vm._v("/AF v4.19; "), _c('a', {
    attrs: {
      "href": "http://Gen.com",
      "target": "_blank"
    }
  }, [_vm._v("Gen.com")]), _vm._v("/WFT]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13217. Glenn Hamilton Curry (born in Plain Dealing, Bossier Parish, La., Oct. 26, 1889; married [Nov. 25, 1913] Hazel Locke [born in Kans., ca. 1893]. He worked as a “warehouse man for an oil company” and resided in Shreveport, Caddo Parish, La., 1930. He died in Houston, Tex., Oct. 12, 1958).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23681. Mary Elizabeth Curry (born in La., ca. 1915).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23682-a. Glenn Hamilton Curry, Jr. (born ibid., ca. 1917).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23682-b. Ruth Curry (born ibid., ca. 1918). [1900 census Bossier Parish, La., E.D. 17, p. 3A; 1930 census Caddo Parish, La., E.D. 43, p. 19B; WW I and WW II Draft Reg.; "), _c('a', {
    attrs: {
      "href": "http://Gen.com",
      "target": "_blank"
    }
  }, [_vm._v("Gen.com")]), _vm._v("/WFT; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11334–15481]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13218. Anna Bell Curry (born in La., Dec. 7, 1890; married William B. Boggs, Jr. [born ibid., ca. 1888]. They resided in Shreveport, Caddo Parish, La., where he was manager of a tool and supply company).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23683. William Curry Boggs (born in La., ca. 1910).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23684. Samuel Henry Boggs.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23685. Marvin Fitzhugh Boggs.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23686. Beryl Boggs.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23687. Margery Gray Boggs. [1930 census Caddo Parish, La., E.D. 55, p. 4B; "), _c('a', {
    attrs: {
      "href": "http://Anc.com",
      "target": "_blank"
    }
  }, [_vm._v("Anc.com")]), _vm._v("/OWT; "), _c('a', {
    attrs: {
      "href": "http://RootsWeb.com",
      "target": "_blank"
    }
  }, [_vm._v("RootsWeb.com")]), _vm._v("/WCP; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11334–15482]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13219. Robert Houston Curry (born in Plain Dealing, Bossier Parish, La., Jan. 27, 1892; working as a cashier for a railroad, he resided unm. in Willcox, Cochise Co., Ariz., when he registered for the draft June 5, 1917. A member of SAR, he was later a general manager of a gas company and also a member of the Louisiana State Board of Education. He married [ca. 1916] Mildred E. Scheffler [born in Ind., ca. 1896], and they resided in Haynesville, Claiborne Parish, La., 1930).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23688. Virginia E. Curry (born in Ariz., ca. 1918).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23689. Mary M. Curry (born in Cal., ca. 1922).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23690. Mildred M. Curry (born in La., ca. June 1926). [1900 census Bossier Parish, La., E.D. 17, p. 3A; 1930 census Claiborne Parish, La., E.D. 5, p. 4B; 1940 census ibid., E.D. 14–6, p. 12A; WW I Draft Reg.; "), _c('a', {
    attrs: {
      "href": "http://Gen.com",
      "target": "_blank"
    }
  }, [_vm._v("Gen.com")]), _vm._v("/WFT; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11334–15482]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13225. Leslie Lena Banks (born in La., July 29, 1896; married in Caddo Parish, La. [April 24, 1920] Karl “Martin” Zylks. They resided in Washington Township, Ouachita Co., Ark., 1930, and she died March 10, 1960).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Child:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23691. Jack M. Zylks (born in La., ca. 1922). [1930 census Ouachita Co., Ark., E.D. 29, p. 16A; "), _c('a', {
    attrs: {
      "href": "http://Anc.com",
      "target": "_blank"
    }
  }, [_vm._v("Anc.com")]), _vm._v("/AWT, entry by RHL; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11334–15496]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13227. Curtis Lyon Banks (born in Plain Dealing, Bossier Parish, La., May 14, 1904; married in Smackover, Union Co., Ark. [Oct. or Nov. 27, 1926] Ruby Lee Burke [born in Tex., Aug. 12, 1909; died in Shreveport, Caddo Parish, La., Oct. 14, 1982]. They resided in Smackover, Ark., in 1930, where he was a laborer in crude oil production. He died in Shreveport, La., June 22, 1966).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23692. William Curtis Banks.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23693. Sammie Jean Banks.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23694. Burke Don Banks. [1930 census Union Co., Ark., E.D. 35, p. 24B; SSDI; "), _c('a', {
    attrs: {
      "href": "http://Gen.com",
      "target": "_blank"
    }
  }, [_vm._v("Gen.com")]), _vm._v("/WFT; "), _c('a', {
    attrs: {
      "href": "http://RootsWeb.com",
      "target": "_blank"
    }
  }, [_vm._v("RootsWeb.com")]), _vm._v("/WCP, entry by CW; FGS By DBS]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13228. Fitzhugh Lee Banks, Jr. (born in La., ca. 1903; a construction worker for an oil refinery, he resided unm. with his parents in El Paso, El Paso Co., Tex., 1930. He later married Ethel Elizabeth Mollinary, and he died in El Paso Co., Tex., April 15, 1974).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23695. Mary Elizabeth Banks.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23696. Ethel Fitzhugh Banks. [1930 census El Paso Co., Tex., E.D. 41, p. 14B; TexBI; TexDI; B. C. NOONAN, website “Desc. of Edward III”]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13233. Mary Fitzhugh Gryder (born in La., ca. 1887; DAR member #145822, she married William Rufus Donley. She resided as a widow with her parents in El Paso, El Paso Co., Tex., 1920, where she worked as a stenographer).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23697. Rufus Fitzhugh Donley (born in La., Dec. 10, 1906; a WW II veteran, he enlisted in Los Angeles Co., Cal., Sept. 2, 1942. He died in Los Angeles Co., Cal., June 16, 1964, and he was buried at Fort Rosecrans National Cemetery in San Diego, Cal.).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23698. Houser (?) Donley (born in La., ca. 1911). [1920 census El Paso Co., Tex., E.D. 65, p. 9B; WW II AER; CalDI]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13240. Julian Chester Gryder (born in La., Aug. 14, 1909; married Mary Frances Taylor [born in Tex., ca. 1912; she worked as a saleslady in a department store, 1940]. They resided in El Paso, Tex., where he worked as a bookkeeper for a construction company. He died in Los Angeles Co., Cal., March 15, 1993).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Child:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23699. Carolyne Jean Gryder (born in Ellis Co., Tex., Nov. 21, 1929). [E. SHUMAKER, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Genealogical Lineage of P. J. M. Leiper")]), _vm._v(", 34; 1930 census El Paso Co., Tex., E.D. 55, p. 7B; 1940 census ibid., E.D. 256–72, p. 4B; TexBI; CalDI; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11334–154ax]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13245. Jesse Pitts Jarvis (born in Ark., March 12, 1887; married in Pulaski Co., Ark. [June 18, 1913] Maybelle Claire Campbell [born in Ark., ca. 1890]. They resided in Victoria, Jefferson Co., Ark., where he managed a plantation).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23700. Floyd Alexander Jarvis (born in Ark., ca. 1914).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23701. Benjamin Jarvis (born ibid., ca. March 1917).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23702. Jesse P. Jarvis (born ibid., ca. Dec. 1918). ["), _c('a', {
    attrs: {
      "href": "http://FamSearch.org",
      "target": "_blank"
    }
  }, [_vm._v("FamSearch.org")]), _vm._v("/Ark. Marriages; 1920 census Jefferson Co., Ark., E.D. 143, pp. 5A-B; "), _c('a', {
    attrs: {
      "href": "http://RootsWeb.com",
      "target": "_blank"
    }
  }, [_vm._v("RootsWeb.com")]), _vm._v("/WCP, entry by CW; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11334–15651]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13246. Sarah Atkins Jarvis (born in Pine Bluff, Jefferson Co., Ark., June 14, 1892; married [1926] Percy Erwin Fallon [born in Dublin, Erath Co., Tex., Jan. 14, 1883; worked as a mechanical engineer for a manufacturing company. He died in Houston, Tex., Jan. 9, 1952]. They resided in Houston, Tex., where she died March 9, 1957).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23703-a. Walter Fallon (born in Ark., ca. July 1928).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23703-b. Ann Fallon (born ibid., ca. 1930). ["), _c('a', {
    attrs: {
      "href": "http://FamSearch.org",
      "target": "_blank"
    }
  }, [_vm._v("FamSearch.org")]), _vm._v("/Tex. Deaths; 1930 census Harris Co., Tex., E.D. 113, p. 22A; 1940 census ibid., E.D. 258–76, p. 11A; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11334–15652]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13247. Edmonia Fentress Jarvis (born in Pine Bluff, Jefferson Co., Ark., May 20, 1897; married in Little Rock, Pulaski Co., Ark. [June 3, 1926] Davis Eugene Van Norman [born in Liberty, Amite Co., Miss., Sept. 12, 1897; died in Centreville, Wilkinson Co., Miss., Sept. 18, 1960]. She died in Baton Rouge, East Baton Rouge Parish, La., Aug. 23, 1967).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23704. Eugene Fentress Van Norman.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23705. James Fitzhugh Van Norman. [Mrs. J. N. BELCHER, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Genealogical Records-DAR, Ark.")]), _vm._v(", 2:63; "), _c('a', {
    attrs: {
      "href": "http://Anc.com",
      "target": "_blank"
    }
  }, [_vm._v("Anc.com")]), _vm._v("/AWT, entry by VNFA; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11334–15653]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13248. Jane Cruse Sanders (born in Oh., Jan. 27, 1909; married in Cincinnati, Oh. [Dec. 2 or 3, 1932] Willard Blayney Fessenden [born in Chillicothe, Ross Co., Oh., Nov. 10, 1900; graduated from the U. of Cincinnati (M.D., 1925). A physician, he served in the Medical Corps, USA, and he died in Cincinnati, Oh., July 1972]. They resided in Cincinnati, Oh., and she died Oct. 5, 1962).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23706. Willard Blayney Fessenden (born in Oh., Oct. 4, 1936).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23707. Jane Ellen Fessenden (born May 16, 1940). [1940 census Hamilton Co., Oh., E.D. 91–16A, p. 9B; "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Am. Med. Dir.")]), _vm._v(", 1950, p. 1573; SSDI; "), _c('a', {
    attrs: {
      "href": "http://Anc.com",
      "target": "_blank"
    }
  }, [_vm._v("Anc.com")]), _vm._v("/AWT, entry by KMC; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11334–19411]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13249. Addison Fitzhugh Sanders (born in Oh., March 1, 1910; married [Jan. 20, 1940] Elizabeth Blagg Motz [born Feb. 12, 1917]. A WW II veteran, he enlisted in Cincinnati, Oh., Oct. 1943. He died Nov. 29, 1951).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Child:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23708. Sara Wright Sanders. [WW II AER; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11334–19411]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13250. Wright Sanders (born in Oh., March 16, 1917; married [March 22, 1943] Sylvia Beste Kerrigan [born Sept. 7, 1916]. Enrolled in Social Security in Ohio, he later died on Hilton Head Island, Beaufort Co., S.C., July 4, 2003).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23709. Barbara Jean Sanders (born March 26, 1945).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23710. James Wright Sanders (born Nov. 23, 1950). [SSDI; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11334–19413]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13252. Sarah Ashton Miller (born in Ind., July 2, 1908; married [Feb. 14, 1941] James Conkling Kimbrough [born Dec. 25, 1906; died Sept. 1967]. She resided in Muncie, Delaware Co., Ind.).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Child:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23711. James Frank Kimbrough (born Nov. 8, 1942). [J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11334–19422]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13253. Virginia Mason Payne (born in Va., April 2, 1882; married [Oct. 7, 1903] Dr. Frank Blair Olhausen [died Oct. 8, 1910]. She resided in 1930 as a widow with her mother in Harrisonburg, Rockingham Co., Va., and she died Dec. 27, 1948).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23712. Blair Olhausen (born March 16, 1905; died April 24, 1906).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23713. Harriet Olhausen (born in Va., Sept. 14, 1906; died unm. Oct. 18, 1987).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23714. William H. Olhausen (born ibid., Dec. 19, 1907; a bookkeeper, he died unm. May 28, 1945).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23715. Mary Elizabeth Olhausen (born ibid., June 24, 1909; married Charles A. Williams [died Nov. 30, 1970]. They resided in Harrisonburg, Va.). [B. PAYNE, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Paynes")]), _vm._v(", 143–145, 181–182, 209–210; 1930 census Rockingham Co., Va., E.D. 104, p. 4A; FGS by LPTN; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11334–1b111]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13257. John Winston Payne (born in Strasburg, Shenandoah Co., Va., Nov. 28, 1889; a salesman, he married [June 26, 1915] Blanche E. Donovan [born in Va., July 18, 1896; died June 19, 1986]. They resided in Harrisonburg, Rockingham Co., Va., and he died July 28, 1948).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23716. Laura J. Payne.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23717. Eleanor Winston Payne.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23718. Virginia Catherine Payne.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23719. Elizabeth Lee Payne. [B. PAYNE, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Paynes")]), _vm._v(", 210, 220; 1930 census Harrisonburg (Independent City), Va., E.D. 2, p. 4A; WW II Draft Reg.; SSDI; FGS by LPTN; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11334–1b115]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13259. Arthur Alexander Morson Payne (born in Va., Nov. 29, 1893; married [June 8, 1921] Helen Marietta Hirst [born in Pa., April 9, 1895; a nurse, she served as nurse in France during WW I]. They resided in Bound Brook, Somerset Co., N.J., 1930, where he worked as a foreman in a factory. He was killed in an industrial explosion, Nov. 29, 1935).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23720. Mary Lee Payne.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23721. Helen Anne Payne. [B. PAYNE, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Paynes")]), _vm._v(", 210, 220; 1930 census Somerset Co., N.J., E.D. 7, p. 7B; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11334–1b117]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13260. Laura Lee Payne (born in Va., Sept. 24, 1895; married [Nov. 7, 1922] Arthur Palfrey Terry [born ibid., ca. 1890; a veteran of WW I, he fought in the Meuse-Argonne offensive. His diary and other war-time papers form part of the Marshall Manuscripts Collection at VMI After the war he worked as a highway contractor]. They resided in 1930 with his parents in Wytheville, Wythe Co., Va. She died Sept. 24, 1967).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23722. Winston Terry (daughter; died at birth).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23723. Laura Payne Terry. [B. PAYNE, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Paynes")]), _vm._v(", 210; 1930 census Wythe Co., Va., E.D. 12, p. 7A; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11334–1b118]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13261. Sadie Winter Payne (born in Va., Aug. 10, 1898; married [Aug. 19, 1924] James Bolton [born ibid., June 27, 1880; an engineer and architect, he worked for the city of Richmond in 1930. He died June 30, 1961. They resided in Richmond, Va., and she died May 18, 1989).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23724. James Bolton, Jr. (born in Va., Aug. 30, 1925; served in the Navy from July 1945 to July 1946. He attended Randolph-Macon College, and later worked for the Department of Public Works, Division of Surveys, in Richmond, Va., from 1962 to 1990. He married ___, and they were divorced. A member of numerous lineage societies, including NSWFD #609, SAR #117871, and SCV, he aided greatly with registration at NSWFD conventions for many years. He generously contributed the full text of a valuable sketch about his great-grandfather, General William Henry Fitzhugh Payne, CSA [q.v. and see bibliography], as well as data on his family. He "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("d.s.p.")]), _vm._v(" in Richmond, Va., Jan. 16, 2010).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23725. William Payne Bolton. [B. PAYNE, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Paynes")]), _vm._v(", 211; 1930 census Henrico Co., Va., E.D. 30, p. 25B; SSDI; "), _c('a', {
    attrs: {
      "href": "http://Anc.com",
      "target": "_blank"
    }
  }, [_vm._v("Anc.com")]), _vm._v("/Dept. of Veterans Affairs; FGS by JB, Jr.; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11334–1b119]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13262. Harry Fitzhugh Payne (born Oct. 20, 1901; married [1"), _c('sup', [_vm._v("st")]), _vm._v(", on Aug. 12, 1920] Sarah “Sadie” Margaret Flick. Later divorced, he married [2"), _c('sup', [_vm._v("nd")]), _vm._v("] Beatriz Muzquiz [born July 28, 1913]. He died May 6, 1949).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children (by his 1"), _c('sup', [_vm._v("st")]), _vm._v(" wife):")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23726. Mary Elizabeth Payne (Flick?) (born Oct. 1, 1920; “adopted by Everhard family in Sioux City, Iowa, following her parents’ divorce.” She married Walter L. Blake).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23727. Robert Fitzhugh Payne.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children (by his 2"), _c('sup', [_vm._v("nd")]), _vm._v(" wife):")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23728. Laura Lee Payne (born March 22, 1936; married Willis Jackson. They resided in Ingleside, Tex., and they had five children and two or more grandchildren).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23729. Mary Josephine Payne.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23730. Harry Fitzhugh Payne. [Quotation from FGS by LPTN. See also: B. PAYNE, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Paynes")]), _vm._v(", 211, 220; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11334–1b11x]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13265. Eppa Hunton IV (born in Richmond, Va., July 31, 1904; graduated from the U. of Va. [B.A., 1925; LL.B., 1927] and was awarded a LL.D. degree by Va. Commonwealth U. [1976]. A lawyer in Richmond, he also served on the board of directors of the First & Merchants National Bank. During WW II he rose from the rank of 1"), _c('sup', [_vm._v("st")]), _vm._v(" Lt. to Major, USA, receiving the Bronze Star. He was a member of the board of visitors of the Medical College of Va. [1932–1951, 1954–1958, 1959–1963, 1964–1968], chairman of the executive board [1954–1958, 1965–1968], and chairman of the board [1960–1963]. He also served as president of the Medical College of Va. Foundation [1972-ca. 1976], as well as a member of the board of visitors for Va. Commonwealth U. [1968–70], vice-president of the Society of the Cincinnati in Virginia [1970–1973], and president of the Virginia Historical Society [1966–1969]. He married in Richmond, Va. [Sept. 28, 1936] his 7"), _c('sup', [_vm._v("th")]), _vm._v(" cousin, Caroline Homassel Marye [born in New York, N.Y., May 22, 1910; #15752, she died in Richmond, Va., July 15, 1962]. They resided in Richmond, Va., where he died Nov. 23, 1976).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23731. Caroline Homassel Hunton.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23732. Virginia Payne Hunton.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23733. Eppa Hunton V. [E. EBERHART-A. ROBERTSON, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Maryes of Va.")]), _vm._v(", 269–270; "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Who’s Who Am.")]), _vm._v(", 1978–79; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11334–1b192 and 11515–61152 (Caroline Homassel Marye)]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13269. Marion Kingsbury Payne (born at Fort Hamilton, Brooklyn, N.Y., Jan. 17, 1900; married in Boston, Mass. [Sept. 9, 1922] George Williamson Brashears, Jr. [born in Mo., 1896; graduated from the USNA, Annapolis, 1919. He served as Capt., USN, and he died Nov. 30, 1948]).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23734. Patricia Brashears (born in N.Y., ca. 1924).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23735. Peter Williamson Brashears (born in Conn., April 28, 1928; died in Flagler Co., Fla., May 6, 1994). [B. PAYNE, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Paynes")]), _vm._v(", 211; 1930 census Philadelphia Co., Pa., E.D. 260, p. 9A; brief obit. notice of G. W. Brashears in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Shipmate")]), _vm._v(", Jan. 1948; FlaDI; "), _c('a', {
    attrs: {
      "href": "http://www.icon.net/˜sdcaller",
      "target": "_blank"
    }
  }, [_vm._v("www.icon.net/˜sdcaller")]), _vm._v("]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13273. James Keith Payne, Jr. (born in St. Louis, Mo., Aug. 25, 1911; worked for A. G. Edwards in St. Louis, Mo., 1928, where he later joined the D’Arcy Advertising Agency in 1935. He married [1"), _c('sup', [_vm._v("st")]), _vm._v("] Frances Share [born in Mo., ca. 1911; died 1976], and he later married [2"), _c('sup', [_vm._v("nd")]), _vm._v("] Mary ___ [died May 2003]. After retiring in 1967, he moved to Victoria, British Columbia, Canada, where he died Aug. 29, 2003).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Child:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23736. Marion Payne (born in Mo., ca. 1939; married ___ Killion, and they resided in Phoenix, Ariz.). [B. PAYNE, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Paynes")]), _vm._v(", 188–189; 211; 1940 census St. Louis Co., Mo., E.D. 96–746, p. 62A; "), _c('a', {
    attrs: {
      "href": "http://Anc.com",
      "target": "_blank"
    }
  }, [_vm._v("Anc.com")]), _vm._v("/AWT J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11334–1b651]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13278. Thomas Edward Johnson (born in North East, Cecil Co., Md., Jan. 25, 1879; married [Oct. 18, 1899] Agnes Burdell Pierson [born in Elk Neck, Cecil Co., Md., Jan. 1877; died in Newark, New Castle Co., Dela., ca. 1967]. They resided in Cecil Co., Md., where he was a teamster in 1900 and a railroad laborer in 1910. He reportedly abandoned his wife and children, and he died in Newark, Dela., Jan. 13, 1947).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23737. Edith Ellen Johnson (born in North East, Md., March 29, 1900; married Mead Ragan, and she died in Newark, Dela., Jan. 1975. They adopted one child: Rhoda Ragan).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23738. Thomas Edward Johnson (born in North East, Md., July 12, 1903; married [1"), _c('sup', [_vm._v("st")]), _vm._v("] Bessie ___, and he married [2"), _c('sup', [_vm._v("nd")]), _vm._v("] ___. He "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("d.s.p.")]), _vm._v(" in Newark, Dela., May 8, 1952).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23739. Lloyd Emery Johnson (twin; born in North East, Md., Sept. 20, 1905; married Dorothy Agnes Johnson, and he died May 1977. They had one child: Eugene Lloyd Johnson [born in Newark, Dela.]).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23740. Earl M. Johnson (born and died 1909).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23741. Mildred Johnson (born Oct. 19, 1909; married Joseph Greene, and she died in N.J., Sept. 12, 2005. They had two children: Joseph Lee Green [born April 4, 1941] and James Michael Green [born Nov. 4, 1946]).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23742. Ethel Egner Johnson (born in Cowentown, Cecil Co., Md., Sept. 23, 1913; married in Elkton, Cecil Co., Md. [Oct. 27, 1943] Albert Varady [born in Phoenixville, Chester Co., Pa., Feb. 3, 1916; enlisted in the Army on April 30, 1945, and he died May 1, 1973]. She died in Newark, Dela., Dec. 3, 1984. They had five children:")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("[1]. Nancy Louise Varady (born in Elkton, Md., Aug. 18, 1944; married in Newark, Dela. [Aug. 20, 1966] Carl Mark Koch [born April 29, 1944]. They resided in Wilmington, New Castle, Dela., and they had three children: [i] Carcy Lorraine Koch [born in Wilmington, Dela., April 27, 1971; married in Wilmington, Dela. (Nov. 18, 1995) Peter Michael Vreeland (born Feb. 17, 1969). They resided in Denver, Lancaster Co., Pa., and they had two children: Sydney Daley Vreeland and Nathan Peter Vreeland]; [ii] Roger Carlson Albert Koch [born May 24, 1973, and he resided in Wilmington, Dela.]; and [iii] Janine Louise Koch [born in Wilmington, Dela., April 14, 1976; married (1"), _c('sup', [_vm._v("st")]), _vm._v(") Gary Morgan (born Feb. 21, 1971), and she married (2"), _c('sup', [_vm._v("nd")]), _vm._v(", on March 21, 2009) Sean Doughty (born Nov. 2, 1975). Janine and her first husband Gary had two children: Sadie Elizabeth Morgan and Tanner Patrick Morgan. Janine and her second husband Sean had one child: Mikaylee Doughty]).")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("[2]. Ethel Agnes Varady (born in Elkton, Md., Nov. 17, 1947; married in Newark, Dela. [Oct. 30, 1965] Harold Hudson [born July 18, 1945]. They had two children: [i] Janet Dale Hudson [born in Wilmington, Dela., July 15, 1966; married in West Chester, Chester Co., Pa. (Aug. 4, 1990) Bradley Dix (born in Philadelphia, Pa., Aug. 5, 1965), and they had two children: Ashley Jenna Dix and Kyle Bradley Dix] and [ii] Mark Harold Hudson [born in Wilmington, Dela., Sept. 5, 1968; married Dawn ___, and they had six children: Madelyn Sophia Hudson, Broden Joseph Hudson, Shane William Hudson, Angela Lynne Hudson, Ethan Mark Hudson, and Zachary Michael Hudson]).")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("[3]. Albert Varady (born in Elkton, Md., Dec. 18, 1948; married [April 30, 1968] Gail Price [born in Ashe Co., N.C., Jan. 25, 1948]. They had five children: [i] Dawn Marie Varady [born Jan. 3, 1970; served as Lt. Colonel, USAF, and she married Robert Graham, and they had three children: Matthew Graham, Eric Graham, and Michael Graham], [ii] Andrew Michael Varady [born in Wilmington, Dela., Sept. 1, 1972; married Tammy Hill, and they had two children: Briana Varady and Alyssa Varady], [iii] Jennifer Lynn Varady [born in Wilmington, Dela., Feb. 2, 1976, and she had two children: Deanna and Isabella], [iv] Holly Michelle Varady [born Feb. 24, 1980; married Albert Gaskins, and they had three children: Caitlyn Marie Gaskins, Nicholas Gaskins, and Madelyn Gaskins]; and [v] April Ann Varady [born in Wilmington, Dela., April 21, 1981; she had two children: Michael and Jeremy]).")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("[4]. Barbara Jean Varady (born in Elkton, Md., June 14, 1951; married Bruce Wendell Ryser [born in Chester, Delaware Co., Pa., June 23, 1951]. They had one child: Alexander Stephen Ryser [born Dec. 6, 1978; married Frances Lucero, and they had one child: Theodore Ryser]).")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("[5]. Darlene Varady (born in Elkton, Md., June 2, 1954; married [1"), _c('sup', [_vm._v("st")]), _vm._v(", on Dec. 28, 1974] John Howard Tobin [born in New Haven, Conn., May 10, 1946; died in Boston, Mass., Sept. 18, 1992]. She married [2"), _c('sup', [_vm._v("nd")]), _vm._v("] Robert Battiste [born July 19, 1961]. She had four children by her first husband John: [i] Rebecca Anne Tobin [born May 18, 1976; married Carmine Valentino, and they had one child: Carmine Valentino, Jr.], [ii] Seth Ian Tobin [born Sept. 27, 1977; married Sandy Sgrott (born May 28, 1982), and they had one child: Gage Tobin], [iii] Daniel David Tobin [born June 26, 1979], and [iv] Rachael Erin Tobin [born June 14, 1981; married Joseph Gangi, and they had two children: Tobin Gangi and Clover Gangi]).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23743. Marian E. Johnson (born in Elkton, Md., April 24, 1915; died in Newark, Dela., June 15, 1999). [1900 census Cecil Co., Md., E.D. 20, p. 9A; 1910 census ibid., E.D. 21, p. 7A; SSDI; FGS by CKV; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11336–41311]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13279. Molly Etta Johnson (born Sept. 1, 1880; married [1"), _c('sup', [_vm._v("st")]), _vm._v(", on Oct. 10, 1913] Hugh Smith Murphy [born April 14, 1885; died Oct. 4, 1918, and he was buried in North East, Harford Co., Md.]. She married [2"), _c('sup', [_vm._v("nd")]), _vm._v(", on Nov. 27, 1927] Louis Jay Rhein [born June 15, 1891; he was an ordnance engineer]. They resided in Aberdeen, Harford Co., Md.).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23744. Hugh Augustus Murphy (born April 23, 1914; a carpenter, he married ___, and they resided in Syracuse, Onondaga Co., N.Y.).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23745. Budd H. Murphy (Oct. 18, 1916; died Aug. 28, 1917). [J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11336–41312]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13280. Lucy McDaniel Johnson (born Oct. 14/17, 1882; married [Sept. 22, 1913] Seigfried Camillo Engleskirch [born May 3, 1888]. They resided in Delaware City, New Castle Co., Dela.).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Child:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23746. Selma Marie Engleskirch. [J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11336–41313]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13281. Bessie Ellsworth Johnson (born June 12, 1885 or July 25, 1884; married in Baltimore, Md. [Oct. 19, 1908] James Alfred Rowe [born July 1882; he was a railroad superintendent]. They resided in Baltimore, Md., where she died Dec. 21/22, 1925. The previous information comes from J.A.W. In spite of the slight discrepancies in ages, the names of this family perfectly fit the following in the 1920 census Baltimore Co., Md.: James Rowe [born in Md., ca. 1883, ware house laborer], married to Bessie [born ibid., ca. 1889], with one son: James [born ibid., ca. 1910]).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Child:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23747. James Howard Rowe. [1920 census Baltimore Co., Md., E.D. 373, p. 16A; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11336–41314]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13282. Joseph Bailey Johnson, Jr. (born in Md., July 12, 1888; an engineer for the Pennsylvania Railroad, he married [Oct. 16, 1912] Sue Heverin Howell [born in Md., Jan. 29, 1892]. They resided in Perryville, Cecil Co., Md.).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Child:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23748. Paul Wilbur Johnson. [1930 census Cecil Co., Md., E.D. 14, p. 5B; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11336–41315]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13283. Harry Augustus Johnson (born March 25, 1890; an engineer for the Pennsylvania Railroad, he married [Sept. 15, 1909] Eva Lake Crouch [born May 18, 1892]. They resided in Elkton, Cecil Co., Md.).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23749. Harry Albert Johnson (born Jan. 16, 1913; married [July 27, 1945] Martha Jane Madden [born Aug. 18, 1915]).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23750. Etta Louisa Johnson. [J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11336–41316]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13285. Robert Marshall Johnson (born in Md., Aug. 11, 1896; a locomotive engineer for the Pennsylvania Railroad, he married [1"), _c('sup', [_vm._v("st")]), _vm._v(", on Jan. 3, 1915] Elsie Hall Sipps [born in Md., June 2, 1893; died Sept. 11, 1923]. He married [2"), _c('sup', [_vm._v("nd")]), _vm._v(", on April 24, 1925] Ruth Virginia Kennedy [born Jan. 22, 1907]. They resided in Port Deposit, Cecil Co., Md., 1920, and they also resided at one time in Havre de Grace, Harford Co., Md.).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children (by his 1"), _c('sup', [_vm._v("st")]), _vm._v(" wife):")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23751. Dorothy Florence Johnson.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23752. Howard Joseph Johnson.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23753. Robert Marshall Johnson, Jr. (born in Md., Jan. 9, 1919; died unm. Jan. 9, 1937). [1920 census Cecil Co., Md., E.D. 29, p. 15B; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11336–41318]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13288. Bessie Elsworth Johnson (born in North East, Cecil Co., Md., April 9, 1908; married [Feb. 11, 1926] William Hiram Wright [born in Pennsauken, Camden Co., N.J., July 27, 1900; died in N.J., Nov. 1, 1930]. They resided in Camden, Camden Co., N.J., where she died Jan. 20, 1999).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23754. William Corbin Wright (born Sept. 1, 1927).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23755. Frances Ellen Wright (born in N.J., Nov. 1, 1930; married ___ Jones. She died in Redwood City, San Mateo Co., Cal., March 10, 1997, and they had two children).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23756. Robert Edward Wright (born 1937). ["), _c('a', {
    attrs: {
      "href": "http://RootsWeb.com",
      "target": "_blank"
    }
  }, [_vm._v("RootsWeb.com")]), _vm._v("/WCP, entry by DBC; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11336–41351]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13289. Beatrice Rebecca Johnson (born Sept. 1, 1909; married [April 6, 1928] Roy Leon Murray [born March 29, 1900]. She resided at one time in Buffalo, Erie Co., N.Y., and she died in Batavia, Genesee Co., N.Y., March 18, 2004).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23757. Robert Leon Murray (born 1932).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23758. George Corbin Murray (born July 23, 1933; served in the Army during the Korean War. He last resided in East Pembroke, Genesee Co., N.Y., and he died Jan. 12, 2005. He was buried at Stafford Rural Cemetery in Le Roy, Genesee Co., N.Y.).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23759. Edith Stella Murray (born May 17, 1936).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23760. Edward James Murray (born 1937). [SSDI; U.S. Veterans Gravesites; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11336–41352]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13290. Sarah Caroline Johnson (born in Md., Dec. 17, 1910; married [Jan. 18, 1929] Ralph Stephen Atkinson [born ibid., May 30, 1909]. They resided in Cecil Co., Md., 1930, where he was a laborer in a clay mine).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23761. Cora Alverta Atkinson (born July 15, 1930).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23762. Mary Elizabeth Atkinson (born April 15 and died Sept. 4, 1931). [1930 census Cecil Co., Md., E.D. 11, p. 11B, which gives her name as “Caroline S. Atkinson”; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11336–41353]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13291. Kathryn Tobin Johnson (born in Leslie, Cecil Co., Md., June 7, 1912; married in Cecil Co., Md. [Oct. 4, 1930] John Lewis McKinney [born Aug. 12, 1897 or 1898; a carpenter in a shipyard, he died in Rising Sun, Cecil Co., Md., Dec. 15, 1992]. They resided in North East, Cecil Co., Md., and both died at Calvert Manor Healthcare Center in Rising Sun, Md., Nov. 28, 1996).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23763. William Keithley McKinney (born in North East, Md., May 4, 1931; married ___ Fields [born 1939]. He died in North East, Md., Nov. 9, 1985, and they had three children).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23764. John Lewis McKinney, Jr. (born in Md., ca. 1933).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23765. Margaret Elizabeth McKinney (born ibid., ca. 1935).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23766. Eugene Jacob McKinney (born 1943). [1940 census Cecil Co., Md., E.D. 8–12, p. 14A; SSDI; "), _c('a', {
    attrs: {
      "href": "http://RootsWeb.com",
      "target": "_blank"
    }
  }, [_vm._v("RootsWeb.com")]), _vm._v("/WCP, entry by DBC; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11336–41354]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13292. Margaret E. Johnson (born in Md., Nov. 30, 1914; married [1"), _c('sup', [_vm._v("st")]), _vm._v("] Herman Irwin [born in Md., ca. 1916]. They resided in North East, Cecil Co., Md., 1940, where he was a trackman for a railroad. They were later divorced. She married [2"), _c('sup', [_vm._v("nd")]), _vm._v("] Robert Rudy, and she resided in Dade City, Pasco Co., Fla., 2004, according to the obituary of her sister Patricia).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Child:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23767. Roger L. Johnson (born in Md., ca. 1934; he later appears to have taken the surname of his stepfather Herman Irwin). [1940 census Cecil Co., Md., E.D. 8–11, p. 11B; FGS by WER; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11336–41355]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13293. Laura Virginia Johnson (born Jan. 10, 1919; married [1"), _c('sup', [_vm._v("st")]), _vm._v("] Joseph Bernard Hitchens. She married [2"), _c('sup', [_vm._v("nd")]), _vm._v("] Clifford Roth, married [3"), _c('sup', [_vm._v("rd")]), _vm._v("] John Barranco, and married [4"), _c('sup', [_vm._v("th")]), _vm._v("] Raymond “Wally” Kennedy).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23768. Wayne Eugene Racine (born Oct. 3, 1935; his mother Laura did not marry his father. Wayne generously shared his extensive notes on his mother’s family and ancestry, and he resided in The Villages, Sumter Co., Fla.).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Child (by her 1"), _c('sup', [_vm._v("st")]), _vm._v(" husband);")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23769. Calysta Delores Hitchens (born July 13, 1937).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Child (by her 2"), _c('sup', [_vm._v("nd")]), _vm._v(" husband):")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23770. Margaret Virginia “Ginger” Roth (born Nov. 27, 1945). [FGS by WER; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11336–41356]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13294. Corbin Washington Johnson, Jr. (born March 29, 1920; married [Jan. 13, 1942] Nellie Dean Johnson [born July 8, 1919]. They resided Elkton and later North East, Cecil Co., Md. He last resided in Cecil Co., Md., and he died Oct. 26, 1992).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23771. Helen Geraldine Johnson (born 1943).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23772. Corbin Washington Johnson III (born 1947). [SSDI; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11336–41357]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13295. Bertha Josephine Johnson (born Jan. 28, 1923; married [Oct. 10, 1941] Emmett Ulysses Letts [born in North East, Cecil Co., Md., Feb. 27, 1920; he worked as a fireman for the Pennsylvania Railroad and later as an engineer for Amtrak. He died in North East, Md., March 6, 2006]. They resided in North East, Md., and Bertha died Oct. 28, 2003).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children (order of younger children uncertain):")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23773. Patricia Ann Letts (born 1942; married ___ Jones, and they resided in North East, Md.).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23774. Linda Lee Letts (born 1943; married ___ Foreaker, and they resided in North East, Md.).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23775. Joyce Arlene Letts (born 1946; married ___ Lake).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23776. Diane Letts (married ___ Fritz, and they resided in Port Deposit, Cecil Co., Md.).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23777. Earl Letts (resided in North East, Md.).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23778. Emmett Ulysses Letts, Jr. (resided ibid.). [SSDI; obit. of Emmett U. Letts in the Wilmington (Dela.) "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("News Journal")]), _vm._v(", 3/8/2006; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11336–41358]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13299. Bruce Magruder (born in Washington, D.C., Dec. 3, 1882; enlisted as Pvt., Coast Artillery Corps, Aug. 31, 1904. Over the course of his long military career, he rose from the rank of Pvt. to Maj. General. He initially served in the Coastal Artillery Corps from 1904 to 1907, and was then promoted to 2"), _c('sup', [_vm._v("nd")]), _vm._v(" Lt., Inf., Feb. 11, 1907. He served in the Philippines from 1907 to 1911 and 1914 to 1917, and in the interim he was stationed along Mexican border. During WW I he served with the AEF in France as the Executive Officer of the intelligence section of General Pershing’s Headquarters, attaining the rank of Lt. Colonel, Inf., by the end of the war. He graduated from the advance course at the Infantry School in 1923 and Command and General Staff School in 1927. After teaching military science to ROTC students at N.C. State College [Aug. 1931- Oct. 1936], he became Executive Officer at the Infantry School [1937–1940]. He was promoted to Brig. General in 1939.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Magruder took a keen interest in armored tactics, and he played a prominent role in the large-scale Army maneuvers held in central Louisiana in the spring of 1940. He took command of most of the infantry’s armor, molding it into a provisional armored brigade. When the maneuvers ended on May 25, 1940, several key officers, including Magruder and then Colonel George S. Patton, gathered in the basement of Alexandria, La. High School for what proved to be an historic meeting. They drafted an urgent recommendation to Army Chief of Staff, General George C. Marshall: withdraw all the armor from cavalry and infantry units and assign it to a new armored forced. Marshall promptly implemented the recommendation, and the result was the activation of the 1"), _c('sup', [_vm._v("st")]), _vm._v(" Armored Division at Fort Knox. On July 15, 1940. Magruder was given command of the Division and promoted to the rank of Maj. General, USA, on Oct. 2, 1940. Addressing his initial task, Magruder announced a contest to come up with a name for the Division. As he sat at his desk mulling the 200 suggestions that had poured in, he found none satisfactory. He happened to glance up at his wall where a painting of the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("USS Constitution")]), _vm._v(" was hanging. Later that day, Magruder announced that the 1"), _c('sup', [_vm._v("st")]), _vm._v(" Armored Division would be known as “Old Ironsides,” a title it has retained ever since.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("After commanding the Division through its initial organization and training, Magruder was named commanding officer of the Infantry Replacement Training Center at Camp Wolter. He held this post from 1942 to 1946. His decorations included the Distinguished Service Medal and Legion of Merit. He married [1"), _c('sup', [_vm._v("st")]), _vm._v(", on Feb. 14, 1912] Ferol Clara Lott [born in San Antonio, Tex., March 15, 1891; died Jan. 29, 1945]. Later divorced, he married [2"), _c('sup', [_vm._v("nd")]), _vm._v(", on Nov. 30, 1935] Ethel [Marshall] Stevenson [born Nov. 1, 1901]. He died in Orlando, Orange Co., Fla., July 23, 1953).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children (by his 1"), _c('sup', [_vm._v("st")]), _vm._v(" wife):")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23779. Bruce Magruder, Jr. (born in Washington, D.C., Feb. 12, 1922; served in WW II as PFC, USMC Reserve. Wounded in action, his decorations included the Purple Heart. By 1957 he had reached the rank of Major. Apparently retiring at the rank of Lt. Colonel, USMC, he served in both military and civilian capacities in Southeast Asia during the era of the Vietnam War. He married [Aug. 1956] Margo ___, and they had one daughter: Isabelle Anne Magruder [born June 19, 1957]).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23780. William Marshall Magruder. ["), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Who’s Who in Am.")]), _vm._v(", 1946–47; R. ANCELL, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Biog. Dicty. of WW II Generals")]), _vm._v(", 200; F. VIRKUS, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("CAG")]), _vm._v(", 4:374; "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Yearbook American Clan Gregor Society")]), _vm._v(", vol. 43 (1959), pp. 41–42; A. M. WASHINGTON, “Living Desc. of J. Washington,” 616; obit. of Gen. Bruce Magruder in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Stars and Stripes")]), _vm._v(", 7/27/1953, p. 2; WW II USN, USMC, & USCG Casualties; C. R. GABEL, website “The 1940 Maneuvers” (see bibliog.) and website "), _c('a', {
    attrs: {
      "href": "http://www.1ad.army.mil/history",
      "target": "_blank"
    }
  }, [_vm._v("www.1ad.army.mil/history")]), _vm._v("; Daniel CAMERON, “Saigon Notes,” "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Saigon Post")]), _vm._v(", 12/21/1970, posted on numerous blog sites; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11336–41411]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13301. Marshall Magruder (born in Washington, D.C., Oct. 12, 1885; attended George Washington U., 1904–1907. He entered the Army as 2"), _c('sup', [_vm._v("nd")]), _vm._v(" Lt., Field Artillery, 1908, and he went on to serve in the Philippines [1915–1917] and then with the 1"), _c('sup', [_vm._v("st")]), _vm._v(" Division in France and the Army of Occupation in WW I. He graduated from the Army War College [1932] and the Naval War College [1933], and then taught military science at the U. of Ill. [1924–1928]. After serving as regimental commander at Schofield Barracks in Hawaii [1935–1937], he organized and commanded the Army’s first “armored cavalry artillery regiment,” the 1"), _c('sup', [_vm._v("st")]), _vm._v(" Armored Artillery Regiment, in 1939. Promoted to Brig. General to command the 14"), _c('sup', [_vm._v("th")]), _vm._v(" Field Artillery Brigade in 1942, he was transferred to the War Department Manpower Board in March 1943, where he served until his retirement in Aug. 1946. He married in Washington, D.C. [Dec. 18, 1909] Anne Louise Peyton [born May 8, 1888]. Intensely proud of his Scotch heritage, he was a prominent leader in the American Clan Gregor Society, whose archives are housed in the General Marshall Magruder Memorial Library in the Langsdale Library at the U. of Baltimore. He died July 4, 1956).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23781. Peyton Marshall Magruder.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23782. Anne Marshall Magruder.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23783. Margaret Magruder. ["), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Who’s Who in Am.")]), _vm._v(", 1946–47; R. ANCELL, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Biog. Dicty. of WW II Generals")]), _vm._v(", 201; A. M. WASHINGTON, “Living Desc. of J. Washington,” 616; "), _c('a', {
    attrs: {
      "href": "http://FamSearch.org",
      "target": "_blank"
    }
  }, [_vm._v("FamSearch.org")]), _vm._v("/District of Columbia Marriages; NSWFD #825 (Loren F. Cole, Jr.); J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11336–41413]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13302. Eleanor Magruder (born in Washington, D.C., Aug. 29, 1887; married [Sept. 12, 1908] Herndon Sharp [born in Va., Sept. 21, 1882; a WW I veteran, he was a mechanical engineer. His father, Dr. Robert Sharp, was president of Tulane U.]. They resided in Philadelphia, Pa., 1920, and by 1930 they moved to Biloxi, Harrison Co., Miss., where he was manager of an ice plant).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23784. Bruce Herndon Sharp.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23785. Eleanor Blanche “Nancy” Sharp.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23786. James Covington Sharp.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23787. Patricia Adelaide Sharp. [1920 census Philadelphia Co., Pa., E.D. 687, p. 3A; 1930 census Harrison Co., Miss., E.D. 2, p. 9A, which gives Herndon Sharp’s place of birth as S.C.; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11336–41414]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13303. Lyles Magruder (born in Washington, D.C., July 31, 1889; married [1"), _c('sup', [_vm._v("st")]), _vm._v(", on Oct. 10, 1910] Marguerite Conoley ["), _c('em', {
    staticClass: "italic"
  }, [_vm._v("d.s.p.")]), _vm._v(" Nov. 12, 1954]. After a divorce, he married [2"), _c('sup', [_vm._v("nd")]), _vm._v(", on Jan. 6, 1922] his 1"), _c('sup', [_vm._v("st")]), _vm._v(" cousin, Betty Kimberlin Magruder [born in Okla., Aug. 16, 1906; she = #13309]. They resided in Oklahoma City, Oklahoma Co., Okla., 1930, where he was a salesman for a lubrication company. After another divorce, he married [3"), _c('sup', [_vm._v("rd")]), _vm._v(", on Jan. 6, 1941] Mrs. Mary Josephine [Danford] Carter [born Jan. 21, 1912]. They resided in Los Angeles, Cal., where he died June 12, 1953).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Child (by his 2"), _c('sup', [_vm._v("nd")]), _vm._v(" wife):")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23788. Donald Lyles Magruder.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Child (by his 3"), _c('sup', [_vm._v("rd")]), _vm._v(" wife):")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23789. Jo Ann (Carter) Magruder (born in Okla., April 1935). [WW I Draft Reg.; 1930 census Oklahoma Co., Okla., E.D. 39, p. 18B, which names the daughter “Betty Ann Magruder”; CalDI; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11336–41415 and 11336–41425 (Betty Kimberlin Magruder)]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13305. Fannie May Magruder (born in Okla., Jan. 27, 1892; married [Dec. 20, 1911] Frederick Leon Button [born Jan. 10, 1889]. They resided in Saskatchewan, Canada, and she died June 11, 1921. They had one child that was stillborn, Oct. 15, 1912).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children (surviving):")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23790. Leora May Button.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23791. Wilbur Leon Button.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23792. Ruby Elsie Button. [J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11336–41421]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13306. Ruth Imogene Magruder (born in Okla., March 17, 1894; married ibid. [Jan. 7, 1912] Vance Montgomery Reed [born in Kans., Nov. 24, 1890; died in Tarrant Co., Tex., Jan. 5, 1976]. They resided in Choctaw Township, Oklahoma Co., Okla., 1920, where he drove a school bus. They resided mainly in Keene, Johnson Co., Tex., where she died Oct. 25, 1975).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23793. Hubert Vance Reed.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23794. Richard Ray Reed (born in Okla., April 30, 1917; died Dec. 19, 1922).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23795. Margaret Louise Reed (born ibid., April 30, 1927; married Ernest Phillips). [1930 census Oklahoma Co., Okla., E.D. 7, p. 3A; SSDI; TexDI; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11336–41422]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13307. Calvin Stuve Magruder (born in Okla., Aug. 2, 1896; married [1"), _c('sup', [_vm._v("st")]), _vm._v("] Bernice ___ [born in N.D., 1908]. In 1930 he was apparently unemployed and resided in Miami, Gila Co., Ariz. He married [2"), _c('sup', [_vm._v("nd")]), _vm._v(", ca. July 18, 1935] Dorothy Margaret Millard [born March 31, 1912; died in Los Angeles, Cal., Sept. 12, 2000]. He last resided in Los Angeles Co., Cal., where he died May 17, 1968).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Child (adopted):")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23796. Malcolm C. Magruder (born in Cal., ca. March 10, 1926; died in Rancho Mirage, Riverside Co., Cal., Feb. 7, 2002). [1930 census Gila Co., Ariz., E.D. 30, p. 1A; CalDI; SSDI; B. C. NOONAN, website “Desc. of Edward III”; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11336–41423]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13310. Marion West Magruder (born in Va., ca. Jan. 1, 1894; married [Nov. 12, 1921] Esther Ida Post [born in Wisc., Feb. 6, 1901; died in Riverside Co., Cal., Dec. 10, 1993]. He resided in Long Beach, Cal. in 1930, working as a machinist at an oil field, and he died in Los Angeles Co., Cal., May 25, 1957).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Child:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23797. Barbara May Magruder. [1930 census Los Angeles Co., Cal., E.D. 1120, p. 2A; CalDI; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11336–41431]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13311. Walter Magruder Leonard (born in Fostoria, Hancock Co., Oh., Sept. 6, 1891; graduated from Adelbert College [1913] and Case Western Reserve U. [M.D., 1917]. He married [April 17, 1918] Ruth Alma Ralston [born Aug. 26, 1891; last resided in Albuquerque, Bernalillo Co., N.M., and she died Dec. 1981]. They resided in Fostoria, Oh., and one week after their wedding he entered the Army as 1"), _c('sup', [_vm._v("st")]), _vm._v(" Lieut., Medical Reserve Corps, on April 24, 1918. He served as an instructor at the Medical Officers Training Camp at Fort Oglethorpe, Ga., and later as Chief of Receiving Service in the U.S. General Hospital at Fort Sheridan, Ill. Proud of his Scotch heritage, he was an active member of the American Clan Gregor Society. He died in Cleveland, Oh., Feb. 22, 1927).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23798. Walter Magruder Leonard, Jr. (born Nov. 19, 1920; married [Jan. 31, 1948] Phyllis Grubbs [born in Westerville, Oh., Oct. 4, 1924; attended Cleveland College (now Case Western Reserve U.), 1942–1944, and later received certificates from Universidad de San Carlos and American Graduate School of International Management. Together with her husband she was co-owner and sometime president of the Leonard Insurance Agency and Leonard Corp. in Phoenix, Ariz. She served as president of Insurance Women of Phoenix, Inc. and the Tombstone City Library Board, and as a member of the board of the Cochise County Library.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("She became a free-lance writer in 1971, winning first prize for fiction in the Arizona Press Women’s annual communications contest and second prize for adult fiction in the National Federation of Press Women’s annual communications contest (both in 1974). A prolific novelist with major publishers, her books included "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Prey of the Eagle")]), _vm._v(" (McKay, 1974), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Phantom of the Sacred Well")]), _vm._v(" (McKay, 1976), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Mariposa")]), _vm._v(" (Dell, 1983), and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Beloved Stranger")]), _vm._v(" (Dell, 1984). She also contributed frequently to numerous magazines, including the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Christian Science Monitor")]), _vm._v(", "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("National Parks and Conservation")]), _vm._v(", and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Child Life")]), _vm._v("]. They later resided in Tombstone, Cochise Co., Ariz., where Walter worked as a writer and photographer).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23799. Ruth Louise Leonard (born Nov. 15, 1922; married [Aug. 4, 1945] Richard Strong Claassen [born in Ithaca, Tompkins Co., N.Y., May 10, 1922; graduated from Cornell (A.B., 1943), Columbia (M.A., 1947) and U. of Minn. (Ph.D., 1950). He worked as a physicist at Sandia National Laboratories beginning in 1951, rising to the position of Director of Physics Research (1960–1968). He then became Director of Electronic Component Development. He was chairman of the National Science Seminar in 1963 and chairman of the Rocky Mountain Science Council (1965–1966). He served as panel chairman for the National Academy of Science (1971), and he received the New Mexico Academy of Science Award in 1967]. They resided in Albuquerque, N.M., 1973, and they had three children). [F. VIRKUS, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("CAG")]), _vm._v(", 3:302; "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("AmM&WSci")]), _vm._v(", 1971–1973, 1:1035; R. HENRY, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Gen. of the Fam. of the Presidents")]), _vm._v(", 28; E. W. MAGRUDER, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Yearbook of the Am. Clan Gregor Soc., 1919")]), _vm._v(", 27; obit. of Dr. W. M. Leonard, Sr., in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("JAMA")]), _vm._v(", 88 (1927) 1021; "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ConAu")]), _vm._v(", New Revision Series, 12:270–271; SSDI; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11336–41451]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13315. Helen Caroline Barnard (born in Ill., July 29, 1900; married in Cook Co., Ill. [1"), _c('sup', [_vm._v("st")]), _vm._v(", on Aug. 31, 1920] Phineas Norton Cohen [born in Ill., April 30, 1897; owner of a clothing store, he died Jan. 10, 1941]. She married [2"), _c('sup', [_vm._v("nd")]), _vm._v(", on July 5, 1941] William Worden Kruschke [born July 20, 1893; last resided in Shippenville, Clarion Co., Pa., but he died in Fort Myers Beach, Lee Co., Fla., April 1979]. Helen operated a beauty salon in Pittsburgh, Pa. She last resided in Shippenville, Pa., and she died March 1968).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Child (by her 1"), _c('sup', [_vm._v("st")]), _vm._v(" husband; adopted by her 2"), _c('sup', [_vm._v("nd")]), _vm._v(" husband):")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23800. Maurice James Cohen Kruschke. [1930 census Cook Co., Ill., E.D. 307, p. 34B; SSDI; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11336–43213]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13316. James Elmer Barnard (born in Ill., Jan. 26, 1904; at one time he was branch manager of Paramount Film Company in Indianapolis, Ind. He married [1921] Margaret Elizabeth Devney [born in Ill., Nov. 12, 1903]. They resided in Chicago, Ill., 1930, the census listing his occupation as a motion pictures traveling salesman. He died Oct. 10, 1938).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Child:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23801. James Elmer Barnard, Jr. (born in Ill., July 19, 1925; resided in Oklahoma City, Oklahoma Co., Okla., 1952). [1930 census Cook Co., Ill., E.D. 365, p. 23A, which gives the father’s name as “Elmer J. Barnard”; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11336–43214]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13317. Charles Halden Barnard, Jr. (born in Ill., Feb. 14, 1909; married [1"), _c('sup', [_vm._v("st")]), _vm._v(", ca. 1927] Patricia Barry. Later divorced, ca. 1933, he married [2"), _c('sup', [_vm._v("nd")]), _vm._v(", ca. 1933] Irma Ritter. He resided in Chicago, Ill., site of both marriages, and he later moved to Detroit, Mich., and then to Milwaukee, Milwaukee Co., Wisc. He died June 10, 1947).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children (by his 2"), _c('sup', [_vm._v("nd")]), _vm._v(" wife):")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23802. Charles Halden Barnard III (born in Chicago, Ill., Aug. 21, 1934 or 1935).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23803. Bonnie Lee Barnard (born in Milwaukee, Wisc., April 17, 1945). [J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11336–43215]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13318. Odelle Lee Washington (born in Chicago, Ill., April 20, 1921; married [1"), _c('sup', [_vm._v("st")]), _vm._v(", on Nov. 28, 1940] Charles Theodore Ketchel [born June 13, 1921; a WW II veteran, he died April 22, 2001, and he was buried at Arlington (Okla.) Memory Gardens]. After her divorce in April 1947, she married in Oak Lawn, Cook Co., Ill. [2"), _c('sup', [_vm._v("nd")]), _vm._v(", on April 28, 1948] Ernest Chrest Hanson [born Dec. 8, 1917; served as 1"), _c('sup', [_vm._v("st")]), _vm._v(" Lt., USA, and his decorations included the Bronze Star with Oak Leaf Cluster. He last resided in St. Petersburg, Pinellas Co., Fla., and he died Aug. 31, 1988]. They resided in Ariz., later Wisc., and retired in Madeira Beach, Pinellas Co., Fla.).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children (by her 2"), _c('sup', [_vm._v("nd")]), _vm._v(" husband):")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23804. Brynda Leigh Hanson (born in Phoenix, Ariz., 1948; married in Miamisburg, Montgomery Co., Oh. [Dec. 23, 1972] Michael James Kelly [born 1941 or 1942]).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23805. Victoria Louise Hanson (born in Burlington, Racine Co., Wisc., 1954). ["), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Burke’s")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Pres. Fam.")]), _vm._v(", 26; U.S. Veterans Gravesites; SSDI; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11336–43231]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13319. William Augustine Washington (born in Ill., Jan. 28, 1906; married [Nov. 11, 1927] Hazel Marie Craver [born ibid., June 13, 1910; last resided in Kankakee, Kankakee Co., Ill., and she died Oct. 8, 2006]. They resided in Kankakee, Ill., 1930, where he was a tool dye maker for a stove factory. They later resided in Bradley, Kankakee Co., Ill.).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23806. Joyce Eileen Washington.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23807. Inez Gay Washington. ["), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Burke’s")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Pres. Fam.")]), _vm._v(", 26; H. BROGAN-C. MOSLEY, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Am. Pres. Fam")]), _vm._v("., 54; 1930 census Kankakee Co., Ill., E.D. 17, p. 12A; SSDI; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11336–43331]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13320. Florence Eveline Washington (born in Ill., Aug. 14, 1909; married [Aug. 21, 1930] Fredrick Henry Nemitz [born in Ill., Dec. 14, 1905]. They resided in Kankakee, Kankakee Co., Ill., where he worked at a stove works).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23808. Gerald Fredrick Nemitz (born in Kankakee, Ill., Dec. 26, 1931; a CPA, he married Janet Hicks, and they resided in Houston, Tex., 1974).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23809. Beverly Ann Nemitz (born in Kankakee, Ill., April 10, 1933; married Dale R. Irps, and they resided in St. Anne, Kankakee Co., Ill., 1974).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23810. William Corbin Nemitz (born in Kankakee, Ill., Nov. 15, 1935; married Phyllis Lehnus, and they resided in Kankakee, Ill., 1974). ["), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Burke’s Pres. Fam.")]), _vm._v(", 26; 1940 census Kankakee Co., Ill., E.D. 46–21, p. 1B; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11336–43332]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13322. Grace Leona Kice (born in Chicago, Ill., March 24, 1902; married [1"), _c('sup', [_vm._v("st")]), _vm._v(", ibid., Dec. 31, 1922] Richard Virginius Petersen [born Feb. 12, 1895]. Later divorced, she married [2"), _c('sup', [_vm._v("nd")]), _vm._v(", on March 22, 1930] Herbert Arthur Bates [born in Ill., Oct. 29, 1899]. They resided in Riverside, Cook Co., Ill., where he worked for an oil refinery in 1940. Again divorced, she married [3"), _c('sup', [_vm._v("rd")]), _vm._v(", on Aug. 12, 1953] Joseph Valentine Bay [born March 16, 1907]. She later resided in Fairfax, Marin Co., Cal., and she died in Sacramento Co., Cal., June 14, 1995).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Child (by her 1"), _c('sup', [_vm._v("st")]), _vm._v(" husband):")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23811. Virginia Lorraine Petersen (born Jan. 8 and died April 19, 1924).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children (by her 2"), _c('sup', [_vm._v("nd")]), _vm._v(" husband):")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23812. Grace Elizabeth Bates (born in Berwyn, Cook Co., Ill., 1931; married ___ Mast. They resided in Bethlehem, Northampton Co., Pa., and they had two children: Lori Mast [born ca. 1952] and Steven D. Mast [born ca. 1953]).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23813. Herbert Arthur Bates, Jr. [1940 census Cook Co., Ill., E.D. 16–267, p. 6A; CalDI; USPRI; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11336–43421]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13324. Ann Franklin Keyser (born in Baltimore, Md., April 30, 1893; married [Oct. 4, 1919] James Albert Gary, Jr. [born ibid., Jan. 19, 1887; graduated from Harvard, 1910. He served as Lt., USN, aboard the battleship "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Missouri")]), _vm._v(" and the gunboat "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Wheeling")]), _vm._v(" during WW I. His occupation is listed as “cotton executive” in the 1930 census. His father, a wealthy Baltimore textile manufacturer, served as U.S. Postmaster General in the administration of President William McKinley, 1897–1898]. They resided in Baltimore, Md.).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23814. Caroline Fischer Gary.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23815. Ann Franklin Gary.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23816. James Albert Gary III (born in Baltimore, Md., April 17, 1925; graduated from the USCG Academy, New London, Conn. [B.S., Marine Engineering]. A prominent business executive and trust officer, he served as president of the Board of Trustees of the Enoch Pratt Free Library in Baltimore, Md. He married [June 21, 1950] Alice Wainwright, and they had two daughters and one son. He died in Towson, Md., Feb. 1, 2007). [1930 census Baltimore Co., Md., E.D. 436, p. 6A; A. M. WASHINGTON, “Living Desc. of J. Washington,” 610; 1930 census Baltimore Co., Md., E.D. 436, p. 6A; "), _c('a', {
    attrs: {
      "href": "http://Anc.com",
      "target": "_blank"
    }
  }, [_vm._v("Anc.com")]), _vm._v("/Md. Military Men and Passport Applications; "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Archives of Md")]), _vm._v("., on-line, vol. 182 (1985–1986) p. 153; brief obit. of J. A. Gary III in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Baltimore Sun")]), _vm._v(", 2/1/2007; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11336–64311]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13326. Mary Washington Keyser (born in Md., Feb. 4, 1899; a book binder in her spare time, she married [June 22, 1921] Frederick William Brune [born in Baltimore, Md., Oct. 15, 1894; attended Johns Hopkins (1911–1912) and graduated from Harvard (A.B., 1915; LL.B., 1920). During WW I he served in France with the American Red Cross Volunteer Ambulance Corps in 1917, with the U.S. Army Ambulance Service in 1917–1918, and as a Sgt. with the U.S. Army Intelligence in 1918–1919. Admitted to the Maryland bar in 1921, he was a partner in several Baltimore law firms from 1924 to 1954. He established his reputation as an expert in drafting refunding plans for surety companies during the early years of the Depression. He successfully litigated several landmark cases, including the bankruptcy case of Consolidated Coal Company (1935), National Union Mortgage Corporation vs. Potomac Consolidated Debenture Corp. (1940), and Parker vs. MacBryde (1942). During WW II he served on the Baltimore War Price and Ration Board (1942–1945). He was appointed chief judge of the Court of the Appeals of Maryland in 1954, and he held that post until he retired in 1964.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("His service to his profession, state, and community was extensive. He was Assistant U.S. Attorney for Maryland (1923–1924) and served on numerous boards and commissions in Baltimore, including: the City Service Commission (1937–1946), City Hospitals Commission (1965–1971), and the board of trustees of Maryland School for the Blind, Goucher College, and Union Memorial Hospital. He also served (1948–1951) on the Committee of the Revision of the Corporation Laws, which completely rewrote the Maryland code of corporate law in a draft that was adopted by the legislature in 1951.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("During his years on the bench, Brune was twice a member of the Conference of Chief Justices of State Courts’ executive council and chairman of this conference’s committee on federal-state relationships. He was also chairman of both the National Conference of Judicial Councils (1955–1958) and the Maryland Commission on Criminal Law (1965–1972), as well as president of the Bar Association of Baltimore (1939–1940), the Maryland Bar Association (1947–1948), and the Maryland Historical Society (1965–1967). In 1965 he received an honorary LL.D. degree from the U. of Maryland and an award and citation from the American Trial Lawyers Association for his outstanding contributions to his profession. He took special pleasure in his azalea garden, covering nearly four acres, which he personally planned and planted. He died in Baltimore, Md., Feb. 19, 1972]. Mary died ibid., May 1984).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23817. Frederick William Brune, Jr. (born in Md., May 23, 1922; married [1"), _c('sup', [_vm._v("st")]), _vm._v(", in May 1947] Katherine H. Ryland. Later divorced, he married [2"), _c('sup', [_vm._v("nd")]), _vm._v("] Jean S. [Waller] Smith, and they adopted two children).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23818. Caroline Fischer Brune. ["), _c('em', {
    staticClass: "italic"
  }, [_vm._v("NCAB")]), _vm._v(", 57:87–88; A. M. WASHINGTON, “Living Desc. of J. Washington,” 604; 1930 census Baltimore Co., Md., E.D. 437, p. 11A; 1940 census ibid., E.D. 4–795, p. 5B; SSDI; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11336–64313]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13330. John Stewart (born in Md., Nov. 15, 1898; married [1"), _c('sup', [_vm._v("st")]), _vm._v(", on Nov. 8, 1924] Dorothy Browning Rodgers [born in Pa., July 15, 1903]. He resided in 1930 with his first wife, Dorothy, in Radnor, Delaware Co., Pa., where his occupation is not listed. After a divorce, he married [2"), _c('sup', [_vm._v("nd")]), _vm._v("] Mrs. Frances Trenchard [Leaf] Howell. He continued to reside in Delaware Co., Pa., and he died Nov. 1980).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23819. Dora Browning Stewart.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23820. Mary Washington Stewart. [A. M. WASHINGTON, “Living Desc. of J. Washington,” 624; 1930 census Delaware Co., Pa., E.D. 114, p. 10A; SSDI; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11336–64351]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13331. Mary Washington Stewart (born in Baltimore, Md., Nov. 17, 1900; married ibid. [Dec. 8, 1920] Talbot Taylor Speer [born in Pittsburgh, Pa., Jan. 7, 1895; attended Episcopal High School in Alexandria, Va., the U. of Va., and the U. of Maryland. In both high school and college, he was an outstanding athlete. He served in France as 2"), _c('sup', [_vm._v("nd")]), _vm._v(" Lt. and Capt., 1"), _c('sup', [_vm._v("st")]), _vm._v(" Division, USA (1917–1918), and his decorations included the Silver Star and Purple Heart. He was later president and chairman of the board of the Baltimore Salesbrook Company (1922-ca. 1986). He was chairman of the board of the Capital-Gazette Press in Annapolis, Md. (1926) and publisher of the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Daily Evening Capital, Maryland Gazette, South Maryland Times, U.S. Coast Guard Magazine, Chesapeake Skipper, Prince George County News")]), _vm._v(", and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Capital Gazette News")]), _vm._v(". He went on to become president of Speer Publications (1951-ca. 1986) and publisher of the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("St. Mary’s Beacon")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Waldorf Leaf")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("He was founder and president of the National Educational Foundation in Baltimore, Md., and director of the Baltimore Association of Commerce (1935–1940), the Baltimore Convention Bureau (1946–1948), the U.S. Naval Academy Foundation (1950–1954), and the Union Trust Company (1947-ca. 1986). He was also president of Associated Industries of Maryland (1949–1951), senior director, representing Maryland, of the National Association of Manufacturers (1947–1950), and president of the U. of Maryland Alumni Association (1950–1952). A prominent lay leader in the Episcopal Church, he was a member of the Episcopal lay council of the pro-cathedral of Maryland (1925–1954). He received an honorary degree of LL.D. from the U. of Baltimore, 1974. He last resided in Delray Beach, Palm Beach Co., Fla., and he died Oct. 14, 1987]. She died of cancer, Oct. 29, 1926).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Child:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23821. Mary Washington Speer. ["), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Who’s Who Am.")]), _vm._v(", 1986–87; A. M. WASHINGTON, “Living Desc. of J. Washington,” 623; Anon., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Colonial and Rev. Lineages of Am.")]), _vm._v(", 3:250; A. B. KINSOLVING, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Story of a Southern School")]), _vm._v(", 165; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11336–64352]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13332. Elizabeth Keyser Thom (born Sept. 30, 1912; married [July 19, 1939] Robert Lee Graham [born Nov. 23, 1908; graduated from Princeton (1932) and Johns Hopkins (M.D., 1937), and he practiced medicine as a pathologist]. Before moving to California, she was president of the Junior League of Baltimore, Md. When her children were older, she returned to college, and she graduated from UCLA [B.A., Anthropology, 1957]. They resided in Beverly Hills, Cal., and they were later divorced. She died Oct. 18, 2003).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23822. Robert Lee Graham, Jr. (born Sept. 10, 1940; resided in Los Angeles, Cal.).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23823. DeCourcy Wright Graham.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23824. Victoria Mayo Graham (born Oct. 7, 1944; married Frank D. Atkins, Jr., and they resided in Houston, Tex.). ["), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Am. Med. Dir.")]), _vm._v(", 1950, p. 929; obit. of Elizabeth Graham in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("L.A. Times")]), _vm._v(", 12/6/2003; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11336–64353]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13334. Washington Platt (born in Baltimore, Md., Oct. 6, 1890; attended Phillips Academy, Andover, graduated from Yale [Ph.B., 1911], and he was a medical student at Johns Hopkins [1911–1912]. He then went to work for the National Biscuit Company as a dough-mixer, though by 1917 he had worked his way up to supervisor of the research laboratory. Commissioned Capt., USA, he went to France with the AEF in WW I, and upon his return he went to work for the Bordon Company in industrial research. On Dec. 6, 1921, he married Emily Kent. By 1941 he was assistant director of research laboratories.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Platt had maintained his officer’s commission in the Army Reserve, and when the U.S. entered WW II he returned to active duty as Colonel. He served with the XIX Army Corps throughout its European operations in WW II as a combat intelligence officer. His decorations included the Legion of Merit, Legion of Honor, Croix de Guerre with Palm, and seven battle stars. His intelligence work generally earned high praise, with the rare exception of his seriously underestimating German strength in the Peel Marshes campaign in early Oct. 1944. He prepared a notable three-page intelligence report on April 14, 1945, in response to the question: how long would it take American forces to enter Berlin? His answer, issued with the endorsement of the XIX Corps’ Operations Officer, Colonel Sloan, was that “within forty-eight hours of resuming the advance, the lead elements of American armored troops will enter Berlin.” Promoted to Brig. General in 1948, he commanded the 98"), _c('sup', [_vm._v("th")]), _vm._v(" Inf. Division in 1949 before retiring in 1950.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("In his long and versatile career, Platt also served as professor and chairman of Administrative Engineering at Syracuse U., 1946–1951, and was one of the founders of the Central Intelligence Agency. A prolific author, he wrote "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Strategic Intelligence Production—Basic Principles")]), _vm._v(" [Praeger, 1957] and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("National Character in Action: Intelligence Factors in Foreign Relations")]), _vm._v(" [Rutgers U. Press, 1961]. He also published ca. twenty articles on combat intelligence and engineering, and in 1958 he won a Guggenheim Fellowship for studies of strategic intelligence. He died in England, May 19, 1965).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23825. Emily Kent Platt.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23826. Eleanor Washington Platt.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23827. Mary Perine Platt.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23828. Lucian Brewster Platt. [Quotation from B. LEE, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Marching Orders")]), _vm._v(", 437. See also: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ConAu")]), _vm._v(", vols. 1–4, p. 760 and 120:295; C. B. MacDONALD, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("European Theater of Operations: The Siegfried Line")]), _vm._v(", 234–236; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11336–64411]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13337. Mary Perine Platt (born in Md., June 6, 1903; married [June 2, 1922] Charles Chauncey Hall [born in Md., March 21, 1886; operator of a bed factory, he died March 4, 1938]. They resided in Baltimore, Md., and she died May 18, 1930).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23829-a. Charles Chauncey Hall, Jr. (born in Md., April 9, 1923; graduated from Harvard [M.D., 1947], and he married [1947] ___).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23829-b. Mary Perine Hall (born in Md., April 22, 1924; married ___). [1930 census Baltimore Co., Md., E.D. 518, p. 19B; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11336–64414]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13340. Mary Ball Washington Perine (born Nov. 15, 1912; married [1"), _c('sup', [_vm._v("st")]), _vm._v(", on Aug. 11, 1934] Allen Keeling. Later divorced, she married [2"), _c('sup', [_vm._v("nd")]), _vm._v(", on April 11, 1942] Frank Dominick Mead [born Sept. 8, 1905; served as Lt., USNR, and he died Jan. 22, 1991]. They resided in Conn. and Md., and she died April 10, 1962).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Child (by her 1"), _c('sup', [_vm._v("st")]), _vm._v(" husband);")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23829-c. Allen John Perine Keeling (Mead) (used the surname of his stepfather; born May 28, 1935. He married __, and he had at least two children). [SSDI; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11336–64473]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13345. Stanley Hart Freeman (daughter; born Sept. 21, 1916; married [1"), _c('sup', [_vm._v("st")]), _vm._v(", in Oct. 1939] Edward Adams Wheeler [born 1911]. Later divorced, she married [2"), _c('sup', [_vm._v("nd")]), _vm._v("] Edmund Rhett Elliott [born 1913; graduated from Princeton, 1935, and he "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("d.s.p.")]), _vm._v(" Dec. 1955]. Divorced again, she resided in Richmond, Va.).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Child (by her 1"), _c('sup', [_vm._v("st")]), _vm._v(" husband):")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23830. Eleanor Perine Wheeler. [J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11336–644c5]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13346. Lawrence Fielding Lewis (born Dec. 31, 1890; a WW I veteran, he married in Louisville, Jefferson Co., Ky. [1920] ___, and his wife died in childbirth. He died in a Veterans Hospital Oct. 31, 1956, and he was buried at Zachary Taylor National Cemetery in Frankfort, Ky.).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Child:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23831. Betty Washington Lewis (married ___ Adams, and they had at least three children). [Obit. of Lawrence F. Lewis, Louisville "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Courier-Journal")]), _vm._v(", 11/1/1957; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11361–42111]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13350. Doris Louise Robertson (born in Cal., Aug. 29, 1906; married [Feb. 16, 1928] Walter Edward Lauritzen [born in Cal., Feb. 2, 1903; a salesman, he resided in Fresno, Fresno Co., Cal., where he died Feb. 12, 1997]. She died in Fresno, Cal., Feb. 20, 1999).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23832. Richard Edward Lauritzen (born in Fresno Co., Cal., Jan. 15, 1931).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23833. Walter Lee Lauritzen (born ibid., Oct. 29, 1933). [M. SORLEY, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Lewis")]), _vm._v(", 148; 1940 census Fresno Co., Cal., E.D. 10–68, pp. 11A-B; CalBI; CalDI; SSDI; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11361–42141]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13352. Leland Ross Robertson (born in Fresno Co., Cal., June 7, 1911; married Bettie Louise Frembling [born in Cal., Feb. 11, 1913; died in Los Angeles Co., Cal., Nov. 29, 1991]. They resided in Fresno, Fresno Co., Cal., 1940, where he was a draftsman for a building contractor. They later resided in Long Beach, Los Angeles Co., Cal., where he died June 4, 1985).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23834. Michael Lee Robertson (born in Fresno Co., Cal., July 16, 1938).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23835. Duncan Granger Robertson (born ibid., Aug. 28, 1942). [1940 census Fresno Co., Cal., E.D. 10–36, p. 1A; CalBI; CalDI; SSDI; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11361–42143]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13353. Henry Lawrence Robertson (born in Cal., June 29, 1914; married Frances Katherine Schaap [born Jan. 28, 1913]. He last resided in Tarzana, Los Angeles Co., Cal., and he died Jan. 1975).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23836. Stephen Lewis Robertson (born in Los Angeles Co., Cal., Aug. 3, 1939).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23837. Christopher Reed Robertson (born ibid., July 20, 1944). [CalBI; SSDI; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11361–42144]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13358. Thelma Camille Lewis (born Nov. 14, 1926; married [Sept. 23, 1950] John Glen Chervenak [born Oct. 12, 1927]).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23838-a. Eugene Joseph Chervenak (born in Jefferson Co., Ky., May 20, 1953).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23838-b. Karen L. Chervenak (born ibid., Oct. 2, 1956).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23838-c. Michael Lewis Chervenak (born ibid., March 12, 1962). [KyBI; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11361–42172]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13360. Lee Conway Lewis (born in Louisville, Jefferson Co., Ky., Nov. 7, 1932; graduated from the U. of Louisville [B.S., 1954]. He then served in the Navy, rising from Lt. [jg] to Commander, 1954–1957. He served aboard the aircraft carrier "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Bennington")]), _vm._v(", and on Jan. 21, 2000 he recorded the following anecdote in an article “Man Overboard: The Rest of the Story.” He was serving as the Junior Officer of the Deck as a young Lt [jg] in April 1956, when the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Bennington")]), _vm._v(" sailed from Kobe, Japan. Only one hour out of port, the cry went up, “Man overboard—port side!” As Junior Officer of the Deck, it was his task to command the small launch that was lowered to search for the body. After groping in the dark icy water for about 45 minutes, they finally found the body. The victim turned out to be not a crew member of the carrier but a Japanese civilian who had been in the water for several weeks.")]), _vm._v(" "), _c('div', {
    staticClass: "extract"
  }, [_c('p', {
    staticClass: "extractText"
  }, [_vm._v("I’m sure most of our crew was not aware of what took place from that time on. The copter pilot headed back to Kobe and began searching for a place to land and leave the body bag. The only place visible with ample lighting was a baseball field where a game was in progress. He hovered over second base and dropped the [body] bag. While leaving to return to the ship, he noted the second baseman dumping the contents of the bag and immediately started running. Needless to say, it was a real shocker to all people in attendance.")]), _vm._v(" "), _c('p', {
    staticClass: "extractText"
  }, [_vm._v("We later received notification from the Japanese Government that the body was that of a Japanese fisherman lost at sea approximately six weeks earlier. They thanked the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Bennington")]), _vm._v(" and her crew for returning the body, allowing them to give the fisherman a proper burial in his home country.")]), _vm._v(" "), _c('p', {
    staticClass: "extractText"
  }, [_vm._v("The entire life boat crew went to Sick Bay on our return to the ship. I remember receiving brandy to help thaw me out due to the extremely low water temperature, approximately 38 degrees and outside air temperature 33 degrees. I had nightmares for weeks after the rescue; you see, when I turned the person over in the water, I wasn’t looking at a face with flesh, but a skeleton head with no flesh. We had a difficult time keeping his body parts together. It’s a journey that will live with me forever.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Initially a sales representative, in 1962 he began a long and successful career with Reynolds & Reynolds in Dayton, Montgomery Co., Oh. By 1985 he was vice-president of the business systems division. He married [1"), _c('sup', [_vm._v("st")]), _vm._v(", on Dec. 18, 1954] Beverly Jane Randles Horrar [born Aug. 18, 1932], and they were divorced Oct. 1974. He married [2"), _c('sup', [_vm._v("nd")]), _vm._v(", on Sept. 13, 1980] Deborah Gay Gross, and they resided in Dayton, Oh.).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children (by his 1"), _c('sup', [_vm._v("st")]), _vm._v(" wife):")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23839-a. Lee Lewis.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23839-b. John Lewis.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23839-c. Todd Lewis.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23839-d. Barbara Lewis.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Child (by his 2"), _c('sup', [_vm._v("nd")]), _vm._v(" wife):")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23839-e. Kelly Lee Lewis. [Quotation from L. C. LEWIS, “Man Overboard,” on "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("USS Bennington")]), _vm._v(" website (see bibliog., websites). See also: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Who’s Who Am")]), _vm._v("., 1986–87; M. SORLEY, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Lewis")]), _vm._v(", 149; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11361–42174]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13366. Monte Randall Lewis (born in Santa Cruz Co., Cal., July 5, 1927; married Betty Ann Bagby).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23840. Christine Louise Lewis (born in Santa Cruz Co., Cal., July 7, 1946).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23841. Marci Jo Lewis (born in Santa Clara Co., Cal., April 5, 1952). [CalBI; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11361–42412]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13367. Mary Lee Lewis (born in Sana Cruz Co., Cal., Oct. 30, 1929; married James E. Gregg, and they resided in Sacramento, Sacramento Co., Cal.).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23842. Jannie Lee Gregg (born 1950).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23843. Susan Elizabeth Gregg (born 1952). [CalBI; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11361–42413]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13377. Shirley Kaye Hammond (born Jan. 17, 1925; married [May 30, 1947] Pierre Marie St. Clair [born in Paris, France, Nov. 21, 1923; he became a naturalized citizen in Los Angeles, Cal., Nov. 17, 1950. His naturalization papers indicate that he was originally named “Pierre Jules Marie Schlisler.” A man of that name, accompanied by his wife “Kay,” sailed for New York City from Rotterdam, the Netherlands, on Oct. 29, 1947. He gave his place of birth as Paris, France, and his occupation as sculptor. Kay’s birth date confirms her identity as Shirley Kaye Hammond. His previous residence is listed as Paris, France, and hers as Fresno, Cal.]).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23844. Michele St. Clair (born 1949).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23845. Peter St. Clair (born 1950). ["), _c('a', {
    attrs: {
      "href": "http://Anc.com",
      "target": "_blank"
    }
  }, [_vm._v("Anc.com")]), _vm._v("/U.S. Naturalization Record Indexes, which I follow, and New York Passenger Lists; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11361–42921, which gives Pierre M. St. Clair’s date of birth as Nov. 2"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("4")]), _vm._v(", 1923]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13382. Betty Lewis Davidson (born in Glasgow, Barren Co., Ky., Oct. 1891; married in Louisville, Jefferson Co., Ky. [Sept. 20, 1913] Oscar Virgil Wright [born in Daviess Co., Ky., Oct. 23, 1889; died in Louisville, Ky., Aug. 3, 1969]. They resided in Louisville, Ky., 1930, where he was a boiler inspector for a railroad. Betty died in Louisville, Ky., Nov. 28, 1957).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23846. Charles D. Wright (born in Jefferson Co., Ky., July 25, 1914; married Dorothy ___, and he died ibid., Jan. 31, 1974).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23847. Paula K. Wright (born ibid., Jan. 4, 1917).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23848. Oscar Lewis Wright (born in Harlan Co., Ky., May 3, 1924). ["), _c('a', {
    attrs: {
      "href": "http://FamSearch.org",
      "target": "_blank"
    }
  }, [_vm._v("FamSearch.org")]), _vm._v("/Ky. Marriages; 1930 census Jefferson Co., Ky., E.D. 76, p. 12A; KyBI; KyDI; "), _c('a', {
    attrs: {
      "href": "http://Anc.com",
      "target": "_blank"
    }
  }, [_vm._v("Anc.com")]), _vm._v("/PMT; FGS by DPS]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13383. Mamie Robinson (born in Ky., ca. 1895; married Roy Anderson [born ibid., ca. 1895; employed by the Louisville & Nashville Railroad, he was a talented engineer who designed numerous innovations for locomotives]. They resided in Louisville, Jefferson Co., Ky., and Mamie died ca. 1977).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Child:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23849. Martha Peake Anderson (born in Jefferson Co., Ky., Dec. 31, 1923; married ___ Comstock). [1930 census Jefferson Co., Ky., E.D. 119, p. 70A; 1940 census ibid., E.D. 121–236, p. 1A; FGS by DPS]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13384. Gertrude Robinson (born Dec. 1, 1900; married Howard Miller Hoffman [born March 29, 1899; “something of a ne’er do well,” he reportedly had trouble keeping a job and staying sober. A gifted designer and inventor, he failed to follow through and obtain any patents. They separated ca. 1941, and their marriage ended in divorce in 1944. He died May 14, 1952]. They resided in Louisville, Jefferson Co., Ky., and she died Dec. 1988).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Child:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23850. Norma Jean Hoffmann. [FGS by DPS]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13389. James Donald Davidson (born in Beaver Creek, Barren Co., Ky., June 10, 1920; worked for Boweil and Company, a division of North American Van Lines. He married in Cincinnati, Oh. [June 17, 1944] Dorothea Estella Steinmann [born in Cincinnati, Oh., Nov. 3, 1917; a tax examiner for the IRS, she died in Ormond Beach, Volusia Co., Fla., June 7, 1982]. He died in Ormond Beach, Fla., June 20, 1982).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23851. James Dee Davison (born 1946; married Charlene Mergy [born 1948]. They had two children:")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("[1]. Lisa Ann Davidson (born 1969; married Douglas Patrick Flynn [born 1968]. They had two children: Gabrielle Rose Flynn and E. Rose Flynn).")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("[2]. Dorothy Ann Davidson (born 1978).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23852. Carolyn Lee Davison (born 1948; married Charles Raymond Fehr [born 1938]).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23853. Lois Ann Davidson. [L. MASCHMEYER, “Desc. J. Washington,” 8; FGS by EDG, LDM, and EDG]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13391. Mitchell Charles Davidson (born in Glasgow, Barren Co., Ky., Sept. 27, 1924; married [ca. 1945] Virginia Black [born in Cincinnati, Oh., ca. 1922; died June 20, 1998]. He died in Ky., Jan. 20, 1988).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23854-a. Donna L. Davidson (born 1946; married [1"), _c('sup', [_vm._v("st")]), _vm._v("] ___, and she married [2"), _c('sup', [_vm._v("nd")]), _vm._v("] ___. She died in Oh., Oct. 31, 1998, and she had two children by her first husband).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23854-b. Sandra Davidson (born 1957; married Ron Ernst [born 1953], and they had one child: Joseph Ernst).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23854-c. Mitchell Charles Davidson, Jr. (born 1959; married Serna Fields, and he died 2002). [Ibid.]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13392. Robert Herndon Davison, Jr. (born in Cincinnati, Oh., Oct. 5, 1928; served as a medic during the Korean War. He married [June 11, 1955] Audrey McGeorge [born 1925; a teacher, she died 1997]. He died in Lexington, Fayette Co., Ky., March 4, 1994).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Child:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23854-d. Robbie Gail Davidson (born 1970; married Jerry James Gambrel. They had one child: Tiffany Michelle Gambrel [born 1989]). [Ibid.]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13393. Paul Knickerbocker Davison (born Nov. 10, 1930; married [ca. 1949] Mary Roth [born 1933]. He died in Ky., Jan. 31, 1994).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23855-a. Paula Ann Davidson (born 1950; married John Lee May [born 1981]. They had three children: John May [born 1968], Charles May [born 1970; died 1986], and David May [born 1977]).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23855-b. Mary Lee Davidson (born 1951; married Tom Smith [born 1949]. They had three children: Tammy Smith [born 1969], Tommy Smith [1970], and Ronda Smith [born 1977]).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23855-c. Brenda Kay Davidson (born 1952; married James Lovins [born 1952]. They had two children: Jeanette Lovins [born 1974] and James Robert Lovins [born 1978]).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23855-d. John Robert Davidson (born 1953; married Jo Ann Cook [born 1945]. They had one child: Travis Davidson [born 1980]).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23855-e. Ronnie Dell Davidson (born 1954; married [1"), _c('sup', [_vm._v("st")]), _vm._v("] Charlotte Thrin, and he married [2"), _c('sup', [_vm._v("nd")]), _vm._v("] Karen Lou Upton [born 1958]. He had two children by his 1"), _c('sup', [_vm._v("st")]), _vm._v(" wife: Leah Davidson [born 1984] and Helen Davidson [born 1985]. He also had one child by his 2"), _c('sup', [_vm._v("nd")]), _vm._v(" wife: Adriana Upton Davidson [born 1979]).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23855-f. Richard Paul Davidson (born 1956; married Mary Ann Stevenson [born 1958], and they had three children: Michelle Marie Davidson [born 1976], Matthew Paul Davidson [born 1978], and Richard Paul Davidson [born 1979]).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23855-g. Judy Carol Davidson (born 1957; married Daniel William Asmann [born 1957]. They had three children: Mary Elizabeth Asmann [born 1978], Janice Marie Asmann [born 1988], and Robbie Adam Asmann [born 1991]).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23855-h. Ramona Davidson (born 1958; married Jerry Arnold [born 1942]).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23855-i. Elizabeth Davidson (born 1960; married Steven Buchanan, and they had two children: Steven Buchanan [born 1984] and Jason Buchanan [born 1987]).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23855-j. Roger Davidson [born 1963; married [1"), _c('sup', [_vm._v("st")]), _vm._v("] Lyvonne ___, and he married [2"), _c('sup', [_vm._v("nd")]), _vm._v("] Patricia Benjey [born 1965]. They had two children: Jennifer Davidson [born 1990] and Haley Davidson [born 1996]).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23855-k. Christine Davidson (born 1964; married Michael Golatzki, and they had one child: Jennifer Golatzki [born 1984]).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23855-l. Paul Davidson (born 1965; married Linda Paul [born 1963]. They had three children: Brett Davidson [born 1990], Amber Davidson [1993], and Nickole Davidson [born 1995]).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23855-m. Frank Davidson (born 1968; married [1"), _c('sup', [_vm._v("st")]), _vm._v("] Cathy ___, married [2"), _c('sup', [_vm._v("nd")]), _vm._v("] Shauna ___, and he married [3"), _c('sup', [_vm._v("rd")]), _vm._v("] Debbie ___).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23855-n. Mark William Davidson (born 1969; married Elizabeth Sloan Douglass [born 1970]. They had four children; Mark William Davison, Jr. [born 1991], Caleb Davidson [born 1993], Connor Davidson [2002], and Noah Davidson [2004]).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23855-o. Janice Davison (born 1970; married [1"), _c('sup', [_vm._v("st")]), _vm._v("] Daniel Yarbro, and she married [2"), _c('sup', [_vm._v("nd")]), _vm._v("] John Gregory. She had two children by her 1"), _c('sup', [_vm._v("st")]), _vm._v(" husband: Justin Yarbro [born 1991] and Daniel Harbor, Jr. [born 1992]. [Ibid.]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13394. Billie Lewis Davison (born in Cincinnati, Oh., May 21, 1933; married [June 2, 1956] Mary Evelyn McGeorge [born 1934]).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23856. Steven Louis Davison (born 1958; married Elizabeth Marie Pohlman [born 1958]. They had two children: Shelly Lynn Davison [born 1981] and Sherry Marie Davison [born 1982]).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23857. Jeffrey Brian Davison (born 1960). [Ibid.]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13395. Earl Edward Davison (born in Cincinnati, Oh., June 11, 1935; married ibid. [Aug. 8, 1953] Thelma Jean Rector [born July 22, 1934]. He died May 6, 2010).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23858. Dora Lynn Davison (born 1955).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23859. Earlene Davison (born in Cincinnati, Oh., July 23, 1958; married in Clermont Co., Oh. [Nov. 21, 1981] James David Giglierano. An avid genealogist, she was NSWFD member #1128, and she generously contributed information on her branch of the family. They resided in Iowa City, Johnson Co., Iowa. They had one child: Nathan James Giglierano [born Sept. 7, 1990; NSWFD member #1129]).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23860. Michael Edward Davison (born in Cincinnati, Oh., June 26, 1965; married in Clermont Co., Oh. [June 1, 1991] Rita Das Roychoudury. He was NSWFD member #1130). [L. MASCHMEYER, “Desc. J. Washington,” 8; FGS EDG]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13406. John Washington Kimbrough (born in Muldoon, Fayette Co., Tex., Jan. 21, 1877; married Annie Elizabeth Richardson [born in Fayette Co., Tex., May 3, 1876; died in Fayette Co., Tex., Sept. 23, 1953]. They resided in Goliad, Goliad Co., Tex., 1920, where he was a building contractor. He died in Refugio, Refugio Co., Tex., June 5, 1972, and they had another child who died young by 1910).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children (surviving):")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23861. Erna Leslie Kimbrough.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23862. Harry Langford Kimbrough.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23863. Bessie L. Kimbrough (born in Tex., ca. 1905).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23864. John Washington Kimbrough.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23865. Roy Lee Kimbrough (born in Tex., ca. 1910).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23866. Maurice W. Kimbrough (born in Tex., Jan. 18, 1915; a WW II veteran, he enlisted at Fort Sam Houston, Tex., Feb. 9, 1941. He died in Victoria, Victoria Co., Tex., Feb. 27, 1996). [1920 census Goliad Co., Tex., E.D. 73, p. 2B; WW II AER; TexBI; SSDI; "), _c('a', {
    attrs: {
      "href": "http://Anc.com",
      "target": "_blank"
    }
  }, [_vm._v("Anc.com")]), _vm._v("/OWT; B. C. NOONAN, website “Desc. of Edward III”]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13410. Thomas H. Kimbrough (born in Tex., March 11, 1883; married [ca. 1905] Myrtle R. [born in Tex., Jan. 26, 1888; died in Bastrop Co., Tex., Oct. 1985]. They farmed in Bastrop Co., Tex.).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23867. Mamie L. Kimbrough (born in Tex., 1905; married Jake Smith [born in Tex.]).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23868. Knox H. Kimbrough (born in Tex., Feb. 10, 1908; died in Bastrop Co., Tex., May 1978).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23869. Jesse Thomas Kimbrough.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23870. Cynthia Eulalie Kimbrough.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23871. Imogene Kimbrough.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23872. John Milton Kimbrough.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23873. Edna M. Kimbrough (born in Tex., ca. 1919; died "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ante")]), _vm._v(" 1930).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23874. Julia Evelyn Kimbrough.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23875. Iris Roe Kimbrough. [1900 census Fayette Co., Tex., E.D. 41, p. 9B; 1920 census Bastrop Co., Tex., E.D. 29, p. 5A; 1930 census ibid., E.D. 16, p. 5A; B. C. NOONAN, website “Desc. of Edward III”]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13414. Lyttie Arcena Kimbrough (born in Tex., Oct. 22, 1895; married Arbuth Bryan Merkin [born in San Antonio, Tex., Feb. 25, 1900; a carpenter, he died in Bexar Co., Tex., May 4, 1960]. They resided in San Antonio, Tex., where she died Oct. 6, 1980).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23876. Arbuth Bryan Merkin, Jr.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23877. Rena Merle Merkin. [1900 census Fayette Co., Tex., E.D. 41, pp. 9A-B; 1930 census Bexar Co., Tex., E.D. 60, p. 8A; SSDI; TexDI; "), _c('a', {
    attrs: {
      "href": "http://FamSearch.org",
      "target": "_blank"
    }
  }, [_vm._v("FamSearch.org")]), _vm._v("/Tex. Deaths; "), _c('a', {
    attrs: {
      "href": "http://Anc.com",
      "target": "_blank"
    }
  }, [_vm._v("Anc.com")]), _vm._v("/OWT; B. C. NOONAN, website “Desc. of Edward III”]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13415. Mary Susan Fitzgerald (born in Fayette Co., Tex., Aug. 8, 1878; called “Susan E.” by L. E. Dabney, she is “Mary L. Fitzgerald, age 1” in the 1880 census, “Susan M.” in the 1900 census, and “Mary Susan” in "), _c('a', {
    attrs: {
      "href": "http://Ancestry.com",
      "target": "_blank"
    }
  }, [_vm._v("Ancestry.com")]), _vm._v("/OWT. She married in Fayette Co., Tex. [Dec. 12, 1894] Charles Clinton Moore [born in Fayette Co., Tex., May 18, 1873; died in Amarillo, Potter Co., Tex., May 20, 1950]. They resided in Ballinger, Runnels Co., Tex., where he was a farmer in 1900 and a bartender in 1910. They moved by 1920 to Amarillo, Tex., where he was manager of a messenger service in 1920 and unemployed in 1930. They are said to have had eleven children. The 1910 census indicates that by that date Mary had had eight children, and six were still living. Mary died in Amarillo, Tex., Jan. 25, 1963).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23878. Arthur Clinton Moore (born in Fayette Co., Tex., Jan. 4, 1896; he was unm. and working for the fire department in Amarillo, Tex., when he registered for the draft June 5, 1917. He died in Tex., Feb. 28, 1976).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23879. Jesse L. Moore (born in Tex., Aug. 7, 1897; died in San Angelo, Tom Green Co., Tex., July 22, 1912).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23880. William C. Moore (born in Tex., May 1899).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23881. Mittie Velma Moore (born ibid., ca. 1904).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23882. Charles Clinton Moore, Jr.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23883. T. P. Moore.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23884. Carlos Moore (born in Tex., ca. 1911).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23885. Vernon D. Moore (born ibid., ca. 1914).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23886. Marguerite Moore (born ibid., ca. June 1917). [1900 census Runnels Co., Tex., E.D. 126, p. 20A; 1910 census ibid., E.D. 212, p. 3B; 1920 census Potter Co., Tex., E.D. 204, p. 12A; 1930 census ibid., E.D. 13, p. 37B; WW I Draft Reg.; "), _c('a', {
    attrs: {
      "href": "http://FamSearch.org",
      "target": "_blank"
    }
  }, [_vm._v("FamSearch.org")]), _vm._v("/Tex. Deaths; "), _c('a', {
    attrs: {
      "href": "http://Anc.com",
      "target": "_blank"
    }
  }, [_vm._v("Anc.com")]), _vm._v("/OWT and PMT]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13417. Annie Myrtle Fitzgerald (born in Fayette Co., Tex., July 11, 1882; married in Hardin Co., Tex. [July 12 or 17, 1904] Lewis Walter Moore [born in Black Jack Springs, Fayette Co., Tex., April 1, 1876; died in Muldoon, Fayette Co., Tex., Sept. 14, 1946]. She died in Muldoon, Tex., Nov. 27, 1913).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23887. Oscar Lewis Moore (born in Hardin Co., Tex., Jan. 28, 1905; married in Beaumont, Jefferson Co., Tex. [Feb. 18, 1931] Opal M. Whitman [born in La., ca. 1909]. They resided in Harris Co., Tex., 1940, and he worked for a petroleum company. He last resided in Silsbee, Hardin Co., Tex., and he died Jan. 4, 1988. They had one child: Dorothy C. Moore [born in Tex., ca. 1931]).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23888. Mabel Dorothy Moore (born in Humble, Harris Co., Tex., March 30, 1908; married James Leslie Rowland, and she died in Abilene, Taylor Co., Tex., 1958). [1940 census Harris Co., Tex., E.D. 101–10C, p. 36B; "), _c('a', {
    attrs: {
      "href": "http://FamSearch.org",
      "target": "_blank"
    }
  }, [_vm._v("FamSearch.org")]), _vm._v("/Tex. Marriages; SSDI; "), _c('a', {
    attrs: {
      "href": "http://Anc.com",
      "target": "_blank"
    }
  }, [_vm._v("Anc.com")]), _vm._v("/AWT and OWT; L. E. DABNEY, “Texas Desc. Jean d’Aubigné,” 6; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11361–81213]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13420. Orville Threadgill Fitzgerald (born in Muldoon, Fayette Co., Tex., Oct. 19, 1887; married in Houston, Tex. [May 8, 1911] Eva Ethel Threadgill [born in Lometa, Lampasas Co., Tex., Sept. 5, 1891]. He died in Kilgore, Rusk Co., Tex., Oct. 3, 1963, according to "), _c('a', {
    attrs: {
      "href": "http://Ancestry.com",
      "target": "_blank"
    }
  }, [_vm._v("Ancestry.com")]), _vm._v("/OWT, although the Texas Death Index gives “Orvil Fitzgerald, died in Gregg Co., Tex., Oct. 3, 1963”).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Child:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23889. Milton David Fitzgerald. [TexBI; TexDI; "), _c('a', {
    attrs: {
      "href": "http://Anc.com",
      "target": "_blank"
    }
  }, [_vm._v("Anc.com")]), _vm._v("/OWT; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11361–81215]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13421. Margaret Adelia Fitzgerald (born in Muldoon, Fayette Co., Tex., Aug. 7, 1893; married in Humble, Harris Co., Tex. [Jan. 21, 1912] Christian Wilson Levy [born in Burnet, Burnet Co., Tex., Jan. 20, 1887; died in Duncan, Stephens Co., Tex., July 30, 1930]. They resided in Wichita Co., Tex., 1920, where he was a field manager for Humboldt Oil Company. In July 1930, he was working on an oil derrick crew about five miles southwest of Duncan, Stephens Co., Okla. The derrick suddenly collapsed, and Christian was killed instantly when a falling timber crushed his skull. Margaret served in the 1920s on the Duncan Board of Education, the first woman to hold that post. A member of DAR, she died in Duncan, Okla., Dec. 29, 1981. Both were buried at the Duncan [Okla.] Municipal Cemetery).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children (partial list):")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23890. William Marvin Levy.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23891. Harold Levy (born in Tex., ca. July 1915; resided in Prescott, Yavapai Co., Ariz., 1981).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23892. Peggy Jean Levy (married ___ Hashman, and they resided in Seattle, Wash., 1981). [WW I Draft Reg.; 1920 census Wichita Co., Tex., E.D. 188, p. 3A; obits. of Christian W. and Margaret A. F. Levy in the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Duncan (Okla.) Banner")]), _vm._v(", posted on "), _c('a', {
    attrs: {
      "href": "http://www.findagrave.com",
      "target": "_blank"
    }
  }, [_vm._v("www.findagrave.com")]), _vm._v("; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11361–81217]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13422. Betty Lucile Fitzgerald (born in Fayette Co., Tex., Oct. 3, 1895; married in Harris Co., Tex. [Aug. 20, 1912] John W. McWilliams [born in Tex., ca. 1893]. They resided in Humble, Harris Co., Tex., 1930, although the census notes that John was absent in Mexico, where he worked as a driller).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23893. Betty M. McWilliams (born in Tex., ca. 1913).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23894. Evelyn N. McWilliams (born ibid., ca. 1919). ["), _c('a', {
    attrs: {
      "href": "http://FamSearch.org",
      "target": "_blank"
    }
  }, [_vm._v("FamSearch.org")]), _vm._v("/Tex. Marriages; 1930 census Harris Co., Tex., E.D. 191, p. 22A; L. E. DABNEY, “Texas Desc. Jean d’Aubigné,” 6; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11361–81218]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13426. Yancy Clifton Carmichael (born in Smithville, Bastrop Co., Tex., July 2, 1889; married in Wharton Co., Tex. [June 16, 1912] Ruby Wilda Wallace [born in La., March 4, 1892; died in Houston, Tex., July 15, 1976]. They resided in Oklahoma City, Oklahoma Co., Okla., 1930, where he worked as a “water supply contractor.” He died in Harris Co., Tex., Aug. 18, 1951).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23895. Ruby Lee Carmichael (born in Tex., April 3, 1913).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23896. Yancy Clifton Carmichael, Jr. (born in Harris Co., Tex., May 3, 1916).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23897. Elizabeth May Carmichael (born ibid., Dec. 22, 1918). [1930 census Oklahoma Co., Okla., E.D. 33, p. 17A; "), _c('a', {
    attrs: {
      "href": "http://FamSearch.org",
      "target": "_blank"
    }
  }, [_vm._v("FamSearch.org")]), _vm._v("/Tex. Births; "), _c('a', {
    attrs: {
      "href": "http://Anc.com",
      "target": "_blank"
    }
  }, [_vm._v("Anc.com")]), _vm._v("/AWT, entry by RobB; B. K. PIERCE, website “Belinda’s Burleson and Lancaster Family Home Page”; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11361–81223]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13427. Winogene (or “Winna Jean”) Henry Kimbrough (born in Tex., Oct. 5, 1901; married Houston Roger Hunter [born in Tex., Jan. 23, 1899; a WW I veteran, he was later a postman. He died in Roswell, Chaves Co., N.M., Jan. 15, 1894]. They resided in Roswell, N.M., where she died Jan. 7, 2005).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23898. Houston Roger Hunter, Jr. (born in Tex., ca. 1923).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23899. Thana (?) Hunter (born ibid., ca. 1924).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23900. Beaulah Hunter (born ibid., ca. Aug. 1926). [1930 census Chaves Co., N.M., E.D. 5, p. 11A; SSDI; "), _c('a', {
    attrs: {
      "href": "http://Anc.com",
      "target": "_blank"
    }
  }, [_vm._v("Anc.com")]), _vm._v("/PMT; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11361–81231]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13429. Winton Forrest Scott (born near Willow City, Gillespie Co., Tex., Nov. 1, 1904; married [ca. 1932] Mary Sue Wyatt [died in Fort Worth, Tarrant Co., Tex., May 31, 1977]. As their son Winton notes, “My parents met while attending the U. of Texas in Austin. I think my mother got pregnant and so they quit school and got married. I think my mother was in her first or second year but my father had only about twelve hours left for his degree. Neither of them ever went back and, sadly, that baby boy died in childbirth.” They resided in Austin until moving in 1955 to Fort Worth, Tex., and he died in Tyler, Smith Co., Tex., March 31, 1977).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Child (surviving):")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23901. Winton Forrest Scott, Jr. [Quotation and FGS from WFS. See also: TexDI; SSDI; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11361–81421]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13432. Ina Lewis Giles (born near Willow City, Gillespie Co., Tex., July 5, 1895; married in Springfield, Baca Co., Colo., Claude H. Allison [born in a small town that apparently no longer exists, “Inanah (Suanah),” Tex., Aug. 16, 1893; a veteran of WW I, he later worked for an insurance company]. They resided in Texas Co., Okla., 1917]. By 1923 they settled in Glendale, Los Angeles, Cal., and she died in Riverside Co., Cal., Sept. 3, 1970).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23902. Claude H. Allison, Jr. (born in Los Angeles Co., Cal., Feb. 5, 1923; he died in San Luis Obispo Co., Cal., June 26, 1985).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23903. Giles Fulton Allison (born in Cal., Aug. 26, 1927). [WW I Draft Reg.; 1930 census Los Angeles Co., Cal., E.D. 961, p. 9A; CalDI, which wrongly gives Ina’s birth date as July 5, 18"), _c('span', {
    staticClass: "underline"
  }, [_vm._v("7")]), _vm._v("5; L. E. DABNEY, “Texas Desc. Jean d’Aubigné,” 8; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11361–81431]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13433. Edgar James Giles (born near Willow City, Gillespie Co., Tex., July 6, 1898; married [1"), _c('sup', [_vm._v("st")]), _vm._v(", in 1922] Gertrude Heaton [“of Fort Worth, Tex.”]. After their divorce, he married [2"), _c('sup', [_vm._v("nd")]), _vm._v("] Bonnie Sayer [“of Kenton, Okla.”]. They resided near Kenton, Cimarron Co., Okla., and later in Clayton, Union Co., N.M., and he died Jan. 1974).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children (by his 1"), _c('sup', [_vm._v("st")]), _vm._v(" wife):")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23904. Edgar James Giles, Jr. (born in Clayton, N.M., 1922; married twice, he had three daughters by his first wife).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children (by his 2"), _c('sup', [_vm._v("nd")]), _vm._v(" wife):")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23905. Gary Giles (married ___; they resided in Wash., and they had four children).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23906. Glena Giles (married ___; they resided in Albuquerque, Bernalillo Co., N.M., and they had two children).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23907. Gloria Giles (married George Cliff; they resided in Sacramento, Sacramento Co., Cal., and they had four children).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23908. Mary Giles (married Jim Elder; they resided in Albuquerque, N.M., and they had one child: Debra Elder).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23909. Karen Giles (resided in Clayton, N.M.). [SSDI; L. E. DABNEY, “Texas Desc. Jean d’Aubigné,” 8; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11361–81432]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13434. Hope E. Giles (born in Kenton, Cimarron Co., Okla., Nov. 15, 1903; married in Los Angeles, Cal. [1923] Lester Milton Bechtel [born in Wyo., Aug. 12, 1901; “from Geneva, Neb.,” he worked as a rancher]. They resided in 1930 with Hope’s parents in Cimarron, Union Co., N.M. He last resided in Folsom, Union Co., N.M. and died Oct. 1965]. She last resided in Clayton, Union Co., N.M., and she died May 5, 1996).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23910. Joseph Milton Bechtel.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23911. Ina Jean Bechtel.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23912. Dick Bechtel (born in Los Angeles, Cal.; married [1"), _c('sup', [_vm._v("st")]), _vm._v("] ___ Davis, and they resided in Clayton, N.M. He had one son by his first marriage: Richie Bechtel. Dick married [2"), _c('sup', [_vm._v("nd")]), _vm._v("] ___, and he perhaps had children by a second marriage).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23913. Stephen Bechtel. [1930 census Union Co., N.M., E.D. 3, p. 1A; SSDI; L. E. DABNEY, “Texas Desc. Jean d’Aubigné,” 8; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11361–81433]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13436. Thomas Evans Giles III (born in Clayton, Union Co., N.M., March 23, 1911; married in Boise City, Cimarron Co., Okla. [1"), _c('sup', [_vm._v("st")]), _vm._v("] Fern Greer [born 1914]. He married [2"), _c('sup', [_vm._v("nd")]), _vm._v("] Alma Carr [born in Cook Co., Ill., May 19, 1915; died in San Diego Co., Cal., Oct. 20, 1994]. He resided mainly in Los Angeles, Cal., and he died in Van Nuys, Los Angeles Co., Cal.).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Child (by his 1"), _c('sup', [_vm._v("st")]), _vm._v(" wife):")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23914. Tommy Jim Giles (born in Tex., Dec. 15, 1932; married in San Bernardino Co., Cal. [March 28, 1961] Beverly A. Kassis, and he died in Sacramento Co., Cal., May 2, 1993).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Child (by his 2"), _c('sup', [_vm._v("nd")]), _vm._v(" wife):")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23915. Jeff Giles. ["), _c('a', {
    attrs: {
      "href": "http://Anc.com",
      "target": "_blank"
    }
  }, [_vm._v("Anc.com")]), _vm._v("/Cook Co., Ill. Births; CalDI; L. E. DABNEY, “Texas Desc. Jean d’Aubigné,” 9; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11361–81435]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13437. Eugene Barton Giles (born in Clayton, Union Co., N.M., March 19, 1913; married [1"), _c('sup', [_vm._v("st")]), _vm._v("] Ethyl Harvey. He married [2"), _c('sup', [_vm._v("nd")]), _vm._v("] Joan ___, and they resided in Van Nuys, Los Angeles Co., Cal. They later in Oceanside, San Diego Co., Cal., where he died Dec. 22, 1980).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children (by his 1"), _c('sup', [_vm._v("st")]), _vm._v(" wife):")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23916. Dona Ray Giles.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23917. Jeoneil Giles.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Child (by his 2"), _c('sup', [_vm._v("nd")]), _vm._v(" wife):")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23918. Dianna Giles. [CalDI; SSDI; L. E. DABNEY, “Texas Desc. Jean d’Aubigné,” 9; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11361–81436]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13438. Lancaster Eugene Dabney (born on the George R. Dabney Ranch near Willow City, Gillespie Co., Tex., April 20, 1898; Ph.D., he was professor of French at the U. of Texas-Austin. He was the author of a valuable genealogical sketch, “The Texas Descendants of Jean d’Aubigné of Virginia,” often cited herein. He married in Quanah, Hardeman Co., Tex. [Sept. 9, 1924] Kathleen Reeves [born in Quanah, Tex., Aug. 7, 1904; graduated from Butler U. in Indianapolis, Ind., 1927. She taught high school English in Loretta, Tex., and elementary school in Lubbock, Lubbock Co., Tex. She died in Austin, Travis Co., Tex., Feb. 16, 1999]. They resided in Austin, Tex., where he died in April 18, 1977).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Child:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23919. Alan Lancaster Dabney. ["), _c('a', {
    attrs: {
      "href": "http://Anc.com",
      "target": "_blank"
    }
  }, [_vm._v("Anc.com")]), _vm._v("/obit. of Kathleen R. Dabney in Austin "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("American-Statesman")]), _vm._v(", 2/26/1999; SSDI; TexDI; L. E. DABNEY, “Texas Desc. Jean d’Aubigné,” 9; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11361–81441]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13439. Mary Elizabeth Dabney (born Oct. 17, 1899; married [June 26, 1928] Charles Edwin Briggs [born June 27, 1899]. They resided in Corpus Christi, Nueces Co., Tex., where she died Sept. 9, 1957).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Child:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23920. Charles Edwin Briggs, Jr. (born in Bexar Co., Tex., May 23, 1936). [TexBI; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11361–81442]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13440. Lora Morris Dabney (born on the George R. Dabney Ranch near Willow City, Gillespie Co., Tex., July 16, 1901; married [1"), _c('sup', [_vm._v("st")]), _vm._v("] Horace Oldham. After their divorce she married [2"), _c('sup', [_vm._v("nd")]), _vm._v(", on May 26, 1926] Charles L. Oden [born in Tex., March 29, 1890; a veteran of WW I, he died June 10, 1975]. They resided in Wichita Falls, Wichita Co., Tex., 1930, where he was a manager for an oil company. They later resided in Fort Worth, Tarrant Co., Tex., and she died Feb. 16, 2000).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Child (by her 2"), _c('sup', [_vm._v("nd")]), _vm._v(" husband):")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23921. Mary Oden. [1930 census Wichita Co., Tex., E.D. 20, p. 10B; SSDI; L. E. DABNEY, “Texas Desc. Jean d’Aubigné,” 9; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11361–81443]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13441. Gordon Willeford Dabney (born on the George R. Dabney Ranch near Willow City, Tex., Sept. 17, 1903; married in Amarillo, Potter Co., Tex. [1"), _c('sup', [_vm._v("st")]), _vm._v(", on Dec. 23, 1928] Frances Evans [born Nov. 23, 1906; died in San Antonio, Tex., May 22, 1956]. He later married at La Paz, Bolivia [2"), _c('sup', [_vm._v("nd")]), _vm._v(", on Nov. 16, 1957] Larena L. Jenkins [born Sept. 19, 1915]. They resided in San Antonio, Tex. and Martindale, Caldwell Co., Tex. He died in San Antonio, Tex., July 28, 1977).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children (by his 1"), _c('sup', [_vm._v("st")]), _vm._v(" wife):")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23922. Eugene Evans Dabney.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23923. Jane Dabney. [SSDI; TexDI; L. E. DABNEY, “Texas Desc. Jean d’Aubigné,” 9; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11361–81444]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13443. Ada Byron Dabney (born at Center Point, Kerr Co., Tex., Sept. 3, 1909; married [Sept. 4, 1931] Henry Raymond Armstrong [born in Tex., ca. 1905]. They resided in Kermit, Winkler Co., \nTex., 1940. They resided at one time in Seguin, Guadalupe Co., Tex. and later in Big Spring, Howard Co., Tex. She died in Howard Co., Tex., Feb. 1, 1999).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23924. John Franklin Armstrong (born in Gorman, Eastland Co., Tex., May 24, 1933; died unm. in Culberson Co., Tex., Jan. 19 or 20, 1974).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23925. Elizabeth Armstrong (twin).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23926. Lora Armstrong (twin). [1940 census Winkler Co., Tex., E.D. 248–8B, p. 11A; SSDI; TexDI; L. E. DABNEY, “Texas Desc. Jean d’Aubigné,” 9; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11361–81446]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13444. Robert Raymond Dabney (born in Hilda, Mason Co., Tex., Dec. 1, 1902; married ibid. [1"), _c('sup', [_vm._v("st")]), _vm._v(", on Aug. 16, 1930] Cora Mae Beck [born in Wills Point, Van Zandt Co., Tex., ca. Sept. 27, 1898; died in San Antonio, Tex., ca. June 3, 1945]. He married in Kerrville, Kerr Co., Tex. [2"), _c('sup', [_vm._v("nd")]), _vm._v(", on Feb. 9, 1946] Ruth Baxter [born Oct. 21, 1907; died in Eddy Co., N.M., April 1985]. They resided in Carlsbad, Eddy Co., N.M., and he died July 1985).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Child (by his 1"), _c('sup', [_vm._v("st")]), _vm._v(" wife; adopted):")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23927. Robert Faulkner Dabney. [SSDI; posting by Nell Truitt on "), _c('a', {
    attrs: {
      "href": "http://http://genforum.genealogy.com",
      "target": "_blank"
    }
  }, [_vm._v("http://genforum.genealogy.com")]), _vm._v("/gardner; L. E. DABNEY, “Texas Desc. Jean d’Aubigné,” 10–11; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11361–81451]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13446. Mary Juliette Dabney (born in Boerne, Kendall Co., Tex., May 6, 1911; married [March 28, 1936] Oscar Vernon Fontaine [born Aug. 31, 1905; a descendant of the Rev. Peter Fontaine, Oscar died in Gillespie Co., Tex., Jan. 5, 1992]. They resided in Austin, Travis Co., Tex., and later in Harper, Gillespie Co., Tex. Mary died in Kerr Co., Tex., Oct. 5, 1993).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Child:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23928. Nancy Renée Fontaine. [SSDI; TexDI; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11361–81453]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13447. Henry Lothaire Dabney (born in Boerne, Kendall Co., Tex., Nov. 18, 1913; married [May 29, 1937] Ruth Lerna Ennis [born Aug. 18, 1913; died in Matagorda Co., Tex., April 7, 1982]. He last resided in West Columbia, Brazoria Co., Tex., but he died in Matagorda Co., Tex., May 11, 1984).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23929. Tom Ennis Dabney.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23930. Margaret Deborah Dabney. [SSDI; TexDI; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11361–81454]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13448. Malcolm Kelso Dabney (born in Harper, Gillespie Co., Tex., July 23, 1918; married [Sept. 8, 1945] Jane Sullivan [born in Dallas, Tex. March or May 10, 1922]. They resided in San Angelo, Tom Green Co., Tex., and later Harper, Gillespie Co., Tex., where he died Oct. 22, 1989).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Child:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23931. Susan Lynn Dabney (born in Austin, Travis Co., Tex., Nov. 9, 1946; married [June 18, 1967] Gary F. Guenther [born March 27, 1945]. They resided in Austin, Tex.). [SSDI; TexDI; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11361–81455]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13451. Oscar Kenneth Smith (born in Blanco Co., Tex., Sept. 9, 1906; married in Waxahachie, Ellis Co., Tex. [1930] Elizabeth Painter. He died in Waxahachie, Tex., April 18, 1990).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23932. Joseph Sidney Smith (born in Bell Co., Tex. Nov. 8, 1940).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23933. Michael Phillip Smith (born ibid., Jan. 3, 1945). [TexBI; "), _c('a', {
    attrs: {
      "href": "http://FamSearch.org",
      "target": "_blank"
    }
  }, [_vm._v("FamSearch.org")]), _vm._v("/Tex. Deaths; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11361–81463]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13453. Lois Agnes Smith (born in Llano Co., Tex., Aug. 18, 1915; married in Austin, Travis Co., Tex., Charles Julian Baldwin, Jr., and they were later divorced. She died in Travis Co., Tex., Aug. 20, 1985).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Child:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23934. Charles Julian Baldwin III (born in Travis Co., Tex., July 17, 1938). [TexBI; "), _c('a', {
    attrs: {
      "href": "http://FamSearch.org",
      "target": "_blank"
    }
  }, [_vm._v("FamSearch.org")]), _vm._v("/Tex. Deaths; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11361–81465]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13456. Gaylord Alexander Eddy (born in La Junta, Otero Co., Colo., Feb. 28, 1908; married [Oct. 1931] Martha Hickman [born in Tenn., ca. 1911]. A longshoreman, he died in Corpus Christi, Nueces Co., Tex., July 6, 1977).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23935-a. Gaylord Houston Eddy (born in Tex., Aug. 18, 1932; died in Las Vegas, Clark Co., Nev., Nov. 28, 1994).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23935-b. Byron B. Eddy (born in Tex., ca. 1934). [1940 census Nueces Co., Tex., E.D. 178–37A, p. 64A; SSDI; TexDI; L. E. DABNEY, “Texas Desc. Jean d’Aubigné,” 12; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11361–81473]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13458. George Wendell Eddy (born in San Saba, San Saba Co., Tex., Sept. 4, 1916; served as Capt., USA. He married in Deming, Luna Co., N.M. [June 6, 1942] Mary Helen McDaniel. He last resided in Colorado Springs, El Paso Co., Colo., and he died Aug. 2, 1992).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23936. Mary Camille Eddy (born Aug. 14, 1948; married ___ Larson, and they had three children: Michael Larson, Eric Larson, and Elizabeth Larson).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23937. Philip Blaine Eddy (born Nov. 1, 1953). [SSDI; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11361–81475]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13460. Nettie Ola Dabney (born in Willow City, Gillespie Co., Tex., April 15, 1908; married in Trinidad, Las Animas Co., Colo. [May 28, 1930] Walter Gray Richardson [born in Tom’s Creek, Wise Co., Va., July 9, 1906]).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Child:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23938. Jack Richardson (born in Trinidad, Colo., Feb. 15, 1931). [J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11361–81481]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13468. Jean Elizabeth Dabney (born in Tex., Sept. 29, 1913; married Joseph Lawrence Nobles. She was killed in an automobile accident Oct. 6, 1954, while moving from Alice, Jim Wells Co., Tex., to Houston, Tex., with the ultimate destination of Oklahoma).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23939. Jean Elizabeth Nobles (born Feb. 25, 1939).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23940. Teresa Ann Nobles (born ca. 1948). [SAR Membership Applications (James Finney Dabney, natl. #56792); TexBI; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11361–81611]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13469. Willie Mae Dabney (born in Texarkana, Bowie Co., Tex., Oct. 20, 1903; married in Smithville, Bastrop Co., Tex. [Jan. 24, 1929] Andrew Jackson Perciville [born in Bastrop Co., Tex., Oct. 29, 1882; died in Palacios, Matagorda Co., Tex., Feb. 13, 1952, and he was buried in Smithville, Tex.]. They resided in Smithville, Tex., 1930, where he worked as a blacksmith. She died in Brazoria Co., Tex., Nov. 12, 1990; their first child, unnamed, was born and died in La Grange, Fayette Co., Tex., Aug. 22, 1929).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Child (surviving):")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23941. Andrew Jackson Perciville, Jr. (born in Smithville, Tex., March 4, 1932). [1930 census Bastrop Co., Tex., E.D. 4, p. 3B; TexDI; "), _c('a', {
    attrs: {
      "href": "http://FamSearch.org",
      "target": "_blank"
    }
  }, [_vm._v("FamSearch.org")]), _vm._v("/Tex. Deaths; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11361–81631]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13473. Mary Elizabeth Dabney (born in Beaumont, Jefferson Co., Tex., May 13, 1913; married Claude Carl Strickland. She last resided in Lewisville, Denton Co., Tex., and she died Nov. 18, 2001).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23942-a. William Ted Strickland (born in Anderson Co., Tex., Nov. 11, 1936).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23942-b. Mary Louise Strickland (born in Bastrop Co., Tex., July 31, 1938). [TexBI; "), _c('a', {
    attrs: {
      "href": "http://Anc.com",
      "target": "_blank"
    }
  }, [_vm._v("Anc.com")]), _vm._v("/OWT]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13475. Della Corinne Dabney (born in Upton, Bastrop Co., Tex., Jan. 12, 1919; married Wiley Farrow Robertson).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23943-a. Duckie Ann Robertson (born in Bastrop Co., Tex., Nov. 29, 1945).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23943-b. Thomas Wiley Robertson (born ibid., July 28, 1947). [TexBI, which spells Della’s middle name “Corrine”; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11361–81917]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13477. Benjamin Lyman Grimes, Jr. (born in Cameron, Milam Co., Tex., Nov. 22, 1907; graduated from Texas A&M U., 1929. He resided unm. with his parents in San Angelo, Tom Green Co., Tex., 1930. He later married in Houston, Tex. [July 22, 1933] Frances Elizabeth Craighead [born in Patterson, St. Mary Parish, La., July 12, 1904; DAR member #600610, she died in Georgetown, Williamson Co., Tex., Sept. 19, 2000]. They resided in Corpus Christi, Nueces Co., Tex., 1940, where he was a city engineer for the Health Department. He died in Houston, Tex., May 24, 1984).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23944. Benjamin Lyman Grimes III.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23945. Charles Bowman Grimes (born in Juneau, Alaska, ca. 1938; married in Aiken, Aiken Co., S.C. [Aug. 3, 1963] Cynthia Matthews [born in Portsmouth, Va.]). [1930 census Tom Green Co., Tex., E.D. 9, p. 8B; 1940 census Nueces Co., Tex., E.D. 178–33B, p. 7A; SSDI; "), _c('a', {
    attrs: {
      "href": "http://Anc.com",
      "target": "_blank"
    }
  }, [_vm._v("Anc.com")]), _vm._v("/OWT; "), _c('a', {
    attrs: {
      "href": "http://RootsWeb.com",
      "target": "_blank"
    }
  }, [_vm._v("RootsWeb.com")]), _vm._v("/WCP; D. S. C. NORMAN, website “Genealogy” (see bibliog.)]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13481. Walter Lee Davis (born in Manor, Travis Co., Tex., June 22, 1897; he was unm. and residing in Sonora, Sutton Co., Tex., when he registered for the draft Aug. 24, 1918. He married Buenavista “Buena” Irene Hoggett [born in Tex., Aug. 27, 1899; died in Stephenville, Erath Co., Tex., March 3, 1983]. They resided on a ranch in Sutton Co., Tex., 1940. He died in Sonora, Tex., Aug. 13, 1971).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23946. Walter Louis Davis.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23947. Rodney Ellis Davis (born in Tom Green Co., Tex., Oct. 30, 1939). [1900 census Bastrop Co., Tex., E.D. 8, p. 31D; 1940 census Sutton Co., Tex., E.D. 218–2, pp. 2B-3A; WW I Draft Reg.; TexBI; TexDI; SSDI; "), _c('a', {
    attrs: {
      "href": "http://Anc.com",
      "target": "_blank"
    }
  }, [_vm._v("Anc.com")]), _vm._v("/PMT]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13484. John Tyson Cope (born in Tex., ca. 1908; married Olene Poe [born Dec. 11, 1911; last resided in North Richland Hills, Tarrant Co., Tex., and she died Nov. 1985]. They resided at one time in Breckenridge, Stephens Co., Tex., and he died in Stephens Co., Tex., May 9, 1960).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Child:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23948. Evelyn Olene Cope (born in Potter Co., Tex., July 12, 1941). [1920 census Travis Co., Tex., E.D. 102, p. 7A; TexBI; SSDI; TexDI; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11361–81922]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13486. Virgil Claude Dabney (born in Colony, Fayette Co., Tex., Dec. 2, 1899; his family had no spare money for college expenses, so he went to work with his father as a carpenter for a year and saved enough to enroll in Texas A&M U. in the fall of 1918. On Nov. 11, 1918, he and the entire Corps of Cadets were ordered to form a semicircle around the home of the university’s president, Dr. William Bizzell, who came out and simply announced, “The war is over.” At that point, Dabney recalled:")]), _vm._v(" "), _c('div', {
    staticClass: "extract"
  }, [_c('p', {
    staticClass: "extractText"
  }, [_vm._v("You were standing there at attention, but you couldn’t help but glance to the left and glance to the right and question yourself, ‘Did I hear what he said?’ And finally, it dawned on the Corps what Dr. Bizzell had said, and all at once, that Cadet Corps burst into a yell. And it continued so long and so loud, that you wondered if it would ever quit.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The returning veterans from France were more than the college could accommodate, and along with hundreds of students Virgil found himself housed in a tent inadequately heated by a wood-burning stove:")]), _vm._v(" "), _c('div', {
    staticClass: "extract"
  }, [_c('p', {
    staticClass: "extractText"
  }, [_vm._v("We didn’t have facilities, like showers or water in the tents. It wasn’t too bad, until winter hit. It was unusually hard winter, and the snow would cover our firewood… . In the winter of 1919, an influenza epidemic hit the campus, and the cadets housed [in tents] were affected the most.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("From time to time Virgil had to withdraw temporarily to earn more money. To accelerate his delayed graduation, he took 23 semester hours during his last semester and graduated in the fall of 1923. He then worked briefly as an instructor in Industrial Arts at his both his alma mater and Wichita Falls High School. After then working as a carpenter for four years, he took a job teaching machine design, architectural drawing, and wood shop at San Jacinto High School in Houston, Tex.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Soon afterward he married in San Antonio, Tex. [Oct. 14, 1928] Katie Mae Wilcox [born in Tex., Jan. 23, 1905; a stenographer, she died in Bandera Co., Tex., Sept. 11, 1991]. After 38 years he retired from San Jacinto High School and moved to Bandera Co., Tex., where he and his wife operated a small ranch and farm. After the death of his wife in 1991, Virgil continued to farm until age 97. He was honored during halftime at many football games at Kyle Field as the oldest living alumnus of Texas A&M. He died at the age of 103 in Kerrville, Kerr Co., Tex., Sept. 28, 2003).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23949. Robert Claude Dabney.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23950. Thomas William Dabney. [1930 census Harris Co., Tex., E.D. 121, p. 2B; SSDI; TexDI; obit. of Virgil C. Dabney in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Battalion News")]), _vm._v(" ("), _c('a', {
    attrs: {
      "href": "http://www.thebatt.com/news/2003/10/03",
      "target": "_blank"
    }
  }, [_vm._v("www.thebatt.com/news/2003/10/03")]), _vm._v("); J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11361–81x21]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13487. Ruby Estella Dabney (born July 23, 1902; married in San Antonio, Tex. [1"), _c('sup', [_vm._v("st")]), _vm._v(", on May 9, 1921] Walter Ray Wolfe [born April 19, 1903; died Aug. 19, 1982; “of Pearsall, Tex.”]. After a divorce, she married in San Antonio, Tex. [2"), _c('sup', [_vm._v("nd")]), _vm._v(", on Aug. 7, 1925] Gerald Beaver Meeks [born in Urbana, Champaign Co., Ill., Feb. 17, 1895; died in San Antonio, Tex., Dec. 4, 1959]. She last resided and died in San Antonio, Tex., Oct. 7, 1999).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Child (by her 1"), _c('sup', [_vm._v("st")]), _vm._v(" husband):")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23951. Kathleen Frances Wolfe.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Child (by her 2"), _c('sup', [_vm._v("nd")]), _vm._v(" husband):")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23952. Gerald Beaver Meeks, Jr. [WW II Draft Reg.; SSDI; "), _c('a', {
    attrs: {
      "href": "http://FamSearch.org",
      "target": "_blank"
    }
  }, [_vm._v("FamSearch.org")]), _vm._v("/Tex. Deaths; L. E. DABNEY, “Texas Desc. Jean d’Aubigné,” 14; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11361–81x22]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13496. Newton Thomas Baggett, Jr. (born in Rolling Fork, Sharkey Co., Miss., Dec. 27, 1896; served in Co. C, 155"), _c('sup', [_vm._v("th")]), _vm._v(" Miss. Inf. Regt., National Guard, 1916–1917. Late in WW I, he arrived in France and was assigned to a pioneer battalion consisting of white officers and NCOs, along with black enlisted men, who had the task of laying telephone lines and burying the dead. Pockets of poison gas still lingered on the battlefield as Newton and the others collected mutilated bodies for mass burial. Unable to endure the horror any longer, he asked to be transferred to a combat unit, and he was on his way to the front when the war ended Nov. 11, 1918. He was discharged from the Army at the rank of 1"), _c('sup', [_vm._v("st")]), _vm._v(" Sgt. in 1919.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("After attending a business college in New Orleans, La., he returned to Rolling Fork, Miss., and farmed. Meanwhile he played semi-pro baseball with a team in Vicksburg, the forerunner of the AA Cotton States League team known as the Vicksburg Hillbillies. Family tradition records that he once pitched in an exhibition game against the New York Yankees, but “he was quickly knocked out of the box.” He then spent several years in Los Angeles, Cal., with a farm team of the Brooklyn Dodgers, until a shoulder injury ended his career.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Newton returned to Mississippi in the fall of 1926, where he soon met his future bride on a dance held on the courthouse lawn in Rolling Fork. He courted her throughout that fall and winter, as the rain fell for weeks on end. On April 21, 1927, the swollen Mississippi River finally burst the levee at Scott, Miss., sending a wall of water toward Rolling Fork. His future wife Sara fled on the last train south for Vicksburg, while he stayed to salvage what little he could at the farm and help the field hands evacuate to higher ground.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("A few weeks later Newton and his fiancée took a steamboat to Memphis, Tenn. where he married [June 7, 1927] Sara Evelyn Joiner [born in West Point, Clay Co., Miss., May 17, 1904; a talented musician and dancer, she also taught school. During their 46 years of marriage, according to their daughter Frances, they “never exchanged a cross word.” She died March 9, 1984]. After their marriage, Newton went to work for the Virden Lumber Company in Greenville, Washington Co., Miss., and later went into the wholesale lumber business. He died in Indianola, Sunflower Co., Miss., Jan. 8, 1974).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23953. Marcella Wilsford Baggett.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23954. Frances Ann Baggett. [Quotations from "), _c('a', {
    attrs: {
      "href": "http://Anc.com",
      "target": "_blank"
    }
  }, [_vm._v("Anc.com")]), _vm._v("/AWT, entry by FABD. See also: FGS by FABD; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11361–84112]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13498. Greenfield Marion Baggett II (born in Rolling Fork, Sharkey Co., Miss., Aug. 1901; married ibid. [Nov. 27, 1934] Frances Moore [born ibid., June 4, 1909; died ibid., Jan. 1982]. He died ibid., Feb. 1, 1981).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23955. Annie Gale Baggett (born in Rolling Fork, Miss., Aug. 1935).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23956. Greenfield Marion Baggett III. [SSDI; FGS by FABD; "), _c('a', {
    attrs: {
      "href": "http://Anc.com",
      "target": "_blank"
    }
  }, [_vm._v("Anc.com")]), _vm._v("/AWT; "), _c('a', {
    attrs: {
      "href": "http://RootsWeb.com",
      "target": "_blank"
    }
  }, [_vm._v("RootsWeb.com")]), _vm._v("/WCP, entry by JW; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11361–84114]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13499. Fielding Lewis Wright (born in Rolling Fork, Sharkey Co., Miss., May 16, 1895; attended the local public school which had only ten grades and fewer than 80 students. After attending the Webb School in Bell Buckle, Tenn., for the academic year 1911–1912, he enrolled in the U. of Ala., where he was a charter member of Sigma Chi and graduated with a law degree in 1915. The following year he was admitted to the Mississippi bar. From his youth he was active in the Methodist church, later organizing and teaching a men’s Bible class.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("He married [July 16, 1917] his childhood sweetheart from Rolling Fork, Nan Kelly [born Jan. 5, 1899; died Sept. 22, 1990]. Soon after U.S. entry into WW I, he enlisted in the Army ca. May 1917, and he arrived in France ca. Sept. 1918. His military record is confused. According to "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Current Biography Yearbook,")]), _vm._v(" the war ended before his unit was assigned to the front lines. In contrast, Hilliard [citing the Jackson "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Clarion Ledger")]), _vm._v(" of Jan. 19, 1948] says that his unit, the 149"), _c('sup', [_vm._v("th")]), _vm._v(" Machinegun Battalion of the 38"), _c('sup', [_vm._v("th")]), _vm._v(" Inf. Division, saw action at Belleau Wood and Chateau-Thierry. After serving in the Army of Occupation, he was honorably discharged Sept. 1, 1919, and he returned to his law practice in Rolling Fork, Miss. To supplement his income, he played semi-professional baseball from 1919 to 1922.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("In 1925 he organized Co. B., 106"), _c('sup', [_vm._v("th")]), _vm._v(" Engineers, Mississippi National Guard, serving as its Captain, and was the first commander of the Rolling Fork American Legion post formed in 1921. His long and successful political career began with his winning a seat as state senator from Sharkey Co., Miss. In his first session, he authored or co-authored fourteen bills, six of which were signed into law. He later served as a state representative from his county, winning election without opposition in 1931 and serving continually until 1940.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("When he took office in 1932, the state government was deeply in debt, the economy in shambles, and gun-waving protesters were threatening to riot in front of the capitol building. In the face of near-violent opposition, Wright was a prominent leader in the successful battle to initiate a state sales tax. As newly appointed chairman of the House Rules Committee, he broke all precedent in admitting journalists to the previously secret deliberations of the committee. Known for his hard work and long hours, he was dubbed “a human slave driver” by the Jackson "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Daily News")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("When the Speaker of the House Horace Stansel became critically ill late in the 1936 session, Wright was elected by acclamation to replace him as speaker pro tempore. After Stansel’s death during the extraordinary session late in 1936, Wright was unanimously elected to succeed him as Speaker. Far from the stereotype of a flamboyant Southern politician, Wright was described by his local newspaper as “modest to the point of self-effacement and as quiet as a Quaker at a funeral.” He served continuously as Speaker until he withdrew from politics in 1940 to devote his full time and energy to his law practice.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Joining a prominent Vicksburg law firm as a senior partner, Wright soon was operating three busy and lucrative law offices. In the summer of 1943, he returned home from an out-of-state trip to discover to his amazement that he was a candidate for lieutenant governor. The campaign announcements had been released to newspapers by Wright’s supporters without his knowledge. Irked and inclined to issue a statement disavowing the reports, the reluctant Wright was finally persuaded by supporters to enter the crowded field of candidates. With very little campaigning, Wright managed to make it into the run-off, which he then proceeded to win by a wide margin. Upon the death of Governor Thomas Bailey, Wright succeeded him as governor of Mississippi on Nov. 2, 1946. He swamped four opponents to win the governor’s race in 1947 without a run-off election, and he served until 1952. His administration was marked on the state level by the establishment of a medical school at the U. of Miss., considerable success in attracting new industry, and the mobilization of the National Guard at the outbreak of the Korean War in 1950.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Meanwhile, Wright made a mark for himself in national politics. His inaugural address of Jan. 20, 1948, was punctuated both with attacks on President Truman’s new civil rights proposals and with warnings that the national Democratic party should no longer take the South for granted. The following month he took a leading role at the Southern Governors’ Conference in Wakulla Springs, Fla., suggesting that a convention of “true Democrats” be held at Jackson, Miss. When finally assembled in Jackson on May 10, 1948, the conference drew a thousand delegates from nine Southern states.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The crisis within the Democratic Party came rapidly to a head in the summer of 1948. Wright was a delegate to the National Democratic Convention that met in Philadelphia, Pa., on July 12. After losing a fairly close vote in opposition to Hubert Humphrey’s civil rights plank, the Mississippi delegates and half of those from Alabama walked out of the convention the following day. Just three days later, on July 16, the States’ Rights Democrats convened in Birmingham, Ala., and the following day nominated South Carolina Governor Strom Thurmond for President and Mississippi Governor Fielding Wright for Vice-President. The two men formally accepted the nominations at a States’ Rights rally in Houston, Tex., on Aug. 11, 1948.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("With no chance of winning a majority of electoral votes, the strategy of the Thurmond-Wright ticket was obvious. If they could win enough Southern states and if Dewey and Truman ran a very close race [as expected], this would deny any candidate an electoral majority and thus send the issue to the U.S. Congress. There, as Mississippi Senator James Eastland saw it, “Northern Democrats would still prefer a Southern Democrat to a Republican, and Republicans would prefer a Southern Democrat to a Northern one.” Even on election night the strategy seemed to have some hope for success. Then, after wavering all night, California, Illinois, and Ohio all went to Truman by razor-thin margins, giving him an outright majority of electoral votes. Thurmond and Wright carried four states—Mississippi, Alabama, South Carolina, and Louisiana—for just 39 electoral votes.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("As a Democratic National Committeeman from Mississippi in 1952, Wright reluctantly voted [but refused to campaign] for Adlai Stevenson. Wright was apparently mollified by the selection of Alabama Senator John Sparkman as Stevenson’s running-mate and also the refusal of the National Democratic Party to criticize the successful Southern filibuster which had blocked civil rights legislation in Congress. That same year, Wright’s term as governor expired, and he returned to his law practice.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Late in 1954, Wright decided to run again for governor. Though he had won regional prominence and was widely referred to as “Mississippi’s Mr. States’ Rights,” the five-way race proved to be extremely bruising. Though all candidates were segregationists, each had a different strategy for counteracting perceived Federal encroachments. Election night in Aug. 1955 brought shocking results: the favorite, Fielding L. Wright, had been eliminated in the first primary and did not even qualify for the run-off election. His defeat was widely blamed on complacency and the failure to campaign vigorously. Close associates believed that he never recovered from the shock and pain of this defeat. Nine months later on May 4, 1956, he suddenly died of a heart attack while watching television at his home in Jackson, Miss. Both Fielding and his wife Nan were buried at Kelly Cemetery in Rolling Fork, Sharkey Co., Miss).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23957. Fielding Lewis Wright, Jr. (born in Sharkey Co., Miss., ca. 1920; he enlisted in Jackson, Miss., March 14, 1942, and he served in the Air Force as a pilot in WW II).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23958. Elaine Wright (adopted; married Charles Hunt). [Quotations from E. HILLIARD, “Fielding Lewis Wright” (M.A. Thesis), 41, 45, 92–93. See also: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("CBY")]), _vm._v(", 1948; R. SOBEL-J. RAIMO, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Biog. Dir. of Governors")]), _vm._v(", 2:829–830; C. L. SUMNERS, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Governors of Miss")]), _vm._v("., 123–125; WW II AER; Larry Wheeler, “Mount Cemetery, Rolling Fork, Sharkey Co., Miss.” (see bibliog., websites); J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11361–84121]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13504. Gertrude Vivian Clements (born in Rolling Fork, Sharkey Co., Miss., July 14, 1902; married Thomas A. Burgin [born in N.C., ca. 1892]. He was apparently unemployed in Biloxi, Harrison Co., Miss., 1940. She last resided in Prentiss, Jefferson Davis Co., Miss., and she died Oct. 13, 1972).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23959-a. Elizabeth Burgin (born in Collins, Covington Co., Miss., Aug. 19, 1926; married Ed Hinman, and she died in Vicksburg, Warren Co., Miss., ca. 1978).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23959-b. Barbara G. Burgin (born in Tenn., ca. 1928). [1940 census Harrison Co., Miss., E.D. 24–10, p. 18B; SSDI; "), _c('a', {
    attrs: {
      "href": "http://Gen.com",
      "target": "_blank"
    }
  }, [_vm._v("Gen.com")]), _vm._v("/WFT]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13509. Annie Prince Clements (born in Rolling Fork, Sharkey Co., Miss., Jan. 1913; graduated from Peabody College in Nashville, Tenn., and she taught physical education at Rolling Fork Elementary School. She was a member and officer of the Betsy Love Allen Chapter of the DAR, and for 55 years she sang in the choir of the First Baptist Church in Rolling Fork, Miss. She married in Rolling Fork, Miss. [Jan. 6, 1936] Wilson Maxwell Virden [born in Rolling Fork, Miss., Dec. 12, 1911; served in the Army from Oct. 1, 1941 to Oct. 29, 1945, and he died ibid., March 17, 1987]. She died July 22, 2004, and both were buried at Mount Cemetery in Rolling Fork, Miss.).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23960. Wilson Maxwell Virden, Jr. (born in Miss., ca. 1937; resided in Woodstock, Cherokee Co., Ga.).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23961. Jack G. Virden (born in Miss., ca. March 1940; resided in Vicksburg, Warren Co., Miss.).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23962. Thad M. Virden (born Aug. 1951; married Nancy B. [born Nov. 1951], and they resided in Rolling Fork, Miss.). [USPRI; obit. of Mrs. Annie P. C. Virden in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Vicksburg Post")]), _vm._v(", 7/24/2004; SSDI; "), _c('a', {
    attrs: {
      "href": "http://www.findagrave.com",
      "target": "_blank"
    }
  }, [_vm._v("www.findagrave.com")]), _vm._v("; "), _c('a', {
    attrs: {
      "href": "http://Anc.com",
      "target": "_blank"
    }
  }, [_vm._v("Anc.com")]), _vm._v("/Dept. of Veterans Affairs; OWT; Mound Cem. records, posted on "), _c('a', {
    attrs: {
      "href": "http://RootsWeb.com",
      "target": "_blank"
    }
  }, [_vm._v("RootsWeb.com")]), _vm._v("]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13515. Claibourne Watkins Patty (born Sept. 21, 1903; married Eleanor Todd [born April 20, 1908; died in Little Rock, Pulaski Co., Ark., May 12, 1988]. They resided in Little Rock, Ark., where he died Oct. 10, 1985).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Child:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23963. Claibourne Watkins Patty, Jr. ["), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Who’s Who Am")]), _vm._v("., 2002; "), _c('a', {
    attrs: {
      "href": "http://Anc.com",
      "target": "_blank"
    }
  }, [_vm._v("Anc.com")]), _vm._v("/PMT; SSDI]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13519. Sidney Dade Cox (born in Miss., Nov. 1, 1901; a farmer, he married [ca. 1922] Margie Watts [born ibid., July 28, 1905; died Sept. 27, 1997]. They resided in Lowndes Co., Miss., and he died Oct. 11, 1992).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23964. Sidney Dade Cox, Jr. (born in Miss., ca. 1922).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23965. William A. Cox (born ibid., ca. 1924).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23966. Beatrice/Lelia Cox (born ibid., ca. 1926). [1930 census Lowndes Co., Miss., E.D. 21, p. 5B; 1940 census ibid., E.D. 44–25, p. 6B; A. W. FOOTE, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Foote")]), _vm._v(", 2:1149; "), _c('a', {
    attrs: {
      "href": "http://www.findagrave.com",
      "target": "_blank"
    }
  }, [_vm._v("www.findagrave.com")]), _vm._v("; FGS by DCM; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11361–84432]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13523. Henry Dade Foote, Jr. (born in Hattiesburg, Forrest Co., Miss., April 15, 1912; moved with his family in 1920 to Alexandria, Rapides Parish, La., where he eventually worked with his father in the family lumber business. He married [May 28, 1936] Elizabeth Hemenway [born in Alexandria, La., Dec. 23, 1913; died Dec. 9, 1974]. He died in Alexandria, La., June 12, 1955).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23967. Henry Dade Foote III.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23968. Frank Hemenway Foote (born June 21, 1938; married Margaret Hart, and they were later divorced).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23969. Lester McLure Foote (born Aug. 8, 1942; married Melinda Allen).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23970. Elizabeth Alma Foote. [G. M. G. STAFFORD, “M. R. W. Triumvirate,” 82; "), _c('a', {
    attrs: {
      "href": "http://Anc.com",
      "target": "_blank"
    }
  }, [_vm._v("Anc.com")]), _vm._v("/AWT, entry by FAD; FGS by DCM; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11361–84451]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13524. Ray Foote (born in Miss., Feb. 19, 1914; married [Dec. 28, 1937] Hale Oliver Schaleben [born Aug. 11, 1909; last resided in Edinburg, Hidalgo, Tex., but he died in Harris Co., Tex., April 13, 1984]).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23971. Jeannette Schaleben.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23972. Gertrude Schaleben. [SSDI; TexDI; G. M. G. STAFFORD, “M. R. W. Triumvirate,” 82; FGS by DCM; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11361–84452]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13525. George Messenger Foote (born in Alexandria, Rapides Parish, La., Nov. 16, 1919; rose to the rank of Lt. Colonel, USMC, serving 27 months in the South Pacific in WW II. He was awarded the Silver Star for his valor on July 21–22, 1944, during the bitter struggle for Guam. I had the pleasure of corresponding with Colonel [also Judge] Foote, who contributed some information about his family but was extremely modest and reticent about his WW II service. His son-in-law and avid genealogist, David Marriott, told me that he had been equally unsuccessful in his attempts to learn any details. After repeated attempts and some timely assistance from a staffer of U.S. Senator Connie Mack, I finally discovered that Colonel Foote was the subject of a 1945 dispatch by a Marine Corps combat correspondent that found its way into Colonel Foote’s file at the Reference Section of the Marine Corps Historical Center in Washington, D.C. It was written by Sgt. Harold A. Breard, of Monroe, La.:")]), _vm._v(" "), _c('div', {
    staticClass: "extract"
  }, [_c('p', {
    staticClass: "extractNoIndent"
  }, [_vm._v("Iwo Jima (Delayed).—A 25-year-old resident of Alexandria, La., a Marine Major George M. Foote, played a leading role in getting the 5"), _c('sup', [_vm._v("th")]), _vm._v(" Marine Division ashore on Iwo Jima in the toughest amphibious operations against the Japs the Marines have experienced thus far.")]), _vm._v(" "), _c('p', {
    staticClass: "extractText"
  }, [_vm._v("He is [sic] operations officer of the 3"), _c('sup', [_vm._v("rd")]), _vm._v(" Marine Division on Bougainville and Guam. He won the Silver Star on Guam by reconnoitering and mapping an amphibian tractor route through an enemy mine field.")]), _vm._v(" "), _c('p', {
    staticClass: "extractText"
  }, [_vm._v("With the aid of another battalion of personnel and cargo carrying tractors and part of a battalion of armored amphibian tractors, Maj. Foote’s outfit transported all of the assault troops, most of the reserves and virtually all of the supplies of the 5"), _c('sup', [_vm._v("th")]), _vm._v(" Division ashore here.")]), _vm._v(" "), _c('p', {
    staticClass: "extractText"
  }, [_vm._v("Moreover, although attached to the 5"), _c('sup', [_vm._v("th")]), _vm._v(", it unloaded a considerable portion of the 3"), _c('sup', [_vm._v("rd")]), _vm._v(" Division’s supplies after the 3"), _c('sup', [_vm._v("rd")]), _vm._v(" was brought ashore, to break the backbone of Jap resistance on the sixth day.")]), _vm._v(" "), _c('p', {
    staticClass: "extractText"
  }, [_vm._v("Although it lost approximately half of its vehicles the battalion suffered few casualties. The heavy artillery and mortar fire the enemy rained on the beach the first few days had little effect on the tractors. Most of them were wrecked by the surf at the beach or swamped by the rough seas while transporting supplies from ship to shore, especially at night while forced to operate without lights. The ships were standing four miles off the island.")]), _vm._v(" "), _c('p', {
    staticClass: "extractText"
  }, [_vm._v("The Marines used the best beach Iwo Jima offered for landing purposes but its best was bad. The beach rises abruptly out of the sea and is pounded almost constantly by a heavy surf.")]), _vm._v(" "), _c('p', {
    staticClass: "extractText"
  }, [_vm._v("The only place at the outset where the tractors could move inland was immediately below heavily fortified Mount Suribachi, extinct volcano at the southern tip of the island. Later, other breaks in the vertical shore were spotted and bulldozers broke other approaches.")]), _vm._v(" "), _c('p', {
    staticClass: "extractText"
  }, [_vm._v("In the initial stages of the assault, the tractors dropped the assault troops at the water’s edge and then began hauling supplies from ships to dumps. They were, during the first four days, the only means of getting ammunition, food and water to the fighters. Higgins boats were useless in the shoreline surf and Jap guns and mortars held off the LCTs, LSMs, and LSTs… .")]), _vm._v(" "), _c('p', {
    staticClass: "extractText"
  }, [_vm._v("Maj. Foote has been overseas more than two years and is a veteran of the battle of Bougainville, as well as of the liberation of Guam and the invasion of Iwo Jima.")]), _vm._v(" "), _c('p', {
    staticClass: "extractText"
  }, [_vm._v("He was born and reared in Alexandria and is a graduate of Bolton High School of that city. He is the son of Mr. and Mrs. H. D. Foote, with whom he resides at 2012 Elliott Street.")]), _vm._v(" "), _c('p', {
    staticClass: "extractText"
  }, [_vm._v("Maj. Foote is an alumnus of Washington and Lee U., of Lexington, Va., from which he received his AB degree in 1940.")]), _vm._v(" "), _c('p', {
    staticClass: "extractText"
  }, [_vm._v("He was studying law at Tulane in New Orleans, La., when, as a Marine reserve officer, he was called to active duty. He has since been commissioned in the regular Marine Corps.")]), _vm._v(" "), _c('p', {
    staticClass: "extractText"
  }, [_vm._v("While at Washington and Lee, where he was on the varsity track and swimming teams, Maj. Foote became a member of Kappa Alpha social fraternity.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("After the war he returned to law school and graduated from Tulane U. [LL.B., 1947]. He went on to become a respected lawyer and judge in his native Alexandria, La., and he rose to the rank of Colonel in the USMC Reserve. One of the founders of Renaissance Home for Youth, he was also chairman of the building committee for First United Methodist Church of Alexandria, La. In his later years, he was executive director of the Louisiana Council of Juvenile and Family Court Judges. He married in Alexandria, Rapides Parish, La. [Oct. 26, 1945] Antonia Voelker, and he died June 21, 2010).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23973. Evelyn Neill Foote.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23974. George Messenger Foote, Jr.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23975. Edward Voelker Foote.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23976. William Ross Foote.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23977. August Lee Foote.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23978. Robert Hale Foote.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23979. Ray Ashbridge Foote. [Quotation from H. A. BEARD, “Marine Corps Combat.” See also: G. M. G. STAFFORD, “M. R. W. Triumvirate,” 82; obit. of Judge Foote on "), _c('a', {
    attrs: {
      "href": "http://www.thetowntalk.com",
      "target": "_blank"
    }
  }, [_vm._v("www.thetowntalk.com")]), _vm._v(" (“the home page of Alexandria, LA”), 6/23/2010; FGS by DCM; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11361–84453]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13526. Jane Ann Foote (born in La., Nov. 16, 1926; attended Louisiana State U. She married in Alexandria, Rapides Parish, La. [May 15, 1948] Marion Lee Jarrell [born Dec. 17, 1921; graduated from Tulane U. (M.D., 1945). A physician in New Orleans, La., he later resided in Alexandria, La., and he died April 24, 1984]).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23980. Elizabeth Ray Jarrell (born 1949; married [May 14, 1994] Carl Craig).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23981. Ann Jarrell (born 1951).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23982. Sally Jarrell (born 1952; married James McMichael).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23983. Fahy Jarrell (born 1957; married [Nov. 29, 1985] Gary DeWitt). [G. M. G. STAFFORD, “M. R. W. Triumvirate,” 82; "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Am. Med. Dir.")]), _vm._v(", 1950, p. 898; SSDI; FGS by DCM; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11361–84454]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13531. Jack Paxton Aldridge, Jr. (born in Columbus, Lowndes Co., Miss., Dec. 11, 1913; attended Delta State College [1929–1930]. He began working as a salesman for the Midsouth Sporting Goods Company in 1945, and by 1952 he was an executive of the company. He became president of the Four Rivers Tackle Company in 1958, and he served as director of the Greenwood, Miss. Chamber of Commerce [1963–1964] and president of the Citizens Council of Greenwood, Miss. [1970–71]. He married in Leflore Co., Miss. [Aug. 14, 1937] Lillian Dale Pillow [born Sept. 5, 1914]. They resided in Greenwood, Leflore Co., Miss., where he died Dec. 1986).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23984. Jack Paxton Aldridge III.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23985. Walter Pillow Aldridge (born 1942; resided in Roanoke, Va.).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23986. John Baker Aldridge (born 1948; married Marie ___, and they resided in Greenwood, Miss.). ["), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Who’s Who F&I")]), _vm._v(", 1975–1976, which gives the year of marriage as 1936; SSDI; MissMI; FGS by Sue Foote Aldridge in J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("GSU ")]), _vm._v("#6; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11361–84471]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13533. Lucy Paxton Aldridge (born in Arcola, Washington Co., Miss., July 4, 1917; married in Cleveland, Bolivar Co., Miss. [Jan. 15, 1942] Michael Hammond Carter [born Nov. 26, 1919; last resided in Greenwood, Leflore Co., Miss., where he died Aug. 14, 2003]. They resided in Greenwood, Miss.).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23987. Michael Hammond Carter, Jr.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23988. Kirk Paxton Carter (born 1945; married Paula Whiting).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23989. Alan Walker Carter. [SSDI; FGS by DCM; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11361–84473]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13536. Francis William Foote, Jr. (born in Hattiesburg, Forrest Co., Miss., March 8, 1911; graduated from the U. of Va. [B.A., 1931; M.D., 1935]. An instructor at the U. of Va. [1935–1939], he was a special fellow in tumor pathology at the National Cancer Institute [1939–1940]. He then became attending pathologist and consulting pathologist at Memorial Hospital [New York City], Valley Hospital [Ridgewood, N.J.] and St. Johns Riverside Hospital [Yonkers, N.Y.]. He next was associate pathologist [1954–1959] and subsequently chairman of the Department of Pathology at Cornell U. Medical School’s Sloan-Kettering division in New York City. A prominent cancer researcher, he was the co-author of two major medical books, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Tumors of the Major Salivary Glands")]), _vm._v(" [1954] and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Seminar on Diseases of the Maxillo-Facial Region")]), _vm._v(" [1961]. He married [Feb. 14, 1936] Margaret Bernardene Johnson [born Oct. 27, 1914; died June 7, 1983]. After his retirement from Sloan-Kettering in July 1972, he resided in Sarasota, Sarasota Co., Fla., and he died March 4, 1989).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23990. Frank Foote.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23991. Caroline Yates Foote.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23992. Emilie (or “Emelie”) Clemens Foote. [J. B. LLOYD, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Miss. Authors")]), _vm._v(", 173; J. TYSON, “Hist. Notes,” 283–285; "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Dir. Med. Spec")]), _vm._v("., 12:1076; FGS by DCM; J.A.W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Outline")]), _vm._v(", 11361–84512]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13537. Marie Lovett Foote (born in Brewton, Escambia Co., Ala. Nov. 29, 1926; raised in Mobile, Mobile Co., Ala., she graduated from Duke U. [M.S., Electric Engineering, magna cum laude, 1946]. She was one of the first two women to receive an engineering degree from Duke. After her graduation, she worked in New York City as the editorial assistant on the staff of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Electrical Engineering")]), _vm._v(", the monthly magazine of the American Institute of Electrical Engineers. She married [1948] Kermit Dean Reel [born Feb. 27, 1923; graduated from USMA, West Point (1947), and he served as an artillery officer in Germany, Korea, and Vietnam. He was awarded the Legion of Merit on June 18, 1969, for his valor in Vietnam. Retiring at the rank of Colonel in 1974, he served for many years on the Virginia Game and Inland Fisheries Commission. He died in Richmond, Va., Feb. 16, 2011, and he was buried at Arlington National Cemetery].")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Although a devoted mother and frequently uprooted by her husband’s military career, she managed to remain active in her chosen field of engineering. Among other responsibilities, she was an instructor of Electrical Engineering at Texas A&M U. and a specifications writer for the Atlantic Research Corp., working on in-space propulsion as part of NASA’s Mercury program. A lay leader of her local Methodist church, she last resided in Raleigh, Wake Co., N.C., and she died April 20, 2006).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23993. Thomas R. Reel (predeceased his mother).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23994. Martha Jeanne Reel. ["), _c('a', {
    attrs: {
      "href": "http://Anc.com",
      "target": "_blank"
    }
  }, [_vm._v("Anc.com")]), _vm._v("/Vietnam War, Awards and Decorations; obit. of Marie F. Reel in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The (Durham, N.C.) Herald-Sun")]), _vm._v(", 4/25/2006; SSDI; obit. of Kermit D. Reel posted on usma1947.westpointaog; FGS by DCM]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13538. Katherine Foote (born in Miss., ca. 1919; married Robert Burdette Ireland).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23995. Robert Burdette Ireland, Jr.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("23996. Tom Ireland (married [1978] Jan Stone).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23997. Selby Allen Ireland. [J. TYSON, “Hist. Notes,” 282; 1930 census Forrest Co., Miss., E.D. 2, p. 21A; FGS by AMF and DCM]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13539. Ashby Minor Foote, Jr. (born in Miss., Sept. 26, 1924; enlisted in the Army, Dec. 1942, while a student at Marion Military Institute. After completing basic training at Fort Benning, he studied engineering at St. John’s U., N.Y., Nov. 1943 to March 1944, and he was briefly assigned to Co. A, 391"), _c('sup', [_vm._v("st")]), _vm._v(" Inf., 75"), _c('sup', [_vm._v("th")]), _vm._v(" Inf. Div., USA. He was honorably discharged June 1944 for the purpose of entering the USMA, West Point, where he graduated 1948. Completing Field Artillery School at Fort Sill, he went on to serve as battery officer and battalion staff officer with the 33"), _c('sup', [_vm._v("rd")]), _vm._v(" Field Artillery Battalion, 1"), _c('sup', [_vm._v("st")]), _vm._v(" Inf. Division, July 1949 to July 1952. He was stationed at Fort Bliss as a student, battery commander, and staff officer [1952–1955]. After completing the Advanced Field Artillery Officers course, he taught in the Field Artillery School, and he was aide-de-camp to the commanding general [1955–1959].")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Next serving at Fort McPherson [1959–1960] and in Korea [1960–1961], he completed the Command General Staff course at Fort Leavenworth and taught at the USMA, West Point [1961–1965]. He next served in Germany first as a commander of Hawk [missile] artillery battalion and later on the joint staff of the 4"), _c('sup', [_vm._v("th")]), _vm._v(" Allied Tactical Air Force [1965–1968]. Following a tour of duty in Vietnam as an advisor to the South Vietnamese army [July 1968 to July 1969], he was staff officer at the Army Air Defense Command in Colorado Springs, Colo. [1969–1970]. His last assignments were as commander of the 35"), _c('sup', [_vm._v("th")]), _vm._v(" Air Defense Artillery Brigade at Fort Meade, staff officer at the Pentagon, and chief-of-staff of the Army Air Defense Center at Fort Bliss [1970–1978]. He also graduated from Army War College, 1973. His decorations included the Legion of Merit with two Oak Leaf Clusters.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("After his retirement from the Army as Colonel on July 1, 1978, he was assistant vice-president, senior vice-president, and branch manager of the Texas National Bank in El Paso [1978–1990]. He also served on the board of directors of St. Clemente Episcopal School [1984–1986]. He married [April 16, 1949] Marian Helen Skaggs [born May 28, 1929; graduated from Kansas State U., 1949]. He generously contributed information on his branch of the Foote family to this project).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23998. Ashby Minor Foote III.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+23999. Marian Katherine Foote.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("24000. Taylor Marshall Foote (born April 19, 1965). [FGS by AMF]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13542. Anderson Marshall Foote, Jr. (born in Hattiesburg, Forrest Co., Miss., July 20, 1920; as a boy, he moved with his family to Holopaw, Osceola Co., Fla., and later Jacksonville, Fla. A WW II veteran, he enlisted at Camp Blanding, Fla., Aug. 25, 1942. He was stationed in Louisiana as a Supply Sgt. After his honorable discharge, he graduated from Davidson College and U. of Fla. [J.D.]. He then returned to Jacksonville, Fla., where he worked for two law firms before establishing his own practice in 1971. He married in Duval Co., Fla. [July 1956] Joan Marie Woodberry [born 1932; she previously worked as a flight attendant]. He died in Fernandina Beach, Nassau Co., Fla., June 27, 2011).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("24001. Anderson Marshall Foote III (married Gaye ___, and he resided in Fernandina Beach, Fla.).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("24002. Elizabeth Foote (married Thomas Morris, and they resided in Cumming, Forsyth Co., Ga. They had four children: Thomas Morris, John Morris, Mary Morris, and Calvin Morris).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("24003. David Foote (married Gail ___, and they resided in Minneapolis, Hennepin Co., Minn.).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("24004. Laura E. Foote (resided in Savannah, Chatham Co., Ga.). [WW II AER; FlaMI; USPRI; obit. of Anderson M. Foote, Jr. in the Fernandina Beach (Fla.) "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("News Leader")]), _vm._v(", 7/4/2011; "), _c('a', {
    attrs: {
      "href": "http://Anc.com",
      "target": "_blank"
    }
  }, [_vm._v("Anc.com")]), _vm._v("/AWT; FGS by MFD]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13543. Laura Norrell Foote (born in Miss., Feb. 17, 1922; married [1942] Edmund Deberry Covington [attended the U. of Fla., and he served as Colonel, USA]).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("24005. William Deberry Covington (born in El Paso Co., Tex., March 12, 1943).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("24006. Susan Covington.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("24007. Rebecca Covington.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("24008. Katherine Covington.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("24009. Cynthia Covington.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("24010. Laura Covington. [TexBI; "), _c('a', {
    attrs: {
      "href": "http://Anc.com",
      "target": "_blank"
    }
  }, [_vm._v("Anc.com")]), _vm._v("/AWT; FGS by MFD]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13544. William Enoch Foote (born in Fla., March 5, 1926; a paratrooper [1944–1946], he fought in Battle of the Bulge. He attended Davidson College and the U. of Fla., and he was vice-president of Barnett Bank. He married [Aug. 30, 19___] Frances Mizelle [attended Jacksonville U.]. He died in Duval Co., Fla., Aug. 11, 1998).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("24011. William Foote.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("24012. Carol Foote. [FlaDI; "), _c('a', {
    attrs: {
      "href": "http://Anc.com",
      "target": "_blank"
    }
  }, [_vm._v("Anc.com")]), _vm._v("/AWT; FGS by MFD]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13545. Margaret Mercer Foote (born in Fla., June 4, 1928; graduated from Fla. State U. [B.S., 1950]. She married in Duval Co., Fla. [April 10, 1954] Ensor Rubidge Dunsford, Jr. [born May 25, 1923; graduated from the U. of the South (B.S., 1945), Vanderbilt (M.D., 1948), and Ohio State U. (M.M.Sc., 1956). He was an active alumnus of U. of the South and chairman of his Class of 1945 Gift Fund]).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("Children:")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("24013. James Hartley Dunsford (born 1955; married in Clay Co., Fla. [April 13, 1985] Janice Nadine Stokes).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("24014. Ann Ashby Dunsford (born 1957).")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent"
  }, [_vm._v("+24015. John Ensor Dunsford.")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndent1"
  }, [_vm._v("24016. Margaret Cheek Dunsford (born 1962). [FlaMI; "), _c('a', {
    attrs: {
      "href": "http://Anc.com",
      "target": "_blank"
    }
  }, [_vm._v("Anc.com")]), _vm._v("/AWT; "), _c('a', {
    attrs: {
      "href": "http://www.sewaneeonline.com",
      "target": "_blank"
    }
  }, [_vm._v("www.sewaneeonline.com")]), _vm._v("; FGS by MFD]")]), _vm._v(" "), _c('p', {
    staticClass: "NoIndentTop"
  }, [_vm._v("13546. Shelby Dade Foote, Jr. (born in Greenville, Washington Co., Miss., Nov. 17, 1916; an only child, at age five he lost his father and was raised by his mother, mainly in Greenville, Miss., the Delta region of the state. His literary interests were fostered from an early age by a family friend, William Alexander Percy, lawyer, planter, and author of four books of poetry in addition to his autobiography, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Lantern on the Levee")]), _vm._v(". Precocious but a notoriously mischievous prankster as a youth, Shelby first began to develop a love of literature when he read "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("David Copperfield")]), _vm._v(" at the age of twelve. Later “Uncle Will” Percy urged him to read Proust, and Shelby’s mother obligingly gave him a set of Proust’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Remembrance of Things Past")]), _vm._v(". Soon his appetite for reading knew no bounds. He edited his high school’s prize-winning newspaper, which featured his own thinly disguised, caustic satires of the principal.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Strongly encouraged by his mentor William A. Percy, young Foote as a high school senior applied for admission to the U. of North Carolina at Chapel Hill. His many pranks and lapses in deportment, however, had earned him the undying wrath of his principal. The irate Mr. Leuckenbach apparently vented his spleen in a damning letter that convinced the university to deny him admission. Disappointed but still determined, Foote went to work in the town’s sweltering U.S. Gypsum mill and hatched a plan. He calculated that the Depression would trigger some last-minute withdrawals by some financially strapped students who had been admitted to the U. of N.C. So in the fall of 1935 he hitched a ride east with a college-bound friend and showed up uninvited at Chapel Hill. Summoning all of his considerable powers of persuasion, he finally induced the astonished and initially recalcitrant officials to admit him. They insisted that he would be a non-degree-seeking “special student,” and Foote accepted this compromise.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("His short stories and reviews soon began to appear in a campus publication, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Carolina Magazine")]), _vm._v(". His first published piece was a short story about a black Delta farmer, “The Good Pilgrim: A Fury Calmed” [Nov. 1935]. Over the course of the next two years, he published eight more stories and four book reviews in the same magazine. He quickly came to view his “special student” status as a boon. Attempting to graduate from the university would mean actually attending the science, mathematics, and similar courses that he was forced to take from time to time. That was out of the question; he could not spare the time from his literature classes and curling up with books in the library. During the summer of 1936, he resumed his exhausting job at the U.S. Gypsum Company in Greenville for thirty-two cents an hour, and he also “enjoyed dances and helling around the Delta”—experiences which later provided grist for his novels.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("He withdrew from the U. of North Carolina in 1937 to take a job in his hometown Greenville, Miss., with Hodding Carter II’s newspaper, the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Delta Democrat Times")]), _vm._v(". To earn extra money, he worked on the construction crew that built the bridge across the Mississippi River at Greenville. Meanwhile, he completed his first novel, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Tournament")]), _vm._v(", which he submitted unsuccessfully to William A. Percy’s publisher, Alfred A. Knopf.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("With war clouds looming, literary affairs now took a back seat to military. Joining the National Guard as a private in Oct. 1939, he soon impressed his superiors with his keen intelligence and was promoted to sergeant by the summer of 1940. Foote entered active service in November 1940 and was assigned to Battery A, 114"), _c('sup', [_vm._v("th")]), _vm._v(" Field Artillery. His performance in training exercises was so impressive that he was soon sent to Officers Candidate School at Fort Sill, Okla. By the end of 1942, he had been promoted to captain of Battery A, 50"), _c('sup', [_vm._v("th")]), _vm._v(" Field Artillery, 5"), _c('sup', [_vm._v("th")]), _vm._v(" Inf. Division. He sailed with his unit for Europe in the summer of 1943, and he was soon stationed in Northern Ireland, about 50 miles from Belfast.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("On one of his leaves, he met and fell in love with Tess Lavery, whose home was just outside the 50-mile visitation limit prescribed by Army regulations. Foote used the common practice of listing the object of his frequent visits as 48 miles away. This was a natural stratagem since other units of the division were stationed a little closer to Belfast, just inside the limit. Foote’s activities were subjected to careful scrutiny in the spring of 1944, however, after he had a public argument with his superior officer, a lieutenant colonel. When the officer unfairly called a soldier a liar, Foote called on him to apologize. This led to an impasse which Foote eventually won by going over the officer’s head and appealing to the commanding colonel. Foote won his case but also the lieutenant colonel’s wrath. Obsessed with revenge [as Foote later told the story], the officer had Foote put under surveillance during his leaves and discovered his infraction. When Foote logged his trip to Belfast as 48 miles, he was arrested and charged with falsifying an official government record. After a court-martial he was dismissed with a “dishonorable discharge” from the Army—“a real con job!” as he later described it. It was a bitter disappointment: he had prepared for combat for nearly five years, and his unit was scheduled to join the Normandy invasion in just a few weeks.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("He sailed for the States aboard the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Mauretania")]), _vm._v(" in August 1944. Ashamed to show his face back home in Greenville, he lingered for a while in New York City and found a job writing for the Associated Press. He arranged for Tess Lavery to meet him in the city in October 1944, and a few days later they were married at the Church of the Transfiguration. He had been attempting for some time to enlist in the Marines, but his “dishonorable discharge” blocked all efforts. With the help of some influential friends, Foote finally succeeded in reducing it to “less than honorable discharge.” This did the trick, and a few days after his wedding he learned that the Marine Corps had finally accepted him. In January 1945, he reported for basic training at Parris Island, S.C. Tess followed him and moved into an off-base trailer. He received a lukewarm welcome: “We hear you were a captain in the Army; you might make a pretty good private in the Marines.” After completing boot camp, he went to Combat Intelligence School at Camp Lejeune, N.C. He was then assigned to a unit slated for combat in the Pacific, but the war ended while he was waiting to be shipped out.")])])])])
}]}

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(83),
  /* template */
  __webpack_require__(84),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 84 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(86),
  /* template */
  __webpack_require__(87),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 87 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(89),
  /* template */
  __webpack_require__(90),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 90 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(92),
  /* template */
  __webpack_require__(93),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 93 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(95),
  /* template */
  __webpack_require__(96),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 96 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(98),
  /* template */
  __webpack_require__(99),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 99 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(101),
  /* template */
  __webpack_require__(102),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 102 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(104),
  /* template */
  __webpack_require__(105),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 105 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', [_vm._v("Thank you for reading this sample. Here are other books you might like.")]), _c('div', [_c('div', {
    attrs: {
      "id": "textcafe-gallery-widget-container"
    }
  }), _vm._v(" "), _c('script', {
    attrs: {
      "type": "application/javascript"
    }
  }, [_vm._v("\n      TextCafeWidget.config({\n          'type':'related',\n          'id':'9781940669311',\n          'coverImageWidth': '30',\n          'hideDescriptions': true\n      });\n      var textCafeGalleryWidget = TextCafeWidget.widgets.galleryWidget.new({selector:'#textcafe-gallery-widget-container'});\n      textCafeGalleryWidget.render();\n    ")])])])
}]}

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["Vuetify"] = factory();
	else
		root["Vuetify"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 29);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = createSimpleFunctional;
/* harmony export (immutable) */ __webpack_exports__["e"] = createSimpleTransition;
/* harmony export (immutable) */ __webpack_exports__["b"] = createJavaScriptTransition;
/* harmony export (immutable) */ __webpack_exports__["f"] = directiveConfig;
/* harmony export (immutable) */ __webpack_exports__["a"] = addOnceEventListener;
/* harmony export (immutable) */ __webpack_exports__["g"] = getObjectValueByPath;
/* harmony export (immutable) */ __webpack_exports__["c"] = createRange;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function createSimpleFunctional(c) {
  var el = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'div';

  return {
    functional: true,

    render: function render(h, _ref) {
      var data = _ref.data,
          children = _ref.children;

      data.staticClass = (c + ' ' + (data.staticClass || '')).trim();

      return h(el, data, children);
    }
  };
}

function createSimpleTransition(name) {
  var origin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top center 0';
  var mode = arguments[2];

  return {
    functional: true,

    props: {
      origin: {
        type: String,
        default: origin
      }
    },

    render: function render(h, context) {
      context.data = context.data || {};
      context.data.props = { name: name };
      context.data.on = context.data.on || {};

      if (mode) context.data.props.mode = mode;

      context.data.on.beforeEnter = function (el) {
        el.style.transformOrigin = origin;
        el.style.webkitTransformOrigin = origin;
      };

      return h('transition', context.data, context.children);
    }
  };
}

function createJavaScriptTransition(name, functions) {
  var css = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var mode = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'in-out';

  return {
    functional: true,

    props: {
      css: {
        type: Boolean,
        default: css
      },
      mode: {
        type: String,
        default: mode
      }
    },

    render: function render(h, context) {
      var data = {
        props: _extends({}, context.props, {
          name: name
        }),
        on: functions
      };

      return h('transition', data, context.children);
    }
  };
}

function directiveConfig(binding) {
  var defaults = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return Object.assign({}, defaults, binding.modifiers, { value: binding.arg }, binding.value || {});
}

function addOnceEventListener(el, event, cb) {
  var once = function once() {
    cb();
    el.removeEventListener(event, once, false);
  };

  el.addEventListener(event, once, false);
}

function getObjectValueByPath(obj, path) {
  // credit: http://stackoverflow.com/questions/6491463/accessing-nested-javascript-objects-with-string-key#comment55278413_6491621
  if (!path || path.constructor !== String) return;
  path = path.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
  path = path.replace(/^\./, ''); // strip a leading dot
  var a = path.split('.');
  for (var i = 0, n = a.length; i < n; ++i) {
    var k = a[i];
    if (obj instanceof Object && k in obj) {
      obj = obj[k];
    } else {
      return;
    }
  }
  return obj;
}

function createRange(length) {
  return [].concat(_toConsumableArray(Array.from({ length: length }, function (v, k) {
    return k;
  })));
}

/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    dark: Boolean,
    light: Boolean
  }
});

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isActive: !!this.value
    };
  },


  props: {
    value: {
      required: false
    }
  },

  watch: {
    value: function value(val) {
      this.isActive = !!val;
    },
    isActive: function isActive(val) {
      !!val !== this.value && this.$emit('input', val);
    }
  }
});

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_contextualable__ = __webpack_require__(8);



/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_contextualable__["a" /* default */]],

  props: {
    disabled: Boolean,
    fa: Boolean,
    mdi: Boolean,
    large: Boolean,
    left: Boolean,
    medium: Boolean,
    right: Boolean,
    xLarge: Boolean
  },

  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        _ref$children = _ref.children,
        children = _ref$children === undefined ? [] : _ref$children;

    if (props.fa || props.mdi) console.warn('The v-icon prop \'fa\' and \'mdi\' will be deprecated in the next release. Use \'fa\' or \'mdi\' prefix in icon name instead.');
    var iconName = '';
    var iconType = 'material-icons';

    if (children.length) {
      iconName = children.pop().text;
    } else if (data.domProps && data.domProps.textContent) {
      iconName = data.domProps.textContent;
      delete data.domProps.textContent;
    } else if (data.domProps && data.domProps.innerHTML) {
      iconName = data.domProps.innerHTML;
      delete data.domProps.innerHTML;
    }

    var thirdPartyIcon = iconName.indexOf('-') > -1;
    if (thirdPartyIcon) iconType = iconName.slice(0, iconName.indexOf('-'));

    // To keep things backwards compatible for now
    iconType = props.fa ? 'fa' : props.mdi ? 'mdi' : iconType;

    data.staticClass = (iconType + ' icon ' + (data.staticClass || '')).trim();
    data.attrs = data.attrs || {};

    var classes = {
      'icon--large': props.large,
      'icon--left': props.left,
      'icon--medium': props.medium,
      'icon--right': props.right,
      'icon--x-large': props.xLarge,
      'primary--text': props.primary,
      'secondary--text': props.secondary,
      'success--text': props.success,
      'info--text': props.info,
      'warning--text': props.warning,
      'error--text': props.error,
      'theme--dark': props.dark,
      'theme--light': props.light
    };

    var iconClasses = Object.keys(classes).filter(function (k) {
      return classes[k];
    }).join(' ');
    iconClasses && (data.staticClass += ' ' + iconClasses);

    // To keep things backwards compatible for now
    if (props.fa || props.mdi) {
      var comparison = props.fa ? 'fa' : 'mdi';

      if (iconName.indexOf(' ') > -1) data.staticClass += ' ' + comparison + '-' + iconName;else data.staticClass += ' ' + comparison + '-' + iconName.split(' ').join('-');
    }

    if (thirdPartyIcon) data.staticClass += ' ' + iconName;
    if (props.disabled) data.attrs.disabled = props.disabled;
    !(thirdPartyIcon || props.fa || props.mdi) && children.push(iconName);

    return h('i', data, children);
  }
});

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__badge__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__click_outside__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__resize__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ripple__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__scroll__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__tooltip__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__touch__ = __webpack_require__(81);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Badge", function() { return __WEBPACK_IMPORTED_MODULE_0__badge__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ClickOutside", function() { return __WEBPACK_IMPORTED_MODULE_1__click_outside__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Ripple", function() { return __WEBPACK_IMPORTED_MODULE_3__ripple__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Resize", function() { return __WEBPACK_IMPORTED_MODULE_2__resize__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Scroll", function() { return __WEBPACK_IMPORTED_MODULE_4__scroll__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Tooltip", function() { return __WEBPACK_IMPORTED_MODULE_5__tooltip__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Touch", function() { return __WEBPACK_IMPORTED_MODULE_6__touch__["a"]; });










/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_positionable__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_route_link__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_toggleable__ = __webpack_require__(2);






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-btn',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_route_link__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_positionable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_toggleable__["a" /* default */]],

  props: {
    activeClass: {
      type: String,
      default: 'btn--active'
    },
    block: Boolean,
    fab: Boolean,
    flat: Boolean,
    icon: Boolean,
    large: Boolean,
    loading: Boolean,
    outline: Boolean,
    ripple: {
      type: [Boolean, Object],
      default: true
    },
    round: Boolean,
    small: Boolean,
    tag: {
      type: String,
      default: 'button'
    },
    type: {
      type: String,
      default: 'button'
    }
  },

  computed: {
    classes: function classes() {
      return {
        'btn': true,
        'btn--absolute': this.absolute,
        'btn--active': this.isActive,
        'btn--block': this.block,
        'btn--bottom': this.bottom,
        'btn--disabled': this.disabled,
        'btn--flat': this.flat,
        'btn--floating': this.fab,
        'btn--fixed': this.fixed,
        'btn--hover': this.hover,
        'btn--icon': this.icon,
        'btn--large': this.large,
        'btn--left': this.left,
        'btn--loader': this.loading,
        'btn--outline': this.outline,
        'btn--raised': !this.flat,
        'btn--right': this.right,
        'btn--round': this.round,
        'btn--small': this.small,
        'btn--top': this.top,
        'theme--dark': this.dark,
        'theme--light': this.light,
        'primary': this.primary && !this.outline,
        'secondary': this.secondary && !this.outline,
        'success': this.success && !this.outline,
        'info': this.info && !this.outline,
        'warning': this.warning && !this.outline,
        'error': this.error && !this.outline,
        'primary--text': this.primary && (this.outline || this.flat),
        'secondary--text': this.secondary && (this.outline || this.flat),
        'success--text': this.success && (this.outline || this.flat),
        'info--text': this.info && (this.outline || this.flat),
        'warning--text': this.warning && (this.outline || this.flat),
        'error--text': this.error && (this.outline || this.flat)
      };
    }
  },

  methods: {
    // Prevent focus to match md spec
    click: function click(e) {
      !this.fab && e.detail && this.$el.blur();

      this.$emit('click', e);
    },
    genContent: function genContent() {
      return this.$createElement('div', { 'class': 'btn__content' }, [this.$slots.default]);
    },
    genLoader: function genLoader() {
      var children = [];

      if (!this.$slots.loader) {
        children.push(this.$createElement('v-progress-circular', {
          props: {
            indeterminate: true,
            size: 26
          }
        }));
      } else {
        children.push(this.$slots.loader);
      }

      return this.$createElement('span', { 'class': 'btn__loading' }, children);
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    var children = [this.genContent()];

    tag === 'button' && (data.attrs.type = this.type);
    this.loading && children.push(this.genLoader());

    return h(tag, data, children);
  }
});

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VCarouselTransition */
/* unused harmony export VCarouselReverseTransition */
/* unused harmony export VTabTransition */
/* unused harmony export VTabReverseTransition */
/* unused harmony export VMenuTransition */
/* unused harmony export VFabTransition */
/* unused harmony export VDialogTransition */
/* unused harmony export VDialogBottomTransition */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return VFadeTransition; });
/* unused harmony export VScaleTransition */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return VSlideXTransition; });
/* unused harmony export VSlideXReverseTransition */
/* unused harmony export VSlideYTransition */
/* unused harmony export VSlideYReverseTransition */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VExpandTransition; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__expand_transition__ = __webpack_require__(71);




// Component specific transitions
var VCarouselTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('carousel-transition');
var VCarouselReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('carousel-reverse-transition');
var VTabTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('tab-transition');
var VTabReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('tab-reverse-transition');
var VMenuTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('menu-transition');
var VFabTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('fab-transition', 'center center', 'out-in');

// Generic transitions
var VDialogTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('dialog-transition');
var VDialogBottomTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('dialog-bottom-transition');
var VFadeTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('fade-transition');
var VScaleTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('scale-transition');
var VSlideXTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-x-transition');
var VSlideXReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-x-reverse-transition');
var VSlideYTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-y-transition');
var VSlideYReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-y-reverse-transition');

// JavaScript transitions
var VExpandTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["b" /* createJavaScriptTransition */])('expand-transition', __WEBPACK_IMPORTED_MODULE_1__expand_transition__["a" /* default */]);

/* harmony default export */ __webpack_exports__["d"] = ({
  VCarouselTransition: VCarouselTransition,
  VCarouselReverseTransition: VCarouselReverseTransition,
  VDialogTransition: VDialogTransition,
  VDialogBottomTransition: VDialogBottomTransition,
  VFabTransition: VFabTransition,
  VFadeTransition: VFadeTransition,
  VMenuTransition: VMenuTransition,
  VScaleTransition: VScaleTransition,
  VSlideXTransition: VSlideXTransition,
  VSlideXReverseTransition: VSlideXReverseTransition,
  VSlideYTransition: VSlideYTransition,
  VSlideYReverseTransition: VSlideYReverseTransition,
  VTabReverseTransition: VTabReverseTransition,
  VTabTransition: VTabTransition,
  VExpandTransition: VExpandTransition
});

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__themeable__ = __webpack_require__(1);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__themeable__["a" /* default */]],

  data: function data() {
    return {
      errorBucket: [],
      focused: false,
      tabFocused: false,
      lazyValue: this.value
    };
  },


  props: {
    appendIcon: String,
    appendIconCb: Function,
    disabled: Boolean,
    error: Boolean,
    errorMessages: {
      type: [String, Array],
      default: function _default() {
        return [];
      }
    },
    hint: String,
    hideDetails: Boolean,
    label: String,
    persistentHint: Boolean,
    placeholder: String,
    prependIcon: String,
    prependIconCb: Function,
    required: Boolean,
    rules: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    tabindex: {
      default: 0
    },
    value: {
      required: false
    }
  },

  computed: {
    hasError: function hasError() {
      return this.validations.length || this.error;
    },
    inputGroupClasses: function inputGroupClasses() {
      return Object.assign({
        'input-group': true,
        'input-group--focused': this.focused,
        'input-group--dirty': this.isDirty,
        'input-group--tab-focused': this.tabFocused,
        'input-group--disabled': this.disabled,
        'input-group--error': this.hasError,
        'input-group--append-icon': this.appendIcon,
        'input-group--prepend-icon': this.prependIcon,
        'input-group--required': this.required,
        'input-group--hide-details': this.hideDetails,
        'input-group--placeholder': !!this.placeholder,
        'theme--dark': this.dark,
        'theme--light': this.light
      }, this.classes);
    },
    isDirty: function isDirty() {
      return this.inputValue;
    },
    modifiers: function modifiers() {
      var modifiers = {
        lazy: false,
        number: false,
        trim: false
      };

      if (!this.$vnode.data.directives) {
        return modifiers;
      }

      var model = this.$vnode.data.directives.find(function (i) {
        return i.name === 'model';
      });

      if (!model) {
        return modifiers;
      }

      return Object.assign(modifiers, model.modifiers);
    },
    validations: function validations() {
      return (!Array.isArray(this.errorMessages) ? [this.errorMessages] : this.errorMessages).concat(this.errorBucket);
    }
  },

  watch: {
    rules: function rules() {
      this.validate();
    }
  },

  mounted: function mounted() {
    this.validate();
  },


  methods: {
    genLabel: function genLabel() {
      return this.$createElement('label', {
        attrs: {
          for: this.$attrs.id
        }
      }, this.$slots.label || this.label);
    },
    genMessages: function genMessages() {
      var _this = this;

      var messages = [];

      if ((this.hint && this.focused || this.hint && this.persistentHint) && this.validations.length === 0) {
        messages = [this.genHint()];
      } else if (this.validations.length) {
        messages = this.validations.map(function (i) {
          return _this.genError(i);
        });
      }

      return this.$createElement('transition-group', {
        'class': 'input-group__messages',
        props: {
          tag: 'div',
          name: 'slide-y-transition'
        }
      }, messages);
    },
    genHint: function genHint() {
      return this.$createElement('div', {
        'class': 'input-group__hint',
        key: this.hint,
        domProps: { innerHTML: this.hint }
      });
    },
    genError: function genError(error) {
      return this.$createElement('div', {
        'class': 'input-group__error',
        key: error
      }, error);
    },
    genIcon: function genIcon(type) {
      var _class;

      var icon = this[type + 'Icon'];
      var cb = this[type + 'IconCb'];
      var hasCallback = typeof cb === 'function';

      return this.$createElement('v-icon', {
        'class': (_class = {}, _defineProperty(_class, 'input-group__' + type + '-icon', true), _defineProperty(_class, 'input-group__icon-cb', hasCallback), _class),
        on: {
          click: function click(e) {
            hasCallback && cb(e);
          }
        }
      }, icon);
    },
    genInputGroup: function genInputGroup(input) {
      var _this2 = this;

      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var children = [];
      var wrapperChildren = [];
      var detailsChildren = [];

      data = Object.assign({}, {
        'class': this.inputGroupClasses,
        attrs: {
          tabindex: this.tabindex
        },
        on: {
          blur: function blur() {
            return _this2.tabFocused = false;
          },
          click: function click() {
            return _this2.tabFocused = false;
          },
          keyup: function keyup(e) {
            if ([9, 16].includes(e.keyCode)) {
              _this2.tabFocused = true;
            }
          },
          keydown: function keydown(e) {
            if (!_this2.toggle) return;

            if ([13, 32].includes(e.keyCode)) {
              e.preventDefault();
              _this2.toggle();
            }
          }
        }
      }, data);

      if (this.$slots.label || this.label) {
        children.push(this.genLabel());
      }

      wrapperChildren.push(input);

      if (this.prependIcon) {
        wrapperChildren.unshift(this.genIcon('prepend'));
      }

      if (this.appendIcon) {
        wrapperChildren.push(this.genIcon('append'));
      }

      children.push(this.$createElement('div', {
        'class': 'input-group__input'
      }, wrapperChildren));

      detailsChildren.push(this.genMessages());
      this.counter && detailsChildren.push(this.genCounter());

      children.push(this.$createElement('div', {
        'class': 'input-group__details'
      }, detailsChildren));

      return this.$createElement('div', data, children);
    },
    validate: function validate() {
      var _this3 = this;

      this.errorBucket = [];

      this.rules.forEach(function (rule) {
        var valid = typeof rule === 'function' ? rule(_this3.value) : rule;

        if (valid !== true) {
          _this3.errorBucket.push(valid);
        }
      });
    }
  }
});

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    primary: Boolean,
    secondary: Boolean,
    success: Boolean,
    info: Boolean,
    warning: Boolean,
    error: Boolean
  }
});

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    append: Boolean,
    disabled: Boolean,
    exact: Boolean,
    href: [String, Object],
    to: [String, Object],
    nuxt: Boolean,
    replace: Boolean,
    router: Boolean,
    ripple: {
      type: Boolean,
      default: true
    },
    tag: String
  },

  methods: {
    click: function click() {},
    generateRouteLink: function generateRouteLink() {
      var exact = this.exact;
      var tag = void 0;

      var data = {
        attrs: { disabled: this.disabled },
        class: this.classes,
        props: {},
        directives: [{
          name: 'ripple',
          value: this.ripple || false
        }],
        on: Object.assign({
          click: this.click
        }, this.$listeners || {})
      };

      if (typeof this.exact === 'undefined') {
        exact = this.to === '/' || this.to === Object(this.to) && this.to.path === '/';
      }

      if (this.to) {
        tag = this.nuxt ? 'nuxt-link' : 'router-link';
        data.props.to = this.to;
        data.props.exact = exact;
        data.props.activeClass = this.activeClass;
        data.props.append = this.append;
        data.props.replace = this.replace;
      } else {
        tag = this.href && 'a' || this.tag || 'a';

        if (tag === 'a') {
          data.attrs.href = this.href || 'javascript:;';
        }
      }

      return { tag: tag, data: data };
    }
  }
});

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isBooted: false
    };
  },


  watch: {
    isActive: function isActive() {
      this.isBooted = true;
    }
  },

  methods: {
    showLazyContent: function showLazyContent(content) {
      return this.lazy && this.isBooted || !this.lazy ? content : null;
    }
  }
});

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VListTileActionText */
/* unused harmony export VListTileAvatar */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VListTileContent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return VListTileTitle; });
/* unused harmony export VListTileSubTitle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VList__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VListGroup__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VListTile__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__VListTileAction__ = __webpack_require__(21);







var VListTileActionText = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__action-text', 'span');
var VListTileAvatar = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__avatar', 'v-avatar');
var VListTileContent = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__content', 'div');
var VListTileTitle = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__title', 'div');
var VListTileSubTitle = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__sub-title', 'div');

/* harmony default export */ __webpack_exports__["c"] = ({
  VList: __WEBPACK_IMPORTED_MODULE_1__VList__["a" /* default */],
  VListTile: __WEBPACK_IMPORTED_MODULE_3__VListTile__["a" /* default */],
  VListGroup: __WEBPACK_IMPORTED_MODULE_2__VListGroup__["a" /* default */],
  VListTileAction: __WEBPACK_IMPORTED_MODULE_4__VListTileAction__["a" /* default */],
  VListTileActionText: VListTileActionText,
  VListTileAvatar: VListTileAvatar,
  VListTileContent: VListTileContent,
  VListTileTitle: VListTileTitle,
  VListTileSubTitle: VListTileSubTitle
});

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    absolute: Boolean,
    bottom: Boolean,
    fixed: Boolean,
    left: Boolean,
    right: Boolean,
    top: Boolean
  }
});

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    flat: Boolean,
    height: {
      type: String,
      default: 'auto'
    },
    hover: Boolean,
    img: String,
    raised: Boolean,
    tile: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('card ' + (data.staticClass || '')).trim();
    data.style = data.style || {};
    data.style.height = props.height;

    if (props.dark) data.staticClass += ' theme--dark';
    if (props.flat) data.staticClass += ' card--flat';
    if (props.horizontal) data.staticClass += ' card--horizontal';
    if (props.hover) data.staticClass += ' card--hover';
    if (props.light) data.staticClass += ' theme--light';
    if (props.raised) data.staticClass += ' card--raised';
    if (props.tile) data.staticClass += ' card--tile';

    if (props.img) {
      data.style.background = 'url(' + props.img + ') center center / cover no-repeat';
    }

    return h('div', data, children);
  }
});

/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isSaving: false
    };
  },


  props: {
    actions: Boolean,
    autosave: Boolean,
    landscape: Boolean,
    noTitle: Boolean,
    scrollable: Boolean,
    value: {
      required: true
    },
    light: {
      type: Boolean,
      default: true
    },
    dark: Boolean
  },

  methods: {
    save: function save() {},
    cancel: function cancel() {},
    genSlot: function genSlot() {
      return this.$scopedSlots.default({
        save: this.save,
        cancel: this.cancel
      });
    }
  }
});

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    contentClass: {
      default: ''
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.$vuetify.load(function () {
      if (_this._isDestroyed) return;

      var app = document.querySelector('[data-app]');

      if (!app) {
        return console.warn('Application is missing <v-app> component.');
      }

      app.insertBefore(_this.$refs.content, app.firstChild);
    });
  },
  beforeDestroy: function beforeDestroy() {
    if (!this.$refs.content) return;

    // IE11 Fix
    try {
      this.$refs.content.parentNode.removeChild(this.$refs.content);
    } catch (e) {}
  }
});

/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      overlay: null,
      overlayOffset: 0,
      overlayTransitionDuration: 500
    };
  },


  props: {
    hideOverlay: Boolean
  },

  beforeDestroy: function beforeDestroy() {
    this.removeOverlay();
  },


  methods: {
    genOverlay: function genOverlay() {
      var _this = this;

      if (!this.isActive || this.hideOverlay || this.isActive && this.overlay) return;

      this.overlay = document.createElement('div');
      this.overlay.className = 'overlay';
      this.overlay.onclick = function () {
        if (_this.permanent) return;else if (!_this.persistent) _this.isActive = false;else if (_this.isMobile) _this.isActive = false;
      };

      if (this.absolute) this.overlay.className += ' overlay--absolute';

      this.hideScroll();

      if (this.absolute) {
        // Required for IE11
        var parent = this.$el.parentNode;
        parent.insertBefore(this.overlay, parent.firstChild);
      } else {
        document.querySelector('[data-app]').appendChild(this.overlay);
      }

      this.overlay.clientHeight; // Force repaint
      requestAnimationFrame(function () {
        _this.overlay.className += ' overlay--active';
      });

      return true;
    },
    removeOverlay: function removeOverlay() {
      var _this2 = this;

      if (!this.overlay) {
        return this.showScroll();
      }

      this.overlay.classList.remove('overlay--active');

      setTimeout(function () {
        // IE11 Fix
        try {
          _this2.overlay.parentNode.removeChild(_this2.overlay);
          _this2.overlay = null;
          _this2.showScroll();
        } catch (e) {}
      }, this.overlayTransitionDuration);
    },
    hideScroll: function hideScroll() {
      // Check documentElement first for IE11
      // this.overlayOffset = document.documentElement &&
      //   document.documentElement.scrollTop ||
      //   document.body.scrollTop

      // document.body.style.top = `-${this.overlayOffset}px`
      // document.body.style.position = 'fixed'
      document.documentElement.style.overflow = 'hidden';
    },
    showScroll: function showScroll() {
      document.documentElement.removeAttribute('style');

      // if (!this.overlayOffset) return
      // document.body.scrollTop = this.overlayOffset
      // document.documentElement.scrollTop = this.overlayOffset
    }
  }
});

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-list',

  provide: function provide() {
    return {
      listClick: this.listClick,
      listClose: this.listClose
    };
  },


  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      uid: null,
      groups: []
    };
  },


  props: {
    dense: Boolean,
    subheader: Boolean,
    threeLine: Boolean,
    twoLine: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'list': true,
        'list--two-line': this.twoLine,
        'list--dense': this.dense,
        'list--three-line': this.threeLine,
        'list--subheader': this.subheader,
        'theme--dark dark--bg': this.dark,
        'theme--light light--bg': this.light
      };
    }
  },

  watch: {
    uid: function uid() {
      var _this = this;

      this.$children.filter(function (i) {
        return i.$options._componentTag === 'v-list-group';
      }).forEach(function (i) {
        return i.toggle(_this.uid);
      });
    }
  },

  methods: {
    listClick: function listClick(uid, force) {
      if (force) {
        this.uid = uid;
      } else {
        this.uid = this.uid === uid ? null : uid;
      }
    },
    listClose: function listClose(uid) {
      if (this.uid === uid) {
        this.uid = null;
      }
    }
  },

  render: function render(h) {
    var data = {
      'class': this.classes,
      attrs: { 'data-uid': this._uid }
    };

    return h('ul', data, [this.$slots.default]);
  }
});

/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_route_link__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__directives__ = __webpack_require__(4);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-list-tile',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_route_link__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  directives: {
    Ripple: __WEBPACK_IMPORTED_MODULE_2__directives__["Ripple"]
  },

  inheritAttrs: false,

  props: {
    activeClass: {
      type: String,
      default: 'list__tile--active'
    },
    avatar: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'list__tile': true,
        'list__tile--avatar': this.avatar,
        'list__tile--disabled': this.disabled
      };
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    data.attrs = Object.assign({}, data.attrs, this.$attrs);

    return h('li', {
      attrs: {
        disabled: this.disabled
      }
    }, [h(tag, data, [this.$slots.default])]);
  }
});

/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function directive(e, el, binding, v) {
  var cb = function cb() {
    return true;
  };

  if (binding.value) cb = binding.value;

  if (v.context.isActive && e && e.target && e.target !== el && !el.contains(e.target) && cb(e)) {
    v.context.isActive = false;
  }
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: function bind(el, binding, v) {
    v.context.$vuetify.load(function () {
      var outside = document.querySelector('[data-app]');
      var click = function click(e) {
        return directive(e, el, binding, v);
      };
      outside.addEventListener('click', click, false);
      el._clickOutside = click;
    });
  },
  unbind: function unbind(el) {
    var outside = document.querySelector('[data-app]');
    outside && outside.removeEventListener('click', el._clickOutside, false);
  }
});

/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function style(el, value) {
  ['transform', 'webkitTransform'].forEach(function (i) {
    el.style[i] = value;
  });
}

var ripple = {
  show: function show(e, el, _ref) {
    var _ref$value = _ref.value,
        value = _ref$value === undefined ? {} : _ref$value;

    var container = document.createElement('span');
    var animation = document.createElement('span');

    container.appendChild(animation);
    container.className = 'ripple__container';

    if (value.class) {
      container.className += ' ' + value.class;
    }

    var size = el.clientWidth > el.clientHeight ? el.clientWidth : el.clientHeight;
    animation.className = 'ripple__animation';
    animation.style.width = size * (value.center ? 1 : 2) + 'px';
    animation.style.height = animation.style.width;

    el.appendChild(container);
    var computed = window.getComputedStyle(el);
    if (computed.position !== 'absolute' && computed.position !== 'fixed') el.style.position = 'relative';

    var offset = el.getBoundingClientRect();
    var x = value.center ? '50%' : e.clientX - offset.left + 'px';
    var y = value.center ? '50%' : e.clientY - offset.top + 'px';

    animation.classList.add('ripple__animation--enter');
    animation.classList.add('ripple__animation--visible');
    style(animation, 'translate(-50%, -50%) translate(' + x + ', ' + y + ') scale3d(0.01,0.01,0.01)');
    animation.dataset.activated = Date.now();

    setTimeout(function () {
      animation.classList.remove('ripple__animation--enter');
      style(animation, 'translate(-50%, -50%) translate(' + x + ', ' + y + ')  scale3d(0.99,0.99,0.99)');
    }, 0);
  },

  hide: function hide(el) {
    var ripples = el.getElementsByClassName('ripple__animation');

    if (ripples.length === 0) return;
    var animation = ripples[ripples.length - 1];
    var diff = Date.now() - Number(animation.dataset.activated);
    var delay = 400 - diff;

    delay = delay < 0 ? 0 : delay;

    setTimeout(function () {
      animation.classList.remove('ripple__animation--visible');

      setTimeout(function () {
        // Need to figure out a new way to do this
        try {
          if (ripples.length < 1) el.style.position = null;
          animation.parentNode && el.removeChild(animation.parentNode);
        } catch (e) {}
      }, 300);
    }, delay);
  }
};

function directive(el, binding, v) {
  if (binding.value === false) return;

  if ('ontouchstart' in window) {
    el.addEventListener('touchend', function () {
      return ripple.hide(el);
    }, false);
    el.addEventListener('touchcancel', function () {
      return ripple.hide(el);
    }, false);
  }

  el.addEventListener('mousedown', function (e) {
    return ripple.show(e, el, binding);
  }, false);
  el.addEventListener('mouseup', function () {
    return ripple.hide(el);
  }, false);
  el.addEventListener('mouseleave', function () {
    return ripple.hide(el);
  }, false);
}

function unbind(el, binding) {
  el.removeEventListener('touchstart', function (e) {
    return ripple.show(e, el, binding);
  }, false);
  el.removeEventListener('mousedown', function (e) {
    return ripple.show(e, el, binding);
  }, false);
  el.removeEventListener('touchend', function () {
    return ripple.hide(el);
  }, false);
  el.removeEventListener('touchcancel', function () {
    return ripple.hide(el);
  }, false);
  el.removeEventListener('mouseup', function () {
    return ripple.hide(el);
  }, false);
  el.removeEventListener('mouseleave', function () {
    return ripple.hide(el);
  }, false);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: directive,
  unbind: unbind
});

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  name: 'list-tile-action',

  render: function render(h, _ref) {
    var data = _ref.data,
        children = _ref.children;

    data.staticClass = data.staticClass ? 'list__tile__action ' + (data.staticClass || '') : 'list__tile__action';
    if ((children || []).length > 1) data.staticClass += ' list__tile__action--stack';

    return h('div', data, children);
  }
});

/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_activator__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_generators__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_position__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_utils__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_keyable__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__directives__ = __webpack_require__(4);










/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-menu',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_activator__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_generators__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__mixins_keyable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_position__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_utils__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_toggleable__["a" /* default */]],

  directives: {
    ClickOutside: __WEBPACK_IMPORTED_MODULE_7__directives__["ClickOutside"]
  },

  data: function data() {
    return {
      autoIndex: null,
      dimensions: {
        activator: {
          top: 0, left: 0,
          bottom: 0, right: 0,
          width: 0, height: 0,
          offsetTop: 0, scrollHeight: 0
        },
        content: {
          top: 0, left: 0,
          bottom: 0, right: 0,
          width: 0, height: 0,
          offsetTop: 0, scrollHeight: 0
        },
        list: null,
        selected: null
      },
      direction: { vert: 'bottom', horiz: 'right' },
      isContentActive: false,
      isBooted: false,
      maxHeightAutoDefault: '200px',
      resizeTimeout: {},
      startIndex: 3,
      stopIndex: 0,
      tileLength: 0,
      window: {},
      absoluteX: 0,
      absoluteY: 0,
      hasJustFocused: false,
      focusedTimeout: {}
    };
  },


  props: {
    top: Boolean,
    left: Boolean,
    bottom: Boolean,
    right: Boolean,
    fullWidth: Boolean,
    auto: Boolean,
    offsetX: Boolean,
    offsetY: Boolean,
    disabled: Boolean,
    maxHeight: {
      default: 'auto'
    },
    nudgeTop: {
      type: Number,
      default: 0
    },
    nudgeBottom: {
      type: Number,
      default: 0
    },
    nudgeLeft: {
      type: Number,
      default: 0
    },
    nudgeRight: {
      type: Number,
      default: 0
    },
    nudgeWidth: {
      type: Number,
      default: 0
    },
    openOnClick: {
      type: Boolean,
      default: true
    },
    openOnHover: {
      type: Boolean,
      default: false
    },
    lazy: Boolean,
    closeOnClick: {
      type: Boolean,
      default: true
    },
    closeOnContentClick: {
      type: Boolean,
      default: true
    },
    activator: {
      default: null
    },
    origin: {
      type: String,
      default: 'top left'
    },
    transition: {
      type: String,
      default: 'menu-transition'
    },
    positionX: {
      type: Number,
      default: null
    },
    positionY: {
      type: Number,
      default: null
    },
    positionAbsolutely: {
      type: Boolean,
      default: false
    },
    maxWidth: [Number, String],
    minWidth: [Number, String]
  },

  computed: {
    calculatedMinWidth: function calculatedMinWidth() {
      var minWidth = parseInt(this.minWidth) || this.dimensions.activator.width + this.nudgeWidth + (this.auto ? 16 : 0);

      if (!this.maxWidth) return minWidth;

      var maxWidth = parseInt(this.maxWidth);

      return maxWidth < minWidth ? maxWidth : minWidth;
    },
    styles: function styles() {
      return {
        maxHeight: this.auto ? '200px' : isNaN(this.maxHeight) ? this.maxHeight : this.maxHeight + 'px',
        minWidth: this.calculatedMinWidth + 'px',
        maxWidth: parseInt(this.maxWidth) + 'px',
        top: this.calcTop() + 'px',
        left: this.calcLeft() + 'px'
      };
    },
    hasActivator: function hasActivator() {
      return !!this.$slots.activator || this.activator;
    }
  },

  watch: {
    activator: function activator(newActivator, oldActivator) {
      this.removeActivatorEvents(oldActivator);
      this.addActivatorEvents(newActivator);
    },
    disabled: function disabled(val) {
      val && this.deactivate();
    },
    hasJustFocused: function hasJustFocused(val) {
      var _this = this;

      if (!val) return;

      clearTimeout(this.focusedTimeout);
      this.focusedTimeout = setTimeout(function () {
        return _this.hasJustFocused = false;
      }, 550);
    },
    isActive: function isActive(val) {
      if (this.disabled) return;

      val && this.activate() || this.deactivate();
    },
    windowResizeHandler: function windowResizeHandler() {
      this.isBooted = false;
    }
  },

  mounted: function mounted() {
    window.addEventListener('resize', this.onResize, { passive: true });
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.onResize, { passive: true });
    window.removeEventListener('resize', this.windowResizeHandler);
  },


  methods: {
    activate: function activate() {
      if (typeof window === 'undefined') return;
      this.isBooted = true;
      this.getTiles();
      this.updateDimensions();
      requestAnimationFrame(this.startTransition);
      this.$emit('activate');
    },
    deactivate: function deactivate() {
      this.isContentActive = false;
      this.$emit('deactivate');
    },
    onResize: function onResize() {
      clearTimeout(this.resizeTimeout);
      if (!this.isActive) return;
      this.resizeTimeout = setTimeout(this.updateDimensions, 200);
    },
    startTransition: function startTransition() {
      var _this2 = this;

      requestAnimationFrame(function () {
        return _this2.isContentActive = true;
      });
      requestAnimationFrame(this.calculateScroll);
    }
  },

  render: function render(h) {
    var _this3 = this;

    var data = {
      'class': 'menu',
      style: {
        display: this.fullWidth ? 'block' : 'inline-block'
      },
      directives: [{
        name: 'click-outside',
        value: function value() {
          return _this3.closeOnClick;
        }
      }],
      on: {
        keydown: function keydown(e) {
          if (e.keyCode === 27) _this3.isActive = false;else _this3.changeListIndex(e);
        }
      }
    };

    return h('div', data, [this.genActivator(), this.genTransition()]);
  }
});

/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_transitions__ = __webpack_require__(6);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-progress-linear',

  components: {
    VFadeTransition: __WEBPACK_IMPORTED_MODULE_0__components_transitions__["b" /* VFadeTransition */],
    VSlideXTransition: __WEBPACK_IMPORTED_MODULE_0__components_transitions__["c" /* VSlideXTransition */]
  },

  props: {
    active: {
      type: Boolean,
      default: true
    },
    buffer: Boolean,
    bufferValue: Number,
    error: Boolean,
    height: {
      type: [Number, String],
      default: 7
    },
    indeterminate: Boolean,
    info: Boolean,
    secondary: Boolean,
    success: Boolean,
    query: Boolean,
    warning: Boolean,
    value: {
      type: [Number, String],
      default: 0
    },
    colorFront: {
      type: String,
      default: null
    },
    colorBack: {
      type: String,
      default: null
    }
  },

  computed: {
    classes: function classes() {
      return {
        'progress-linear--query': this.query,
        'progress-linear--secondary': this.secondary,
        'progress-linear--success': this.success,
        'progress-linear--info': this.info,
        'progress-linear--warning': this.warning,
        'progress-linear--error': this.error
      };
    },
    styles: function styles() {
      var styles = {};

      if (!this.active) {
        styles.height = 0;
      }

      if (this.buffer) {
        styles.width = this.bufferValue + '%';
      }

      return styles;
    },
    bufferStyles: function bufferStyles() {
      var styles = {};

      if (!this.active) {
        styles.height = 0;
      }

      return styles;
    }
  },

  methods: {
    genDeterminate: function genDeterminate(h) {
      return h('div', {
        ref: 'front',
        class: ['progress-linear__bar__determinate', this.colorFront],
        style: { width: this.value + '%' }
      });
    },
    genBar: function genBar(h, name) {
      return h('div', {
        class: ['progress-linear__bar__indeterminate', name, this.colorFront]
      });
    },
    genIndeterminate: function genIndeterminate(h) {
      return h('div', {
        ref: 'front',
        class: {
          'progress-linear__bar__indeterminate': true,
          'progress-linear__bar__indeterminate--active': this.active
        }
      }, [this.genBar(h, 'long'), this.genBar(h, 'short')]);
    }
  },

  render: function render(h) {
    var fade = h('v-fade-transition', [this.indeterminate && this.genIndeterminate(h)]);
    var slide = h('v-slide-x-transition', [!this.indeterminate && this.genDeterminate(h)]);

    var bar = h('div', { class: ['progress-linear__bar', this.colorBack], style: this.styles }, [fade, slide]);

    return h('div', {
      class: ['progress-linear', this.classes],
      style: { height: this.height + 'px' },
      on: this.$listeners
    }, [bar]);
  }
});

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_autocomplete__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_filterable__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_generators__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_input__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_cards_VCard__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_selection_controls_VCheckbox__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_lists_VList__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_lists_VListTile__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_lists_VListTileAction__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_lists__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_menus_VMenu__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__directives_click_outside__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__util_helpers__ = __webpack_require__(0);



















/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-select',

  components: {
    VCard: __WEBPACK_IMPORTED_MODULE_4__components_cards_VCard__["a" /* default */],
    VCheckbox: __WEBPACK_IMPORTED_MODULE_5__components_selection_controls_VCheckbox__["a" /* default */],
    VIcon: __WEBPACK_IMPORTED_MODULE_6__components_icons_VIcon__["a" /* default */],
    VList: __WEBPACK_IMPORTED_MODULE_7__components_lists_VList__["a" /* default */],
    VListTile: __WEBPACK_IMPORTED_MODULE_8__components_lists_VListTile__["a" /* default */],
    VListTileAction: __WEBPACK_IMPORTED_MODULE_9__components_lists_VListTileAction__["a" /* default */],
    VListTileContent: __WEBPACK_IMPORTED_MODULE_10__components_lists__["a" /* VListTileContent */],
    VListTileTitle: __WEBPACK_IMPORTED_MODULE_10__components_lists__["b" /* VListTileTitle */],
    VMenu: __WEBPACK_IMPORTED_MODULE_11__components_menus_VMenu__["a" /* default */]
  },

  directives: {
    clickOutside: __WEBPACK_IMPORTED_MODULE_12__directives_click_outside__["a" /* default */]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_autocomplete__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_input__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_filterable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_generators__["a" /* default */]],

  data: function data() {
    return {
      content: {},
      hasFocused: false,
      inputValue: this.multiple && !this.value ? [] : this.value,
      isBooted: false,
      lastItem: 20,
      isActive: false,
      searchInputValue: this.searchInput
    };
  },


  props: {
    appendIcon: {
      type: String,
      default: 'arrow_drop_down'
    },
    auto: Boolean,
    autocomplete: Boolean,
    bottom: Boolean,
    chips: Boolean,
    close: Boolean,
    debounce: {
      type: Number,
      default: 200
    },
    items: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    filter: Function,
    itemText: {
      type: String,
      default: 'text'
    },
    itemValue: {
      type: String,
      default: 'value'
    },
    itemDisabled: {
      type: String,
      default: 'disabled'
    },
    maxHeight: {
      type: [Number, String],
      default: 300
    },
    minWidth: {
      type: [Boolean, Number, String],
      default: false
    },
    multiple: Boolean,
    multiLine: Boolean,
    offset: Boolean,
    searchInput: null,
    singleLine: Boolean,
    top: Boolean,
    returnObject: Boolean,
    overflow: Boolean,
    segmented: Boolean,
    editable: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'input-group--text-field input-group--select': true,
        'input-group--auto': this.auto,
        'input-group--overflow': this.overflow,
        'input-group--segmented': this.segmented,
        'input-group--editable': this.editable,
        'input-group--autocomplete': this.autocomplete,
        'input-group--single-line': this.singleLine || this.isDropdown,
        'input-group--multi-line': this.multiLine,
        'input-group--chips': this.chips,
        'input-group--multiple': this.multiple
      };
    },
    computedContentClass: function computedContentClass() {
      var children = [this.auto ? 'menu__content--auto' : '', this.isDropdown ? 'menu__content--dropdown' : ''];

      return children.join(' ');
    },
    filteredItems: function filteredItems() {
      var items = this.autocomplete && this.searchValue ? this.filterSearch() : this.items;

      return !this.auto ? items.slice(0, this.lastItem) : items;
    },
    hasError: function hasError() {
      return this.validations.length || this.error || this.hasFocused && !this.focused && !this.isDirty && this.required;
    },
    isDirty: function isDirty() {
      return this.selectedItems.length;
    },
    isDropdown: function isDropdown() {
      return this.segmented || this.overflow || this.editable;
    },

    searchValue: {
      get: function get() {
        return this.searchInput || this.searchInputValue;
      },
      set: function set(val) {
        this.searchInputValue = val;
        this.$emit('update:searchInput', val);
      }
    },
    selectedItems: function selectedItems() {
      var _this = this;

      if (this.inputValue === null || typeof this.inputValue === 'undefined') return [];

      return this.items.filter(function (i) {
        if (!_this.multiple) {
          return _this.getValue(i) === _this.getValue(_this.inputValue);
        } else {
          // Always return Boolean
          return _this.inputValue.find(function (j) {
            return _this.getValue(j) === _this.getValue(i);
          }) !== undefined;
        }
      });
    }
  },

  watch: {
    inputValue: function inputValue(val) {
      this.$emit('input', val);
    },
    value: function value(val) {
      this.inputValue = val;
      this.validate();
      if (this.autocomplete || this.editable) {
        this.$nextTick(this.$refs.menu.updateDimensions);
      }
    },
    isActive: function isActive(val) {
      this.isBooted = true;
      this.lastItem += !val ? 20 : 0;

      if (!val) this.blur();else this.focus();
    },
    isBooted: function isBooted() {
      var _this2 = this;

      this.$nextTick(function () {
        if (_this2.content) {
          _this2.content.addEventListener('scroll', _this2.onScroll, false);
        }
      });
    },
    searchValue: function searchValue() {
      this.$refs.menu.listIndex = -1;
    }
  },

  mounted: function mounted() {
    var _this3 = this;

    this.$vuetify.load(function () {
      if (_this3._isDestroyed) return;

      _this3.content = _this3.$refs.menu.$refs.content;
    });
  },
  beforeDestroy: function beforeDestroy() {
    if (this.isBooted) {
      if (this.content) {
        this.content.removeEventListener('scroll', this.onScroll, false);
      }
    }
  },


  methods: {
    blur: function blur() {
      var _this4 = this;

      this.$nextTick(function () {
        _this4.focused = false;
        _this4.hasFocused = true;
        _this4.searchValue = null;
        _this4.$el.blur();
      });
    },
    focus: function focus() {
      var _this5 = this;

      this.focused = true;
      this.$refs.input && (this.autocomplete || this.editable) && this.$refs.input.focus();

      if (this.editable && this.inputValue !== null && typeof this.inputValue !== 'undefined') {
        this.$nextTick(function () {
          _this5.$refs.input.value = _this5.getValue(_this5.inputValue);
        });
      }
    },
    genLabel: function genLabel() {
      if (this.searchValue && !this.focused && this.isDirty) return null;

      var data = {};

      if (this.id) data.attrs = { for: this.id };

      return this.$createElement('label', data, this.label);
    },
    getPropertyFromItem: function getPropertyFromItem(item, field) {
      if (item !== Object(item)) return item;

      var value = Object(__WEBPACK_IMPORTED_MODULE_13__util_helpers__["g" /* getObjectValueByPath */])(item, field);

      return typeof value === 'undefined' ? item : value;
    },
    getText: function getText(item) {
      return this.getPropertyFromItem(item, this.itemText);
    },
    getValue: function getValue(item) {
      return this.getPropertyFromItem(item, this.itemValue);
    },
    onScroll: function onScroll() {
      var _this6 = this;

      if (!this.isActive) {
        requestAnimationFrame(function () {
          return _this6.content.scrollTop = 0;
        });
      } else {
        var showMoreItems = this.content.scrollHeight - (this.content.scrollTop + this.content.clientHeight) < 200;

        if (showMoreItems) {
          this.lastItem += 20;
        }
      }
    },
    selectItem: function selectItem(item) {
      var _this7 = this;

      if (!this.multiple) {
        this.inputValue = this.returnObject ? item : this.getValue(item);
      } else {
        var inputValue = this.inputValue.slice();
        var i = this.inputValue.findIndex(function (i) {
          return _this7.getValue(i) === _this7.getValue(item);
        });

        i !== -1 && inputValue.splice(i, 1) || inputValue.push(item);
        this.inputValue = inputValue.map(function (i) {
          return _this7.returnObject ? i : _this7.getValue(i);
        });
      }

      if (this.autocomplete || this.editable) {
        this.$nextTick(function () {
          _this7.searchValue = null;
          _this7.$refs.input && _this7.$refs.input.focus();
        });
      }

      this.$emit('change', this.inputValue);
    }
  },

  render: function render(h) {
    var _this8 = this;

    return this.genInputGroup([this.genSelectionsAndSearch(), this.genMenu()], {
      ref: 'activator',
      directives: [{
        name: 'click-outside',
        value: function value() {
          return _this8.isActive = false;
        }
      }],
      on: {
        keydown: this.onKeyDown // Located in mixins/autocomplete.js
      }
    });
  }
});

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    noDataText: {
      type: String,
      default: 'No data available'
    }
  }
});

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_selectable__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives_ripple__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_icons_VIcon__ = __webpack_require__(3);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-checkbox',

  components: {
    VFadeTransition: __WEBPACK_IMPORTED_MODULE_2__components_transitions__["b" /* VFadeTransition */],
    VIcon: __WEBPACK_IMPORTED_MODULE_3__components_icons_VIcon__["a" /* default */]
  },

  directives: {
    Ripple: __WEBPACK_IMPORTED_MODULE_1__directives_ripple__["a" /* default */]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_selectable__["a" /* default */]],

  data: function data() {
    return {
      inputIndeterminate: this.indeterminate
    };
  },


  props: {
    indeterminate: Boolean
  },

  computed: {
    classes: function classes() {
      return this.addColorClassChecks({
        'checkbox': true,
        'input-group--selection-controls': true,
        'input-group--active': this.isActive
      });
    },
    icon: function icon() {
      if (this.inputIndeterminate) {
        return 'indeterminate_check_box';
      } else if (this.isActive) {
        return 'check_box';
      } else {
        return 'check_box_outline_blank';
      }
    }
  },

  render: function render(h) {
    var transition = h('v-fade-transition', [h('v-icon', {
      'class': {
        'icon--checkbox': this.icon === 'check_box'
      },
      key: this.icon
    }, this.icon)]);

    var ripple = h('div', {
      'class': 'input-group--selection-controls__ripple',
      on: Object.assign({}, {
        click: this.toggle
      }, this.$listeners),
      directives: [{
        name: 'ripple',
        value: { center: true }
      }]
    });

    var data = {
      attrs: {
        role: 'checkbox',
        'aria-checked': this.inputIndeterminate && 'mixed' || this.isActive && 'true' || 'false',
        'aria-label': this.label
      }
    };

    return this.genInputGroup([transition, ripple], data);
  }
});

/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colorable__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__input__ = __webpack_require__(7);



/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__input__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__colorable__["a" /* default */]],

  model: {
    prop: 'inputValue',
    event: 'change'
  },

  props: {
    inputValue: null,
    falseValue: null,
    trueValue: null
  },

  computed: {
    isActive: function isActive() {
      if (Array.isArray(this.inputValue)) {
        return this.inputValue.indexOf(this.value) !== -1;
      }

      if (!this.trueValue || !this.falseValue) {
        return this.value ? this.value === this.inputValue : Boolean(this.inputValue);
      }

      return this.inputValue === this.trueValue;
    }
  },

  watch: {
    indeterminate: function indeterminate(val) {
      this.inputIndeterminate = val;
    }
  },

  methods: {
    genLabel: function genLabel() {
      return this.$createElement('label', {
        on: { click: this.toggle },
        attrs: {
          for: this.$attrs.id
        }
      }, this.$slots.label || this.label);
    },
    toggle: function toggle() {
      if (this.disabled) {
        return;
      }

      var input = this.inputValue;
      if (Array.isArray(input)) {
        input = input.slice();
        var i = input.indexOf(this.value);

        if (i === -1) {
          input.push(this.value);
        } else {
          input.splice(i, 1);
        }
      } else if (this.trueValue || this.falseValue) {
        input = input === this.trueValue ? this.falseValue : this.trueValue;
      } else if (this.value) {
        input = this.value === this.inputValue ? null : this.value;
      } else {
        input = !input;
      }

      this.$emit('change', input);
    }
  }
});

/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    color: String
  },
  methods: {
    addColorClassChecks: function addColorClassChecks(classes) {
      var parts = this.color ? this.color.trim().split(' ') : [''];
      var color = parts[0] + '--text';
      if (parts.length > 1) color += ' text--' + parts[1];
      classes[color] = !!this.color;
      return classes;
    }
  }
});

/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__package_json__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__package_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__package_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__directives__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_load__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_semver__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_semver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_semver__);
__webpack_require__(30);







function plugin(Vue) {
  Object.keys(__WEBPACK_IMPORTED_MODULE_1__components__["a" /* default */]).forEach(function (key) {
    Vue.component(key, __WEBPACK_IMPORTED_MODULE_1__components__["a" /* default */][key]);
  });

  Object.keys(__WEBPACK_IMPORTED_MODULE_2__directives__).forEach(function (key) {
    Vue.directive(key, __WEBPACK_IMPORTED_MODULE_2__directives__[key]);
  });

  Vue.prototype.$vuetify = {
    load: __WEBPACK_IMPORTED_MODULE_3__util_load__["a" /* default */]
  };
}

function checkVueVersion() {
  var vueDep = __WEBPACK_IMPORTED_MODULE_0__package_json__["devDependencies"].vue;
  if (!__WEBPACK_IMPORTED_MODULE_4_semver___default.a.satisfies(window.Vue.version, vueDep)) {
    console.warn('Vuetify requires Vue version ' + vueDep);
  }
}

if (typeof window !== 'undefined' && window.Vue) {
  if (window.Vue.version) {
    checkVueVersion();
  }
  window.Vue.use(plugin);
}

/* harmony default export */ __webpack_exports__["default"] = (plugin);

/***/ }),
/* 30 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 31 */
/***/ (function(module, exports) {

module.exports = {
	"name": "vuetify",
	"version": "0.14.10",
	"author": {
		"name": "John Leider",
		"email": "john.j.leider@gmail.com"
	},
	"license": "MIT",
	"homepage": "http://vuetifyjs.com",
	"main": "dist/vuetify.js",
	"types": "index.d.ts",
	"scripts": {
		"watch": "cross-env TARGET=dev webpack --config build/config.js --progress --hide-modules --watch",
		"dev": "cross-env NODE_ENV=development webpack-dev-server --config build/webpack.dev.config.js --open --hot",
		"build": "rimraf dist && cross-env NODE_ENV=production node build/build.js --progress --hide-modules",
		"debug-build": "node --inspect --debug-brk build/build.js",
		"test": "cross-env NODE_ENV=test jest --no-cache --verbose",
		"test-coverage": "cross-env NODE_ENV=test jest --no-cache --coverage --verbose",
		"lint": "eslint --ext .js,.vue src"
	},
	"description": "Vue.js 2 Semantic Component Framework",
	"devDependencies": {
		"autoprefixer": "^6.6.0",
		"avoriaz": "^3.2.0",
		"babel-cli": "^6.24.1",
		"babel-core": "^6.24.1",
		"babel-eslint": "^7.1.1",
		"babel-jest": "^20.0.3",
		"babel-loader": "^7.1.1",
		"babel-plugin-add-filehash": "^6.9.4",
		"babel-plugin-module-resolver": "^2.7.1",
		"babel-plugin-transform-async-to-generator": "^6.24.1",
		"babel-plugin-transform-runtime": "^6.23.0",
		"babel-preset-env": "^1.5.1",
		"babel-preset-es2015": "^6.24.1",
		"babel-preset-stage-2": "^6.24.1",
		"chalk": "^1.1.3",
		"chromedriver": "^2.21.2",
		"cross-env": "^3.1.3",
		"cross-spawn": "^4.0.2",
		"css-loader": "^0.23.1",
		"css-mqpacker": "^6.0.1",
		"cssnano": "^3.10.0",
		"eslint": "^3.7.1",
		"eslint-config-standard": "^6.1.0",
		"eslint-config-vue": "^2.0.2",
		"eslint-friendly-formatter": "^2.0.5",
		"eslint-loader": "^1.6.1",
		"eslint-plugin-html": "^1.3.0",
		"eslint-plugin-promise": "^3.4.0",
		"eslint-plugin-pug": "^1.0.0",
		"eslint-plugin-standard": "^3.0.1",
		"eslint-plugin-vue": "^2.1.0",
		"eventsource-polyfill": "^0.9.6",
		"extract-text-webpack-plugin": "^3.0.0",
		"friendly-errors-webpack-plugin": "^1.6.1",
		"function-bind": "^1.0.2",
		"jest": "^20.0.4",
		"jest-cli": "^20.0.4",
		"jest-css-modules": "^1.1.0",
		"jest-serializer-html": "^4.0.0",
		"jest-vue-preprocessor": "^0.2.0",
		"lolex": "^1.4.0",
		"nightwatch": "^0.9.8",
		"opn": "^4.0.2",
		"optimize-css-assets-webpack-plugin": "^2.0.0",
		"optimize-js-plugin": "^0.0.4",
		"ora": "^0.3.0",
		"phantomjs-prebuilt": "^2.1.3",
		"postcss-loader": "^1.2.1",
		"precss": "^1.4.0",
		"pug": "^2.0.0-beta3",
		"pug-loader": "^2.3.0",
		"ress": "^1.1.1",
		"rimraf": "^2.5.4",
		"selenium-server": "2.53.1",
		"semver": "^5.3.0",
		"serialize-javascript": "^1.3.0",
		"shelljs": "^0.7.4",
		"style-loader": "^0.13.1",
		"stylus": "^0.54.5",
		"stylus-loader": "^2.1.1",
		"uglifyjs-webpack-plugin": "^0.4.6",
		"vue": "^2.4.1",
		"vue-loader": "^10.1.0",
		"vue-router": "^2.7.0",
		"vue-server-renderer": "^2.4.1",
		"vue-template-compiler": "^2.4.1",
		"webpack": "^3.2.0",
		"webpack-bundle-size-analyzer": "^2.7.0",
		"webpack-dev-server": "^2.6.1",
		"webpack-merge": "^4.1.0"
	},
	"dependencies": {},
	"engines": {
		"node": ">= 4.0.0",
		"npm": ">= 3.0.0"
	},
	"jest": {
		"verbose": false,
		"roots": [
			"<rootDir>/src"
		],
		"moduleFileExtensions": [
			"js",
			"vue"
		],
		"moduleDirectories": [
			"node_modules"
		],
		"moduleNameMapper": {
			"src/(.*)": "<rootDir>/src/$1"
		},
		"transform": {
			".*\\.(vue)$": "<rootDir>/node_modules/jest-vue-preprocessor",
			"\\.(styl)$": "<rootDir>/node_modules/jest-css-modules",
			".*\\.(vue|js)$": "<rootDir>/node_modules/babel-jest"
		},
		"transformIgnorePatterns": [
			"node_modules/(?!vue-router)"
		],
		"snapshotSerializers": [
			"jest-serializer-html"
		]
	}
};

/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__alerts__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__avatars__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bottom_nav__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__breadcrumbs__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__buttons__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__cards__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__carousel__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__chips__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pickers__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__dialogs__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__dividers__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__expansion_panel__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__footer__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__grid__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__icons__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__lists__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__menus__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__navigation_drawer__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__toolbar__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__pagination__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__parallax__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__progress__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__selects__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__selection_controls__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__sliders__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__subheaders__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__steppers__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__tables__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__tabs__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__text_fields__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__snackbars__ = __webpack_require__(129);


































/* harmony default export */ __webpack_exports__["a"] = (Object.assign({}, __WEBPACK_IMPORTED_MODULE_0__alerts__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__app__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__avatars__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__bottom_nav__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__breadcrumbs__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__buttons__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__cards__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__carousel__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__chips__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__pickers__["a" /* default */], __WEBPACK_IMPORTED_MODULE_10__dialogs__["a" /* default */], __WEBPACK_IMPORTED_MODULE_11__dividers__["a" /* default */], __WEBPACK_IMPORTED_MODULE_12__expansion_panel__["a" /* default */], __WEBPACK_IMPORTED_MODULE_13__footer__["a" /* default */], __WEBPACK_IMPORTED_MODULE_14__grid__["a" /* default */], __WEBPACK_IMPORTED_MODULE_15__icons__["a" /* default */], __WEBPACK_IMPORTED_MODULE_16__lists__["c" /* default */], __WEBPACK_IMPORTED_MODULE_17__menus__["a" /* default */], __WEBPACK_IMPORTED_MODULE_18__navigation_drawer__["a" /* default */], __WEBPACK_IMPORTED_MODULE_19__toolbar__["a" /* default */], __WEBPACK_IMPORTED_MODULE_20__pagination__["a" /* default */], __WEBPACK_IMPORTED_MODULE_21__parallax__["a" /* default */], __WEBPACK_IMPORTED_MODULE_22__progress__["a" /* default */], __WEBPACK_IMPORTED_MODULE_23__selects__["a" /* default */], __WEBPACK_IMPORTED_MODULE_24__selection_controls__["a" /* default */], __WEBPACK_IMPORTED_MODULE_25__sliders__["a" /* default */], __WEBPACK_IMPORTED_MODULE_26__subheaders__["a" /* default */], __WEBPACK_IMPORTED_MODULE_27__steppers__["a" /* default */], __WEBPACK_IMPORTED_MODULE_28__tables__["a" /* default */], __WEBPACK_IMPORTED_MODULE_29__tabs__["a" /* default */], __WEBPACK_IMPORTED_MODULE_30__text_fields__["a" /* default */], __WEBPACK_IMPORTED_MODULE_31__transitions__["d" /* default */], __WEBPACK_IMPORTED_MODULE_32__snackbars__["a" /* default */]));

/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VAlert__ = __webpack_require__(34);


/* harmony default export */ __webpack_exports__["a"] = ({
  VAlert: __WEBPACK_IMPORTED_MODULE_0__VAlert__["a" /* default */]
});

/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_transitionable__ = __webpack_require__(35);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-alert',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_transitionable__["a" /* default */]],

  props: {
    dismissible: Boolean,
    hideIcon: Boolean,
    icon: String
  },

  computed: {
    classes: function classes() {
      return {
        'alert': true,
        'alert--dismissible': this.dismissible,
        'error': this.error,
        'info': this.info,
        'primary': this.primary,
        'secondary': this.secondary,
        'success': this.success,
        'warning': this.warning
      };
    },
    mdIcon: function mdIcon() {
      switch (true) {
        case !!this.icon:
          return this.icon;
        case this.error:
          return 'warning';
        case this.info:
          return 'info';
        case this.success:
          return 'check_circle';
        case this.warning:
          return 'priority_high';
      }
    }
  },

  render: function render(h) {
    var _this = this;

    var children = [h('div', this.$slots.default)];

    if (!this.hideIcon && this.mdIcon) {
      children.unshift(h('v-icon', {
        'class': 'alert__icon'
      }, this.mdIcon));
    }

    if (this.dismissible) {
      var close = h('a', {
        'class': 'alert__dismissible',
        domProps: { href: 'javascript:;' },
        on: { click: function click() {
            return _this.$emit('input', false);
          } }
      }, [h('v-icon', {
        props: { right: true }
      }, 'cancel')]);

      children.push(close);
    }

    var alert = h('div', {
      'class': this.classes,
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      on: this.$listeners
    }, children);

    if (!this.transition) return alert;

    return h('transition', {
      props: {
        name: this.transition,
        origin: this.origin,
        mode: this.mode
      }
    }, [alert]);
  }
});

/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    mode: String,
    origin: String,
    transition: String
  }
});

/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VApp__ = __webpack_require__(37);


/* harmony default export */ __webpack_exports__["a"] = ({
  VApp: __WEBPACK_IMPORTED_MODULE_0__VApp__["a" /* default */]
});

/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    fixedFooter: Boolean,
    footer: Boolean,
    id: {
      type: String,
      default: 'app'
    },
    toolbar: Boolean
  },

  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;

    data.staticClass = ('application ' + (data.staticClass || '')).trim();
    data.staticClass += ' application--' + (props.dark ? 'dark' : 'light');

    props.footer && (data.staticClass += ' application--footer');
    props.fixedFooter && (data.staticClass += ' application--footer-fixed');
    props.toolbar && (data.staticClass += ' application--toolbar');

    data.attrs = { 'data-app': true };
    data.domProps = { id: props.id };

    return h('div', data, children);
  }
});

/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VAvatar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


var VAvatar = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('avatar');

/* harmony default export */ __webpack_exports__["a"] = ({
  VAvatar: VAvatar
});

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VBottomNav__ = __webpack_require__(40);


/* harmony default export */ __webpack_exports__["a"] = ({
  VBottomNav: __WEBPACK_IMPORTED_MODULE_0__VBottomNav__["a" /* default */]
});

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  props: {
    absolute: Boolean,
    shift: Boolean,
    value: { required: false }
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('bottom-nav ' + (data.staticClass || '')).trim();

    if (props.absolute) data.staticClass += ' bottom-nav--absolute';
    if (props.shift) data.staticClass += ' bottom-nav--shift';
    if (props.value) data.staticClass += ' bottom-nav--active';

    return h('div', data, children);
  }
});

/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VBreadcrumbs__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VBreadcrumbsItem__ = __webpack_require__(43);



/* harmony default export */ __webpack_exports__["a"] = ({
  VBreadcrumbs: __WEBPACK_IMPORTED_MODULE_0__VBreadcrumbs__["a" /* default */],
  VBreadcrumbsItem: __WEBPACK_IMPORTED_MODULE_1__VBreadcrumbsItem__["a" /* default */]
});

/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-breadcrumbs',

  provide: function provide() {
    return {
      divider: this.divider
    };
  },


  props: {
    divider: {
      type: String,
      default: '/'
    },
    icons: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'breadcrumbs': true,
        'breadcrumbs--with-icons': this.icons
      };
    }
  },

  render: function render(h) {
    return h('ul', {
      'class': this.classes,
      props: { items: this.items }
    }, this.$slots.default);
  }
});

/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_route_link__ = __webpack_require__(9);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-breadcrumbs-item',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_route_link__["a" /* default */]],

  inject: ['divider'],

  props: {
    activeClass: {
      type: String,
      default: 'breadcrumbs__item--active'
    }
  },

  computed: {
    classes: function classes() {
      var classes = _defineProperty({
        'breadcrumbs__item': true
      }, this.activeClass, !this.disabled);

      return classes;
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    return h('li', {
      attrs: { 'data-divider': this.divider }
    }, [h(tag, data, this.$slots.default)]);
  }
});

/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VBtnToggle__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VSpeedDial__ = __webpack_require__(46);




/* harmony default export */ __webpack_exports__["a"] = ({
  VBtn: __WEBPACK_IMPORTED_MODULE_0__VBtn__["a" /* default */],
  VBtnToggle: __WEBPACK_IMPORTED_MODULE_1__VBtnToggle__["a" /* default */],
  VSpeedDial: __WEBPACK_IMPORTED_MODULE_2__VSpeedDial__["a" /* default */]
});

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-btn-toggle',

  model: {
    prop: 'inputValue',
    event: 'change'
  },

  props: {
    inputValue: {
      required: false
    },
    items: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    mandatory: Boolean,
    multiple: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'btn-toggle': true,
        'btn-toggle--selected': this.inputValue && (!this.multiple || this.inputValue.length)
      };
    }
  },

  methods: {
    isSelected: function isSelected(item) {
      if (!this.multiple) {
        return this.inputValue === item.value;
      }

      return this.inputValue.includes(item.value);
    },
    updateValue: function updateValue(item) {
      if (!this.multiple) {
        if (this.mandatory && this.inputValue === item.value) return;
        return this.$emit('change', this.inputValue === item.value ? null : item.value);
      }

      var items = this.inputValue.slice();

      var i = items.indexOf(item.value);
      if (i > -1) {
        items.length >= 1 && !this.mandatory && items.splice(i, 1);
      } else {
        items.push(item.value);
      }

      this.$emit('change', items);
    }
  },

  render: function render(h) {
    var _this = this;

    var buttons = this.items.map(function (item, index) {
      var children = [];

      item.text && children.push(h('span', item.text));
      item.icon && children.push(h(__WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__["a" /* default */], item.icon));

      return h(__WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__["a" /* default */], {
        key: index,
        props: {
          flat: true
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this.updateValue(item);
          }
        },
        attrs: {
          'data-selected': _this.isSelected(item),
          'data-index': index,
          'data-only-child': _this.isSelected(item) && (!_this.multiple || _this.inputValue.length === 1)
        }
      }, children);
    });

    return h('div', { class: this.classes }, buttons);
  }
});

/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_positionable__ = __webpack_require__(12);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-speed-dial',

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_positionable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__["a" /* default */]],

  props: {
    direction: {
      type: String,
      default: 'top',
      validator: function validator(val) {
        return ['top', 'right', 'bottom', 'left'].includes(val);
      }
    },
    hover: Boolean,
    transition: {
      type: String,
      default: 'scale-transition'
    }
  },

  computed: {
    classes: function classes() {
      return _defineProperty({
        'speed-dial': true,
        'speed-dial--top': this.top,
        'speed-dial--right': this.right,
        'speed-dial--bottom': this.bottom,
        'speed-dial--left': this.left,
        'speed-dial--absolute': this.absolute,
        'speed-dial--fixed': this.fixed
      }, 'speed-dial--direction-' + this.direction, true);
    }
  },

  render: function render(h) {
    var _this = this;

    var children = [];
    var data = {
      'class': this.classes,
      directives: [{
        name: 'click-outside'
      }],
      on: {
        click: function click() {
          return _this.isActive = !_this.isActive;
        }
      }
    };

    if (this.hover) {
      data.on.mouseenter = function () {
        return _this.isActive = true;
      };
      data.on.mouseleave = function () {
        return _this.isActive = false;
      };
    }

    if (this.isActive) {
      children = (this.$slots.default || []).map(function (b, i) {
        b.key = i;

        return b;
      });
    }

    var list = h('transition-group', {
      'class': 'speed-dial__list',
      props: {
        name: this.transition,
        tag: 'div'
      }
    }, children);

    return h('div', data, [this.$slots.activator, list]);
  }
});

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VCard__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VCardMedia__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VCardTitle__ = __webpack_require__(49);





var VCardActions = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('card__actions');
var VCardText = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('card__text');

/* harmony default export */ __webpack_exports__["a"] = ({
  VCard: __WEBPACK_IMPORTED_MODULE_1__VCard__["a" /* default */],
  VCardActions: VCardActions,
  VCardMedia: __WEBPACK_IMPORTED_MODULE_2__VCardMedia__["a" /* default */],
  VCardText: VCardText,
  VCardTitle: __WEBPACK_IMPORTED_MODULE_3__VCardTitle__["a" /* default */]
});

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-card-media',

  props: {
    contain: Boolean,
    height: {
      type: [Number, String],
      default: 'auto'
    },
    src: {
      type: String
    }
  },

  render: function render(h) {
    var data = {
      'class': 'card__media',
      style: {
        height: !isNaN(this.height) ? this.height + 'px' : this.height
      },
      on: this.$listeners
    };

    var children = [];

    if (this.src) {
      children.push(h('div', {
        'class': 'card__media__background',
        style: {
          background: 'url(' + this.src + ') center center / ' + (this.contain ? 'contain' : 'cover') + ' no-repeat'
        }
      }));
    }

    children.push(h('div', {
      'class': 'card__media__content'
    }, this.$slots.default));

    return h('div', data, children);
  }
});

/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  props: {
    primaryTitle: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('card__title ' + (data.staticClass || '')).trim();

    if (props.primaryTitle) data.staticClass += ' card__title--primary';

    return h('div', data, children);
  }
});

/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VCarousel__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VCarouselItem__ = __webpack_require__(52);



/* harmony default export */ __webpack_exports__["a"] = ({
  VCarousel: __WEBPACK_IMPORTED_MODULE_0__VCarousel__["a" /* default */],
  VCarouselItem: __WEBPACK_IMPORTED_MODULE_1__VCarouselItem__["a" /* default */]
});

/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_bootable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__ = __webpack_require__(1);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-carousel',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_bootable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      current: null,
      items: [],
      slideInterval: {},
      reverse: false
    };
  },


  props: {
    cycle: {
      type: Boolean,
      default: true
    },
    icon: {
      type: String,
      default: 'fiber_manual_record'
    },
    interval: {
      type: Number,
      default: 6000
    },
    leftControlIcon: {
      type: [Boolean, String],
      default: 'chevron_left'
    },
    rightControlIcon: {
      type: [Boolean, String],
      default: 'chevron_right'
    }
  },

  computed: {
    defaultState: function defaultState() {
      return {
        current: null,
        reverse: false
      };
    }
  },

  watch: {
    current: function current() {
      var _this = this;

      // Evaluate items when current changes to account for
      // dynamic changing of children
      this.items = this.$children.filter(function (i) {
        return i.$el.classList && i.$el.classList.contains('carousel__item');
      });

      this.items.forEach(function (i) {
        return i.open(_this.items[_this.current]._uid, _this.reverse);
      });

      !this.isBooted && this.cycle && this.restartInterval();
      this.isBooted = true;
    },
    cycle: function cycle(val) {
      val && this.restartInterval() || clearInterval(this.slideInterval);
    }
  },

  mounted: function mounted() {
    this.init();
  },


  methods: {
    genControls: function genControls() {
      return this.$createElement('div', {
        staticClass: 'carousel__controls'
      }, this.genItems());
    },
    genIcon: function genIcon(direction, icon, fn) {
      if (!icon) return null;

      return this.$createElement('div', {
        staticClass: 'carousel__' + direction
      }, [this.$createElement(__WEBPACK_IMPORTED_MODULE_1__components_buttons_VBtn__["a" /* default */], {
        props: {
          icon: true,
          dark: this.dark || !this.light,
          light: this.light
        },
        on: { click: fn }
      }, [this.$createElement(__WEBPACK_IMPORTED_MODULE_2__components_icons_VIcon__["a" /* default */], icon)])]);
    },
    genItems: function genItems() {
      var _this2 = this;

      return this.items.map(function (item, index) {
        return _this2.$createElement(__WEBPACK_IMPORTED_MODULE_1__components_buttons_VBtn__["a" /* default */], {
          class: {
            'carousel__controls__item': true,
            'carousel__controls__item--active': index === _this2.current
          },
          props: {
            icon: true,
            dark: _this2.dark || !_this2.light,
            light: _this2.light
          },
          key: index,
          on: { click: _this2.select.bind(_this2, index) }
        }, [_this2.$createElement(__WEBPACK_IMPORTED_MODULE_2__components_icons_VIcon__["a" /* default */], _this2.icon)]);
      });
    },
    restartInterval: function restartInterval() {
      clearInterval(this.slideInterval);
      this.$nextTick(this.startInterval);
    },
    init: function init() {
      this.current = 0;
    },
    next: function next() {
      this.reverse = false;

      if (this.current + 1 === this.items.length) {
        return this.current = 0;
      }

      this.current++;
    },
    prev: function prev() {
      this.reverse = true;

      if (this.current - 1 < 0) {
        return this.current = this.items.length - 1;
      }

      this.current--;
    },
    select: function select(index) {
      this.reverse = index < this.current;
      this.current = index;
    },
    startInterval: function startInterval() {
      this.slideInterval = setInterval(this.next, this.interval);
    }
  },

  render: function render(h) {
    return h('div', {
      staticClass: 'carousel',
      directives: [{
        name: 'touch',
        value: {
          left: this.next,
          right: this.prev
        }
      }]
    }, [this.genIcon('left', this.leftControlIcon, this.prev), this.genIcon('right', this.rightControlIcon, this.next), this.genControls(), this.$slots.default]);
  }
});

/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-carousel-item',

  data: function data() {
    return {
      active: false,
      reverse: false
    };
  },


  props: {
    src: {
      type: String,
      required: true
    },

    transition: {
      type: String,
      default: 'tab-transition'
    },

    reverseTransition: {
      type: String,
      default: 'tab-reverse-transition'
    }
  },

  computed: {
    computedTransition: function computedTransition() {
      return this.reverse ? this.reverseTransition : this.transition;
    },
    styles: function styles() {
      return {
        backgroundImage: 'url(' + this.src + ')'
      };
    }
  },

  methods: {
    open: function open(id, reverse) {
      this.active = this._uid === id;
      this.reverse = reverse;
    }
  },

  render: function render(h) {
    var item = h('div', {
      class: {
        'carousel__item': true,
        'reverse': this.reverse
      },
      style: this.styles,
      on: this.$listeners,
      directives: [{
        name: 'show',
        value: this.active
      }]
    }, [this.$slots.default]);

    return h('transition', { props: { name: this.computedTransition } }, [item]);
  }
});

/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VChip__ = __webpack_require__(54);


/* harmony default export */ __webpack_exports__["a"] = ({
  VChip: __WEBPACK_IMPORTED_MODULE_0__VChip__["a" /* default */]
});

/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__ = __webpack_require__(2);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-chip',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__["a" /* default */]],

  props: {
    close: Boolean,
    label: Boolean,
    outline: Boolean,
    small: Boolean,
    value: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    classes: function classes() {
      return {
        'chip': true,
        'chip--label': this.label,
        'chip--outline': this.outline,
        'chip--small': this.small,
        'chip--removable': this.close
      };
    }
  },

  render: function render(h) {
    var _this = this;

    var children = [this.$slots.default];
    var data = {
      'class': this.classes,
      attrs: { tabindex: -1 },
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      on: this.$listeners
    };

    if (this.close) {
      children.push(h('a', {
        'class': 'chip__close',
        domProps: { href: 'javascript:;' },
        on: {
          click: function click(e) {
            e.stopPropagation();

            _this.$emit('input', false);
          }
        }
      }, [h('v-icon', { props: { right: true } }, 'cancel')]));
    }

    return h('span', data, children);
  }
});

/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VDatePicker__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VTimePicker__ = __webpack_require__(61);



/* harmony default export */ __webpack_exports__["a"] = ({
  VDatePicker: __WEBPACK_IMPORTED_MODULE_0__VDatePicker__["a" /* default */],
  VTimePicker: __WEBPACK_IMPORTED_MODULE_1__VTimePicker__["a" /* default */]
});

/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_date_title__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_date_header__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_date_table__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_date_years__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_picker__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_helpers__ = __webpack_require__(0);







var defaultDateFormat = function defaultDateFormat(val) {
  return new Date(val).toISOString().substr(0, 10);
};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-date-picker',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_date_title__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_date_header__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_date_table__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_date_years__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_picker__["a" /* default */]],

  data: function data() {
    return {
      tableDate: new Date(),
      originalDate: this.value,
      currentDay: null,
      currentMonth: null,
      currentYear: null,
      isSelected: false,
      isReversing: false,
      narrowDays: []
    };
  },


  props: {
    locale: {
      type: String,
      default: 'en-us'
    },
    dateFormat: {
      type: Function,
      default: defaultDateFormat
    },
    titleDateFormat: {
      type: Object,
      default: function _default() {
        return { weekday: 'short', month: 'short', day: 'numeric' };
      }
    },
    headerDateFormat: {
      type: Object,
      default: function _default() {
        return { month: 'long', year: 'numeric' };
      }
    },
    formattedValue: {
      required: false
    },
    allowedDates: {
      type: [Array, Object, Function],
      default: function _default() {
        return null;
      }
    },
    firstDayOfWeek: {
      type: [String, Number],
      default: 0
    },
    yearIcon: String
  },

  computed: {
    firstAllowedDate: function firstAllowedDate() {
      var date = new Date();
      date.setHours(12, 0, 0, 0);

      if (this.allowedDates) {
        var millisecondOffset = 1 * 24 * 60 * 60 * 1000;
        var valid = new Date(date);
        for (var i = 0; i < 31; i++) {
          if (this.isAllowed(valid)) return valid;

          valid.setTime(valid.getTime() + millisecondOffset);
        }
      }

      return date;
    },

    inputDate: {
      get: function get() {
        if (!this.value) return this.firstAllowedDate;
        if (this.value instanceof Date) return this.value;
        if (!isNaN(this.value) || typeof this.value === 'string' && this.value.indexOf(':') !== -1) return new Date(this.value);

        return new Date(this.value + 'T12:00:00');
      },
      set: function set(val) {
        this.$emit('input', val ? defaultDateFormat(val) : this.originalDate);
        this.$emit('update:formattedValue', val ? this.dateFormat(val) : this.dateFormat(this.originalDate));
      }
    },
    day: function day() {
      return this.inputDate.getDate();
    },
    month: function month() {
      return this.inputDate.getMonth();
    },
    year: function year() {
      return this.inputDate.getFullYear();
    },
    tableMonth: function tableMonth() {
      return this.tableDate.getMonth();
    },
    tableYear: function tableYear() {
      return this.tableDate.getFullYear();
    },
    computedTransition: function computedTransition() {
      return this.isReversing ? 'v-tab-reverse-transition' : 'v-tab-transition';
    }
  },

  watch: {
    isSelected: function isSelected(val) {
      var _this = this;

      val && this.$nextTick(function () {
        _this.$refs.years.scrollTop = _this.$refs.years.scrollHeight / 2 - 125;
      });
    },
    tableDate: function tableDate(val, prev) {
      this.isReversing = val < prev;
    },
    value: function value(val) {
      if (val) this.tableDate = this.inputDate;
    }
  },

  methods: {
    save: function save() {
      if (this.originalDate) {
        this.originalDate = this.value;
      } else {
        this.originalDate = this.inputDate;
      }

      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    cancel: function cancel() {
      this.inputDate = this.originalDate;
      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    isAllowed: function isAllowed(date) {
      if (!this.allowedDates) return true;

      if (Array.isArray(this.allowedDates)) {
        return !!this.allowedDates.find(function (allowedDate) {
          var d = new Date(allowedDate);
          d.setHours(12, 0, 0, 0);

          return d - date === 0;
        });
      } else if (this.allowedDates instanceof Function) {
        return this.allowedDates(date);
      } else if (this.allowedDates instanceof Object) {
        var min = new Date(this.allowedDates.min);
        min.setHours(12, 0, 0, 0);
        var max = new Date(this.allowedDates.max);
        max.setHours(12, 0, 0, 0);

        return date >= min && date <= max;
      }

      return true;
    }
  },

  created: function created() {
    var _this2 = this;

    var date = new Date();
    date.setDate(date.getDate() - date.getDay() + parseInt(this.firstDayOfWeek));

    Object(__WEBPACK_IMPORTED_MODULE_5__util_helpers__["c" /* createRange */])(7).forEach(function () {
      var narrow = date.toLocaleString(_this2.locale, { weekday: 'narrow' });
      _this2.narrowDays.push(narrow);

      date.setDate(date.getDate() + 1);
    });
  },
  mounted: function mounted() {
    this.currentDay = this.tableDate.getDate();
    this.currentMonth = this.tableDate.getMonth();
    this.currentYear = this.tableDate.getFullYear();
    this.tableDate = this.inputDate;
  },
  render: function render(h) {
    var children = [];

    !this.noTitle && children.push(this.genTitle());

    if (!this.isSelected) {
      var bodyChildren = [];

      bodyChildren.push(this.genHeader());
      bodyChildren.push(this.genTable());

      children.push(h('div', {
        'class': 'picker__body'
      }, bodyChildren));
    } else {
      children.push(this.genYears());
    }

    this.$scopedSlots.default && children.push(this.genSlot());

    return h('v-card', {
      'class': {
        'picker picker--date': true,
        'picker--landscape': this.landscape,
        'picker--dark': this.dark,
        'picker--light': this.light && !this.dark
      }
    }, children);
  }
});

/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genYearIcon: function genYearIcon() {
      return this.yearIcon ? this.$createElement('v-icon', {
        props: {
          dark: true
        }
      }, this.yearIcon) : null;
    },
    genTitle: function genTitle() {
      var _this = this;

      var date = new Date(this.year, this.month, this.day);
      date = date.toLocaleString(this.locale, this.titleDateFormat);

      if (this.landscape) {
        if (date.indexOf(',') > -1) date = date.replace(',', ',<br>');else if (date.indexOf(' ') > -1) date = date.replace(' ', '<br>');
      }

      var text = this.$createElement('transition', {
        props: {
          name: 'slide-x-transition',
          mode: 'out-in'
        }
      }, [this.$createElement('div', {
        domProps: { innerHTML: date },
        key: date
      })]);

      return this.$createElement('div', {
        'class': 'picker__title'
      }, [this.$createElement('div', {
        'class': {
          'picker--date__title-year': true,
          'active': this.isSelected
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this.isSelected = true;
          }
        }
      }, [this.year, this.genYearIcon()]), this.$createElement('div', {
        'class': {
          'picker--date__title-date': true,
          'active': !this.isSelected
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this.isSelected = false;
          }
        }
      }, [text])]);
    }
  }
});

/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genHeader: function genHeader() {
      return this.$createElement('div', {
        'class': 'picker--date__header'
      }, [this.genSelector()]);
    },
    genBtn: function genBtn(change, children) {
      var _this = this;

      return this.$createElement('v-btn', {
        props: {
          dark: this.dark,
          icon: true
        },
        nativeOn: {
          click: function click(e) {
            e.stopPropagation();
            _this.tableDate = new Date(_this.tableYear, change);
          }
        }
      }, children);
    },
    genSelector: function genSelector() {
      var date = new Date(this.tableYear, this.tableMonth);
      var header = this.$createElement('div', {
        'class': 'picker--date__header-selector-date'
      }, [this.$createElement(this.computedTransition, [this.$createElement('strong', {
        key: this.tableMonth
      }, date.toLocaleString(this.locale, this.headerDateFormat))])]);

      return this.$createElement('div', {
        'class': 'picker--date__header-selector'
      }, [this.genBtn(this.tableMonth - 1, [this.$createElement('v-icon', 'chevron_left')]), header, this.genBtn(this.tableMonth + 1, [this.$createElement('v-icon', 'chevron_right')])]);
    }
  }
});

/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    wheelScroll: function wheelScroll(e) {
      e.preventDefault();

      var month = this.tableMonth;

      if (e.deltaY < 0) month++;else month--;

      this.tableDate = new Date(this.tableYear, month);
    },
    touch: function touch(value) {
      this.tableDate = new Date(this.tableYear, this.tableMonth + value);
    },
    genTable: function genTable() {
      var _this = this;

      var children = [];
      var data = {
        'class': 'picker--date__table',
        directives: [{
          name: 'touch',
          value: {
            left: function left(e) {
              return e.offsetX < -15 && _this.touch(1);
            },
            right: function right(e) {
              return e.offsetX > 15 && _this.touch(-1);
            }
          }
        }]
      };

      if (this.scrollable) {
        data.on = { wheel: this.wheelScroll };
      }

      children.push(this.$createElement('table', {
        key: this.tableMonth
      }, [this.genTHead(), this.genTBody()]));

      return this.$createElement('div', data, [this.$createElement(this.computedTransition, children)]);
    },
    genTHead: function genTHead() {
      var _this2 = this;

      var days = this.narrowDays.map(function (day) {
        return _this2.$createElement('th', day);
      });
      return this.$createElement('thead', this.genTR(days));
    },
    genTBody: function genTBody() {
      var _this3 = this;

      var children = [];
      var rows = [];
      var length = new Date(this.tableYear, this.tableMonth + 1, 0).getDate();

      var day = new Date(this.tableYear, this.tableMonth).getDay() - parseInt(this.firstDayOfWeek);

      for (var i = 0; i < day; i++) {
        rows.push(this.$createElement('td'));
      }

      var _loop = function _loop(_i) {
        var date = new Date(_this3.tableYear, _this3.tableMonth, _i, 12, 0, 0, 0);
        rows.push(_this3.$createElement('td', [_this3.$createElement('button', {
          'class': {
            'btn btn--floating btn--small btn--flat': true,
            'btn--active': _this3.isActive(_i),
            'btn--current': _this3.isCurrent(_i),
            'btn--light': _this3.dark,
            'btn--disabled': !_this3.isAllowed(date)
          },
          attrs: {
            type: 'button'
          },
          domProps: {
            innerHTML: '<span class="btn__content">' + _i + '</span>'
          },
          on: {
            click: function click() {
              var day = _i < 10 ? '0' + _i : _i;
              var tableYear = _this3.tableYear;
              var tableMonth = _this3.tableMonth + 1;
              tableMonth = tableMonth < 10 ? '0' + tableMonth : tableMonth;

              _this3.inputDate = tableYear + '-' + tableMonth + '-' + day + 'T12:00:00';
              _this3.$nextTick(function () {
                return _this3.autosave && _this3.save();
              });
            }
          }
        })]));

        if (rows.length % 7 === 0) {
          children.push(_this3.genTR(rows));
          rows = [];
        }
      };

      for (var _i = 1; _i <= length; _i++) {
        _loop(_i);
      }

      if (rows.length) {
        children.push(this.genTR(rows));
      }

      children.length < 6 && children.push(this.genTR([this.$createElement('td', { domProps: { innerHTML: '&nbsp;' } })]));

      return this.$createElement('tbody', children);
    },
    genTR: function genTR() {
      var children = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return [this.$createElement('tr', data, children)];
    },
    isActive: function isActive(i) {
      return this.tableYear === this.year && this.tableMonth === this.month && this.day === i;
    },
    isCurrent: function isCurrent(i) {
      return this.currentYear === this.tableYear && this.currentMonth === this.tableMonth && this.currentDay === i;
    }
  }
});

/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genYears: function genYears() {
      return this.$createElement('ul', {
        'class': 'picker--date__years',
        ref: 'years'
      }, this.genYearItems());
    },
    genYearItems: function genYearItems() {
      var _this = this;

      var children = [];

      var _loop = function _loop(i, length) {
        children.push(_this.$createElement('li', {
          'class': {
            active: _this.year === i
          },
          on: {
            click: function click(e) {
              e.stopPropagation();

              var tableMonth = _this.tableMonth + 1;
              var day = _this.day;
              tableMonth = tableMonth < 10 ? '0' + tableMonth : tableMonth;
              day = day < 10 ? '0' + day : day;

              _this.inputDate = i + '-' + tableMonth + '-' + day;
              _this.isSelected = false;
            }
          }
        }, i));
      };

      for (var i = this.year + 100, length = this.year - 100; i > length; i--) {
        _loop(i, length);
      }
      return children;
    }
  }
});

/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_picker__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_time_title__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_time_body__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_helpers__ = __webpack_require__(0);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-time-picker',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_picker__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_time_body__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_time_title__["a" /* default */]],

  data: function data() {
    return {
      isDragging: false,
      rotate: 0,
      originalTime: this.value,
      period: 'am',
      selectingHour: true,
      ranges: {
        hours: Object(__WEBPACK_IMPORTED_MODULE_3__util_helpers__["c" /* createRange */])(24),
        minutes: Object(__WEBPACK_IMPORTED_MODULE_3__util_helpers__["c" /* createRange */])(60)
      }
    };
  },


  props: {
    format: {
      type: String,
      default: 'ampm',
      validator: function validator(val) {
        return ['ampm', '24hr'].includes(val);
      }
    },
    allowedHours: {
      type: [Array, Object, Function],
      default: function _default() {
        return null;
      }
    },
    allowedMinutes: {
      type: [Array, Object, Function],
      default: function _default() {
        return null;
      }
    }
  },

  computed: {
    is24hr: function is24hr() {
      return this.format !== 'ampm';
    },
    is24hrAfter12: function is24hrAfter12() {
      return this.selectingHour && this.is24hr && this.hour >= 12;
    },
    divider: function divider() {
      return this.selectingHour ? 12 : 60;
    },
    degrees: function degrees() {
      return this.degreesPerUnit * Math.PI / 180;
    },
    degreesPerUnit: function degreesPerUnit() {
      return 360 / this.divider;
    },

    inputTime: {
      get: function get() {
        if (this.value && !(this.value instanceof Date)) {
          if (!this.is24hr) {
            this.period = this.value.match(/pm/) ? 'pm' : 'am';
          }

          return this.value;
        }
        var value = new Date();

        if (this.value instanceof Date) {
          value = this.value;
        }

        var hour = value.getHours();
        var minute = value.getMinutes();
        var period = '';

        if (!this.is24hr) {
          hour = hour > 12 ? hour - 12 : hour;
          period = hour > 12 ? 'pm' : 'am';
        }

        period && (this.period = period);

        hour = this.firstAllowed('hour', hour);
        minute = this.firstAllowed('minute', minute);

        return hour + ':' + minute + period;
      },
      set: function set(val) {
        return this.$emit('input', val);
      }
    },
    timeArray: function timeArray() {
      return this.inputTime.replace(/(am|pm)/, '').split(':');
    },

    hour: {
      get: function get() {
        return parseInt(this.timeArray[0]);
      },
      set: function set(val) {
        if (!this.is24hr) {
          val = val > 12 ? val - 12 : val < 1 ? 12 : val;
        } else {
          val = val < 10 ? '0' + val : val > 23 ? '00' : val;
        }

        this.inputTime = val + ':' + this.minute + (!this.is24hr ? this.period : '');
      }
    },
    minute: {
      get: function get() {
        var minute = parseInt(this.timeArray[1]);

        return minute < 10 ? '0' + minute : minute > 59 ? '00' : minute;
      },
      set: function set(val) {
        val = val < 10 ? '0' + parseInt(val) : val > 59 ? '00' : val;
        var hour = this.hour;

        if (this.is24hr && hour < 10) {
          hour = '0' + hour;
        }

        this.inputTime = hour + ':' + val + (!this.is24hr ? this.period : '');
      }
    },
    clockHand: function clockHand() {
      if (this.selectingHour) return this.degreesPerUnit * this.hour;
      return this.degreesPerUnit * this.minute;
    },
    radius: function radius() {
      return this.clockSize / 2;
    },

    clockSize: {
      get: function get() {
        return this.size;
      },
      set: function set(val) {
        this.size = val;
      }
    },
    size: function size() {
      return this.landscape ? 250 : 280;
    }
  },

  watch: {
    period: function period(val) {
      var hour = !!this.allowedHours && this.selectingHour ? this.firstAllowed('hour', this.hour - 1) : this.hour;
      this.inputTime = hour + ':' + this.minute + val;
    },
    value: function value(val) {
      if (this.isSaving) {
        this.originalTime = this.inputTime;
        this.isSaving = false;
      }
    }
  },

  methods: {
    save: function save() {
      if (this.originalTime) {
        this.originalTime = this.value;
      } else {
        this.inputTime = this.inputTime;
        this.originalTime = this.inputTime;
      }

      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    cancel: function cancel() {
      this.inputTime = this.originalTime;
      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    isAllowed: function isAllowed(type, value) {
      var allowed = this['allowed' + (type.charAt(0).toUpperCase() + type.slice(1)) + 's'];

      if (!allowed) return true;

      if (Array.isArray(allowed)) {
        return !!allowed.find(function (v) {
          return v === value;
        });
      } else if (allowed instanceof Function) {
        return allowed(value);
      } else if (allowed === Object(allowed)) {
        var range = type === 'minute' ? this.ranges.minutes : this.ranges.hours;
        var mod = type === 'minute' ? 60 : 24;

        if (allowed.min === String(allowed.min)) {
          allowed.min = this.convert12to24hr(allowed.min);
        }

        if (allowed.max === String(allowed.max)) {
          allowed.max = this.convert12to24hr(allowed.max);
        }

        var steps = allowed.max - allowed.min;
        value = type === 'hour' && !this.is24hr && this.period === 'pm' ? value + 12 : value;

        for (var i = 0; i <= steps; i++) {
          var index = (allowed.min + i) % mod;
          if (range[index] === value) return true;
        }

        return false;
      }

      return true;
    },
    convert12to24hr: function convert12to24hr(input) {
      input = input.toLowerCase();
      var pm = input.indexOf('pm') !== -1;
      var hour = parseInt(input.slice(0, input.indexOf(pm ? 'pm' : 'am')));

      return pm ? hour + 12 : hour;
    },
    generateRange: function generateRange(type, start) {
      var range = type === 'hour' ? this.ranges.hours : this.ranges.minutes;
      var offset = 1;

      if (type === 'hour' && !this.is24hr) {
        range = range.slice(1, 13);
        offset = 0;
      }

      return range.slice(start + offset, range.length).concat(range.slice(0, start + offset));
    },
    firstAllowed: function firstAllowed(type, value) {
      var _this = this;

      var allowed = this['allowed' + (type.charAt(0).toUpperCase() + type.slice(1)) + 's'];

      if (!allowed) return value;

      var range = this.generateRange(type, value);

      var first = range.find(function (v) {
        return _this.isAllowed(type, v);
      });

      return first || value;
    }
  },

  render: function render(h) {
    var children = [this.genBody()];

    !this.noTitle && children.unshift(this.genTitle());
    this.$scopedSlots.default && children.push(this.genSlot());

    return h('v-card', {
      'class': {
        'picker picker--time': true,
        'picker--landscape': this.landscape,
        'picker--dark': this.dark,
        'picker--light': this.light && !this.dark,
        'picker--time--hours': this.selectingHour
      }
    }, children);
  }
});

/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genTitle: function genTitle() {
      var children = [this.genTime()];

      if (this.format === 'ampm') {
        children.push(this.genAMPM());
      }

      return this.$createElement('div', {
        'class': 'picker__title'
      }, children);
    },
    genTime: function genTime() {
      var _this = this;

      var hour = this.hour;

      if (this.is24hr && hour < 10) {
        hour = '0' + hour;
      }

      return this.$createElement('div', {
        'class': 'picker--time__title'
      }, [this.$createElement('span', {
        'class': { active: this.selectingHour },
        on: {
          click: function click() {
            return _this.selectingHour = true;
          }
        }
      }, hour), this.$createElement('span', {
        'class': { active: !this.selectingHour },
        on: {
          click: function click() {
            return _this.selectingHour = false;
          }
        }
      }, ':' + this.minute)]);
    },
    genAMPM: function genAMPM() {
      return this.$createElement('div', [this.genPeriod('am'), this.genPeriod('pm')]);
    },
    genPeriod: function genPeriod(period) {
      var _this2 = this;

      return this.$createElement('span', {
        'class': { active: this.period === period },
        on: { click: function click() {
            return _this2.period = period;
          } }
      }, period.toUpperCase());
    }
  }
});

/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      hasChanged: false
    };
  },

  methods: {
    genBody: function genBody() {
      var _this = this;

      var children = [this.genHand(this.selectingHour ? 'hour' : 'minute')];
      var data = {
        'class': 'picker--time__clock',
        on: {
          mousedown: this.onMouseDown,
          mouseup: this.onMouseUp,
          mouseleave: function mouseleave() {
            _this.isDragging && _this.onMouseUp();
          },
          touchstart: this.onMouseDown,
          touchend: this.onMouseUp,
          mousemove: this.onDragMove,
          touchmove: this.onDragMove
        },
        key: this.selectingHour ? 'hour' : 'minute',
        ref: 'clock'
      };

      this.selectingHour && children.push(this.genHours()) || children.push(this.genMinutes());

      if (this.scrollable) {
        data.on.wheel = function (e) {
          e.preventDefault();

          var diff = e.wheelDelta > 0 ? 1 : -1;
          var changing = _this.selectingHour ? 'changeHour' : 'changeMinute';

          _this[changing](diff);
        };
      }

      return this.$createElement('div', {
        'class': 'picker__body'
      }, [this.$createElement('v-fade-transition', {
        props: { mode: 'out-in' }
      }, [this.$createElement('div', data, children)])]);
    },
    genHand: function genHand(type) {
      var scale = this.is24hrAfter12 ? 'scaleY(0.6)' : '';
      return [this.$createElement('div', {
        'class': 'picker--time__clock-hand ' + type,
        style: {
          transform: 'rotate(' + this.clockHand + 'deg) ' + scale
        }
      })];
    },
    genHours: function genHours() {
      var hours = this.is24hr ? 24 : 12;
      var children = [];
      var start = 0;

      if (hours === 12) {
        hours++;
        start = 1;
      }

      for (var i = start; i < hours; i++) {
        children.push(this.$createElement('span', {
          'class': {
            'active': i === this.hour,
            'disabled': !this.isAllowed('hour', i)
          },
          style: this.getTransform(i),
          domProps: { innerHTML: '<span>' + i + '</span>' }
        }));
      }

      return children;
    },
    genMinutes: function genMinutes() {
      var children = [];

      for (var i = 0; i < 60; i = i + 5) {
        var num = i;

        if (num < 10) num = '0' + num;
        if (num === 60) num = '00';

        children.push(this.$createElement('span', {
          'class': {
            'active': num.toString() === this.minute.toString(),
            'disabled': !this.isAllowed('minute', i)
          },
          style: this.getTransform(i),
          domProps: { innerHTML: '<span>' + num + '</span>' }
        }));
      }

      return children;
    },
    getTransform: function getTransform(i) {
      var _getPosition = this.getPosition(i),
          x = _getPosition.x,
          y = _getPosition.y;

      return { transform: 'translate(' + x + 'px, ' + y + 'px)' };
    },
    getPosition: function getPosition(i) {
      var radiusPercentage = this.selectingHour && this.is24hr && i >= 12 ? 0.5 : 0.8;
      var r = this.radius * radiusPercentage;
      i = this.selectingHour && this.is24hr ? i % 12 : i;
      return {
        x: Math.round(Math.sin(i * this.degrees) * r),
        y: Math.round(-Math.cos(i * this.degrees) * r)
      };
    },
    changeHour: function changeHour(time) {
      var _this2 = this;

      var range = this.generateRange('hour', this.hour);

      time < 0 && (range = range.reverse().slice(1));
      this.hour = range.find(function (h) {
        return _this2.allowedHours ? _this2.isAllowed('hour', h) : true;
      });

      return true;
    },
    changeMinute: function changeMinute(time) {
      var _this3 = this;

      var current = Number(this.minute);
      var range = this.generateRange('minute', current);

      time < 0 && (range = range.reverse().slice(1));
      var minute = range.find(function (m) {
        return _this3.allowedMinutes ? _this3.isAllowed('minute', m) : true;
      });

      this.minute = minute < 10 ? '0' + minute : minute;

      return true;
    },
    onMouseDown: function onMouseDown(e) {
      e.preventDefault();

      this.isDragging = true;
      this.onDragMove(e);
    },
    onMouseUp: function onMouseUp() {
      this.isDragging = false;
      !this.selectingHour && this.autosave && this.save();
      if (this.hasChanged) {
        this.selectingHour = false;
        this.hasChanged = false;
      }
    },
    onDragMove: function onDragMove(e) {
      e.preventDefault();
      if (!this.isDragging && e.type !== 'click') return;

      var rect = this.$refs.clock.getBoundingClientRect();
      var center = { x: rect.width / 2, y: 0 - rect.width / 2 };
      var clientY = 'touches' in e ? e.touches[0].clientY : e.clientY;
      var clientX = 'touches' in e ? e.touches[0].clientX : e.clientX;
      var coords = {
        y: rect.top - clientY,
        x: clientX - rect.left
      };

      var selecting = this.selectingHour ? 'hour' : 'minute';
      var value = Math.round(this.angle(center, coords) / this.degreesPerUnit);

      if (this.selectingHour && this.is24hr) {
        var insideClick = this.euclidean(center, coords) / this.radius < 0.65;
        value = insideClick ? value + 12 : value;

        // Necessary to fix edge case when selecting left part of 0 and 12
        value = this.angle(center, coords) >= 345 ? (value + 12) % 24 : value;
      }

      if (this.isAllowed(selecting, value)) {
        this[selecting] = value;
        this.hasChanged = true;
      }
    },
    euclidean: function euclidean(p0, p1) {
      var dx = Math.abs(p1.x - p0.x);
      var dy = Math.abs(p1.y - p0.y);

      return Math.sqrt(dx * dx + dy * dy);
    },
    angle: function angle(center, p1) {
      var p0 = {
        x: center.x,
        y: center.y + Math.sqrt(Math.abs(p1.x - center.x) * Math.abs(p1.x - center.x) + Math.abs(p1.y - center.y) * Math.abs(p1.y - center.y))
      };

      var value = 2 * Math.atan2(p1.y - p0.y, p1.x - p0.x);
      return Math.abs(value * 180 / Math.PI);
    }
  }
});

/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VDialog__ = __webpack_require__(65);


/* harmony default export */ __webpack_exports__["a"] = ({
  VDialog: __WEBPACK_IMPORTED_MODULE_0__VDialog__["a" /* default */]
});

/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_bootable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_overlayable__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_toggleable__ = __webpack_require__(2);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-dialog',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_bootable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_overlayable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_toggleable__["a" /* default */]],

  props: {
    disabled: Boolean,
    persistent: Boolean,
    fullscreen: Boolean,
    fullWidth: Boolean,
    lazy: Boolean,
    origin: {
      type: String,
      default: 'center center'
    },
    width: {
      type: [String, Number],
      default: 290
    },
    scrollable: Boolean,
    transition: {
      type: [String, Boolean],
      default: 'dialog-transition'
    }
  },

  computed: {
    classes: function classes() {
      return {
        'dialog': true,
        'dialog--active': this.isActive,
        'dialog--persistent': this.persistent,
        'dialog--fullscreen': this.fullscreen,
        'dialog--stacked-actions': this.stackedActions && !this.fullscreen,
        'dialog--scrollable': this.scrollable
      };
    }
  },

  watch: {
    isActive: function isActive(val) {
      if (val) {
        !this.fullscreen && !this.hideOverlay && this.genOverlay();
        this.fullscreen && this.hideScroll();
      } else {
        if (!this.fullscreen) this.removeOverlay();else this.showScroll();
      }
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.isBooted = this.isActive;
    this.$vuetify.load(function () {
      return _this.isActive && _this.genOverlay();
    });
  },


  methods: {
    closeConditional: function closeConditional(e) {
      // close dialog if !persistent and clicked outside
      return !this.persistent;
    }
  },

  render: function render(h) {
    var _this2 = this;

    var children = [];
    var data = {
      'class': this.classes,
      ref: 'dialog',
      directives: [{ name: 'click-outside', value: this.closeConditional }, { name: 'show', value: this.isActive }]
    };

    if (!this.fullscreen) {
      data.style = {
        width: isNaN(this.width) ? this.width : this.width + 'px'
      };
    }

    if (this.$slots.activator) {
      children.push(h('div', {
        'class': 'dialog__activator',
        on: {
          click: function click(e) {
            e.stopPropagation();
            if (!_this2.disabled) _this2.isActive = !_this2.isActive;
          }
        }
      }, [this.$slots.activator]));
    }

    var dialog = h('transition', {
      props: {
        name: this.transition || '', // If false, show nothing
        origin: this.origin
      }
    }, [h('div', data, this.showLazyContent(this.$slots.default))]);

    children.push(h('div', {
      'class': ('dialog__content ' + this.contentClass).trim(),
      ref: 'content'
    }, [dialog]));

    return h('div', {
      'class': 'dialog__container',
      style: {
        display: !this.$slots.activator && 'none' || this.fullWidth ? 'block' : 'inline-block'
      }
    }, children);
  }
});

/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VDivider__ = __webpack_require__(67);


/* harmony default export */ __webpack_exports__["a"] = ({
  VDivider: __WEBPACK_IMPORTED_MODULE_0__VDivider__["a" /* default */]
});

/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    inset: Boolean
  },

  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;

    data.staticClass = ('divider ' + (data.staticClass || '')).trim();

    if (props.dark) data.staticClass += ' theme--dark';
    if (props.inset) data.staticClass += ' divider--inset';
    if (props.light) data.staticClass += ' theme--light';

    return h('hr', data);
  }
});

/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VExpansionPanel__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VExpansionPanelContent__ = __webpack_require__(70);



/* harmony default export */ __webpack_exports__["a"] = ({
  VExpansionPanel: __WEBPACK_IMPORTED_MODULE_0__VExpansionPanel__["a" /* default */],
  VExpansionPanelContent: __WEBPACK_IMPORTED_MODULE_1__VExpansionPanelContent__["a" /* default */]
});

/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-expansion-panel',

  props: {
    expand: Boolean
  },

  computed: {
    params: function params() {
      return {
        expand: this.expand
      };
    }
  },

  render: function render(h) {
    return h('ul', {
      'class': 'expansion-panel'
    }, this.$slots.default);
  }
});

/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-expansion-panel-content',

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  data: function data() {
    return {
      height: 'auto'
    };
  },


  props: {
    ripple: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'expansion-panel__header': true,
        'expansion-panel__header--active': this.isActive
      };
    }
  },

  methods: {
    closeConditional: function closeConditional(e) {
      return this.$parent.$el.contains(e.target) && !this.$parent.expand && !this.$el.contains(e.target);
    },
    toggle: function toggle() {
      this.isActive = !this.isActive;
    },
    genHeader: function genHeader(h) {
      var _this = this;

      return h('div', {
        class: this.classes,
        directives: [{
          name: 'click-outside',
          value: this.closeConditional
        }, {
          name: 'ripple',
          value: this.ripple
        }],
        on: {
          click: function click() {
            _this.isActive = !_this.isActive;
          }
        }
      }, [this.$slots.header]);
    },
    genBody: function genBody(h) {
      return h('div', {
        ref: 'body',
        class: 'expansion-panel__body',
        directives: [{
          name: 'show',
          value: this.isActive
        }]
      }, [this.$slots.default]);
    }
  },

  render: function render(h) {
    var children = [];

    this.$slots.header && children.push(this.genHeader(h));
    children.push(h(__WEBPACK_IMPORTED_MODULE_0__components_transitions__["a" /* VExpandTransition */], [this.genBody(h)]));

    return h('li', children);
  }
});

/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


/* harmony default export */ __webpack_exports__["a"] = ({
  enter: function enter(el, done) {
    // Remove initial transition
    el.style.transition = 'none';
    Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["a" /* addOnceEventListener */])(el, 'transitionend', done);

    // Get height that is to be scrolled
    el.style.overflow = 'hidden';
    el.style.height = null;
    el.style.display = 'block';
    var height = el.clientHeight + 'px';
    el.style.height = 0;
    el.style.transition = null;

    setTimeout(function () {
      return el.style.height = height;
    }, 50);
  },
  afterEnter: function afterEnter(el) {
    el.style.height = 'auto';
    el.style.overflow = null;
  },
  leave: function leave(el, done) {
    // Remove initial transition
    el.style.transition = 'none';
    Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["a" /* addOnceEventListener */])(el, 'transitionend', done);

    // Set height before we transition to 0
    el.style.overflow = 'hidden';
    el.style.height = el.clientHeight + 'px';
    el.style.transition = null;

    setTimeout(function () {
      return el.style.height = 0;
    }, 50);
  }
});

/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VFooter__ = __webpack_require__(73);


/* harmony default export */ __webpack_exports__["a"] = ({
  VFooter: __WEBPACK_IMPORTED_MODULE_0__VFooter__["a" /* default */]
});

/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  props: {
    absolute: Boolean,
    fixed: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('footer ' + (data.staticClass || '')).trim();

    if (props.absolute) data.staticClass += ' footer--absolute';
    if (props.fixed) data.staticClass += ' footer--fixed';

    return h('footer', data, children);
  }
});

/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


var Grid = function Grid(name) {
  return {
    functional: true,

    props: {
      id: String
    },

    render: function render(h, _ref) {
      var props = _ref.props,
          data = _ref.data,
          children = _ref.children;

      data.staticClass = (name + ' ' + (data.staticClass || '')).trim();

      if (data.attrs) {
        data.staticClass += ' ' + Object.keys(data.attrs).join(' ');
        delete data.attrs;
      }

      if (props.id) {
        data.domProps = data.domProps || {};
        data.domProps.id = props.id;
      }

      return h('div', data, children);
    }
  };
};

var VContainer = Grid('container');
var VFlex = Grid('flex');
var VLayout = Grid('layout');
var VSpacer = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('spacer');

/* harmony default export */ __webpack_exports__["a"] = ({
  VContainer: VContainer,
  VFlex: VFlex,
  VLayout: VLayout,
  VSpacer: VSpacer
});

/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VIcon__ = __webpack_require__(3);


/* harmony default export */ __webpack_exports__["a"] = ({
  VIcon: __WEBPACK_IMPORTED_MODULE_0__VIcon__["a" /* default */]
});

/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-list-group',

  inject: ['listClick', 'listClose'],

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  data: function data() {
    return {
      isBooted: this.value
    };
  },


  props: {
    group: String,
    lazy: Boolean,
    noAction: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'list--group__header': true,
        'list--group__header--active': this.isActive,
        'list--group__header--no-action': this.noAction
      };
    }
  },

  watch: {
    isActive: function isActive() {
      this.isBooted = true;

      if (!this.isActive) {
        this.listClose(this._uid);
      }
    },
    $route: function $route(to) {
      var isActive = this.matchRoute(to.path);

      if (this.group) {
        if (isActive && this.isActive !== isActive) {
          this.listClick(this._uid);
        }
        this.isActive = isActive;
      }
    }
  },

  mounted: function mounted() {
    if (this.group) {
      this.isActive = this.matchRoute(this.$route.path);
    }

    if (this.isActive) {
      this.listClick(this._uid);
    }
  },


  methods: {
    click: function click() {
      var _this = this;

      if (!this.$refs.item.querySelector('.list__tile--disabled')) {
        requestAnimationFrame(function () {
          return _this.listClick(_this._uid);
        });
      }
    },
    toggle: function toggle(uid) {
      this.isActive = this._uid === uid;
    },
    matchRoute: function matchRoute(to) {
      if (!this.group) return false;
      return to.match(this.group) !== null;
    }
  },

  render: function render(h) {
    var group = h('ul', {
      'class': 'list list--group',
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      ref: 'group'
    }, [this.lazy && !this.isBooted ? null : this.$slots.default]);

    var item = h('div', {
      'class': this.classes,
      on: Object.assign({}, { click: this.click }, this.$listeners),
      ref: 'item'
    }, [this.$slots.item]);

    var transition = h(__WEBPACK_IMPORTED_MODULE_0__components_transitions__["a" /* VExpandTransition */], [group]);

    return h('div', { 'class': 'list--group__container' }, [item, transition]);
  }
});

/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


function directive(el, binding) {
  var config = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["f" /* directiveConfig */])(binding, {
    icon: false,
    left: false,
    bottom: false,
    overlap: false,
    visible: true
  });

  if (!config.visible || binding.expression && !binding.value) {
    return unbind(el);
  }

  if (config.overlap) el.classList.add('badge--overlap');
  if (config.icon) el.classList.add('badge--icon');
  if (config.left) el.classList.add('badge--left');
  if (config.bottom) el.classList.add('badge--bottom');

  el.dataset.badge = config.value;
  el.classList.add('badge');
}

function unbind(el) {
  el.removeAttribute('data-badge');
  el.classList.remove('badge');
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: directive,
  updated: directive,
  componentUpdated: directive,
  unbind: unbind
});

/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function inserted(el, binding) {
  var debounce = function debounce(cb) {
    return setTimeout(cb, 50);
  };
  var onResize = function onResize() {
    clearTimeout(debounce);
    debounce(binding.value);
  };

  window.addEventListener('resize', onResize, { passive: true });
  el._onResize = onResize;
}

function unbind(el, binding) {
  window.removeEventListener('resize', el._onResize);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  inserted: inserted,
  unbind: unbind
});

/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function inserted(el, binding) {
  var callback = typeof binding.value === 'function' ? binding.value : binding.value.callback;
  var options = binding.value.options || { passive: true };
  var target = binding.value.target || window;
  if (target === 'undefined') return;

  if (target !== window) {
    target = document.querySelector(target);
  }

  target.addEventListener('scroll', callback, options);

  el._onScroll = {
    target: target,
    options: options
  };
}

function unbind(el, binding) {
  var _el$_onScroll = el._onScroll,
      target = _el$_onScroll.target,
      options = _el$_onScroll.options;


  target.removeEventListener('scroll', binding.callback, options);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  inserted: inserted,
  unbind: unbind
});

/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


function directive(el, binding) {
  var config = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["f" /* directiveConfig */])(binding, {
    top: true,
    visible: true
  });

  if (!config.visible || binding.expression && !binding.value) {
    return unbind(el);
  }

  unbind(el, binding, config);

  el.dataset.tooltip = config.html;
  el.dataset['tooltipLocation'] = config.value;
}

function unbind(el) {
  el.removeAttribute('data-tooltip');
  el.removeAttribute('data-tooltip-location');
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: directive,
  updated: directive,
  componentUpdated: directive,
  unbind: unbind
});

/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var touchstart = function touchstart(event, wrapper) {
  var touch = event.changedTouches[0];
  wrapper.touchstartX = touch.clientX;
  wrapper.touchstartY = touch.clientY;

  wrapper.start && wrapper.start(Object.assign(event, wrapper));
};

var touchend = function touchend(event, wrapper) {
  var touch = event.changedTouches[0];
  wrapper.touchendX = touch.clientX;
  wrapper.touchendY = touch.clientY;

  wrapper.end && wrapper.end(Object.assign(event, wrapper));

  handleGesture(wrapper);
};

var touchmove = function touchmove(event, wrapper) {
  var touch = event.changedTouches[0];
  wrapper.touchmoveX = touch.clientX;
  wrapper.touchmoveY = touch.clientY;

  wrapper.move && wrapper.move(Object.assign(event, wrapper));
};

var handleGesture = function handleGesture(wrapper) {
  var touchstartX = wrapper.touchstartX,
      touchendX = wrapper.touchendX,
      touchstartY = wrapper.touchstartY,
      touchendY = wrapper.touchendY;

  wrapper.offsetX = touchendX - touchstartX;
  wrapper.offsetY = touchendY - touchstartY;

  if (touchendX < touchstartX) {
    wrapper.left && wrapper.left(wrapper);
  }
  if (touchendX > touchstartX) {
    wrapper.right && wrapper.right(wrapper);
  }
  if (touchendY < touchstartY) {
    wrapper.up && wrapper.up(wrapper);
  }
  if (touchendY > touchstartY) {
    wrapper.down && wrapper.down(wrapper);
  }
};

function inserted(el, _ref) {
  var value = _ref.value;

  var wrapper = {
    touchstartX: 0,
    touchstartY: 0,
    touchendX: 0,
    touchendY: 0,
    touchmoveX: 0,
    touchmoveY: 0,
    offsetX: 0,
    offsetY: 0,
    left: value.left,
    right: value.right,
    up: value.up,
    down: value.down,
    start: value.start,
    move: value.move,
    end: value.end
  };

  var target = value.parent ? el.parentNode : el;
  var options = value.options || {};

  target.addEventListener('touchstart', function (e) {
    return touchstart(e, wrapper);
  }, options);
  target.addEventListener('touchend', function (e) {
    return touchend(e, wrapper);
  }, options);
  target.addEventListener('touchmove', function (e) {
    return touchmove(e, wrapper);
  }, options);
}

function unbind(el, _ref2) {
  var value = _ref2.value;

  var target = value.parent ? el.parentNode : el;

  if (!target) return;

  target.removeEventListener('touchstart', touchstart);
  target.removeEventListener('touchend', touchend);
  target.removeEventListener('touchmove', touchmove);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  inserted: inserted,
  unbind: unbind
});

/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VMenu_js__ = __webpack_require__(22);


/* harmony default export */ __webpack_exports__["a"] = ({
  VMenu: __WEBPACK_IMPORTED_MODULE_0__VMenu_js__["a" /* default */]
});

/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    getActivator: function getActivator() {
      if (this.activator) return this.activator;
      return this.$refs.activator.children ? this.$refs.activator.children[0] : this.$refs.activator;
    },
    activatorClickHandler: function activatorClickHandler(e) {
      if (this.disabled) return;else if (this.openOnClick && !this.isActive) {
        this.isActive = true;
        this.absoluteX = e.clientX;
        this.absoluteY = e.clientY;
      } else if (this.closeOnClick && this.isActive) this.isActive = false;
    },
    mouseEnterHandler: function mouseEnterHandler(e) {
      if (this.disabled || this.hasJustFocused) return;
      this.hasJustFocused = true;
      this.isActive = true;
    },
    mouseLeaveHandler: function mouseLeaveHandler(e) {
      if (this.isContentActive) return;
      this.isActive = false;
    },
    addActivatorEvents: function addActivatorEvents() {
      var activator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (!activator) return;
      activator.addEventListener('click', this.activatorClickHandler);
    },
    removeActivatorEvents: function removeActivatorEvents() {
      var activator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (!activator) return;
      activator.removeEventListener('click', this.activatorClickHandler);
    }
  }
});

/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genActivator: function genActivator() {
      if (!this.$slots.activator) return null;

      var options = {
        'class': {
          'menu__activator--active': this.hasJustFocused || this.isActive
        },
        staticClass: 'menu__activator',
        ref: 'activator',
        slot: 'activator',
        on: {}
      };

      if (this.openOnHover) {
        options.on['mouseenter'] = this.mouseEnterHandler;
        options.on['mouseleave'] = this.mouseLeaveHandler;
      } else if (this.openOnClick) {
        options.on['click'] = this.activatorClickHandler;
      }

      return this.$createElement('div', options, this.$slots.activator);
    },
    genTransition: function genTransition() {
      return this.$createElement('transition', {
        props: {
          name: this.transition,
          origin: this.origin
        }
      }, [this.genContent()]);
    },
    genContent: function genContent() {
      var _this = this;

      var booted = this.lazy && this.isBooted || !this.lazy;
      return this.$createElement('div', {
        'class': ('menu__content ' + this.contentClass).trim(),
        ref: 'content',
        style: this.styles,
        directives: [{
          name: 'show',
          value: this.isContentActive
        }],
        on: {
          click: function click(e) {
            e.stopPropagation();
            if (e.target.getAttribute('disabled')) return;
            if (_this.closeOnContentClick) _this.isActive = false;
          },
          mouseleave: function mouseleave(e) {
            _this.openOnHover && (_this.isActive = false);
          }
        }
      }, [booted ? this.$slots.default : null]);
    }
  }
});

/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    // Revisit this
    calculateScroll: function calculateScroll() {
      if (this.selectedIndex === null) return;

      var scrollTop = 0;

      if (this.selectedIndex >= this.stopIndex) {
        scrollTop = this.$refs.content.scrollHeight;
      } else if (this.selectedIndex > this.startIndex) {
        scrollTop = this.selectedIndex * 48 - 56;
      }

      this.$refs.content.scrollTop = scrollTop;
    },
    calcLeftAuto: function calcLeftAuto() {
      var a = this.dimensions.activator;

      return parseInt(a.left - 16);
    },
    calcTopAuto: function calcTopAuto() {
      if (!this.hasActivator) return this.calcTop(true);

      var selectedIndex = Array.from(this.tiles).findIndex(function (n) {
        return n.classList.contains('list__tile--active');
      });

      if (selectedIndex === -1) {
        this.selectedIndex = null;

        return this.calcTop(true);
      }

      this.selectedIndex = selectedIndex;
      var actingIndex = selectedIndex;

      var offsetPadding = 1;
      // #708 Stop index should vary by tile length
      this.stopIndex = this.tiles.length > 4 ? this.tiles.length - 4 : this.tiles.length;

      if (selectedIndex > this.startIndex && selectedIndex < this.stopIndex) {
        actingIndex = 2;
        offsetPadding = 41;
      } else if (selectedIndex >= this.stopIndex) {
        offsetPadding = 9;
        actingIndex = selectedIndex - this.stopIndex;
      }

      return this.calcTop(true) + offsetPadding - actingIndex * 48;
    },
    calcLeft: function calcLeft() {
      if (this.auto) return this.calcLeftAuto();

      var a = this.dimensions.activator;
      var c = this.dimensions.content;
      var left = this.left ? a.right - c.width : a.left;

      if (this.offsetX) left += this.left ? -a.width : a.width;
      if (this.nudgeLeft) left += this.nudgeLeft;
      if (this.nudgeRight) left -= this.nudgeRight;

      return this.calcXOverflow(left);
    },
    calcTop: function calcTop(force) {
      if (this.auto && !force) return this.calcTopAuto();

      var a = this.dimensions.activator;
      var c = this.dimensions.content;
      var top = this.top ? a.bottom - c.height : a.top;

      if (this.offsetY) top += this.top ? -a.height : a.height;
      if (this.nudgeTop) top -= this.nudgeTop;
      if (this.nudgeBottom) top += this.nudgeBottom;

      var defined = typeof window !== 'undefined';
      var pageYOffset = defined ? window.pageYOffset : 0;

      return this.calcYOverflow(top) + pageYOffset;
    },
    calcXOverflow: function calcXOverflow(left) {
      var hasWindow = typeof window !== 'undefined';
      var innerWidth = hasWindow ? window.innerWidth : 0;
      var maxWidth = Math.max(this.dimensions.content.width, this.calculatedMinWidth, parseInt(this.maxWidth) || 0);
      var totalWidth = left + maxWidth;
      var availableWidth = totalWidth - innerWidth;

      if ((!this.left || this.right) && availableWidth > 0) {
        left = innerWidth - maxWidth - (innerWidth > 1024 ? 30 : 12) // Account for scrollbar
        ;
      } else if (this.left && left < 0) left = 12;

      return left;
    },
    calcYOverflow: function calcYOverflow(top) {
      var totalHeight = top + this.dimensions.content.height;
      var defined = typeof window !== 'undefined';
      var innerHeight = defined ? window.innerHeight : 0;

      if (this.top && top < 0) top = 12;else if ((!this.top || this.bottom) && innerHeight < totalHeight) {
        top = innerHeight - this.dimensions.content.height;
      }

      return top < 12 ? 12 : top;
    },
    sneakPeek: function sneakPeek(cb) {
      var _this = this;

      requestAnimationFrame(function () {
        var el = _this.$refs.content;
        var currentDisplay = el.style.display;

        el.style.display = 'inline-block';
        cb();
        el.style.display = currentDisplay;
      });
    },
    absolutePosition: function absolutePosition() {
      return {
        offsetTop: 0,
        scrollHeight: 0,
        top: this.positionY || this.absoluteY,
        bottom: this.positionY || this.absoluteY,
        left: this.positionX || this.absoluteX,
        right: this.positionX || this.absoluteX,
        height: 0,
        width: 0
      };
    },
    updateDimensions: function updateDimensions() {
      var _this2 = this;

      this.sneakPeek(function () {
        _this2.dimensions = {
          activator: !_this2.hasActivator || _this2.positionAbsolutely ? _this2.absolutePosition() : _this2.measure(_this2.getActivator()),
          content: _this2.measure(_this2.$refs.content)
        };
      });
    }
  }
});

/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    measure: function measure(el, selector) {
      var getParent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      el = selector ? el.querySelector(selector) : el;

      if (!el) return null;

      var _el$getBoundingClient = el.getBoundingClientRect(),
          top = _el$getBoundingClient.top,
          bottom = _el$getBoundingClient.bottom,
          left = _el$getBoundingClient.left,
          right = _el$getBoundingClient.right,
          height = _el$getBoundingClient.height,
          width = _el$getBoundingClient.width;

      return {
        offsetTop: el.offsetTop,
        scrollHeight: el.scrollHeight,
        top: top, bottom: bottom, left: left, right: right, height: height, width: width
      };
    }
  }
});

/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      listIndex: -1,
      isUsingKeys: false,
      tiles: []
    };
  },

  watch: {
    isActive: function isActive(val) {
      if (!val) this.listIndex = -1;
    },
    listIndex: function listIndex(next, prev) {
      // For infinite scroll and autocomplete, re-evaluate children
      this.getTiles();

      if (next in this.tiles) {
        this.tiles[next].classList.add('list__tile--highlighted');
        this.$refs.content.scrollTop = next * 48;
      }

      prev in this.tiles && this.tiles[prev].classList.remove('list__tile--highlighted');
    }
  },

  methods: {
    changeListIndex: function changeListIndex(e) {
      [40, 38, 13].includes(e.keyCode) && e.preventDefault();
      e.keyCode === 32 && !this.isActive && e.preventDefault();

      if (this.listIndex === -1) this.setActiveListIndex();
      if ([27, 9].includes(e.keyCode)) return this.isActive = false;else if (!this.isActive && [13, 32].includes(e.keyCode)) {
        return this.isActive = true;
      }

      if (e.keyCode === 40 && this.listIndex < this.tiles.length - 1) {
        this.listIndex++;
      } else if (e.keyCode === 38 && this.listIndex > 0) {
        this.listIndex--;
      } else if (e.keyCode === 13 && this.listIndex !== -1) {
        this.tiles[this.listIndex].click();
      }
    },
    getTiles: function getTiles() {
      this.tiles = this.$refs.content.querySelectorAll('.list__tile');
    },
    setActiveListIndex: function setActiveListIndex() {
      var _this = this;

      this.tiles.forEach(function (t, i) {
        if (t.classList.contains('list__tile--active')) {
          _this.listIndex = i;
          return;
        }
      });
    }
  }
});

/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VNavigationDrawer__ = __webpack_require__(89);


/* harmony default export */ __webpack_exports__["a"] = ({
  VNavigationDrawer: __WEBPACK_IMPORTED_MODULE_0__VNavigationDrawer__["a" /* default */]
});

/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_overlayable__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__directives__ = __webpack_require__(4);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-navigation-drawer',

  directives: {
    Resize: __WEBPACK_IMPORTED_MODULE_2__directives__["Resize"]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_overlayable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      isActive: this.value,
      isBooted: false,
      isMobile: false,
      touchArea: {
        left: 0,
        right: 0
      }
    };
  },


  props: {
    absolute: Boolean,
    clipped: Boolean,
    disableRouteWatcher: Boolean,
    enableResizeWatcher: Boolean,
    height: String,
    floating: Boolean,
    miniVariant: Boolean,
    mobileBreakPoint: {
      type: Number,
      default: 1024
    },
    permanent: Boolean,
    persistent: Boolean,
    right: Boolean,
    temporary: Boolean,
    touchless: Boolean,
    value: { required: false }
  },

  computed: {
    calculatedHeight: function calculatedHeight() {
      return this.height || '100%';
    },
    classes: function classes() {
      return {
        'navigation-drawer': true,
        'navigation-drawer--absolute': this.absolute,
        'navigation-drawer--clipped': this.clipped,
        'navigation-drawer--close': !this.isActive,
        'navigation-drawer--floating': this.floating,
        'navigation-drawer--is-booted': this.isBooted,
        'navigation-drawer--is-mobile': this.isMobile,
        'navigation-drawer--mini-variant': this.miniVariant,
        'navigation-drawer--open': this.isActive,
        'navigation-drawer--permanent': this.permanent,
        'navigation-drawer--persistent': this.persistent,
        'navigation-drawer--right': this.right,
        'navigation-drawer--temporary': this.temporary,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    },
    showOverlay: function showOverlay() {
      return !this.permanent && this.isActive && (this.temporary || this.isMobile);
    }
  },

  watch: {
    $route: function $route() {
      if (!this.disableRouteWatcher) {
        this.isActive = !this.closeConditional();
      }
    },
    isActive: function isActive(val) {
      this.$emit('input', val);
      this.showOverlay && val && this.genOverlay() || this.removeOverlay();
      this.$el.scrollTop = 0;
    },
    isMobile: function isMobile(val) {
      !val && this.removeOverlay();
    },
    permanent: function permanent(val) {
      this.$emit('input', val);
    },
    value: function value(val) {
      if (this.permanent) return;
      if (val !== this.isActive) this.isActive = val;
    }
  },

  mounted: function mounted() {
    this.$vuetify.load(this.init);
  },


  methods: {
    init: function init() {
      var _this = this;

      this.checkIfMobile();
      setTimeout(function () {
        return _this.isBooted = true;
      }, 0);

      if (this.permanent) this.isActive = true;else if (this.isMobile) this.isActive = false;else if (!this.value && (this.persistent || this.temporary)) this.isActive = false;
    },
    checkIfMobile: function checkIfMobile() {
      this.isMobile = window.innerWidth < parseInt(this.mobileBreakPoint);
    },
    closeConditional: function closeConditional() {
      return !this.permanent && (this.temporary || this.isMobile);
    },
    onResize: function onResize() {
      var _this2 = this;

      clearTimeout(this.resizeTimeout);

      if (!this.enableResizeWatcher || this.permanent || this.temporary) return;

      this.resizeTimeout = setTimeout(function () {
        _this2.checkIfMobile();
        _this2.isActive = !_this2.isMobile;
      }, 200);
    },
    swipeRight: function swipeRight(e) {
      if (this.isActive && !this.right) return;
      this.calculateTouchArea();

      if (Math.abs(e.touchendX - e.touchstartX) < 100) return;else if (!this.right && e.touchstartX <= this.touchArea.left) this.isActive = true;else if (this.right && this.isActive) this.isActive = false;
    },
    swipeLeft: function swipeLeft(e) {
      if (this.isActive && this.right) return;
      this.calculateTouchArea();

      if (Math.abs(e.touchendX - e.touchstartX) < 100) return;else if (this.right && e.touchstartX >= this.touchArea.right) this.isActive = true;else if (!this.right && this.isActive) this.isActive = false;
    },
    calculateTouchArea: function calculateTouchArea() {
      if (!this.$el.parentNode) return;
      var parentRect = this.$el.parentNode.getBoundingClientRect();

      this.touchArea = {
        left: parentRect.left + 50,
        right: parentRect.right - 50
      };
    },
    genDirectives: function genDirectives() {
      var directives = [{
        name: 'click-outside',
        value: this.closeConditional
      }, {
        name: 'resize',
        value: this.onResize
      }];

      !this.touchless && directives.push({
        name: 'touch',
        value: {
          parent: true,
          left: this.swipeLeft,
          right: this.swipeRight
        }
      });

      return directives;
    }
  },

  render: function render(h) {
    var _this3 = this;

    var data = {
      'class': this.classes,
      style: { height: this.calculatedHeight },
      directives: this.genDirectives(),
      on: Object.assign({}, {
        click: function click() {
          return _this3.$emit('update:miniVariant', false);
        }
      }, this.$listeners)
    };

    return h('aside', data, [this.$slots.default, h('div', { 'class': 'navigation-drawer__border' })]);
  }
});

/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VSystemBar__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VToolbar__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VToolbarSideIcon__ = __webpack_require__(93);






var VToolbarTitle = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('toolbar__title');
var VToolbarItems = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('toolbar__items');

/* harmony default export */ __webpack_exports__["a"] = ({
  VSystemBar: __WEBPACK_IMPORTED_MODULE_1__VSystemBar__["a" /* default */],
  VToolbar: __WEBPACK_IMPORTED_MODULE_2__VToolbar__["a" /* default */],
  VToolbarItems: VToolbarItems,
  VToolbarTitle: VToolbarTitle,
  VToolbarSideIcon: __WEBPACK_IMPORTED_MODULE_3__VToolbarSideIcon__["a" /* default */]
});

/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    lightsOut: Boolean,
    status: Boolean,
    window: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('system-bar ' + (data.staticClass || '')).trim();

    if (props.dark) data.staticClass += ' theme--dark';
    if (props.light) data.staticClass += ' theme--light';
    if (props.status) data.staticClass += ' system-bar--status';
    if (props.window) data.staticClass += ' system-bar--window';
    if (props.lightsOut) data.staticClass += ' system-bar--lights-out';

    return h('div', data, children);
  }
});

/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-toolbar',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      isExtended: false,
      isScrolling: false,
      marginTop: 0,
      previousScroll: null,
      target: null
    };
  },

  props: {
    absolute: Boolean,
    card: Boolean,
    dense: Boolean,
    extended: Boolean,
    fixed: Boolean,
    flat: Boolean,
    floating: Boolean,
    prominent: Boolean,
    scrollOffScreen: Boolean,
    scrollTarget: String,
    scrollThreshHold: {
      type: Number,
      default: 100
    }
  },

  computed: {
    classes: function classes() {
      return {
        'toolbar': true,
        'elevation-0': this.flat,
        'toolbar--absolute': this.absolute,
        'toolbar--card': this.card,
        'toolbar--dense': this.dense,
        'toolbar--fixed': this.fixed,
        'toolbar--floating': this.floating,
        'toolbar--prominent': this.prominent,
        'toolbar--extended': this.isExtended,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    },
    styles: function styles() {
      return {
        marginTop: this.marginTop
      };
    }
  },

  watch: {
    isScrolling: function isScrolling(val) {
      if (!val) this.marginTop = 0;else this.marginTop = -this.$refs.content.clientHeight - 6 + 'px';
    }
  },

  methods: {
    onScroll: function onScroll() {
      if (typeof window === 'undefined') return;

      if (!this.target) {
        this.target = this.scrollTarget ? document.querySelector(this.scrollTarget) : window;
      }

      var currentScroll = this.scrollTarget ? this.target.scrollTop : this.target.pageYOffset || document.documentElement.scrollTop;

      if (currentScroll < this.scrollThreshHold) return;

      if (this.previousScroll === null) {
        this.previousScroll = currentScroll;
      }

      this.isScrolling = this.previousScroll < currentScroll;

      this.previousScroll = currentScroll;
    }
  },

  render: function render(h) {
    this.isExtended = this.extended || !!this.$slots.extension;
    var children = [];
    var data = {
      'class': this.classes,
      style: this.styles,
      on: this.$listeners
    };

    if (this.scrollOffScreen) {
      data.directives = [{
        name: 'scroll',
        value: {
          callback: this.onScroll,
          target: this.scrollTarget
        }
      }];
    }

    children.push(h('div', {
      'class': 'toolbar__content',
      ref: 'content'
    }, this.$slots.default));

    if (this.isExtended) {
      children.push(h('div', {
        'class': 'toolbar__extension'
      }, this.$slots.extension));
    }

    return h('nav', data, children);
  }
});

/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-toolbar-side-icon',

  functional: true,

  render: function render(h, _ref) {
    var slots = _ref.slots,
        listeners = _ref.listeners,
        props = _ref.props;

    var data = {
      staticClass: 'toolbar__side-icon',
      props: Object.assign(props, {
        icon: true
      }),
      on: listeners
    };

    var defaultSlot = slots().default;

    return h(__WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__["a" /* default */], data, defaultSlot || [h(__WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__["a" /* default */], 'menu')]);
  }
});

/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VPagination__ = __webpack_require__(95);


/* harmony default export */ __webpack_exports__["a"] = ({
  VPagination: __WEBPACK_IMPORTED_MODULE_0__VPagination__["a" /* default */]
});

/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__ = __webpack_require__(3);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-pagination',

  props: {
    circle: Boolean,
    disabled: Boolean,
    length: {
      type: Number,
      default: 0,
      validator: function validator(val) {
        return val % 1 === 0;
      }
    },
    value: {
      type: Number,
      default: 0
    },
    prevIcon: {
      type: String,
      default: 'chevron_left'
    },
    nextIcon: {
      type: String,
      default: 'chevron_right'
    }
  },

  watch: {
    value: function value() {
      this.init();
    }
  },

  computed: {
    classes: function classes() {
      return {
        'pagination': true,
        'pagination--circle': this.circle,
        'pagination--disabled': this.disabled
      };
    },
    items: function items() {
      if (this.length <= 5) {
        return this.range(1, this.length);
      }

      var min = this.value - 3;
      min = min > 0 ? min : 1;

      var max = min + 6;
      max = max <= this.length ? max : this.length;

      if (max === this.length) {
        min = this.length - 6;
      }

      var range = this.range(min, max);

      if (this.value >= 4 && this.length > 6) {
        range.splice(0, 2, 1, '...');
      }

      if (this.value + 3 < this.length && this.length > 6) {
        range.splice(range.length - 2, 2, '...', this.length);
      }

      return range;
    }
  },

  mounted: function mounted() {
    this.$vuetify.load.call(this, this.init);
  },


  methods: {
    init: function init() {
      var _this = this;

      this.selected = null;

      // Change this
      setTimeout(function () {
        return _this.selected = _this.value;
      }, 100);
    },
    next: function next(e) {
      e.preventDefault();
      this.$emit('input', this.value + 1);
      this.$emit('next');
    },
    previous: function previous(e) {
      e.preventDefault();
      this.$emit('input', this.value - 1);
      this.$emit('previous');
    },
    range: function range(from, to) {
      var range = [];

      from = from > 0 ? from : 1;

      for (var i = from; i <= to; i++) {
        range.push(i);
      }

      return range;
    },
    genIcon: function genIcon(h, icon, disabled, fn) {
      return h('li', [h('a', {
        class: {
          'pagination__navigation': true,
          'pagination__navigation--disabled': disabled
        },
        attrs: { href: '#!' },
        on: { click: fn }
      }, [h(__WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__["a" /* default */], [icon])])]);
    },
    genItem: function genItem(h, i) {
      var _this2 = this;

      return h('a', {
        class: {
          'pagination__item': true,
          'pagination__item--active': i === this.value
        },
        attrs: { href: '#!' },
        on: {
          click: function click(e) {
            e.preventDefault();
            _this2.$emit('input', i);
          }
        }
      }, [i]);
    },
    genItems: function genItems(h) {
      var _this3 = this;

      return this.items.map(function (i) {
        return h('li', [isNaN(i) && h('span', { class: 'pagination__more' }, [i]) || _this3.genItem(h, i)]);
      });
    }
  },

  render: function render(h) {
    var children = [this.genIcon(h, this.prevIcon, this.value === 1, this.previous), this.genItems(h), this.genIcon(h, this.nextIcon, this.value === this.length, this.next)];

    return h('ul', { class: this.classes }, children);
  }
});

/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VParallax__ = __webpack_require__(97);


/* harmony default export */ __webpack_exports__["a"] = ({
  VParallax: __WEBPACK_IMPORTED_MODULE_0__VParallax__["a" /* default */]
});

/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_translatable__ = __webpack_require__(98);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-parallax',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_translatable__["a" /* default */]],

  props: {
    height: {
      type: [String, Number],
      default: 500
    },
    src: String
  },

  computed: {
    styles: function styles() {
      return {
        display: 'block',
        transform: 'translate3d(-50%, ' + this.parallax + 'px, 0)'
      };
    }
  },

  methods: {
    init: function init() {
      var _this = this;

      if (!this.$refs.img) return;

      if (this.$refs.img.complete) {
        this.translate();
        this.listeners();
      } else {
        this.$refs.img.addEventListener('load', function () {
          _this.translate();
          _this.listeners();
        }, false);
      }
    },
    objHeight: function objHeight() {
      return this.$refs.img.naturalHeight;
    },
    elOffsetTop: function elOffsetTop() {
      return this.$el.offsetTop;
    }
  },

  render: function render(h) {
    var container = h('div', {
      staticClass: 'parallax__image-container'
    }, [h('img', {
      staticClass: 'parallax__image',
      style: this.styles,
      attrs: {
        src: this.src
      },
      ref: 'img'
    })]);

    var content = h('div', {
      staticClass: 'parallax__content'
    }, this.$slots.default);

    return h('div', {
      staticClass: 'parallax',
      style: {
        height: parseInt(this.normalizedHeight) + 'px'
      },
      on: this.$listeners
    }, [container, content]);
  }
});

/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      parallax: null,
      parallaxDist: null,
      percentScrolled: null,
      scrollTop: null,
      windowHeight: null,
      windowBottom: null
    };
  },


  computed: {
    normalizedHeight: function normalizedHeight() {
      return Number(this.height.toString().replace(/(^[0-9]*$)/, '$1'));
    },
    imgHeight: function imgHeight() {
      return this.objHeight();
    }
  },

  mounted: function mounted() {
    this.$vuetify.load(this.init);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('scroll', this.translate, false);
    window.removeEventListener('resize', this.translate, false);
  },


  methods: {
    listeners: function listeners() {
      window.addEventListener('scroll', this.translate, false);
      window.addEventListener('resize', this.translate, false);
    },
    translate: function translate() {
      this.calcDimensions();

      this.percentScrolled = (this.windowBottom - this.elOffsetTop) / (this.normalizedHeight + this.windowHeight);

      this.parallax = Math.round(this.parallaxDist * this.percentScrolled);

      if (this.translated) {
        this.translated();
      }
    },
    calcDimensions: function calcDimensions() {
      var offset = this.$el.getBoundingClientRect();

      this.scrollTop = window.pageYOffset;
      this.parallaxDist = this.imgHeight - this.normalizedHeight;
      this.elOffsetTop = offset.top + this.scrollTop;
      this.windowHeight = window.innerHeight;
      this.windowBottom = this.scrollTop + this.windowHeight;
    }
  }
});

/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VProgressLinear__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VProgressCircular__ = __webpack_require__(100);



/* harmony default export */ __webpack_exports__["a"] = ({
  VProgressLinear: __WEBPACK_IMPORTED_MODULE_0__VProgressLinear__["a" /* default */],
  VProgressCircular: __WEBPACK_IMPORTED_MODULE_1__VProgressCircular__["a" /* default */]
});

/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _this = this;

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-progress-circular',

  props: {
    button: Boolean,

    fill: {
      type: String,
      default: function _default() {
        return _this.indeterminate ? 'none' : 'transparent';
      }
    },

    indeterminate: Boolean,

    rotate: {
      type: Number,
      default: 0
    },

    size: {
      type: [Number, String],
      default: 32
    },

    width: {
      type: Number,
      default: 4
    },

    value: {
      type: Number,
      default: 0
    }
  },

  computed: {
    calculatedSize: function calculatedSize() {
      var size = Number(this.size);

      if (this.button) {
        size += 8;
      }

      return size;
    },
    circumference: function circumference() {
      return 2 * Math.PI * this.radius;
    },
    classes: function classes() {
      return {
        'progress-circular': true,
        'progress-circular--indeterminate': this.indeterminate,
        'progress-circular--button': this.button
      };
    },
    cxy: function cxy() {
      return this.indeterminate && !this.button ? 50 : this.calculatedSize / 2;
    },
    normalizedValue: function normalizedValue() {
      if (this.value < 0) {
        return 0;
      }

      if (this.value > 100) {
        return 100;
      }

      return this.value;
    },
    radius: function radius() {
      return this.indeterminate && !this.button ? 20 : (this.calculatedSize - this.width) / 2;
    },
    strokeDashArray: function strokeDashArray() {
      return Math.round(this.circumference * 1000) / 1000;
    },
    strokeDashOffset: function strokeDashOffset() {
      return (100 - this.normalizedValue) / 100 * this.circumference + 'px';
    },
    styles: function styles() {
      return {
        height: this.calculatedSize + 'px',
        width: this.calculatedSize + 'px'
      };
    },
    svgSize: function svgSize() {
      return this.indeterminate ? false : this.calculatedSize;
    },
    svgStyles: function svgStyles() {
      return {
        transform: 'rotate(' + this.rotate + 'deg)'
      };
    },
    viewBox: function viewBox() {
      return this.indeterminate ? '25 25 50 50' : false;
    }
  },

  methods: {
    genCircle: function genCircle(h, name, offset) {
      return h('circle', {
        class: 'progress-circular__' + name,
        attrs: {
          fill: 'transparent',
          cx: this.cxy,
          cy: this.cxy,
          r: this.radius,
          'stroke-width': this.width,
          'stroke-dasharray': this.strokeDashArray,
          'stroke-dashoffset': offset
        }
      });
    },
    genSvg: function genSvg(h) {
      var children = [!this.indeterminate && this.genCircle(h, 'underlay', 0), this.genCircle(h, 'overlay', this.strokeDashOffset)];

      return h('svg', {
        style: this.svgStyles,
        attrs: {
          xmlns: 'http://www.w3.org/2000/svg',
          height: this.svgSize,
          width: this.svgSize,
          viewBox: this.viewBox
        }
      }, children);
    }
  },

  render: function render(h) {
    var info = h('div', { class: 'progress-circular__info' }, [this.$slots.default]);
    var svg = this.genSvg(h);

    return h('div', {
      class: this.classes,
      style: this.styles,
      on: this.$listeners
    }, [svg, info]);
  }
});

/*
<template lang="pug">
  div(
    class="progress-circular"
    v-bind:class="classes"
    v-bind:style="styles"
    v-on="$listeners"
  )
    svg(
      xmlns="http://www.w3.org/2000/svg"
      v-bind:height="svgSize"
      v-bind:width="svgSize"
      v-bind:viewBox="viewBox"
      v-bind:style="svgStyles"
    )
      circle(
        class="progress-circular__underlay"
        fill="transparent"
        v-bind:cx="cxy"
        v-bind:cy="cxy"
        v-bind:r="radius"
        v-bind:stroke-width="width"
        v-bind:stroke-dasharray="strokeDashArray"
        v-bind:stroke-dashoffset="0"
        v-if="!indeterminate"
      )
      circle(
        class="progress-circular__overlay"
        v-bind:fill="fill"
        v-bind:cx="cxy"
        v-bind:cy="cxy"
        v-bind:r="radius"
        v-bind:stroke-width="width"
        v-bind:stroke-dasharray="strokeDashArray"
        v-bind:stroke-dashoffset="strokeDashOffset"
      )
    div(class="progress-circular__info")
      slot
</template>
*/

/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSelect__ = __webpack_require__(24);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSelect: __WEBPACK_IMPORTED_MODULE_0__VSelect__["a" /* default */]
});

/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    filterSearch: function filterSearch() {
      var _this = this;

      return this.items.filter(function (i) {
        var text = _this.getText(i);
        if (typeof text !== 'string') return false;

        return text.toLowerCase().indexOf(_this.searchValue.toLowerCase()) !== -1;
      });
    },
    onKeyDown: function onKeyDown(e) {
      this.$refs.menu.changeListIndex(e);
    }
  }
});

/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genMenu: function genMenu() {
      var _this = this;

      var offsetY = this.autocomplete || this.offset || this.isDropdown;
      var data = {
        ref: 'menu',
        props: {
          activator: this.$refs.activator,
          auto: this.auto,
          closeOnClick: false,
          closeOnContentClick: !this.multiple,
          contentClass: this.computedContentClass,
          disabled: this.disabled,
          maxHeight: this.maxHeight,
          nudgeTop: this.isDropdown ? 22 : offsetY ? 38 : 0,
          offsetY: offsetY,
          value: this.isActive
        },
        on: { input: function input(val) {
            return _this.isActive = val;
          } }
      };

      this.minWidth && (data.props.minWidth = this.minWidth);

      return this.$createElement('v-menu', data, [this.genList()]);
    },
    genSelectionsAndSearch: function genSelectionsAndSearch() {
      var _this2 = this;

      var input = void 0;

      if (this.autocomplete || this.editable) {
        input = this.$createElement('input', {
          'class': 'input-group--select__autocomplete',
          domProps: { value: this.searchValue },
          on: { input: function input(e) {
              return _this2.searchValue = e.target.value;
            } },
          attrs: { tabindex: -1 },
          ref: 'input',
          key: 'input'
        });
      }

      var selections = this.isDirty && (!this.editable || this.editable && !this.focused) ? this.genSelections() : [];
      input && selections.push(input);
      var group = this.$createElement('div', selections);

      return this.$createElement('div', {
        'class': 'input-group__selections',
        style: { 'overflow': 'hidden' },
        ref: 'activator'
      }, [group]);
    },
    genSelections: function genSelections() {
      var _this3 = this;

      var children = [];
      var chips = this.chips;
      var slots = this.$scopedSlots.selection;
      var length = this.selectedItems.length;

      this.selectedItems.forEach(function (item, i) {
        if (slots) {
          children.push(_this3.genSlotSelection(item));
        } else if (chips) {
          children.push(_this3.genChipSelection(item));
        } else {
          children.push(_this3.genCommaSelection(item, i < length - 1));
        }
      });

      return children;
    },
    genSlotSelection: function genSlotSelection(item) {
      return this.$scopedSlots.selection({ parent: this, item: item });
    },
    genChipSelection: function genChipSelection(item) {
      var _this4 = this;

      return this.$createElement('v-chip', {
        'class': 'chip--select-multi',
        props: { close: true },
        on: {
          input: function input() {
            return _this4.selectItem(item);
          },
          click: function click(e) {
            return e.stopPropagation();
          }
        },
        key: this.getValue(item)
      }, this.getText(item));
    },
    genCommaSelection: function genCommaSelection(item, comma) {
      return this.$createElement('div', {
        'class': 'input-group__selections__comma',
        key: JSON.stringify(this.getValue(item)) // Item may be an object
      }, '' + this.getText(item) + (comma ? ', ' : ''));
    },
    genList: function genList() {
      var _this5 = this;

      var children = this.filteredItems.map(function (o) {
        if (o.header) return _this5.genHeader(o);
        if (o.divider) return _this5.genDivider(o);else return _this5.genTile(o);
      });

      if (!children.length) {
        children.push(this.genTile(this.noDataText, true));
      }

      return this.$createElement('v-card', [this.$createElement('v-list', {
        ref: 'list'
      }, children)]);
    },
    genHeader: function genHeader(item) {
      return this.$createElement('v-subheader', {
        props: item
      }, item.header);
    },
    genDivider: function genDivider(item) {
      return this.$createElement('v-divider', {
        props: item
      });
    },
    genTile: function genTile(item, disabled) {
      var _this6 = this;

      var active = this.selectedItems.indexOf(item) !== -1;

      if (typeof disabled === 'undefined') {
        disabled = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["g" /* getObjectValueByPath */])(item, this.itemDisabled);
      }

      var data = {
        on: { click: function click(e) {
            return _this6.selectItem(item);
          } },
        props: {
          avatar: item === Object(item) && 'avatar' in item,
          ripple: true,
          value: active
        }
      };

      if (disabled) {
        data.props.disabled = disabled;
      }

      if (this.$scopedSlots.item) {
        return this.$createElement('v-list-tile', data, [this.$scopedSlots.item({ parent: this, item: item })]);
      }

      return this.$createElement('v-list-tile', data, [this.genAction(item, active), this.genContent(item)]);
    },
    genAction: function genAction(item, active) {
      var _this7 = this;

      if (!this.multiple) return null;

      var data = {
        'class': {
          'list__tile__action--select-multi': this.multiple
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this7.selectItem(item);
          }
        }
      };

      return this.$createElement('v-list-tile-action', data, [this.$createElement('v-checkbox', { props: { inputValue: active } })]);
    },
    genContent: function genContent(item) {
      return this.$createElement('v-list-tile-content', [this.$createElement('v-list-tile-title', this.getText(item))]);
    }
  }
});

/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VCheckbox__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VRadio__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VSwitch__ = __webpack_require__(106);




/* harmony default export */ __webpack_exports__["a"] = ({
  VCheckbox: __WEBPACK_IMPORTED_MODULE_0__VCheckbox__["a" /* default */],
  VRadio: __WEBPACK_IMPORTED_MODULE_1__VRadio__["a" /* default */],
  VSwitch: __WEBPACK_IMPORTED_MODULE_2__VSwitch__["a" /* default */]
});

/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_input__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_colorable__ = __webpack_require__(28);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'radio',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_input__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_colorable__["a" /* default */]],

  model: {
    prop: 'inputValue',
    event: 'change'
  },

  props: {
    inputValue: [String, Number]
  },

  computed: {
    isActive: function isActive() {
      return this.inputValue === this.value;
    },
    classes: function classes() {
      return this.addColorClassChecks({
        'radio': true,
        'input-group--selection-controls': true,
        'input-group--active': this.isActive
      });
    },
    icon: function icon() {
      return this.isActive ? 'radio_button_checked' : 'radio_button_unchecked';
    }
  },

  methods: {
    genLabel: function genLabel() {
      return this.$createElement('label', {
        on: { click: this.toggle }
      }, this.label);
    },
    toggle: function toggle() {
      if (!this.disabled) {
        this.$emit('change', this.value);
      }
    }
  },

  render: function render(h) {
    var transition = h('v-fade-transition', {}, [h('v-icon', {
      'class': {
        'icon--radio': this.isActive
      },
      key: this.icon
    }, this.icon)]);

    var ripple = h('div', {
      'class': 'input-group--selection-controls__ripple',
      on: Object.assign({}, {
        click: this.toggle
      }, this.$listeners),
      directives: [{
        name: 'ripple',
        value: { center: true }
      }]
    });

    return this.genInputGroup([transition, ripple]);
  }
});

/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_selectable__ = __webpack_require__(27);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'switch',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_selectable__["a" /* default */]],

  computed: {
    classes: function classes() {
      return {
        'input-group--selection-controls switch': true
      };
    },
    rippleClasses: function rippleClasses() {
      return {
        'input-group--selection-controls__ripple': true,
        'input-group--selection-controls__ripple--active': this.isActive
      };
    },
    containerClasses: function containerClasses() {
      return this.addColorClassChecks({
        'input-group--selection-controls__container': true,
        'input-group--selection-controls__container--light': this.light,
        'input-group--selection-controls__container--disabled': this.disabled
      });
    },
    toggleClasses: function toggleClasses() {
      return {
        'input-group--selection-controls__toggle': true,
        'input-group--selection-controls__toggle--active': this.isActive
      };
    }
  },

  render: function render(h) {
    var ripple = h('div', {
      'class': this.rippleClasses,
      on: Object.assign({}, {
        click: this.toggle
      }, this.$listeners),
      directives: [{
        name: 'ripple',
        value: { center: true }
      }]
    });

    var container = h('div', {
      'class': this.containerClasses
    }, [h('div', { 'class': this.toggleClasses }), ripple]);

    return this.genInputGroup([container]);
  }
});

/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSlider__ = __webpack_require__(108);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSlider: __WEBPACK_IMPORTED_MODULE_0__VSlider__["a" /* default */]
});

/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_input__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_helpers__ = __webpack_require__(0);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-slider',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_input__["a" /* default */]],

  data: function data() {
    return {
      app: {},
      isActive: false,
      inputWidth: 0
    };
  },


  props: {
    inverted: Boolean,
    min: {
      type: [Number, String],
      default: 0
    },
    max: {
      type: [Number, String],
      default: 100
    },
    step: {
      type: [Number, String],
      default: null
    },
    thumbLabel: Boolean,
    value: [Number, String],
    vertical: Boolean,
    snap: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'input-group input-group--slider': true,
        'input-group--active': this.isActive,
        'input-group--dirty': this.inputWidth > 0,
        'input-group--disabled': this.disabled,
        'input-group--ticks': !this.disabled && this.step
      };
    },

    inputValue: {
      get: function get() {
        return this.value;
      },
      set: function set(val) {
        var min = this.min,
            max = this.max,
            step = this.step,
            snap = this.snap;

        val = val < min ? min : val > max ? max : val;
        if (Math.ceil(val) !== Math.ceil(this.lazyValue)) {
          this.inputWidth = this.calculateWidth(val);
        }

        var value = snap ? Math.round(val / step) * step : parseInt(val);
        this.lazyValue = value;

        if (value !== this.value) {
          this.$emit('input', value);
        }
      }
    },
    interval: function interval() {
      return 100 / (this.max - this.min) * this.step;
    },
    thumbContainerClasses: function thumbContainerClasses() {
      return {
        'slider__thumb-container': true,
        'slider__thumb-container--label': this.thumbLabel
      };
    },
    thumbStyles: function thumbStyles() {
      return {
        left: this.inputWidth + '%'
      };
    },
    tickContainerStyles: function tickContainerStyles() {
      return {
        transform: 'translate3d(0, -50%, 0)'
      };
    },
    trackStyles: function trackStyles() {
      var scaleX = this.calculateScale(1 - this.inputWidth / 100);
      var translateX = this.inputWidth < 1 && !this.isActive ? 8 + 'px' : 0;
      return {
        transform: 'scaleX(' + scaleX + ') translateX(' + translateX + ')'
      };
    },
    trackFillStyles: function trackFillStyles() {
      var inputWidth = this.inputWidth;
      var scaleX = this.calculateScale(inputWidth / 100);
      var translateX = inputWidth > 99 && !this.thumbLabel ? -8 + 'px' : 0;
      return {
        transform: 'scaleX(' + scaleX + ') translateX(' + translateX + ')'
      };
    },
    numTicks: function numTicks() {
      return parseInt((this.max - this.min) / this.step);
    }
  },

  watch: {
    value: function value() {
      this.inputValue = this.value;
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.inputValue = this.value;
    this.$nextTick(function () {
      _this.inputWidth = _this.calculateWidth(_this.inputValue);
    });

    // Without a v-app, iOS does not work with body selectors
    this.app = document.querySelector('[data-app]') || console.warn('The v-slider component requires the present of v-app or a non-body wrapping element with the [data-app] attribute.');
  },


  methods: {
    calculateWidth: function calculateWidth(val) {
      if (this.snap) {
        val = Math.round(val / this.step) * this.step;
      }

      val = (val - this.min) / (this.max - this.min) * 100;

      return val < 0.15 ? 0 : val;
    },
    calculateScale: function calculateScale(scale) {
      if (scale < 0.02 && !this.thumbLabel) {
        return 0;
      }

      return this.disabled ? scale - 0.015 : scale;
    },
    onMouseDown: function onMouseDown(e) {
      var options = { passive: true };
      this.isActive = true;

      if ('touches' in e) {
        this.app.addEventListener('touchmove', this.onMouseMove, options);
        Object(__WEBPACK_IMPORTED_MODULE_1__util_helpers__["a" /* addOnceEventListener */])(this.app, 'touchend', this.onMouseUp);
      } else {
        this.app.addEventListener('mousemove', this.onMouseMove, options);
        Object(__WEBPACK_IMPORTED_MODULE_1__util_helpers__["a" /* addOnceEventListener */])(this.app, 'mouseup', this.onMouseUp);
      }
    },
    onMouseUp: function onMouseUp() {
      var options = { passive: true };
      this.isActive = false;
      this.app.removeEventListener('touchmove', this.onMouseMove, options);
      this.app.removeEventListener('mousemove', this.onMouseMove, options);
    },
    onMouseMove: function onMouseMove(e) {
      var _$refs$track$getBound = this.$refs.track.getBoundingClientRect(),
          offsetLeft = _$refs$track$getBound.left,
          trackWidth = _$refs$track$getBound.width;

      var clientX = 'touches' in e ? e.touches[0].clientX : e.clientX;
      var left = (clientX - offsetLeft) / trackWidth * 100;

      left = left < 0 ? 0 : left > 100 ? 100 : left;

      this.inputValue = this.min + left / 100 * (this.max - this.min);
    },
    onKeyDown: function onKeyDown(e) {
      if (!e.keyCode === 37 && !e.keyCode === 39) return;

      var direction = e.keyCode === 37 && -1 || e.keyCode === 39 && 1 || 0;
      var multiplier = e.shiftKey && 3 || e.ctrlKey && 2 || 1;
      var amount = this.snap && this.step || 1;

      this.inputValue = this.inputValue + direction * amount * multiplier;
    },
    sliderMove: function sliderMove(e) {
      if (!this.isActive) {
        this.onMouseMove(e);
      }
    },
    genThumbLabel: function genThumbLabel(h) {
      return h('v-scale-transition', {
        props: { origin: 'bottom center' }
      }, [h('div', {
        'class': 'slider__thumb--label__container',
        directives: [{
          name: 'show',
          value: this.isActive
        }]
      }, [h('div', { 'class': 'slider__thumb--label' }, [h('span', {}, parseInt(this.inputValue))])])]);
    },
    genThumbContainer: function genThumbContainer(h) {
      var children = [];
      children.push(h('div', { 'class': 'slider__thumb' }));

      this.thumbLabel && children.push(this.genThumbLabel(h));

      return h('div', {
        'class': this.thumbContainerClasses,
        style: this.thumbStyles,
        on: {
          touchstart: this.onMouseDown,
          mousedown: this.onMouseDown
        },
        ref: 'thumb'
      }, children);
    },
    genSteps: function genSteps(h) {
      var _this2 = this;

      var ticks = Object(__WEBPACK_IMPORTED_MODULE_1__util_helpers__["c" /* createRange */])(this.numTicks + 1).map(function (i) {
        var span = h('span', {
          class: 'slider__tick',
          style: {
            left: i * (100 / _this2.numTicks) + '%'
          }
        });

        return span;
      });

      return h('div', {
        'class': 'slider__ticks-container',
        style: this.tickContainerStyles
      }, ticks);
    },
    genTrackContainer: function genTrackContainer(h) {
      var children = [h('div', {
        'class': 'slider__track',
        style: this.trackStyles
      }), h('div', {
        'class': 'slider__track-fill',
        style: this.trackFillStyles
      })];

      return h('div', {
        'class': 'slider__track__container',
        ref: 'track'
      }, children);
    }
  },

  render: function render(h) {
    var children = [];

    children.push(this.genTrackContainer(h));
    this.step && children.push(this.genSteps(h));
    children.push(this.genThumbContainer(h));

    var slider = h('div', { 'class': 'slider' }, children);

    return this.genInputGroup([slider], {
      attrs: {
        role: 'slider',
        tabindex: this.tabindex
      },
      on: Object.assign({}, {
        mouseup: this.sliderMove,
        keydown: this.onKeyDown
      }, this.$listeners),
      directives: [{
        name: 'click-outside'
      }]
    });
  }
});

/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSubheader__ = __webpack_require__(110);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSubheader: __WEBPACK_IMPORTED_MODULE_0__VSubheader__["a" /* default */]
});

/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    inset: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        children = _ref.children,
        props = _ref.props;

    data.staticClass = ('subheader ' + (data.staticClass || '')).trim();

    if (props.inset) data.staticClass += ' subheader--inset';
    if (props.light) data.staticClass += ' theme--light';
    if (props.dark) data.staticClass += ' theme--dark';

    return h('li', data, children);
  }
});

/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VStepper__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VStepperStep__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VStepperContent__ = __webpack_require__(114);





var VStepperHeader = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('stepper__header');

/* harmony default export */ __webpack_exports__["a"] = ({
  VStepper: __WEBPACK_IMPORTED_MODULE_1__VStepper__["a" /* default */],
  VStepperContent: __WEBPACK_IMPORTED_MODULE_3__VStepperContent__["a" /* default */],
  VStepperHeader: VStepperHeader,
  VStepperStep: __WEBPACK_IMPORTED_MODULE_2__VStepperStep__["a" /* default */]
});

/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-stepper',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  provide: function provide() {
    return {
      stepClick: this.stepClick
    };
  },
  data: function data() {
    return {
      inputValue: null,
      isBooted: false,
      steps: [],
      content: [],
      isReverse: false
    };
  },


  props: {
    nonLinear: Boolean,
    altLabels: Boolean,
    vertical: Boolean,
    value: [Number, String]
  },

  computed: {
    classes: function classes() {
      return {
        'stepper': true,
        'stepper--is-booted': this.isBooted,
        'stepper--vertical': this.vertical,
        'stepper--alt-labels': this.altLabels,
        'stepper--non-linear': this.nonLinear,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    }
  },

  watch: {
    inputValue: function inputValue(val, prev) {
      var _this = this;

      this.isReverse = Number(val) < Number(prev);
      this.steps.forEach(function (i) {
        return i.toggle(_this.inputValue);
      });
      this.content.forEach(function (i) {
        return i.toggle(_this.inputValue, _this.isReverse);
      });

      this.$emit('input', this.inputValue);
      prev && (this.isBooted = true);
    },
    value: function value() {
      this.inputValue = this.value;
    }
  },

  mounted: function mounted() {
    this.$vuetify.load(this.init);
  },


  methods: {
    init: function init() {
      var _this2 = this;

      this.$children.forEach(function (i) {
        if (i.$options._componentTag === 'v-stepper-step') {
          _this2.steps.push(i);
        } else if (i.$options._componentTag === 'v-stepper-content') {
          i.isVertical = _this2.vertical;
          _this2.content.push(i);
        }
      });

      this.inputValue = this.value || this.steps[0].step || 1;
    },
    stepClick: function stepClick(step) {
      this.inputValue = step;
    }
  },

  render: function render(h) {
    return h('div', {
      'class': this.classes
    }, this.$slots.default);
  }
});

/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-stepper-step',

  inject: ['stepClick'],

  data: function data() {
    return {
      isActive: false,
      isInactive: true
    };
  },


  props: {
    complete: Boolean,
    completeIcon: {
      type: String,
      default: 'check'
    },
    editIcon: {
      type: String,
      default: 'edit'
    },
    errorIcon: {
      type: String,
      default: 'warning'
    },
    editable: Boolean,
    rules: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    step: [Number, String]
  },

  computed: {
    classes: function classes() {
      return {
        'stepper__step': true,
        'stepper__step--active': this.isActive,
        'stepper__step--editable': this.editable,
        'stepper__step--inactive': this.isInactive,
        'stepper__step--error': this.hasError,
        'stepper__step--complete': this.complete
      };
    },
    hasError: function hasError() {
      return this.rules.some(function (i) {
        return i() !== true;
      });
    }
  },

  methods: {
    click: function click(e) {
      e.stopPropagation();

      if (this.editable) {
        this.stepClick(this.step);
      }
    },
    toggle: function toggle(step) {
      this.isActive = step.toString() === this.step.toString();
      this.isInactive = Number(step) < Number(this.step);
    }
  },

  render: function render(h) {
    var data = {
      'class': this.classes,
      directives: [{
        name: 'ripple',
        value: this.editable
      }],
      on: { click: this.click }
    };
    var stepContent = void 0;

    if (this.hasError) {
      stepContent = [h('v-icon', {}, this.errorIcon)];
    } else if (this.complete) {
      if (this.editable) {
        stepContent = [h('v-icon', {}, this.editIcon)];
      } else {
        stepContent = [h('v-icon', {}, this.completeIcon)];
      }
    } else {
      stepContent = this.step;
    }

    var step = h('span', { 'class': 'stepper__step__step' }, stepContent);
    var label = h('div', { 'class': 'stepper__label' }, this.$slots.default);

    return h('div', data, [step, label]);
  }
});

/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-stepper-content',

  data: function data() {
    return {
      height: 0,
      isActive: false,
      isReverse: false,
      isVertical: false
    };
  },


  props: {
    step: {
      type: [Number, String],
      required: true
    }
  },

  computed: {
    classes: function classes() {
      return {
        'stepper__content': true
      };
    },
    computedTransition: function computedTransition() {
      return this.isReverse ? 'v-tab-reverse-transition' : 'v-tab-transition';
    },
    styles: function styles() {
      if (!this.isVertical) return {};

      return {
        height: !isNaN(this.height) ? this.height + 'px' : this.height
      };
    },
    wrapperClasses: function wrapperClasses() {
      return {
        'stepper__wrapper': true
      };
    }
  },

  watch: {
    isActive: function isActive() {
      if (!this.isVertical) {
        return;
      }

      if (this.isActive) {
        this.enter();
      } else {
        this.leave();
      }
    }
  },

  mounted: function mounted() {
    this.$refs.wrapper.addEventListener('transitionend', this.onTransition, false);
  },
  beforeDestroy: function beforeDestroy() {
    this.$refs.wrapper.removeEventListener('transitionend', this.onTransition, false);
  },


  methods: {
    onTransition: function onTransition() {
      if (!this.isActive) return;

      this.height = 'auto';
    },
    enter: function enter() {
      var _this = this;

      var scrollHeight = 0;

      // Render bug with height
      setTimeout(function () {
        scrollHeight = _this.$refs.wrapper.scrollHeight;
      }, 0);

      this.height = 0;

      // Give the collapsing element time to collapse
      setTimeout(function () {
        return _this.height = scrollHeight || 'auto';
      }, 450);
    },
    leave: function leave() {
      var _this2 = this;

      this.height = this.$refs.wrapper.clientHeight;
      setTimeout(function () {
        return _this2.height = 0;
      }, 0);
    },
    toggle: function toggle(step, reverse) {
      this.isActive = step.toString() === this.step.toString();
      this.isReverse = reverse;
    }
  },

  render: function render(h) {
    var contentData = {
      'class': this.classes
    };
    var wrapperData = {
      'class': this.wrapperClasses,
      style: this.styles,
      ref: 'wrapper'
    };

    if (!this.isVertical) {
      contentData.directives = [{
        name: 'show',
        value: this.isActive
      }];
    }

    var wrapper = h('div', wrapperData, [this.$slots.default]);
    var content = h('div', contentData, [wrapper]);

    return h(this.computedTransition, {
      on: this.$listeners
    }, [content]);
  }
});

/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VTableOverflow */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VDataTable__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VEditDialog__ = __webpack_require__(121);




var VTableOverflow = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('table__overflow');

/* harmony default export */ __webpack_exports__["a"] = ({
  VDataTable: __WEBPACK_IMPORTED_MODULE_1__VDataTable__["a" /* default */],
  VEditDialog: __WEBPACK_IMPORTED_MODULE_2__VEditDialog__["a" /* default */],
  VTableOverflow: VTableOverflow
});

/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_head__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_body__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_foot__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_progress__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_filterable__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_progress_VProgressLinear__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_selects_VSelect__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_helpers__ = __webpack_require__(0);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };















/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-datatable',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_head__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_body__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_filterable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_foot__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_progress__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_themeable__["a" /* default */]],

  components: {
    VBtn: __WEBPACK_IMPORTED_MODULE_6__components_buttons_VBtn__["a" /* default */],
    VIcon: __WEBPACK_IMPORTED_MODULE_7__components_icons_VIcon__["a" /* default */],
    VProgressLinear: __WEBPACK_IMPORTED_MODULE_8__components_progress_VProgressLinear__["a" /* default */],
    VSelect: __WEBPACK_IMPORTED_MODULE_9__components_selects_VSelect__["a" /* default */],
    // Importing does not work properly
    'v-table-overflow': Object(__WEBPACK_IMPORTED_MODULE_10__util_helpers__["d" /* createSimpleFunctional */])('table__overflow')
  },

  data: function data() {
    return {
      all: false,
      searchLength: 0,
      defaultPagination: {
        page: 1,
        rowsPerPage: 5,
        descending: false,
        totalItems: 0
      }
    };
  },


  props: {
    headers: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    headerText: {
      type: String,
      default: 'text'
    },
    hideActions: Boolean,
    noResultsText: {
      type: String,
      default: 'No matching records found'
    },
    rowsPerPageItems: {
      type: Array,
      default: function _default() {
        return [5, 10, 25, { text: 'All', value: -1 }];
      }
    },
    rowsPerPageText: {
      type: String,
      default: 'Rows per page:'
    },
    selectAll: [Boolean, String],
    search: {
      required: false
    },
    filter: {
      type: Function,
      default: function _default(val, search) {
        return val !== null && ['undefined', 'boolean'].indexOf(typeof val === 'undefined' ? 'undefined' : _typeof(val)) === -1 && val.toString().toLowerCase().indexOf(search) !== -1;
      }
    },
    customFilter: {
      type: Function,
      default: function _default(items, search, filter) {
        search = search.toString().toLowerCase();
        return items.filter(function (i) {
          return Object.keys(i).some(function (j) {
            return filter(i[j], search);
          });
        });
      }
    },
    customSort: {
      type: Function,
      default: function _default(items, index, isDescending) {
        if (index === null) return items;

        return items.sort(function (a, b) {
          var sortA = Object(__WEBPACK_IMPORTED_MODULE_10__util_helpers__["g" /* getObjectValueByPath */])(a, index);
          var sortB = Object(__WEBPACK_IMPORTED_MODULE_10__util_helpers__["g" /* getObjectValueByPath */])(b, index);

          if (isDescending) {
            var _ref = [sortB, sortA];
            sortA = _ref[0];
            sortB = _ref[1];
          }

          // Check if both are numbers
          if (!isNaN(sortA) && !isNaN(sortB)) {
            return sortA - sortB;
          }

          // Check if both cannot be evaluated
          if (sortA === null && sortB === null) {
            return 0;
          }

          var _map = [sortA, sortB].map(function (s) {
            return (s || '').toString().toLocaleLowerCase();
          });

          var _map2 = _slicedToArray(_map, 2);

          sortA = _map2[0];
          sortB = _map2[1];


          if (sortA > sortB) return 1;
          if (sortA < sortB) return -1;

          return 0;
        });
      }
    },
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    items: {
      type: Array,
      required: true,
      default: function _default() {
        return [];
      }
    },
    totalItems: {
      type: Number,
      default: null
    },
    loading: {
      type: [Boolean, String],
      default: false
    },
    selectedKey: {
      type: String,
      default: 'id'
    },
    pagination: {
      type: Object,
      default: null
    }
  },

  computed: {
    classes: function classes() {
      return {
        'datatable table': true,
        'datatable--select-all': this.selectAll !== false,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    },
    computedPagination: function computedPagination() {
      return this.pagination || this.defaultPagination;
    },
    hasSelectAll: function hasSelectAll() {
      return this.selectAll !== undefined && this.selectAll !== false;
    },
    itemsLength: function itemsLength() {
      if (this.search) return this.searchLength;
      return this.totalItems || this.items.length;
    },
    indeterminate: function indeterminate() {
      return this.hasSelectAll && this.someItems && !this.everyItem;
    },
    everyItem: function everyItem() {
      var _this = this;

      return this.filteredItems.length && this.filteredItems.every(function (i) {
        return _this.isSelected(i);
      });
    },
    someItems: function someItems() {
      var _this2 = this;

      return this.filteredItems.some(function (i) {
        return _this2.isSelected(i);
      });
    },
    getPage: function getPage() {
      var rowsPerPage = this.computedPagination.rowsPerPage;


      return rowsPerPage === Object(rowsPerPage) ? rowsPerPage.value : rowsPerPage;
    },
    pageStart: function pageStart() {
      return this.getPage === -1 ? 0 : (this.computedPagination.page - 1) * this.getPage;
    },
    pageStop: function pageStop() {
      return this.getPage === -1 ? this.itemsLength : this.computedPagination.page * this.getPage;
    },
    filteredItems: function filteredItems() {
      if (this.totalItems) return this.items;

      var items = this.items.slice();
      var hasSearch = typeof this.search !== 'undefined' && this.search !== null;

      if (hasSearch) {
        items = this.customFilter(items, this.search, this.filter);
        this.searchLength = items.length;
      }

      items = this.customSort(items, this.computedPagination.sortBy, this.computedPagination.descending);

      return this.hideActions && !this.pagination ? items : items.slice(this.pageStart, this.pageStop);
    },
    selected: function selected() {
      var _this3 = this;

      var selected = {};
      this.value.forEach(function (i) {
        return selected[i[_this3.selectedKey]] = true;
      });
      return selected;
    }
  },

  watch: {
    indeterminate: function indeterminate(val) {
      if (val) this.all = true;
    },
    someItems: function someItems(val) {
      if (!val) this.all = false;
    },
    search: function search() {
      this.updatePagination({ page: 1 });
    },
    everyItem: function everyItem(val) {
      if (val) this.all = true;
    }
  },

  methods: {
    updatePagination: function updatePagination(val) {
      var pagination = this.pagination || this.defaultPagination;
      var updatedPagination = Object.assign({}, pagination, val);

      if (this.pagination) {
        this.$emit('update:pagination', updatedPagination);
      } else {
        this.defaultPagination = updatedPagination;
      }
    },
    isSelected: function isSelected(item) {
      return this.selected[item[this.selectedKey]];
    },
    sort: function sort(index) {
      var _computedPagination = this.computedPagination,
          sortBy = _computedPagination.sortBy,
          descending = _computedPagination.descending;

      if (sortBy === null) {
        this.updatePagination({ sortBy: index, descending: false });
      } else if (sortBy === index && !descending) {
        this.updatePagination({ descending: true });
      } else if (sortBy !== index) {
        this.updatePagination({ sortBy: index, descending: false });
      } else {
        this.updatePagination({ sortBy: null, descending: null });
      }
    },
    needsTR: function needsTR(row) {
      return row.length && row.find(function (c) {
        return c.tag === 'td';
      });
    },
    genTR: function genTR(children) {
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return this.$createElement('tr', data, children);
    },
    toggle: function toggle(value) {
      var _this4 = this;

      var selected = Object.assign({}, this.selected);
      this.filteredItems.forEach(function (i) {
        return selected[i[_this4.selectedKey]] = value;
      });

      this.$emit('input', this.items.filter(function (i) {
        return selected[i[_this4.selectedKey]];
      }));
    }
  },

  created: function created() {
    var firstSortable = this.headers.find(function (h) {
      return !('sortable' in h) || h.sortable;
    });

    this.defaultPagination.sortBy = firstSortable ? firstSortable.value : null;

    if (!this.rowsPerPageItems.length) {
      console.warn('The prop \'rows-per-page-items\' in v-data-table can not be empty.');
    } else {
      this.defaultPagination.rowsPerPage = this.rowsPerPageItems[0];
    }

    this.updatePagination(Object.assign({}, this.defaultPagination, this.pagination));
  },
  render: function render(h) {
    return h('v-table-overflow', {}, [h('table', {
      'class': this.classes
    }, [this.genTHead(), this.genTProgress(), this.genTBody(), this.genTFoot()])]);
  }
});

/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genTHead: function genTHead() {
      var _this = this;

      var children = [];

      if (this.$scopedSlots.headers) {
        var row = this.$scopedSlots.headers({
          headers: this.headers,
          indeterminate: this.indeterminate,
          all: this.all
        });

        children = this.needsTR(row) ? this.genTR(row) : row;
      } else {
        var _row = this.headers.map(function (o) {
          return _this.genHeader(o);
        });
        var checkbox = this.$createElement('v-checkbox', {
          props: {
            dark: this.dark,
            light: this.light,
            color: this.selectAll === true && '' || this.selectAll,
            hideDetails: true,
            inputValue: this.all,
            indeterminate: this.indeterminate
          },
          on: { change: this.toggle }
        });

        this.hasSelectAll && _row.unshift(this.$createElement('th', [checkbox]));

        children = this.genTR(_row);
      }

      return this.$createElement('thead', [children]);
    },
    genHeader: function genHeader(header) {
      var array = [this.$scopedSlots.headerCell ? this.$scopedSlots.headerCell({ header: header }) : header[this.headerText]];

      return this.$createElement.apply(this, ['th'].concat(_toConsumableArray(this.genHeaderData(header, array))));
    },
    genHeaderData: function genHeaderData(header, children) {
      var _this2 = this;

      var classes = ['column'];
      var data = {};
      var pagination = this.computedPagination;

      if ('sortable' in header && header.sortable || !('sortable' in header)) {
        data.on = { click: function click() {
            return _this2.sort(header.value);
          } };
        if (!('value' in header)) {
          console.warn('Data table headers must have a value property that corresponds to a value in the v-model array');
        }

        classes.push('sortable');
        var icon = this.$createElement('v-icon', 'arrow_upward');
        if (header.align && header.align === 'left') {
          children.push(icon);
        } else {
          children.unshift(icon);
        }

        var beingSorted = pagination.sortBy === header.value;
        if (beingSorted) {
          classes.push('active');
          classes.push(pagination.descending ? 'desc' : 'asc');
        }
      }

      classes.push('text-xs-' + (header.align || 'right'));
      data.class = classes;

      return [data, children];
    }
  }
});

/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genTBody: function genTBody() {
      var children = [];

      if (!this.itemsLength) {
        children.push(this.genEmptyBody(this.noDataText));
      } else if (!this.filteredItems.length) {
        children.push(this.genEmptyBody(this.noResultsText));
      } else {
        children.push(this.genFilteredItems());
      }

      return this.$createElement('tbody', children);
    },
    genFilteredItems: function genFilteredItems() {
      var _this = this;

      return this.filteredItems.map(function (item, index) {
        var props = { item: item, index: index };
        var key = _this.selectedKey;

        Object.defineProperty(props, 'selected', {
          get: function get() {
            return _this.selected[item[_this.selectedKey]];
          },
          set: function set(value) {
            var selected = _this.value.slice();
            if (value) selected.push(item);else selected = selected.filter(function (i) {
              return i[key] !== item[key];
            });

            _this.$emit('input', selected);
          }
        });

        var row = _this.$scopedSlots.items(props);

        return _this.needsTR(row) ? _this.genTR(row, {
          attrs: { active: _this.isSelected(item) }
        }) : row;
      });
    },
    genEmptyBody: function genEmptyBody(text) {
      return this.genTR([this.$createElement('td', {
        'class': 'text-xs-center',
        attrs: { colspan: '100%' }
      }, text)]);
    }
  }
});

/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genPrevIcon: function genPrevIcon() {
      var _this = this;

      return this.$createElement('v-btn', {
        props: {
          disabled: this.computedPagination.page === 1,
          icon: true,
          flat: true,
          dark: this.dark,
          light: this.light
        },
        on: {
          click: function click() {
            var page = _this.computedPagination.page;
            _this.updatePagination({ page: page - 1 });
          }
        }
      }, [this.$createElement('v-icon', 'chevron_left')]);
    },
    genNextIcon: function genNextIcon() {
      var _this2 = this;

      var pagination = this.computedPagination;
      var disabled = pagination.rowsPerPage < 0 || pagination.page * pagination.rowsPerPage >= this.itemsLength || this.pageStop < 0;

      return this.$createElement('v-btn', {
        props: {
          disabled: disabled,
          icon: true,
          flat: true,
          dark: this.dark,
          light: this.light
        },
        on: {
          click: function click() {
            var page = _this2.computedPagination.page;
            _this2.updatePagination({ page: page + 1 });
          }
        }
      }, [this.$createElement('v-icon', 'chevron_right')]);
    },
    genSelect: function genSelect() {
      var _this3 = this;

      return this.$createElement('div', {
        'class': 'datatable__actions__select'
      }, [this.rowsPerPageText, this.$createElement('v-select', {
        props: {
          items: this.rowsPerPageItems,
          value: this.computedPagination.rowsPerPage,
          hideDetails: true,
          auto: true,
          minWidth: '75px'
        },
        on: {
          input: function input(val) {
            _this3.updatePagination({
              page: 1,
              rowsPerPage: val
            });
          }
        }
      })]);
    },
    genPagination: function genPagination() {
      var pagination = '–';

      if (this.itemsLength) {
        var stop = this.itemsLength < this.pageStop || this.pageStop < 0 ? this.itemsLength : this.pageStop;

        pagination = this.$scopedSlots.pageText ? this.$scopedSlots.pageText({
          pageStart: this.pageStart + 1,
          pageStop: stop,
          itemsLength: this.itemsLength
        }) : this.pageStart + 1 + '-' + stop + ' of ' + this.itemsLength;
      }

      return this.$createElement('div', {
        'class': 'datatable__actions__pagination'
      }, [pagination]);
    },
    genActions: function genActions() {
      return [this.$createElement('div', {
        'class': 'datatable__actions'
      }, [this.genSelect(), this.genPagination(), this.genPrevIcon(), this.genNextIcon()])];
    },
    genTFoot: function genTFoot() {
      var children = [];

      if (this.$slots.footer) {
        var footer = this.$slots.footer;
        var row = this.needsTR(footer) ? this.genTR(footer) : footer;

        children.push(row);
      }

      if (!this.hideActions) {
        children.push(this.genTR([this.$createElement('td', {
          attrs: { colspan: '100%' }
        }, this.genActions())]));
      }

      if (!children.length) return null;
      return this.$createElement('tfoot', children);
    }
  }
});

/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      color: ''
    };
  },


  watch: {
    loading: function loading(val) {
      if (val) this.color = val;
    }
  },

  methods: {
    genTProgress: function genTProgress() {
      var loader = this.$createElement('v-progress-linear', {
        props: {
          primary: this.color === 'primary',
          secondary: this.color === 'secondary',
          success: this.color === 'success',
          info: this.color === 'info',
          warning: this.color === 'warning',
          error: this.color === 'error',
          indeterminate: true,
          height: 3,
          active: !!this.loading
        }
      });

      var col = this.$createElement('th', {
        class: 'column',
        attrs: {
          colspan: '100%'
        }
      }, [loader]);

      return this.$createElement('thead', {
        class: 'datatable__progress'
      }, [this.genTR([col])]);
    }
  }
});

/***/ }),
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-edit-dialog',

  data: function data() {
    return {
      isActive: false,
      isSaving: false
    };
  },


  props: {
    cancelText: {
      default: 'Cancel'
    },
    large: Boolean,
    lazy: Boolean,
    saveText: {
      default: 'Save'
    },
    transition: {
      type: String,
      default: 'slide-x-reverse-transition'
    }
  },

  watch: {
    isActive: function isActive(val) {
      val && this.$emit('open') && setTimeout(this.focus, 50); // Give DOM time to paint

      if (!val) {
        !this.isSaving && this.$emit('cancel');
        this.isSaving && this.$emit('close');
        this.isSaving = false;
      }
    }
  },

  methods: {
    cancel: function cancel() {
      this.isActive = false;
    },
    focus: function focus() {
      var input = this.$refs.content.querySelector('input');
      input && input.focus();
    },
    save: function save() {
      this.isSaving = true;
      this.isActive = false;
      this.$emit('save');
    },
    genButton: function genButton(fn, text) {
      return this.$createElement('v-btn', {
        props: {
          flat: true,
          primary: true,
          light: true
        },
        on: { click: fn }
      }, text);
    },
    genActions: function genActions() {
      return this.$createElement('div', {
        'class': 'small-dialog__actions',
        directives: [{
          name: 'show',
          value: this.large
        }]
      }, [this.genButton(this.cancel, this.cancelText), this.genButton(this.save, this.saveText)]);
    },
    genContent: function genContent() {
      var _this = this;

      return this.$createElement('div', {
        'class': 'small-dialog__content',
        on: {
          keydown: function keydown(e) {
            e.keyCode === 27 && _this.cancel();
            e.keyCode === 13 && _this.save();
          }
        },
        ref: 'content'
      }, [this.$slots.input]);
    }
  },

  render: function render(h) {
    var _this2 = this;

    return h('v-menu', {
      'class': 'small-dialog',
      props: {
        transition: this.transition,
        origin: 'top right',
        right: true,
        value: this.isActive,
        closeOnContentClick: false,
        lazy: this.lazy
      },
      on: {
        input: function input(val) {
          return _this2.isActive = val;
        }
      }
    }, [h('a', {
      domProps: { href: 'javascript:;' },
      slot: 'activator'
    }, this.$slots.default), this.genContent(), this.genActions()]);
  }
});

/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VTabs__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VTabsItem__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VTabsContent__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__VTabsBar__ = __webpack_require__(126);






var VTabsSlider = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('tabs__slider', 'li');

var VTabsItems = {
  name: 'v-tabs-items',

  render: function render(h) {
    return h('div', { 'class': { 'tabs__items': true } }, [this.$slots.default]);
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  VTabsItem: __WEBPACK_IMPORTED_MODULE_2__VTabsItem__["a" /* default */],
  VTabsItems: VTabsItems,
  VTabs: __WEBPACK_IMPORTED_MODULE_1__VTabs__["a" /* default */],
  VTabsContent: __WEBPACK_IMPORTED_MODULE_3__VTabsContent__["a" /* default */],
  VTabsBar: __WEBPACK_IMPORTED_MODULE_4__VTabsBar__["a" /* default */],
  VTabsSlider: VTabsSlider
});

/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives__ = __webpack_require__(4);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs',

  directives: {
    Resize: __WEBPACK_IMPORTED_MODULE_1__directives__["Resize"]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  provide: function provide() {
    var _this = this;

    return {
      slider: this.slider,
      tabClick: this.tabClick,
      isScrollable: function isScrollable() {
        return _this.scrollable;
      },
      isMobile: function isMobile() {
        return _this.isMobile;
      }
    };
  },
  data: function data() {
    return {
      activators: [],
      activeIndex: null,
      isMobile: false,
      reverse: false,
      target: null,
      tabsSlider: null,
      targetEl: null,
      tabsContainer: null
    };
  },


  props: {
    centered: Boolean,
    fixed: Boolean,
    grow: Boolean,
    icons: Boolean,
    mobileBreakPoint: {
      type: [Number, String],
      default: 1024
    },
    value: String,
    scrollable: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    classes: function classes() {
      return {
        'tabs': true,
        'tabs--centered': this.centered,
        'tabs--fixed': this.fixed,
        'tabs--grow': this.grow,
        'tabs--icons': this.icons,
        'tabs--mobile': this.isMobile,
        'tabs--scroll-bars': this.scrollable,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    }
  },

  watch: {
    value: function value() {
      this.tabClick(this.value);
    },
    activeIndex: function activeIndex() {
      this.updateTabs();
      this.$emit('input', this.target);
      this.isBooted = true;
    }
  },

  mounted: function mounted() {
    var _this2 = this;

    this.$vuetify.load(function () {
      var activators = _this2.$slots.activators;

      if (!activators || !activators.length || !activators[0].componentInstance) return;

      var bar = activators[0].componentInstance.$children;
      // // This is a workaround to detect if link is active
      // // when being used as a router or nuxt link
      var i = bar.findIndex(function (t) {
        return t.$el.firstChild.classList.contains('tabs__item--active');
      });

      var tab = _this2.value || (bar[i !== -1 ? i : 0] || {}).action;

      tab && _this2.tabClick(tab) && _this2.onResize();
    });
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.resize, { passive: true });
  },


  methods: {
    onResize: function onResize() {
      this.isMobile = window.innerWidth < this.mobileBreakPoint;
      this.slider();
    },
    slider: function slider(el) {
      var _this3 = this;

      this.tabsSlider = this.tabsSlider || this.$el.querySelector('.tabs__slider');

      this.tabsContainer = this.tabsContainer || this.$el.querySelector('.tabs__container');

      if (!this.tabsSlider || !this.tabsContainer) return;

      this.targetEl = el || this.targetEl;

      if (!this.targetEl || !this.tabsContainer) return;

      // Gives DOM time to paint when
      // processing slider for
      // dynamic tabs
      this.$nextTick(function () {
        // #684 Calculate width as %
        var width = _this3.targetEl.scrollWidth / _this3.tabsContainer.clientWidth * 100;

        _this3.tabsSlider.style.width = width + '%';
        _this3.tabsSlider.style.left = _this3.targetEl.offsetLeft + 'px';
      });
    },
    tabClick: function tabClick(target) {
      var _this4 = this;

      var setActiveIndex = function setActiveIndex(index) {
        if (_this4.activeIndex === index) {
          // #762 update tabs display
          // In case tabs count got changed but activeIndex didn't
          _this4.updateTabs();
        } else {
          _this4.activeIndex = index;
        }
      };

      this.target = target;

      var content = this.$refs.content;
      if (!content) {
        setActiveIndex(target);
        return;
      }

      this.$nextTick(function () {
        var nextIndex = content.$children.findIndex(function (i) {
          return i.id === target;
        });
        _this4.reverse = nextIndex < _this4.activeIndex;
        setActiveIndex(nextIndex);
      });
    },
    updateTabs: function updateTabs() {
      var _this5 = this;

      var activators = this.$slots.activators;
      var content = this.$refs.content;

      if (!activators || !activators.length || activators.length && !activators[0].componentInstance) return;

      activators[0].componentInstance.$children.filter(function (i) {
        return i.$options._componentTag === 'v-tabs-item';
      }).forEach(function (i) {
        return i.toggle(_this5.target);
      });

      content && content.$children.forEach(function (i) {
        return i.toggle(_this5.target, _this5.reverse, _this5.isBooted);
      });
    }
  },

  render: function render(h) {
    var content = [];
    var slot = [];
    var iter = this.$slots.default || [];

    iter.forEach(function (c) {
      if (!c.componentOptions) slot.push(c);else if (c.componentOptions.tag === 'v-tabs-content') content.push(c);else slot.push(c);
    });

    var tabs = content.length ? h('v-tabs-items', {
      ref: 'content'
    }, content) : null;

    return h('div', {
      'class': this.classes,
      directives: [{
        name: 'resize',
        value: this.onResize
      }]
    }, [slot, this.$slots.activators, tabs]);
  }
});

/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_route_link__ = __webpack_require__(9);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs-item',

  inject: ['slider', 'tabClick'],

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_route_link__["a" /* default */]],

  data: function data() {
    return {
      isActive: false
    };
  },


  props: {
    activeClass: {
      type: String,
      default: 'tabs__item--active'
    }
  },

  computed: {
    classes: function classes() {
      var classes = {
        'tabs__item': true,
        'tabs__item--disabled': this.disabled
      };

      classes[this.activeClass] = !this.to && this.isActive;

      return classes;
    },
    action: function action() {
      var to = this.to || this.href;

      if (!to || to === Object(to)) return this._uid;

      return to.replace('#', '');
    }
  },

  watch: {
    $route: function $route() {
      this.to && this.callSlider();
    }
  },

  mounted: function mounted() {
    this.callSlider();
  },


  methods: {
    callSlider: function callSlider() {
      var _this = this;

      setTimeout(function () {
        _this.$el.firstChild.classList.contains('tabs__item--active') && _this.slider(_this.$el);
      }, 0);
    },
    click: function click(e) {
      e.preventDefault();

      if (!this.to && !this.href) return;

      if (!this.to) {
        this.tabClick(this.action);
      }

      this.callSlider();
    },
    toggle: function toggle(action) {
      var _this2 = this;

      this.isActive = this.action === action;

      this.$nextTick(function () {
        _this2.isActive && _this2.slider(_this2.$el);
      });
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    return h('li', {
      'class': 'tabs__li'
    }, [h(tag, data, this.$slots.default)]);
  }
});

/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_bootable__ = __webpack_require__(10);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs-content',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_bootable__["a" /* default */]],

  data: function data() {
    return {
      isActive: false,
      reverse: false
    };
  },


  props: {
    id: {
      type: String,
      required: true
    },
    lazy: Boolean,
    transition: {
      type: String,
      default: 'v-tab-transition'
    },
    reverseTransition: {
      type: String,
      default: 'v-tab-reverse-transition'
    }
  },

  computed: {
    computedTransition: function computedTransition() {
      return this.reverse ? this.reverseTransition : this.transition;
    }
  },

  methods: {
    toggle: function toggle(target, reverse, showTransition) {
      this.$el.style.transition = !showTransition ? 'none' : null;
      this.reverse = reverse;
      this.isActive = this.id === target;
    }
  },

  render: function render(h) {
    return h(this.computedTransition, {}, [h('div', {
      'class': 'tabs__content',
      domProps: { id: this.id },
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      on: this.$listeners
    }, this.lazy && this.isBooted || !this.lazy ? this.$slots.default : null)]);
  }
});

/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives__ = __webpack_require__(4);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs-bar',

  directives: {
    Resize: __WEBPACK_IMPORTED_MODULE_1__directives__["Resize"]
  },

  inject: ['isScrollable', 'isMobile'],

  data: function data() {
    return {
      isOverflowing: false,
      scrollOffset: 0,
      itemOffset: 0,
      startX: 0
    };
  },


  computed: {
    classes: function classes() {
      return {
        'tabs__bar': true
      };
    },
    containerClasses: function containerClasses() {
      return {
        'tabs__container': true
      };
    },
    wrapperClasses: function wrapperClasses() {
      return {
        'tabs__wrapper': true,
        'tabs__wrapper--scrollable': this.isScrollable(),
        'tabs__wrapper--overflow': this.isOverflowing
      };
    },
    containerStyles: function containerStyles() {
      return {
        'transform': 'translateX(' + -this.scrollOffset + 'px)'
      };
    },
    leftIconVisible: function leftIconVisible() {
      return !this.isMobile() && this.isScrollable() && this.isOverflowing && this.scrollOffset > 0;
    },
    rightIconVisible: function rightIconVisible() {
      if (this.isMobile() || !this.isScrollable() || !this.isOverflowing) return;

      // Check one scroll ahead to know the width of right-most item
      var container = this.$refs.container;
      var item = this.newOffsetRight(this.scrollOffset, this.itemOffset);
      var itemWidth = item && container.children[item.index].clientWidth || 0;
      var scrollOffset = this.scrollOffset + container.clientWidth;

      return container.scrollWidth - scrollOffset > itemWidth * 0.30;
    }
  },

  methods: {
    genContainer: function genContainer() {
      return this.$createElement('ul', {
        'class': this.containerClasses,
        'style': this.containerStyles,
        ref: 'container'
      }, this.$slots.default);
    },
    genIcon: function genIcon(direction) {
      var capitalize = direction.charAt(0).toUpperCase() + direction.slice(1);
      return this.$createElement(__WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__["a" /* default */], {
        props: _defineProperty({}, '' + direction, true),
        style: { display: 'inline-flex' },
        on: {
          click: this['scroll' + capitalize]
        }
      }, 'chevron_' + direction);
    },
    genWrapper: function genWrapper() {
      return this.$createElement('div', {
        class: this.wrapperClasses,
        directives: [{
          name: 'touch',
          value: {
            start: this.start,
            move: this.move,
            end: this.end
          }
        }]
      }, [this.genContainer()]);
    },
    start: function start(e) {
      this.startX = this.scrollOffset + e.touchstartX;
      this.$refs.container.style.transition = 'none';
    },
    move: function move(e) {
      var offset = this.startX - e.touchmoveX;
      this.scrollOffset = offset;
    },
    end: function end(e) {
      this.onResize();
      var container = this.$refs.container;
      var scrollWidth = container.scrollWidth - this.$el.clientWidth / 2;
      container.style.transition = null;

      if (this.scrollOffset < 0 || !this.isOverflowing) {
        this.scrollOffset = 0;
      } else if (this.scrollOffset >= scrollWidth) {
        var lastItem = container.children[container.children.length - 1];
        this.scrollOffset = scrollWidth - lastItem.clientWidth;
      }
    },
    scrollLeft: function scrollLeft() {
      var _newOffset = this.newOffset('Left'),
          offset = _newOffset.offset,
          index = _newOffset.index;

      this.scrollOffset = offset;
      this.itemOffset = index;
    },
    scrollRight: function scrollRight() {
      var _newOffset2 = this.newOffset('Right'),
          offset = _newOffset2.offset,
          index = _newOffset2.index;

      this.scrollOffset = offset;
      this.itemOffset = index;
    },
    onResize: function onResize() {
      if (this._isDestroyed) return;

      var container = this.$refs.container;
      this.isOverflowing = container.clientWidth < container.scrollWidth;
    },
    newOffset: function newOffset(direction) {
      return this['newOffset' + direction](this.scrollOffset, this.itemOffset);
    },
    newOffsetLeft: function newOffsetLeft(currentOffset, currentIndex) {
      var container = this.$refs.container;
      var items = container.children;
      var offset = 0;

      for (var index = currentIndex - 1; index >= 0; index--) {
        if (!items[index].classList.contains('tabs__slider')) {
          var newOffset = offset + items[index].clientWidth;
          if (newOffset >= container.clientWidth) {
            return { offset: currentOffset - offset, index: index + 1 };
          }
          offset = newOffset;
        }
      }

      return { offset: 0, index: 0 };
    },
    newOffsetRight: function newOffsetRight(currentOffset, currentIndex) {
      var container = this.$refs.container;
      var items = container.children;
      var offset = currentOffset;

      for (var index = currentIndex; index < items.length; index++) {
        if (!items[index].classList.contains('tabs__slider')) {
          var newOffset = offset + items[index].clientWidth;
          if (newOffset > currentOffset + container.clientWidth) {
            return { offset: offset, index: index };
          }
          offset = newOffset;
        }
      }

      return null;
    }
  },

  render: function render(h) {
    return h('div', {
      'class': this.classes,
      directives: [{
        name: 'resize',
        value: this.onResize
      }]
    }, [this.genWrapper(), this.leftIconVisible ? this.genIcon('left') : null, this.rightIconVisible ? this.genIcon('right') : null]);
  }
});

/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VTextField__ = __webpack_require__(128);


/* harmony default export */ __webpack_exports__["a"] = ({
  VTextField: __WEBPACK_IMPORTED_MODULE_0__VTextField__["a" /* default */]
});

/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_input__ = __webpack_require__(7);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-text-field',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_input__["a" /* default */]],

  inheritAttrs: false,

  data: function data() {
    return {
      hasFocused: false,
      inputHeight: null
    };
  },


  props: {
    autofocus: Boolean,
    autoGrow: Boolean,
    counter: Boolean,
    fullWidth: Boolean,
    max: [Number, String],
    min: [Number, String],
    multiLine: Boolean,
    placeholder: String,
    prefix: String,
    rows: {
      default: 5
    },
    singleLine: Boolean,
    solo: Boolean,
    suffix: String,
    textarea: Boolean,
    type: {
      type: String,
      default: 'text'
    }
  },

  computed: {
    classes: function classes() {
      return {
        'input-group--text-field': true,
        'input-group--single-line': this.singleLine,
        'input-group--solo': this.solo,
        'input-group--multi-line': this.multiLine,
        'input-group--full-width': this.fullWidth,
        'input-group--prefix': this.prefix,
        'input-group--suffix': this.suffix,
        'input-group--textarea': this.textarea
      };
    },
    hasError: function hasError() {
      return this.validations.length || this.errorMessages.length > 0 || !this.counterIsValid() || !this.validateIsValid() || this.error;
    },
    count: function count() {
      var inputLength = void 0;
      if (this.inputValue) inputLength = this.inputValue.toString().length;else inputLength = 0;
      var min = inputLength;

      if (this.counterMin !== 0 && inputLength < this.counterMin) {
        min = this.counterMin;
      }

      return min + ' / ' + this.counterMax;
    },
    counterMin: function counterMin() {
      var parsedMin = parseInt(this.min, 10);
      return isNaN(parsedMin) ? 0 : parsedMin;
    },
    counterMax: function counterMax() {
      var parsedMax = parseInt(this.max, 10);
      return isNaN(parsedMax) ? 25 : parsedMax;
    },

    inputValue: {
      get: function get() {
        return this.value;
      },
      set: function set(val) {
        if (this.modifiers.trim) {
          val = val.trim();
        }

        if (this.modifiers.number) {
          val = Number(val);
        }

        if (!this.modifiers.lazy) {
          this.$emit('input', val);
        }

        this.lazyValue = val;
      }
    },
    isDirty: function isDirty() {
      return this.lazyValue !== null && typeof this.lazyValue !== 'undefined' && this.lazyValue.toString().length > 0 || this.placeholder;
    }
  },

  watch: {
    focused: function focused(val) {
      this.hasFocused = true;
    },
    value: function value() {
      this.lazyValue = this.value;
      this.validate();
      this.multiLine && this.autoGrow && this.calculateInputHeight();
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.$vuetify.load(function () {
      _this.multiLine && _this.autoGrow && _this.calculateInputHeight();
      _this.autofocus && _this.focus();
    });
  },


  methods: {
    calculateInputHeight: function calculateInputHeight() {
      var _this2 = this;

      this.inputHeight = null;

      this.$nextTick(function () {
        var height = _this2.$refs.input.scrollHeight;
        var minHeight = _this2.rows * 24;
        var inputHeight = height < minHeight ? minHeight : height;
        _this2.inputHeight = inputHeight;
      });
    },
    onChange: function onChange(e) {
      this.lazyValue = e.target.value;
      this.$emit('change', this.lazyValue || null);
    },
    onInput: function onInput(e) {
      this.inputValue = e.target.value;
      this.multiLine && this.autoGrow && this.calculateInputHeight();
    },
    blur: function blur(e) {
      var _this3 = this;

      this.validate();
      this.$nextTick(function () {
        return _this3.focused = false;
      });
      this.$emit('blur', e);
    },
    focus: function focus(e) {
      this.focused = true;
      this.$refs.input.focus();
      this.$emit('focus', e);
    },
    genCounter: function genCounter() {
      return this.$createElement('div', {
        'class': {
          'input-group__counter': true,
          'input-group__counter--error': !this.counterIsValid()
        }
      }, this.count);
    },
    genInput: function genInput() {
      var tag = this.multiLine || this.textarea ? 'textarea' : 'input';

      var data = {
        style: {
          'height': this.inputHeight && this.inputHeight + 'px'
        },
        domProps: {
          autofocus: this.autofocus,
          disabled: this.disabled,
          required: this.required,
          value: this.lazyValue
        },
        attrs: _extends({}, this.$attrs, {
          tabindex: this.tabindex,
          'aria-label': !this.$attrs.id && this.label // Label `for` will be set if we have an id
        }),
        on: _extends({}, this.$listeners, {
          blur: this.blur,
          input: this.onInput,
          focus: this.focus
        }),
        ref: 'input'
      };

      if (this.placeholder) data.domProps.placeholder = this.placeholder;

      if (!this.counter) {
        if (![undefined, null].includes(this.max)) data.attrs.max = this.max;
        if (![undefined, null].includes(this.min)) data.attrs.min = this.min;
      }

      if (!this.textarea && !this.multiLine) {
        data.domProps.type = this.type;
      } else {
        data.domProps.rows = this.rows;
      }

      var children = [this.$createElement(tag, data)];

      this.prefix && children.unshift(this.genFix('prefix'));
      this.suffix && children.push(this.genFix('suffix'));

      return children;
    },
    genFix: function genFix(type) {
      return this.$createElement('span', {
        'class': 'input-group--text-field__' + type
      }, this[type]);
    },

    counterIsValid: function counterIsValid() {
      var val = this.inputValue && this.inputValue.toString() || '';

      return !this.counter || val.length >= this.counterMin && val.length <= this.counterMax;
    },
    validateIsValid: function validateIsValid() {
      return !this.required || this.required && this.isDirty || !this.hasFocused || this.hasFocused && this.focused;
    }
  },

  render: function render() {
    return this.genInputGroup(this.genInput(), { attrs: { tabindex: false } });
  }
});

/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSnackbar__ = __webpack_require__(130);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSnackbar: __WEBPACK_IMPORTED_MODULE_0__VSnackbar__["a" /* default */]
});

/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-snackbar',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  data: function data() {
    return {
      activeTimeout: {}
    };
  },


  props: {
    absolute: Boolean,
    bottom: Boolean,
    left: Boolean,
    multiLine: Boolean,
    right: Boolean,
    top: Boolean,
    timeout: {
      type: Number,
      default: 6000
    },
    vertical: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'snack': true,
        'snack--active': this.isActive,
        'snack--absolute': this.absolute,
        'snack--bottom': this.bottom || !this.top,
        'snack--left': this.left,
        'snack--multi-line': this.multiLine && !this.vertical,
        'snack--right': this.right,
        'snack--top': this.top,
        'snack--vertical': this.vertical,
        'primary': this.primary,
        'secondary': this.secondary,
        'success': this.success,
        'info': this.info,
        'warning': this.warning,
        'error': this.error
      };
    },
    computedTransition: function computedTransition() {
      return this.top ? 'v-slide-y-transition' : 'v-slide-y-reverse-transition';
    }
  },

  watch: {
    isActive: function isActive() {
      var _this = this;

      clearTimeout(this.activeTimeout);

      if (this.isActive && this.timeout) {
        this.activeTimeout = setTimeout(function () {
          _this.isActive = false;
        }, this.timeout);
      }
    }
  },

  render: function render(h) {
    var children = [];

    if (this.isActive) {
      children.push(h('div', {
        'class': 'snack__content'
      }, this.$slots.default));
    }

    return h('div', {
      'class': this.classes,
      on: this.$listeners
    }, [h(this.computedTransition, children)]);
  }
});

/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function load(cb) {
  var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  if (document.readyState === 'complete') {
    return setTimeout(cb, 0);
  }

  if (document.readyState === 'interactive' && i <= 10) {
    return setTimeout(function () {
      return load(cb, i + 1);
    }, 200);
  }

  window.addEventListener('load', cb);
}

/* harmony default export */ __webpack_exports__["a"] = (load);

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {exports = module.exports = SemVer;

// The debug function is excluded entirely from the minified version.
/* nomin */ var debug;
/* nomin */ if (typeof process === 'object' &&
    /* nomin */ process.env &&
    /* nomin */ process.env.NODE_DEBUG &&
    /* nomin */ /\bsemver\b/i.test(process.env.NODE_DEBUG))
  /* nomin */ debug = function() {
    /* nomin */ var args = Array.prototype.slice.call(arguments, 0);
    /* nomin */ args.unshift('SEMVER');
    /* nomin */ console.log.apply(console, args);
    /* nomin */ };
/* nomin */ else
  /* nomin */ debug = function() {};

// Note: this is the semver.org version of the spec that it implements
// Not necessarily the package version of this code.
exports.SEMVER_SPEC_VERSION = '2.0.0';

var MAX_LENGTH = 256;
var MAX_SAFE_INTEGER = Number.MAX_SAFE_INTEGER || 9007199254740991;

// The actual regexps go on exports.re
var re = exports.re = [];
var src = exports.src = [];
var R = 0;

// The following Regular Expressions can be used for tokenizing,
// validating, and parsing SemVer version strings.

// ## Numeric Identifier
// A single `0`, or a non-zero digit followed by zero or more digits.

var NUMERICIDENTIFIER = R++;
src[NUMERICIDENTIFIER] = '0|[1-9]\\d*';
var NUMERICIDENTIFIERLOOSE = R++;
src[NUMERICIDENTIFIERLOOSE] = '[0-9]+';


// ## Non-numeric Identifier
// Zero or more digits, followed by a letter or hyphen, and then zero or
// more letters, digits, or hyphens.

var NONNUMERICIDENTIFIER = R++;
src[NONNUMERICIDENTIFIER] = '\\d*[a-zA-Z-][a-zA-Z0-9-]*';


// ## Main Version
// Three dot-separated numeric identifiers.

var MAINVERSION = R++;
src[MAINVERSION] = '(' + src[NUMERICIDENTIFIER] + ')\\.' +
                   '(' + src[NUMERICIDENTIFIER] + ')\\.' +
                   '(' + src[NUMERICIDENTIFIER] + ')';

var MAINVERSIONLOOSE = R++;
src[MAINVERSIONLOOSE] = '(' + src[NUMERICIDENTIFIERLOOSE] + ')\\.' +
                        '(' + src[NUMERICIDENTIFIERLOOSE] + ')\\.' +
                        '(' + src[NUMERICIDENTIFIERLOOSE] + ')';

// ## Pre-release Version Identifier
// A numeric identifier, or a non-numeric identifier.

var PRERELEASEIDENTIFIER = R++;
src[PRERELEASEIDENTIFIER] = '(?:' + src[NUMERICIDENTIFIER] +
                            '|' + src[NONNUMERICIDENTIFIER] + ')';

var PRERELEASEIDENTIFIERLOOSE = R++;
src[PRERELEASEIDENTIFIERLOOSE] = '(?:' + src[NUMERICIDENTIFIERLOOSE] +
                                 '|' + src[NONNUMERICIDENTIFIER] + ')';


// ## Pre-release Version
// Hyphen, followed by one or more dot-separated pre-release version
// identifiers.

var PRERELEASE = R++;
src[PRERELEASE] = '(?:-(' + src[PRERELEASEIDENTIFIER] +
                  '(?:\\.' + src[PRERELEASEIDENTIFIER] + ')*))';

var PRERELEASELOOSE = R++;
src[PRERELEASELOOSE] = '(?:-?(' + src[PRERELEASEIDENTIFIERLOOSE] +
                       '(?:\\.' + src[PRERELEASEIDENTIFIERLOOSE] + ')*))';

// ## Build Metadata Identifier
// Any combination of digits, letters, or hyphens.

var BUILDIDENTIFIER = R++;
src[BUILDIDENTIFIER] = '[0-9A-Za-z-]+';

// ## Build Metadata
// Plus sign, followed by one or more period-separated build metadata
// identifiers.

var BUILD = R++;
src[BUILD] = '(?:\\+(' + src[BUILDIDENTIFIER] +
             '(?:\\.' + src[BUILDIDENTIFIER] + ')*))';


// ## Full Version String
// A main version, followed optionally by a pre-release version and
// build metadata.

// Note that the only major, minor, patch, and pre-release sections of
// the version string are capturing groups.  The build metadata is not a
// capturing group, because it should not ever be used in version
// comparison.

var FULL = R++;
var FULLPLAIN = 'v?' + src[MAINVERSION] +
                src[PRERELEASE] + '?' +
                src[BUILD] + '?';

src[FULL] = '^' + FULLPLAIN + '$';

// like full, but allows v1.2.3 and =1.2.3, which people do sometimes.
// also, 1.0.0alpha1 (prerelease without the hyphen) which is pretty
// common in the npm registry.
var LOOSEPLAIN = '[v=\\s]*' + src[MAINVERSIONLOOSE] +
                 src[PRERELEASELOOSE] + '?' +
                 src[BUILD] + '?';

var LOOSE = R++;
src[LOOSE] = '^' + LOOSEPLAIN + '$';

var GTLT = R++;
src[GTLT] = '((?:<|>)?=?)';

// Something like "2.*" or "1.2.x".
// Note that "x.x" is a valid xRange identifer, meaning "any version"
// Only the first item is strictly required.
var XRANGEIDENTIFIERLOOSE = R++;
src[XRANGEIDENTIFIERLOOSE] = src[NUMERICIDENTIFIERLOOSE] + '|x|X|\\*';
var XRANGEIDENTIFIER = R++;
src[XRANGEIDENTIFIER] = src[NUMERICIDENTIFIER] + '|x|X|\\*';

var XRANGEPLAIN = R++;
src[XRANGEPLAIN] = '[v=\\s]*(' + src[XRANGEIDENTIFIER] + ')' +
                   '(?:\\.(' + src[XRANGEIDENTIFIER] + ')' +
                   '(?:\\.(' + src[XRANGEIDENTIFIER] + ')' +
                   '(?:' + src[PRERELEASE] + ')?' +
                   src[BUILD] + '?' +
                   ')?)?';

var XRANGEPLAINLOOSE = R++;
src[XRANGEPLAINLOOSE] = '[v=\\s]*(' + src[XRANGEIDENTIFIERLOOSE] + ')' +
                        '(?:\\.(' + src[XRANGEIDENTIFIERLOOSE] + ')' +
                        '(?:\\.(' + src[XRANGEIDENTIFIERLOOSE] + ')' +
                        '(?:' + src[PRERELEASELOOSE] + ')?' +
                        src[BUILD] + '?' +
                        ')?)?';

var XRANGE = R++;
src[XRANGE] = '^' + src[GTLT] + '\\s*' + src[XRANGEPLAIN] + '$';
var XRANGELOOSE = R++;
src[XRANGELOOSE] = '^' + src[GTLT] + '\\s*' + src[XRANGEPLAINLOOSE] + '$';

// Tilde ranges.
// Meaning is "reasonably at or greater than"
var LONETILDE = R++;
src[LONETILDE] = '(?:~>?)';

var TILDETRIM = R++;
src[TILDETRIM] = '(\\s*)' + src[LONETILDE] + '\\s+';
re[TILDETRIM] = new RegExp(src[TILDETRIM], 'g');
var tildeTrimReplace = '$1~';

var TILDE = R++;
src[TILDE] = '^' + src[LONETILDE] + src[XRANGEPLAIN] + '$';
var TILDELOOSE = R++;
src[TILDELOOSE] = '^' + src[LONETILDE] + src[XRANGEPLAINLOOSE] + '$';

// Caret ranges.
// Meaning is "at least and backwards compatible with"
var LONECARET = R++;
src[LONECARET] = '(?:\\^)';

var CARETTRIM = R++;
src[CARETTRIM] = '(\\s*)' + src[LONECARET] + '\\s+';
re[CARETTRIM] = new RegExp(src[CARETTRIM], 'g');
var caretTrimReplace = '$1^';

var CARET = R++;
src[CARET] = '^' + src[LONECARET] + src[XRANGEPLAIN] + '$';
var CARETLOOSE = R++;
src[CARETLOOSE] = '^' + src[LONECARET] + src[XRANGEPLAINLOOSE] + '$';

// A simple gt/lt/eq thing, or just "" to indicate "any version"
var COMPARATORLOOSE = R++;
src[COMPARATORLOOSE] = '^' + src[GTLT] + '\\s*(' + LOOSEPLAIN + ')$|^$';
var COMPARATOR = R++;
src[COMPARATOR] = '^' + src[GTLT] + '\\s*(' + FULLPLAIN + ')$|^$';


// An expression to strip any whitespace between the gtlt and the thing
// it modifies, so that `> 1.2.3` ==> `>1.2.3`
var COMPARATORTRIM = R++;
src[COMPARATORTRIM] = '(\\s*)' + src[GTLT] +
                      '\\s*(' + LOOSEPLAIN + '|' + src[XRANGEPLAIN] + ')';

// this one has to use the /g flag
re[COMPARATORTRIM] = new RegExp(src[COMPARATORTRIM], 'g');
var comparatorTrimReplace = '$1$2$3';


// Something like `1.2.3 - 1.2.4`
// Note that these all use the loose form, because they'll be
// checked against either the strict or loose comparator form
// later.
var HYPHENRANGE = R++;
src[HYPHENRANGE] = '^\\s*(' + src[XRANGEPLAIN] + ')' +
                   '\\s+-\\s+' +
                   '(' + src[XRANGEPLAIN] + ')' +
                   '\\s*$';

var HYPHENRANGELOOSE = R++;
src[HYPHENRANGELOOSE] = '^\\s*(' + src[XRANGEPLAINLOOSE] + ')' +
                        '\\s+-\\s+' +
                        '(' + src[XRANGEPLAINLOOSE] + ')' +
                        '\\s*$';

// Star ranges basically just allow anything at all.
var STAR = R++;
src[STAR] = '(<|>)?=?\\s*\\*';

// Compile to actual regexp objects.
// All are flag-free, unless they were created above with a flag.
for (var i = 0; i < R; i++) {
  debug(i, src[i]);
  if (!re[i])
    re[i] = new RegExp(src[i]);
}

exports.parse = parse;
function parse(version, loose) {
  if (version instanceof SemVer)
    return version;

  if (typeof version !== 'string')
    return null;

  if (version.length > MAX_LENGTH)
    return null;

  var r = loose ? re[LOOSE] : re[FULL];
  if (!r.test(version))
    return null;

  try {
    return new SemVer(version, loose);
  } catch (er) {
    return null;
  }
}

exports.valid = valid;
function valid(version, loose) {
  var v = parse(version, loose);
  return v ? v.version : null;
}


exports.clean = clean;
function clean(version, loose) {
  var s = parse(version.trim().replace(/^[=v]+/, ''), loose);
  return s ? s.version : null;
}

exports.SemVer = SemVer;

function SemVer(version, loose) {
  if (version instanceof SemVer) {
    if (version.loose === loose)
      return version;
    else
      version = version.version;
  } else if (typeof version !== 'string') {
    throw new TypeError('Invalid Version: ' + version);
  }

  if (version.length > MAX_LENGTH)
    throw new TypeError('version is longer than ' + MAX_LENGTH + ' characters')

  if (!(this instanceof SemVer))
    return new SemVer(version, loose);

  debug('SemVer', version, loose);
  this.loose = loose;
  var m = version.trim().match(loose ? re[LOOSE] : re[FULL]);

  if (!m)
    throw new TypeError('Invalid Version: ' + version);

  this.raw = version;

  // these are actually numbers
  this.major = +m[1];
  this.minor = +m[2];
  this.patch = +m[3];

  if (this.major > MAX_SAFE_INTEGER || this.major < 0)
    throw new TypeError('Invalid major version')

  if (this.minor > MAX_SAFE_INTEGER || this.minor < 0)
    throw new TypeError('Invalid minor version')

  if (this.patch > MAX_SAFE_INTEGER || this.patch < 0)
    throw new TypeError('Invalid patch version')

  // numberify any prerelease numeric ids
  if (!m[4])
    this.prerelease = [];
  else
    this.prerelease = m[4].split('.').map(function(id) {
      if (/^[0-9]+$/.test(id)) {
        var num = +id;
        if (num >= 0 && num < MAX_SAFE_INTEGER)
          return num;
      }
      return id;
    });

  this.build = m[5] ? m[5].split('.') : [];
  this.format();
}

SemVer.prototype.format = function() {
  this.version = this.major + '.' + this.minor + '.' + this.patch;
  if (this.prerelease.length)
    this.version += '-' + this.prerelease.join('.');
  return this.version;
};

SemVer.prototype.toString = function() {
  return this.version;
};

SemVer.prototype.compare = function(other) {
  debug('SemVer.compare', this.version, this.loose, other);
  if (!(other instanceof SemVer))
    other = new SemVer(other, this.loose);

  return this.compareMain(other) || this.comparePre(other);
};

SemVer.prototype.compareMain = function(other) {
  if (!(other instanceof SemVer))
    other = new SemVer(other, this.loose);

  return compareIdentifiers(this.major, other.major) ||
         compareIdentifiers(this.minor, other.minor) ||
         compareIdentifiers(this.patch, other.patch);
};

SemVer.prototype.comparePre = function(other) {
  if (!(other instanceof SemVer))
    other = new SemVer(other, this.loose);

  // NOT having a prerelease is > having one
  if (this.prerelease.length && !other.prerelease.length)
    return -1;
  else if (!this.prerelease.length && other.prerelease.length)
    return 1;
  else if (!this.prerelease.length && !other.prerelease.length)
    return 0;

  var i = 0;
  do {
    var a = this.prerelease[i];
    var b = other.prerelease[i];
    debug('prerelease compare', i, a, b);
    if (a === undefined && b === undefined)
      return 0;
    else if (b === undefined)
      return 1;
    else if (a === undefined)
      return -1;
    else if (a === b)
      continue;
    else
      return compareIdentifiers(a, b);
  } while (++i);
};

// preminor will bump the version up to the next minor release, and immediately
// down to pre-release. premajor and prepatch work the same way.
SemVer.prototype.inc = function(release, identifier) {
  switch (release) {
    case 'premajor':
      this.prerelease.length = 0;
      this.patch = 0;
      this.minor = 0;
      this.major++;
      this.inc('pre', identifier);
      break;
    case 'preminor':
      this.prerelease.length = 0;
      this.patch = 0;
      this.minor++;
      this.inc('pre', identifier);
      break;
    case 'prepatch':
      // If this is already a prerelease, it will bump to the next version
      // drop any prereleases that might already exist, since they are not
      // relevant at this point.
      this.prerelease.length = 0;
      this.inc('patch', identifier);
      this.inc('pre', identifier);
      break;
    // If the input is a non-prerelease version, this acts the same as
    // prepatch.
    case 'prerelease':
      if (this.prerelease.length === 0)
        this.inc('patch', identifier);
      this.inc('pre', identifier);
      break;

    case 'major':
      // If this is a pre-major version, bump up to the same major version.
      // Otherwise increment major.
      // 1.0.0-5 bumps to 1.0.0
      // 1.1.0 bumps to 2.0.0
      if (this.minor !== 0 || this.patch !== 0 || this.prerelease.length === 0)
        this.major++;
      this.minor = 0;
      this.patch = 0;
      this.prerelease = [];
      break;
    case 'minor':
      // If this is a pre-minor version, bump up to the same minor version.
      // Otherwise increment minor.
      // 1.2.0-5 bumps to 1.2.0
      // 1.2.1 bumps to 1.3.0
      if (this.patch !== 0 || this.prerelease.length === 0)
        this.minor++;
      this.patch = 0;
      this.prerelease = [];
      break;
    case 'patch':
      // If this is not a pre-release version, it will increment the patch.
      // If it is a pre-release it will bump up to the same patch version.
      // 1.2.0-5 patches to 1.2.0
      // 1.2.0 patches to 1.2.1
      if (this.prerelease.length === 0)
        this.patch++;
      this.prerelease = [];
      break;
    // This probably shouldn't be used publicly.
    // 1.0.0 "pre" would become 1.0.0-0 which is the wrong direction.
    case 'pre':
      if (this.prerelease.length === 0)
        this.prerelease = [0];
      else {
        var i = this.prerelease.length;
        while (--i >= 0) {
          if (typeof this.prerelease[i] === 'number') {
            this.prerelease[i]++;
            i = -2;
          }
        }
        if (i === -1) // didn't increment anything
          this.prerelease.push(0);
      }
      if (identifier) {
        // 1.2.0-beta.1 bumps to 1.2.0-beta.2,
        // 1.2.0-beta.fooblz or 1.2.0-beta bumps to 1.2.0-beta.0
        if (this.prerelease[0] === identifier) {
          if (isNaN(this.prerelease[1]))
            this.prerelease = [identifier, 0];
        } else
          this.prerelease = [identifier, 0];
      }
      break;

    default:
      throw new Error('invalid increment argument: ' + release);
  }
  this.format();
  this.raw = this.version;
  return this;
};

exports.inc = inc;
function inc(version, release, loose, identifier) {
  if (typeof(loose) === 'string') {
    identifier = loose;
    loose = undefined;
  }

  try {
    return new SemVer(version, loose).inc(release, identifier).version;
  } catch (er) {
    return null;
  }
}

exports.diff = diff;
function diff(version1, version2) {
  if (eq(version1, version2)) {
    return null;
  } else {
    var v1 = parse(version1);
    var v2 = parse(version2);
    if (v1.prerelease.length || v2.prerelease.length) {
      for (var key in v1) {
        if (key === 'major' || key === 'minor' || key === 'patch') {
          if (v1[key] !== v2[key]) {
            return 'pre'+key;
          }
        }
      }
      return 'prerelease';
    }
    for (var key in v1) {
      if (key === 'major' || key === 'minor' || key === 'patch') {
        if (v1[key] !== v2[key]) {
          return key;
        }
      }
    }
  }
}

exports.compareIdentifiers = compareIdentifiers;

var numeric = /^[0-9]+$/;
function compareIdentifiers(a, b) {
  var anum = numeric.test(a);
  var bnum = numeric.test(b);

  if (anum && bnum) {
    a = +a;
    b = +b;
  }

  return (anum && !bnum) ? -1 :
         (bnum && !anum) ? 1 :
         a < b ? -1 :
         a > b ? 1 :
         0;
}

exports.rcompareIdentifiers = rcompareIdentifiers;
function rcompareIdentifiers(a, b) {
  return compareIdentifiers(b, a);
}

exports.major = major;
function major(a, loose) {
  return new SemVer(a, loose).major;
}

exports.minor = minor;
function minor(a, loose) {
  return new SemVer(a, loose).minor;
}

exports.patch = patch;
function patch(a, loose) {
  return new SemVer(a, loose).patch;
}

exports.compare = compare;
function compare(a, b, loose) {
  return new SemVer(a, loose).compare(b);
}

exports.compareLoose = compareLoose;
function compareLoose(a, b) {
  return compare(a, b, true);
}

exports.rcompare = rcompare;
function rcompare(a, b, loose) {
  return compare(b, a, loose);
}

exports.sort = sort;
function sort(list, loose) {
  return list.sort(function(a, b) {
    return exports.compare(a, b, loose);
  });
}

exports.rsort = rsort;
function rsort(list, loose) {
  return list.sort(function(a, b) {
    return exports.rcompare(a, b, loose);
  });
}

exports.gt = gt;
function gt(a, b, loose) {
  return compare(a, b, loose) > 0;
}

exports.lt = lt;
function lt(a, b, loose) {
  return compare(a, b, loose) < 0;
}

exports.eq = eq;
function eq(a, b, loose) {
  return compare(a, b, loose) === 0;
}

exports.neq = neq;
function neq(a, b, loose) {
  return compare(a, b, loose) !== 0;
}

exports.gte = gte;
function gte(a, b, loose) {
  return compare(a, b, loose) >= 0;
}

exports.lte = lte;
function lte(a, b, loose) {
  return compare(a, b, loose) <= 0;
}

exports.cmp = cmp;
function cmp(a, op, b, loose) {
  var ret;
  switch (op) {
    case '===':
      if (typeof a === 'object') a = a.version;
      if (typeof b === 'object') b = b.version;
      ret = a === b;
      break;
    case '!==':
      if (typeof a === 'object') a = a.version;
      if (typeof b === 'object') b = b.version;
      ret = a !== b;
      break;
    case '': case '=': case '==': ret = eq(a, b, loose); break;
    case '!=': ret = neq(a, b, loose); break;
    case '>': ret = gt(a, b, loose); break;
    case '>=': ret = gte(a, b, loose); break;
    case '<': ret = lt(a, b, loose); break;
    case '<=': ret = lte(a, b, loose); break;
    default: throw new TypeError('Invalid operator: ' + op);
  }
  return ret;
}

exports.Comparator = Comparator;
function Comparator(comp, loose) {
  if (comp instanceof Comparator) {
    if (comp.loose === loose)
      return comp;
    else
      comp = comp.value;
  }

  if (!(this instanceof Comparator))
    return new Comparator(comp, loose);

  debug('comparator', comp, loose);
  this.loose = loose;
  this.parse(comp);

  if (this.semver === ANY)
    this.value = '';
  else
    this.value = this.operator + this.semver.version;

  debug('comp', this);
}

var ANY = {};
Comparator.prototype.parse = function(comp) {
  var r = this.loose ? re[COMPARATORLOOSE] : re[COMPARATOR];
  var m = comp.match(r);

  if (!m)
    throw new TypeError('Invalid comparator: ' + comp);

  this.operator = m[1];
  if (this.operator === '=')
    this.operator = '';

  // if it literally is just '>' or '' then allow anything.
  if (!m[2])
    this.semver = ANY;
  else
    this.semver = new SemVer(m[2], this.loose);
};

Comparator.prototype.toString = function() {
  return this.value;
};

Comparator.prototype.test = function(version) {
  debug('Comparator.test', version, this.loose);

  if (this.semver === ANY)
    return true;

  if (typeof version === 'string')
    version = new SemVer(version, this.loose);

  return cmp(version, this.operator, this.semver, this.loose);
};


exports.Range = Range;
function Range(range, loose) {
  if ((range instanceof Range) && range.loose === loose)
    return range;

  if (!(this instanceof Range))
    return new Range(range, loose);

  this.loose = loose;

  // First, split based on boolean or ||
  this.raw = range;
  this.set = range.split(/\s*\|\|\s*/).map(function(range) {
    return this.parseRange(range.trim());
  }, this).filter(function(c) {
    // throw out any that are not relevant for whatever reason
    return c.length;
  });

  if (!this.set.length) {
    throw new TypeError('Invalid SemVer Range: ' + range);
  }

  this.format();
}

Range.prototype.format = function() {
  this.range = this.set.map(function(comps) {
    return comps.join(' ').trim();
  }).join('||').trim();
  return this.range;
};

Range.prototype.toString = function() {
  return this.range;
};

Range.prototype.parseRange = function(range) {
  var loose = this.loose;
  range = range.trim();
  debug('range', range, loose);
  // `1.2.3 - 1.2.4` => `>=1.2.3 <=1.2.4`
  var hr = loose ? re[HYPHENRANGELOOSE] : re[HYPHENRANGE];
  range = range.replace(hr, hyphenReplace);
  debug('hyphen replace', range);
  // `> 1.2.3 < 1.2.5` => `>1.2.3 <1.2.5`
  range = range.replace(re[COMPARATORTRIM], comparatorTrimReplace);
  debug('comparator trim', range, re[COMPARATORTRIM]);

  // `~ 1.2.3` => `~1.2.3`
  range = range.replace(re[TILDETRIM], tildeTrimReplace);

  // `^ 1.2.3` => `^1.2.3`
  range = range.replace(re[CARETTRIM], caretTrimReplace);

  // normalize spaces
  range = range.split(/\s+/).join(' ');

  // At this point, the range is completely trimmed and
  // ready to be split into comparators.

  var compRe = loose ? re[COMPARATORLOOSE] : re[COMPARATOR];
  var set = range.split(' ').map(function(comp) {
    return parseComparator(comp, loose);
  }).join(' ').split(/\s+/);
  if (this.loose) {
    // in loose mode, throw out any that are not valid comparators
    set = set.filter(function(comp) {
      return !!comp.match(compRe);
    });
  }
  set = set.map(function(comp) {
    return new Comparator(comp, loose);
  });

  return set;
};

// Mostly just for testing and legacy API reasons
exports.toComparators = toComparators;
function toComparators(range, loose) {
  return new Range(range, loose).set.map(function(comp) {
    return comp.map(function(c) {
      return c.value;
    }).join(' ').trim().split(' ');
  });
}

// comprised of xranges, tildes, stars, and gtlt's at this point.
// already replaced the hyphen ranges
// turn into a set of JUST comparators.
function parseComparator(comp, loose) {
  debug('comp', comp);
  comp = replaceCarets(comp, loose);
  debug('caret', comp);
  comp = replaceTildes(comp, loose);
  debug('tildes', comp);
  comp = replaceXRanges(comp, loose);
  debug('xrange', comp);
  comp = replaceStars(comp, loose);
  debug('stars', comp);
  return comp;
}

function isX(id) {
  return !id || id.toLowerCase() === 'x' || id === '*';
}

// ~, ~> --> * (any, kinda silly)
// ~2, ~2.x, ~2.x.x, ~>2, ~>2.x ~>2.x.x --> >=2.0.0 <3.0.0
// ~2.0, ~2.0.x, ~>2.0, ~>2.0.x --> >=2.0.0 <2.1.0
// ~1.2, ~1.2.x, ~>1.2, ~>1.2.x --> >=1.2.0 <1.3.0
// ~1.2.3, ~>1.2.3 --> >=1.2.3 <1.3.0
// ~1.2.0, ~>1.2.0 --> >=1.2.0 <1.3.0
function replaceTildes(comp, loose) {
  return comp.trim().split(/\s+/).map(function(comp) {
    return replaceTilde(comp, loose);
  }).join(' ');
}

function replaceTilde(comp, loose) {
  var r = loose ? re[TILDELOOSE] : re[TILDE];
  return comp.replace(r, function(_, M, m, p, pr) {
    debug('tilde', comp, _, M, m, p, pr);
    var ret;

    if (isX(M))
      ret = '';
    else if (isX(m))
      ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0';
    else if (isX(p))
      // ~1.2 == >=1.2.0 <1.3.0
      ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0';
    else if (pr) {
      debug('replaceTilde pr', pr);
      if (pr.charAt(0) !== '-')
        pr = '-' + pr;
      ret = '>=' + M + '.' + m + '.' + p + pr +
            ' <' + M + '.' + (+m + 1) + '.0';
    } else
      // ~1.2.3 == >=1.2.3 <1.3.0
      ret = '>=' + M + '.' + m + '.' + p +
            ' <' + M + '.' + (+m + 1) + '.0';

    debug('tilde return', ret);
    return ret;
  });
}

// ^ --> * (any, kinda silly)
// ^2, ^2.x, ^2.x.x --> >=2.0.0 <3.0.0
// ^2.0, ^2.0.x --> >=2.0.0 <3.0.0
// ^1.2, ^1.2.x --> >=1.2.0 <2.0.0
// ^1.2.3 --> >=1.2.3 <2.0.0
// ^1.2.0 --> >=1.2.0 <2.0.0
function replaceCarets(comp, loose) {
  return comp.trim().split(/\s+/).map(function(comp) {
    return replaceCaret(comp, loose);
  }).join(' ');
}

function replaceCaret(comp, loose) {
  debug('caret', comp, loose);
  var r = loose ? re[CARETLOOSE] : re[CARET];
  return comp.replace(r, function(_, M, m, p, pr) {
    debug('caret', comp, _, M, m, p, pr);
    var ret;

    if (isX(M))
      ret = '';
    else if (isX(m))
      ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0';
    else if (isX(p)) {
      if (M === '0')
        ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0';
      else
        ret = '>=' + M + '.' + m + '.0 <' + (+M + 1) + '.0.0';
    } else if (pr) {
      debug('replaceCaret pr', pr);
      if (pr.charAt(0) !== '-')
        pr = '-' + pr;
      if (M === '0') {
        if (m === '0')
          ret = '>=' + M + '.' + m + '.' + p + pr +
                ' <' + M + '.' + m + '.' + (+p + 1);
        else
          ret = '>=' + M + '.' + m + '.' + p + pr +
                ' <' + M + '.' + (+m + 1) + '.0';
      } else
        ret = '>=' + M + '.' + m + '.' + p + pr +
              ' <' + (+M + 1) + '.0.0';
    } else {
      debug('no pr');
      if (M === '0') {
        if (m === '0')
          ret = '>=' + M + '.' + m + '.' + p +
                ' <' + M + '.' + m + '.' + (+p + 1);
        else
          ret = '>=' + M + '.' + m + '.' + p +
                ' <' + M + '.' + (+m + 1) + '.0';
      } else
        ret = '>=' + M + '.' + m + '.' + p +
              ' <' + (+M + 1) + '.0.0';
    }

    debug('caret return', ret);
    return ret;
  });
}

function replaceXRanges(comp, loose) {
  debug('replaceXRanges', comp, loose);
  return comp.split(/\s+/).map(function(comp) {
    return replaceXRange(comp, loose);
  }).join(' ');
}

function replaceXRange(comp, loose) {
  comp = comp.trim();
  var r = loose ? re[XRANGELOOSE] : re[XRANGE];
  return comp.replace(r, function(ret, gtlt, M, m, p, pr) {
    debug('xRange', comp, ret, gtlt, M, m, p, pr);
    var xM = isX(M);
    var xm = xM || isX(m);
    var xp = xm || isX(p);
    var anyX = xp;

    if (gtlt === '=' && anyX)
      gtlt = '';

    if (xM) {
      if (gtlt === '>' || gtlt === '<') {
        // nothing is allowed
        ret = '<0.0.0';
      } else {
        // nothing is forbidden
        ret = '*';
      }
    } else if (gtlt && anyX) {
      // replace X with 0
      if (xm)
        m = 0;
      if (xp)
        p = 0;

      if (gtlt === '>') {
        // >1 => >=2.0.0
        // >1.2 => >=1.3.0
        // >1.2.3 => >= 1.2.4
        gtlt = '>=';
        if (xm) {
          M = +M + 1;
          m = 0;
          p = 0;
        } else if (xp) {
          m = +m + 1;
          p = 0;
        }
      } else if (gtlt === '<=') {
        // <=0.7.x is actually <0.8.0, since any 0.7.x should
        // pass.  Similarly, <=7.x is actually <8.0.0, etc.
        gtlt = '<';
        if (xm)
          M = +M + 1;
        else
          m = +m + 1;
      }

      ret = gtlt + M + '.' + m + '.' + p;
    } else if (xm) {
      ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0';
    } else if (xp) {
      ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0';
    }

    debug('xRange return', ret);

    return ret;
  });
}

// Because * is AND-ed with everything else in the comparator,
// and '' means "any version", just remove the *s entirely.
function replaceStars(comp, loose) {
  debug('replaceStars', comp, loose);
  // Looseness is ignored here.  star is always as loose as it gets!
  return comp.trim().replace(re[STAR], '');
}

// This function is passed to string.replace(re[HYPHENRANGE])
// M, m, patch, prerelease, build
// 1.2 - 3.4.5 => >=1.2.0 <=3.4.5
// 1.2.3 - 3.4 => >=1.2.0 <3.5.0 Any 3.4.x will do
// 1.2 - 3.4 => >=1.2.0 <3.5.0
function hyphenReplace($0,
                       from, fM, fm, fp, fpr, fb,
                       to, tM, tm, tp, tpr, tb) {

  if (isX(fM))
    from = '';
  else if (isX(fm))
    from = '>=' + fM + '.0.0';
  else if (isX(fp))
    from = '>=' + fM + '.' + fm + '.0';
  else
    from = '>=' + from;

  if (isX(tM))
    to = '';
  else if (isX(tm))
    to = '<' + (+tM + 1) + '.0.0';
  else if (isX(tp))
    to = '<' + tM + '.' + (+tm + 1) + '.0';
  else if (tpr)
    to = '<=' + tM + '.' + tm + '.' + tp + '-' + tpr;
  else
    to = '<=' + to;

  return (from + ' ' + to).trim();
}


// if ANY of the sets match ALL of its comparators, then pass
Range.prototype.test = function(version) {
  if (!version)
    return false;

  if (typeof version === 'string')
    version = new SemVer(version, this.loose);

  for (var i = 0; i < this.set.length; i++) {
    if (testSet(this.set[i], version))
      return true;
  }
  return false;
};

function testSet(set, version) {
  for (var i = 0; i < set.length; i++) {
    if (!set[i].test(version))
      return false;
  }

  if (version.prerelease.length) {
    // Find the set of versions that are allowed to have prereleases
    // For example, ^1.2.3-pr.1 desugars to >=1.2.3-pr.1 <2.0.0
    // That should allow `1.2.3-pr.2` to pass.
    // However, `1.2.4-alpha.notready` should NOT be allowed,
    // even though it's within the range set by the comparators.
    for (var i = 0; i < set.length; i++) {
      debug(set[i].semver);
      if (set[i].semver === ANY)
        continue;

      if (set[i].semver.prerelease.length > 0) {
        var allowed = set[i].semver;
        if (allowed.major === version.major &&
            allowed.minor === version.minor &&
            allowed.patch === version.patch)
          return true;
      }
    }

    // Version has a -pre, but it's not one of the ones we like.
    return false;
  }

  return true;
}

exports.satisfies = satisfies;
function satisfies(version, range, loose) {
  try {
    range = new Range(range, loose);
  } catch (er) {
    return false;
  }
  return range.test(version);
}

exports.maxSatisfying = maxSatisfying;
function maxSatisfying(versions, range, loose) {
  return versions.filter(function(version) {
    return satisfies(version, range, loose);
  }).sort(function(a, b) {
    return rcompare(a, b, loose);
  })[0] || null;
}

exports.minSatisfying = minSatisfying;
function minSatisfying(versions, range, loose) {
  return versions.filter(function(version) {
    return satisfies(version, range, loose);
  }).sort(function(a, b) {
    return compare(a, b, loose);
  })[0] || null;
}

exports.validRange = validRange;
function validRange(range, loose) {
  try {
    // Return '*' instead of '' so that truthiness works.
    // This will throw if it's invalid anyway
    return new Range(range, loose).range || '*';
  } catch (er) {
    return null;
  }
}

// Determine if version is less than all the versions possible in the range
exports.ltr = ltr;
function ltr(version, range, loose) {
  return outside(version, range, '<', loose);
}

// Determine if version is greater than all the versions possible in the range.
exports.gtr = gtr;
function gtr(version, range, loose) {
  return outside(version, range, '>', loose);
}

exports.outside = outside;
function outside(version, range, hilo, loose) {
  version = new SemVer(version, loose);
  range = new Range(range, loose);

  var gtfn, ltefn, ltfn, comp, ecomp;
  switch (hilo) {
    case '>':
      gtfn = gt;
      ltefn = lte;
      ltfn = lt;
      comp = '>';
      ecomp = '>=';
      break;
    case '<':
      gtfn = lt;
      ltefn = gte;
      ltfn = gt;
      comp = '<';
      ecomp = '<=';
      break;
    default:
      throw new TypeError('Must provide a hilo val of "<" or ">"');
  }

  // If it satisifes the range it is not outside
  if (satisfies(version, range, loose)) {
    return false;
  }

  // From now on, variable terms are as if we're in "gtr" mode.
  // but note that everything is flipped for the "ltr" function.

  for (var i = 0; i < range.set.length; ++i) {
    var comparators = range.set[i];

    var high = null;
    var low = null;

    comparators.forEach(function(comparator) {
      if (comparator.semver === ANY) {
        comparator = new Comparator('>=0.0.0')
      }
      high = high || comparator;
      low = low || comparator;
      if (gtfn(comparator.semver, high.semver, loose)) {
        high = comparator;
      } else if (ltfn(comparator.semver, low.semver, loose)) {
        low = comparator;
      }
    });

    // If the edge version comparator has a operator then our version
    // isn't outside it
    if (high.operator === comp || high.operator === ecomp) {
      return false;
    }

    // If the lowest version comparator has an operator and our version
    // is less than it then it isn't higher than the range
    if ((!low.operator || low.operator === comp) &&
        ltefn(version, low.semver)) {
      return false;
    } else if (low.operator === ecomp && ltfn(version, low.semver)) {
      return false;
    }
  }
  return true;
}

exports.prerelease = prerelease;
function prerelease(version, loose) {
  var parsed = parse(version, loose);
  return (parsed && parsed.prerelease.length) ? parsed.prerelease : null;
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(133)))

/***/ }),
/* 133 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ })
/******/ ]);
});
//# sourceMappingURL=vuetify.js.map

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define("VueShortkey",[],t):"object"==typeof exports?exports.VueShortkey=t():e.VueShortkey=t()}("undefined"!=typeof self?self:this,function(){return function(e){function t(r){if(n[r])return n[r].exports;var o=n[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,t),o.l=!0,o.exports}var n={};return t.m=e,t.c=n,t.d=function(e,n,r){t.o(e,n)||Object.defineProperty(e,n,{configurable:!1,enumerable:!0,get:r})},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p="../dist/",t(t.s=0)}([function(e,t,n){"use strict";(function(r){function o(e){if(Array.isArray(e)){for(var t=0,n=Array(e.length);t<e.length;t++)n[t]=e[t];return n}return Array.from(e)}var c;n(2),n(3);var u={},i={},a=[],l=[],s=!1,f=function(e){return e="string"==typeof e?JSON.parse(e.replace(/\'/gi,'"')):e,e instanceof Array?{"":e}:e},p=function(e,t,n,r){var o=!0===n.modifiers.push,c=!0===n.modifiers.avoid,u=!0==!n.modifiers.focus,i=!0===n.modifiers.once;c?(a=a.filter(function(e){return!e===t}),a.push(t)):v({b:e,push:o,once:i,focus:u,el:r.elm})},y=function(e,t){for(var n in e){var r=u.encodeKey(e[n]),o=i[r].el.indexOf(t);i[r].el.length>1&&o>-1?i[r].el.splice(o,1):delete i[r]}};u.install=function(e,t){l=[].concat(o(t&&t.prevent?t.prevent:[])),e.directive("shortkey",{bind:function(e,t,n){var r=f(t.value);p(r,e,t,n)},update:function(e,t,n){var r=f(t.oldValue);y(r,e);var o=f(t.value);p(o,e,t,n)},unbind:function(e,t){var n=f(t.value);y(n,e)}})},u.decodeKey=function(e){return d(e)},u.encodeKey=function(e){var t={};t.shiftKey=e.includes("shift"),t.ctrlKey=e.includes("ctrl"),t.metaKey=e.includes("meta"),t.altKey=e.includes("alt");var n=d(t);return n+=e.filter(function(e){return!["shift","ctrl","meta","alt"].includes(e)}).join("")};var d=function(e){var t="";return("Shift"===e.key||e.shiftKey)&&(t+="shift"),("Control"===e.key||e.ctrlKey)&&(t+="ctrl"),("Meta"===e.key||e.metaKey)&&(t+="meta"),("Alt"===e.key||e.altKey)&&(t+="alt"),"ArrowUp"===e.key&&(t+="arrowup"),"ArrowLeft"===e.key&&(t+="arrowleft"),"ArrowRight"===e.key&&(t+="arrowright"),"ArrowDown"===e.key&&(t+="arrowdown"),"AltGraph"===e.key&&(t+="altgraph"),"Escape"===e.key&&(t+="esc"),"Enter"===e.key&&(t+="enter"),"Tab"===e.key&&(t+="tab")," "===e.key&&(t+="space"),"PageUp"===e.key&&(t+="pageup"),"PageDown"===e.key&&(t+="pagedown"),"Home"===e.key&&(t+="home"),"End"===e.key&&(t+="end"),"Delete"===e.key&&(t+="del"),"Backspace"===e.key&&(t+="backspace"),"Insert"===e.key&&(t+="insert"),"NumLock"===e.key&&(t+="numlock"),"CapsLock"===e.key&&(t+="capslock"),"Pause"===e.key&&(t+="pause"),"ContextMenu"===e.key&&(t+="contextmenu"),"ScrollLock"===e.key&&(t+="scrolllock"),"BrowserHome"===e.key&&(t+="browserhome"),"MediaSelect"===e.key&&(t+="mediaselect"),(e.key&&" "!==e.key&&1===e.key.length||/F\d{1,2}|\//g.test(e.key))&&(t+=e.key.toLowerCase()),t},h=function(e){var t=new CustomEvent("shortkey",{bubbles:!1});i[e].key&&(t.srcKey=i[e].key);var n=i[e].el;n[n.length-1].dispatchEvent(t)};u.keyDown=function(e){(!i[e].once&&!i[e].push||i[e].push&&!s)&&h(e)},r&&Object({NODE_ENV:"production"})&&function(){document.addEventListener("keydown",function(e){var t=u.decodeKey(e);if(m(t))if(e.preventDefault(),e.stopPropagation(),i[t].focus)u.keyDown(t),s=!0;else if(!s){var n=i[t].el;n[n.length-1].focus(),s=!0}},!0),document.addEventListener("keyup",function(e){var t=u.decodeKey(e);m(t)&&(e.preventDefault(),e.stopPropagation(),(i[t].once||i[t].push)&&h(t)),s=!1},!0)}();var v=function(e){var t=e.b,n=e.push,r=e.once,o=e.focus,c=e.el;for(var a in t){var l=u.encodeKey(t[a]),s=i[l]&&i[l].el?i[l].el:[];s.push(c),i[l]={push:n,once:r,focus:o,key:a,el:s}}},m=function(e){var t=!!a.find(function(e){return e===document.activeElement}),n=!!l.find(function(e){return document.activeElement&&document.activeElement.matches(e)});return!!i[e]&&!(t||n)};void 0!==e&&e.exports?e.exports=u:void 0!==(c=function(){return u}.call(t,n,t,e))&&(e.exports=c)}).call(t,n(1))},function(e,t){function n(){throw new Error("setTimeout has not been defined")}function r(){throw new Error("clearTimeout has not been defined")}function o(e){if(s===setTimeout)return setTimeout(e,0);if((s===n||!s)&&setTimeout)return s=setTimeout,setTimeout(e,0);try{return s(e,0)}catch(t){try{return s.call(null,e,0)}catch(t){return s.call(this,e,0)}}}function c(e){if(f===clearTimeout)return clearTimeout(e);if((f===r||!f)&&clearTimeout)return f=clearTimeout,clearTimeout(e);try{return f(e)}catch(t){try{return f.call(null,e)}catch(t){return f.call(this,e)}}}function u(){h&&y&&(h=!1,y.length?d=y.concat(d):v=-1,d.length&&i())}function i(){if(!h){var e=o(u);h=!0;for(var t=d.length;t;){for(y=d,d=[];++v<t;)y&&y[v].run();v=-1,t=d.length}y=null,h=!1,c(e)}}function a(e,t){this.fun=e,this.array=t}function l(){}var s,f,p=e.exports={};!function(){try{s="function"==typeof setTimeout?setTimeout:n}catch(e){s=n}try{f="function"==typeof clearTimeout?clearTimeout:r}catch(e){f=r}}();var y,d=[],h=!1,v=-1;p.nextTick=function(e){var t=new Array(arguments.length-1);if(arguments.length>1)for(var n=1;n<arguments.length;n++)t[n-1]=arguments[n];d.push(new a(e,t)),1!==d.length||h||o(i)},a.prototype.run=function(){this.fun.apply(null,this.array)},p.title="browser",p.browser=!0,p.env={},p.argv=[],p.version="",p.versions={},p.on=l,p.addListener=l,p.once=l,p.off=l,p.removeListener=l,p.removeAllListeners=l,p.emit=l,p.prependListener=l,p.prependOnceListener=l,p.listeners=function(e){return[]},p.binding=function(e){throw new Error("process.binding is not supported")},p.cwd=function(){return"/"},p.chdir=function(e){throw new Error("process.chdir is not supported")},p.umask=function(){return 0}},function(e,t){Element.prototype.matches||(Element.prototype.matches=Element.prototype.matchesSelector||Element.prototype.msMatchesSelector||Element.prototype.webkitMatchesSelector)},function(e,t){!function(){if("undefined"!=typeof window)try{var e=new window.CustomEvent("test",{cancelable:!0});if(e.preventDefault(),!0!==e.defaultPrevented)throw new Error("Could not prevent default")}catch(e){var t=function(e,t){var n,r;return t=t||{},t.bubbles=!!t.bubbles,t.cancelable=!!t.cancelable,n=document.createEvent("CustomEvent"),n.initCustomEvent(e,t.bubbles,t.cancelable,t.detail),r=n.preventDefault,n.preventDefault=function(){r.call(this);try{Object.defineProperty(this,"defaultPrevented",{get:function(){return!0}})}catch(e){this.defaultPrevented=!0}},n};t.prototype=window.Event.prototype,window.CustomEvent=t}}()}])});
//# sourceMappingURL=index.js.map

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

(function (global, factory) {
   true ? factory(__webpack_require__(109)) :
  typeof define === 'function' && define.amd ? define(['hammerjs'], factory) :
  (factory(global.Hammer));
}(this, (function (Hammer) { 'use strict';

Hammer = 'default' in Hammer ? Hammer['default'] : Hammer;

function assign(target) {
  var sources = [], len = arguments.length - 1;
  while ( len-- > 0 ) sources[ len ] = arguments[ len + 1 ];
  for (var i = 0; i < sources.length; i++) {
    var source = sources[i];
    var keys = Object.keys(source);
    for (var i$1 = 0; i$1 < keys.length; i$1++) {
      var key = keys[i$1];
      target[key] = source[key];
    }
  }
  return target
}
function createProp() {
  return {
    type: Object,
    default: function() { return {} }
  }
}
function capitalize (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
}
var directions = ['up', 'down', 'left', 'right', 'horizontal', 'vertical', 'all'];
function guardDirections (options) {
  var dir = options.direction;
  if (typeof dir === 'string') {
    var hammerDirection = 'DIRECTION_' + dir.toUpperCase();
    if (directions.indexOf(dir) > -1 && Hammer.hasOwnProperty(hammerDirection)) {
      options.direction = Hammer[hammerDirection];
    } else {
      console.warn('[vue-touch] invalid direction: ' + dir);
    }
  }
  return options
}
var config = {
};
var customEvents = {
};
var gestures = [
  'pan','panstart','panmove','panend','pancancel','panleft','panright','panup','pandown',
  'pinch','pinchstart','pinchmove','pinchend','pinchcancel','pinchin','pinchout',
  'press','pressup',
  'rotate','rotatestart','rotatemove','rotateend','rotatecancel',
  'swipe','swipeleft','swiperight','swipeup','swipedown',
  'tap'
];
var gestureMap = {
  pan: 'pan',
  panstart: 'pan',
  panmove: 'pan',
  panend: 'pan',
  pancancel: 'pan',
  panleft: 'pan',
  panright: 'pan',
  panup: 'pan',
  pandown: 'pan',
  pinch: 'pinch',
  pinchstart: 'pinch',
  pinchmove: 'pinch',
  pinchend: 'pinch',
  pinchcancel: 'pinch',
  pinchin: 'pinch',
  pinchout: 'pinch',
  press: 'press',
  pressup: 'press',
  rotate: 'rotate',
  rotatestart: 'rotate',
  rotatemove: 'rotate',
  rotateend: 'rotate',
  rotatecancel: 'rotate',
  swipe: 'swipe',
  swipeleft: 'swipe',
  swiperight: 'swipe',
  swipeup: 'swipe',
  swipedown: 'swipe',
  tap: 'tap'
};

var Component = {
  props: {
    options: createProp(),
    tapOptions: createProp(),
    panOptions: createProp(),
    pinchOptions: createProp(),
    pressOptions: createProp(),
    rotateOptions: createProp(),
    swipeOptions: createProp(),
    tag: { type: String, default: 'div' },
    enabled: {
      default: true,
      type: [Boolean, Object],
    }
  },
  mounted: function mounted() {
    if (!this.$isServer) {
      this.hammer = new Hammer.Manager(this.$el, this.options);
      this.recognizers = {};
      this.setupBuiltinRecognizers();
      this.setupCustomRecognizers();
      this.updateEnabled(this.enabled);
    }
  },
  destroyed: function destroyed() {
    if (!this.$isServer) {
      this.hammer.destroy();
    }
  },
  watch: {
    enabled: {
      deep: true,
      handler: function handler() {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];
        (ref = this).updateEnabled.apply(ref, args);
        var ref;
      }
    }
  },
  methods: {
    setupBuiltinRecognizers: function setupBuiltinRecognizers()  {
      var this$1 = this;
      for (var i = 0; i < gestures.length; i++) {
        var gesture = gestures[i];
        if (this$1._events[gesture]) {
          var mainGesture = gestureMap[gesture];
          var options = assign({}, (config[mainGesture] || {}), this$1[(mainGesture + "Options")]);
          this$1.addRecognizer(mainGesture, options);
          this$1.addEvent(gesture);
        }
      }
    },
    setupCustomRecognizers: function setupCustomRecognizers() {
      var this$1 = this;
      var gestures$$1 = Object.keys(customEvents);
      for (var i = 0; i < gestures$$1.length; i++) {
        var gesture = gestures$$1[i];
        if (this$1._events[gesture]) {
          var opts = customEvents[gesture];
          var localCustomOpts = this$1[(gesture + "Options")] || {};
          var options = assign({}, opts, localCustomOpts);
          this$1.addRecognizer(gesture, options, {mainGesture: options.type});
          this$1.addEvent(gesture);
        }
      }
    },
    addRecognizer: function addRecognizer(gesture, options, ref) {
      if ( ref === void 0 ) ref = {};
      var mainGesture = ref.mainGesture;
      if (!this.recognizers[gesture]) {
        var recognizer = new Hammer[capitalize(mainGesture || gesture)](guardDirections(options));
        this.recognizers[gesture] = recognizer;
        this.hammer.add(recognizer);
        recognizer.recognizeWith(this.hammer.recognizers);
      }
    },
    addEvent: function addEvent(gesture) {
      var this$1 = this;
      this.hammer.on(gesture, function (e) { return this$1.$emit(gesture, e); });
    },
    updateEnabled: function updateEnabled(newVal, oldVal) {
      var this$1 = this;
      if (newVal === true) {
        this.enableAll();
      } else if (newVal === false) {
        this.disableAll();
      } else if (typeof newVal === 'object') {
        var keys = Object.keys(newVal);
        for (var i = 0; i < keys.length; i++) {
          var event = keys[i];
          if (this$1.recognizers[event]) {
            newVal[event]
              ? this$1.enable(event)
              : this$1.disable(event);
          }
        }
      }
    },
    enable: function enable(r) {
      var recognizer = this.recognizers[r];
      if (!recognizer.options.enable) {
        recognizer.set({ enable: true });
      }
    },
    disable: function disable(r) {
      var recognizer = this.recognizers[r];
      if (recognizer.options.enable) {
        recognizer.set({ enable: false });
      }
    },
    toggle: function toggle(r) {
      var recognizer = this.recognizers[r];
      if (recognizer) {
        recognizer.options.enable
          ? this.disable(r)
          : this.enable(r);
      }
    },
    enableAll: function enableAll(r) {
      this.toggleAll({ enable: true });
    },
    disableAll: function disableAll(r) {
      this.toggleAll({ enable: false });
    },
    toggleAll: function toggleAll(ref) {
      var this$1 = this;
      var enable = ref.enable;
      var keys = Object.keys(this.recognizers);
      for (var i = 0; i < keys.length; i++) {
        var r = this$1.recognizers[keys[i]];
        if (r.options.enable !== enable) {
          r.set({ enable: enable });
        }
      }
    },
    isEnabled: function isEnabled(r) {
      return this.recognizers[r] && this.recognizers[r].options.enable
    }
  },
  render: function render(h) {
    return h(this.tag, {}, this.$slots.default)
  }
};

var installed = false;
var vueTouch = { config: config, customEvents: customEvents };
vueTouch.install = function install(Vue, opts) {
  if ( opts === void 0 ) opts = {};
  var name = opts.name || 'v-touch';
  Vue.component(name, assign(Component, { name: name }));
  installed = true;
}.bind(vueTouch);
vueTouch.registerCustomEvent = function registerCustomEvent(event, options) {
  if ( options === void 0 ) options = {};
  if (installed) {
    console.warn(("\n      [vue-touch]: Custom Event '" + event + "' couldn't be added to vue-touch.\n      Custom Events have to be registered before installing the plugin.\n      "));
    return
  }
  options.event = event;
  customEvents[event] = options;
  Component.props[(event + "Options")] = {
    type: Object,
    default: function default$1() { return {} }
  };
}.bind(vueTouch);
vueTouch.component = Component;
if (true) {
  module.exports = vueTouch;
} else if (typeof define == "function" && define.amd) {
  define([], function(){ return vueTouch });
} else if (typeof window !== 'undefined' && window.Vue) {
  window.VueTouch = vueTouch;
  Vue.use(vueTouch);
}

})));
//# sourceMappingURL=vue-touch.js.map


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*! Hammer.JS - v2.0.7 - 2016-04-22
 * http://hammerjs.github.io/
 *
 * Copyright (c) 2016 Jorik Tangelder;
 * Licensed under the MIT license */
(function(window, document, exportName, undefined) {
  'use strict';

var VENDOR_PREFIXES = ['', 'webkit', 'Moz', 'MS', 'ms', 'o'];
var TEST_ELEMENT = document.createElement('div');

var TYPE_FUNCTION = 'function';

var round = Math.round;
var abs = Math.abs;
var now = Date.now;

/**
 * set a timeout with a given scope
 * @param {Function} fn
 * @param {Number} timeout
 * @param {Object} context
 * @returns {number}
 */
function setTimeoutContext(fn, timeout, context) {
    return setTimeout(bindFn(fn, context), timeout);
}

/**
 * if the argument is an array, we want to execute the fn on each entry
 * if it aint an array we don't want to do a thing.
 * this is used by all the methods that accept a single and array argument.
 * @param {*|Array} arg
 * @param {String} fn
 * @param {Object} [context]
 * @returns {Boolean}
 */
function invokeArrayArg(arg, fn, context) {
    if (Array.isArray(arg)) {
        each(arg, context[fn], context);
        return true;
    }
    return false;
}

/**
 * walk objects and arrays
 * @param {Object} obj
 * @param {Function} iterator
 * @param {Object} context
 */
function each(obj, iterator, context) {
    var i;

    if (!obj) {
        return;
    }

    if (obj.forEach) {
        obj.forEach(iterator, context);
    } else if (obj.length !== undefined) {
        i = 0;
        while (i < obj.length) {
            iterator.call(context, obj[i], i, obj);
            i++;
        }
    } else {
        for (i in obj) {
            obj.hasOwnProperty(i) && iterator.call(context, obj[i], i, obj);
        }
    }
}

/**
 * wrap a method with a deprecation warning and stack trace
 * @param {Function} method
 * @param {String} name
 * @param {String} message
 * @returns {Function} A new function wrapping the supplied method.
 */
function deprecate(method, name, message) {
    var deprecationMessage = 'DEPRECATED METHOD: ' + name + '\n' + message + ' AT \n';
    return function() {
        var e = new Error('get-stack-trace');
        var stack = e && e.stack ? e.stack.replace(/^[^\(]+?[\n$]/gm, '')
            .replace(/^\s+at\s+/gm, '')
            .replace(/^Object.<anonymous>\s*\(/gm, '{anonymous}()@') : 'Unknown Stack Trace';

        var log = window.console && (window.console.warn || window.console.log);
        if (log) {
            log.call(window.console, deprecationMessage, stack);
        }
        return method.apply(this, arguments);
    };
}

/**
 * extend object.
 * means that properties in dest will be overwritten by the ones in src.
 * @param {Object} target
 * @param {...Object} objects_to_assign
 * @returns {Object} target
 */
var assign;
if (typeof Object.assign !== 'function') {
    assign = function assign(target) {
        if (target === undefined || target === null) {
            throw new TypeError('Cannot convert undefined or null to object');
        }

        var output = Object(target);
        for (var index = 1; index < arguments.length; index++) {
            var source = arguments[index];
            if (source !== undefined && source !== null) {
                for (var nextKey in source) {
                    if (source.hasOwnProperty(nextKey)) {
                        output[nextKey] = source[nextKey];
                    }
                }
            }
        }
        return output;
    };
} else {
    assign = Object.assign;
}

/**
 * extend object.
 * means that properties in dest will be overwritten by the ones in src.
 * @param {Object} dest
 * @param {Object} src
 * @param {Boolean} [merge=false]
 * @returns {Object} dest
 */
var extend = deprecate(function extend(dest, src, merge) {
    var keys = Object.keys(src);
    var i = 0;
    while (i < keys.length) {
        if (!merge || (merge && dest[keys[i]] === undefined)) {
            dest[keys[i]] = src[keys[i]];
        }
        i++;
    }
    return dest;
}, 'extend', 'Use `assign`.');

/**
 * merge the values from src in the dest.
 * means that properties that exist in dest will not be overwritten by src
 * @param {Object} dest
 * @param {Object} src
 * @returns {Object} dest
 */
var merge = deprecate(function merge(dest, src) {
    return extend(dest, src, true);
}, 'merge', 'Use `assign`.');

/**
 * simple class inheritance
 * @param {Function} child
 * @param {Function} base
 * @param {Object} [properties]
 */
function inherit(child, base, properties) {
    var baseP = base.prototype,
        childP;

    childP = child.prototype = Object.create(baseP);
    childP.constructor = child;
    childP._super = baseP;

    if (properties) {
        assign(childP, properties);
    }
}

/**
 * simple function bind
 * @param {Function} fn
 * @param {Object} context
 * @returns {Function}
 */
function bindFn(fn, context) {
    return function boundFn() {
        return fn.apply(context, arguments);
    };
}

/**
 * let a boolean value also be a function that must return a boolean
 * this first item in args will be used as the context
 * @param {Boolean|Function} val
 * @param {Array} [args]
 * @returns {Boolean}
 */
function boolOrFn(val, args) {
    if (typeof val == TYPE_FUNCTION) {
        return val.apply(args ? args[0] || undefined : undefined, args);
    }
    return val;
}

/**
 * use the val2 when val1 is undefined
 * @param {*} val1
 * @param {*} val2
 * @returns {*}
 */
function ifUndefined(val1, val2) {
    return (val1 === undefined) ? val2 : val1;
}

/**
 * addEventListener with multiple events at once
 * @param {EventTarget} target
 * @param {String} types
 * @param {Function} handler
 */
function addEventListeners(target, types, handler) {
    each(splitStr(types), function(type) {
        target.addEventListener(type, handler, false);
    });
}

/**
 * removeEventListener with multiple events at once
 * @param {EventTarget} target
 * @param {String} types
 * @param {Function} handler
 */
function removeEventListeners(target, types, handler) {
    each(splitStr(types), function(type) {
        target.removeEventListener(type, handler, false);
    });
}

/**
 * find if a node is in the given parent
 * @method hasParent
 * @param {HTMLElement} node
 * @param {HTMLElement} parent
 * @return {Boolean} found
 */
function hasParent(node, parent) {
    while (node) {
        if (node == parent) {
            return true;
        }
        node = node.parentNode;
    }
    return false;
}

/**
 * small indexOf wrapper
 * @param {String} str
 * @param {String} find
 * @returns {Boolean} found
 */
function inStr(str, find) {
    return str.indexOf(find) > -1;
}

/**
 * split string on whitespace
 * @param {String} str
 * @returns {Array} words
 */
function splitStr(str) {
    return str.trim().split(/\s+/g);
}

/**
 * find if a array contains the object using indexOf or a simple polyFill
 * @param {Array} src
 * @param {String} find
 * @param {String} [findByKey]
 * @return {Boolean|Number} false when not found, or the index
 */
function inArray(src, find, findByKey) {
    if (src.indexOf && !findByKey) {
        return src.indexOf(find);
    } else {
        var i = 0;
        while (i < src.length) {
            if ((findByKey && src[i][findByKey] == find) || (!findByKey && src[i] === find)) {
                return i;
            }
            i++;
        }
        return -1;
    }
}

/**
 * convert array-like objects to real arrays
 * @param {Object} obj
 * @returns {Array}
 */
function toArray(obj) {
    return Array.prototype.slice.call(obj, 0);
}

/**
 * unique array with objects based on a key (like 'id') or just by the array's value
 * @param {Array} src [{id:1},{id:2},{id:1}]
 * @param {String} [key]
 * @param {Boolean} [sort=False]
 * @returns {Array} [{id:1},{id:2}]
 */
function uniqueArray(src, key, sort) {
    var results = [];
    var values = [];
    var i = 0;

    while (i < src.length) {
        var val = key ? src[i][key] : src[i];
        if (inArray(values, val) < 0) {
            results.push(src[i]);
        }
        values[i] = val;
        i++;
    }

    if (sort) {
        if (!key) {
            results = results.sort();
        } else {
            results = results.sort(function sortUniqueArray(a, b) {
                return a[key] > b[key];
            });
        }
    }

    return results;
}

/**
 * get the prefixed property
 * @param {Object} obj
 * @param {String} property
 * @returns {String|Undefined} prefixed
 */
function prefixed(obj, property) {
    var prefix, prop;
    var camelProp = property[0].toUpperCase() + property.slice(1);

    var i = 0;
    while (i < VENDOR_PREFIXES.length) {
        prefix = VENDOR_PREFIXES[i];
        prop = (prefix) ? prefix + camelProp : property;

        if (prop in obj) {
            return prop;
        }
        i++;
    }
    return undefined;
}

/**
 * get a unique id
 * @returns {number} uniqueId
 */
var _uniqueId = 1;
function uniqueId() {
    return _uniqueId++;
}

/**
 * get the window object of an element
 * @param {HTMLElement} element
 * @returns {DocumentView|Window}
 */
function getWindowForElement(element) {
    var doc = element.ownerDocument || element;
    return (doc.defaultView || doc.parentWindow || window);
}

var MOBILE_REGEX = /mobile|tablet|ip(ad|hone|od)|android/i;

var SUPPORT_TOUCH = ('ontouchstart' in window);
var SUPPORT_POINTER_EVENTS = prefixed(window, 'PointerEvent') !== undefined;
var SUPPORT_ONLY_TOUCH = SUPPORT_TOUCH && MOBILE_REGEX.test(navigator.userAgent);

var INPUT_TYPE_TOUCH = 'touch';
var INPUT_TYPE_PEN = 'pen';
var INPUT_TYPE_MOUSE = 'mouse';
var INPUT_TYPE_KINECT = 'kinect';

var COMPUTE_INTERVAL = 25;

var INPUT_START = 1;
var INPUT_MOVE = 2;
var INPUT_END = 4;
var INPUT_CANCEL = 8;

var DIRECTION_NONE = 1;
var DIRECTION_LEFT = 2;
var DIRECTION_RIGHT = 4;
var DIRECTION_UP = 8;
var DIRECTION_DOWN = 16;

var DIRECTION_HORIZONTAL = DIRECTION_LEFT | DIRECTION_RIGHT;
var DIRECTION_VERTICAL = DIRECTION_UP | DIRECTION_DOWN;
var DIRECTION_ALL = DIRECTION_HORIZONTAL | DIRECTION_VERTICAL;

var PROPS_XY = ['x', 'y'];
var PROPS_CLIENT_XY = ['clientX', 'clientY'];

/**
 * create new input type manager
 * @param {Manager} manager
 * @param {Function} callback
 * @returns {Input}
 * @constructor
 */
function Input(manager, callback) {
    var self = this;
    this.manager = manager;
    this.callback = callback;
    this.element = manager.element;
    this.target = manager.options.inputTarget;

    // smaller wrapper around the handler, for the scope and the enabled state of the manager,
    // so when disabled the input events are completely bypassed.
    this.domHandler = function(ev) {
        if (boolOrFn(manager.options.enable, [manager])) {
            self.handler(ev);
        }
    };

    this.init();

}

Input.prototype = {
    /**
     * should handle the inputEvent data and trigger the callback
     * @virtual
     */
    handler: function() { },

    /**
     * bind the events
     */
    init: function() {
        this.evEl && addEventListeners(this.element, this.evEl, this.domHandler);
        this.evTarget && addEventListeners(this.target, this.evTarget, this.domHandler);
        this.evWin && addEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
    },

    /**
     * unbind the events
     */
    destroy: function() {
        this.evEl && removeEventListeners(this.element, this.evEl, this.domHandler);
        this.evTarget && removeEventListeners(this.target, this.evTarget, this.domHandler);
        this.evWin && removeEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
    }
};

/**
 * create new input type manager
 * called by the Manager constructor
 * @param {Hammer} manager
 * @returns {Input}
 */
function createInputInstance(manager) {
    var Type;
    var inputClass = manager.options.inputClass;

    if (inputClass) {
        Type = inputClass;
    } else if (SUPPORT_POINTER_EVENTS) {
        Type = PointerEventInput;
    } else if (SUPPORT_ONLY_TOUCH) {
        Type = TouchInput;
    } else if (!SUPPORT_TOUCH) {
        Type = MouseInput;
    } else {
        Type = TouchMouseInput;
    }
    return new (Type)(manager, inputHandler);
}

/**
 * handle input events
 * @param {Manager} manager
 * @param {String} eventType
 * @param {Object} input
 */
function inputHandler(manager, eventType, input) {
    var pointersLen = input.pointers.length;
    var changedPointersLen = input.changedPointers.length;
    var isFirst = (eventType & INPUT_START && (pointersLen - changedPointersLen === 0));
    var isFinal = (eventType & (INPUT_END | INPUT_CANCEL) && (pointersLen - changedPointersLen === 0));

    input.isFirst = !!isFirst;
    input.isFinal = !!isFinal;

    if (isFirst) {
        manager.session = {};
    }

    // source event is the normalized value of the domEvents
    // like 'touchstart, mouseup, pointerdown'
    input.eventType = eventType;

    // compute scale, rotation etc
    computeInputData(manager, input);

    // emit secret event
    manager.emit('hammer.input', input);

    manager.recognize(input);
    manager.session.prevInput = input;
}

/**
 * extend the data with some usable properties like scale, rotate, velocity etc
 * @param {Object} manager
 * @param {Object} input
 */
function computeInputData(manager, input) {
    var session = manager.session;
    var pointers = input.pointers;
    var pointersLength = pointers.length;

    // store the first input to calculate the distance and direction
    if (!session.firstInput) {
        session.firstInput = simpleCloneInputData(input);
    }

    // to compute scale and rotation we need to store the multiple touches
    if (pointersLength > 1 && !session.firstMultiple) {
        session.firstMultiple = simpleCloneInputData(input);
    } else if (pointersLength === 1) {
        session.firstMultiple = false;
    }

    var firstInput = session.firstInput;
    var firstMultiple = session.firstMultiple;
    var offsetCenter = firstMultiple ? firstMultiple.center : firstInput.center;

    var center = input.center = getCenter(pointers);
    input.timeStamp = now();
    input.deltaTime = input.timeStamp - firstInput.timeStamp;

    input.angle = getAngle(offsetCenter, center);
    input.distance = getDistance(offsetCenter, center);

    computeDeltaXY(session, input);
    input.offsetDirection = getDirection(input.deltaX, input.deltaY);

    var overallVelocity = getVelocity(input.deltaTime, input.deltaX, input.deltaY);
    input.overallVelocityX = overallVelocity.x;
    input.overallVelocityY = overallVelocity.y;
    input.overallVelocity = (abs(overallVelocity.x) > abs(overallVelocity.y)) ? overallVelocity.x : overallVelocity.y;

    input.scale = firstMultiple ? getScale(firstMultiple.pointers, pointers) : 1;
    input.rotation = firstMultiple ? getRotation(firstMultiple.pointers, pointers) : 0;

    input.maxPointers = !session.prevInput ? input.pointers.length : ((input.pointers.length >
        session.prevInput.maxPointers) ? input.pointers.length : session.prevInput.maxPointers);

    computeIntervalInputData(session, input);

    // find the correct target
    var target = manager.element;
    if (hasParent(input.srcEvent.target, target)) {
        target = input.srcEvent.target;
    }
    input.target = target;
}

function computeDeltaXY(session, input) {
    var center = input.center;
    var offset = session.offsetDelta || {};
    var prevDelta = session.prevDelta || {};
    var prevInput = session.prevInput || {};

    if (input.eventType === INPUT_START || prevInput.eventType === INPUT_END) {
        prevDelta = session.prevDelta = {
            x: prevInput.deltaX || 0,
            y: prevInput.deltaY || 0
        };

        offset = session.offsetDelta = {
            x: center.x,
            y: center.y
        };
    }

    input.deltaX = prevDelta.x + (center.x - offset.x);
    input.deltaY = prevDelta.y + (center.y - offset.y);
}

/**
 * velocity is calculated every x ms
 * @param {Object} session
 * @param {Object} input
 */
function computeIntervalInputData(session, input) {
    var last = session.lastInterval || input,
        deltaTime = input.timeStamp - last.timeStamp,
        velocity, velocityX, velocityY, direction;

    if (input.eventType != INPUT_CANCEL && (deltaTime > COMPUTE_INTERVAL || last.velocity === undefined)) {
        var deltaX = input.deltaX - last.deltaX;
        var deltaY = input.deltaY - last.deltaY;

        var v = getVelocity(deltaTime, deltaX, deltaY);
        velocityX = v.x;
        velocityY = v.y;
        velocity = (abs(v.x) > abs(v.y)) ? v.x : v.y;
        direction = getDirection(deltaX, deltaY);

        session.lastInterval = input;
    } else {
        // use latest velocity info if it doesn't overtake a minimum period
        velocity = last.velocity;
        velocityX = last.velocityX;
        velocityY = last.velocityY;
        direction = last.direction;
    }

    input.velocity = velocity;
    input.velocityX = velocityX;
    input.velocityY = velocityY;
    input.direction = direction;
}

/**
 * create a simple clone from the input used for storage of firstInput and firstMultiple
 * @param {Object} input
 * @returns {Object} clonedInputData
 */
function simpleCloneInputData(input) {
    // make a simple copy of the pointers because we will get a reference if we don't
    // we only need clientXY for the calculations
    var pointers = [];
    var i = 0;
    while (i < input.pointers.length) {
        pointers[i] = {
            clientX: round(input.pointers[i].clientX),
            clientY: round(input.pointers[i].clientY)
        };
        i++;
    }

    return {
        timeStamp: now(),
        pointers: pointers,
        center: getCenter(pointers),
        deltaX: input.deltaX,
        deltaY: input.deltaY
    };
}

/**
 * get the center of all the pointers
 * @param {Array} pointers
 * @return {Object} center contains `x` and `y` properties
 */
function getCenter(pointers) {
    var pointersLength = pointers.length;

    // no need to loop when only one touch
    if (pointersLength === 1) {
        return {
            x: round(pointers[0].clientX),
            y: round(pointers[0].clientY)
        };
    }

    var x = 0, y = 0, i = 0;
    while (i < pointersLength) {
        x += pointers[i].clientX;
        y += pointers[i].clientY;
        i++;
    }

    return {
        x: round(x / pointersLength),
        y: round(y / pointersLength)
    };
}

/**
 * calculate the velocity between two points. unit is in px per ms.
 * @param {Number} deltaTime
 * @param {Number} x
 * @param {Number} y
 * @return {Object} velocity `x` and `y`
 */
function getVelocity(deltaTime, x, y) {
    return {
        x: x / deltaTime || 0,
        y: y / deltaTime || 0
    };
}

/**
 * get the direction between two points
 * @param {Number} x
 * @param {Number} y
 * @return {Number} direction
 */
function getDirection(x, y) {
    if (x === y) {
        return DIRECTION_NONE;
    }

    if (abs(x) >= abs(y)) {
        return x < 0 ? DIRECTION_LEFT : DIRECTION_RIGHT;
    }
    return y < 0 ? DIRECTION_UP : DIRECTION_DOWN;
}

/**
 * calculate the absolute distance between two points
 * @param {Object} p1 {x, y}
 * @param {Object} p2 {x, y}
 * @param {Array} [props] containing x and y keys
 * @return {Number} distance
 */
function getDistance(p1, p2, props) {
    if (!props) {
        props = PROPS_XY;
    }
    var x = p2[props[0]] - p1[props[0]],
        y = p2[props[1]] - p1[props[1]];

    return Math.sqrt((x * x) + (y * y));
}

/**
 * calculate the angle between two coordinates
 * @param {Object} p1
 * @param {Object} p2
 * @param {Array} [props] containing x and y keys
 * @return {Number} angle
 */
function getAngle(p1, p2, props) {
    if (!props) {
        props = PROPS_XY;
    }
    var x = p2[props[0]] - p1[props[0]],
        y = p2[props[1]] - p1[props[1]];
    return Math.atan2(y, x) * 180 / Math.PI;
}

/**
 * calculate the rotation degrees between two pointersets
 * @param {Array} start array of pointers
 * @param {Array} end array of pointers
 * @return {Number} rotation
 */
function getRotation(start, end) {
    return getAngle(end[1], end[0], PROPS_CLIENT_XY) + getAngle(start[1], start[0], PROPS_CLIENT_XY);
}

/**
 * calculate the scale factor between two pointersets
 * no scale is 1, and goes down to 0 when pinched together, and bigger when pinched out
 * @param {Array} start array of pointers
 * @param {Array} end array of pointers
 * @return {Number} scale
 */
function getScale(start, end) {
    return getDistance(end[0], end[1], PROPS_CLIENT_XY) / getDistance(start[0], start[1], PROPS_CLIENT_XY);
}

var MOUSE_INPUT_MAP = {
    mousedown: INPUT_START,
    mousemove: INPUT_MOVE,
    mouseup: INPUT_END
};

var MOUSE_ELEMENT_EVENTS = 'mousedown';
var MOUSE_WINDOW_EVENTS = 'mousemove mouseup';

/**
 * Mouse events input
 * @constructor
 * @extends Input
 */
function MouseInput() {
    this.evEl = MOUSE_ELEMENT_EVENTS;
    this.evWin = MOUSE_WINDOW_EVENTS;

    this.pressed = false; // mousedown state

    Input.apply(this, arguments);
}

inherit(MouseInput, Input, {
    /**
     * handle mouse events
     * @param {Object} ev
     */
    handler: function MEhandler(ev) {
        var eventType = MOUSE_INPUT_MAP[ev.type];

        // on start we want to have the left mouse button down
        if (eventType & INPUT_START && ev.button === 0) {
            this.pressed = true;
        }

        if (eventType & INPUT_MOVE && ev.which !== 1) {
            eventType = INPUT_END;
        }

        // mouse must be down
        if (!this.pressed) {
            return;
        }

        if (eventType & INPUT_END) {
            this.pressed = false;
        }

        this.callback(this.manager, eventType, {
            pointers: [ev],
            changedPointers: [ev],
            pointerType: INPUT_TYPE_MOUSE,
            srcEvent: ev
        });
    }
});

var POINTER_INPUT_MAP = {
    pointerdown: INPUT_START,
    pointermove: INPUT_MOVE,
    pointerup: INPUT_END,
    pointercancel: INPUT_CANCEL,
    pointerout: INPUT_CANCEL
};

// in IE10 the pointer types is defined as an enum
var IE10_POINTER_TYPE_ENUM = {
    2: INPUT_TYPE_TOUCH,
    3: INPUT_TYPE_PEN,
    4: INPUT_TYPE_MOUSE,
    5: INPUT_TYPE_KINECT // see https://twitter.com/jacobrossi/status/480596438489890816
};

var POINTER_ELEMENT_EVENTS = 'pointerdown';
var POINTER_WINDOW_EVENTS = 'pointermove pointerup pointercancel';

// IE10 has prefixed support, and case-sensitive
if (window.MSPointerEvent && !window.PointerEvent) {
    POINTER_ELEMENT_EVENTS = 'MSPointerDown';
    POINTER_WINDOW_EVENTS = 'MSPointerMove MSPointerUp MSPointerCancel';
}

/**
 * Pointer events input
 * @constructor
 * @extends Input
 */
function PointerEventInput() {
    this.evEl = POINTER_ELEMENT_EVENTS;
    this.evWin = POINTER_WINDOW_EVENTS;

    Input.apply(this, arguments);

    this.store = (this.manager.session.pointerEvents = []);
}

inherit(PointerEventInput, Input, {
    /**
     * handle mouse events
     * @param {Object} ev
     */
    handler: function PEhandler(ev) {
        var store = this.store;
        var removePointer = false;

        var eventTypeNormalized = ev.type.toLowerCase().replace('ms', '');
        var eventType = POINTER_INPUT_MAP[eventTypeNormalized];
        var pointerType = IE10_POINTER_TYPE_ENUM[ev.pointerType] || ev.pointerType;

        var isTouch = (pointerType == INPUT_TYPE_TOUCH);

        // get index of the event in the store
        var storeIndex = inArray(store, ev.pointerId, 'pointerId');

        // start and mouse must be down
        if (eventType & INPUT_START && (ev.button === 0 || isTouch)) {
            if (storeIndex < 0) {
                store.push(ev);
                storeIndex = store.length - 1;
            }
        } else if (eventType & (INPUT_END | INPUT_CANCEL)) {
            removePointer = true;
        }

        // it not found, so the pointer hasn't been down (so it's probably a hover)
        if (storeIndex < 0) {
            return;
        }

        // update the event in the store
        store[storeIndex] = ev;

        this.callback(this.manager, eventType, {
            pointers: store,
            changedPointers: [ev],
            pointerType: pointerType,
            srcEvent: ev
        });

        if (removePointer) {
            // remove from the store
            store.splice(storeIndex, 1);
        }
    }
});

var SINGLE_TOUCH_INPUT_MAP = {
    touchstart: INPUT_START,
    touchmove: INPUT_MOVE,
    touchend: INPUT_END,
    touchcancel: INPUT_CANCEL
};

var SINGLE_TOUCH_TARGET_EVENTS = 'touchstart';
var SINGLE_TOUCH_WINDOW_EVENTS = 'touchstart touchmove touchend touchcancel';

/**
 * Touch events input
 * @constructor
 * @extends Input
 */
function SingleTouchInput() {
    this.evTarget = SINGLE_TOUCH_TARGET_EVENTS;
    this.evWin = SINGLE_TOUCH_WINDOW_EVENTS;
    this.started = false;

    Input.apply(this, arguments);
}

inherit(SingleTouchInput, Input, {
    handler: function TEhandler(ev) {
        var type = SINGLE_TOUCH_INPUT_MAP[ev.type];

        // should we handle the touch events?
        if (type === INPUT_START) {
            this.started = true;
        }

        if (!this.started) {
            return;
        }

        var touches = normalizeSingleTouches.call(this, ev, type);

        // when done, reset the started state
        if (type & (INPUT_END | INPUT_CANCEL) && touches[0].length - touches[1].length === 0) {
            this.started = false;
        }

        this.callback(this.manager, type, {
            pointers: touches[0],
            changedPointers: touches[1],
            pointerType: INPUT_TYPE_TOUCH,
            srcEvent: ev
        });
    }
});

/**
 * @this {TouchInput}
 * @param {Object} ev
 * @param {Number} type flag
 * @returns {undefined|Array} [all, changed]
 */
function normalizeSingleTouches(ev, type) {
    var all = toArray(ev.touches);
    var changed = toArray(ev.changedTouches);

    if (type & (INPUT_END | INPUT_CANCEL)) {
        all = uniqueArray(all.concat(changed), 'identifier', true);
    }

    return [all, changed];
}

var TOUCH_INPUT_MAP = {
    touchstart: INPUT_START,
    touchmove: INPUT_MOVE,
    touchend: INPUT_END,
    touchcancel: INPUT_CANCEL
};

var TOUCH_TARGET_EVENTS = 'touchstart touchmove touchend touchcancel';

/**
 * Multi-user touch events input
 * @constructor
 * @extends Input
 */
function TouchInput() {
    this.evTarget = TOUCH_TARGET_EVENTS;
    this.targetIds = {};

    Input.apply(this, arguments);
}

inherit(TouchInput, Input, {
    handler: function MTEhandler(ev) {
        var type = TOUCH_INPUT_MAP[ev.type];
        var touches = getTouches.call(this, ev, type);
        if (!touches) {
            return;
        }

        this.callback(this.manager, type, {
            pointers: touches[0],
            changedPointers: touches[1],
            pointerType: INPUT_TYPE_TOUCH,
            srcEvent: ev
        });
    }
});

/**
 * @this {TouchInput}
 * @param {Object} ev
 * @param {Number} type flag
 * @returns {undefined|Array} [all, changed]
 */
function getTouches(ev, type) {
    var allTouches = toArray(ev.touches);
    var targetIds = this.targetIds;

    // when there is only one touch, the process can be simplified
    if (type & (INPUT_START | INPUT_MOVE) && allTouches.length === 1) {
        targetIds[allTouches[0].identifier] = true;
        return [allTouches, allTouches];
    }

    var i,
        targetTouches,
        changedTouches = toArray(ev.changedTouches),
        changedTargetTouches = [],
        target = this.target;

    // get target touches from touches
    targetTouches = allTouches.filter(function(touch) {
        return hasParent(touch.target, target);
    });

    // collect touches
    if (type === INPUT_START) {
        i = 0;
        while (i < targetTouches.length) {
            targetIds[targetTouches[i].identifier] = true;
            i++;
        }
    }

    // filter changed touches to only contain touches that exist in the collected target ids
    i = 0;
    while (i < changedTouches.length) {
        if (targetIds[changedTouches[i].identifier]) {
            changedTargetTouches.push(changedTouches[i]);
        }

        // cleanup removed touches
        if (type & (INPUT_END | INPUT_CANCEL)) {
            delete targetIds[changedTouches[i].identifier];
        }
        i++;
    }

    if (!changedTargetTouches.length) {
        return;
    }

    return [
        // merge targetTouches with changedTargetTouches so it contains ALL touches, including 'end' and 'cancel'
        uniqueArray(targetTouches.concat(changedTargetTouches), 'identifier', true),
        changedTargetTouches
    ];
}

/**
 * Combined touch and mouse input
 *
 * Touch has a higher priority then mouse, and while touching no mouse events are allowed.
 * This because touch devices also emit mouse events while doing a touch.
 *
 * @constructor
 * @extends Input
 */

var DEDUP_TIMEOUT = 2500;
var DEDUP_DISTANCE = 25;

function TouchMouseInput() {
    Input.apply(this, arguments);

    var handler = bindFn(this.handler, this);
    this.touch = new TouchInput(this.manager, handler);
    this.mouse = new MouseInput(this.manager, handler);

    this.primaryTouch = null;
    this.lastTouches = [];
}

inherit(TouchMouseInput, Input, {
    /**
     * handle mouse and touch events
     * @param {Hammer} manager
     * @param {String} inputEvent
     * @param {Object} inputData
     */
    handler: function TMEhandler(manager, inputEvent, inputData) {
        var isTouch = (inputData.pointerType == INPUT_TYPE_TOUCH),
            isMouse = (inputData.pointerType == INPUT_TYPE_MOUSE);

        if (isMouse && inputData.sourceCapabilities && inputData.sourceCapabilities.firesTouchEvents) {
            return;
        }

        // when we're in a touch event, record touches to  de-dupe synthetic mouse event
        if (isTouch) {
            recordTouches.call(this, inputEvent, inputData);
        } else if (isMouse && isSyntheticEvent.call(this, inputData)) {
            return;
        }

        this.callback(manager, inputEvent, inputData);
    },

    /**
     * remove the event listeners
     */
    destroy: function destroy() {
        this.touch.destroy();
        this.mouse.destroy();
    }
});

function recordTouches(eventType, eventData) {
    if (eventType & INPUT_START) {
        this.primaryTouch = eventData.changedPointers[0].identifier;
        setLastTouch.call(this, eventData);
    } else if (eventType & (INPUT_END | INPUT_CANCEL)) {
        setLastTouch.call(this, eventData);
    }
}

function setLastTouch(eventData) {
    var touch = eventData.changedPointers[0];

    if (touch.identifier === this.primaryTouch) {
        var lastTouch = {x: touch.clientX, y: touch.clientY};
        this.lastTouches.push(lastTouch);
        var lts = this.lastTouches;
        var removeLastTouch = function() {
            var i = lts.indexOf(lastTouch);
            if (i > -1) {
                lts.splice(i, 1);
            }
        };
        setTimeout(removeLastTouch, DEDUP_TIMEOUT);
    }
}

function isSyntheticEvent(eventData) {
    var x = eventData.srcEvent.clientX, y = eventData.srcEvent.clientY;
    for (var i = 0; i < this.lastTouches.length; i++) {
        var t = this.lastTouches[i];
        var dx = Math.abs(x - t.x), dy = Math.abs(y - t.y);
        if (dx <= DEDUP_DISTANCE && dy <= DEDUP_DISTANCE) {
            return true;
        }
    }
    return false;
}

var PREFIXED_TOUCH_ACTION = prefixed(TEST_ELEMENT.style, 'touchAction');
var NATIVE_TOUCH_ACTION = PREFIXED_TOUCH_ACTION !== undefined;

// magical touchAction value
var TOUCH_ACTION_COMPUTE = 'compute';
var TOUCH_ACTION_AUTO = 'auto';
var TOUCH_ACTION_MANIPULATION = 'manipulation'; // not implemented
var TOUCH_ACTION_NONE = 'none';
var TOUCH_ACTION_PAN_X = 'pan-x';
var TOUCH_ACTION_PAN_Y = 'pan-y';
var TOUCH_ACTION_MAP = getTouchActionProps();

/**
 * Touch Action
 * sets the touchAction property or uses the js alternative
 * @param {Manager} manager
 * @param {String} value
 * @constructor
 */
function TouchAction(manager, value) {
    this.manager = manager;
    this.set(value);
}

TouchAction.prototype = {
    /**
     * set the touchAction value on the element or enable the polyfill
     * @param {String} value
     */
    set: function(value) {
        // find out the touch-action by the event handlers
        if (value == TOUCH_ACTION_COMPUTE) {
            value = this.compute();
        }

        if (NATIVE_TOUCH_ACTION && this.manager.element.style && TOUCH_ACTION_MAP[value]) {
            this.manager.element.style[PREFIXED_TOUCH_ACTION] = value;
        }
        this.actions = value.toLowerCase().trim();
    },

    /**
     * just re-set the touchAction value
     */
    update: function() {
        this.set(this.manager.options.touchAction);
    },

    /**
     * compute the value for the touchAction property based on the recognizer's settings
     * @returns {String} value
     */
    compute: function() {
        var actions = [];
        each(this.manager.recognizers, function(recognizer) {
            if (boolOrFn(recognizer.options.enable, [recognizer])) {
                actions = actions.concat(recognizer.getTouchAction());
            }
        });
        return cleanTouchActions(actions.join(' '));
    },

    /**
     * this method is called on each input cycle and provides the preventing of the browser behavior
     * @param {Object} input
     */
    preventDefaults: function(input) {
        var srcEvent = input.srcEvent;
        var direction = input.offsetDirection;

        // if the touch action did prevented once this session
        if (this.manager.session.prevented) {
            srcEvent.preventDefault();
            return;
        }

        var actions = this.actions;
        var hasNone = inStr(actions, TOUCH_ACTION_NONE) && !TOUCH_ACTION_MAP[TOUCH_ACTION_NONE];
        var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_Y];
        var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_X];

        if (hasNone) {
            //do not prevent defaults if this is a tap gesture

            var isTapPointer = input.pointers.length === 1;
            var isTapMovement = input.distance < 2;
            var isTapTouchTime = input.deltaTime < 250;

            if (isTapPointer && isTapMovement && isTapTouchTime) {
                return;
            }
        }

        if (hasPanX && hasPanY) {
            // `pan-x pan-y` means browser handles all scrolling/panning, do not prevent
            return;
        }

        if (hasNone ||
            (hasPanY && direction & DIRECTION_HORIZONTAL) ||
            (hasPanX && direction & DIRECTION_VERTICAL)) {
            return this.preventSrc(srcEvent);
        }
    },

    /**
     * call preventDefault to prevent the browser's default behavior (scrolling in most cases)
     * @param {Object} srcEvent
     */
    preventSrc: function(srcEvent) {
        this.manager.session.prevented = true;
        srcEvent.preventDefault();
    }
};

/**
 * when the touchActions are collected they are not a valid value, so we need to clean things up. *
 * @param {String} actions
 * @returns {*}
 */
function cleanTouchActions(actions) {
    // none
    if (inStr(actions, TOUCH_ACTION_NONE)) {
        return TOUCH_ACTION_NONE;
    }

    var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X);
    var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y);

    // if both pan-x and pan-y are set (different recognizers
    // for different directions, e.g. horizontal pan but vertical swipe?)
    // we need none (as otherwise with pan-x pan-y combined none of these
    // recognizers will work, since the browser would handle all panning
    if (hasPanX && hasPanY) {
        return TOUCH_ACTION_NONE;
    }

    // pan-x OR pan-y
    if (hasPanX || hasPanY) {
        return hasPanX ? TOUCH_ACTION_PAN_X : TOUCH_ACTION_PAN_Y;
    }

    // manipulation
    if (inStr(actions, TOUCH_ACTION_MANIPULATION)) {
        return TOUCH_ACTION_MANIPULATION;
    }

    return TOUCH_ACTION_AUTO;
}

function getTouchActionProps() {
    if (!NATIVE_TOUCH_ACTION) {
        return false;
    }
    var touchMap = {};
    var cssSupports = window.CSS && window.CSS.supports;
    ['auto', 'manipulation', 'pan-y', 'pan-x', 'pan-x pan-y', 'none'].forEach(function(val) {

        // If css.supports is not supported but there is native touch-action assume it supports
        // all values. This is the case for IE 10 and 11.
        touchMap[val] = cssSupports ? window.CSS.supports('touch-action', val) : true;
    });
    return touchMap;
}

/**
 * Recognizer flow explained; *
 * All recognizers have the initial state of POSSIBLE when a input session starts.
 * The definition of a input session is from the first input until the last input, with all it's movement in it. *
 * Example session for mouse-input: mousedown -> mousemove -> mouseup
 *
 * On each recognizing cycle (see Manager.recognize) the .recognize() method is executed
 * which determines with state it should be.
 *
 * If the recognizer has the state FAILED, CANCELLED or RECOGNIZED (equals ENDED), it is reset to
 * POSSIBLE to give it another change on the next cycle.
 *
 *               Possible
 *                  |
 *            +-----+---------------+
 *            |                     |
 *      +-----+-----+               |
 *      |           |               |
 *   Failed      Cancelled          |
 *                          +-------+------+
 *                          |              |
 *                      Recognized       Began
 *                                         |
 *                                      Changed
 *                                         |
 *                                  Ended/Recognized
 */
var STATE_POSSIBLE = 1;
var STATE_BEGAN = 2;
var STATE_CHANGED = 4;
var STATE_ENDED = 8;
var STATE_RECOGNIZED = STATE_ENDED;
var STATE_CANCELLED = 16;
var STATE_FAILED = 32;

/**
 * Recognizer
 * Every recognizer needs to extend from this class.
 * @constructor
 * @param {Object} options
 */
function Recognizer(options) {
    this.options = assign({}, this.defaults, options || {});

    this.id = uniqueId();

    this.manager = null;

    // default is enable true
    this.options.enable = ifUndefined(this.options.enable, true);

    this.state = STATE_POSSIBLE;

    this.simultaneous = {};
    this.requireFail = [];
}

Recognizer.prototype = {
    /**
     * @virtual
     * @type {Object}
     */
    defaults: {},

    /**
     * set options
     * @param {Object} options
     * @return {Recognizer}
     */
    set: function(options) {
        assign(this.options, options);

        // also update the touchAction, in case something changed about the directions/enabled state
        this.manager && this.manager.touchAction.update();
        return this;
    },

    /**
     * recognize simultaneous with an other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    recognizeWith: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'recognizeWith', this)) {
            return this;
        }

        var simultaneous = this.simultaneous;
        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        if (!simultaneous[otherRecognizer.id]) {
            simultaneous[otherRecognizer.id] = otherRecognizer;
            otherRecognizer.recognizeWith(this);
        }
        return this;
    },

    /**
     * drop the simultaneous link. it doesnt remove the link on the other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    dropRecognizeWith: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'dropRecognizeWith', this)) {
            return this;
        }

        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        delete this.simultaneous[otherRecognizer.id];
        return this;
    },

    /**
     * recognizer can only run when an other is failing
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    requireFailure: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'requireFailure', this)) {
            return this;
        }

        var requireFail = this.requireFail;
        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        if (inArray(requireFail, otherRecognizer) === -1) {
            requireFail.push(otherRecognizer);
            otherRecognizer.requireFailure(this);
        }
        return this;
    },

    /**
     * drop the requireFailure link. it does not remove the link on the other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    dropRequireFailure: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'dropRequireFailure', this)) {
            return this;
        }

        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        var index = inArray(this.requireFail, otherRecognizer);
        if (index > -1) {
            this.requireFail.splice(index, 1);
        }
        return this;
    },

    /**
     * has require failures boolean
     * @returns {boolean}
     */
    hasRequireFailures: function() {
        return this.requireFail.length > 0;
    },

    /**
     * if the recognizer can recognize simultaneous with an other recognizer
     * @param {Recognizer} otherRecognizer
     * @returns {Boolean}
     */
    canRecognizeWith: function(otherRecognizer) {
        return !!this.simultaneous[otherRecognizer.id];
    },

    /**
     * You should use `tryEmit` instead of `emit` directly to check
     * that all the needed recognizers has failed before emitting.
     * @param {Object} input
     */
    emit: function(input) {
        var self = this;
        var state = this.state;

        function emit(event) {
            self.manager.emit(event, input);
        }

        // 'panstart' and 'panmove'
        if (state < STATE_ENDED) {
            emit(self.options.event + stateStr(state));
        }

        emit(self.options.event); // simple 'eventName' events

        if (input.additionalEvent) { // additional event(panleft, panright, pinchin, pinchout...)
            emit(input.additionalEvent);
        }

        // panend and pancancel
        if (state >= STATE_ENDED) {
            emit(self.options.event + stateStr(state));
        }
    },

    /**
     * Check that all the require failure recognizers has failed,
     * if true, it emits a gesture event,
     * otherwise, setup the state to FAILED.
     * @param {Object} input
     */
    tryEmit: function(input) {
        if (this.canEmit()) {
            return this.emit(input);
        }
        // it's failing anyway
        this.state = STATE_FAILED;
    },

    /**
     * can we emit?
     * @returns {boolean}
     */
    canEmit: function() {
        var i = 0;
        while (i < this.requireFail.length) {
            if (!(this.requireFail[i].state & (STATE_FAILED | STATE_POSSIBLE))) {
                return false;
            }
            i++;
        }
        return true;
    },

    /**
     * update the recognizer
     * @param {Object} inputData
     */
    recognize: function(inputData) {
        // make a new copy of the inputData
        // so we can change the inputData without messing up the other recognizers
        var inputDataClone = assign({}, inputData);

        // is is enabled and allow recognizing?
        if (!boolOrFn(this.options.enable, [this, inputDataClone])) {
            this.reset();
            this.state = STATE_FAILED;
            return;
        }

        // reset when we've reached the end
        if (this.state & (STATE_RECOGNIZED | STATE_CANCELLED | STATE_FAILED)) {
            this.state = STATE_POSSIBLE;
        }

        this.state = this.process(inputDataClone);

        // the recognizer has recognized a gesture
        // so trigger an event
        if (this.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED | STATE_CANCELLED)) {
            this.tryEmit(inputDataClone);
        }
    },

    /**
     * return the state of the recognizer
     * the actual recognizing happens in this method
     * @virtual
     * @param {Object} inputData
     * @returns {Const} STATE
     */
    process: function(inputData) { }, // jshint ignore:line

    /**
     * return the preferred touch-action
     * @virtual
     * @returns {Array}
     */
    getTouchAction: function() { },

    /**
     * called when the gesture isn't allowed to recognize
     * like when another is being recognized or it is disabled
     * @virtual
     */
    reset: function() { }
};

/**
 * get a usable string, used as event postfix
 * @param {Const} state
 * @returns {String} state
 */
function stateStr(state) {
    if (state & STATE_CANCELLED) {
        return 'cancel';
    } else if (state & STATE_ENDED) {
        return 'end';
    } else if (state & STATE_CHANGED) {
        return 'move';
    } else if (state & STATE_BEGAN) {
        return 'start';
    }
    return '';
}

/**
 * direction cons to string
 * @param {Const} direction
 * @returns {String}
 */
function directionStr(direction) {
    if (direction == DIRECTION_DOWN) {
        return 'down';
    } else if (direction == DIRECTION_UP) {
        return 'up';
    } else if (direction == DIRECTION_LEFT) {
        return 'left';
    } else if (direction == DIRECTION_RIGHT) {
        return 'right';
    }
    return '';
}

/**
 * get a recognizer by name if it is bound to a manager
 * @param {Recognizer|String} otherRecognizer
 * @param {Recognizer} recognizer
 * @returns {Recognizer}
 */
function getRecognizerByNameIfManager(otherRecognizer, recognizer) {
    var manager = recognizer.manager;
    if (manager) {
        return manager.get(otherRecognizer);
    }
    return otherRecognizer;
}

/**
 * This recognizer is just used as a base for the simple attribute recognizers.
 * @constructor
 * @extends Recognizer
 */
function AttrRecognizer() {
    Recognizer.apply(this, arguments);
}

inherit(AttrRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof AttrRecognizer
     */
    defaults: {
        /**
         * @type {Number}
         * @default 1
         */
        pointers: 1
    },

    /**
     * Used to check if it the recognizer receives valid input, like input.distance > 10.
     * @memberof AttrRecognizer
     * @param {Object} input
     * @returns {Boolean} recognized
     */
    attrTest: function(input) {
        var optionPointers = this.options.pointers;
        return optionPointers === 0 || input.pointers.length === optionPointers;
    },

    /**
     * Process the input and return the state for the recognizer
     * @memberof AttrRecognizer
     * @param {Object} input
     * @returns {*} State
     */
    process: function(input) {
        var state = this.state;
        var eventType = input.eventType;

        var isRecognized = state & (STATE_BEGAN | STATE_CHANGED);
        var isValid = this.attrTest(input);

        // on cancel input and we've recognized before, return STATE_CANCELLED
        if (isRecognized && (eventType & INPUT_CANCEL || !isValid)) {
            return state | STATE_CANCELLED;
        } else if (isRecognized || isValid) {
            if (eventType & INPUT_END) {
                return state | STATE_ENDED;
            } else if (!(state & STATE_BEGAN)) {
                return STATE_BEGAN;
            }
            return state | STATE_CHANGED;
        }
        return STATE_FAILED;
    }
});

/**
 * Pan
 * Recognized when the pointer is down and moved in the allowed direction.
 * @constructor
 * @extends AttrRecognizer
 */
function PanRecognizer() {
    AttrRecognizer.apply(this, arguments);

    this.pX = null;
    this.pY = null;
}

inherit(PanRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof PanRecognizer
     */
    defaults: {
        event: 'pan',
        threshold: 10,
        pointers: 1,
        direction: DIRECTION_ALL
    },

    getTouchAction: function() {
        var direction = this.options.direction;
        var actions = [];
        if (direction & DIRECTION_HORIZONTAL) {
            actions.push(TOUCH_ACTION_PAN_Y);
        }
        if (direction & DIRECTION_VERTICAL) {
            actions.push(TOUCH_ACTION_PAN_X);
        }
        return actions;
    },

    directionTest: function(input) {
        var options = this.options;
        var hasMoved = true;
        var distance = input.distance;
        var direction = input.direction;
        var x = input.deltaX;
        var y = input.deltaY;

        // lock to axis?
        if (!(direction & options.direction)) {
            if (options.direction & DIRECTION_HORIZONTAL) {
                direction = (x === 0) ? DIRECTION_NONE : (x < 0) ? DIRECTION_LEFT : DIRECTION_RIGHT;
                hasMoved = x != this.pX;
                distance = Math.abs(input.deltaX);
            } else {
                direction = (y === 0) ? DIRECTION_NONE : (y < 0) ? DIRECTION_UP : DIRECTION_DOWN;
                hasMoved = y != this.pY;
                distance = Math.abs(input.deltaY);
            }
        }
        input.direction = direction;
        return hasMoved && distance > options.threshold && direction & options.direction;
    },

    attrTest: function(input) {
        return AttrRecognizer.prototype.attrTest.call(this, input) &&
            (this.state & STATE_BEGAN || (!(this.state & STATE_BEGAN) && this.directionTest(input)));
    },

    emit: function(input) {

        this.pX = input.deltaX;
        this.pY = input.deltaY;

        var direction = directionStr(input.direction);

        if (direction) {
            input.additionalEvent = this.options.event + direction;
        }
        this._super.emit.call(this, input);
    }
});

/**
 * Pinch
 * Recognized when two or more pointers are moving toward (zoom-in) or away from each other (zoom-out).
 * @constructor
 * @extends AttrRecognizer
 */
function PinchRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(PinchRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof PinchRecognizer
     */
    defaults: {
        event: 'pinch',
        threshold: 0,
        pointers: 2
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_NONE];
    },

    attrTest: function(input) {
        return this._super.attrTest.call(this, input) &&
            (Math.abs(input.scale - 1) > this.options.threshold || this.state & STATE_BEGAN);
    },

    emit: function(input) {
        if (input.scale !== 1) {
            var inOut = input.scale < 1 ? 'in' : 'out';
            input.additionalEvent = this.options.event + inOut;
        }
        this._super.emit.call(this, input);
    }
});

/**
 * Press
 * Recognized when the pointer is down for x ms without any movement.
 * @constructor
 * @extends Recognizer
 */
function PressRecognizer() {
    Recognizer.apply(this, arguments);

    this._timer = null;
    this._input = null;
}

inherit(PressRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof PressRecognizer
     */
    defaults: {
        event: 'press',
        pointers: 1,
        time: 251, // minimal time of the pointer to be pressed
        threshold: 9 // a minimal movement is ok, but keep it low
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_AUTO];
    },

    process: function(input) {
        var options = this.options;
        var validPointers = input.pointers.length === options.pointers;
        var validMovement = input.distance < options.threshold;
        var validTime = input.deltaTime > options.time;

        this._input = input;

        // we only allow little movement
        // and we've reached an end event, so a tap is possible
        if (!validMovement || !validPointers || (input.eventType & (INPUT_END | INPUT_CANCEL) && !validTime)) {
            this.reset();
        } else if (input.eventType & INPUT_START) {
            this.reset();
            this._timer = setTimeoutContext(function() {
                this.state = STATE_RECOGNIZED;
                this.tryEmit();
            }, options.time, this);
        } else if (input.eventType & INPUT_END) {
            return STATE_RECOGNIZED;
        }
        return STATE_FAILED;
    },

    reset: function() {
        clearTimeout(this._timer);
    },

    emit: function(input) {
        if (this.state !== STATE_RECOGNIZED) {
            return;
        }

        if (input && (input.eventType & INPUT_END)) {
            this.manager.emit(this.options.event + 'up', input);
        } else {
            this._input.timeStamp = now();
            this.manager.emit(this.options.event, this._input);
        }
    }
});

/**
 * Rotate
 * Recognized when two or more pointer are moving in a circular motion.
 * @constructor
 * @extends AttrRecognizer
 */
function RotateRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(RotateRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof RotateRecognizer
     */
    defaults: {
        event: 'rotate',
        threshold: 0,
        pointers: 2
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_NONE];
    },

    attrTest: function(input) {
        return this._super.attrTest.call(this, input) &&
            (Math.abs(input.rotation) > this.options.threshold || this.state & STATE_BEGAN);
    }
});

/**
 * Swipe
 * Recognized when the pointer is moving fast (velocity), with enough distance in the allowed direction.
 * @constructor
 * @extends AttrRecognizer
 */
function SwipeRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(SwipeRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof SwipeRecognizer
     */
    defaults: {
        event: 'swipe',
        threshold: 10,
        velocity: 0.3,
        direction: DIRECTION_HORIZONTAL | DIRECTION_VERTICAL,
        pointers: 1
    },

    getTouchAction: function() {
        return PanRecognizer.prototype.getTouchAction.call(this);
    },

    attrTest: function(input) {
        var direction = this.options.direction;
        var velocity;

        if (direction & (DIRECTION_HORIZONTAL | DIRECTION_VERTICAL)) {
            velocity = input.overallVelocity;
        } else if (direction & DIRECTION_HORIZONTAL) {
            velocity = input.overallVelocityX;
        } else if (direction & DIRECTION_VERTICAL) {
            velocity = input.overallVelocityY;
        }

        return this._super.attrTest.call(this, input) &&
            direction & input.offsetDirection &&
            input.distance > this.options.threshold &&
            input.maxPointers == this.options.pointers &&
            abs(velocity) > this.options.velocity && input.eventType & INPUT_END;
    },

    emit: function(input) {
        var direction = directionStr(input.offsetDirection);
        if (direction) {
            this.manager.emit(this.options.event + direction, input);
        }

        this.manager.emit(this.options.event, input);
    }
});

/**
 * A tap is ecognized when the pointer is doing a small tap/click. Multiple taps are recognized if they occur
 * between the given interval and position. The delay option can be used to recognize multi-taps without firing
 * a single tap.
 *
 * The eventData from the emitted event contains the property `tapCount`, which contains the amount of
 * multi-taps being recognized.
 * @constructor
 * @extends Recognizer
 */
function TapRecognizer() {
    Recognizer.apply(this, arguments);

    // previous time and center,
    // used for tap counting
    this.pTime = false;
    this.pCenter = false;

    this._timer = null;
    this._input = null;
    this.count = 0;
}

inherit(TapRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof PinchRecognizer
     */
    defaults: {
        event: 'tap',
        pointers: 1,
        taps: 1,
        interval: 300, // max time between the multi-tap taps
        time: 250, // max time of the pointer to be down (like finger on the screen)
        threshold: 9, // a minimal movement is ok, but keep it low
        posThreshold: 10 // a multi-tap can be a bit off the initial position
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_MANIPULATION];
    },

    process: function(input) {
        var options = this.options;

        var validPointers = input.pointers.length === options.pointers;
        var validMovement = input.distance < options.threshold;
        var validTouchTime = input.deltaTime < options.time;

        this.reset();

        if ((input.eventType & INPUT_START) && (this.count === 0)) {
            return this.failTimeout();
        }

        // we only allow little movement
        // and we've reached an end event, so a tap is possible
        if (validMovement && validTouchTime && validPointers) {
            if (input.eventType != INPUT_END) {
                return this.failTimeout();
            }

            var validInterval = this.pTime ? (input.timeStamp - this.pTime < options.interval) : true;
            var validMultiTap = !this.pCenter || getDistance(this.pCenter, input.center) < options.posThreshold;

            this.pTime = input.timeStamp;
            this.pCenter = input.center;

            if (!validMultiTap || !validInterval) {
                this.count = 1;
            } else {
                this.count += 1;
            }

            this._input = input;

            // if tap count matches we have recognized it,
            // else it has began recognizing...
            var tapCount = this.count % options.taps;
            if (tapCount === 0) {
                // no failing requirements, immediately trigger the tap event
                // or wait as long as the multitap interval to trigger
                if (!this.hasRequireFailures()) {
                    return STATE_RECOGNIZED;
                } else {
                    this._timer = setTimeoutContext(function() {
                        this.state = STATE_RECOGNIZED;
                        this.tryEmit();
                    }, options.interval, this);
                    return STATE_BEGAN;
                }
            }
        }
        return STATE_FAILED;
    },

    failTimeout: function() {
        this._timer = setTimeoutContext(function() {
            this.state = STATE_FAILED;
        }, this.options.interval, this);
        return STATE_FAILED;
    },

    reset: function() {
        clearTimeout(this._timer);
    },

    emit: function() {
        if (this.state == STATE_RECOGNIZED) {
            this._input.tapCount = this.count;
            this.manager.emit(this.options.event, this._input);
        }
    }
});

/**
 * Simple way to create a manager with a default set of recognizers.
 * @param {HTMLElement} element
 * @param {Object} [options]
 * @constructor
 */
function Hammer(element, options) {
    options = options || {};
    options.recognizers = ifUndefined(options.recognizers, Hammer.defaults.preset);
    return new Manager(element, options);
}

/**
 * @const {string}
 */
Hammer.VERSION = '2.0.7';

/**
 * default settings
 * @namespace
 */
Hammer.defaults = {
    /**
     * set if DOM events are being triggered.
     * But this is slower and unused by simple implementations, so disabled by default.
     * @type {Boolean}
     * @default false
     */
    domEvents: false,

    /**
     * The value for the touchAction property/fallback.
     * When set to `compute` it will magically set the correct value based on the added recognizers.
     * @type {String}
     * @default compute
     */
    touchAction: TOUCH_ACTION_COMPUTE,

    /**
     * @type {Boolean}
     * @default true
     */
    enable: true,

    /**
     * EXPERIMENTAL FEATURE -- can be removed/changed
     * Change the parent input target element.
     * If Null, then it is being set the to main element.
     * @type {Null|EventTarget}
     * @default null
     */
    inputTarget: null,

    /**
     * force an input class
     * @type {Null|Function}
     * @default null
     */
    inputClass: null,

    /**
     * Default recognizer setup when calling `Hammer()`
     * When creating a new Manager these will be skipped.
     * @type {Array}
     */
    preset: [
        // RecognizerClass, options, [recognizeWith, ...], [requireFailure, ...]
        [RotateRecognizer, {enable: false}],
        [PinchRecognizer, {enable: false}, ['rotate']],
        [SwipeRecognizer, {direction: DIRECTION_HORIZONTAL}],
        [PanRecognizer, {direction: DIRECTION_HORIZONTAL}, ['swipe']],
        [TapRecognizer],
        [TapRecognizer, {event: 'doubletap', taps: 2}, ['tap']],
        [PressRecognizer]
    ],

    /**
     * Some CSS properties can be used to improve the working of Hammer.
     * Add them to this method and they will be set when creating a new Manager.
     * @namespace
     */
    cssProps: {
        /**
         * Disables text selection to improve the dragging gesture. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */
        userSelect: 'none',

        /**
         * Disable the Windows Phone grippers when pressing an element.
         * @type {String}
         * @default 'none'
         */
        touchSelect: 'none',

        /**
         * Disables the default callout shown when you touch and hold a touch target.
         * On iOS, when you touch and hold a touch target such as a link, Safari displays
         * a callout containing information about the link. This property allows you to disable that callout.
         * @type {String}
         * @default 'none'
         */
        touchCallout: 'none',

        /**
         * Specifies whether zooming is enabled. Used by IE10>
         * @type {String}
         * @default 'none'
         */
        contentZooming: 'none',

        /**
         * Specifies that an entire element should be draggable instead of its contents. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */
        userDrag: 'none',

        /**
         * Overrides the highlight color shown when the user taps a link or a JavaScript
         * clickable element in iOS. This property obeys the alpha value, if specified.
         * @type {String}
         * @default 'rgba(0,0,0,0)'
         */
        tapHighlightColor: 'rgba(0,0,0,0)'
    }
};

var STOP = 1;
var FORCED_STOP = 2;

/**
 * Manager
 * @param {HTMLElement} element
 * @param {Object} [options]
 * @constructor
 */
function Manager(element, options) {
    this.options = assign({}, Hammer.defaults, options || {});

    this.options.inputTarget = this.options.inputTarget || element;

    this.handlers = {};
    this.session = {};
    this.recognizers = [];
    this.oldCssProps = {};

    this.element = element;
    this.input = createInputInstance(this);
    this.touchAction = new TouchAction(this, this.options.touchAction);

    toggleCssProps(this, true);

    each(this.options.recognizers, function(item) {
        var recognizer = this.add(new (item[0])(item[1]));
        item[2] && recognizer.recognizeWith(item[2]);
        item[3] && recognizer.requireFailure(item[3]);
    }, this);
}

Manager.prototype = {
    /**
     * set options
     * @param {Object} options
     * @returns {Manager}
     */
    set: function(options) {
        assign(this.options, options);

        // Options that need a little more setup
        if (options.touchAction) {
            this.touchAction.update();
        }
        if (options.inputTarget) {
            // Clean up existing event listeners and reinitialize
            this.input.destroy();
            this.input.target = options.inputTarget;
            this.input.init();
        }
        return this;
    },

    /**
     * stop recognizing for this session.
     * This session will be discarded, when a new [input]start event is fired.
     * When forced, the recognizer cycle is stopped immediately.
     * @param {Boolean} [force]
     */
    stop: function(force) {
        this.session.stopped = force ? FORCED_STOP : STOP;
    },

    /**
     * run the recognizers!
     * called by the inputHandler function on every movement of the pointers (touches)
     * it walks through all the recognizers and tries to detect the gesture that is being made
     * @param {Object} inputData
     */
    recognize: function(inputData) {
        var session = this.session;
        if (session.stopped) {
            return;
        }

        // run the touch-action polyfill
        this.touchAction.preventDefaults(inputData);

        var recognizer;
        var recognizers = this.recognizers;

        // this holds the recognizer that is being recognized.
        // so the recognizer's state needs to be BEGAN, CHANGED, ENDED or RECOGNIZED
        // if no recognizer is detecting a thing, it is set to `null`
        var curRecognizer = session.curRecognizer;

        // reset when the last recognizer is recognized
        // or when we're in a new session
        if (!curRecognizer || (curRecognizer && curRecognizer.state & STATE_RECOGNIZED)) {
            curRecognizer = session.curRecognizer = null;
        }

        var i = 0;
        while (i < recognizers.length) {
            recognizer = recognizers[i];

            // find out if we are allowed try to recognize the input for this one.
            // 1.   allow if the session is NOT forced stopped (see the .stop() method)
            // 2.   allow if we still haven't recognized a gesture in this session, or the this recognizer is the one
            //      that is being recognized.
            // 3.   allow if the recognizer is allowed to run simultaneous with the current recognized recognizer.
            //      this can be setup with the `recognizeWith()` method on the recognizer.
            if (session.stopped !== FORCED_STOP && ( // 1
                    !curRecognizer || recognizer == curRecognizer || // 2
                    recognizer.canRecognizeWith(curRecognizer))) { // 3
                recognizer.recognize(inputData);
            } else {
                recognizer.reset();
            }

            // if the recognizer has been recognizing the input as a valid gesture, we want to store this one as the
            // current active recognizer. but only if we don't already have an active recognizer
            if (!curRecognizer && recognizer.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED)) {
                curRecognizer = session.curRecognizer = recognizer;
            }
            i++;
        }
    },

    /**
     * get a recognizer by its event name.
     * @param {Recognizer|String} recognizer
     * @returns {Recognizer|Null}
     */
    get: function(recognizer) {
        if (recognizer instanceof Recognizer) {
            return recognizer;
        }

        var recognizers = this.recognizers;
        for (var i = 0; i < recognizers.length; i++) {
            if (recognizers[i].options.event == recognizer) {
                return recognizers[i];
            }
        }
        return null;
    },

    /**
     * add a recognizer to the manager
     * existing recognizers with the same event name will be removed
     * @param {Recognizer} recognizer
     * @returns {Recognizer|Manager}
     */
    add: function(recognizer) {
        if (invokeArrayArg(recognizer, 'add', this)) {
            return this;
        }

        // remove existing
        var existing = this.get(recognizer.options.event);
        if (existing) {
            this.remove(existing);
        }

        this.recognizers.push(recognizer);
        recognizer.manager = this;

        this.touchAction.update();
        return recognizer;
    },

    /**
     * remove a recognizer by name or instance
     * @param {Recognizer|String} recognizer
     * @returns {Manager}
     */
    remove: function(recognizer) {
        if (invokeArrayArg(recognizer, 'remove', this)) {
            return this;
        }

        recognizer = this.get(recognizer);

        // let's make sure this recognizer exists
        if (recognizer) {
            var recognizers = this.recognizers;
            var index = inArray(recognizers, recognizer);

            if (index !== -1) {
                recognizers.splice(index, 1);
                this.touchAction.update();
            }
        }

        return this;
    },

    /**
     * bind event
     * @param {String} events
     * @param {Function} handler
     * @returns {EventEmitter} this
     */
    on: function(events, handler) {
        if (events === undefined) {
            return;
        }
        if (handler === undefined) {
            return;
        }

        var handlers = this.handlers;
        each(splitStr(events), function(event) {
            handlers[event] = handlers[event] || [];
            handlers[event].push(handler);
        });
        return this;
    },

    /**
     * unbind event, leave emit blank to remove all handlers
     * @param {String} events
     * @param {Function} [handler]
     * @returns {EventEmitter} this
     */
    off: function(events, handler) {
        if (events === undefined) {
            return;
        }

        var handlers = this.handlers;
        each(splitStr(events), function(event) {
            if (!handler) {
                delete handlers[event];
            } else {
                handlers[event] && handlers[event].splice(inArray(handlers[event], handler), 1);
            }
        });
        return this;
    },

    /**
     * emit event to the listeners
     * @param {String} event
     * @param {Object} data
     */
    emit: function(event, data) {
        // we also want to trigger dom events
        if (this.options.domEvents) {
            triggerDomEvent(event, data);
        }

        // no handlers, so skip it all
        var handlers = this.handlers[event] && this.handlers[event].slice();
        if (!handlers || !handlers.length) {
            return;
        }

        data.type = event;
        data.preventDefault = function() {
            data.srcEvent.preventDefault();
        };

        var i = 0;
        while (i < handlers.length) {
            handlers[i](data);
            i++;
        }
    },

    /**
     * destroy the manager and unbinds all events
     * it doesn't unbind dom events, that is the user own responsibility
     */
    destroy: function() {
        this.element && toggleCssProps(this, false);

        this.handlers = {};
        this.session = {};
        this.input.destroy();
        this.element = null;
    }
};

/**
 * add/remove the css properties as defined in manager.options.cssProps
 * @param {Manager} manager
 * @param {Boolean} add
 */
function toggleCssProps(manager, add) {
    var element = manager.element;
    if (!element.style) {
        return;
    }
    var prop;
    each(manager.options.cssProps, function(value, name) {
        prop = prefixed(element.style, name);
        if (add) {
            manager.oldCssProps[prop] = element.style[prop];
            element.style[prop] = value;
        } else {
            element.style[prop] = manager.oldCssProps[prop] || '';
        }
    });
    if (!add) {
        manager.oldCssProps = {};
    }
}

/**
 * trigger dom event
 * @param {String} event
 * @param {Object} data
 */
function triggerDomEvent(event, data) {
    var gestureEvent = document.createEvent('Event');
    gestureEvent.initEvent(event, true, true);
    gestureEvent.gesture = data;
    data.target.dispatchEvent(gestureEvent);
}

assign(Hammer, {
    INPUT_START: INPUT_START,
    INPUT_MOVE: INPUT_MOVE,
    INPUT_END: INPUT_END,
    INPUT_CANCEL: INPUT_CANCEL,

    STATE_POSSIBLE: STATE_POSSIBLE,
    STATE_BEGAN: STATE_BEGAN,
    STATE_CHANGED: STATE_CHANGED,
    STATE_ENDED: STATE_ENDED,
    STATE_RECOGNIZED: STATE_RECOGNIZED,
    STATE_CANCELLED: STATE_CANCELLED,
    STATE_FAILED: STATE_FAILED,

    DIRECTION_NONE: DIRECTION_NONE,
    DIRECTION_LEFT: DIRECTION_LEFT,
    DIRECTION_RIGHT: DIRECTION_RIGHT,
    DIRECTION_UP: DIRECTION_UP,
    DIRECTION_DOWN: DIRECTION_DOWN,
    DIRECTION_HORIZONTAL: DIRECTION_HORIZONTAL,
    DIRECTION_VERTICAL: DIRECTION_VERTICAL,
    DIRECTION_ALL: DIRECTION_ALL,

    Manager: Manager,
    Input: Input,
    TouchAction: TouchAction,

    TouchInput: TouchInput,
    MouseInput: MouseInput,
    PointerEventInput: PointerEventInput,
    TouchMouseInput: TouchMouseInput,
    SingleTouchInput: SingleTouchInput,

    Recognizer: Recognizer,
    AttrRecognizer: AttrRecognizer,
    Tap: TapRecognizer,
    Pan: PanRecognizer,
    Swipe: SwipeRecognizer,
    Pinch: PinchRecognizer,
    Rotate: RotateRecognizer,
    Press: PressRecognizer,

    on: addEventListeners,
    off: removeEventListeners,
    each: each,
    merge: merge,
    extend: extend,
    assign: assign,
    inherit: inherit,
    bindFn: bindFn,
    prefixed: prefixed
});

// this prevents errors when Hammer is loaded in the presence of an AMD
//  style loader but by script tag, not by the loader.
var freeGlobal = (typeof window !== 'undefined' ? window : (typeof self !== 'undefined' ? self : {})); // jshint ignore:line
freeGlobal.Hammer = Hammer;

if (true) {
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
        return Hammer;
    }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
} else if (typeof module != 'undefined' && module.exports) {
    module.exports = Hammer;
} else {
    window[exportName] = Hammer;
}

})(window, document, 'Hammer');


/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Url */
/* unused harmony export Http */
/* unused harmony export Resource */
/*!
 * vue-resource v1.5.1
 * https://github.com/pagekit/vue-resource
 * Released under the MIT License.
 */

/**
 * Promises/A+ polyfill v1.1.4 (https://github.com/bramstein/promis)
 */

var RESOLVED = 0;
var REJECTED = 1;
var PENDING = 2;

function Promise$1(executor) {

    this.state = PENDING;
    this.value = undefined;
    this.deferred = [];

    var promise = this;

    try {
        executor(function (x) {
            promise.resolve(x);
        }, function (r) {
            promise.reject(r);
        });
    } catch (e) {
        promise.reject(e);
    }
}

Promise$1.reject = function (r) {
    return new Promise$1(function (resolve, reject) {
        reject(r);
    });
};

Promise$1.resolve = function (x) {
    return new Promise$1(function (resolve, reject) {
        resolve(x);
    });
};

Promise$1.all = function all(iterable) {
    return new Promise$1(function (resolve, reject) {
        var count = 0, result = [];

        if (iterable.length === 0) {
            resolve(result);
        }

        function resolver(i) {
            return function (x) {
                result[i] = x;
                count += 1;

                if (count === iterable.length) {
                    resolve(result);
                }
            };
        }

        for (var i = 0; i < iterable.length; i += 1) {
            Promise$1.resolve(iterable[i]).then(resolver(i), reject);
        }
    });
};

Promise$1.race = function race(iterable) {
    return new Promise$1(function (resolve, reject) {
        for (var i = 0; i < iterable.length; i += 1) {
            Promise$1.resolve(iterable[i]).then(resolve, reject);
        }
    });
};

var p = Promise$1.prototype;

p.resolve = function resolve(x) {
    var promise = this;

    if (promise.state === PENDING) {
        if (x === promise) {
            throw new TypeError('Promise settled with itself.');
        }

        var called = false;

        try {
            var then = x && x['then'];

            if (x !== null && typeof x === 'object' && typeof then === 'function') {
                then.call(x, function (x) {
                    if (!called) {
                        promise.resolve(x);
                    }
                    called = true;

                }, function (r) {
                    if (!called) {
                        promise.reject(r);
                    }
                    called = true;
                });
                return;
            }
        } catch (e) {
            if (!called) {
                promise.reject(e);
            }
            return;
        }

        promise.state = RESOLVED;
        promise.value = x;
        promise.notify();
    }
};

p.reject = function reject(reason) {
    var promise = this;

    if (promise.state === PENDING) {
        if (reason === promise) {
            throw new TypeError('Promise settled with itself.');
        }

        promise.state = REJECTED;
        promise.value = reason;
        promise.notify();
    }
};

p.notify = function notify() {
    var promise = this;

    nextTick(function () {
        if (promise.state !== PENDING) {
            while (promise.deferred.length) {
                var deferred = promise.deferred.shift(),
                    onResolved = deferred[0],
                    onRejected = deferred[1],
                    resolve = deferred[2],
                    reject = deferred[3];

                try {
                    if (promise.state === RESOLVED) {
                        if (typeof onResolved === 'function') {
                            resolve(onResolved.call(undefined, promise.value));
                        } else {
                            resolve(promise.value);
                        }
                    } else if (promise.state === REJECTED) {
                        if (typeof onRejected === 'function') {
                            resolve(onRejected.call(undefined, promise.value));
                        } else {
                            reject(promise.value);
                        }
                    }
                } catch (e) {
                    reject(e);
                }
            }
        }
    });
};

p.then = function then(onResolved, onRejected) {
    var promise = this;

    return new Promise$1(function (resolve, reject) {
        promise.deferred.push([onResolved, onRejected, resolve, reject]);
        promise.notify();
    });
};

p.catch = function (onRejected) {
    return this.then(undefined, onRejected);
};

/**
 * Promise adapter.
 */

if (typeof Promise === 'undefined') {
    window.Promise = Promise$1;
}

function PromiseObj(executor, context) {

    if (executor instanceof Promise) {
        this.promise = executor;
    } else {
        this.promise = new Promise(executor.bind(context));
    }

    this.context = context;
}

PromiseObj.all = function (iterable, context) {
    return new PromiseObj(Promise.all(iterable), context);
};

PromiseObj.resolve = function (value, context) {
    return new PromiseObj(Promise.resolve(value), context);
};

PromiseObj.reject = function (reason, context) {
    return new PromiseObj(Promise.reject(reason), context);
};

PromiseObj.race = function (iterable, context) {
    return new PromiseObj(Promise.race(iterable), context);
};

var p$1 = PromiseObj.prototype;

p$1.bind = function (context) {
    this.context = context;
    return this;
};

p$1.then = function (fulfilled, rejected) {

    if (fulfilled && fulfilled.bind && this.context) {
        fulfilled = fulfilled.bind(this.context);
    }

    if (rejected && rejected.bind && this.context) {
        rejected = rejected.bind(this.context);
    }

    return new PromiseObj(this.promise.then(fulfilled, rejected), this.context);
};

p$1.catch = function (rejected) {

    if (rejected && rejected.bind && this.context) {
        rejected = rejected.bind(this.context);
    }

    return new PromiseObj(this.promise.catch(rejected), this.context);
};

p$1.finally = function (callback) {

    return this.then(function (value) {
        callback.call(this);
        return value;
    }, function (reason) {
        callback.call(this);
        return Promise.reject(reason);
    }
    );
};

/**
 * Utility functions.
 */

var ref = {};
var hasOwnProperty = ref.hasOwnProperty;
var ref$1 = [];
var slice = ref$1.slice;
var debug = false, ntick;

var inBrowser = typeof window !== 'undefined';

function Util (ref) {
    var config = ref.config;
    var nextTick = ref.nextTick;

    ntick = nextTick;
    debug = config.debug || !config.silent;
}

function warn(msg) {
    if (typeof console !== 'undefined' && debug) {
        console.warn('[VueResource warn]: ' + msg);
    }
}

function error(msg) {
    if (typeof console !== 'undefined') {
        console.error(msg);
    }
}

function nextTick(cb, ctx) {
    return ntick(cb, ctx);
}

function trim(str) {
    return str ? str.replace(/^\s*|\s*$/g, '') : '';
}

function trimEnd(str, chars) {

    if (str && chars === undefined) {
        return str.replace(/\s+$/, '');
    }

    if (!str || !chars) {
        return str;
    }

    return str.replace(new RegExp(("[" + chars + "]+$")), '');
}

function toLower(str) {
    return str ? str.toLowerCase() : '';
}

function toUpper(str) {
    return str ? str.toUpperCase() : '';
}

var isArray = Array.isArray;

function isString(val) {
    return typeof val === 'string';
}

function isFunction(val) {
    return typeof val === 'function';
}

function isObject(obj) {
    return obj !== null && typeof obj === 'object';
}

function isPlainObject(obj) {
    return isObject(obj) && Object.getPrototypeOf(obj) == Object.prototype;
}

function isBlob(obj) {
    return typeof Blob !== 'undefined' && obj instanceof Blob;
}

function isFormData(obj) {
    return typeof FormData !== 'undefined' && obj instanceof FormData;
}

function when(value, fulfilled, rejected) {

    var promise = PromiseObj.resolve(value);

    if (arguments.length < 2) {
        return promise;
    }

    return promise.then(fulfilled, rejected);
}

function options(fn, obj, opts) {

    opts = opts || {};

    if (isFunction(opts)) {
        opts = opts.call(obj);
    }

    return merge(fn.bind({$vm: obj, $options: opts}), fn, {$options: opts});
}

function each(obj, iterator) {

    var i, key;

    if (isArray(obj)) {
        for (i = 0; i < obj.length; i++) {
            iterator.call(obj[i], obj[i], i);
        }
    } else if (isObject(obj)) {
        for (key in obj) {
            if (hasOwnProperty.call(obj, key)) {
                iterator.call(obj[key], obj[key], key);
            }
        }
    }

    return obj;
}

var assign = Object.assign || _assign;

function merge(target) {

    var args = slice.call(arguments, 1);

    args.forEach(function (source) {
        _merge(target, source, true);
    });

    return target;
}

function defaults(target) {

    var args = slice.call(arguments, 1);

    args.forEach(function (source) {

        for (var key in source) {
            if (target[key] === undefined) {
                target[key] = source[key];
            }
        }

    });

    return target;
}

function _assign(target) {

    var args = slice.call(arguments, 1);

    args.forEach(function (source) {
        _merge(target, source);
    });

    return target;
}

function _merge(target, source, deep) {
    for (var key in source) {
        if (deep && (isPlainObject(source[key]) || isArray(source[key]))) {
            if (isPlainObject(source[key]) && !isPlainObject(target[key])) {
                target[key] = {};
            }
            if (isArray(source[key]) && !isArray(target[key])) {
                target[key] = [];
            }
            _merge(target[key], source[key], deep);
        } else if (source[key] !== undefined) {
            target[key] = source[key];
        }
    }
}

/**
 * Root Prefix Transform.
 */

function root (options$$1, next) {

    var url = next(options$$1);

    if (isString(options$$1.root) && !/^(https?:)?\//.test(url)) {
        url = trimEnd(options$$1.root, '/') + '/' + url;
    }

    return url;
}

/**
 * Query Parameter Transform.
 */

function query (options$$1, next) {

    var urlParams = Object.keys(Url.options.params), query = {}, url = next(options$$1);

    each(options$$1.params, function (value, key) {
        if (urlParams.indexOf(key) === -1) {
            query[key] = value;
        }
    });

    query = Url.params(query);

    if (query) {
        url += (url.indexOf('?') == -1 ? '?' : '&') + query;
    }

    return url;
}

/**
 * URL Template v2.0.6 (https://github.com/bramstein/url-template)
 */

function expand(url, params, variables) {

    var tmpl = parse(url), expanded = tmpl.expand(params);

    if (variables) {
        variables.push.apply(variables, tmpl.vars);
    }

    return expanded;
}

function parse(template) {

    var operators = ['+', '#', '.', '/', ';', '?', '&'], variables = [];

    return {
        vars: variables,
        expand: function expand(context) {
            return template.replace(/\{([^{}]+)\}|([^{}]+)/g, function (_, expression, literal) {
                if (expression) {

                    var operator = null, values = [];

                    if (operators.indexOf(expression.charAt(0)) !== -1) {
                        operator = expression.charAt(0);
                        expression = expression.substr(1);
                    }

                    expression.split(/,/g).forEach(function (variable) {
                        var tmp = /([^:*]*)(?::(\d+)|(\*))?/.exec(variable);
                        values.push.apply(values, getValues(context, operator, tmp[1], tmp[2] || tmp[3]));
                        variables.push(tmp[1]);
                    });

                    if (operator && operator !== '+') {

                        var separator = ',';

                        if (operator === '?') {
                            separator = '&';
                        } else if (operator !== '#') {
                            separator = operator;
                        }

                        return (values.length !== 0 ? operator : '') + values.join(separator);
                    } else {
                        return values.join(',');
                    }

                } else {
                    return encodeReserved(literal);
                }
            });
        }
    };
}

function getValues(context, operator, key, modifier) {

    var value = context[key], result = [];

    if (isDefined(value) && value !== '') {
        if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
            value = value.toString();

            if (modifier && modifier !== '*') {
                value = value.substring(0, parseInt(modifier, 10));
            }

            result.push(encodeValue(operator, value, isKeyOperator(operator) ? key : null));
        } else {
            if (modifier === '*') {
                if (Array.isArray(value)) {
                    value.filter(isDefined).forEach(function (value) {
                        result.push(encodeValue(operator, value, isKeyOperator(operator) ? key : null));
                    });
                } else {
                    Object.keys(value).forEach(function (k) {
                        if (isDefined(value[k])) {
                            result.push(encodeValue(operator, value[k], k));
                        }
                    });
                }
            } else {
                var tmp = [];

                if (Array.isArray(value)) {
                    value.filter(isDefined).forEach(function (value) {
                        tmp.push(encodeValue(operator, value));
                    });
                } else {
                    Object.keys(value).forEach(function (k) {
                        if (isDefined(value[k])) {
                            tmp.push(encodeURIComponent(k));
                            tmp.push(encodeValue(operator, value[k].toString()));
                        }
                    });
                }

                if (isKeyOperator(operator)) {
                    result.push(encodeURIComponent(key) + '=' + tmp.join(','));
                } else if (tmp.length !== 0) {
                    result.push(tmp.join(','));
                }
            }
        }
    } else {
        if (operator === ';') {
            result.push(encodeURIComponent(key));
        } else if (value === '' && (operator === '&' || operator === '?')) {
            result.push(encodeURIComponent(key) + '=');
        } else if (value === '') {
            result.push('');
        }
    }

    return result;
}

function isDefined(value) {
    return value !== undefined && value !== null;
}

function isKeyOperator(operator) {
    return operator === ';' || operator === '&' || operator === '?';
}

function encodeValue(operator, value, key) {

    value = (operator === '+' || operator === '#') ? encodeReserved(value) : encodeURIComponent(value);

    if (key) {
        return encodeURIComponent(key) + '=' + value;
    } else {
        return value;
    }
}

function encodeReserved(str) {
    return str.split(/(%[0-9A-Fa-f]{2})/g).map(function (part) {
        if (!/%[0-9A-Fa-f]/.test(part)) {
            part = encodeURI(part);
        }
        return part;
    }).join('');
}

/**
 * URL Template (RFC 6570) Transform.
 */

function template (options) {

    var variables = [], url = expand(options.url, options.params, variables);

    variables.forEach(function (key) {
        delete options.params[key];
    });

    return url;
}

/**
 * Service for URL templating.
 */

function Url(url, params) {

    var self = this || {}, options$$1 = url, transform;

    if (isString(url)) {
        options$$1 = {url: url, params: params};
    }

    options$$1 = merge({}, Url.options, self.$options, options$$1);

    Url.transforms.forEach(function (handler) {

        if (isString(handler)) {
            handler = Url.transform[handler];
        }

        if (isFunction(handler)) {
            transform = factory(handler, transform, self.$vm);
        }

    });

    return transform(options$$1);
}

/**
 * Url options.
 */

Url.options = {
    url: '',
    root: null,
    params: {}
};

/**
 * Url transforms.
 */

Url.transform = {template: template, query: query, root: root};
Url.transforms = ['template', 'query', 'root'];

/**
 * Encodes a Url parameter string.
 *
 * @param {Object} obj
 */

Url.params = function (obj) {

    var params = [], escape = encodeURIComponent;

    params.add = function (key, value) {

        if (isFunction(value)) {
            value = value();
        }

        if (value === null) {
            value = '';
        }

        this.push(escape(key) + '=' + escape(value));
    };

    serialize(params, obj);

    return params.join('&').replace(/%20/g, '+');
};

/**
 * Parse a URL and return its components.
 *
 * @param {String} url
 */

Url.parse = function (url) {

    var el = document.createElement('a');

    if (document.documentMode) {
        el.href = url;
        url = el.href;
    }

    el.href = url;

    return {
        href: el.href,
        protocol: el.protocol ? el.protocol.replace(/:$/, '') : '',
        port: el.port,
        host: el.host,
        hostname: el.hostname,
        pathname: el.pathname.charAt(0) === '/' ? el.pathname : '/' + el.pathname,
        search: el.search ? el.search.replace(/^\?/, '') : '',
        hash: el.hash ? el.hash.replace(/^#/, '') : ''
    };
};

function factory(handler, next, vm) {
    return function (options$$1) {
        return handler.call(vm, options$$1, next);
    };
}

function serialize(params, obj, scope) {

    var array = isArray(obj), plain = isPlainObject(obj), hash;

    each(obj, function (value, key) {

        hash = isObject(value) || isArray(value);

        if (scope) {
            key = scope + '[' + (plain || hash ? key : '') + ']';
        }

        if (!scope && array) {
            params.add(value.name, value.value);
        } else if (hash) {
            serialize(params, value, key);
        } else {
            params.add(key, value);
        }
    });
}

/**
 * XDomain client (Internet Explorer).
 */

function xdrClient (request) {
    return new PromiseObj(function (resolve) {

        var xdr = new XDomainRequest(), handler = function (ref) {
                var type = ref.type;


                var status = 0;

                if (type === 'load') {
                    status = 200;
                } else if (type === 'error') {
                    status = 500;
                }

                resolve(request.respondWith(xdr.responseText, {status: status}));
            };

        request.abort = function () { return xdr.abort(); };

        xdr.open(request.method, request.getUrl());

        if (request.timeout) {
            xdr.timeout = request.timeout;
        }

        xdr.onload = handler;
        xdr.onabort = handler;
        xdr.onerror = handler;
        xdr.ontimeout = handler;
        xdr.onprogress = function () {};
        xdr.send(request.getBody());
    });
}

/**
 * CORS Interceptor.
 */

var SUPPORTS_CORS = inBrowser && 'withCredentials' in new XMLHttpRequest();

function cors (request) {

    if (inBrowser) {

        var orgUrl = Url.parse(location.href);
        var reqUrl = Url.parse(request.getUrl());

        if (reqUrl.protocol !== orgUrl.protocol || reqUrl.host !== orgUrl.host) {

            request.crossOrigin = true;
            request.emulateHTTP = false;

            if (!SUPPORTS_CORS) {
                request.client = xdrClient;
            }
        }
    }

}

/**
 * Form data Interceptor.
 */

function form (request) {

    if (isFormData(request.body)) {
        request.headers.delete('Content-Type');
    } else if (isObject(request.body) && request.emulateJSON) {
        request.body = Url.params(request.body);
        request.headers.set('Content-Type', 'application/x-www-form-urlencoded');
    }

}

/**
 * JSON Interceptor.
 */

function json (request) {

    var type = request.headers.get('Content-Type') || '';

    if (isObject(request.body) && type.indexOf('application/json') === 0) {
        request.body = JSON.stringify(request.body);
    }

    return function (response) {

        return response.bodyText ? when(response.text(), function (text) {

            var type = response.headers.get('Content-Type') || '';

            if (type.indexOf('application/json') === 0 || isJson(text)) {

                try {
                    response.body = JSON.parse(text);
                } catch (e) {
                    response.body = null;
                }

            } else {
                response.body = text;
            }

            return response;

        }) : response;

    };
}

function isJson(str) {

    var start = str.match(/^\s*(\[|\{)/);
    var end = {'[': /]\s*$/, '{': /}\s*$/};

    return start && end[start[1]].test(str);
}

/**
 * JSONP client (Browser).
 */

function jsonpClient (request) {
    return new PromiseObj(function (resolve) {

        var name = request.jsonp || 'callback', callback = request.jsonpCallback || '_jsonp' + Math.random().toString(36).substr(2), body = null, handler, script;

        handler = function (ref) {
            var type = ref.type;


            var status = 0;

            if (type === 'load' && body !== null) {
                status = 200;
            } else if (type === 'error') {
                status = 500;
            }

            if (status && window[callback]) {
                delete window[callback];
                document.body.removeChild(script);
            }

            resolve(request.respondWith(body, {status: status}));
        };

        window[callback] = function (result) {
            body = JSON.stringify(result);
        };

        request.abort = function () {
            handler({type: 'abort'});
        };

        request.params[name] = callback;

        if (request.timeout) {
            setTimeout(request.abort, request.timeout);
        }

        script = document.createElement('script');
        script.src = request.getUrl();
        script.type = 'text/javascript';
        script.async = true;
        script.onload = handler;
        script.onerror = handler;

        document.body.appendChild(script);
    });
}

/**
 * JSONP Interceptor.
 */

function jsonp (request) {

    if (request.method == 'JSONP') {
        request.client = jsonpClient;
    }

}

/**
 * Before Interceptor.
 */

function before (request) {

    if (isFunction(request.before)) {
        request.before.call(this, request);
    }

}

/**
 * HTTP method override Interceptor.
 */

function method (request) {

    if (request.emulateHTTP && /^(PUT|PATCH|DELETE)$/i.test(request.method)) {
        request.headers.set('X-HTTP-Method-Override', request.method);
        request.method = 'POST';
    }

}

/**
 * Header Interceptor.
 */

function header (request) {

    var headers = assign({}, Http.headers.common,
        !request.crossOrigin ? Http.headers.custom : {},
        Http.headers[toLower(request.method)]
    );

    each(headers, function (value, name) {
        if (!request.headers.has(name)) {
            request.headers.set(name, value);
        }
    });

}

/**
 * XMLHttp client (Browser).
 */

function xhrClient (request) {
    return new PromiseObj(function (resolve) {

        var xhr = new XMLHttpRequest(), handler = function (event) {

                var response = request.respondWith(
                'response' in xhr ? xhr.response : xhr.responseText, {
                    status: xhr.status === 1223 ? 204 : xhr.status, // IE9 status bug
                    statusText: xhr.status === 1223 ? 'No Content' : trim(xhr.statusText)
                });

                each(trim(xhr.getAllResponseHeaders()).split('\n'), function (row) {
                    response.headers.append(row.slice(0, row.indexOf(':')), row.slice(row.indexOf(':') + 1));
                });

                resolve(response);
            };

        request.abort = function () { return xhr.abort(); };

        xhr.open(request.method, request.getUrl(), true);

        if (request.timeout) {
            xhr.timeout = request.timeout;
        }

        if (request.responseType && 'responseType' in xhr) {
            xhr.responseType = request.responseType;
        }

        if (request.withCredentials || request.credentials) {
            xhr.withCredentials = true;
        }

        if (!request.crossOrigin) {
            request.headers.set('X-Requested-With', 'XMLHttpRequest');
        }

        // deprecated use downloadProgress
        if (isFunction(request.progress) && request.method === 'GET') {
            xhr.addEventListener('progress', request.progress);
        }

        if (isFunction(request.downloadProgress)) {
            xhr.addEventListener('progress', request.downloadProgress);
        }

        // deprecated use uploadProgress
        if (isFunction(request.progress) && /^(POST|PUT)$/i.test(request.method)) {
            xhr.upload.addEventListener('progress', request.progress);
        }

        if (isFunction(request.uploadProgress) && xhr.upload) {
            xhr.upload.addEventListener('progress', request.uploadProgress);
        }

        request.headers.forEach(function (value, name) {
            xhr.setRequestHeader(name, value);
        });

        xhr.onload = handler;
        xhr.onabort = handler;
        xhr.onerror = handler;
        xhr.ontimeout = handler;
        xhr.send(request.getBody());
    });
}

/**
 * Http client (Node).
 */

function nodeClient (request) {

    var client = __webpack_require__(111);

    return new PromiseObj(function (resolve) {

        var url = request.getUrl();
        var body = request.getBody();
        var method = request.method;
        var headers = {}, handler;

        request.headers.forEach(function (value, name) {
            headers[name] = value;
        });

        client(url, {body: body, method: method, headers: headers}).then(handler = function (resp) {

            var response = request.respondWith(resp.body, {
                status: resp.statusCode,
                statusText: trim(resp.statusMessage)
            });

            each(resp.headers, function (value, name) {
                response.headers.set(name, value);
            });

            resolve(response);

        }, function (error$$1) { return handler(error$$1.response); });
    });
}

/**
 * Base client.
 */

function Client (context) {

    var reqHandlers = [sendRequest], resHandlers = [];

    if (!isObject(context)) {
        context = null;
    }

    function Client(request) {
        while (reqHandlers.length) {

            var handler = reqHandlers.pop();

            if (isFunction(handler)) {

                var response = (void 0), next = (void 0);

                response = handler.call(context, request, function (val) { return next = val; }) || next;

                if (isObject(response)) {
                    return new PromiseObj(function (resolve, reject) {

                        resHandlers.forEach(function (handler) {
                            response = when(response, function (response) {
                                return handler.call(context, response) || response;
                            }, reject);
                        });

                        when(response, resolve, reject);

                    }, context);
                }

                if (isFunction(response)) {
                    resHandlers.unshift(response);
                }

            } else {
                warn(("Invalid interceptor of type " + (typeof handler) + ", must be a function"));
            }
        }
    }

    Client.use = function (handler) {
        reqHandlers.push(handler);
    };

    return Client;
}

function sendRequest(request) {

    var client = request.client || (inBrowser ? xhrClient : nodeClient);

    return client(request);
}

/**
 * HTTP Headers.
 */

var Headers = function Headers(headers) {
    var this$1 = this;


    this.map = {};

    each(headers, function (value, name) { return this$1.append(name, value); });
};

Headers.prototype.has = function has (name) {
    return getName(this.map, name) !== null;
};

Headers.prototype.get = function get (name) {

    var list = this.map[getName(this.map, name)];

    return list ? list.join() : null;
};

Headers.prototype.getAll = function getAll (name) {
    return this.map[getName(this.map, name)] || [];
};

Headers.prototype.set = function set (name, value) {
    this.map[normalizeName(getName(this.map, name) || name)] = [trim(value)];
};

Headers.prototype.append = function append (name, value) {

    var list = this.map[getName(this.map, name)];

    if (list) {
        list.push(trim(value));
    } else {
        this.set(name, value);
    }
};

Headers.prototype.delete = function delete$1 (name) {
    delete this.map[getName(this.map, name)];
};

Headers.prototype.deleteAll = function deleteAll () {
    this.map = {};
};

Headers.prototype.forEach = function forEach (callback, thisArg) {
        var this$1 = this;

    each(this.map, function (list, name) {
        each(list, function (value) { return callback.call(thisArg, value, name, this$1); });
    });
};

function getName(map, name) {
    return Object.keys(map).reduce(function (prev, curr) {
        return toLower(name) === toLower(curr) ? curr : prev;
    }, null);
}

function normalizeName(name) {

    if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) {
        throw new TypeError('Invalid character in header field name');
    }

    return trim(name);
}

/**
 * HTTP Response.
 */

var Response = function Response(body, ref) {
    var url = ref.url;
    var headers = ref.headers;
    var status = ref.status;
    var statusText = ref.statusText;


    this.url = url;
    this.ok = status >= 200 && status < 300;
    this.status = status || 0;
    this.statusText = statusText || '';
    this.headers = new Headers(headers);
    this.body = body;

    if (isString(body)) {

        this.bodyText = body;

    } else if (isBlob(body)) {

        this.bodyBlob = body;

        if (isBlobText(body)) {
            this.bodyText = blobText(body);
        }
    }
};

Response.prototype.blob = function blob () {
    return when(this.bodyBlob);
};

Response.prototype.text = function text () {
    return when(this.bodyText);
};

Response.prototype.json = function json () {
    return when(this.text(), function (text) { return JSON.parse(text); });
};

Object.defineProperty(Response.prototype, 'data', {

    get: function get() {
        return this.body;
    },

    set: function set(body) {
        this.body = body;
    }

});

function blobText(body) {
    return new PromiseObj(function (resolve) {

        var reader = new FileReader();

        reader.readAsText(body);
        reader.onload = function () {
            resolve(reader.result);
        };

    });
}

function isBlobText(body) {
    return body.type.indexOf('text') === 0 || body.type.indexOf('json') !== -1;
}

/**
 * HTTP Request.
 */

var Request = function Request(options$$1) {

    this.body = null;
    this.params = {};

    assign(this, options$$1, {
        method: toUpper(options$$1.method || 'GET')
    });

    if (!(this.headers instanceof Headers)) {
        this.headers = new Headers(this.headers);
    }
};

Request.prototype.getUrl = function getUrl () {
    return Url(this);
};

Request.prototype.getBody = function getBody () {
    return this.body;
};

Request.prototype.respondWith = function respondWith (body, options$$1) {
    return new Response(body, assign(options$$1 || {}, {url: this.getUrl()}));
};

/**
 * Service for sending network requests.
 */

var COMMON_HEADERS = {'Accept': 'application/json, text/plain, */*'};
var JSON_CONTENT_TYPE = {'Content-Type': 'application/json;charset=utf-8'};

function Http(options$$1) {

    var self = this || {}, client = Client(self.$vm);

    defaults(options$$1 || {}, self.$options, Http.options);

    Http.interceptors.forEach(function (handler) {

        if (isString(handler)) {
            handler = Http.interceptor[handler];
        }

        if (isFunction(handler)) {
            client.use(handler);
        }

    });

    return client(new Request(options$$1)).then(function (response) {

        return response.ok ? response : PromiseObj.reject(response);

    }, function (response) {

        if (response instanceof Error) {
            error(response);
        }

        return PromiseObj.reject(response);
    });
}

Http.options = {};

Http.headers = {
    put: JSON_CONTENT_TYPE,
    post: JSON_CONTENT_TYPE,
    patch: JSON_CONTENT_TYPE,
    delete: JSON_CONTENT_TYPE,
    common: COMMON_HEADERS,
    custom: {}
};

Http.interceptor = {before: before, method: method, jsonp: jsonp, json: json, form: form, header: header, cors: cors};
Http.interceptors = ['before', 'method', 'jsonp', 'json', 'form', 'header', 'cors'];

['get', 'delete', 'head', 'jsonp'].forEach(function (method$$1) {

    Http[method$$1] = function (url, options$$1) {
        return this(assign(options$$1 || {}, {url: url, method: method$$1}));
    };

});

['post', 'put', 'patch'].forEach(function (method$$1) {

    Http[method$$1] = function (url, body, options$$1) {
        return this(assign(options$$1 || {}, {url: url, method: method$$1, body: body}));
    };

});

/**
 * Service for interacting with RESTful services.
 */

function Resource(url, params, actions, options$$1) {

    var self = this || {}, resource = {};

    actions = assign({},
        Resource.actions,
        actions
    );

    each(actions, function (action, name) {

        action = merge({url: url, params: assign({}, params)}, options$$1, action);

        resource[name] = function () {
            return (self.$http || Http)(opts(action, arguments));
        };
    });

    return resource;
}

function opts(action, args) {

    var options$$1 = assign({}, action), params = {}, body;

    switch (args.length) {

        case 2:

            params = args[0];
            body = args[1];

            break;

        case 1:

            if (/^(POST|PUT|PATCH)$/i.test(options$$1.method)) {
                body = args[0];
            } else {
                params = args[0];
            }

            break;

        case 0:

            break;

        default:

            throw 'Expected up to 2 arguments [params, body], got ' + args.length + ' arguments';
    }

    options$$1.body = body;
    options$$1.params = assign({}, options$$1.params, params);

    return options$$1;
}

Resource.actions = {

    get: {method: 'GET'},
    save: {method: 'POST'},
    query: {method: 'GET'},
    update: {method: 'PUT'},
    remove: {method: 'DELETE'},
    delete: {method: 'DELETE'}

};

/**
 * Install plugin.
 */

function plugin(Vue) {

    if (plugin.installed) {
        return;
    }

    Util(Vue);

    Vue.url = Url;
    Vue.http = Http;
    Vue.resource = Resource;
    Vue.Promise = PromiseObj;

    Object.defineProperties(Vue.prototype, {

        $url: {
            get: function get() {
                return options(Vue.url, this, this.$options.url);
            }
        },

        $http: {
            get: function get() {
                return options(Vue.http, this, this.$options.http);
            }
        },

        $resource: {
            get: function get() {
                return Vue.resource.bind(this);
            }
        },

        $promise: {
            get: function get() {
                var this$1 = this;

                return function (executor) { return new Vue.Promise(executor, this$1); };
            }
        }

    });
}

if (typeof window !== 'undefined' && window.Vue) {
    window.Vue.use(plugin);
}

/* harmony default export */ __webpack_exports__["a"] = (plugin);



/***/ }),
/* 111 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,n){if(true)module.exports=n();else if("function"==typeof define&&define.amd)define([],n);else{var t=n();for(var r in t)("object"==typeof exports?exports:e)[r]=t[r]}}("undefined"!=typeof self?self:this,(function(){return function(e){var n={};function t(r){if(n[r])return n[r].exports;var o=n[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,t),o.l=!0,o.exports}return t.m=e,t.c=n,t.d=function(e,n,r){t.o(e,n)||Object.defineProperty(e,n,{enumerable:!0,get:r})},t.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},t.t=function(e,n){if(1&n&&(e=t(e)),8&n)return e;if(4&n&&"object"==typeof e&&e&&e.__esModule)return e;var r=Object.create(null);if(t.r(r),Object.defineProperty(r,"default",{enumerable:!0,value:e}),2&n&&"string"!=typeof e)for(var o in e)t.d(r,o,function(n){return e[n]}.bind(null,o));return r},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,n){return Object.prototype.hasOwnProperty.call(e,n)},t.p="",t(t.s=0)}([function(e,n,t){"use strict";function r(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function o(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?r(t,!0).forEach((function(n){i(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):r(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}function i(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}t.r(n);var c={$vue:null,id:null,router:null,fields:{},customIdFields:{},ignoreRoutes:[],linkers:[],commands:{},disabled:!1,customResourceURL:null,set:[],require:[],ecommerce:{enabled:!1,options:null,enhanced:!1},autoTracking:{screenview:!1,shouldRouterUpdate:null,skipSamePath:!1,exception:!1,exceptionLogs:!0,page:!0,transformQueryString:!0,pageviewOnLoad:!0,pageviewTemplate:null,untracked:!0,prependBase:!0},debug:{enabled:!1,trace:!1,sendHitTask:!0},batch:{enabled:!1,delay:500,amount:2},checkDuplicatedScript:!1,disableScriptLoader:!1,beforeFirstHit:s,ready:s,untracked:[]},a=o({},c);function u(e){!function e(n,t){return Object.keys(t).forEach((function(r){var o=n[r]&&Object.prototype.toString.call(n[r]);"[object Object]"!==o&&"[object Array]"!==o?n[r]=t[r]:e(n[r],t[r])})),n}(a,e)}function f(){return a.id?[].concat(a.id):[]}var l=a;function s(){}var p=function(e){console.warn("[vue-analytics] ".concat(e))};function d(e,n){return new Promise((function(t,r){var o=document.head||document.getElementsByTagName("head")[0],i=document.createElement("script");if(i.async=!0,i.src=e,i.charset="utf-8",n){var c=document.createElement("link");c.href=n,c.rel="preconnect",o.appendChild(c)}o.appendChild(i),i.onload=t,i.onerror=r}))}function y(e){return e.name||e.replace(/-/gi,"")}function b(e,n){if(f().length>1){var t=y(n);return"".concat(t,".").concat(e)}return e}var m,v=function(e){if(e.then)return e;if("function"==typeof e){var n=e();return n.then?n:Promise.resolve(n)}return Promise.resolve(e)};function g(e){return function(e){if(Array.isArray(e)){for(var n=0,t=new Array(e.length);n<e.length;n++)t[n]=e[n];return t}}(e)||function(e){if(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e))return Array.from(e)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}()}var h=[];function w(e){for(var n=arguments.length,t=new Array(n>1?n-1:0),r=1;r<n;r++)t[r-1]=arguments[r];"undefined"!=typeof window&&f().forEach((function(n){var r,o={m:b(e,n),a:t};window.ga?l.batch.enabled?(h.push(o),m||(m=setInterval((function(){h.length?h.splice(0,l.batch.amount).forEach((function(e){var n;(n=window).ga.apply(n,[e.m].concat(g(e.a)))})):(clearInterval(m),m=null)}),l.batch.delay))):(r=window).ga.apply(r,[b(e,n)].concat(t)):l.untracked.push(o)}))}function O(e){return(O="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function j(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];"object"!==O(n[0])||n[0].constructor!==Object?w("set",n[0],n[1]):w("set",n[0])}function P(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function S(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}function k(){if(window.ga||!l.debug.enabled){if(window.ga){var e=f();l.debug.enabled&&(window.ga_debug={trace:l.debug.trace}),e.forEach((function(n){var t=y(n),r=l.customIdFields[n]||{},o=e.length>1?function(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?P(t,!0).forEach((function(n){S(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):P(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}({},l.fields,{},r,{name:t}):l.fields;window.ga("create",n.id||n,"auto",o)})),l.beforeFirstHit();var n=l.ecommerce;if(n.enabled){var t=n.enhanced?"ec":"ecommerce";n.options?w("require",t,n.options):w("require",t)}l.linkers.length>0&&(w("require","linker"),w("linker:autoLink",l.linkers)),l.debug.sendHitTask||j("sendHitTask",null)}}else p("Google Analytics has probably been blocked.")}var E=function(){2!=arguments.length?w("require",arguments.length<=0?void 0:arguments[0]):w("require",arguments.length<=0?void 0:arguments[0],arguments.length<=1?void 0:arguments[1])};function A(e){return(A="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}var x=function(){var e;l.set.forEach((function(e){var n=e.field,t=e.value;if(void 0===n||void 0===t)throw new Error('[vue-analytics] Wrong configuration in the plugin options.\nThe "set" array requires each item to have a "field" and a "value" property.');j(n,t)})),e=["ec","ecommerce"],l.require.forEach((function(n){if(-1!==e.indexOf(n)||-1!==e.indexOf(n.name))throw new Error("[vue-analytics] The ecommerce features are built-in in the plugin. \nFollow the ecommerce instructions available in the documentation.");if("string"!=typeof n&&"object"!==A(n))throw new Error('[vue-analytics] Wrong configuration in the plugin options. \nThe "require" array requires each item to be a string or to have a "name" and an "options" property.');var t=n.name||n;n.options?E(t,n.options):E(t)}))};function T(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];var r=n[0];if(1===n.length&&"string"==typeof r)return w("send","screenview",{screenName:r});w.apply(void 0,["send","screenview"].concat(n))}function D(e){return(D="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function q(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];var r;n.length&&!n[0]||(n.length&&n[0].currentRoute&&(r=n[0].currentRoute),n.length&&function(e){return e.query&&e.params}(n[0])&&(r=n[0]),r?R(r):(j("page","object"===D(n[0])?n[0].page:n[0]),w.apply(void 0,["send","pageview"].concat(n))))}function R(e){if(![(n=e).name,n.path].filter(Boolean).find((function(e){return-1!==l.ignoreRoutes.indexOf(e)}))){var n,t=l.autoTracking,r=e.meta.analytics,o=(void 0===r?{}:r).pageviewTemplate||t.pageviewTemplate;if(t.screenview&&!e.name)throw new Error("[vue-analytics] Route name is mandatory when using screenview.");if(t.screenview)T(e.name);else if(o)q(o(e));else{var i=l.router,c=l.autoTracking,a=c.transformQueryString,u=c.prependBase,f=function(e){var n=Object.keys(e).reduce((function(n,t,r,o){var i=r===o.length-1,c=e[t];return null==c?n:n+="".concat(t,"=").concat(c).concat(i?"":"&")}),"");return""!==n?"?".concat(n):""}(e.query),s=i&&i.options.base,p=u&&s,d=e.path+(a?f:"");q(d=p?function(e,n){var t=n.split("/"),r=e.split("/");return""===t[0]&&"/"===e[e.length-1]&&t.shift(),r.join("/")+t.join("/")}(s,d):d)}}}function I(e){return function(e){if(Array.isArray(e)){for(var n=0,t=new Array(e.length);n<e.length;n++)t[n]=e[n];return t}}(e)||function(e){if(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e))return Array.from(e)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}()}var L=function(){var e=!(arguments.length>0&&void 0!==arguments[0])||arguments[0];"undefined"!=typeof window&&f().forEach((function(n){window["ga-disable-".concat(n)]=e}))},_=function(){if("undefined"!=typeof document&&"undefined"!=typeof window){if(l.id){var e,n,t=[v(l.id),v(l.disabled)];if(e=l.checkDuplicatedScript,n=l.disableScriptLoader,[Boolean(window&&window.ga),e&&!(Array.prototype.slice.call(document.getElementsByTagName("script")).filter((function(e){return-1!==e.src.indexOf("analytics")||-1!==e.src.indexOf("gtag")})).length>0),!n].some(Boolean)){var r="https://www.google-analytics.com",o=l.debug.enabled?"analytics_debug":"analytics",i=l.customResourceURL?d(l.customResourceURL):d("".concat(r,"/").concat(o,".js"),r);t.push(i.catch((function(){p("An error occured! Please check your connection or disable your AD blocker")})))}return Promise.all(t).then((function(e){var n,t,r;u({id:e[0],disabled:e[1]}),L(l.disabled),k(),x(),l.untracked.forEach((function(e){w.apply(void 0,[e.m].concat(I(e.a)))})),n=l.router,t=l.autoTracking,r=l.$vue,t.page&&n&&n.onReady((function(){t.pageviewOnLoad&&n.history.ready&&R(n.currentRoute),n.afterEach((function(e,o){var i=t.skipSamePath,c=t.shouldRouterUpdate;i&&e.path===o.path||("function"!=typeof c||c(e,o))&&r.nextTick().then((function(){R(n.currentRoute)}))}))})),l.ready()})).catch((function(e){l.debug.enabled&&p(e.message)}))}p('Missing the "id" parameter. Add at least one tracking domain ID')}};var B=function(e){var n=arguments.length>1&&void 0!==arguments[1]&&arguments[1];w("send","exception",{exDescription:e,exFatal:n})},H=function(e){if(l.autoTracking.exception){window.addEventListener("error",(function(e){B(e.message)}));var n=e.config.errorHandler;e.config.errorHandler=function(e,t,r){B(e.message),l.autoTracking.exceptionLogs&&console.error(e),"function"==typeof n&&n.call(void 0,e,t,r)}}},F=B;function M(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function U(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}var $=function(e){return"".concat(l.ecommerce.enhanced?"ec":"ecommerce",":").concat(e)},C=["addItem","addTransaction","addProduct","addImpression","setAction","addPromo","send"].reduce((function(e,n){return function(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?M(t,!0).forEach((function(n){U(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):M(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}({},e,U({},n,(function(){for(var e=arguments.length,t=new Array(e),r=0;r<e;r++)t[r]=arguments[r];w.apply(void 0,[$(n)].concat(t))})))}),{}),N={event:function(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];w.apply(void 0,["send","event"].concat(n))},exception:F,page:q,query:w,require:E,set:j,social:function(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];w.apply(void 0,["send","social"].concat(n))},time:function(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];w.apply(void 0,["send","timing"].concat(n))},screenview:T,ecommerce:C,disable:function(){return L(!0)},enable:function(){return L(!1)},commands:l.commands},Q={inserted:function(e,n,t){var r=Object.keys(n.modifiers);0===r.length&&r.push("click"),r.forEach((function(r){e.addEventListener(r,(function(){var e="string"==typeof n.value?l.commands[n.value]:n.value;if(!e)throw new Error("[vue-analytics] The value passed to v-ga is not defined in the commands list.");e.apply(t.context)}))}))}};function W(e){return function(e){if(Array.isArray(e)){for(var n=0,t=new Array(e.length);n<e.length;n++)t[n]=e[n];return t}}(e)||function(e){if(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e))return Array.from(e)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}()}function G(e,n){return function(e){if(Array.isArray(e))return e}(e)||function(e,n){if(!(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e)))return;var t=[],r=!0,o=!1,i=void 0;try{for(var c,a=e[Symbol.iterator]();!(r=(c=a.next()).done)&&(t.push(c.value),!n||t.length!==n);r=!0);}catch(e){o=!0,i=e}finally{try{r||null==a.return||a.return()}finally{if(o)throw i}}return t}(e,n)||function(){throw new TypeError("Invalid attempt to destructure non-iterable instance")}()}function z(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function J(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}function K(e){u(function(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?z(t,!0).forEach((function(n){J(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):z(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}({},arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},{$vue:e})),e.directive("ga",Q),e.prototype.$ga=e.$ga=N,H(e),_()}t.d(n,"default",(function(){return K})),t.d(n,"analyticsMiddleware",(function(){return V})),t.d(n,"onAnalyticsReady",(function(){return X})),t.d(n,"event",(function(){return Y})),t.d(n,"ecommerce",(function(){return Z})),t.d(n,"set",(function(){return ee})),t.d(n,"page",(function(){return ne})),t.d(n,"query",(function(){return te})),t.d(n,"screenview",(function(){return re})),t.d(n,"time",(function(){return oe})),t.d(n,"require",(function(){return ie})),t.d(n,"exception",(function(){return ce})),t.d(n,"social",(function(){return ae}));var V=function(e){e.subscribe((function(e){var n=e.payload;if(n&&n.meta&&n.meta.analytics){var t=n.meta.analytics;if(!Array.isArray(t))throw new Error('The "analytics" property needs to be an array');t.forEach((function(e){var n,t,r=e.shift(),o=e;if(r.includes(":")){var i=G(r.split(":"),2);r=i[0],n=i[1]}if(!(r in N))throw new Error('[vue-analytics:vuex] The type "'.concat(r,"\" doesn't exist."));if(n&&!(n in N[r]))throw new Error('[vue-analytics:vuex] The type "'.concat(r,'" has not method "').concat(n,'".'));if("ecommerce"===r&&!n)throw new Error('[vue-analytics:vuex] The type "'.concat(r,'" needs to call a method. Check documentation.'));n?(t=N[r])[n].apply(t,W(o)):N[r].apply(N,W(o))}))}}))},X=function(){return new Promise((function(e,n){var t=setInterval((function(){"undefined"!=typeof window&&window.ga&&(e(),clearInterval(t))}),10)}))},Y=N.event,Z=N.ecommerce,ee=N.set,ne=N.page,te=N.query,re=N.screenview,oe=N.time,ie=N.require,ce=N.exception,ae=N.social}])}));

/***/ })
],[16]);


// WEBPACK FOOTER //
// js/app.dfe26315323421ae60c1.js